import { IconTemplate } from "../lib/index.jsx";
  export function RiArrowsArrowDownCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm1 10V8h-2v4H8l4 4 4-4h-3Z"/>'
      }, props)
  }
  export function RiArrowsArrowDownCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8Zm1-8h3l-4 4-4-4h3V8h2v4Z"/>'
      }, props)
  }
  export function RiArrowsArrowDownDoubleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 19.164 6.207-6.207-1.414-1.414L12 16.336l-4.793-4.793-1.414 1.414L12 19.164Zm0-5.65 6.207-6.207-1.414-1.414L12 10.686 7.207 5.893 5.793 7.307 12 13.514Z"/>'
      }, props)
  }
  export function RiArrowsArrowDownDoubleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 19.164 6.207-6.207-1.414-1.414L12 16.336l-4.793-4.793-1.414 1.414L12 19.164Zm0-5.65 6.207-6.207-1.414-1.414L12 10.686 7.207 5.893 5.793 7.307 12 13.514Z"/>'
      }, props)
  }
  export function RiArrowsArrowDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 12h7l-8 8-8-8h7V4h2v8Z"/>'
      }, props)
  }
  export function RiArrowsArrowDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13 16.172 5.364-5.364 1.414 1.414L12 20l-7.778-7.778 1.414-1.414L11 16.172V4h2v12.172Z"/>'
      }, props)
  }
  export function RiArrowsArrowDownSFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 16-6-6h12l-6 6Z"/>'
      }, props)
  }
  export function RiArrowsArrowDownSLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 13.171 4.95-4.95 1.414 1.415L12 16 5.636 9.636 7.05 8.222l4.95 4.95Z"/>'
      }, props)
  }
  export function RiArrowsArrowDropDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 14-4-4h8l-4 4Z"/>'
      }, props)
  }
  export function RiArrowsArrowDropDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 15-4.243-4.242 1.415-1.414L12 12.172l2.828-2.828 1.415 1.414L12 15.001Z"/>'
      }, props)
  }
  export function RiArrowsArrowDropLeftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m9 12 4-4v8l-4-4Z"/>'
      }, props)
  }
  export function RiArrowsArrowDropLeftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.828 12 2.829 2.829-1.414 1.414L9 12.001l4.243-4.243 1.414 1.414-2.829 2.829Z"/>'
      }, props)
  }
  export function RiArrowsArrowDropRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14 12-4 4V8l4 4Z"/>'
      }, props)
  }
  export function RiArrowsArrowDropRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.172 12 9.343 9.173l1.415-1.414L15 12l-4.242 4.242-1.415-1.414L12.172 12Z"/>'
      }, props)
  }
  export function RiArrowsArrowDropUpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 10 4 4H8l4-4Z"/>'
      }, props)
  }
  export function RiArrowsArrowDropUpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 11.828-2.828 2.829-1.415-1.414L12 9l4.243 4.243-1.415 1.414L12 11.828Z"/>'
      }, props)
  }
  export function RiArrowsArrowGoBackFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 7v4L2 6l6-5v4h5a8 8 0 1 1 0 16H4v-2h9a6 6 0 0 0 0-12H8Z"/>'
      }, props)
  }
  export function RiArrowsArrowGoBackLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m5.828 7 2.536 2.535L6.95 10.95 2 6l4.95-4.95 1.414 1.415L5.828 5H13a8 8 0 1 1 0 16H4v-2h9a6 6 0 0 0 0-12H5.828Z"/>'
      }, props)
  }
  export function RiArrowsArrowGoForwardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 7h-5a6 6 0 1 0 0 12h9v2h-9a8 8 0 1 1 0-16h5V1l6 5-6 5V7Z"/>'
      }, props)
  }
  export function RiArrowsArrowGoForwardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.172 7H11a6 6 0 0 0 0 12h9v2h-9a8 8 0 0 1 0-16h7.172l-2.536-2.536L17.05 1.05 22 6l-4.95 4.95-1.414-1.415L18.172 7Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 9V8l-4 4 4 4v-3h4v-2h-4Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8Zm0-9h4v2h-4v3l-4-4 4-4v3Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftDoubleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4.836 12 6.207 6.207 1.414-1.414L7.664 12l4.793-4.793-1.414-1.414L4.836 12Zm5.65 0 6.207 6.207 1.414-1.414L13.314 12l4.793-4.793-1.414-1.414L10.486 12Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftDoubleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4.836 12 6.207 6.207 1.414-1.414L7.664 12l4.793-4.793-1.414-1.414L4.836 12Zm5.65 0 6.207 6.207 1.414-1.414L13.314 12l4.793-4.793-1.414-1.414L10.486 12Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.361 13.052 4.95 4.95H5.997V6.687l4.95 4.95 5.657-5.658 1.414 1.415-5.657 5.657Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m9 13.589 8.607-8.607 1.414 1.415-8.607 8.606H18v2H7v-11h2v7.586Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 13v7l-8-8 8-8v7h8v2h-8Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.828 11H20v2H7.828l5.364 5.364-1.414 1.414L4 12l7.778-7.778 1.414 1.414L7.828 11Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 16v-4l5 5-5 5v-4H4v-2h12ZM8 2v3.999L20 6v2H8v4L3 7l5-5Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.05 12.05 21 17l-4.95 4.95-1.414-1.415L17.172 18H4v-2h13.172l-2.536-2.535 1.414-1.414Zm-8.1-10 1.414 1.414-2.536 2.535H20v2H6.828l2.536 2.536L7.95 11.95 3 7l4.95-4.95Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftSFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m8 12 6-6v12l-6-6Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftSLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.828 12 4.95 4.95-1.414 1.415L8 12l6.364-6.364 1.414 1.414-4.95 4.95Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftUpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.361 10.947 5.657 5.657-1.414 1.414-5.657-5.657-4.95 4.95V5.997h11.314l-4.95 4.95Z"/>'
      }, props)
  }
  export function RiArrowsArrowLeftUpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m9.414 8 8.607 8.607-1.414 1.414L8 9.414V17H6V6h11v2H9.414Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 9H8v2h4v3l4-4-4-4v3Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 11V8l4 4-4 4v-3H8v-2h4Zm0-9c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightDoubleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19.164 12-6.207-6.207-1.414 1.414L16.336 12l-4.793 4.793 1.414 1.414L19.164 12Zm-5.65 0L7.307 5.793 5.893 7.207 10.686 12l-4.793 4.793 1.414 1.414L13.514 12Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightDoubleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19.164 12-6.207-6.207-1.414 1.414L16.336 12l-4.793 4.793 1.414 1.414L19.164 12Zm-5.65 0L7.307 5.793 5.893 7.207 10.686 12l-4.793 4.793 1.414 1.414L13.514 12Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.636 13.052 5.98 7.395 7.394 5.98l5.657 5.657L18 6.687v11.314H6.686l4.95-4.95Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.59 16.003 5.982 7.397l1.414-1.415 8.607 8.607V7.003h2v11h-11v-2h7.585Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 13H4v-2h8V4l8 8-8 8v-7Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.172 11-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2h12.172Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightSFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 12-6 6V6l6 6Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightSLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.171 12-4.95-4.95 1.415-1.413L16 12l-6.364 6.364-1.414-1.415 4.95-4.95Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightUpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.05 12.361-5.656 5.657-1.415-1.414 5.657-5.657-4.95-4.95H18v11.314l-4.95-4.95Z"/>'
      }, props)
  }
  export function RiArrowsArrowRightUpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.004 9.414-8.607 8.607-1.414-1.414L14.59 8H7.003V6h11v11h-2V9.414Z"/>'
      }, props)
  }
  export function RiArrowsArrowTurnBackFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 16h-4l5 6 5-6h-4v-5a8 8 0 1 0-16 0v9h2v-9a6 6 0 1 1 12 0v5Z"/>'
      }, props)
  }
  export function RiArrowsArrowTurnBackLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17 18.172-2.535-2.536-1.414 1.414L18 22l4.95-4.95-1.415-1.414L19 18.172V11a8 8 0 1 0-16 0v9h2v-9a6 6 0 0 1 12 0v7.172Z"/>'
      }, props)
  }
  export function RiArrowsArrowTurnForwardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 8v5a6 6 0 0 1-12 0V4H3v9a8 8 0 1 0 16 0V8h4l-5-6-5 6h4Z"/>'
      }, props)
  }
  export function RiArrowsArrowTurnForwardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 5.828V13a6 6 0 0 1-12 0V4H3v9a8 8 0 1 0 16 0V5.828l2.536 2.536L22.95 6.95 18 2l-4.95 4.95 1.415 1.414L17 5.828Z"/>'
      }, props)
  }
  export function RiArrowsArrowUpCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm1 10h3l-4-4-4 4h3v4h2v-4Z"/>'
      }, props)
  }
  export function RiArrowsArrowUpCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8Zm1-8v4h-2v-4H8l4-4 4 4h-3Z"/>'
      }, props)
  }
  export function RiArrowsArrowUpDoubleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 4.836-6.207 6.207 1.414 1.414L12 7.664l4.793 4.793 1.414-1.414L12 4.836Zm0 5.65-6.207 6.207 1.414 1.414L12 13.314l4.793 4.793 1.414-1.414L12 10.486Z"/>'
      }, props)
  }
  export function RiArrowsArrowUpDoubleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 4.836-6.207 6.207 1.414 1.414L12 7.664l4.793 4.793 1.414-1.414L12 4.836Zm0 5.65-6.207 6.207 1.414 1.414L12 13.314l4.793 4.793 1.414-1.414L12 10.486Z"/>'
      }, props)
  }
  export function RiArrowsArrowUpDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 8H8.001L8 20H6V8H2l5-5 5 5Zm10 8-5 5-5-5h4V4h2v12h4Z"/>'
      }, props)
  }
  export function RiArrowsArrowUpDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.95 7.95-1.414 1.414L8 6.828 8 20H6V6.828L3.466 9.364 2.05 7.95 7 3l4.95 4.95Zm10 8.1L17 21l-4.95-4.95 1.414-1.414 2.537 2.536L16 4h2v13.172l2.536-2.536 1.414 1.414Z"/>'
      }, props)
  }
  export function RiArrowsArrowUpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 12v8h-2v-8H4l8-8 8 8h-7Z"/>'
      }, props)
  }
  export function RiArrowsArrowUpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828Z"/>'
      }, props)
  }
  export function RiArrowsArrowUpSFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 8 6 6H6l6-6Z"/>'
      }, props)
  }
  export function RiArrowsArrowUpSLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 10.828-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.415 1.414-4.95-4.95Z"/>'
      }, props)
  }
  export function RiArrowsContractLeftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.414 4.586V11H21v2h-5.586v6.414L8 12l7.414-7.414ZM4 19V5h2v14H4Z"/>'
      }, props)
  }
  export function RiArrowsContractLeftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.071 4.929 1.415 1.414L11.829 11H21v2h-9.172l4.657 4.657-1.415 1.414L8.001 12l7.07-7.071Zm-11.07 14.07V5h2v14H4Z"/>'
      }, props)
  }
  export function RiArrowsContractLeftRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m5 18 6-6-6-6v12ZM19 6l-6 6 6 6V6Z"/>'
      }, props)
  }
  export function RiArrowsContractLeftRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.793 5.793 12.586 12l6.207 6.207 1.415-1.414L15.415 12l4.793-4.793-1.415-1.414ZM5.207 18.207 11.414 12 5.207 5.793 3.793 7.207 8.586 12l-4.793 4.793 1.414 1.414Z"/>'
      }, props)
  }
  export function RiArrowsContractRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.586 4.586 16 12l-7.414 7.414V13H3v-2h5.586V4.586ZM18 19V5h2v14h-2Z"/>'
      }, props)
  }
  export function RiArrowsContractRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.171 11 7.515 6.343l1.414-1.414 7.07 7.07-7.07 7.072-1.414-1.414L12.17 13H3v-2h9.171ZM18 19V5h2v14h-2Z"/>'
      }, props)
  }
  export function RiArrowsContractUpDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18 5-6 6-6-6h12Zm0 14-6-6-6 6h12Z"/>'
      }, props)
  }
  export function RiArrowsContractUpDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.793 5.207 12 11.414l6.207-6.207-1.414-1.414L12 8.586 7.207 3.793 5.793 5.207Zm12.414 13.586L12 12.586l-6.207 6.207 1.414 1.414L12 15.414l4.793 4.793 1.414-1.414Z"/>'
      }, props)
  }
  export function RiArrowsCornerDownLeftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 14V5h-2v7H9.414V6.586L3 13l6.414 6.414V14H19Z"/>'
      }, props)
  }
  export function RiArrowsCornerDownLeftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 14V5h-2v7H6.828l3.95-3.95-1.414-1.414L3 13l6.364 6.364 1.414-1.414L6.828 14H19Z"/>'
      }, props)
  }
  export function RiArrowsCornerDownRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 14V5h2v7h7.586V6.586L21 13l-6.414 6.414V14H5Z"/>'
      }, props)
  }
  export function RiArrowsCornerDownRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 14V5h2v7h10.172l-3.95-3.95 1.414-1.414L21 13l-6.364 6.364-1.414-1.414 3.95-3.95H5Z"/>'
      }, props)
  }
  export function RiArrowsCornerLeftDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 5h9v2h-7v7.586h5.414L11 21l-6.414-6.414H10V5Z"/>'
      }, props)
  }
  export function RiArrowsCornerLeftDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 5h9v2h-7v10.172l3.95-3.95 1.414 1.414L11 21l-6.364-6.364 1.414-1.414 3.95 3.95V5Z"/>'
      }, props)
  }
  export function RiArrowsCornerLeftUpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 19h9v-2h-7V9.414h5.414L11 3 4.586 9.414H10V19Z"/>'
      }, props)
  }
  export function RiArrowsCornerLeftUpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 19h9v-2h-7V6.828l3.95 3.95 1.414-1.414L11 3 4.636 9.364l1.414 1.414L10 6.828V19Z"/>'
      }, props)
  }
  export function RiArrowsCornerRightDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 5H5v2h7v7.586H6.586L13 21l6.414-6.414H14V5Z"/>'
      }, props)
  }
  export function RiArrowsCornerRightDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 5H5v2h7v10.172l-3.95-3.95-1.414 1.414L13 21l6.364-6.364-1.414-1.414-3.95 3.95V5Z"/>'
      }, props)
  }
  export function RiArrowsCornerRightUpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 19H5v-2h7V9.414H6.586L13 3l6.414 6.414H14V19Z"/>'
      }, props)
  }
  export function RiArrowsCornerRightUpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 19H5v-2h7V6.828l-3.95 3.95-1.414-1.414L13 3l6.364 6.364-1.414 1.414L14 6.828V19Z"/>'
      }, props)
  }
  export function RiArrowsCornerUpLeftDoubleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 19v-9h-5.586V4.586L8 11l6.414 6.414V12H18v7h2ZM10.164 6.05 8.75 4.636 2.386 11l6.364 6.364 1.414-1.414L5.214 11l4.95-4.95Z"/>'
      }, props)
  }
  export function RiArrowsCornerUpLeftDoubleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 10v9h-2v-7h-6.172l3.95 3.95-1.414 1.414L8 11l6.364-6.364 1.414 1.414-3.95 3.95H20ZM8.75 4.636l1.414 1.414L5.214 11l4.95 4.95-1.414 1.414L2.386 11 8.75 4.636Z"/>'
      }, props)
  }
  export function RiArrowsCornerUpLeftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 10v9h-2v-7H9.414v5.414L3 11l6.414-6.414V10H19Z"/>'
      }, props)
  }
  export function RiArrowsCornerUpLeftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 10v9h-2v-7H6.828l3.95 3.95-1.414 1.414L3 11l6.364-6.364 1.414 1.414L6.828 10H19Z"/>'
      }, props)
  }
  export function RiArrowsCornerUpRightDoubleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 19v-9h5.586V4.586L16 11l-6.414 6.414V12H6v7H4Zm9.836-12.95 1.414-1.414L21.614 11l-6.364 6.364-1.414-1.414 4.95-4.95-4.95-4.95Z"/>'
      }, props)
  }
  export function RiArrowsCornerUpRightDoubleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 10v9h2v-7h6.172l-3.95 3.95 1.414 1.414L16 11 9.636 4.636 8.222 6.05l3.95 3.95H4Zm11.25-5.364L13.837 6.05l4.95 4.95-4.95 4.95 1.415 1.414L21.615 11 15.25 4.636Z"/>'
      }, props)
  }
  export function RiArrowsCornerUpRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 10v9h2v-7h7.586v5.414L21 11l-6.414-6.414V10H5Z"/>'
      }, props)
  }
  export function RiArrowsCornerUpRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 10v9h2v-7h10.172l-3.95 3.95 1.414 1.414L21 11l-6.364-6.364-1.414 1.414 3.95 3.95H5Z"/>'
      }, props)
  }
  export function RiArrowsDragMove2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 11V8l4 4-4 4v-3h-5v5h3l-4 4-4-4h3v-5H6v3l-4-4 4-4v3h5V6H8l4-4 4 4h-3v5h5Z"/>'
      }, props)
  }
  export function RiArrowsDragMove2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 11V5.828L9.172 7.657 7.757 6.243 12 2l4.243 4.243-1.415 1.414L13 5.828V11h5.172l-1.829-1.828 1.414-1.415L22 12l-4.243 4.243-1.414-1.415L18.172 13H13v5.172l1.828-1.829 1.415 1.414L12 22l-4.243-4.243 1.415-1.414L11 18.172V13H5.828l1.829 1.828-1.414 1.415L2 12l4.243-4.243 1.414 1.415L5.828 11H11Z"/>'
      }, props)
  }
  export function RiArrowsDragMoveFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 22-4-4h8l-4 4Zm0-20 4 4H8l4-4Zm0 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM2 12l4-4v8l-4-4Zm20 0-4 4V8l4 4Z"/>'
      }, props)
  }
  export function RiArrowsDragMoveLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 2 4.243 4.243-1.415 1.414L12 4.828 9.172 7.657 7.757 6.243 12 2ZM2 12l4.243-4.243 1.414 1.415L4.828 12l2.829 2.828-1.414 1.415L2 12Zm20 0-4.243 4.243-1.414-1.415L19.172 12l-2.829-2.828 1.414-1.415L22 12Zm-10 2a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 8-4.243-4.243 1.415-1.414L12 19.172l2.828-2.829 1.415 1.414L12 22Z"/>'
      }, props)
  }
  export function RiArrowsExpandLeftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.414 4.586V11H16v2h-5.586v6.414L3 12l7.414-7.414ZM18 19V5h2v14h-2Z"/>'
      }, props)
  }
  export function RiArrowsExpandLeftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.071 4.93 1.414 1.413L6.828 11H16v2H6.828l4.657 4.657-1.414 1.414L3 12.001l7.071-7.072ZM18.001 19V5h2v14h-2Z"/>'
      }, props)
  }
  export function RiArrowsExpandLeftRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m9 6-6 6 6 6V6Zm6 12 6-6-6-6v12Z"/>'
      }, props)
  }
  export function RiArrowsExpandLeftRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.043 5.793 2.836 12l6.207 6.207 1.414-1.414L5.664 12l4.793-4.793-1.414-1.414Zm5.914 12.414L21.164 12l-6.207-6.207-1.414 1.414L18.336 12l-4.793 4.793 1.414 1.414Z"/>'
      }, props)
  }
  export function RiArrowsExpandRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.586 4.586 21 12l-7.414 7.414V13H8v-2h5.586V4.586ZM4 19V5h2v14H4Z"/>'
      }, props)
  }
  export function RiArrowsExpandRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.172 11-4.657-4.657 1.414-1.414L21 12l-7.07 7.071-1.415-1.414L17.172 13H8v-2h9.172ZM4 19V5h2v14H4Z"/>'
      }, props)
  }
  export function RiArrowsExpandUpDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18 9-6-6-6 6h12Zm0 6-6 6-6-6h12Z"/>'
      }, props)
  }
  export function RiArrowsExpandUpDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.207 9.043 12 2.836 5.793 9.043l1.414 1.414L12 5.664l4.793 4.793 1.414-1.414ZM5.793 14.957 12 21.165l6.207-6.208-1.414-1.414L12 18.336l-4.793-4.793-1.414 1.414Z"/>'
      }, props)
  }
  export function RiArrowsSkipDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 17H6v-2h12v2Zm-6-4 6-6H6l6 6Z"/>'
      }, props)
  }
  export function RiArrowsSkipDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 10.086 7.207 5.293 5.793 6.707 12 12.914l6.207-6.207-1.414-1.414L12 10.086ZM18 17H6v-2h12v2Z"/>'
      }, props)
  }
  export function RiArrowsSkipLeftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 18V6h2v12H7Zm4-6 6-6v12l-6-6Z"/>'
      }, props)
  }
  export function RiArrowsSkipLeftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.914 12 4.793-4.793-1.414-1.414L11.086 12l6.207 6.207 1.414-1.414L13.914 12ZM7 18V6h2v12H7Z"/>'
      }, props)
  }
  export function RiArrowsSkipRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 6v12h-2V6h2Zm-4 6-6 6V6l6 6Z"/>'
      }, props)
  }
  export function RiArrowsSkipRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.086 12-4.793 4.793 1.414 1.414L12.914 12 6.707 5.793 5.293 7.207 10.086 12ZM17 6v12h-2V6h2Z"/>'
      }, props)
  }
  export function RiArrowsSkipUpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 7h12v2H6V7Zm6 4 6 6H6l6-6Z"/>'
      }, props)
  }
  export function RiArrowsSkipUpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 13.914 4.793 4.793 1.414-1.414L12 11.086l-6.207 6.207 1.414 1.414L12 13.914ZM6 7h12v2H6V7Z"/>'
      }, props)
  }
  export function RiBuildingsAncientGateFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.964 3h10.072a3.5 3.5 0 0 0 4.445 2.86A3.5 3.5 0 0 1 18 9H6a3.5 3.5 0 0 1-3.481-3.14A3.5 3.5 0 0 0 6.964 3Zm16.015 8.111a2.999 2.999 0 0 1-4.077-1.11H5.098a2.999 2.999 0 0 1-4.078 1.11A3.5 3.5 0 0 0 3 14.663V21h6v-2a3 3 0 0 1 6 0v2h6v-6.336a3.5 3.5 0 0 0 1.979-3.553Z"/>'
      }, props)
  }
  export function RiBuildingsAncientGateLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.964 3h10.072a3.5 3.5 0 0 0 4.445 2.86A3.5 3.5 0 0 1 18 9H6a3.5 3.5 0 0 1-3.482-3.14A3.5 3.5 0 0 0 6.964 3ZM16.9 6.658A5.43 5.43 0 0 1 15.59 5H8.411A5.43 5.43 0 0 1 7.1 6.658 5.976 5.976 0 0 1 6.667 7h10.666a6.007 6.007 0 0 1-.434-.342ZM21.5 11.5c.538 0 1.042-.142 1.479-.39A3.5 3.5 0 0 1 21 14.663V21h-7v-2a2 2 0 1 0-4 0v2H3v-6.336a3.5 3.5 0 0 1-1.979-3.553 2.999 2.999 0 0 0 4.077-1.11h13.803a2.999 2.999 0 0 0 2.599 1.5Zm-2.537 1.309a4.99 4.99 0 0 1-1.038-.81H6.075a5.094 5.094 0 0 1-1.66 1.121L5 13.4V19h3c0-1.105.39-2.047 1.172-2.828A3.854 3.854 0 0 1 12 15c1.105 0 2.047.39 2.828 1.172A3.854 3.854 0 0 1 16 19h3v-5.6l.585-.278a5.092 5.092 0 0 1-.622-.312Z"/>'
      }, props)
  }
  export function RiBuildingsAncientPavilionFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1.516 7.877A4.5 4.5 0 0 0 5 11.887v7.114H3v2h18v-2h-2v-7.114a4.5 4.5 0 0 0 3.484-4.01A9 9 0 0 1 12.514 2h-1.029a9 9 0 0 1-9.97 5.877ZM17 19H7V12h10v7.001Z"/>'
      }, props)
  }
  export function RiBuildingsAncientPavilionLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1.516 7.877A4.5 4.5 0 0 0 5 11.887v7.114H3v2h18v-2h-2v-7.114a4.5 4.5 0 0 0 3.484-4.01A9 9 0 0 1 12.514 2h-1.029a9 9 0 0 1-9.97 5.877ZM17 19H7V12h10v7.001Zm1.555-9.064-.274.063H5.72l-.275-.063a2.593 2.593 0 0 1-.39-.121C6.59 9.532 8.021 8.92 9.35 7.98A10.88 10.88 0 0 0 12 5.346a10.877 10.877 0 0 0 2.649 2.635c1.328.94 2.76 1.551 4.298 1.835-.125.05-.256.09-.392.121Z"/>'
      }, props)
  }
  export function RiBuildingsBankFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 20h20v2H2v-2Zm2-8h2v7H4v-7Zm5 0h2v7H9v-7Zm4 0h2v7h-2v-7Zm5 0h2v7h-2v-7ZM2 7l10-5 10 5v4H2V7Zm10 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiBuildingsBankLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 20h20v2H2v-2Zm2-8h2v7H4v-7Zm5 0h2v7H9v-7Zm4 0h2v7h-2v-7Zm5 0h2v7h-2v-7ZM2 7l10-5 10 5v4H2V7Zm2 1.236V9h16v-.764l-8-4-8 4ZM12 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/>'
      }, props)
  }
  export function RiBuildingsBuilding2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 19h2V6l6.394 2.74a1 1 0 0 1 .606.92V19h2v2H1v-2h2V5.65a1 1 0 0 1 .594-.914l7.703-3.423A.5.5 0 0 1 12 1.77V19Z"/>'
      }, props)
  }
  export function RiBuildingsBuilding2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 19V5.7a1 1 0 0 1 .658-.94l9.671-3.516a.5.5 0 0 1 .671.47v4.953l6.316 2.105a1 1 0 0 1 .684.949V19h2v2H1v-2h2Zm2 0h7V3.856L5 6.4v12.6Zm14 0v-8.558l-5-1.667V19h5Z"/>'
      }, props)
  }
  export function RiBuildingsBuilding3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 10.111V1l11 6v14H3V7l7 3.111Z"/>'
      }, props)
  }
  export function RiBuildingsBuilding3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 10.111V1l11 6v14H3V7l7 3.111Zm2-5.742v8.82l-7-3.111V19h14V8.187L12 4.37Z"/>'
      }, props)
  }
  export function RiBuildingsBuilding4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 20h2v2H1v-2h2V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v17ZM8 11v2h3v-2H8Zm0-4v2h3V7H8Zm0 8v2h3v-2H8Zm5 0v2h3v-2h-3Zm0-4v2h3v-2h-3Zm0-4v2h3V7h-3Z"/>'
      }, props)
  }
  export function RiBuildingsBuilding4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 20h2v2H1v-2h2V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v17Zm-2 0V4H5v16h14ZM8 11h3v2H8v-2Zm0-4h3v2H8V7Zm0 8h3v2H8v-2Zm5 0h3v2h-3v-2Zm0-4h3v2h-3v-2Zm0-4h3v2h-3V7Z"/>'
      }, props)
  }
  export function RiBuildingsBuildingFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 19h2v2H1v-2h2V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v15h2V9h3a1 1 0 0 1 1 1v9ZM7 11v2h4v-2H7Zm0-4v2h4V7H7Z"/>'
      }, props)
  }
  export function RiBuildingsBuildingLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 19h2v2H1v-2h2V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v15h4v-8h-2V9h3a1 1 0 0 1 1 1v9ZM5 5v14h8V5H5Zm2 6h4v2H7v-2Zm0-4h4v2H7V7Z"/>'
      }, props)
  }
  export function RiBuildingsCommunityFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 19h3v-6.058L8 9.454l-4 3.488V19h3v-4h2v4Zm12 2H3a1 1 0 0 1-1-1v-7.513a1 1 0 0 1 .343-.754L6 8.544V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1Zm-5-10v2h2v-2h-2Zm0 4v2h2v-2h-2Zm0-8v2h2V7h-2Zm-4 0v2h2V7h-2Z"/>'
      }, props)
  }
  export function RiBuildingsCommunityLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 21H3a1 1 0 0 1-1-1v-7.513a1 1 0 0 1 .343-.754L6 8.544V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1ZM9 19h3v-6.058L8 9.454l-4 3.488V19h3v-4h2v4Zm5 0h6V5H8v2.127c.234 0 .469.082.657.247l5 4.359a1 1 0 0 1 .343.754V19Zm2-8h2v2h-2v-2Zm0 4h2v2h-2v-2Zm0-8h2v2h-2V7Zm-4 0h2v2h-2V7Z"/>'
      }, props)
  }
  export function RiBuildingsGovernmentFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 19V8H1V6h3V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2h3v2h-1v11h1v2H1v-2h1Zm11 0v-7h-2v7h2Zm-5 0v-7H6v7h2Zm10 0v-7h-2v7h2ZM6 5v1h12V5H6Z"/>'
      }, props)
  }
  export function RiBuildingsGovernmentLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 6h3v2h-1v11h1v2H1v-2h1V8H1V6h3V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2Zm0 2H4v11h3v-7h2v7h2v-7h2v7h2v-7h2v7h3V8ZM6 5v1h12V5H6Z"/>'
      }, props)
  }
  export function RiBuildingsHome2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9Z"/>'
      }, props)
  }
  export function RiBuildingsHome2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1ZM6 19h12V9.158l-6-5.455-6 5.455V19Z"/>'
      }, props)
  }
  export function RiBuildingsHome3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9ZM8 15v2h8v-2H8Z"/>'
      }, props)
  }
  export function RiBuildingsHome3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1ZM6 19h12V9.158l-6-5.455-6 5.455V19Zm2-4h8v2H8v-2Z"/>'
      }, props)
  }
  export function RiBuildingsHome4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9Zm-9-7v6h2v-6h-2Z"/>'
      }, props)
  }
  export function RiBuildingsHome4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1Zm-6-2h5V9.158l-6-5.455-6 5.455V19h5v-6h2v6Z"/>'
      }, props)
  }
  export function RiBuildingsHome5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.489a1 1 0 0 1 .386-.79l8-6.222a1 1 0 0 1 1.228 0l8 6.222a1 1 0 0 1 .386.79v10.51Zm-10-7v6h2v-6h-2Z"/>'
      }, props)
  }
  export function RiBuildingsHome5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 19h6V9.978l-7-5.445-7 5.445V19h6v-6h2v6Zm8 1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.489a1 1 0 0 1 .386-.79l8-6.222a1 1 0 0 1 1.228 0l8 6.222a1 1 0 0 1 .386.79v10.51Z"/>'
      }, props)
  }
  export function RiBuildingsHome6Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.489a1 1 0 0 1 .386-.79l8-6.222a1 1 0 0 1 1.228 0l8 6.222a1 1 0 0 1 .386.79v10.51ZM7 15v2h10v-2H7Z"/>'
      }, props)
  }
  export function RiBuildingsHome6Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.489a1 1 0 0 1 .386-.79l8-6.222a1 1 0 0 1 1.228 0l8 6.222a1 1 0 0 1 .386.79v10.51Zm-2-1V9.978l-7-5.445-7 5.445V19h14ZM7 15h10v2H7v-2Z"/>'
      }, props)
  }
  export function RiBuildingsHome7Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9Zm-8-5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>'
      }, props)
  }
  export function RiBuildingsHome7Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1ZM6 19h12V9.158l-6-5.455-6 5.455V19Zm6-4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"/>'
      }, props)
  }
  export function RiBuildingsHome8Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9ZM9 10v6h6v-6H9Zm2 2h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiBuildingsHome8Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1ZM6 19h12V9.158l-6-5.455-6 5.455V19Zm3-9h6v6H9v-6Zm2 2v2h2v-2h-2Z"/>'
      }, props)
  }
  export function RiBuildingsHomeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.489a1 1 0 0 1 .386-.79l8-6.222a1 1 0 0 1 1.228 0l8 6.222a1 1 0 0 1 .386.79v10.51Z"/>'
      }, props)
  }
  export function RiBuildingsHomeGearFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9ZM8.592 13.808l-.991.572 1 1.733.993-.573a3.5 3.5 0 0 0 1.405.811v1.145h2.002V16.35a3.5 3.5 0 0 0 1.405-.81l.992.572L16.4 14.38l-.991-.572a3.504 3.504 0 0 0 0-1.62l.991-.572-1-1.734-.993.574A3.499 3.499 0 0 0 13 9.644V8.5h-2.002v1.144a3.5 3.5 0 0 0-1.405.812l-.992-.574L7.6 11.616l.991.572a3.505 3.505 0 0 0 0 1.62Zm3.408.69a1.5 1.5 0 1 1-.002-3.001 1.5 1.5 0 0 1 .002 3Z"/>'
      }, props)
  }
  export function RiBuildingsHomeGearLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1ZM6 19h12V9.158l-6-5.455-6 5.455V19Zm2.591-5.191a3.508 3.508 0 0 1 0-1.622l-.991-.572 1-1.732.991.573a3.494 3.494 0 0 1 1.404-.812V8.5h2v1.144c.532.159 1.01.44 1.404.812l.991-.573 1 1.732-.991.572a3.508 3.508 0 0 1 0 1.622l.991.572-1 1.731-.991-.572a3.494 3.494 0 0 1-1.404.811v1.145h-2V16.35a3.495 3.495 0 0 1-1.404-.811l-.991.573-1-1.732.991-.572Zm3.404.688a1.5 1.5 0 1 0 0-2.998 1.5 1.5 0 0 0 0 2.998Z"/>'
      }, props)
  }
  export function RiBuildingsHomeHeartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9Zm-8-3 3.359-3.359a2.25 2.25 0 0 0-3.182-3.182l-.177.177-.177-.177a2.25 2.25 0 1 0-3.182 3.182L12 17.001Z"/>'
      }, props)
  }
  export function RiBuildingsHomeHeartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9Zm-2-1V9.158l-6-5.455-6 5.455V19h12Zm-6-2-3.359-3.359a2.25 2.25 0 1 1 3.182-3.182l.177.177.177-.177a2.25 2.25 0 1 1 3.182 3.182L12 17.001Z"/>'
      }, props)
  }
  export function RiBuildingsHomeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.489a1 1 0 0 1 .386-.79l8-6.222a1 1 0 0 1 1.228 0l8 6.222a1 1 0 0 1 .386.79v10.51Zm-2-1V9.978l-7-5.445-7 5.445V19h14Z"/>'
      }, props)
  }
  export function RiBuildingsHomeOfficeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.8 9H12v8h-1v4H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L20.8 9ZM14 11h9v7h-9v-7Zm-1 10h11v-2H13v2Z"/>'
      }, props)
  }
  export function RiBuildingsHomeOfficeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.673 1.612 20.8 9h-2.973L12 3.703 6 9.158V19h5v2H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0ZM14 11h9v7h-9v-7Zm2 2v3h5v-3h-5Zm8 8H13v-2h11v2Z"/>'
      }, props)
  }
  export function RiBuildingsHomeSmile2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.314a1 1 0 0 1 .38-.785l8-6.311a1 1 0 0 1 1.24 0l8 6.31a1 1 0 0 1 .38.786V20ZM7 12a5 5 0 0 0 10 0h-2a3 3 0 1 1-6 0H7Z"/>'
      }, props)
  }
  export function RiBuildingsHomeSmile2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 19V9.799l-7-5.522-7 5.522v9.2h14Zm2 1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.314a1 1 0 0 1 .38-.785l8-6.311a1 1 0 0 1 1.24 0l8 6.31a1 1 0 0 1 .38.786V20ZM7 12h2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0Z"/>'
      }, props)
  }
  export function RiBuildingsHomeSmileFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9ZM7.5 13a4.5 4.5 0 1 0 9 0h-2a2.5 2.5 0 0 1-5 0h-2Z"/>'
      }, props)
  }
  export function RiBuildingsHomeSmileLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 19h12V9.158l-6-5.455-6 5.455V19Zm13 2H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1ZM7.5 13h2a2.5 2.5 0 0 0 5 0h2a4.5 4.5 0 1 1-9 0Z"/>'
      }, props)
  }
  export function RiBuildingsHomeWifiFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 20a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9ZM7 11v2a5 5 0 0 1 5 5h2a7 7 0 0 0-7-7Zm0 4v3h3a3 3 0 0 0-3-3Z"/>'
      }, props)
  }
  export function RiBuildingsHomeWifiLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 19h12V9.158l-6-5.455-6 5.455V19Zm13 2H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1ZM8 10a7 7 0 0 1 7 7h-2a5 5 0 0 0-5-5v-2Zm0 4a3 3 0 0 1 3 3H8v-3Z"/>'
      }, props)
  }
  export function RiBuildingsHospitalFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 20h2v2H1v-2h2V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v17ZM11 8H9v2h2v2h2v-2h2V8h-2V6h-2v2Zm3 12h2v-6H8v6h2v-4h4v4Z"/>'
      }, props)
  }
  export function RiBuildingsHospitalLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 20v-6h8v6h3V4H5v16h3Zm2 0h4v-4h-4v4Zm11 0h2v2H1v-2h2V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v17ZM11 8V6h2v2h2v2h-2v2h-2v-2H9V8h2Z"/>'
      }, props)
  }
  export function RiBuildingsHotelFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 19h2v-8h-6v8h2v-6h2v6ZM3 19V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v5h2v10h1v2H2v-2h1Zm4-8v2h2v-2H7Zm0 4v2h2v-2H7Zm0-8v2h2V7H7Z"/>'
      }, props)
  }
  export function RiBuildingsHotelLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 21H2v-2h1V4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v5h2v10h1v2Zm-5-2h2v-8h-6v8h2v-6h2v6Zm0-10V5H5v14h6V9h6ZM7 11h2v2H7v-2Zm0 4h2v2H7v-2Zm0-8h2v2H7V7Z"/>'
      }, props)
  }
  export function RiBuildingsSchoolFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M23 19h-1V9h-4V6.586l-6-6-6 6V9H2v10H1v2h22v-2ZM6 19H4v-8h2v8Zm12-8h2v8h-2v-8Zm-7 1h2v7h-2v-7Z"/>'
      }, props)
  }
  export function RiBuildingsSchoolLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 .586 6 6V9h4v10h1v2H1v-2h1V9h4V6.586l6-6ZM18 19h2v-8h-2v8ZM6 11H4v8h2v-8Zm2-3.586V19h3v-7h2v7h3V7.414l-4-4-4 4Z"/>'
      }, props)
  }
  export function RiBuildingsStore2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 20v2H2v-2h1v-6.758A4.496 4.496 0 0 1 1 9.5c0-.827.224-1.624.633-2.303L4.345 2.5a1 1 0 0 1 .866-.5H18.79a1 1 0 0 1 .866.5l2.703 4.682c.418.694.642 1.49.642 2.318 0 1.56-.794 2.935-2 3.742V20h1ZM5.789 4 3.356 8.213a2.5 2.5 0 1 0 4.466 2.216c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 0 0 4.644 0c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 1 0 4.457-2.232L18.21 4H5.79Z"/>'
      }, props)
  }
  export function RiBuildingsStore2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 13.242V20h1v2H2v-2h1v-6.758A4.496 4.496 0 0 1 1 9.5c0-.827.224-1.624.633-2.303L4.345 2.5a1 1 0 0 1 .866-.5H18.79a1 1 0 0 1 .866.5l2.703 4.682c.418.694.642 1.49.642 2.318 0 1.56-.794 2.935-2 3.742Zm-2 .73a4.496 4.496 0 0 1-3.75-1.36A4.496 4.496 0 0 1 12 14.001a4.496 4.496 0 0 1-3.25-1.387A4.496 4.496 0 0 1 5 13.973V20h14v-6.027ZM5.789 4 3.356 8.213a2.5 2.5 0 1 0 4.466 2.216c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 0 0 4.644 0c.335-.837 1.52-.837 1.856 0a2.5 2.5 0 1 0 4.457-2.232L18.21 4H5.79Z"/>'
      }, props)
  }
  export function RiBuildingsStore3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 13v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-7H2v-2l1-5h18l1 5v2h-1ZM5 13v6h14v-6H5Zm1 1h8v3H6v-3ZM3 3h18v2H3V3Z"/>'
      }, props)
  }
  export function RiBuildingsStore3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 13v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-7H2v-2l1-5h18l1 5v2h-1ZM5 13v6h14v-6H5Zm-.96-2h15.92l-.6-3H4.64l-.6 3ZM6 14h8v3H6v-3ZM3 3h18v2H3V3Z"/>'
      }, props)
  }
  export function RiBuildingsStoreFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 11.646V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9.354A3.985 3.985 0 0 1 2 9V3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v6c0 1.014-.378 1.94-1 2.646ZM14 9a1 1 0 1 1 2 0 2 2 0 1 0 4 0V4H4v5a2 2 0 1 0 4 0 1 1 0 0 1 2 0 2 2 0 1 0 4 0Z"/>'
      }, props)
  }
  export function RiBuildingsStoreLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 11.646V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9.354A3.985 3.985 0 0 1 2 9V3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v6c0 1.014-.378 1.94-1 2.646Zm-2 1.228a4.01 4.01 0 0 1-4-1.228A3.99 3.99 0 0 1 12 13a3.99 3.99 0 0 1-3-1.354 3.99 3.99 0 0 1-4 1.228V20h14v-7.126ZM14 9a1 1 0 1 1 2 0 2 2 0 1 0 4 0V4H4v5a2 2 0 1 0 4 0 1 1 0 0 1 2 0 2 2 0 1 0 4 0Z"/>'
      }, props)
  }
  export function RiBusinessAdvertisementFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m7.552 13 .847-2.115L9.244 13H7.552ZM16 12h1v2h-1a1 1 0 1 1 0-2Zm5-9H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Zm-8.402 13h-2.155l-.4-1h-3.29l-.4 1H4.199l1.199-2.998.001-.002 2-5h2l3.199 8ZM17 8h2v8h-3a3 3 0 1 1 0-6h1V8Z"/>'
      }, props)
  }
  export function RiBusinessAdvertisementLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.598 16-3.2-8h-2l-2 5v.002L4.199 16h2.154l.4-1h3.29l.4 1h2.155Zm-5.046-3 .847-2.115L9.244 13H7.552ZM17 8h2v8h-3a3 3 0 1 1 0-6h1V8Zm-1 4a1 1 0 0 0 0 2h1v-2h-1Zm5-9H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1ZM4 19V5h16v14H4Z"/>'
      }, props)
  }
  export function RiBusinessArchive2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 20V7l-2-4H4L2 7.004V20a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1ZM5.236 5h13.528l1 2H4.237l.999-2ZM9 11h6v2H9v-2Z"/>'
      }, props)
  }
  export function RiBusinessArchive2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 20V7l-2-4H4L2 7.004V20a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1ZM4 9h16v10H4V9Zm1.236-4h13.528l1 2H4.237l.999-2ZM15 11H9v2h6v-2Z"/>'
      }, props)
  }
  export function RiBusinessArchiveDrawerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 13h18v8.003c0 .55-.445.997-.993.997H3.993A.995.995 0 0 1 3 21.003V13ZM3 2.998C3 2.447 3.445 2 3.993 2h16.014c.548 0 .993.446.993.998V11H3V2.998ZM9 5v2h6V5H9Zm0 11v2h6v-2H9Z"/>'
      }, props)
  }
  export function RiBusinessArchiveDrawerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 2.992C3 2.444 3.445 2 3.993 2h16.014a1 1 0 0 1 .993.992v18.016a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992ZM19 11V4H5v7h14Zm0 2H5v7h14v-7ZM9 6h6v2H9V6Zm0 9h6v2H9v-2Z"/>'
      }, props)
  }
  export function RiBusinessArchiveFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 10h18v10.004c0 .55-.445.996-.993.996H3.993A.994.994 0 0 1 3 20.004V10Zm6 2v2h6v-2H9ZM2 4c0-.552.455-1 .992-1h18.016c.548 0 .992.444.992 1v4H2V4Z"/>'
      }, props)
  }
  export function RiBusinessArchiveLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 10H2V4.003C2 3.449 2.455 3 2.992 3h18.016A.99.99 0 0 1 22 4.003V10h-1v10.002a.996.996 0 0 1-.993.998H3.993A.996.996 0 0 1 3 20.002V10Zm16 0H5v9h14v-9ZM4 5v3h16V5H4Zm5 7h6v2H9v-2Z"/>'
      }, props)
  }
  export function RiBusinessAtFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm8-10a8 8 0 1 0-3.968 6.911l-1.008-1.728A6 6 0 1 1 18 12v1a1 1 0 1 1-2 0V9h-1.354a4 4 0 1 0 .066 5.94A3 3 0 0 0 20 13v-1Zm-8-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"/>'
      }, props)
  }
  export function RiBusinessAtLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 12a8 8 0 1 0-3.562 6.657l1.11 1.664A9.953 9.953 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v1.5a3.5 3.5 0 0 1-6.396 1.966A5 5 0 1 1 15 8H17v5.5a1.5 1.5 0 0 0 3 0V12Zm-8-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"/>'
      }, props)
  }
  export function RiBusinessAttachmentFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.997 2.992 21 21.008a1 1 0 0 1-.993.992H3.993A.993.993 0 0 1 3 21.008V2.992A1 1 0 0 1 3.993 2h16.01c.549 0 .994.444.994.992ZM9 13V9a1 1 0 0 1 2 0v4a1 1 0 1 0 2 0V9a3 3 0 1 0-6 0v4a5 5 0 0 0 10 0V8h-2v5a3 3 0 1 1-6 0Z"/>'
      }, props)
  }
  export function RiBusinessAttachmentLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 13.5V8a4 4 0 0 0-8 0v5.5a6.5 6.5 0 1 0 13 0V4h2v9.5a8.5 8.5 0 0 1-17 0V8a6 6 0 1 1 12 0v5.5a3.5 3.5 0 1 1-7 0V8h2v5.5a1.5 1.5 0 0 0 3 0Z"/>'
      }, props)
  }
  export function RiBusinessAwardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 15.245v6.872a.5.5 0 0 1-.757.429L12 20l-4.243 2.546a.5.5 0 0 1-.757-.43v-6.87a8 8 0 1 1 10 0ZM12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0-2a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"/>'
      }, props)
  }
  export function RiBusinessAwardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 15.245v6.872a.5.5 0 0 1-.757.429L12 20l-4.243 2.546a.5.5 0 0 1-.757-.43v-6.87a8 8 0 1 1 10 0ZM9 16.42v3.049l3-1.8 3 1.8v-3.05A7.978 7.978 0 0 1 12 17a7.978 7.978 0 0 1-3-.581ZM12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"/>'
      }, props)
  }
  export function RiBusinessBarChart2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 13h6v8H2v-8ZM9 3h6v18H9V3Zm7 5h6v13h-6V8Z"/>'
      }, props)
  }
  export function RiBusinessBarChart2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 13h6v8H2v-8Zm14-5h6v13h-6V8ZM9 3h6v18H9V3ZM4 15v4h2v-4H4Zm7-10v14h2V5h-2Zm7 5v9h2v-9h-2Z"/>'
      }, props)
  }
  export function RiBusinessBarChartBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm4 10v4h2v-4H7Zm4-6v10h2V7h-2Zm4 3v7h2v-7h-2Z"/>'
      }, props)
  }
  export function RiBusinessBarChartBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h16V5H4Zm3 8h2v4H7v-4Zm4-6h2v10h-2V7Zm4 3h2v7h-2v-7Z"/>'
      }, props)
  }
  export function RiBusinessBarChartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 12h4v9H3v-9Zm14-4h4v13h-4V8Zm-7-6h4v19h-4V2Z"/>'
      }, props)
  }
  export function RiBusinessBarChartGroupedFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 12h2v9H2v-9Zm3 2h2v7H5v-7Zm11-6h2v13h-2V8Zm3 2h2v11h-2V10ZM9 2h2v19H9V2Zm3 2h2v17h-2V4Z"/>'
      }, props)
  }
  export function RiBusinessBarChartGroupedLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 12h2v9H2v-9Zm3 2h2v7H5v-7Zm11-6h2v13h-2V8Zm3 2h2v11h-2V10ZM9 2h2v19H9V2Zm3 2h2v17h-2V4Z"/>'
      }, props)
  }
  export function RiBusinessBarChartHorizontalFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3v4H3V3h9Zm4 14v4H3v-4h13Zm6-7v4H3v-4h19Z"/>'
      }, props)
  }
  export function RiBusinessBarChartHorizontalLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3v2H3V3h9Zm4 16v2H3v-2h13Zm6-8v2H3v-2h19Z"/>'
      }, props)
  }
  export function RiBusinessBarChartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 12h2v9H3v-9Zm16-4h2v13h-2V8Zm-8-6h2v19h-2V2Z"/>'
      }, props)
  }
  export function RiBusinessBookmark2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v19.143a.5.5 0 0 1-.766.424L12 18.03l-7.234 4.536A.5.5 0 0 1 4 22.143V3a1 1 0 0 1 1-1Zm3 7v2h8V9H8Z"/>'
      }, props)
  }
  export function RiBusinessBookmark2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v19.143a.5.5 0 0 1-.766.424L12 18.03l-7.234 4.536A.5.5 0 0 1 4 22.143V3a1 1 0 0 1 1-1Zm13 2H6v15.432l6-3.761 6 3.761V4ZM8 9h8v2H8V9Z"/>'
      }, props)
  }
  export function RiBusinessBookmark3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 2h16a1 1 0 0 1 1 1v19.276a.5.5 0 0 1-.704.457L12 19.03l-8.296 3.702A.5.5 0 0 1 3 22.276V3a1 1 0 0 1 1-1Zm8 11.5 2.939 1.545-.561-3.272 2.377-2.318-3.285-.478L12 6l-1.47 2.977-3.285.478 2.377 2.318-.56 3.272L12 13.5Z"/>'
      }, props)
  }
  export function RiBusinessBookmark3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 2h16a1 1 0 0 1 1 1v19.276a.5.5 0 0 1-.704.457L12 19.03l-8.296 3.702A.5.5 0 0 1 3 22.276V3a1 1 0 0 1 1-1Zm15 17.965V4H5v15.965l7-3.124 7 3.123ZM12 13.5l-2.939 1.545.561-3.272-2.377-2.318 3.285-.478L12 6l1.47 2.977 3.285.478-2.377 2.318.56 3.272L12 13.5Z"/>'
      }, props)
  }
  export function RiBusinessBookmarkFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v19.143a.5.5 0 0 1-.766.424L12 18.03l-7.234 4.536A.5.5 0 0 1 4 22.143V3a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiBusinessBookmarkLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v19.143a.5.5 0 0 1-.766.424L12 18.03l-7.234 4.536A.5.5 0 0 1 4 22.143V3a1 1 0 0 1 1-1Zm13 2H6v15.432l6-3.761 6 3.761V4Z"/>'
      }, props)
  }
  export function RiBusinessBriefcase2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4Zm10 8v-3h-2v3H9v-3H7v3H4v6h16v-6h-3ZM9 3v2h6V3H9Z"/>'
      }, props)
  }
  export function RiBusinessBriefcase2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4Zm13 8H4v6h16v-6Zm0-6H4v4h3V9h2v2h6V9h2v2h3V7ZM9 3v2h6V3H9Z"/>'
      }, props)
  }
  export function RiBusinessBriefcase3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4Zm10 2v5h3V7h-3Zm-2 0H9v5h6V7ZM7 7H4v5h3V7Zm2-4v2h6V3H9Z"/>'
      }, props)
  }
  export function RiBusinessBriefcase3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4Zm8 2H9v12h6V7ZM7 7H4v12h3V7Zm10 0v12h3V7h-3ZM9 3v2h6V3H9Z"/>'
      }, props)
  }
  export function RiBusinessBriefcase4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 13v3h6v-3h7v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7h7Zm2-2h2v3h-2v-3ZM7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v5h-7V9H9v2H2V6a1 1 0 0 1 1-1h4Zm2-2v2h6V3H9Z"/>'
      }, props)
  }
  export function RiBusinessBriefcase4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4Zm2 8H4v6h16v-6h-5v3H9v-3Zm11-6H4v4h5V9h6v2h5V7Zm-9 4v3h2v-3h-2ZM9 3v2h6V3H9Z"/>'
      }, props)
  }
  export function RiBusinessBriefcase5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4Zm-1 8V7H4v6h2Zm2-6v6h3v-2h2v2h3V7H8Zm10 6h2V7h-2v6ZM9 3v2h6V3H9Z"/>'
      }, props)
  }
  export function RiBusinessBriefcase5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4Zm9 10h-3v1h-2v-1H8v4h8v-4ZM8 7v6h3v-1h2v1h3V7H8Zm-2 6V7H4v6h2Zm12 0h2V7h-2v6ZM6 15H4v4h2v-4Zm12 0v4h2v-4h-2ZM9 3v2h6V3H9Z"/>'
      }, props)
  }
  export function RiBusinessBriefcaseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4ZM4 15v4h16v-4H4Zm7-4v2h2v-2h-2ZM9 3v2h6V3H9Z"/>'
      }, props)
  }
  export function RiBusinessBriefcaseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 5V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4ZM4 16v3h16v-3H4Zm0-2h16V7H4v7ZM9 3v2h6V3H9Zm2 8h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiBusinessBubbleChartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 16a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM6 12a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm8.5-10a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Z"/>'
      }, props)
  }
  export function RiBusinessBubbleChartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 16a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM6 12a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm10 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM6 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm8.5-12a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm0 2a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z"/>'
      }, props)
  }
  export function RiBusinessCalculatorFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm3 10v2h2v-2H7Zm0 4v2h2v-2H7Zm4-4v2h2v-2h-2Zm0 4v2h2v-2h-2Zm4-4v6h2v-6h-2ZM7 6v4h10V6H7Z"/>'
      }, props)
  }
  export function RiBusinessCalculatorLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm1 2v16h14V4H5Zm2 2h10v4H7V6Zm0 6h2v2H7v-2Zm0 4h2v2H7v-2Zm4-4h2v2h-2v-2Zm0 4h2v2h-2v-2Zm4-4h2v6h-2v-6Z"/>'
      }, props)
  }
  export function RiBusinessCalendar2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2ZM4 9v10h16V9H4Zm2 2h2v2H6v-2Zm5 0h2v2h-2v-2Zm5 0h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiBusinessCalendar2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2Zm11 10H4v8h16v-8ZM8 13v2H6v-2h2Zm5 0v2h-2v-2h2Zm5 0v2h-2v-2h2ZM7 5H4v4h16V5h-3v2h-2V5H9v2H7V5Z"/>'
      }, props)
  }
  export function RiBusinessCalendarCheckFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2Zm11 7H4v11h16V8Zm-4.964 2.136 1.414 1.414-4.95 4.95-3.536-3.536L9.38 11.55l2.121 2.122 3.536-3.536Z"/>'
      }, props)
  }
  export function RiBusinessCalendarCheckLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2Zm11 9H4v9h16v-9Zm-4.964 1.136 1.414 1.414-4.95 4.95-3.536-3.536L9.38 12.55l2.121 2.122 3.536-3.536ZM7 5H4v3h16V5h-3v1h-2V5H9v1H7V5Z"/>'
      }, props)
  }
  export function RiBusinessCalendarCloseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 3V1H7v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4V1h-2v2H9ZM4 8h16v11H4V8Zm5.879 1.964 2.12 2.122 2.122-2.122 1.414 1.415-2.12 2.121 2.12 2.121-1.414 1.414L12 14.915l-2.122 2.12-1.414-1.414 2.122-2.121-2.122-2.121L9.88 9.963Z"/>'
      }, props)
  }
  export function RiBusinessCalendarCloseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 3V1H7v2H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4V1h-2v2H9Zm-5 7h16v9H4v-9Zm0-5h3v1h2V5h6v1h2V5h3v3H4V5Zm5.879 5.964L12 13.086l2.121-2.122 1.415 1.415-2.122 2.121 2.121 2.121-1.414 1.414L12 15.915l-2.121 2.12-1.415-1.414 2.122-2.12-2.122-2.122 1.415-1.415Z"/>'
      }, props)
  }
  export function RiBusinessCalendarEventFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2ZM4 9v10h16V9H4Zm2 4h5v4H6v-4Z"/>'
      }, props)
  }
  export function RiBusinessCalendarEventLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2Zm11 10H4v8h16v-8Zm-9 2v4H6v-4h5ZM7 5H4v4h16V5h-3v2h-2V5H9v2H7V5Z"/>'
      }, props)
  }
  export function RiBusinessCalendarFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 11h20v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9Zm15-8h4a1 1 0 0 1 1 1v5H2V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2Z"/>'
      }, props)
  }
  export function RiBusinessCalendarLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2Zm11 10H4v8h16v-8ZM7 5H4v4h16V5h-3v2h-2V5H9v2H7V5Z"/>'
      }, props)
  }
  export function RiBusinessCalendarTodoFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2ZM4 9v10h16V9H4Zm2 2h2v2H6v-2Zm0 4h2v2H6v-2Zm4-4h8v2h-8v-2Zm0 4h5v2h-5v-2Z"/>'
      }, props)
  }
  export function RiBusinessCalendarTodoLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 1v2h6V1h2v2h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2Zm11 10H4v8h16v-8ZM8 14v2H6v-2h2Zm10 0v2h-8v-2h8ZM7 5H4v4h16V5h-3v2h-2V5H9v2H7V5Z"/>'
      }, props)
  }
  export function RiBusinessCloudFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 7a8.003 8.003 0 0 0-7.493 5.19l1.873.703A6.002 6.002 0 0 1 23 15a6 6 0 0 1-6 6H7A6 6 0 0 1 5.008 9.339a7 7 0 0 1 13.757-2.143A8.027 8.027 0 0 0 17 7Z"/>'
      }, props)
  }
  export function RiBusinessCloudLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a7 7 0 0 1 6.992 7.339A6 6 0 0 1 17 21H7A6 6 0 0 1 5.008 9.339 7 7 0 0 1 12 2Zm0 2a5 5 0 0 0-4.994 5.243l.07 1.488-1.404.494A4.002 4.002 0 0 0 7 19h10a4 4 0 1 0-3.796-5.265l-1.898-.633A6.003 6.003 0 0 1 17 9a5 5 0 0 0-5-5Z"/>'
      }, props)
  }
  export function RiBusinessCloudOffFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3.515 2.1 19.092 19.092-1.415 1.415-2.014-2.015A5.984 5.984 0 0 1 17 21H7A6 6 0 0 1 5.008 9.339a6.992 6.992 0 0 1 .353-2.563L2.1 3.514 3.515 2.1ZM17 9a6.003 6.003 0 0 1 5.204 8.989L14.01 9.796C14.89 9.29 15.91 9 17 9Zm-5-7a7.003 7.003 0 0 1 6.765 5.195 8.027 8.027 0 0 0-6.206 1.15L7.694 3.48A6.97 6.97 0 0 1 12 2Z"/>'
      }, props)
  }
  export function RiBusinessCloudOffLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3.515 2.1 19.092 19.092-1.415 1.415-2.014-2.015A5.984 5.984 0 0 1 17 21H7A6 6 0 0 1 5.008 9.339a6.992 6.992 0 0 1 .353-2.563L2.1 3.514 3.515 2.1ZM7 9c0 .081.002.163.006.243l.07 1.488-1.404.494A4.002 4.002 0 0 0 7 19h10c.186 0 .369-.013.548-.037L7.03 8.445C7.01 8.627 7 8.812 7 9Zm5-7a7 7 0 0 1 6.992 7.339 6.003 6.003 0 0 1 3.212 8.65l-1.493-1.494a3.999 3.999 0 0 0-5.207-5.206L14.01 9.796C14.891 9.29 15.911 9 17 9a5 5 0 0 0-7.876-4.09l-1.43-1.43A6.97 6.97 0 0 1 12 2Z"/>'
      }, props)
  }
  export function RiBusinessCopyleftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10Zm0-5c2.76 0 5-2.24 5-5s-2.24-5-5-5c-1.82 0-3.413.973-4.288 2.428l1.715 1.028A3 3 0 1 1 12 15a2.998 2.998 0 0 1-2.574-1.457l-1.714 1.03A4.999 4.999 0 0 0 12 17Z"/>'
      }, props)
  }
  export function RiBusinessCopyleftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10Zm0-2c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8Zm0-3a4.999 4.999 0 0 1-4.288-2.428l1.714-1.029A3 3 0 1 0 12 9a2.998 2.998 0 0 0-2.573 1.456L7.712 9.428A4.999 4.999 0 0 1 17 12c0 2.76-2.24 5-5 5Z"/>'
      }, props)
  }
  export function RiBusinessCopyrightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 5c-2.76 0-5 2.24-5 5s2.24 5 5 5a5 5 0 0 0 4.288-2.428l-1.715-1.028A3 3 0 1 1 12 9c1.093 0 2.05.584 2.573 1.457l1.715-1.03A5 5 0 0 0 12 7Z"/>'
      }, props)
  }
  export function RiBusinessCopyrightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.288 9.428A4.999 4.999 0 0 0 7 12a4.999 4.999 0 0 0 9.288 2.572l-1.715-1.028A3 3 0 1 1 12 9c1.093 0 2.05.584 2.573 1.457l1.715-1.03ZM22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10ZM4 12c0-4.42 3.58-8 8-8s8 3.58 8 8-3.58 8-8 8-8-3.58-8-8Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsByFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm2 8h-4a1 1 0 0 0-1 1v4h1.5v4h3v-4H15v-4a1 1 0 0 0-1-1Zm-2-5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsByLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1 4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4h1.5v4h3v-4H15v-4Zm-3-9C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM9 8c-2.208 0-4 1.792-4 4a4.001 4.001 0 0 0 6.828 2.828l-1.414-1.414a2 2 0 1 1 0-2.828l1.415-1.413A3.988 3.988 0 0 0 9 8Zm7 0c-2.208 0-4 1.792-4 4a4.001 4.001 0 0 0 6.828 2.828l-1.414-1.414a2 2 0 1 1 0-2.828l1.415-1.413A3.988 3.988 0 0 0 16 8Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 8c1.104 0 2.105.448 2.829 1.173l-1.414 1.413a2 2 0 1 0 0 2.828l1.413 1.414A4.001 4.001 0 0 1 5 12c0-2.208 1.792-4 4-4Zm9.829 1.173A4.001 4.001 0 0 0 12 12a4.001 4.001 0 0 0 6.828 2.828l-1.414-1.414a2 2 0 1 1 0-2.828l1.415-1.413ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsNcFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4.256 5.672 3.58 3.577A2.5 2.5 0 0 0 10 13h3.999l.09.008A.5.5 0 0 1 14 14H8.5v2H11v2h2v-2h1c.182 0 .359-.02.53-.056l3.798 3.8A9.958 9.958 0 0 1 12 22C6.477 22 2 17.523 2 12c0-2.4.846-4.604 2.256-6.328ZM12 2c5.523 0 10 4.477 10 10 0 2.4-.846 4.604-2.256 6.328l-3.579-3.577A2.5 2.5 0 0 0 14 11h-4l-.09-.01A.5.5 0 0 1 10 10h5.5V8H13V6h-2v2h-1c-.181 0-.358.02-.529.056l-3.799-3.8A9.959 9.959 0 0 1 12 2Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsNcLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM7.094 5.68A8 8 0 0 1 18.32 16.905l-2.154-2.154A2.5 2.5 0 0 0 14 11h-4a.5.5 0 0 1 0-1.001h5.5V8H13V6h-2v2h-1c-.182 0-.359.02-.53.056L7.094 5.68ZM5.68 7.094 7.835 9.25A2.5 2.5 0 0 0 10 13h4a.5.5 0 0 1 0 1.001H8.5v2H11v2h2v-2h1c.182 0 .359-.02.53-.056l2.376 2.376A8 8 0 0 1 5.68 7.095Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsNdFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm4 11H8v2h8v-2Zm0-4H8v2h8V9Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsNdLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 9h8v2H8V9Zm0 6v-2h8v2H8Zm-6-3C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsSaFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 4c-2.177 0-4.03 1.67-4.716 4H6l2.5 3 2.5-3H9.401C9.92 8.805 10.89 8 12 8c1.657 0 3 1.79 3 4s-1.343 4-3 4c-1.11 0-2.08-.804-2.598-1.999H7.285C7.97 16.33 9.823 18 12 18c2.761 0 5-2.686 5-6s-2.239-6-5-6Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsSaLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 12c0-3.314-2.239-6-5-6-2.177 0-4.03 1.67-4.716 4H6l2.5 3 2.5-3H9.401C9.92 8.805 10.89 8 12 8c1.657 0 3 1.79 3 4s-1.343 4-3 4c-1.11 0-2.08-.804-2.598-1.999H7.285C7.97 16.33 9.823 18 12 18c2.761 0 5-2.686 5-6ZM12 2a9.971 9.971 0 0 0-7.07 2.93A9.971 9.971 0 0 0 2 12a9.971 9.971 0 0 0 2.93 7.07A9.971 9.971 0 0 0 12 22a9.97 9.97 0 0 0 7.07-2.93A9.97 9.97 0 0 0 22 12a9.971 9.971 0 0 0-2.93-7.07A9.971 9.971 0 0 0 12 2ZM6.344 6.344A7.972 7.972 0 0 1 12 4c2.208 0 4.206.895 5.656 2.344A7.972 7.972 0 0 1 20 12a7.972 7.972 0 0 1-2.344 5.656A7.972 7.972 0 0 1 12 20a7.972 7.972 0 0 1-5.656-2.344A7.972 7.972 0 0 1 4 12c0-2.208.895-4.206 2.344-5.656Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsZeroFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 4c-2.761 0-5 2.686-5 6s2.239 6 5 6 5-2.686 5-6-2.239-6-5-6Zm2.325 3.472c.422.69.675 1.57.675 2.528 0 2.21-1.343 4-3 4-.441 0-.86-.127-1.237-.355l3.562-6.173ZM12 8c.441 0 .86.127 1.237.355l-3.562 6.173C9.253 13.838 9 12.958 9 12c0-2.21 1.343-4 3-4Z"/>'
      }, props)
  }
  export function RiBusinessCreativeCommonsZeroLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 12c0-3.314-2.239-6-5-6s-5 2.686-5 6 2.239 6 5 6 5-2.686 5-6Zm-6.237 3.645 3.562-6.173c.422.69.675 1.57.675 2.528 0 2.21-1.343 4-3 4-.441 0-.86-.127-1.237-.355ZM9 12c0-2.21 1.343-4 3-4 .441 0 .86.127 1.237.355l-3.562 6.173C9.253 13.838 9 12.958 9 12Zm3-10a9.971 9.971 0 0 0-7.07 2.93A9.971 9.971 0 0 0 2 12a9.971 9.971 0 0 0 2.93 7.07A9.971 9.971 0 0 0 12 22a9.97 9.97 0 0 0 7.07-2.93A9.97 9.97 0 0 0 22 12a9.971 9.971 0 0 0-2.93-7.07A9.971 9.971 0 0 0 12 2ZM6.344 6.344A7.972 7.972 0 0 1 12 4c2.208 0 4.206.895 5.656 2.344A7.972 7.972 0 0 1 20 12a7.972 7.972 0 0 1-2.344 5.656A7.972 7.972 0 0 1 12 20a7.972 7.972 0 0 1-5.656-2.344A7.972 7.972 0 0 1 4 12c0-2.208.895-4.206 2.344-5.656Z"/>'
      }, props)
  }
  export function RiBusinessCustomerService2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1.062A8.001 8.001 0 0 1 12 23v-2a6 6 0 0 0 6-6V9A6 6 0 0 0 6 9v7H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.062a8.001 8.001 0 0 1 15.876 0H21ZM7.76 15.785l1.06-1.696A5.972 5.972 0 0 0 12 15a5.972 5.972 0 0 0 3.18-.911l1.06 1.696A7.963 7.963 0 0 1 12 17a7.962 7.962 0 0 1-4.24-1.215Z"/>'
      }, props)
  }
  export function RiBusinessCustomerService2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.938 8H21a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1.062A8.001 8.001 0 0 1 12 23v-2a6 6 0 0 0 6-6V9A6 6 0 0 0 6 9v7H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.062a8.001 8.001 0 0 1 15.876 0ZM3 10v4h1v-4H3Zm17 0v4h1v-4h-1ZM7.76 15.785l1.06-1.696A5.972 5.972 0 0 0 12 15a5.972 5.972 0 0 0 3.18-.911l1.06 1.696A7.963 7.963 0 0 1 12 17a7.962 7.962 0 0 1-4.24-1.215Z"/>'
      }, props)
  }
  export function RiBusinessCustomerServiceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 17.002a6.002 6.002 0 0 1-4.713 5.86l-.638-1.914A4.003 4.003 0 0 0 19.465 19H17a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.938a8.001 8.001 0 0 0-15.876 0H7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5C2 6.477 6.477 2 12 2s10 4.477 10 10V17.002Z"/>'
      }, props)
  }
  export function RiBusinessCustomerServiceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 17.002a6.002 6.002 0 0 1-4.713 5.86l-.638-1.914A4.003 4.003 0 0 0 19.465 19H17a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.938a8.001 8.001 0 0 0-15.876 0H7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5C2 6.477 6.477 2 12 2s10 4.477 10 10V17.002ZM20 17v-4h-3v4h3ZM4 13v4h3v-4H4Z"/>'
      }, props)
  }
  export function RiBusinessDonutChartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2.05v3.02a7.002 7.002 0 1 0 5.192 12.536l2.137 2.137A9.958 9.958 0 0 1 12 22C6.477 22 2 17.523 2 12c0-5.185 3.947-9.449 9-9.95ZM21.95 13a9.954 9.954 0 0 1-2.207 5.328l-2.137-2.136A6.964 6.964 0 0 0 18.93 13h3.022ZM13.002 2.05c4.724.469 8.48 4.226 8.95 8.95h-3.022a7.005 7.005 0 0 0-5.928-5.929V2.049Z"/>'
      }, props)
  }
  export function RiBusinessDonutChartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2.05v2.012a8.001 8.001 0 1 0 5.905 14.258l1.424 1.423A9.958 9.958 0 0 1 12 22C6.477 22 2 17.523 2 12c0-5.185 3.947-9.449 9-9.95ZM21.95 13a9.954 9.954 0 0 1-2.207 5.328l-1.423-1.422A7.96 7.96 0 0 0 19.938 13h2.013ZM13.002 2.05c4.724.469 8.48 4.226 8.95 8.95h-2.013a8.004 8.004 0 0 0-6.937-6.938V2.049Z"/>'
      }, props)
  }
  export function RiBusinessFlag2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3h19.138a.5.5 0 0 1 .434.748L18 10l3.573 6.252a.5.5 0 0 1-.435.748H4v5H2V3Z"/>'
      }, props)
  }
  export function RiBusinessFlag2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.138 3a.5.5 0 0 1 .434.748L18 10l3.573 6.252a.5.5 0 0 1-.435.748H4v5H2V3h19.138Zm-2.584 2H4v10h14.554l-2.857-5 2.857-5Z"/>'
      }, props)
  }
  export function RiBusinessFlagFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h9.382a1 1 0 0 1 .894.553L14 5h6a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-6.382a1 1 0 0 1-.894-.553L12 16H5v6H3V3Z"/>'
      }, props)
  }
  export function RiBusinessFlagLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.382 3a1 1 0 0 1 .894.553L14 5h6a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-6.382a1 1 0 0 1-.894-.553L12 16H5v6H3V3h9.382Zm-.618 2H5v9h8.236l1 2H19V7h-6.236l-1-2Z"/>'
      }, props)
  }
  export function RiBusinessGlobalFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.05 13h5.477a17.9 17.9 0 0 0 2.925 8.881 10.005 10.005 0 0 1-8.403-8.88Zm0-2a10.005 10.005 0 0 1 8.402-8.88A17.9 17.9 0 0 0 7.527 11H2.05Zm19.9 0h-5.477a17.9 17.9 0 0 0-2.925-8.88A10.005 10.005 0 0 1 21.95 11Zm0 2a10.005 10.005 0 0 1-8.402 8.881 17.9 17.9 0 0 0 2.925-8.88h5.478ZM9.53 13h4.94A15.908 15.908 0 0 1 12 20.592 15.908 15.908 0 0 1 9.53 13Zm0-2A15.908 15.908 0 0 1 12 3.41 15.908 15.908 0 0 1 14.47 11H9.53Z"/>'
      }, props)
  }
  export function RiBusinessGlobalLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.008 8.008 0 0 0 5.648 6.667ZM10.03 13c.151 2.439.848 4.73 1.97 6.752A15.905 15.905 0 0 0 13.97 13h-3.94Zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 19.938 13ZM4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.008 8.008 0 0 0 4.062 11Zm5.969 0h3.938A15.905 15.905 0 0 0 12 4.248 15.905 15.905 0 0 0 10.03 11Zm4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.008 8.008 0 0 0-5.648-6.667Z"/>'
      }, props)
  }
  export function RiBusinessHonourFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 4v14.721a.5.5 0 0 1-.298.458L12 23.03 3.298 19.18A.5.5 0 0 1 3 18.722V4H1V2h22v2h-2ZM8 12v2h8v-2H8Zm0-4v2h8V8H8Z"/>'
      }, props)
  }
  export function RiBusinessHonourLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 4v14.721a.5.5 0 0 1-.298.458L12 23.03 3.298 19.18A.5.5 0 0 1 3 18.722V4H1V2h22v2h-2ZM5 4v13.745l7 3.1 7-3.1V4H5Zm3 4h8v2H8V8Zm0 4h8v2H8v-2Z"/>'
      }, props)
  }
  export function RiBusinessInbox2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 3a1 1 0 0 0-.976.783l-2 9A1 1 0 0 0 2 13v7a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-7c0-.073-.008-.146-.024-.217l-2-9A1 1 0 0 0 19 3H5Zm14.753 9H15a3 3 0 1 1-6 0H4.247l1.555-7h12.396l1.555 7Z"/>'
      }, props)
  }
  export function RiBusinessInbox2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.024 3.783A1 1 0 0 1 5 3h14a1 1 0 0 1 .976.783l2 9c.016.071.024.144.024.217v7a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7a1 1 0 0 1 .024-.217l2-9ZM5.802 5l-1.555 7H9a3 3 0 1 0 6 0h4.753l-1.555-7H5.802Zm10.782 9a5.001 5.001 0 0 1-9.168 0H4v5h16v-5h-3.416Z"/>'
      }, props)
  }
  export function RiBusinessInboxArchiveFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16l2 4v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.004L4 3Zm9 11v-4h-2v4H8l4 4 4-4h-3Zm6.764-7-1-2H5.237l-1 2h15.527Z"/>'
      }, props)
  }
  export function RiBusinessInboxArchiveLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20 3 2 4v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.004L4 3h16Zm0 6H4v10h16V9Zm-7 1v4h3l-4 4-4-4h3v-4h2Zm5.764-5H5.237l-1 2h15.527l-1-2Z"/>'
      }, props)
  }
  export function RiBusinessInboxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm6 9a3 3 0 1 0 6 0h5V5H4v7h5Z"/>'
      }, props)
  }
  export function RiBusinessInboxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18ZM7.416 14H4v5h16v-5h-3.416a5.001 5.001 0 0 1-9.168 0ZM20 5H4v7h5a3 3 0 1 0 6 0h5V5Z"/>'
      }, props)
  }
  export function RiBusinessInboxUnarchiveFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20 3 2 4v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.004L4 3h16Zm-8 7-4 4h3v4h2v-4h3l-4-4Zm6.764-5H5.236l-.999 2h15.527l-1-2Z"/>'
      }, props)
  }
  export function RiBusinessInboxUnarchiveLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20 3 2 4v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.004L4 3h16Zm0 6H4v10h16V9Zm-8 1 4 4h-3v4h-2v-4H8l4-4Zm6.764-5H5.236l-.999 2h15.527l-1-2Z"/>'
      }, props)
  }
  export function RiBusinessLineChartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 3v16h16v2H3V3h2Zm14.94 2.94 2.12 2.12L16 14.122l-3-3-3.94 3.94-2.12-2.122L13 6.88l3 3 3.94-3.94Z"/>'
      }, props)
  }
  export function RiBusinessLineChartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 3v16h16v2H3V3h2Zm15.293 3.293 1.414 1.414L16 13.414l-3-2.999-4.293 4.292-1.414-1.414L13 7.586l3 2.999 4.293-4.292Z"/>'
      }, props)
  }
  export function RiBusinessLinksFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.06 8.11 1.415 1.415a7 7 0 0 1 0 9.9l-.354.353a7 7 0 1 1-9.9-9.9l1.415 1.415a5 5 0 0 0 7.07 7.07l.354-.353a5 5 0 0 0 0-7.07l-1.414-1.415L13.06 8.11Zm6.718 6.011-1.414-1.414a5 5 0 0 0-7.071-7.071l-.354.353a5 5 0 0 0 0 7.071l1.414 1.415-1.414 1.414-1.414-1.414a7 7 0 0 1 0-9.9l.353-.353a7 7 0 0 1 9.9 9.9Z"/>'
      }, props)
  }
  export function RiBusinessLinksLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.06 8.11 1.415 1.415a7 7 0 0 1 0 9.9l-.354.353a7 7 0 1 1-9.9-9.9l1.415 1.415a5 5 0 0 0 7.07 7.07l.354-.353a5 5 0 0 0 0-7.07l-1.414-1.415L13.06 8.11Zm6.718 6.011-1.414-1.414a5 5 0 0 0-7.071-7.071l-.354.353a5 5 0 0 0 0 7.071l1.414 1.415-1.414 1.414-1.414-1.414a7 7 0 0 1 0-9.9l.353-.353a7 7 0 0 1 9.9 9.9Z"/>'
      }, props)
  }
  export function RiBusinessMailAddFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13.341A6 6 0 0 0 14.341 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.341Zm-9.94-1.658L5.648 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.285 5.439ZM21 18h3v2h-3v3h-2v-3h-3v-2h3v-3h2v3Z"/>'
      }, props)
  }
  export function RiBusinessMailAddLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13h-2V7.238l-7.928 7.1L4 7.216V19h10v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9ZM4.511 5l7.55 6.662L19.502 5H4.511ZM21 18h3v2h-3v3h-2v-3h-3v-2h3v-3h2v3Z"/>'
      }, props)
  }
  export function RiBusinessMailCheckFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13.341A6 6 0 0 0 14.341 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.341Zm-9.94-1.658L5.648 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.285 5.439ZM19 22l-3.536-3.535 1.415-1.415L19 19.172l3.535-3.536 1.415 1.414L19 22Z"/>'
      }, props)
  }
  export function RiBusinessMailCheckLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 14h-2V7.238l-7.928 7.1L4 7.216V19h10v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v10ZM4.511 5l7.55 6.662L19.502 5H4.511ZM19 22l-3.536-3.535 1.415-1.415L19 19.172l3.535-3.536 1.415 1.414L19 22Z"/>'
      }, props)
  }
  export function RiBusinessMailCloseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13.341A6 6 0 0 0 14.341 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.341Zm-9.94-1.658L5.648 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.285 5.439ZM21.415 19l2.121 2.121-1.414 1.415L20 20.413l-2.121 2.121-1.415-1.414L18.587 19l-2.121-2.121 1.414-1.415L20 17.587l2.121-2.121 1.415 1.414L21.413 19Z"/>'
      }, props)
  }
  export function RiBusinessMailCloseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 14h-2V7.238l-7.928 7.1L4 7.216V19h11v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v10ZM4.511 5l7.55 6.662L19.502 5H4.511Zm16.903 14 2.121 2.121-1.414 1.415L20 20.413l-2.121 2.121-1.415-1.414L18.587 19l-2.121-2.121 1.414-1.415L20 17.587l2.121-2.121 1.415 1.414L21.413 19Z"/>'
      }, props)
  }
  export function RiBusinessMailDownloadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12.803A6 6 0 0 0 13.803 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8.803Zm-9.94-1.12L5.648 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.285 5.439ZM20 18h3l-4 4-4-4h3v-4h2v4Z"/>'
      }, props)
  }
  export function RiBusinessMailDownloadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20 7.238-7.928 7.1L4 7.216V19h9v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8h-2V7.238ZM19.501 5H4.511l7.55 6.662L19.502 5ZM20 18h3l-4 4-4-4h3v-4h2v4Z"/>'
      }, props)
  }
  export function RiBusinessMailFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm9.06 8.683L5.648 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.285 5.439Z"/>'
      }, props)
  }
  export function RiBusinessMailForbidFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.266 11.554 4.388-3.798-1.308-1.512-6.285 5.439-6.414-5.445-1.294 1.524 7.702 6.54A6.967 6.967 0 0 0 11 18c0 1.074.242 2.09.674 3H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8.255A6.968 6.968 0 0 0 18 11a6.98 6.98 0 0 0-2.734.554Zm1.44 9.154a3 3 0 0 0 4.001-4.001l-4 4Zm-1.414-1.415 4.001-4a3 3 0 0 0-4.001 4.001ZM18 23a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z"/>'
      }, props)
  }
  export function RiBusinessMailForbidLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20 7.238-7.928 7.1L4 7.216V19h7.07c.102.706.308 1.378.604 2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8.255a6.972 6.972 0 0 0-2-.965V7.238ZM19.501 5H4.511l7.55 6.662L19.502 5Zm-2.794 15.708a3 3 0 0 0 4.001-4.001l-4.001 4Zm-1.415-1.415 4.001-4a3 3 0 0 0-4.001 4.001ZM18 23a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z"/>'
      }, props)
  }
  export function RiBusinessMailLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm17 4.238-7.928 7.1L4 7.216V19h16V7.238ZM4.511 5l7.55 6.662L19.502 5H4.511Z"/>'
      }, props)
  }
  export function RiBusinessMailLockFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12a5.002 5.002 0 0 0-7.9 3H13v6H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8Zm-9.94-.317L5.648 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.285 5.439ZM22 17h1v5h-8v-5h1v-1a3 3 0 1 1 6 0v1Zm-2 0v-1a1 1 0 1 0-2 0v1h2Z"/>'
      }, props)
  }
  export function RiBusinessMailLockLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20 7.238-7.928 7.1L4 7.216V19h9v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v7h-2V7.238ZM19.501 5H4.511l7.55 6.662L19.502 5ZM22 17h1v5h-8v-5h1v-1a3 3 0 1 1 6 0v1Zm-2 0v-1a1 1 0 1 0-2 0v1h2Z"/>'
      }, props)
  }
  export function RiBusinessMailOpenFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2.243 6.854 9.247-5.546a1 1 0 0 1 1.028 0l9.24 5.546a.5.5 0 0 1 .242.429V20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.283a.5.5 0 0 1 .243-.429Zm16.103 1.39-6.285 5.439-6.414-5.445-1.294 1.524 7.72 6.555 7.581-6.561-1.308-1.512Z"/>'
      }, props)
  }
  export function RiBusinessMailOpenLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2.243 6.854 9.247-5.546a1 1 0 0 1 1.028 0l9.24 5.546a.5.5 0 0 1 .242.429V20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.283a.5.5 0 0 1 .243-.429ZM4 8.132V19h16V8.132l-7.996-4.8L4 8.132Zm8.06 5.566 5.296-4.463 1.288 1.53-6.57 5.537-6.71-5.53 1.272-1.544 5.424 4.47Z"/>'
      }, props)
  }
  export function RiBusinessMailSendFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 5.5V3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V19h18V7.3l-8 7.2-10-9ZM0 10h5v2H0v-2Zm0 5h8v2H0v-2Z"/>'
      }, props)
  }
  export function RiBusinessMailSendLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16.007a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V19h18V7.3l-8 7.2-10-9V4a1 1 0 0 1 1-1h18ZM8 15v2H0v-2h8Zm-3-5v2H0v-2h5Zm14.566-5H4.434L12 11.81 19.566 5Z"/>'
      }, props)
  }
  export function RiBusinessMailSettingsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13.341A6 6 0 0 0 14.341 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9.341Zm-9.94-1.658L5.648 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.285 5.439Zm4.99 7.866a3.023 3.023 0 0 1 0-1.098l-1.014-.585 1-1.732 1.014.586c.278-.238.599-.425.95-.55V15h2v1.17c.351.125.672.312.95.55l1.014-.586 1 1.732-1.014.585a3.023 3.023 0 0 1 0 1.098l1.014.585-1 1.732-1.014-.586a2.997 2.997 0 0 1-.95.55V23h-2v-1.17a2.997 2.997 0 0 1-.95-.55l-1.014.586-1-1.732 1.014-.585ZM20 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiBusinessMailSettingsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20 7.238-7.928 7.1L4 7.216V19h10v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9h-2V7.238ZM19.501 5H4.511l7.55 6.662L19.502 5ZM17.05 19.549a3.023 3.023 0 0 1 0-1.098l-1.014-.585 1-1.732 1.014.586c.278-.238.599-.425.95-.55V15h2v1.17c.351.125.672.312.95.55l1.014-.586 1 1.732-1.014.585a3.023 3.023 0 0 1 0 1.098l1.014.585-1 1.732-1.014-.586a2.997 2.997 0 0 1-.95.55V23h-2v-1.17a2.997 2.997 0 0 1-.95-.55l-1.014.586-1-1.732 1.014-.585ZM20 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiBusinessMailStarFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 14.044A6 6 0 0 0 13.689 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v10.044Zm-9.94-2.361L5.648 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.285 5.439ZM19.5 21.75l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L19.5 15l1.323 2.68 2.957.43-2.14 2.085.505 2.946L19.5 21.75Z"/>'
      }, props)
  }
  export function RiBusinessMailStarLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13h-2V7.238l-7.928 7.1L4 7.216V19h10v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v9ZM4.511 5l7.55 6.662L19.502 5H4.511ZM19.5 21.75l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L19.5 15l1.323 2.68 2.957.43-2.14 2.085.505 2.946L19.5 21.75Z"/>'
      }, props)
  }
  export function RiBusinessMailUnreadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.803 8.493A5.022 5.022 0 0 0 22 8.9V20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h13.1c-.066.323-.1.658-.1 1a4.98 4.98 0 0 0 1.193 3.241l-5.132 4.442-6.414-5.445-1.294 1.524 7.72 6.555 6.73-5.824ZM21 7a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiBusinessMailUnreadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.1 3a5.022 5.022 0 0 0 0 2H4.511l7.55 6.662 5.049-4.52c.426.527.958.966 1.563 1.285l-6.601 5.911L4 7.216V19h16V8.9a5.022 5.022 0 0 0 2 0V20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h13.1ZM21 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"/>'
      }, props)
  }
  export function RiBusinessMailVolumeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 14.5v9L16.667 21H14v-4h2.667L20 14.5ZM21 3a1 1 0 0 1 1 1v10.529A6 6 0 0 0 12.34 21L3.002 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm0 14a2 2 0 0 1 .15 3.994L21 21v-4ZM5.647 6.238 4.353 7.762l7.72 6.555 7.581-6.56-1.308-1.513-6.286 5.438-6.413-5.444Z"/>'
      }, props)
  }
  export function RiBusinessMailVolumeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 14.5v9L16.667 21H14v-4h2.667L20 14.5ZM21 3a1 1 0 0 1 1 1v9h-2V7.237l-7.928 7.101L4 7.215V19h8v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm0 14a2 2 0 0 1 .15 3.994L21 21v-4ZM19.5 5H4.511l7.55 6.662L19.5 5Z"/>'
      }, props)
  }
  export function RiBusinessMedal2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 8.5 2.116 5.088 5.492.44-4.184 3.585 1.278 5.36L12 20.1l-4.702 2.872 1.278-5.36-4.184-3.584 5.492-.44L12 8.5ZM8 2v9H6V2h2Zm10 0v9h-2V2h2Zm-5 0v5h-2V2h2Z"/>'
      }, props)
  }
  export function RiBusinessMedal2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 8.5 2.116 5.088 5.492.44-4.184 3.585 1.278 5.36L12 20.1l-4.702 2.872 1.278-5.36-4.184-3.584 5.492-.44L12 8.5Zm0 5.207-.739 1.776-1.916.154 1.46 1.251-.447 1.871L12 17.756l1.641 1.003-.446-1.87 1.46-1.252-1.916-.154L12 13.707ZM8 2v9H6V2h2Zm10 0v9h-2V2h2Zm-5 0v5h-2V2h2Z"/>'
      }, props)
  }
  export function RiBusinessMedalFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 7a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 3.5-1.322 2.68-2.958.43 2.14 2.085-.505 2.946L12 17.25l2.645 1.39-.505-2.945 2.14-2.086-2.958-.43L12 10.5Zm1-8.501L18 2v3l-1.363 1.138A9.935 9.935 0 0 0 13 5.05L13 1.999Zm-2 0v3.05a9.935 9.935 0 0 0-3.636 1.088L6 5V2l5-.001Z"/>'
      }, props)
  }
  export function RiBusinessMedalLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 7a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm0 1.5 1.322 2.68 2.958.43-2.14 2.085.505 2.946L12 17.25l-2.645 1.39.505-2.945-2.14-2.086 2.958-.43L12 10.5ZM18 2v3l-1.363 1.138A9.935 9.935 0 0 0 13 5.05L13 1.999 18 2Zm-7-.001v3.05a9.935 9.935 0 0 0-3.636 1.088L6 5V2l5-.001Z"/>'
      }, props)
  }
  export function RiBusinessMegaphoneFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 10.063V4a1 1 0 0 0-1-1h-1c-1.979 1.979-5.697 3.087-8 3.613v10.774c2.303.526 6.021 1.634 8 3.613h1a1 1 0 0 0 1-1v-6.063a2 2 0 0 0 0-3.874ZM5 7a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1l1 5h2V7H5Z"/>'
      }, props)
  }
  export function RiBusinessMegaphoneLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 17s7 1 10 4h1a1 1 0 0 0 1-1v-6.063a2 2 0 0 0 0-3.874V4a1 1 0 0 0-1-1h-1C16 6 9 7 9 7H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1l1 5h2v-5Zm2-8.339c.683-.146 1.527-.35 2.44-.617 1.678-.494 3.81-1.271 5.56-2.47v12.851c-1.75-1.198-3.883-1.975-5.56-2.469A33.967 33.967 0 0 0 11 15.34V8.66ZM5 9h4v6H5V9Z"/>'
      }, props)
  }
  export function RiBusinessPassExpiredFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM2 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2Zm9 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-5.473 7.025-1.414-1.414A5.486 5.486 0 0 1 8.003 14c1.518 0 2.894.617 3.888 1.61l-1.414 1.415A3.486 3.486 0 0 0 8.002 16c-.967 0-1.84.39-2.475 1.025ZM16 10.585l1.793-1.792 1.414 1.414L17.414 12l1.793 1.793-1.414 1.414L16 13.414l-1.793 1.793-1.414-1.414L14.586 12l-1.793-1.793 1.414-1.414L16 10.586Z"/>'
      }, props)
  }
  export function RiBusinessPassExpiredLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 18h18V6H3v12ZM1 5a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5Zm8 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-2.998 6c-.967 0-1.84.39-2.475 1.025l-1.414-1.414A5.486 5.486 0 0 1 8.002 14c1.518 0 2.895.617 3.889 1.61l-1.414 1.415A3.486 3.486 0 0 0 8.002 16Zm9.79-7.207L16 10.586l-1.793-1.793-1.414 1.414L14.586 12l-1.793 1.793 1.414 1.414L16 13.414l1.793 1.793 1.414-1.414L17.414 12l1.793-1.793-1.414-1.414Z"/>'
      }, props)
  }
  export function RiBusinessPassPendingFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2Zm7 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-5.473 7.025-1.414-1.414A5.486 5.486 0 0 1 8.003 14c1.518 0 2.894.617 3.888 1.61l-1.414 1.415A3.486 3.486 0 0 0 8.002 16c-.967 0-1.84.39-2.475 1.025ZM13 15V9h2v6h-2Zm4 0V9h2v6h-2Z"/>'
      }, props)
  }
  export function RiBusinessPassPendingLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 18h18V6H3v12ZM1 5a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5Zm8 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-2.998 6c-.967 0-1.84.39-2.475 1.025l-1.414-1.414A5.486 5.486 0 0 1 8.002 14c1.518 0 2.895.617 3.889 1.61l-1.414 1.415A3.486 3.486 0 0 0 8.002 16ZM13 9v6h2V9h-2Zm4 0v6h2V9h-2Z"/>'
      }, props)
  }
  export function RiBusinessPassValidFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H2Zm7 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-5.473 7.025-1.414-1.414A5.486 5.486 0 0 1 8.003 14c1.518 0 2.894.617 3.888 1.61l-1.414 1.415A3.486 3.486 0 0 0 8.002 16c-.967 0-1.84.39-2.475 1.025Zm14.68-6.318-4 4-.707.707-.707-.707-2.5-2.5 1.414-1.414 1.793 1.793 3.293-3.293 1.414 1.414Z"/>'
      }, props)
  }
  export function RiBusinessPassValidLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 18h18V6H3v12ZM1 5a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5Zm8 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-2.998 6c-.967 0-1.84.39-2.475 1.025l-1.414-1.414A5.486 5.486 0 0 1 8.002 14c1.518 0 2.895.617 3.889 1.61l-1.414 1.415A3.486 3.486 0 0 0 8.002 16Zm8.205-1.293 4-4-1.414-1.414-3.293 3.293-1.793-1.793-1.414 1.414 2.5 2.5.707.707.707-.707Z"/>'
      }, props)
  }
  export function RiBusinessPieChart2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2.05V13h10.95c-.501 5.053-4.765 9-9.95 9-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95Zm2-1.507c5.553.478 9.979 4.904 10.457 10.457H13V.543Z"/>'
      }, props)
  }
  export function RiBusinessPieChart2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 .5C18.351.5 23.5 5.649 23.5 12c0 .337-.015.67-.043 1h-1.506c-.502 5.053-4.766 9-9.951 9-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95V.542c.33-.029.663-.043 1-.043Zm-1 3.562A8.001 8.001 0 0 0 12 20a8.001 8.001 0 0 0 7.938-7H11V4.062Zm2-1.51V11h8.448A9.503 9.503 0 0 0 13 2.552Z"/>'
      }, props)
  }
  export function RiBusinessPieChartBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm13.9 10H11V7.1a5.002 5.002 0 0 0 1 9.9 5.002 5.002 0 0 0 4.9-4Zm0-2A5.006 5.006 0 0 0 13 7.1V11h3.9Z"/>'
      }, props)
  }
  export function RiBusinessPieChartBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h16V5H4Zm12.9 8A5.002 5.002 0 0 1 7 12a5.002 5.002 0 0 1 4-4.9V13h5.9Zm0-2H13V7.1a5.006 5.006 0 0 1 3.9 3.9Z"/>'
      }, props)
  }
  export function RiBusinessPieChartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2.05V13h10.95c-.501 5.053-4.765 9-9.95 9-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95Zm2 0A10.003 10.003 0 0 1 21.95 11H13V2.05Z"/>'
      }, props)
  }
  export function RiBusinessPieChartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 2.458v2.124A8.003 8.003 0 0 0 12 20a8.003 8.003 0 0 0 7.419-5h2.123c-1.274 4.057-5.064 7-9.542 7-5.523 0-10-4.477-10-10 0-4.478 2.943-8.268 7-9.542ZM12 2c5.523 0 10 4.477 10 10 0 .338-.017.671-.05 1H11V2.05c.329-.033.662-.05 1-.05Zm1 2.062V11h6.938A8.004 8.004 0 0 0 13 4.062Z"/>'
      }, props)
  }
  export function RiBusinessPresentationFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM5 16v6H3V10a3 3 0 0 1 5.106-2.137l2.374 2.243 2.313-2.313 1.414 1.414-3.687 3.687L9 11.46V22H7v-6H5Zm5-11h9v9h-9v2h4.365l2.824 6h2.21l-2.823-6H20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H10v2Z"/>'
      }, props)
  }
  export function RiBusinessPresentationLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM5 16v6H3V10a3 3 0 0 1 5.106-2.137l2.374 2.243 2.313-2.313 1.414 1.414-3.687 3.687L9 11.46V22H7v-6H5Zm1-7a1 1 0 0 0-1 1v4h2v-4a1 1 0 0 0-1-1Zm13-4h-9V3h10a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-3.424l2.823 6h-2.21l-2.824-6H10v-2h9V5Z"/>'
      }, props)
  }
  export function RiBusinessPrinterCloudFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 2h10a1 1 0 0 1 1 1v3H6V3a1 1 0 0 1 1-1Zm15 7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2v-5h7.194c.243-.891.715-1.688 1.417-2.39C14.685 11.538 15.98 11 17.5 11c1.519 0 2.815.537 3.89 1.61.227.229.43.466.61.714V9ZM8 10v2H5v-2h3Zm13 6.5a3.5 3.5 0 1 0-7 0l.003.102a2.751 2.751 0 0 0 .58 5.393l.167.005h5.5l.168-.005a2.75 2.75 0 0 0 .58-5.392L21 16.5ZM7 17h3.562A4.617 4.617 0 0 0 10 19.25c0 1.032.29 1.949.871 2.75H7v-5Z"/>'
      }, props)
  }
  export function RiBusinessPrinterCloudLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 2a1 1 0 0 1 1 1v4h3a1 1 0 0 1 1 1v5.324a5.925 5.925 0 0 0-.61-.713A5.595 5.595 0 0 0 20 11.583V9H4v8h2v-1a1 1 0 0 1 1-1h5.194a5.305 5.305 0 0 0-.07.283A4.945 4.945 0 0 0 10.562 17H8.001v3h2.054a4.48 4.48 0 0 0 .817 2H7a1 1 0 0 1-1-1v-2H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1h10Zm-1 2H8v3h8V4Zm-8 6v2H5v-2h3Zm13 6.5a3.5 3.5 0 1 0-7 0l.003.102a2.751 2.751 0 0 0 .58 5.393l.167.005h5.5l.168-.005a2.75 2.75 0 0 0 .58-5.392L21 16.5Zm-4.993-.145a1.5 1.5 0 0 1 2.986 0L19 16.5v1.62c.696.199 1.177.334 1.444.406A.75.75 0 0 1 20.255 20h-5.51a.75.75 0 0 1-.19-1.474c.238-.064.645-.178 1.22-.342L16 18.12V16.5l.007-.145Z"/>'
      }, props)
  }
  export function RiBusinessPrinterFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 17h10v5H7v-5Zm12 3v-5H5v5H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2ZM5 10v2h3v-2H5Zm2-8h10a1 1 0 0 1 1 1v3H6V3a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiBusinessPrinterLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 2a1 1 0 0 1 1 1v4h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1h10Zm-1 15H8v3h8v-3Zm4-8H4v8h2v-1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1h2V9ZM8 10v2H5v-2h3Zm8-6H8v3h8V4Z"/>'
      }, props)
  }
  export function RiBusinessProfileFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993ZM6 15v2h12v-2H6Zm0-8v6h6V7H6Zm8 0v2h4V7h-4Zm0 4v2h4v-2h-4ZM8 9h2v2H8V9Z"/>'
      }, props)
  }
  export function RiBusinessProfileLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.008 3c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h18.016ZM20 5H4v14h16V5Zm-2 10v2H6v-2h12Zm-6-8v6H6V7h6Zm6 4v2h-4v-2h4Zm-8-2H8v2h2V9Zm8-2v2h-4V7h4Z"/>'
      }, props)
  }
  export function RiBusinessProjector2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 19v2h-2v-2H4v2H2v-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h9.81a6.481 6.481 0 0 1 4.69-2c1.843 0 3.508.767 4.69 2H22a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1Zm-5.5-5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-2a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM4 13v2h2v-2H4Zm4 0v2h2v-2H8Z"/>'
      }, props)
  }
  export function RiBusinessProjector2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 19v2h-2v-2H4v2H2v-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10.528A5.985 5.985 0 0 1 17 3c1.777 0 3.374.772 4.472 2H22a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1ZM11.341 7H3v10h18v-3.528A6 6 0 0 1 11.341 7ZM17 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM5 13h2v2H5v-2Zm3 0h2v2H8v-2Z"/>'
      }, props)
  }
  export function RiBusinessProjectorFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.111 12a4.502 4.502 0 0 0 8.777 0H22v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h9.111ZM5 16h2v2H5v-2Zm10.5-2.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM11.111 10H2V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v6h-2.111a4.502 4.502 0 0 0-8.777 0Z"/>'
      }, props)
  }
  export function RiBusinessProjectorLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm8.126 9H4v7h16v-7h-1.126a4.002 4.002 0 0 1-7.748 0Zm0-2a4.002 4.002 0 0 1 7.748 0H20V5H4v5h7.126ZM15 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-9 2h2v2H6v-2Z"/>'
      }, props)
  }
  export function RiBusinessRecordMailFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.743 15h4.514a5.5 5.5 0 1 1 4.243 2h-13a5.5 5.5 0 1 1 4.243-2ZM5.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm13 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiBusinessRecordMailLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.257 15a5.5 5.5 0 1 1 4.243 2h-13a5.5 5.5 0 1 1 4.243-2h4.514ZM5.5 15a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm13 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"/>'
      }, props)
  }
  export function RiBusinessRegisteredFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm.5 5H8v10h2v-3h2.217l2.18 3h2.472l-2.55-3.51a3.5 3.5 0 0 0-1.627-6.486l-.192-.004Zm0 2a1.5 1.5 0 0 1 1.493 1.355L14 10.5l-.007.145a1.5 1.5 0 0 1-1.348 1.348L12.5 12H10V9h2.5Z"/>'
      }, props)
  }
  export function RiBusinessRegisteredLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm.5 3a3.5 3.5 0 0 1 1.82 6.49L16.868 17h-2.472l-2.18-3H10v3H8V7h4.5Zm0 2H10v3h2.5a1.5 1.5 0 0 0 1.493-1.355L14 10.5A1.5 1.5 0 0 0 12.5 9Z"/>'
      }, props)
  }
  export function RiBusinessReplyAllFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 4.5V9c5.523 0 10 4.477 10 10 0 .273-.01.543-.032.81a9.002 9.002 0 0 0-7.655-4.805L16 15h-2v4.5L6 12l8-7.5Zm-6 0v2.737L2.92 12l5.079 4.761L8 19.5 0 12l8-7.5Z"/>'
      }, props)
  }
  export function RiBusinessReplyAllLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 4.5V9c5.523 0 10 4.477 10 10 0 .273-.01.543-.032.81a9.002 9.002 0 0 0-7.655-4.805L16 15h-2v4.5L6 12l8-7.5Zm-6 0v2.737L2.92 12l5.079 4.761L8 19.5 0 12l8-7.5Zm4 4.616L8.924 12 12 14.883V13h4.034l.347.007c1.285.043 2.524.31 3.676.766A7.982 7.982 0 0 0 14 11h-2V9.116Z"/>'
      }, props)
  }
  export function RiBusinessReplyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 20 1 12l10-8v5c5.523 0 10 4.477 10 10 0 .273-.01.543-.032.81A8.999 8.999 0 0 0 13 15h-2v5Z"/>'
      }, props)
  }
  export function RiBusinessReplyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 20 1 12l10-8v5c5.523 0 10 4.477 10 10 0 .273-.01.543-.032.81a9.002 9.002 0 0 0-7.655-4.805L13 15h-2v5Zm-2-7h4.034l.347.007c1.285.043 2.524.31 3.676.766A7.982 7.982 0 0 0 11 11H9V8.161L4.202 12 9 15.839V13Z"/>'
      }, props)
  }
  export function RiBusinessSendPlane2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 13h6v-2H3V1.846a.5.5 0 0 1 .741-.438l18.462 10.154a.5.5 0 0 1 0 .876L3.741 22.593A.5.5 0 0 1 3 22.154V13Z"/>'
      }, props)
  }
  export function RiBusinessSendPlane2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.5 1.346a.5.5 0 0 1 .241.062l18.462 10.154a.5.5 0 0 1 0 .876L3.741 22.593A.5.5 0 0 1 3 22.154V1.846a.5.5 0 0 1 .5-.5ZM5 4.383V11h5v2H5v6.617L18.85 12 5 4.383Z"/>'
      }, props)
  }
  export function RiBusinessSendPlaneFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1.946 9.316c-.522-.175-.526-.456.011-.635L21.043 2.32c.529-.176.832.12.684.638l-5.453 19.086c-.151.529-.456.547-.68.045L12 14l6-8-8 6-8.054-2.684Z"/>'
      }, props)
  }
  export function RiBusinessSendPlaneLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m21.726 2.957-5.453 19.086c-.15.529-.475.553-.717.07L11 13 1.923 9.37c-.51-.205-.504-.51.034-.689L21.043 2.32c.528-.176.832.12.683.638Zm-2.69 2.14L6.811 9.17l5.637 2.255 3.04 6.081 3.546-12.41Z"/>'
      }, props)
  }
  export function RiBusinessSeoFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 3a7 7 0 0 0 0 14h1.07a7.06 7.06 0 0 1 0-2H8A5 5 0 0 1 8 5h8a5 5 0 0 1 4.9 6 7.021 7.021 0 0 1 1.426 2A7 7 0 0 0 16 3H8Zm3 13a5 5 0 1 1 9.172 2.757l2.535 2.536-1.414 1.414-2.536-2.535A5 5 0 0 1 11 16Z"/>'
      }, props)
  }
  export function RiBusinessSeoLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 3a7 7 0 0 0 0 14h1.07a7.06 7.06 0 0 1 0-2H8A5 5 0 0 1 8 5h8a5 5 0 0 1 4.9 6 7.021 7.021 0 0 1 1.426 2A7 7 0 0 0 16 3H8Zm8 10a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 9.172 2.757l2.535 2.536-1.414 1.414-2.536-2.535A5 5 0 0 1 11 16Z"/>'
      }, props)
  }
  export function RiBusinessServiceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.121 10.48a1 1 0 0 0-1.414 0l-.707.707a2 2 0 0 1-2.828-2.829l5.63-5.632a6.5 6.5 0 0 1 6.377 10.568l-2.108 2.135-4.95-4.95ZM3.161 4.47a6.503 6.503 0 0 1 8.009-.938L7.757 6.944a4 4 0 0 0 5.513 5.795l.144-.138 4.243 4.243-4.243 4.242a2 2 0 0 1-2.828 0L3.16 13.662a6.5 6.5 0 0 1 0-9.193Z"/>'
      }, props)
  }
  export function RiBusinessServiceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.161 4.469a6.5 6.5 0 0 1 8.84-.328 6.5 6.5 0 0 1 9.178 9.154l-7.765 7.79a2 2 0 0 1-2.719.102l-.11-.101-7.764-7.791a6.5 6.5 0 0 1 .34-8.826Zm1.414 1.414a4.5 4.5 0 0 0-.146 6.21l.146.154L12 19.672l5.303-5.305-3.535-3.534-1.06 1.06a3 3 0 0 1-4.244-4.242l2.102-2.103a4.501 4.501 0 0 0-5.837.189l-.154.146Zm8.486 2.828a1 1 0 0 1 1.414 0l4.242 4.242.708-.706a4.5 4.5 0 0 0-6.211-6.51l-.153.146-3.182 3.182a1 1 0 0 0-.078 1.327l.078.087a1 1 0 0 0 1.327.078l.087-.078 1.768-1.768Z"/>'
      }, props)
  }
  export function RiBusinessShakeHandsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.291 6h.71a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-2l-4.17-5.836a2 2 0 0 0-2.201-.753l-2.486.746a2 2 0 0 1-1.988-.502l-.293-.293a1 1 0 0 1 .152-1.539l5.401-3.6a2 2 0 0 1 2.183-.024l4.156 2.645A1 1 0 0 0 19.29 6ZM5.027 14.295l-1.616 1.414a1 1 0 0 0 .041 1.538l5.14 4.04a1 1 0 0 0 1.487-.29l.704-1.232a2 2 0 0 0-.257-2.338l-2.702-2.973a2 2 0 0 0-2.797-.16ZM7.046 5H3a1 1 0 0 0-1 1v7.516a2 2 0 0 0 .35 1.13 2.61 2.61 0 0 1 .074-.066l1.615-1.414a3.5 3.5 0 0 1 4.895.28l2.702 2.972a3.5 3.5 0 0 1 .45 4.09l-.655 1.146a2 2 0 0 0 1.738-.155l4.41-2.646a1 1 0 0 0 .299-1.438l-5.267-7.379a.5.5 0 0 0-.55-.188l-2.486.745a3.5 3.5 0 0 1-3.48-.877l-.293-.293a2.5 2.5 0 0 1 .38-3.848L7.047 5Z"/>'
      }, props)
  }
  export function RiBusinessShakeHandsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.861 2.39a3 3 0 0 1 3.275-.034L19.29 5H21a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1.52a2.65 2.65 0 0 1-1.285 2.449l-5.093 3.056a2 2 0 0 1-2.07-.008c-.7.62-1.779.688-2.561.073l-5.14-4.039a2.001 2.001 0 0 1-.565-2.446A2 2 0 0 1 2 13.51V6a1 1 0 0 1 1-1h4.947l3.914-2.61ZM4.173 13.646l.692-.605a3 3 0 0 1 4.195.24l2.702 2.972a3 3 0 0 1 .396 3.487l5.008-3.005a.657.657 0 0 0 .279-.79l-4.427-6.198a1 1 0 0 0-1.101-.377l-2.486.745a3 3 0 0 1-2.983-.752l-.293-.292A1.997 1.997 0 0 1 5.68 7H4v6.51l.173.135Zm9.89-9.602a1 1 0 0 0-1.093.012l-5.4 3.6.292.293a1 1 0 0 0 .995.25l2.485-.745a3 3 0 0 1 3.303 1.13L18.515 14H20V7h-.709a2 2 0 0 1-1.074-.313l-4.155-2.644ZM6.181 14.545l-1.616 1.414 5.14 4.039.705-1.232a1 1 0 0 0-.129-1.169L7.58 14.625a1 1 0 0 0-1.398-.08Z"/>'
      }, props)
  }
  export function RiBusinessSlideshow2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 17v3h5v2H6v-2h5v-3H4a1 1 0 0 1-1-1V4H2V2h20v2h-1v12a1 1 0 0 1-1 1h-7ZM10 6v7l5-3.5L10 6Z"/>'
      }, props)
  }
  export function RiBusinessSlideshow2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 17v3h5v2H6v-2h5v-3H4a1 1 0 0 1-1-1V4H2V2h20v2h-1v12a1 1 0 0 1-1 1h-7Zm-8-2h14V4H5v11Zm5-9 5 3.5-5 3.5V6Z"/>'
      }, props)
  }
  export function RiBusinessSlideshow3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 18v2h4v2H7v-2h4v-2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-8ZM10 7.5v6l5-3-5-3Z"/>'
      }, props)
  }
  export function RiBusinessSlideshow3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 18v2h4v2H7v-2h4v-2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-8ZM4 5v11h16V5H4Zm6 2.5 5 3-5 3v-6Z"/>'
      }, props)
  }
  export function RiBusinessSlideshow4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.17 3A3.001 3.001 0 0 1 11 1h2c1.306 0 2.418.835 2.83 2H21a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5.17ZM10 9v6l5-3-5-3Zm1-6a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"/>'
      }, props)
  }
  export function RiBusinessSlideshow4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.17 3A3.001 3.001 0 0 1 11 1h2c1.306 0 2.418.835 2.83 2H21a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5.17ZM4 5v14h16V5h-4.17A3.001 3.001 0 0 1 13 7h-2a3.001 3.001 0 0 1-2.83-2H4Zm7-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Zm-1 6 5 3-5 3V9Z"/>'
      }, props)
  }
  export function RiBusinessSlideshowFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 21v2h-2v-2H3a1 1 0 0 1-1-1V6h20v14a1 1 0 0 1-1 1h-8ZM8 10a3 3 0 1 0 3 3H8v-3Zm5 0v2h6v-2h-6Zm0 4v2h6v-2h-6ZM2 3h20v2H2V3Z"/>'
      }, props)
  }
  export function RiBusinessSlideshowLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 21v2h-2v-2H3a1 1 0 0 1-1-1V6h20v14a1 1 0 0 1-1 1h-8Zm-9-2h16V8H4v11Zm9-9h5v2h-5v-2Zm0 4h5v2h-5v-2Zm-4-4v3h3a3 3 0 1 1-3-3ZM2 3h20v2H2V3Z"/>'
      }, props)
  }
  export function RiBusinessStackFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20.083 10.5 1.202.721a.5.5 0 0 1 0 .858L12 17.649l-9.285-5.57a.5.5 0 0 1 0-.858l1.202-.721L12 15.35l8.083-4.85Zm0 4.7 1.202.721a.5.5 0 0 1 0 .858l-8.77 5.262a1 1 0 0 1-1.03 0l-8.77-5.262a.5.5 0 0 1 0-.858l1.202-.721L12 20.05l8.083-4.85ZM12.514 1.309l8.771 5.262a.5.5 0 0 1 0 .858L12 12.999 2.715 7.43a.5.5 0 0 1 0-.858l8.77-5.262a1 1 0 0 1 1.03 0Z"/>'
      }, props)
  }
  export function RiBusinessStackLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20.083 15.2 1.202.721a.5.5 0 0 1 0 .858l-8.77 5.262a1 1 0 0 1-1.03 0l-8.77-5.262a.5.5 0 0 1 0-.858l1.202-.721L12 20.05l8.083-4.85Zm0-4.7 1.202.721a.5.5 0 0 1 0 .858L12 17.649l-9.285-5.57a.5.5 0 0 1 0-.858l1.202-.721L12 15.35l8.083-4.85Zm-7.569-9.191 8.771 5.262a.5.5 0 0 1 0 .858L12 12.999 2.715 7.43a.5.5 0 0 1 0-.858l8.77-5.262a1 1 0 0 1 1.03 0ZM12 3.332 5.887 7 12 10.667 18.113 7 12 3.332Z"/>'
      }, props)
  }
  export function RiBusinessTrademarkFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 6v2H6v10H4V8H0V6h10Zm2 0h2.5l3 5.196L20.5 6H23v12h-2V9.133l-3.5 6.063L14 9.135V18h-2V6Z"/>'
      }, props)
  }
  export function RiBusinessTrademarkLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 6v2H6v10H4V8H0V6h10Zm2 0h2.5l3 5.196L20.5 6H23v12h-2V9.133l-3.5 6.063L14 9.135V18h-2V6Z"/>'
      }, props)
  }
  export function RiBusinessWindow2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm17 7H4v9h16v-9Zm-5-4v2h4V6h-4Z"/>'
      }, props)
  }
  export function RiBusinessWindow2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-1 8H4v8h16v-8Zm0-6H4v4h16V5Zm-1 1v2h-4V6h4Z"/>'
      }, props)
  }
  export function RiBusinessWindowFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm17 7H4v9h16v-9ZM5 6v2h2V6H5Zm4 0v2h2V6H9Z"/>'
      }, props)
  }
  export function RiBusinessWindowLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-1 8H4v8h16v-8Zm0-6H4v4h16V5Zm-9 1v2H9V6h2ZM7 6v2H5V6h2Z"/>'
      }, props)
  }
  export function RiCommunicationChat1Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 3h4a8 8 0 1 1 0 16v3.5c-5-2-12-5-12-11.5a8 8 0 0 1 8-8Z"/>'
      }, props)
  }
  export function RiCommunicationChat1Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 3h4a8 8 0 1 1 0 16v3.5c-5-2-12-5-12-11.5a8 8 0 0 1 8-8Zm2 14h2a6 6 0 0 0 0-12h-4a6 6 0 0 0-6 6c0 3.61 2.462 5.966 8 8.48V17Z"/>'
      }, props)
  }
  export function RiCommunicationChat2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.45 19 12 22.5 9.55 19H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-6.55Z"/>'
      }, props)
  }
  export function RiCommunicationChat2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.45 19 12 22.5 9.55 19H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-6.55Zm-1.041-2H20V5H4v12h6.591L12 19.012 13.409 17Z"/>'
      }, props)
  }
  export function RiCommunicationChat3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.291 20.824 2 22l1.176-5.291A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.956 9.956 0 0 1-4.709-1.176Z"/>'
      }, props)
  }
  export function RiCommunicationChat3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.291 20.824 2 22l1.176-5.291A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.956 9.956 0 0 1-4.709-1.176Zm.29-2.113.653.35A7.955 7.955 0 0 0 12 20a8 8 0 1 0-8-8c0 1.335.325 2.617.94 3.766l.349.653-.655 2.947 2.947-.655Z"/>'
      }, props)
  }
  export function RiCommunicationChat4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Z"/>'
      }, props)
  }
  export function RiCommunicationChat4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.763 17H20V5H4v13.385L5.763 17Zm.692 2L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Z"/>'
      }, props)
  }
  export function RiCommunicationChatCheckFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Zm4.838-6.879L8.818 9.646l-1.414 1.415 3.889 3.889 5.657-5.657-1.414-1.414-4.243 4.242Z"/>'
      }, props)
  }
  export function RiCommunicationChatCheckLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Zm-.692-2H20V5H4v13.385L5.763 17Zm5.53-4.879 4.243-4.242 1.414 1.414-5.657 5.657-3.89-3.89 1.415-1.414 2.475 2.475Z"/>'
      }, props)
  }
  export function RiCommunicationChatDeleteFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Zm6.96-8 2.474-2.475-1.414-1.414L12 9.586 9.525 7.11 8.111 8.525 10.586 11 8.11 13.475l1.414 1.414L12 12.414l2.475 2.475 1.414-1.414L13.414 11Z"/>'
      }, props)
  }
  export function RiCommunicationChatDeleteLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM4 18.385 5.763 17H20V5H4v13.385ZM13.414 11l2.475 2.475-1.414 1.414L12 12.414 9.525 14.89l-1.414-1.414L10.586 11 8.11 8.525l1.414-1.414L12 9.586l2.475-2.475 1.414 1.414L13.414 11Z"/>'
      }, props)
  }
  export function RiCommunicationChatDownloadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM13 11V7h-2v4H8l4 4 4-4h-3Z"/>'
      }, props)
  }
  export function RiCommunicationChatDownloadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM4 18.385 5.763 17H20V5H4v13.385ZM13 11h3l-4 4-4-4h3V7h2v4Z"/>'
      }, props)
  }
  export function RiCommunicationChatFollowUpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1h18Zm-4 4h-2v8h2V7Zm-6 1H9v1.999L7 10v2l2-.001V14h2v-2.001L13 12v-2l-2-.001V8Z"/>'
      }, props)
  }
  export function RiCommunicationChatFollowUpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1h18Zm-1 2H4v13.385L5.763 17H20V5Zm-3 2v8h-2V7h2Zm-6 1v1.999L13 10v2l-2-.001V14H9v-2.001L7 12v-2l2-.001V8h2Z"/>'
      }, props)
  }
  export function RiCommunicationChatForwardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM12 10H8v2h4v3l4-4-4-4v3Z"/>'
      }, props)
  }
  export function RiCommunicationChatForwardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM4 18.385 5.763 17H20V5H4v13.385ZM12 10V7l4 4-4 4v-3H8v-2h4Z"/>'
      }, props)
  }
  export function RiCommunicationChatHeartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Zm5.563-4.3 3.358-3.359a2.25 2.25 0 1 0-3.181-3.182l-.177.177-.177-.177a2.25 2.25 0 0 0-3.182 3.182l3.359 3.359Z"/>'
      }, props)
  }
  export function RiCommunicationChatHeartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM4 18.385 5.763 17H20V5H4v13.385Zm8.018-3.685L8.659 11.34a2.25 2.25 0 0 1 3.182-3.182l.177.177.176-.177a2.25 2.25 0 0 1 3.182 3.182L12.018 14.7Z"/>'
      }, props)
  }
  export function RiCommunicationChatHistoryFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.956 9.956 0 0 1-4.708-1.175L2 22l1.176-5.29A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2Zm1 5h-2v7h6v-2h-4V7Z"/>'
      }, props)
  }
  export function RiCommunicationChatHistoryLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.956 9.956 0 0 1-4.708-1.175L2 22l1.176-5.29A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2Zm0 2a8 8 0 0 0-8 8c0 1.335.326 2.618.94 3.766l.35.654-.656 2.946 2.948-.654.653.349A7.955 7.955 0 0 0 12 20a8 8 0 1 0 0-16Zm1 3v5h4v2h-6V7h2Z"/>'
      }, props)
  }
  export function RiCommunicationChatNewFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM11 10H8v2h3v3h2v-3h3v-2h-3V7h-2v3Z"/>'
      }, props)
  }
  export function RiCommunicationChatNewLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 3v2H4v13.385L5.763 17H20v-7h2v8a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1h11Zm5 0V0h2v3h3v2h-3v3h-2V5h-3V3h3Z"/>'
      }, props)
  }
  export function RiCommunicationChatOffFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2.808 1.394 19.799 19.798-1.415 1.415L17.585 19H6.455L2 22.5V4c0-.17.042-.329.116-.468l-.722-.724 1.414-1.414ZM21 3a1 1 0 0 1 1 1v13.785L7.214 3H21Z"/>'
      }, props)
  }
  export function RiCommunicationChatOffLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2.808 1.394 19.799 19.798-1.415 1.415L17.585 19H6.455L2 22.5V4c0-.17.042-.329.116-.468l-.722-.724 1.414-1.414ZM4 5.414v12.971L5.763 17h9.822L4 5.414ZM21 3a1 1 0 0 1 1 1v13.785l-2-2V5H9.213L7.214 3H21Z"/>'
      }, props)
  }
  export function RiCommunicationChatPollFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1h18Zm-8 4h-2v8h2V7Zm4 2h-2v6h2V9Zm-8 2H7v4h2v-4Z"/>'
      }, props)
  }
  export function RiCommunicationChatPollLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1h18Zm-1 2H4v13.385L5.763 17H20V5Zm-7 2v8h-2V7h2Zm4 2v6h-2V9h2Zm-8 2v4H7v-4h2Z"/>'
      }, props)
  }
  export function RiCommunicationChatPrivateFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.956 9.956 0 0 1-4.708-1.175L2 22l1.176-5.29A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2Zm0 5c-1.598 0-3 1.34-3 3v1H8v5h8v-5h-1v-1a3 3 0 0 0-3-3Zm2 6v1h-4v-1h4Zm-2-4c.476 0 1 .49 1 1v1h-2v-1c0-.51.487-1 1-1Z"/>'
      }, props)
  }
  export function RiCommunicationChatPrivateLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.956 9.956 0 0 1-4.708-1.175L2 22l1.176-5.29A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2Zm0 2a8 8 0 0 0-8 8c0 1.335.326 2.618.94 3.766l.35.654-.656 2.946 2.948-.654.653.349A7.955 7.955 0 0 0 12 20a8 8 0 1 0 0-16Zm0 3a3 3 0 0 1 3 3v1h1v5H8v-5h1v-1a3 3 0 0 1 3-3Zm2 6h-4v1h4v-1Zm-2-4c-.552 0-1 .45-1 1v1h2v-1a1 1 0 0 0-1-1Z"/>'
      }, props)
  }
  export function RiCommunicationChatQuoteFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1h18ZM10.515 7.412C8.728 8.187 7.5 9.755 7.5 11.505c0 .995.277 1.609.792 2.155.324.345.837.59 1.374.59a1.75 1.75 0 0 0 1.75-1.75 1.76 1.76 0 0 0-1.614-1.745 2.104 2.104 0 0 0-.479.01v-.092c.006-.44.1-1.74 1.639-2.573l-.447-.688Zm5 0c-1.787.775-3.015 2.343-3.015 4.093 0 .995.277 1.609.792 2.155.324.345.837.59 1.374.59a1.75 1.75 0 0 0 1.75-1.75 1.76 1.76 0 0 0-1.614-1.745 2.104 2.104 0 0 0-.479.01v-.092c.006-.44.1-1.74 1.639-2.573l-.447-.688Z"/>'
      }, props)
  }
  export function RiCommunicationChatQuoteLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455L2 22.5V4a1 1 0 0 1 1-1h18Zm-1 2H4v13.385L5.763 17H20V5Zm-9.485 2.412.447.688c-1.668.903-1.639 2.352-1.639 2.665.155-.022.318-.025.48-.01a1.76 1.76 0 0 1 1.613 1.745 1.75 1.75 0 0 1-1.75 1.75c-.537 0-1.05-.245-1.374-.59-.515-.546-.792-1.16-.792-2.155 0-1.75 1.228-3.318 3.015-4.093Zm5 0 .447.688c-1.668.903-1.639 2.352-1.639 2.665.155-.022.318-.025.48-.01a1.76 1.76 0 0 1 1.613 1.745 1.75 1.75 0 0 1-1.75 1.75c-.537 0-1.05-.245-1.374-.59-.515-.546-.792-1.16-.792-2.155 0-1.75 1.228-3.318 3.015-4.093Z"/>'
      }, props)
  }
  export function RiCommunicationChatSettingsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Zm1.69-6.929-.975.563 1 1.732.976-.563c.501.51 1.14.887 1.854 1.071V16h2v-1.126a3.996 3.996 0 0 0 1.854-1.072l.976.564 1-1.732-.975-.563a4.004 4.004 0 0 0 0-2.142l.975-.563-1-1.732-.976.563A3.996 3.996 0 0 0 13 7.126V6h-2v1.126a3.996 3.996 0 0 0-1.854 1.071l-.976-.563-1 1.732.975.563a4.004 4.004 0 0 0 0 2.142ZM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiCommunicationChatSettingsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12h-2V5H4v13.385L5.763 17H12v2H6.455L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v8Zm-7.855 7.071a4.004 4.004 0 0 1 0-2.142l-.975-.563 1-1.732.976.563A3.996 3.996 0 0 1 17 14.127V13h2v1.126c.715.184 1.352.56 1.854 1.072l.976-.564 1 1.732-.975.563a4.004 4.004 0 0 1 0 2.142l.975.563-1 1.732-.976-.564c-.502.511-1.14.888-1.854 1.072V23h-2v-1.126a3.996 3.996 0 0 1-1.854-1.072l-.976.564-1-1.732.975-.563ZM18 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiCommunicationChatSmile2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.291 20.824 2 22l1.176-5.291A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.956 9.956 0 0 1-4.709-1.176ZM7 12a5 5 0 0 0 10 0h-2a3 3 0 1 1-6 0H7Z"/>'
      }, props)
  }
  export function RiCommunicationChatSmile2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.291 20.824 2 22l1.176-5.291A9.956 9.956 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.956 9.956 0 0 1-4.709-1.176Zm.29-2.113.653.35A7.955 7.955 0 0 0 12 20a8 8 0 1 0-8-8c0 1.335.325 2.617.94 3.766l.349.653-.655 2.947 2.947-.655ZM7 12h2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0Z"/>'
      }, props)
  }
  export function RiCommunicationChatSmile3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10H2l2.929-2.929A9.969 9.969 0 0 1 2 12C2 6.477 6.477 2 12 2Zm4 11H8a4 4 0 0 0 8 0Z"/>'
      }, props)
  }
  export function RiCommunicationChatSmile3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10H2l2.929-2.929A9.969 9.969 0 0 1 2 12Zm4.828 8H12a8 8 0 1 0-8-8c0 2.152.851 4.165 2.343 5.657l1.414 1.414-.929.929ZM8 13h8a4 4 0 0 1-8 0Z"/>'
      }, props)
  }
  export function RiCommunicationChatSmileFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM7 10a5 5 0 0 0 10 0h-2a3 3 0 1 1-6 0H7Z"/>'
      }, props)
  }
  export function RiCommunicationChatSmileLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Zm-.692-2H20V5H4v13.385L5.763 17ZM7 10h2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0Z"/>'
      }, props)
  }
  export function RiCommunicationChatUploadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM13 11h3l-4-4-4 4h3v4h2v-4Z"/>'
      }, props)
  }
  export function RiCommunicationChatUploadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM4 18.385 5.763 17H20V5H4v13.385ZM13 11v4h-2v-4H8l4-4 4 4h-3Z"/>'
      }, props)
  }
  export function RiCommunicationChatVoiceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.929 19.071A9.969 9.969 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10H2l2.929-2.929ZM11 6v12h2V6h-2ZM7 9v6h2V9H7Zm8 0v6h2V9h-2Z"/>'
      }, props)
  }
  export function RiCommunicationChatVoiceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10H2l2.929-2.929A9.969 9.969 0 0 1 2 12Zm4.828 8H12a8 8 0 1 0-8-8c0 2.152.851 4.165 2.343 5.657l1.414 1.414-.929.929ZM11 6h2v12h-2V6ZM7 9h2v6H7V9Zm8 0h2v6h-2V9Z"/>'
      }, props)
  }
  export function RiCommunicationDiscussFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.8 19 14 22.5 11.2 19H6a1 1 0 0 1-1-1V7.103a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1h-5.2ZM2 2h17v2H3v11H1V3a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiCommunicationDiscussLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 22.5 11.2 19H6a1 1 0 0 1-1-1V7.103a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1h-5.2L14 22.5Zm1.839-5.5H21V8.103H7V17H12.161L14 19.298 15.839 17ZM2 2h17v2H3v11H1V3a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiCommunicationEmojiStickerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.902 10.598a9.986 9.986 0 0 0-9.381 3.873 4.977 4.977 0 0 1-3.854-1.246l-1.334 1.49a6.976 6.976 0 0 0 4.014 1.753A9.969 9.969 0 0 0 10.5 20.5c0 .476.033.944.098 1.402C5.738 21.221 2 17.047 2 12 2 6.477 6.477 2 12 2c5.047 0 9.22 3.739 9.902 8.598Zm-.031 2.019a7.99 7.99 0 0 0-7.964 3.35A7.958 7.958 0 0 0 12.5 20.5c0 .467.04.925.117 1.37l9.254-9.253ZM8.5 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm7 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiCommunicationEmojiStickerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.52 19.863a9.948 9.948 0 0 1 .826-3.395 6.977 6.977 0 0 1-4.013-1.753l1.334-1.49a4.977 4.977 0 0 0 3.854 1.246 9.987 9.987 0 0 1 7.342-3.951 8 8 0 1 0-9.343 9.343Zm8.503-7.227a8.008 8.008 0 0 0-6.387 6.387l6.387-6.387ZM22 12c0 .168-.004.334-.012.5L12.5 21.988A10.11 10.11 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10Zm-12-2a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm7 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"/>'
      }, props)
  }
  export function RiCommunicationFeedbackFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM11 13v2h2v-2h-2Zm0-6v5h2V7h-2Z"/>'
      }, props)
  }
  export function RiCommunicationFeedbackLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM4 18.385 5.763 17H20V5H4v13.385ZM11 13h2v2h-2v-2Zm0-6h2v5h-2V7Z"/>'
      }, props)
  }
  export function RiCommunicationMessage2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM7 10v2h2v-2H7Zm4 0v2h2v-2h-2Zm4 0v2h2v-2h-2Z"/>'
      }, props)
  }
  export function RiCommunicationMessage2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Zm-.692-2H20V5H4v13.385L5.763 17ZM11 10h2v2h-2v-2Zm-4 0h2v2H7v-2Zm8 0h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiCommunicationMessage3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 8.994A5.99 5.99 0 0 1 8 3h8c3.313 0 6 2.695 6 5.994V21H8c-3.313 0-6-2.695-6-5.994V8.994ZM14 11v2h2v-2h-2Zm-6 0v2h2v-2H8Z"/>'
      }, props)
  }
  export function RiCommunicationMessage3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 8.994A5.99 5.99 0 0 1 8 3h8c3.313 0 6 2.695 6 5.994V21H8c-3.313 0-6-2.695-6-5.994V8.994ZM20 19V8.994A4.004 4.004 0 0 0 16 5H8a3.99 3.99 0 0 0-4 3.994v6.012A4.004 4.004 0 0 0 8 19h12Zm-6-8h2v2h-2v-2Zm-6 0h2v2H8v-2Z"/>'
      }, props)
  }
  export function RiCommunicationMessageFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM8 10v2h8v-2H8Z"/>'
      }, props)
  }
  export function RiCommunicationMessageLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Zm-.692-2H20V5H4v13.385L5.763 17ZM8 10h8v2H8v-2Z"/>'
      }, props)
  }
  export function RiCommunicationQuestionAnswerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 18h10.237L20 19.385V9h1a1 1 0 0 1 1 1v13.5L17.546 20H9a1 1 0 0 1-1-1v-1Zm-2.545-2L1 19.5V4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v12H5.455Z"/>'
      }, props)
  }
  export function RiCommunicationQuestionAnswerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.455 15 1 18.5V3a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v12H5.455Zm-.692-2H16V4H3v10.385L4.763 13ZM8 17h10.237L20 18.385V8h1a1 1 0 0 1 1 1v13.5L17.546 19H9a1 1 0 0 1-1-1v-1Z"/>'
      }, props)
  }
  export function RiCommunicationQuestionnaireFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM11 14v2h2v-2h-2ZM8.567 8.813l1.962.393A1.5 1.5 0 1 1 12 11h-1v2h1a3.5 3.5 0 1 0-3.433-4.187Z"/>'
      }, props)
  }
  export function RiCommunicationQuestionnaireLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.763 17H20V5H4v13.385L5.763 17Zm.692 2L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM11 14h2v2h-2v-2ZM8.567 8.813A3.501 3.501 0 1 1 12 13h-1v-2h1a1.5 1.5 0 1 0-1.471-1.794l-1.962-.393Z"/>'
      }, props)
  }
  export function RiCommunicationSpeakFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 2a8.002 8.002 0 0 1 7.934 6.965l2.25 3.539c.148.233.118.58-.225.728L17 14.07V17a2 2 0 0 1-2 2h-1.999L13 22H4v-3.694c0-1.18-.436-2.297-1.244-3.305A8 8 0 0 1 9 2Zm12.154 16.102-1.665-1.11A8.959 8.959 0 0 0 21 12a8.958 8.958 0 0 0-1.51-4.993l1.664-1.11A10.948 10.948 0 0 1 23 12c0 2.258-.68 4.356-1.846 6.102Z"/>'
      }, props)
  }
  export function RiCommunicationSpeakLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.934 8.965A8.002 8.002 0 0 0 1 10c0 1.892.657 3.631 1.756 5.001C3.564 16.01 4 17.125 4 18.306V22h9l.001-3H15a2 2 0 0 0 2-2v-2.929l1.96-.84c.342-.146.372-.494.224-.727l-2.25-3.54ZM3 10a6 6 0 0 1 11.95-.779l.057.442 1.543 2.425-1.55.664V17h-3.998L11 20H6v-1.694c0-1.639-.591-3.192-1.685-4.556A5.966 5.966 0 0 1 3 10Zm18.154 8.102-1.665-1.11A8.959 8.959 0 0 0 21 12a8.958 8.958 0 0 0-1.51-4.993l1.664-1.11A10.948 10.948 0 0 1 23 12c0 2.258-.68 4.356-1.846 6.102Z"/>'
      }, props)
  }
  export function RiCommunicationVideoChatFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.455 19 2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM14 10.25V8H7v6h7v-2.25L17 14V8l-3 2.25Z"/>'
      }, props)
  }
  export function RiCommunicationVideoChatLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 10.25 17 8v6l-3-2.25V14H7V8h7v2.25ZM5.763 17H20V5H4v13.385L5.763 17Zm.692 2L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455Z"/>'
      }, props)
  }
  export function RiDesignAnticlockwise2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 4h2a5 5 0 0 1 5 5v4h-2V9a3 3 0 0 0-3-3h-2v3L9 5l5-4v3Zm1 7v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z"/>'
      }, props)
  }
  export function RiDesignAnticlockwise2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.414 6 1.829 1.828-1.415 1.415L9.586 5 13.828.757l1.415 1.415L13.414 4H16a5 5 0 0 1 5 5v4h-2V9a3 3 0 0 0-3-3h-2.586ZM15 11v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Zm-2 1H5v8h8v-8Z"/>'
      }, props)
  }
  export function RiDesignAnticlockwiseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 10h3l-4 5-4-5h3V8a5 5 0 0 1 5-5h4v2H9a3 3 0 0 0-3 3v2Zm5-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDesignAnticlockwiseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 9h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1Zm1 2v8h8v-8h-8Zm-6-.414L7.83 8.757l1.414 1.415L5 14.414.758 10.172l1.414-1.415L4 10.586V8a5 5 0 0 1 5-5h4v2H9a3 3 0 0 0-3 3v2.586Z"/>'
      }, props)
  }
  export function RiDesignArtboard2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 6h12v12H6V6Zm0-4h2v3H6V2Zm0 17h2v3H6v-3ZM2 6h3v2H2V6Zm0 10h3v2H2v-2ZM19 6h3v2h-3V6Zm0 10h3v2h-3v-2ZM16 2h2v3h-2V2Zm0 17h2v3h-2v-3Z"/>'
      }, props)
  }
  export function RiDesignArtboard2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 8v8h8V8H8ZM6 6h12v12H6V6Zm0-4h2v3H6V2Zm0 17h2v3H6v-3ZM2 6h3v2H2V6Zm0 10h3v2H2v-2ZM19 6h3v2h-3V6Zm0 10h3v2h-3v-2ZM16 2h2v3h-2V2Zm0 17h2v3h-2v-3Z"/>'
      }, props)
  }
  export function RiDesignArtboardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.586 17H3v-2h18v2h-5.586l3.243 3.243-1.414 1.414L13 17.414V20h-2v-2.586l-4.243 4.243-1.414-1.414L8.586 17ZM5 3h14a1 1 0 0 1 1 1v10H4V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDesignArtboardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.586 17H3v-2h18v2h-5.586l3.243 3.243-1.414 1.414L13 17.414V20h-2v-2.586l-4.243 4.243-1.414-1.414L8.586 17ZM5 3h14a1 1 0 0 1 1 1v10H4V4a1 1 0 0 1 1-1Zm1 2v7h12V5H6Z"/>'
      }, props)
  }
  export function RiDesignBallPenFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.85 11.805-.708-.707-9.9 9.9H3v-4.243L14.314 5.44l5.657 5.657a1 1 0 0 1 0 1.414l-7.072 7.071-1.414-1.414 6.364-6.364Zm.706-9.192 2.829 2.828a1 1 0 0 1 0 1.414L19.97 8.27l-4.243-4.243 1.414-1.414a1 1 0 0 1 1.414 0Z"/>'
      }, props)
  }
  export function RiDesignBallPenLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.85 11.698-.708-.707-9.9 9.9H3v-4.243L14.314 5.334l5.657 5.657a1 1 0 0 1 0 1.414l-7.072 7.071-1.414-1.414 6.364-6.364Zm-2.122-2.121-1.414-1.414L5 17.476v1.415h1.414l9.314-9.314Zm2.828-7.071 2.829 2.828a1 1 0 0 1 0 1.414L19.97 8.163 15.728 3.92l1.414-1.414a1 1 0 0 1 1.414 0Z"/>'
      }, props)
  }
  export function RiDesignBlurOffFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.432 6.843 1.394 2.805 2.808 1.39l19.799 19.8-1.415 1.414-3.038-3.04A9 9 0 0 1 5.432 6.845Zm2.811-2.817L12 .269l6.364 6.364a9.002 9.002 0 0 1 2.05 9.564L8.244 4.026Z"/>'
      }, props)
  }
  export function RiDesignBlurOffLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.154 19.565A9 9 0 0 1 5.432 6.843L1.394 2.805 2.808 1.39l19.799 19.8-1.415 1.414-3.038-3.04ZM6.848 8.259a7 7 0 0 0 9.89 9.89l-9.89-9.89Zm13.566 7.938-1.598-1.599a6.996 6.996 0 0 0-1.866-6.55L12 3.097 9.658 5.44 8.243 4.026 12 .269l6.364 6.364a9.002 9.002 0 0 1 2.05 9.564Z"/>'
      }, props)
  }
  export function RiDesignBrush2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.536 15.947 2.121-2.122-3.182-3.182 3.536-3.535-2.122-2.122-3.535 3.536-3.182-3.182L8.05 7.461l8.486 8.486ZM13.354 5.694l2.828-2.829a1 1 0 0 1 1.414 0l3.536 3.536a1 1 0 0 1 0 1.414l-2.829 2.828 2.475 2.475a1 1 0 0 1 0 1.414L13 22.311a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414l7.779-7.778a1 1 0 0 1 1.414 0l2.475 2.475Z"/>'
      }, props)
  }
  export function RiDesignBrush2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.536 15.947 2.121-2.122-3.182-3.182 3.536-3.535-2.122-2.122-3.535 3.536-3.182-3.182L8.05 7.461l8.486 8.486ZM15.12 17.36 6.636 8.876l-2.828 2.828 8.485 8.485 2.829-2.828ZM13.354 5.694l2.828-2.829a1 1 0 0 1 1.414 0l3.536 3.536a1 1 0 0 1 0 1.414l-2.829 2.828 2.475 2.475a1 1 0 0 1 0 1.414L13 22.311a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414l7.779-7.778a1 1 0 0 1 1.414 0l2.475 2.475Z"/>'
      }, props)
  }
  export function RiDesignBrush3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 10.997v-3h-6v-4h-4v4H4v3h16Zm1 2v8a1 1 0 0 1-1 1H10v-6H8v6H4a1 1 0 0 1-1-1v-8H2v-6a1 1 0 0 1 1-1h5v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3h5a1 1 0 0 1 1 1v6h-1Z"/>'
      }, props)
  }
  export function RiDesignBrush3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 19.997v-5h2v5h9v-7H5v7h3Zm-4-9h16v-3h-6v-4h-4v4H4v3Zm-1 10v-8H2v-6a1 1 0 0 1 1-1h5v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3h5a1 1 0 0 1 1 1v6h-1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z"/>'
      }, props)
  }
  export function RiDesignBrush4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 15.997H4v2h16v-2Zm-17-2v-10a1 1 0 0 1 1-1h3v8.272h2V2.997h11a1 1 0 0 1 1 1v10h1v5a1 1 0 0 1-1 1h-8v3h-2v-3H3a1 1 0 0 1-1-1v-5h1Z"/>'
      }, props)
  }
  export function RiDesignBrush4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 4.997v6.272H7V4.997H5v9h14v-9H9Zm11 11H4v2h16v-2Zm-17-2v-10a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10h1v5a1 1 0 0 1-1 1h-8v3h-2v-3H3a1 1 0 0 1-1-1v-5h1Z"/>'
      }, props)
  }
  export function RiDesignBrushFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.289 6.213 4.939-3.842a1 1 0 0 1 1.32.083l2.995 2.994a1 1 0 0 1 .082 1.32l-3.84 4.939a7.505 7.505 0 0 1-7.283 9.292C8 20.998 3.5 19.496 1 17.996c3.98-3 3.047-4.81 3.5-6.5 1.058-3.95 4.842-6.258 8.789-5.284ZM16.7 8.09c.066.064.13.129.194.194L18.03 9.42l2.475-3.182-1.746-1.746-3.182 2.475L16.7 8.09Z"/>'
      }, props)
  }
  export function RiDesignBrushLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.457 9.675-.143-.142a5.475 5.475 0 0 0-2.39-1.349c-2.907-.779-5.699.869-6.492 3.83-.043.16-.066.34-.104.791-.154 1.87-.594 3.265-1.8 4.68 2.26.888 4.938 1.513 6.974 1.513a5.505 5.505 0 0 0 5.31-4.078 5.497 5.497 0 0 0-1.356-5.245Zm-2.168-3.462 4.939-3.842a1 1 0 0 1 1.32.083l2.995 2.994a1 1 0 0 1 .082 1.32l-3.84 4.939a7.505 7.505 0 0 1-7.283 9.292C8 20.998 3.5 19.496 1 17.996c3.98-3 3.047-4.81 3.5-6.5 1.058-3.95 4.842-6.258 8.789-5.284ZM16.7 8.09c.066.064.13.129.194.194L18.03 9.42l2.475-3.182-1.746-1.746-3.182 2.475L16.7 8.09Z"/>'
      }, props)
  }
  export function RiDesignClockwise2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 4V1l5 4-5 4V6H8a3 3 0 0 0-3 3v4H3V9a5 5 0 0 1 5-5h2Zm-1 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V11Z"/>'
      }, props)
  }
  export function RiDesignClockwise2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.586 4 8.757 2.172 10.172.757 14.414 5l-4.242 4.243-1.415-1.415L10.586 6H8a3 3 0 0 0-3 3v4H3V9a5 5 0 0 1 5-5h2.586ZM9 11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V11Zm2 1v8h8v-8h-8Z"/>'
      }, props)
  }
  export function RiDesignClockwiseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 10h3l-4 5-4-5h3V8a3 3 0 0 0-3-3h-4V3h4a5 5 0 0 1 5 5v2Zm-7-1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h10Z"/>'
      }, props)
  }
  export function RiDesignClockwiseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20 10.586 1.828-1.829 1.415 1.415L19 14.414l-4.243-4.242 1.415-1.415L18 10.586V8a3 3 0 0 0-3-3h-4V3h4a5 5 0 0 1 5 5v2.586ZM13 9a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h10Zm-1 2H4v8h8v-8Z"/>'
      }, props)
  }
  export function RiDesignCollageFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.19 13.264 1.382 7.841-8.571.001a1 1 0 0 1-1-1L3 14.708l8.19-1.444ZM20 3.106a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-5.397l-3.174-18h8.572Zm-10.602 0 1.444 8.188L3 12.677v-8.57a1 1 0 0 1 1-1l5.398-.002Z"/>'
      }, props)
  }
  export function RiDesignCollageLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 3.106a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1h16Zm-8.811 10.159L5 14.355v4.751h7.218l-1.03-5.841ZM19 5.106h-7.219l2.468 14H19v-14Zm-9.25 0H5v7.218l5.841-1.029L9.75 5.106Z"/>'
      }, props)
  }
  export function RiDesignCompasses2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.33 13.497a6.987 6.987 0 0 0 2.67-5.5h2a8.987 8.987 0 0 1-3.662 7.246l2.528 4.378a2 2 0 0 1-.732 2.732l-3.527-6.109a8.97 8.97 0 0 1-3.607.753 8.969 8.969 0 0 1-3.608-.753l-3.526 6.109a2 2 0 0 1-.732-2.732l5.063-8.77a4.002 4.002 0 0 1 1.802-6.728V1.997h2v2.126a4.002 4.002 0 0 1 1.803 6.728l1.528 2.646Zm-1.731 1.001-1.529-2.646a4.003 4.003 0 0 1-2.141 0L9.4 14.498c.803.322 1.68.499 2.598.499.919 0 1.796-.177 2.6-.499Zm-2.6-5.501a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiDesignCompasses2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.33 13.497a6.987 6.987 0 0 0 2.67-5.5h2a8.987 8.987 0 0 1-3.662 7.246l2.528 4.378a2 2 0 0 1-.732 2.732l-3.527-6.109a8.97 8.97 0 0 1-3.607.753 8.969 8.969 0 0 1-3.608-.753l-3.526 6.109a2 2 0 0 1-.732-2.732l5.063-8.77a4.002 4.002 0 0 1 1.802-6.728V1.997h2v2.126a4.002 4.002 0 0 1 1.803 6.728l1.528 2.646Zm-1.731 1.001-1.529-2.646a4.003 4.003 0 0 1-2.141 0L9.4 14.498c.803.322 1.68.499 2.598.499.919 0 1.796-.177 2.6-.499Zm-2.6-4.501a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiDesignCompassesFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 4.123V1.997h2v2.126a4.002 4.002 0 0 1 1.802 6.728l6.064 10.502-1.732 1-6.063-10.501a4.004 4.004 0 0 1-2.142 0L4.866 22.353l-1.732-1 6.063-10.502A4.002 4.002 0 0 1 11 4.123Zm1 4.874a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiDesignCompassesLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 4.123V1.997h2v2.126a4.002 4.002 0 0 1 1.802 6.728l6.064 10.502-1.732 1-6.063-10.501a4.004 4.004 0 0 1-2.142 0L4.866 22.353l-1.732-1 6.063-10.502A4.002 4.002 0 0 1 11 4.123Zm1 5.874a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiDesignContrast2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 21.997c-5.523 0-10-4.478-10-10 0-5.523 4.477-10 10-10s10 4.477 10 10c0 5.522-4.477 10-10 10Zm-6.671-5.575A8 8 0 1 0 16.425 5.325a8.997 8.997 0 0 1-2.304 8.793 8.997 8.997 0 0 1-8.792 2.304Z"/>'
      }, props)
  }
  export function RiDesignContrast2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 21.997c-5.523 0-10-4.478-10-10 0-5.523 4.477-10 10-10s10 4.477 10 10c0 5.522-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-5-4.681a8.965 8.965 0 0 0 5.707-2.612 8.965 8.965 0 0 0 2.612-5.707A6 6 0 1 1 7 15.316Z"/>'
      }, props)
  }
  export function RiDesignContrastDrop2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.636 6.633 12 .269l6.364 6.364a9 9 0 1 1-12.728 0ZM12 3.097l-4.95 4.95A6.978 6.978 0 0 0 5 12.997h14a6.978 6.978 0 0 0-2.05-4.95L12 3.097Z"/>'
      }, props)
  }
  export function RiDesignContrastDrop2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 3.097-4.95 4.95a7 7 0 1 0 9.9 0L12 3.097ZM12 .27l6.364 6.364a9 9 0 1 1-12.728 0L12 .269ZM7 12.997h10a5 5 0 0 1-10 0Z"/>'
      }, props)
  }
  export function RiDesignContrastDropFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 .269 6.364 6.364a9 9 0 1 1-12.728 0L12 .269Zm0 2.828-4.95 4.95a7 7 0 0 0 4.954 11.95L12 3.097Z"/>'
      }, props)
  }
  export function RiDesignContrastDropLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 3.097-4.95 4.95a7 7 0 1 0 9.9 0L12 3.097ZM12 .27l6.364 6.364a9 9 0 1 1-12.728 0L12 .269Zm0 17.728v-10a5 5 0 0 1 0 10Z"/>'
      }, props)
  }
  export function RiDesignContrastFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 21.997c-5.523 0-10-4.478-10-10 0-5.523 4.477-10 10-10s10 4.477 10 10c0 5.522-4.477 10-10 10Zm0-2v-16a8 8 0 0 0 0 16Z"/>'
      }, props)
  }
  export function RiDesignContrastLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 21.997c-5.523 0-10-4.478-10-10 0-5.523 4.477-10 10-10s10 4.477 10 10c0 5.522-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-2v-12a6 6 0 0 1 0 12Z"/>'
      }, props)
  }
  export function RiDesignCrop2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.586 5 2.556-2.556 1.414 1.414L19 6.414V17h3v2h-3v3h-2V7H9V5h8.586ZM15 17v2H6a1 1 0 0 1-1-1V7H2V5h3V2h2v15h8ZM9 9h6v6H9V9Z"/>'
      }, props)
  }
  export function RiDesignCrop2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.414 17H15v2H6a1 1 0 0 1-1-1V7H2V5h3V2h2v13.586L15.586 7H9V5h8.586l2.556-2.556 1.414 1.414L19 6.414V17h3v2h-3v3h-2V8.414L8.414 17Z"/>'
      }, props)
  }
  export function RiDesignCropFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 17h3v2h-3v3h-2v-3H6a1 1 0 0 1-1-1V7H2V5h3V2h2v3h11a1 1 0 0 1 1 1v11Z"/>'
      }, props)
  }
  export function RiDesignCropLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 17v2H6a1 1 0 0 1-1-1V7H2V5h3V2h2v15h8Zm2 5V7H9V5h9a1 1 0 0 1 1 1v11h3v2h-3v3h-2Z"/>'
      }, props)
  }
  export function RiDesignDragDropFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 6h2v2h5a1 1 0 0 1 1 1v7.5L16 13l.036 8.062 2.223-2.15L20.041 22H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6Zm8 11.338V21a1 1 0 0 1-.048.307l-1.96-3.394L22 17.338ZM4 14v2H2v-2h2Zm0-4v2H2v-2h2Zm0-4v2H2V6h2Zm0-4v2H2V2h2Zm4 0v2H6V2h2Zm4 0v2h-2V2h2Zm4 0v2h-2V2h2Z"/>'
      }, props)
  }
  export function RiDesignDragDropLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 13 6.964 4.062-2.973.85 2.125 3.681-1.732 1-2.125-3.68-2.223 2.15L16 13Zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6ZM4 14v2H2v-2h2Zm0-4v2H2v-2h2Zm0-4v2H2V6h2Zm0-4v2H2V2h2Zm4 0v2H6V2h2Zm4 0v2h-2V2h2Zm4 0v2h-2V2h2Z"/>'
      }, props)
  }
  export function RiDesignDropFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.636 6.633 12 .269l6.364 6.364a9 9 0 1 1-12.728 0Z"/>'
      }, props)
  }
  export function RiDesignDropLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 3.097-4.95 4.95a7 7 0 1 0 9.9 0L12 3.097Zm0-2.828 6.364 6.364a9 9 0 1 1-12.728 0L12 .269Z"/>'
      }, props)
  }
  export function RiDesignEdit2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.243 18.996H21v2H3v-4.242l9.9-9.9 4.242 4.243-7.9 7.9Zm5.07-13.556 2.122-2.121a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 0 1 0 1.414l-2.122 2.122-4.242-4.243Z"/>'
      }, props)
  }
  export function RiDesignEdit2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 18.89h1.414l9.314-9.314-1.414-1.414L5 17.476v1.414Zm16 2H3v-4.243L16.435 3.212a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L9.243 18.89H21v2ZM15.728 6.748l1.414 1.414 1.414-1.414-1.414-1.414-1.414 1.414Z"/>'
      }, props)
  }
  export function RiDesignEditBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.757 2.997-7.466 7.466.008 4.247 4.238-.008L21 7.24v12.758a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1h12.757Zm3.728-.9L21.9 3.511l-9.193 9.193-1.412.002-.002-1.416 9.192-9.193Z"/>'
      }, props)
  }
  export function RiDesignEditBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.757 2.997-2 2H5v14h14V9.239l2-2v12.758a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1h12.757Zm3.728-.9L21.9 3.511l-9.193 9.193-1.412.002-.002-1.416 9.192-9.193Z"/>'
      }, props)
  }
  export function RiDesignEditCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.626 3.128 9.29 10.463 9.3 14.71l4.238-.008 7.331-7.331A9.956 9.956 0 0 1 22 11.997c0 5.522-4.477 10-10 10s-10-4.478-10-10c0-5.523 4.477-10 10-10 1.669 0 3.242.408 4.626 1.131Zm3.86-1.03 1.413 1.413-9.192 9.193-1.412.002-.002-1.416 9.192-9.193Z"/>'
      }, props)
  }
  export function RiDesignEditCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.684 4.025a8 8 0 1 0 7.287 7.287 7.935 7.935 0 0 0-.603-2.439l1.5-1.502A9.935 9.935 0 0 1 22 11.997c0 5.522-4.477 10-10 10s-10-4.478-10-10c0-5.523 4.477-10 10-10a9.981 9.981 0 0 1 4.626 1.132l-1.501 1.5a7.941 7.941 0 0 0-2.44-.604Zm7.801-1.928L21.9 3.511l-9.193 9.193-1.412.002-.002-1.416 9.192-9.193Z"/>'
      }, props)
  }
  export function RiDesignEditFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.243 17.996H3v-4.242L14.435 2.319a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 0 1 0 1.414L7.243 17.996Zm-4.243 2h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiDesignEditLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.414 15.89 16.556 5.748l-1.414-1.414L5 14.476v1.414h1.414Zm.829 2H3v-4.243L14.435 2.212a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L7.243 17.89ZM3 19.89h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiDesignEraserFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 18.997h7v2h-9l-3.998.002-6.487-6.487a1 1 0 0 1 0-1.415L12.12 2.491a1 1 0 0 1 1.414 0l7.779 7.778a1 1 0 0 1 0 1.414L14 18.997Zm1.657-4.486 3.535-3.535-6.364-6.364-3.535 3.536 6.364 6.364Z"/>'
      }, props)
  }
  export function RiDesignEraserLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m8.586 8.855-4.95 4.95 5.194 5.194 1.17-.001v-.001h1.171l3.779-3.778-6.364-6.364ZM10 7.44l6.364 6.364 2.828-2.828-6.364-6.364L10 7.44Zm4 11.557h7v2h-9l-3.998.002-6.487-6.487a1 1 0 0 1 0-1.415L12.12 2.491a1 1 0 0 1 1.414 0l7.779 7.778a1 1 0 0 1 0 1.414L14 18.997Z"/>'
      }, props)
  }
  export function RiDesignFocus2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 18c4.427 0 8-3.573 8-8s-3.573-8-8-8a7.99 7.99 0 0 0-8 8c0 4.427 3.573 8 8 8Zm0-2c-3.32 0-6-2.68-6-6s2.68-6 6-6 6 2.68 6 6-2.68 6-6 6Zm0-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"/>'
      }, props)
  }
  export function RiDesignFocus2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-6a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 2a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-4a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiDesignFocus3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13 1 .001 3.062A8.004 8.004 0 0 1 19.938 11H23v2l-3.062.001a8.004 8.004 0 0 1-6.937 6.937L13 23h-2v-3.062a8.004 8.004 0 0 1-6.938-6.937L1 13v-2h3.062A8.004 8.004 0 0 1 11 4.062V1h2Zm-1 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>'
      }, props)
  }
  export function RiDesignFocus3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13 1 .001 3.062A8.004 8.004 0 0 1 19.938 11H23v2l-3.062.001a8.004 8.004 0 0 1-6.937 6.937L13 23h-2v-3.062a8.004 8.004 0 0 1-6.938-6.937L1 13v-2h3.062A8.004 8.004 0 0 1 11 4.062V1h2Zm-1 5a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm0 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"/>'
      }, props)
  }
  export function RiDesignFocusFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"/>'
      }, props)
  }
  export function RiDesignFocusLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-8a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiDesignGridFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 10v4h-4v-4h4Zm2 0h5v4h-5v-4Zm-2 11h-4v-5h4v5Zm2 0v-5h5v4a1 1 0 0 1-1 1h-4ZM14 3v5h-4V3h4Zm2 0h4a1 1 0 0 1 1 1v4h-5V3Zm-8 7v4H3v-4h5Zm0 11H4a1 1 0 0 1-1-1v-4h5v5ZM8 3v5H3V4a1 1 0 0 1 1-1h4Z"/>'
      }, props)
  }
  export function RiDesignGridLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 10h-4v4h4v-4Zm2 0v4h3v-4h-3Zm-2 9v-3h-4v3h4Zm2 0h3v-3h-3v3ZM14 5h-4v3h4V5Zm2 0v3h3V5h-3Zm-8 5H5v4h3v-4Zm0 9v-3H5v3h3ZM8 5H5v3h3V5ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDesignHammerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 8V2h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-3Zm-2 14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V8H2.5V6.074a1 1 0 0 1 .496-.863L8.5 2H15v20Z"/>'
      }, props)
  }
  export function RiDesignHammerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5v13a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V9H3.5a1 1 0 0 1-1-1V5.618a1 1 0 0 1 .553-.894L8.5 2H20Zm-5 2H8.972L4.5 6.236V7H11v14h2V7h2V4Zm4 0h-2v3h2V4Z"/>'
      }, props)
  }
  export function RiDesignInkBottleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 8.997 4.371 1.748a1 1 0 0 1 .629.929v9.323a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9.323a1 1 0 0 1 .629-.929L8 8.997h8Zm4 5H8v5h12v-5Zm-4-11a1 1 0 0 1 1 1v4H7v-4a1 1 0 0 1 1-1h8Z"/>'
      }, props)
  }
  export function RiDesignInkBottleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 8.997 4.371 1.748a1 1 0 0 1 .629.929v9.323a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9.323a1 1 0 0 1 .629-.929L8 8.997h8Zm-.385 2h-7.23L5 12.35v7.646h14v-1H8v-5h11V12.35l-3.385-1.354Zm.385-8a1 1 0 0 1 1 1v4H7v-4a1 1 0 0 1 1-1h8Zm-1 2H9v1h6v-1Z"/>'
      }, props)
  }
  export function RiDesignInputMethodFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm5.869 12h4.262l.82 2h2.216L13 7h-2L6.833 17H9.05l.82-2Zm.82-2L12 9.8l1.312 3.2h-2.623Z"/>'
      }, props)
  }
  export function RiDesignInputMethodLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 5v14h14V5H5ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm5.869 12-.82 2H6.833L11 7h2l4.167 10H14.95l-.82-2H9.87Zm.82-2h2.623L12 9.8 10.688 13Z"/>'
      }, props)
  }
  export function RiDesignLayout2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 3v18H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7Zm10 10v7a1 1 0 0 1-1 1h-7v-8h8ZM20 3a1 1 0 0 1 1 1v7h-8V3h7Z"/>'
      }, props)
  }
  export function RiDesignLayout2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16ZM11 5H5v14h6V5Zm8 8h-6v6h6v-6Zm0-8h-6v6h6V5Z"/>'
      }, props)
  }
  export function RiDesignLayout3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 10v11H4a1 1 0 0 1-1-1V10h5Zm13 0v10a1 1 0 0 1-1 1H10V10h11Zm-1-7a1 1 0 0 1 1 1v4H3V4a1 1 0 0 1 1-1h16Z"/>'
      }, props)
  }
  export function RiDesignLayout3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4Zm4-11H5v9h3v-9Zm11 0h-9v9h9v-9Zm0-5H5v3h14V5Z"/>'
      }, props)
  }
  export function RiDesignLayout4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 13v8H4a1 1 0 0 1-1-1v-7h8Zm2-10h7a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-7V3ZM3 4a1 1 0 0 1 1-1h7v8H3V4Z"/>'
      }, props)
  }
  export function RiDesignLayout4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16Zm-9 10H5v6h6v-6Zm2 6h6V5h-6v14ZM11 5H5v6h6V5Z"/>'
      }, props)
  }
  export function RiDesignLayout5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 10v11H3a1 1 0 0 1-1-1V10h5Zm15 0v10a1 1 0 0 1-1 1H9V10h13Zm-1-7a1 1 0 0 1 1 1v4H2V4a1 1 0 0 1 1-1h18Z"/>'
      }, props)
  }
  export function RiDesignLayout5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3Zm4-11H4v9h3v-9Zm13 0H9v9h11v-9Zm0-5H4v3h16V5Z"/>'
      }, props)
  }
  export function RiDesignLayout6Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 10v11H3a1 1 0 0 1-1-1V10h13Zm7 0v10a1 1 0 0 1-1 1h-4V10h5Zm-1-7a1 1 0 0 1 1 1v4H2V4a1 1 0 0 1 1-1h18Z"/>'
      }, props)
  }
  export function RiDesignLayout6Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3Zm12-11H4v9h11v-9Zm5 0h-3v9h3v-9Zm0-5H4v3h16V5Z"/>'
      }, props)
  }
  export function RiDesignLayoutBottom2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-2 13H5v2h14v-2Z"/>'
      }, props)
  }
  export function RiDesignLayoutBottom2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-1 2H4v14h16V5Zm-2 10v2H6v-2h12Z"/>'
      }, props)
  }
  export function RiDesignLayoutBottomFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 16v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-4h20ZM21 3a1 1 0 0 1 1 1v10H2V4a1 1 0 0 1 1-1h18Z"/>'
      }, props)
  }
  export function RiDesignLayoutBottomLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18ZM4 16v3h16v-3H4Zm0-2h16V5H4v9Z"/>'
      }, props)
  }
  export function RiDesignLayoutColumnFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 5v14h7V5h-7ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDesignLayoutColumnLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 5H5v14h6V5Zm2 0v14h6V5h-6ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDesignLayoutFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 21V10h5v10a1 1 0 0 1-1 1h-4Zm-2 0H4a1 1 0 0 1-1-1V10h11v11Zm7-13H3V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4Z"/>'
      }, props)
  }
  export function RiDesignLayoutGridFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12.999V20a1 1 0 0 1-1 1h-8v-8.001h9Zm-11 0V21H3a1 1 0 0 1-1-1v-7.001h9ZM11 3v7.999H2V4a1 1 0 0 1 1-1h8Zm10 0a1 1 0 0 1 1 1v6.999h-9V3h8Z"/>'
      }, props)
  }
  export function RiDesignLayoutGridLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18ZM11 13H4v6h7v-6Zm9 0h-7v6h7v-6Zm-9-8H4v6h7V5Zm9 0h-7v6h7V5Z"/>'
      }, props)
  }
  export function RiDesignLayoutLeft2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18ZM7 6H5v12h2V6Z"/>'
      }, props)
  }
  export function RiDesignLayoutLeft2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-1 2H4v14h16V5ZM8 7v10H6V7h2Z"/>'
      }, props)
  }
  export function RiDesignLayoutLeftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H9V3h12ZM7 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4v18Z"/>'
      }, props)
  }
  export function RiDesignLayoutLeftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18ZM7 5H4v14h3V5Zm13 0H9v14h11V5Z"/>'
      }, props)
  }
  export function RiDesignLayoutLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 8h14V5H5v3Zm9 11v-9H5v9h9Zm2 0h3v-9h-3v9ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDesignLayoutMasonryFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 9.999V20a1 1 0 0 1-1 1h-8V9.999h9Zm-11 6V21H3a1 1 0 0 1-1-1v-4.001h9ZM11 3v10.999H2V4a1 1 0 0 1 1-1h8Zm10 0a1 1 0 0 1 1 1v3.999h-9V3h8Z"/>'
      }, props)
  }
  export function RiDesignLayoutMasonryLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16Zm-11-5H4v4h7v-4Zm9-4h-7v8h7v-8Zm-9-6H4v8h7V5Zm9 0h-7v4h7V5Z"/>'
      }, props)
  }
  export function RiDesignLayoutRight2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-2 3h-2v12h2V6Z"/>'
      }, props)
  }
  export function RiDesignLayoutRight2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-1 2H4v14h16V5Zm-2 2v10h-2V7h2Z"/>'
      }, props)
  }
  export function RiDesignLayoutRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4V3h4Zm-6 18H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12v18Z"/>'
      }, props)
  }
  export function RiDesignLayoutRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-6 2H4v14h11V5Zm5 0h-3v14h3V5Z"/>'
      }, props)
  }
  export function RiDesignLayoutRowFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 12H5v7h14v-7ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDesignLayoutRowLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 11V5H5v6h14Zm0 2H5v6h14v-6ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDesignLayoutTop2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-2 3H5v2h14V6Z"/>'
      }, props)
  }
  export function RiDesignLayoutTop2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-1 2H4v14h16V5Zm-2 2v2H6V7h12Z"/>'
      }, props)
  }
  export function RiDesignLayoutTopFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 10v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V10h20Zm-1-7a1 1 0 0 1 1 1v4H2V4a1 1 0 0 1 1-1h18Z"/>'
      }, props)
  }
  export function RiDesignLayoutTopLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18ZM4 10v9h16v-9H4Zm0-2h16V5H4v3Z"/>'
      }, props)
  }
  export function RiDesignMagicFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.224 15.508-2.213 4.65a.6.6 0 0 1-.977.155l-3.542-3.739a.6.6 0 0 0-.358-.182l-5.106-.668a.6.6 0 0 1-.45-.882L5.04 10.32a.6.6 0 0 0 .063-.397L4.16 4.86a.6.6 0 0 1 .7-.7l5.062.943a.6.6 0 0 0 .397-.063l4.523-2.461a.6.6 0 0 1 .882.45l.668 5.105a.6.6 0 0 0 .182.358l3.739 3.542a.6.6 0 0 1-.155.977l-4.65 2.213a.6.6 0 0 0-.284.284Zm.797 1.927 1.414-1.414 4.242 4.242-1.414 1.414-4.242-4.242Z"/>'
      }, props)
  }
  export function RiDesignMagicLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.199 9.944a2.6 2.6 0 0 1-.79-1.55l-.403-3.083-2.731 1.486a2.6 2.6 0 0 1-1.719.272L6.5 6.5l.57 3.056a2.6 2.6 0 0 1-.273 1.719l-1.486 2.73 3.083.403a2.6 2.6 0 0 1 1.55.79l2.138 2.258 1.336-2.807a2.6 2.6 0 0 1 1.23-1.231l2.808-1.336-2.257-2.138Zm.025 5.564-2.213 4.65a.6.6 0 0 1-.977.155l-3.542-3.739a.6.6 0 0 0-.358-.182l-5.106-.668a.6.6 0 0 1-.45-.882L5.04 10.32a.6.6 0 0 0 .063-.397L4.16 4.86a.6.6 0 0 1 .7-.7l5.062.943a.6.6 0 0 0 .397-.063l4.523-2.461a.6.6 0 0 1 .882.45l.668 5.105a.6.6 0 0 0 .182.358l3.739 3.542a.6.6 0 0 1-.155.977l-4.65 2.213a.6.6 0 0 0-.284.284Zm.797 1.927 1.414-1.414 4.242 4.242-1.414 1.414-4.242-4.242Z"/>'
      }, props)
  }
  export function RiDesignMarkPenFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.95 2.39 5.657 5.657a1 1 0 0 1 0 1.414l-7.778 7.778-2.122.707-1.414 1.415a1 1 0 0 1-1.414 0l-4.243-4.243a1 1 0 0 1 0-1.414L6.05 12.29l.707-2.122 7.779-7.778a1 1 0 0 1 1.414 0Zm.707 3.536-6.364 6.364 1.414 1.414 6.364-6.364-1.414-1.414ZM4.283 16.886l2.828 2.828-1.414 1.414-4.243-1.414 2.829-2.828Z"/>'
      }, props)
  }
  export function RiDesignMarkPenLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.243 4.511 8.505 11.25l-.707 2.12-1.04 1.042 2.828 2.828 1.04-1.04 2.122-.708 6.737-6.737-4.242-4.243Zm6.364 3.536a1 1 0 0 1 0 1.414l-7.778 7.778-2.122.707-1.414 1.415a1 1 0 0 1-1.414 0l-4.243-4.243a1 1 0 0 1 0-1.414L6.05 12.29l.707-2.122 7.779-7.778a1 1 0 0 1 1.414 0l5.657 5.657Zm-6.364-.707 1.414 1.414-4.95 4.95-1.414-1.414 4.95-4.95Zm-10.96 9.546 2.828 2.828-1.414 1.414-4.243-1.414 2.829-2.828Z"/>'
      }, props)
  }
  export function RiDesignMarkupFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 21.997c-5.523 0-10-4.478-10-10 0-5.523 4.477-10 10-10s10 4.477 10 10c0 5.522-4.477 10-10 10Zm5.051-3.796-.862-3.447a1 1 0 0 0-.97-.757H8.781a1 1 0 0 0-.97.757l-.862 3.447A7.967 7.967 0 0 0 12 19.997a7.967 7.967 0 0 0 5.051-1.796ZM10 11.997h4v-1.5l-1.039-3.635a1 1 0 0 0-1.922 0L10 10.497v1.5Z"/>'
      }, props)
  }
  export function RiDesignMarkupLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10 10.497 1.039-3.635a1 1 0 0 1 1.922 0L14 10.497v1.5h.72a1 1 0 0 1 .97.757l1.361 5.447a8 8 0 1 0-10.102 0l1.362-5.447a1 1 0 0 1 .97-.757H10v-1.5Zm2 9.5a7.951 7.951 0 0 0 3.265-.694l-1.327-5.306h-3.876l-1.327 5.305a7.948 7.948 0 0 0 3.265.695Zm0 2c-5.523 0-10-4.478-10-10 0-5.523 4.477-10 10-10s10 4.477 10 10c0 5.522-4.477 10-10 10Z"/>'
      }, props)
  }
  export function RiDesignPaintBrushFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 2.997h16a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1Zm2 9h6a1 1 0 0 1 1 1v3h1v6h-4v-6h1v-2H5a1 1 0 0 1-1-1v-2h2v1Zm11.732 1.732L19.5 11.96l1.768 1.768a2.5 2.5 0 1 1-3.536 0Z"/>'
      }, props)
  }
  export function RiDesignPaintBrushLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 4.997v3h14v-3H5Zm-1-2h16a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1Zm2 9h6a1 1 0 0 1 1 1v3h1v6h-4v-6h1v-2H5a1 1 0 0 1-1-1v-2h2v1Zm11.732 1.732L19.5 11.96l1.768 1.768a2.5 2.5 0 1 1-3.536 0Z"/>'
      }, props)
  }
  export function RiDesignPaintFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19.228 18.732 1.767-1.768 1.768 1.768a2.5 2.5 0 1 1-3.535 0ZM8.878 1.08l11.314 11.313a1 1 0 0 1 0 1.414l-8.485 8.486a1 1 0 0 1-1.414 0l-8.485-8.486a1 1 0 0 1 0-1.414l7.778-7.778-2.122-2.121L8.88 1.08ZM11 6.03 3.929 13.1H18.07L11 6.03Z"/>'
      }, props)
  }
  export function RiDesignPaintLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19.228 18.732 1.767-1.768 1.768 1.768a2.5 2.5 0 1 1-3.535 0ZM8.878 1.08l11.314 11.313a1 1 0 0 1 0 1.414l-8.485 8.486a1 1 0 0 1-1.414 0l-8.485-8.486a1 1 0 0 1 0-1.414l7.778-7.778-2.122-2.121L8.88 1.08ZM11 6.03 3.929 13.1l7.07 7.072 7.072-7.072L11 6.03Z"/>'
      }, props)
  }
  export function RiDesignPaletteFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.522 0 10 3.978 10 8.889a5.558 5.558 0 0 1-5.556 5.555h-1.966c-.922 0-1.667.745-1.667 1.667 0 .422.167.811.422 1.1.267.3.434.689.434 1.122C13.667 21.256 12.9 22 12 22 6.478 22 2 17.522 2 12S6.478 2 12 2ZM7.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM12 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiDesignPaletteLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.522 0 10 3.978 10 8.889a5.558 5.558 0 0 1-5.556 5.555h-1.966c-.922 0-1.667.745-1.667 1.667 0 .422.167.811.422 1.1.267.3.434.689.434 1.122C13.667 21.256 12.9 22 12 22 6.478 22 2 17.522 2 12S6.478 2 12 2Zm-1.189 16.111a3.664 3.664 0 0 1 3.667-3.667h1.966A3.558 3.558 0 0 0 20 10.89C20 7.139 16.468 4 12 4a8 8 0 0 0-.676 15.972 3.648 3.648 0 0 1-.513-1.86ZM7.5 12a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM12 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiDesignPantoneFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4 18.922-1.349-.545a1 1 0 0 1-.553-1.302l1.903-4.708v6.555ZM8.86 21H7a1 1 0 0 1-1-1v-6.078L8.86 21ZM6.023 5.968l9.271-3.746a1 1 0 0 1 1.302.552l5.62 13.908a1 1 0 0 1-.553 1.302L12.39 21.73a1 1 0 0 1-1.302-.553L5.469 7.27a1 1 0 0 1 .554-1.301ZM9 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiDesignPantoneLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m5.765 8-.295-.73a1 1 0 0 1 .553-1.302l9.271-3.746a1 1 0 0 1 1.302.552l5.62 13.908a1 1 0 0 1-.553 1.302L12.39 21.73a1 1 0 0 1-1.302-.553l-.088-.218v.04H7a1 1 0 0 1-1-1v-.269l-3.35-1.353a1 1 0 0 1-.553-1.302L5.765 8Zm2.236 11h2.208l-2.208-5.467V19Zm-2-6.244-1.674 4.141 1.674.711v-4.852Zm1.698-5.309 4.87 12.054 7.417-2.997-4.87-12.054L7.7 7.447Zm2.978 2.033a1 1 0 1 1-.75-1.855 1 1 0 0 1 .75 1.855Z"/>'
      }, props)
  }
  export function RiDesignPenNibFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4.929 21.482 5.846-5.846a1.999 1.999 0 0 0 1.932-3.346 2 2 0 0 0-3.346 1.932l-5.846 5.846-1.06-1.06c2.828-3.3 3.888-6.954 5.302-13.082l6.364-.707 5.657 5.657-.707 6.363c-6.128 1.415-9.782 2.475-13.081 5.304l-1.061-1.06ZM16.596 2.037l6.347 6.346a.5.5 0 0 1-.277.848l-1.474.23-5.656-5.657.212-1.485a.5.5 0 0 1 .848-.282Z"/>'
      }, props)
  }
  export function RiDesignPenNibLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.596 1.037 6.347 6.346a.5.5 0 0 1-.277.848l-1.474.23-5.656-5.657.212-1.485a.5.5 0 0 1 .848-.282ZM4.595 20.148c3.722-3.331 7.995-4.328 12.643-5.52l.446-4.018-4.297-4.297-4.018.446c-1.192 4.648-2.189 8.92-5.52 12.643l-1.395-1.395c2.829-3.3 3.89-6.953 5.303-13.081l6.364-.707 5.657 5.657-.707 6.363c-6.128 1.415-9.782 2.475-13.081 5.304l-1.395-1.395Zm5.284-6.03a2 2 0 1 1 2.828-2.828 2 2 0 0 1-2.828 2.828Z"/>'
      }, props)
  }
  export function RiDesignPencilFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.9 6.854 4.242 4.243-9.9 9.9H3v-4.243l9.9-9.9Zm1.414-1.414 2.121-2.121a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 0 1 0 1.414l-2.122 2.122-4.242-4.243Z"/>'
      }, props)
  }
  export function RiDesignPencilLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.728 9.576-1.414-1.414L5 17.476v1.414h1.414l9.314-9.314Zm1.414-1.414 1.414-1.414-1.414-1.414-1.414 1.414 1.414 1.414Zm-9.9 12.728H3v-4.243L16.435 3.212a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414L7.243 20.89Z"/>'
      }, props)
  }
  export function RiDesignPencilRuler2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m5.636 12.707 1.829 1.829 1.414-1.415-1.829-1.828 1.415-1.414 1.828 1.828 1.414-1.414L9.88 8.465l1.414-1.415 1.828 1.829 1.415-1.414-1.829-1.829 2.829-2.828a1 1 0 0 1 1.414 0l4.242 4.242a1 1 0 0 1 0 1.415L8.465 21.192a1 1 0 0 1-1.415 0L2.808 16.95a1 1 0 0 1 0-1.414l2.828-2.829Zm8.485 5.656 4.243-4.242L21 16.757V21h-4.242l-2.637-2.637ZM5.636 9.878 2.808 7.05a1 1 0 0 1 0-1.415l2.828-2.828a1 1 0 0 1 1.414 0L9.88 5.635 5.636 9.878Z"/>'
      }, props)
  }
  export function RiDesignPencilRuler2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.05 14.121 4.93 16.243l2.828 2.828L19.071 7.757 16.243 4.93 14.12 7.05l1.415 1.415-1.415 1.414-1.414-1.414-1.414 1.414 1.414 1.414-1.414 1.414-1.414-1.414-1.414 1.414 1.414 1.414-1.414 1.415L7.05 14.12Zm9.9-11.313 4.242 4.242a1 1 0 0 1 0 1.415L8.465 21.192a1 1 0 0 1-1.415 0L2.808 16.95a1 1 0 0 1 0-1.414L15.536 2.808a1 1 0 0 1 1.414 0ZM14.12 18.363l1.415-1.414 2.242 2.243h1.414v-1.414l-2.242-2.243 1.414-1.414L21 16.757V21h-4.242l-2.637-2.637ZM5.636 9.878 2.808 7.05a1 1 0 0 1 0-1.415l2.828-2.828a1 1 0 0 1 1.414 0L9.88 5.635 8.464 7.05l-2.12-2.122-1.415 1.415 2.121 2.12-1.414 1.415Z"/>'
      }, props)
  }
  export function RiDesignPencilRulerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 18v2h4v-2H5ZM3 7l4-5 4 5v15H3V7Zm18 1h-2v2h2v2h-3v2h3v2h-2v2h2v3a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v3Z"/>'
      }, props)
  }
  export function RiDesignPencilRulerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 8v12h4V8H5ZM3 7l4-5 4 5v15H3V7Zm16 9v-2h-3v-2h3v-2h-2V8h2V6h-4v14h4v-2h-2v-2h2ZM14 4h6a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDesignQuillPenFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 1.997c-15 0-17 14-18 20h1.998c.666-3.334 2.333-5.167 5.002-5.5 4-.5 7-4 8-7l-1.5-1 1-1c1-1 2.004-2.5 3.5-5.5Z"/>'
      }, props)
  }
  export function RiDesignQuillPenLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.94 14.033a29.79 29.79 0 0 0-.606 1.782c.96-.696 2.101-1.138 3.418-1.303 2.513-.314 4.746-1.974 5.876-4.059L14.172 9l1.413-1.415 1-1.002c.43-.429.915-1.224 1.428-2.367-5.593.867-9.018 4.291-11.074 9.818ZM17 8.997l1 1c-1 3-4 6-8 6.5-2.669.333-4.336 2.166-5.002 5.5H3c1-6 3-20 18-20-1 2.997-1.998 4.996-2.997 5.997L17 8.997Z"/>'
      }, props)
  }
  export function RiDesignRuler2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 21h-2v-3h-2v3H9v-2H7v2H4a1 1 0 0 1-1-1v-3h2v-2H3v-2h3v-2H3V9h2V7H3V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v9h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-3v-2h-2v2Z"/>'
      }, props)
  }
  export function RiDesignRuler2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 19h2v-5h-9V5H5v2h2v2H5v2h3v2H5v2h2v2H5v2h2v-2h2v2h2v-3h2v3h2v-2h2v2Zm-5-7h8a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v8Z"/>'
      }, props)
  }
  export function RiDesignRulerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4.929 13.314 2.121 2.121 1.415-1.414-2.122-2.122 2.122-2.12 2.828 2.828 1.414-1.415L9.88 8.364 12 6.243l2.121 2.12 1.415-1.413-2.122-2.122L16.243 2a1 1 0 0 1 1.414 0l4.95 4.95a1 1 0 0 1 0 1.414l-14.85 14.85a1 1 0 0 1-1.414 0l-4.95-4.95a1 1 0 0 1 0-1.415l3.536-3.535Z"/>'
      }, props)
  }
  export function RiDesignRulerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m6.343 14.728-2.828 2.828 3.535 3.536L20.485 7.657 16.95 4.12l-2.121 2.122 1.414 1.414-1.414 1.414-1.415-1.414-2.121 2.121 2.121 2.121L12 13.314 9.88 11.192l-2.122 2.122 1.415 1.414-1.415 1.414-1.414-1.414ZM17.657 2l4.95 4.95a1 1 0 0 1 0 1.414l-14.85 14.85a1 1 0 0 1-1.414 0l-4.95-4.95a1 1 0 0 1 0-1.415L16.243 2a1 1 0 0 1 1.414 0Z"/>'
      }, props)
  }
  export function RiDesignScissors2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 14.118-2.317 2.317a4 4 0 1 1-2.121-2.121l2.317-2.317L4.21 6.329a2 2 0 0 1 0-2.828l.708-.707L12 9.875l7.081-7.081.708.707a2 2 0 0 1 0 2.828l-5.668 5.668 2.317 2.316a4 4 0 1 1-2.121 2.121L12 14.119Zm-6 5.879a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiDesignScissors2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 13.41-2.554 2.555a4 4 0 1 1-1.414-1.414l2.554-2.554-6.021-6.021a2 2 0 0 1 0-2.829L12 10.582l7.435-7.435a2 2 0 0 1 0 2.829l-6.02 6.02 2.553 2.554a4 4 0 1 1-1.414 1.414L12 13.412Zm-6 6.587a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiDesignScissorsCutFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.879 11.997 7.562 9.68a4 4 0 1 1 2.121-2.121L12 9.875l6.374-6.374a2 2 0 0 1 2.829 0l.707.707L9.683 16.434a4 4 0 1 1-2.121-2.121l2.317-2.316ZM6 7.997a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm9.535-6.587 6.375 6.375-.707.707a2 2 0 0 1-2.829 0l-4.96-4.96 2.12-2.122ZM16 10.997h2v2h-2v-2Zm4 0h2v2h-2v-2Zm-14 0h2v2H6v-2Zm-4 0h2v2H2v-2Z"/>'
      }, props)
  }
  export function RiDesignScissorsCutLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 5.997c0 .732-.197 1.419-.54 2.01L12 10.581l6.728-6.728a2 2 0 0 1 2.828 0l-12.11 12.11a4 4 0 1 1-1.414-1.414l2.554-2.553-2.554-2.554A4 4 0 1 1 10 5.997Zm-2 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm13.556 14.142a2 2 0 0 1-2.828 0l-5.317-5.317 1.415-1.414 6.73 6.73ZM16 10.997h2v2h-2v-2Zm4 0h2v2h-2v-2Zm-14 0h2v2H6v-2Zm-4 0h2v2H2v-2Zm4 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiDesignScissorsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.683 7.559 12 9.875l6.374-6.374a2 2 0 0 1 2.829 0l.707.707L9.683 16.434a4 4 0 1 1-2.121-2.121l2.317-2.316L7.562 9.68a4 4 0 1 1 2.121-2.121ZM6 7.997a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm9.535-6.587 6.375 6.375-.707.707a2 2 0 0 1-2.829 0l-4.96-4.96 2.12-2.122Z"/>'
      }, props)
  }
  export function RiDesignScissorsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.446 8.029 12 10.582l6.728-6.728a2 2 0 0 1 2.828 0l-12.11 12.11a4 4 0 1 1-1.414-1.414l2.554-2.553-2.554-2.554a4 4 0 1 1 1.414-1.414Zm5.38 5.379 6.73 6.73a2 2 0 0 1-2.828 0l-5.317-5.316 1.415-1.414Zm-7.412 3.174a2 2 0 1 0-2.828 2.828 2 2 0 0 0 2.828-2.828Zm0-9.171a2 2 0 1 0-2.828-2.828A2 2 0 0 0 7.414 7.41Z"/>'
      }, props)
  }
  export function RiDesignScreenshot2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h2v2H3V3Zm4 0h2v2H7V3Zm4 0h2v2h-2V3Zm4 0h2v2h-2V3Zm4 0h2v2h-2V3Zm0 4h2v2h-2V7ZM3 19h2v2H3v-2Zm0-4h2v2H3v-2Zm0-4h2v2H3v-2Zm0-4h2v2H3V7Zm7.667 4 1.036-1.555A1 1 0 0 1 12.535 9h2.93a1 1 0 0 1 .832.445L17.333 11H20a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h2.667ZM14 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiDesignScreenshot2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h2v2H3V3Zm4 0h2v2H7V3Zm4 0h2v2h-2V3Zm4 0h2v2h-2V3Zm4 0h2v2h-2V3Zm0 4h2v2h-2V7ZM3 19h2v2H3v-2Zm0-4h2v2H3v-2Zm0-4h2v2H3v-2Zm0-4h2v2H3V7Zm7.667 4 1.036-1.555A1 1 0 0 1 12.535 9h2.93a1 1 0 0 1 .832.445L17.333 11H20a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h2.667ZM9 19h10v-6h-2.737l-1.333-2h-1.86l-1.333 2H9v6Zm5-1a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiDesignScreenshotFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.993 14.407-1.552 1.552a4 4 0 1 1-1.418-1.41l1.555-1.556-3.124-3.125a1.5 1.5 0 0 1 0-2.121l.354-.354 4.185 4.185 4.189-4.189.353.354a1.5 1.5 0 0 1 0 2.12l-3.128 3.13 1.561 1.56a4 4 0 1 1-1.414 1.414l-1.561-1.56ZM19 13V5H5v8H3V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v9h-2ZM7 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiDesignScreenshotLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.993 14.407-1.552 1.552a4 4 0 1 1-1.418-1.41l1.555-1.556-4.185-4.185 1.415-1.415 4.185 4.185 4.189-4.189 1.414 1.414-4.19 4.19 1.562 1.56a4 4 0 1 1-1.414 1.414l-1.561-1.56ZM7 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2-7V5H5v8H3V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v9h-2Z"/>'
      }, props)
  }
  export function RiDesignShape2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 2h5v5H2V2Zm0 15h5v5H2v-5ZM17 2h5v5h-5V2Zm0 15h5v5h-5v-5ZM8 4h8v2H8V4ZM4 8h2v8H4V8Zm14 0h2v8h-2V8ZM8 18h8v2H8v-2Z"/>'
      }, props)
  }
  export function RiDesignShape2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 16h2v6h-6v-2H8v2H2v-6h2V8H2V2h6v2h8V2h6v6h-2v8Zm-2 0V8h-2V6H8v2H6v8h2v2h8v-2h2ZM4 4v2h2V4H4Zm0 14v2h2v-2H4ZM18 4v2h2V4h-2Zm0 14v2h2v-2h-2Z"/>'
      }, props)
  }
  export function RiDesignShapeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm14 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0 14a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM5 22a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM9 4h6v2H9V4Zm0 14h6v2H9v-2ZM4 9h2v6H4V9Zm14 0h2v6h-2V9Z"/>'
      }, props)
  }
  export function RiDesignShapeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.83 20A3.001 3.001 0 1 1 4 16.17V7.83A3.001 3.001 0 1 1 7.83 4h8.34A3.001 3.001 0 1 1 20 7.83v8.34A3.001 3.001 0 1 1 16.17 20H7.83Zm0-2h8.34A3.009 3.009 0 0 1 18 16.17V7.83A3.008 3.008 0 0 1 16.17 6H7.83A3.008 3.008 0 0 1 6 7.83v8.34A3.008 3.008 0 0 1 7.83 18ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm14 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiDesignSipFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.96 6.501 2.829-2.828a1 1 0 0 1 1.414 0l2.121 2.121a1 1 0 0 1 0 1.414l-2.828 2.829 1.768 1.768-1.415 1.414-7.07-7.071 1.413-1.415 1.768 1.768Zm-3.182 2.475 4.243 4.243-7.778 7.778H3v-4.243l7.778-7.778Z"/>'
      }, props)
  }
  export function RiDesignSipLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m6.457 18.954 8.564-8.564-1.414-1.414-8.564 8.564 1.414 1.414Zm5.735-11.392-1.414-1.414 1.414-1.415 1.768 1.768 2.829-2.828a1 1 0 0 1 1.414 0l2.121 2.121a1 1 0 0 1 0 1.414l-2.828 2.829 1.768 1.768-1.415 1.414-1.414-1.414-9.192 9.192H3v-4.243l9.192-9.192Z"/>'
      }, props)
  }
  export function RiDesignSliceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.768 12.229 2.121 2.121c-4.596 4.596-10.253 6.01-13.788 5.304L17.657 4.097l2.121 2.121-6.01 6.01Z"/>'
      }, props)
  }
  export function RiDesignSliceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.69 12.915 1.769 1.767c-6.01 6.01-10.96 6.01-15.203 4.597L17.812 3.722l3.536 3.536-5.657 5.657Zm-2.827 0 5.656-5.657-.707-.707L6.314 18.048c2.732.108 5.358-.906 8.267-3.415l-1.718-1.718Z"/>'
      }, props)
  }
  export function RiDesignTBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 8H7v2h4v7h2v-7h4V8ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDesignTBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 5v14h14V5H5ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm9 7v7h-2v-7H7V8h10v2h-4Z"/>'
      }, props)
  }
  export function RiDesignTableAltFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 14V3H3a1 1 0 0 0-1 1v10h5Zm8 0V3H9v11h6Zm7 0V4a1 1 0 0 0-1-1h-4v11h5Zm-1 7a1 1 0 0 0 1-1v-4H2v4a1 1 0 0 0 1 1h18Z"/>'
      }, props)
  }
  export function RiDesignTableAltLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-1 13H4v3h16v-3ZM8 5H4v9h4V5Zm6 0h-4v9h4V5Zm6 0h-4v9h4V5Z"/>'
      }, props)
  }
  export function RiDesignTableFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 21H9V10h6v11Zm2 0V10h5v10a1 1 0 0 1-1 1h-4ZM7 21H3a1 1 0 0 1-1-1V10h5v11ZM22 8H2V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v4Z"/>'
      }, props)
  }
  export function RiDesignTableLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 8h16V5H4v3Zm10 11v-9h-4v9h4Zm2 0h4v-9h-4v9Zm-8 0v-9H4v9h4ZM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDesignToolsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.329 3.272A3.5 3.5 0 0 1 9.8 7.745L20.646 18.59l-2.121 2.122L7.679 9.867a3.5 3.5 0 0 1-4.472-4.474L5.443 7.63a1.5 1.5 0 0 0 2.122-2.121L5.329 3.272Zm10.367 1.883 3.182-1.768 1.415 1.415-1.768 3.182-1.768.353-2.121 2.121-1.415-1.414 2.122-2.121.353-1.768Zm-7.07 7.778 2.12 2.122-4.95 4.95a1.5 1.5 0 0 1-2.218-2.015l.097-.107 4.95-4.95Z"/>'
      }, props)
  }
  export function RiDesignToolsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.329 3.272a3.5 3.5 0 0 1 4.255 4.962l10.709 10.71-1.415 1.414L8.17 9.648a3.502 3.502 0 0 1-4.962-4.255L5.443 7.63a1.5 1.5 0 0 0 2.122-2.121L5.329 3.272Zm10.367 1.883 3.182-1.768 1.415 1.415-1.768 3.182-1.768.353-2.121 2.121-1.415-1.414 2.122-2.121.353-1.768ZM8.98 13.287l1.414 1.414-5.303 5.303a1 1 0 0 1-1.492-1.327l.077-.087 5.304-5.303Z"/>'
      }, props)
  }
  export function RiDevelopmentBracesFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 18v-3.7a1.5 1.5 0 0 0-1.5-1.5H2v-1.6h.5A1.5 1.5 0 0 0 4 9.7V6a3 3 0 0 1 3-3h1v2H7a1 1 0 0 0-1 1v4.1A2 2 0 0 1 4.626 12 2 2 0 0 1 6 13.9V18a1 1 0 0 0 1 1h1v2H7a3 3 0 0 1-3-3Zm16-3.7V18a3 3 0 0 1-3 3h-1v-2h1a1 1 0 0 0 1-1v-4.1a2 2 0 0 1 1.374-1.9A2 2 0 0 1 18 10.1V6a1 1 0 0 0-1-1h-1V3h1a3 3 0 0 1 3 3v3.7a1.5 1.5 0 0 0 1.5 1.5h.5v1.6h-.5a1.5 1.5 0 0 0-1.5 1.5Z"/>'
      }, props)
  }
  export function RiDevelopmentBracesLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 18v-3.7a1.5 1.5 0 0 0-1.5-1.5H2v-1.6h.5A1.5 1.5 0 0 0 4 9.7V6a3 3 0 0 1 3-3h1v2H7a1 1 0 0 0-1 1v4.1A2 2 0 0 1 4.626 12 2 2 0 0 1 6 13.9V18a1 1 0 0 0 1 1h1v2H7a3 3 0 0 1-3-3Zm16-3.7V18a3 3 0 0 1-3 3h-1v-2h1a1 1 0 0 0 1-1v-4.1a2 2 0 0 1 1.374-1.9A2 2 0 0 1 18 10.1V6a1 1 0 0 0-1-1h-1V3h1a3 3 0 0 1 3 3v3.7a1.5 1.5 0 0 0 1.5 1.5h.5v1.6h-.5a1.5 1.5 0 0 0-1.5 1.5Z"/>'
      }, props)
  }
  export function RiDevelopmentBracketsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 3v2H6v14h3v2H4V3h5Zm6 0h5v18h-5v-2h3V5h-3V3Z"/>'
      }, props)
  }
  export function RiDevelopmentBracketsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 3v2H6v14h3v2H4V3h5Zm6 0h5v18h-5v-2h3V5h-3V3Z"/>'
      }, props)
  }
  export function RiDevelopmentBug2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.07 16A7.06 7.06 0 0 1 5 15v-1H3v-2h2v-1c0-.34.024-.674.07-1H3V8h2.674a7.03 7.03 0 0 1 2.84-3.072l-1.05-1.05L8.88 2.465l1.683 1.684a7.03 7.03 0 0 1 2.876 0l1.683-1.684 1.414 1.415-1.05 1.05a7.031 7.031 0 0 1 2.841 3.07H21v2h-2.07c.046.327.07.661.07 1v1h2v2h-2v1c0 .34-.024.674-.07 1H21v2h-2.674a7 7 0 0 1-12.652 0H3v-2h2.07ZM9 10v2h6v-2H9Zm0 4v2h6v-2H9Z"/>'
      }, props)
  }
  export function RiDevelopmentBug2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.562 4.148a7.03 7.03 0 0 1 2.876 0l1.683-1.684 1.414 1.415-1.05 1.05a7.031 7.031 0 0 1 2.841 3.07H21v2h-2.07c.046.327.07.661.07 1v1h2v2h-2v1c0 .34-.024.674-.07 1H21v2h-2.674a7 7 0 0 1-12.652 0H3v-2h2.07A7.06 7.06 0 0 1 5 15v-1H3v-2h2v-1c0-.339.024-.673.07-1H3V8h2.674a7.03 7.03 0 0 1 2.84-3.07l-1.05-1.05L8.88 2.464l1.683 1.684ZM12 6a5 5 0 0 0-5 5v4a5 5 0 0 0 10 0v-4a5 5 0 0 0-5-5Zm-3 8h6v2H9v-2Zm0-4h6v2H9v-2Z"/>'
      }, props)
  }
  export function RiDevelopmentBugFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.056 8.3a7.01 7.01 0 0 1 .199-.3h11.49c.069.098.135.199.199.3l2.02-1.166 1 1.732-2.213 1.278c.162.59.249 1.213.249 1.856v1h3v2h-3c0 .953-.19 1.862-.536 2.69l2.5 1.444-1 1.732-2.526-1.458A6.992 6.992 0 0 1 13 21.929V14h-2v7.93a6.992 6.992 0 0 1-4.438-2.522l-2.526 1.458-1-1.732 2.5-1.443A6.98 6.98 0 0 1 5 15H2v-2h3v-1c0-.643.087-1.265.249-1.856L3.036 8.866l1-1.732L6.056 8.3ZM8 6a4 4 0 1 1 8 0H8Z"/>'
      }, props)
  }
  export function RiDevelopmentBugLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 19.9a5.002 5.002 0 0 0 4-4.9v-3c0-.701-.144-1.378-.415-2h-9.17A4.981 4.981 0 0 0 7 12v3a5.002 5.002 0 0 0 4 4.9V14h2v5.9Zm-7.464-2.21A6.98 6.98 0 0 1 5 15H2v-2h3v-1c0-.643.087-1.265.249-1.856L3.036 8.866l1-1.732L6.056 8.3a7.01 7.01 0 0 1 .199-.3h11.49c.069.098.135.199.199.3l2.02-1.166 1 1.732-2.213 1.278c.162.59.249 1.213.249 1.856v1h3v2h-3c0 .953-.19 1.862-.536 2.69l2.5 1.444-1 1.732-2.526-1.458A6.986 6.986 0 0 1 12 22a6.986 6.986 0 0 1-5.438-2.592l-2.526 1.458-1-1.732 2.5-1.443ZM8 6a4 4 0 1 1 8 0H8Z"/>'
      }, props)
  }
  export function RiDevelopmentCodeBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm13.465 12.536L20 12l-3.535-3.536L15.05 9.88 17.172 12l-2.122 2.121 1.415 1.415ZM6.828 12 8.95 9.879 7.536 8.464 4 12l3.536 3.536L8.95 14.12 6.828 12Zm4.416 5 3.64-10h-2.128l-3.64 10h2.128Z"/>'
      }, props)
  }
  export function RiDevelopmentCodeBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h16V5H4Zm16 7-3.535 3.536-1.415-1.415L17.172 12 15.05 9.879l1.415-1.415L20 12ZM6.828 12l2.122 2.121-1.414 1.415L4 12l3.536-3.536L8.95 9.88 6.828 12Zm4.416 5H9.116l3.64-10h2.128l-3.64 10Z"/>'
      }, props)
  }
  export function RiDevelopmentCodeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m23 12-7.071 7.07-1.414-1.413L20.172 12l-5.657-5.657 1.414-1.414L23 11.999ZM3.828 12l5.657 5.657-1.414 1.414L1 12l7.071-7.071 1.414 1.414L3.828 12Z"/>'
      }, props)
  }
  export function RiDevelopmentCodeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m23 12-7.071 7.07-1.414-1.413L20.172 12l-5.657-5.657 1.414-1.414L23 11.999ZM3.828 12l5.657 5.657-1.414 1.414L1 12l7.071-7.071 1.414 1.414L3.828 12Z"/>'
      }, props)
  }
  export function RiDevelopmentCodeSFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m24 12-5.657 5.657-1.414-1.414L21.172 12l-4.243-4.243 1.414-1.414L24 12ZM2.828 12l4.243 4.243-1.414 1.414L0 12l5.657-5.657L7.07 7.757 2.828 12Z"/>'
      }, props)
  }
  export function RiDevelopmentCodeSLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m24 12-5.657 5.657-1.414-1.414L21.172 12l-4.243-4.243 1.414-1.414L24 12ZM2.828 12l4.243 4.243-1.414 1.414L0 12l5.657-5.657L7.07 7.757 2.828 12Z"/>'
      }, props)
  }
  export function RiDevelopmentCodeSSlashFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m24 12-5.657 5.657-1.414-1.414L21.172 12l-4.243-4.243 1.414-1.414L24 12ZM2.828 12l4.243 4.243-1.414 1.414L0 12l5.657-5.657L7.07 7.757 2.828 12Zm6.96 9H7.66l6.552-18h2.128L9.788 21Z"/>'
      }, props)
  }
  export function RiDevelopmentCodeSSlashLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m24 12-5.657 5.657-1.414-1.414L21.172 12l-4.243-4.243 1.414-1.414L24 12ZM2.828 12l4.243 4.243-1.414 1.414L0 12l5.657-5.657L7.07 7.757 2.828 12Zm6.96 9H7.66l6.552-18h2.128L9.788 21Z"/>'
      }, props)
  }
  export function RiDevelopmentCommandFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 8h4V6.5a3.5 3.5 0 1 1 3.5 3.5H16v4h1.5a3.5 3.5 0 1 1-3.5 3.5V16h-4v1.5A3.5 3.5 0 1 1 6.5 14H8v-4H6.5A3.5 3.5 0 1 1 10 6.5V8ZM8 8V6.5A1.5 1.5 0 1 0 6.5 8H8Zm0 8H6.5A1.5 1.5 0 1 0 8 17.5V16Zm8-8h1.5A1.5 1.5 0 1 0 16 6.5V8Zm0 8v1.5a1.5 1.5 0 1 0 1.5-1.5H16Zm-6-6v4h4v-4h-4Z"/>'
      }, props)
  }
  export function RiDevelopmentCommandLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 8h4V6.5a3.5 3.5 0 1 1 3.5 3.5H16v4h1.5a3.5 3.5 0 1 1-3.5 3.5V16h-4v1.5A3.5 3.5 0 1 1 6.5 14H8v-4H6.5A3.5 3.5 0 1 1 10 6.5V8ZM8 8V6.5A1.5 1.5 0 1 0 6.5 8H8Zm0 8H6.5A1.5 1.5 0 1 0 8 17.5V16Zm8-8h1.5A1.5 1.5 0 1 0 16 6.5V8Zm0 8v1.5a1.5 1.5 0 1 0 1.5-1.5H16Zm-6-6v4h4v-4h-4Z"/>'
      }, props)
  }
  export function RiDevelopmentCss3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m5 3-.65 3.34h13.59L17.5 8.5H3.92l-.66 3.33h13.59l-.76 3.81-5.48 1.81-4.75-1.81.33-1.64H2.85l-.79 4 7.85 3 9.05-3 1.2-6.03.24-1.21L21.94 3H5Z"/>'
      }, props)
  }
  export function RiDevelopmentCss3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.8 14h2.04l-.545 2.724 5.744 2.155 7.228-2.41L18.36 11H3.4l.4-2h14.96l.8-4H4.6L5 3h17l-3 15-9 3-8-3 .8-4Z"/>'
      }, props)
  }
  export function RiDevelopmentCursorFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.91 12.36 17 20.854l-2.818 1.026-3.092-8.493-4.172 3.155 1.49-14.909 10.726 10.463-5.225.264Z"/>'
      }, props)
  }
  export function RiDevelopmentCursorLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.387 13.498 2.553 7.014-4.698 1.71-2.553-7.014-3.899 2.445 1.619-16.02 11.537 11.232-4.559.633Zm-.01 5.819-2.715-7.46 2.96-.411-5.64-5.49-.791 7.83 2.531-1.587 2.715 7.46.94-.342Z"/>'
      }, props)
  }
  export function RiDevelopmentGitBranchFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.105 15.21A3.001 3.001 0 1 1 5 15.17V8.83a3.001 3.001 0 1 1 2 0V12c.836-.628 1.874-1 3-1h4a3.001 3.001 0 0 0 2.895-2.21 3.001 3.001 0 1 1 2.032.064A5.002 5.002 0 0 1 14 13h-4a3.001 3.001 0 0 0-2.895 2.21Z"/>'
      }, props)
  }
  export function RiDevelopmentGitBranchLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.105 15.21A3.001 3.001 0 1 1 5 15.17V8.83a3.001 3.001 0 1 1 2 0V12c.836-.628 1.874-1 3-1h4a3.001 3.001 0 0 0 2.895-2.21 3.001 3.001 0 1 1 2.032.064A5.002 5.002 0 0 1 14 13h-4a3.001 3.001 0 0 0-2.895 2.21ZM6 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiDevelopmentGitClosePullRequestFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 6a3 3 0 1 1 4 2.83v6.34a3.001 3.001 0 1 1-2 0V8.83A3.001 3.001 0 0 1 3 6Zm12.293-2.707a1 1 0 0 1 1.414 0L18 4.586l1.293-1.293a1 1 0 1 1 1.414 1.414L19.414 6l1.293 1.293a1 1 0 0 1-1.414 1.414L18 7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L16.586 6l-1.293-1.293a1 1 0 0 1 0-1.414ZM18 10a1 1 0 0 1 1 1v4.17a3.001 3.001 0 1 1-2 0V11a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDevelopmentGitClosePullRequestLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM3 6a3 3 0 1 1 4 2.83v6.34a3.001 3.001 0 1 1-2 0V8.83A3.001 3.001 0 0 1 3 6Zm12.293-2.707a1 1 0 0 1 1.414 0L18 4.586l1.293-1.293a1 1 0 1 1 1.414 1.414L19.414 6l1.293 1.293a1 1 0 0 1-1.414 1.414L18 7.414l-1.293 1.293a1 1 0 1 1-1.414-1.414L16.586 6l-1.293-1.293a1 1 0 0 1 0-1.414ZM18 10a1 1 0 0 1 1 1v4.17a3.001 3.001 0 1 1-2 0V11a1 1 0 0 1 1-1ZM6 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiDevelopmentGitCommitFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.874 13a4.002 4.002 0 0 1-7.748 0H3v-2h5.126a4.002 4.002 0 0 1 7.748 0H21v2h-5.126Z"/>'
      }, props)
  }
  export function RiDevelopmentGitCommitLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.874 13a4.002 4.002 0 0 1-7.748 0H3v-2h5.126a4.002 4.002 0 0 1 7.748 0H21v2h-5.126ZM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiDevelopmentGitMergeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.105 8.79A3.001 3.001 0 0 0 10 11h4a5.002 5.002 0 0 1 4.927 4.146A3.001 3.001 0 0 1 18 21a3 3 0 0 1-1.105-5.79A3.001 3.001 0 0 0 14 13h-4a4.978 4.978 0 0 1-3-1v3.17a3.001 3.001 0 1 1-2 0V8.83a3.001 3.001 0 1 1 2.105-.04Z"/>'
      }, props)
  }
  export function RiDevelopmentGitMergeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.105 8.79A3.001 3.001 0 0 0 10 11h4a5.002 5.002 0 0 1 4.927 4.146A3.001 3.001 0 0 1 18 21a3 3 0 0 1-1.105-5.79A3.001 3.001 0 0 0 14 13h-4a4.978 4.978 0 0 1-3-1v3.17a3.001 3.001 0 1 1-2 0V8.83a3.001 3.001 0 1 1 2.105-.04ZM6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm12 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiDevelopmentGitPullRequestFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 5h2a2 2 0 0 1 2 2v8.17a3.001 3.001 0 1 1-2 0V7h-2v3l-4.5-4L15 2v3ZM5 8.83a3.001 3.001 0 1 1 2 0v6.34a3.001 3.001 0 1 1-2 0V8.83Z"/>'
      }, props)
  }
  export function RiDevelopmentGitPullRequestLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 5h2a2 2 0 0 1 2 2v8.17a3.001 3.001 0 1 1-2 0V7h-2v3l-4.5-4L15 2v3ZM5 8.83a3.001 3.001 0 1 1 2 0v6.34a3.001 3.001 0 1 1-2 0V8.83ZM6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm12 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiDevelopmentGitRepositoryCommitsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 17v6h-2v-6H9l4-5 4 5h-3Zm2 2h3v-3h-.8L13 9.5 7.647 16H6.5a1.5 1.5 0 0 0 0 3H10v2H6.5A3.5 3.5 0 0 1 3 17.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1h-4v-2ZM7 5v2h2V5H7Zm0 3v2h2V8H7Z"/>'
      }, props)
  }
  export function RiDevelopmentGitRepositoryCommitsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 16v-2h1V4H6v10.035c.163-.023.33-.035.5-.035H8v2H6.5a1.5 1.5 0 0 0 0 3H10v2H6.5A3.5 3.5 0 0 1 3 17.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1h-4v-2h3v-3h-1ZM7 5h2v2H7V5Zm0 3h2v2H7V8Zm7 9v6h-2v-6H9l4-5 4 5h-3Z"/>'
      }, props)
  }
  export function RiDevelopmentGitRepositoryFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 21v2.5l-3-2-3 2V21h-.5A3.5 3.5 0 0 1 3 17.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1h-7Zm-6-2v-2h6v2h6v-3H6.5a1.5 1.5 0 0 0 0 3H7ZM7 5v2h2V5H7Zm0 3v2h2V8H7Zm0 3v2h2v-2H7Z"/>'
      }, props)
  }
  export function RiDevelopmentGitRepositoryLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 21v2.5l-3-2-3 2V21h-.5A3.5 3.5 0 0 1 3 17.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1h-7Zm0-2h6v-3H6.5a1.5 1.5 0 0 0 0 3H7v-2h6v2Zm6-5V4H6v10.035c.163-.023.33-.035.5-.035H19ZM7 5h2v2H7V5Zm0 3h2v2H7V8Zm0 3h2v2H7v-2Z"/>'
      }, props)
  }
  export function RiDevelopmentGitRepositoryPrivateFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0v1Zm-2 0V7a4 4 0 0 0-8 0v1h8Zm-9 3v2h2v-2H7Zm0 3v2h2v-2H7Zm0 3v2h2v-2H7Z"/>'
      }, props)
  }
  export function RiDevelopmentGitRepositoryPrivateLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 10v10h13V10H6Zm12-2h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0v1Zm-2 0V7a4 4 0 0 0-8 0v1h8Zm-9 3h2v2H7v-2Zm0 3h2v2H7v-2Zm0 3h2v2H7v-2Z"/>'
      }, props)
  }
  export function RiDevelopmentHtml5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 18.178 4.62-1.256.623-6.778H9.026L8.822 7.89h8.626l.227-2.211H6.325l.636 6.678h7.82l-.261 2.866-2.52.667-2.52-.667-.158-1.844h-2.27l.329 3.544L12 18.178ZM3 2h18l-1.623 18L12 22l-7.377-2L3 2Z"/>'
      }, props)
  }
  export function RiDevelopmentHtml5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 18.178-4.62-1.256-.328-3.544h2.27l.158 1.844 2.52.667 2.52-.667.26-2.866H6.96l-.635-6.678h11.35l-.227 2.21H8.822l.204 2.256h8.217l-.624 6.778L12 18.178ZM3 2h18l-1.623 18L12 22l-7.377-2L3 2Zm2.188 2L6.49 18.434 12 19.928l5.51-1.494L18.812 4H5.188Z"/>'
      }, props)
  }
  export function RiDevelopmentJavascriptFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm7.334 13.055c.72.58 1.438.865 2.156.858.44 0 .778-.08 1.012-.242a.75.75 0 0 0 .341-.66.971.971 0 0 0-.34-.748c-.235-.205-.679-.41-1.332-.616-.784-.227-1.39-.52-1.815-.88-.418-.36-.63-.862-.638-1.507 0-.609.264-1.118.792-1.529.514-.41 1.17-.616 1.97-.616 1.114 0 2.009.271 2.683.814l-.77 1.199a2.597 2.597 0 0 0-.935-.462 3.211 3.211 0 0 0-.946-.165c-.38 0-.685.07-.913.209-.227.14-.34.323-.34.55 0 .25.139.462.417.638.28.169.756.356 1.43.561.814.242 1.394.565 1.738.968.345.403.517.917.517 1.54 0 .638-.245 1.188-.737 1.65-.484.455-1.188.693-2.112.715-1.21 0-2.222-.363-3.036-1.089l.858-1.188Zm-5.53.638c.235.147.517.22.847.22.345 0 .63-.099.858-.297.227-.205.341-.561.341-1.067v-5.302h1.485v5.588c-.022.865-.271 1.489-.748 1.87a2.466 2.466 0 0 1-.891.484 3.296 3.296 0 0 1-.935.143c-.55 0-1.038-.095-1.463-.286-.455-.205-.836-.568-1.144-1.089l1.034-.847c.19.257.396.451.616.583Z"/>'
      }, props)
  }
  export function RiDevelopmentJavascriptLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.334 16.055-.858 1.188c.814.726 1.826 1.089 3.036 1.089.924-.022 1.628-.26 2.112-.715.492-.462.737-1.012.737-1.65 0-.623-.172-1.137-.517-1.54-.344-.403-.924-.726-1.738-.968-.674-.205-1.15-.392-1.43-.561-.278-.176-.418-.389-.418-.638 0-.227.114-.41.341-.55.228-.14.532-.209.913-.209.28 0 .594.055.946.165.352.095.664.25.935.462l.77-1.199c-.674-.543-1.569-.814-2.684-.814-.799 0-1.455.205-1.969.616-.528.41-.792.92-.792 1.529.008.645.22 1.148.638 1.507.426.36 1.03.653 1.815.88.653.205 1.097.41 1.331.616a.971.971 0 0 1 .341.748.75.75 0 0 1-.34.66c-.235.161-.573.242-1.013.242-.718.007-1.437-.279-2.156-.858Zm-5.53.638a2.18 2.18 0 0 1-.616-.583l-1.034.847c.308.52.69.884 1.144 1.089.425.19.913.286 1.463.286.3 0 .612-.048.935-.143.323-.095.62-.257.891-.484.477-.381.726-1.005.748-1.87v-5.588H9.85v5.302c0 .506-.114.862-.34 1.067-.228.198-.514.297-.859.297-.33 0-.612-.073-.847-.22ZM3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Z"/>'
      }, props)
  }
  export function RiDevelopmentParenthesesFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.923 21C5.113 18.664 4 15.493 4 12c0-3.493 1.113-6.664 2.923-9h2.014C7.235 5.388 6.2 8.542 6.2 12s1.035 6.612 2.737 9H6.923Zm10.151 0H15.06c1.702-2.388 2.737-5.542 2.737-9s-1.035-6.612-2.737-9h2.014c1.81 2.336 2.923 5.507 2.923 9 0 3.493-1.112 6.664-2.923 9Z"/>'
      }, props)
  }
  export function RiDevelopmentParenthesesLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.923 21C5.113 18.664 4 15.493 4 12c0-3.493 1.113-6.664 2.923-9h2.014C7.235 5.388 6.2 8.542 6.2 12s1.035 6.612 2.737 9H6.923Zm10.151 0H15.06c1.702-2.388 2.737-5.542 2.737-9s-1.035-6.612-2.737-9h2.014c1.81 2.336 2.923 5.507 2.923 9 0 3.493-1.112 6.664-2.923 9Z"/>'
      }, props)
  }
  export function RiDevelopmentTerminalBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm9 12v2h6v-2h-6Zm-3.586-3-2.828 2.828L7 16.243 11.243 12 7 7.757 5.586 9.172 8.414 12Z"/>'
      }, props)
  }
  export function RiDevelopmentTerminalBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h16V5H4Zm8 10h6v2h-6v-2Zm-3.333-3L5.838 9.172l1.415-1.415L11.495 12l-4.242 4.243-1.415-1.415L8.667 12Z"/>'
      }, props)
  }
  export function RiDevelopmentTerminalFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11 12-7.071 7.07-1.414-1.413L8.172 12 2.514 6.343l1.414-1.414 7.07 7.07Zm0 7h10v2H11v-2Z"/>'
      }, props)
  }
  export function RiDevelopmentTerminalLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11 12-7.071 7.07-1.414-1.413L8.172 12 2.514 6.343l1.414-1.414 7.07 7.07Zm0 7h10v2H11v-2Z"/>'
      }, props)
  }
  export function RiDevelopmentTerminalWindowFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 10H4v9h16v-9ZM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm2 3v2h2V6H5Zm4 0v2h2V6H9Zm-4 5h3v5H5v-5Z"/>'
      }, props)
  }
  export function RiDevelopmentTerminalWindowLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 9V5H4v4h16Zm0 2H4v8h16v-8ZM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm2 9h3v5H5v-5Zm0-6h2v2H5V6Zm4 0h2v2H9V6Z"/>'
      }, props)
  }
  export function RiDeviceAirplayFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.4 13.533 5 6.667a.5.5 0 0 1-.4.8H7a.5.5 0 0 1-.4-.8l5-6.667a.5.5 0 0 1 .8 0ZM18 19v-2h2V5H4v12h2v2H2.992A.994.994 0 0 1 2 18V4c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H18Z"/>'
      }, props)
  }
  export function RiDeviceAirplayLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.4 13.533 5 6.667a.5.5 0 0 1-.4.8H7a.5.5 0 0 1-.4-.8l5-6.667a.5.5 0 0 1 .8 0ZM12 16.33 10 19h4l-2-2.67ZM18 19v-2h2V5H4v12h2v2H2.992A.994.994 0 0 1 2 18V4c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H18Z"/>'
      }, props)
  }
  export function RiDeviceBarcodeBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm3 4v10h3V7H6Zm4 0v10h2V7h-2Zm3 0v10h1V7h-1Zm2 0v10h3V7h-3Z"/>'
      }, props)
  }
  export function RiDeviceBarcodeBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 5v14h16V5H4ZM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm3 4h3v10H6V7Zm4 0h2v10h-2V7Zm3 0h1v10h-1V7Zm2 0h3v10h-3V7Z"/>'
      }, props)
  }
  export function RiDeviceBarcodeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 4h2v16H2V4Zm4 0h2v16H6V4Zm3 0h3v16H9V4Zm4 0h2v16h-2V4Zm3 0h2v16h-2V4Zm3 0h3v16h-3V4Z"/>'
      }, props)
  }
  export function RiDeviceBarcodeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 4h2v16H2V4Zm4 0h1v16H6V4Zm2 0h2v16H8V4Zm3 0h2v16h-2V4Zm3 0h2v16h-2V4Zm3 0h1v16h-1V4Zm2 0h3v16h-3V4Z"/>'
      }, props)
  }
  export function RiDeviceBaseStationFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 13 6 9H6l6-9Zm-1.06-2.44a1.5 1.5 0 1 1 2.121-2.12 1.5 1.5 0 0 1-2.122 2.12ZM5.281 2.782l1.415 1.414a7.5 7.5 0 0 0 0 10.607l-1.415 1.414a9.5 9.5 0 0 1 0-13.435Zm13.436 0a9.5 9.5 0 0 1 0 13.435l-1.415-1.414a7.5 7.5 0 0 0 0-10.607l1.415-1.414ZM8.11 5.611l1.414 1.414a3.5 3.5 0 0 0 0 4.95l-1.414 1.414a5.5 5.5 0 0 1 0-7.778Zm7.778 0a5.5 5.5 0 0 1 0 7.778l-1.414-1.414a3.5 3.5 0 0 0 0-4.95l1.414-1.414Z"/>'
      }, props)
  }
  export function RiDeviceBaseStationLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 13 6 9H6l6-9Zm0 3.6L9.74 20h4.52L12 16.6Zm-1.06-6.04a1.5 1.5 0 1 1 2.121-2.12 1.5 1.5 0 0 1-2.122 2.12ZM5.281 2.782l1.415 1.414a7.5 7.5 0 0 0 0 10.607l-1.415 1.414a9.5 9.5 0 0 1 0-13.435Zm13.436 0a9.5 9.5 0 0 1 0 13.435l-1.415-1.414a7.5 7.5 0 0 0 0-10.607l1.415-1.414ZM8.11 5.611l1.414 1.414a3.5 3.5 0 0 0 0 4.95l-1.414 1.414a5.5 5.5 0 0 1 0-7.778Zm7.778 0a5.5 5.5 0 0 1 0 7.778l-1.414-1.414a3.5 3.5 0 0 0 0-4.95l1.414-1.414Z"/>'
      }, props)
  }
  export function RiDeviceBattery2ChargeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3Zm4 8V7l-5 7h3v5l5-7h-3Z"/>'
      }, props)
  }
  export function RiDeviceBattery2ChargeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 12h3l-5 7v-5H8l5-7v5Zm-2-6H7v14h10V6h-4V4h-2v2ZM9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3Z"/>'
      }, props)
  }
  export function RiDeviceBattery2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3Z"/>'
      }, props)
  }
  export function RiDeviceBattery2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 6H7v14h10V6h-4V4h-2v2ZM9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3Z"/>'
      }, props)
  }
  export function RiDeviceBatteryChargeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 11V5l-5 8h3v6l5-8h-3ZM3 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm18 4h2v6h-2V9Z"/>'
      }, props)
  }
  export function RiDeviceBatteryChargeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 19H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6.625L8.458 7H4v10h4v2Zm4.375 0 1.167-2H18V7h-4V5h5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-6.625ZM21 9h2v6h-2V9Zm-9 2h3l-5 8v-6H7l5-8v6Z"/>'
      }, props)
  }
  export function RiDeviceBatteryFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm18 4h2v6h-2V9Z"/>'
      }, props)
  }
  export function RiDeviceBatteryLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 7v10h14V7H4ZM3 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm18 4h2v6h-2V9Z"/>'
      }, props)
  }
  export function RiDeviceBatteryLowFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm2 3v8h4V8H5Zm16 1h2v6h-2V9Z"/>'
      }, props)
  }
  export function RiDeviceBatteryLowLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 7v10h14V7H4ZM3 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm2 3h4v8H5V8Zm16 1h2v6h-2V9Z"/>'
      }, props)
  }
  export function RiDeviceBatterySaverFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 2a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1h4Zm-1 7h-2v3H8v2h3v3h2v-3h3v-2h-3V9Z"/>'
      }, props)
  }
  export function RiDeviceBatterySaverLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 2a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1h4Zm-1 2h-2v2H7v14h10V6h-4V4Zm0 5v3h3v2h-3v3h-2v-3H8v-2h3V9h2Z"/>'
      }, props)
  }
  export function RiDeviceBatteryShareFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 2a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v6.2L15 8v3h-1c-2.142 0-4 1.79-4 4v3h2v-3c0-1.05.95-2 2-2h1v3l4-3.2V21a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1h4Z"/>'
      }, props)
  }
  export function RiDeviceBatteryShareLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 2a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v2h-2V6h-4V4h-2v2H7v14h10v-3h2v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V3a1 1 0 0 1 1-1h4Zm1 6 5 4-5 4v-3h-1c-1.054 0-2 .95-2 2v3h-2v-3a4 4 0 0 1 4-4h1V8Z"/>'
      }, props)
  }
  export function RiDeviceBluetoothConnectFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14.311 12 4.343 4.343L12.998 22h-2v-6.686l-4.364 4.364-1.415-1.415 5.779-5.778v-.97L5.219 5.737l1.415-1.415 4.364 4.364V2h2l5.656 5.657L14.311 12Zm-1.313 1.515v5.657l2.828-2.829-2.828-2.828Zm0-3.03 2.828-2.828-2.828-2.829v5.657ZM19.5 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-13 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiDeviceBluetoothConnectLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14.311 12 4.343 4.343L12.998 22h-2v-6.686l-4.364 4.364-1.415-1.415 5.779-5.778v-.97L5.219 5.737l1.415-1.415 4.364 4.364V2h2l5.656 5.657L14.311 12Zm-1.313 1.515v5.657l2.828-2.829-2.828-2.828Zm0-3.03 2.828-2.828-2.828-2.829v5.657ZM19.5 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-13 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiDeviceBluetoothFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14.312 12 4.343 4.343L12.998 22h-2v-6.686l-4.364 4.364-1.414-1.415 5.778-5.778v-.97L5.22 5.737l1.414-1.415 4.364 4.364V2h2l5.657 5.657L14.312 12Zm-1.314 1.515v5.657l2.828-2.829-2.828-2.828Zm0-3.03 2.828-2.828-2.828-2.829v5.657Z"/>'
      }, props)
  }
  export function RiDeviceBluetoothLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14.312 12 4.343 4.343L12.998 22h-2v-6.686l-4.364 4.364-1.414-1.415 5.778-5.778v-.97L5.22 5.737l1.414-1.415 4.364 4.364V2h2l5.657 5.657L14.312 12Zm-1.314 1.515v5.657l2.828-2.829-2.828-2.828Zm0-3.03 2.828-2.828-2.828-2.829v5.657Z"/>'
      }, props)
  }
  export function RiDeviceCastFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-6c0-.68-.052-1.348-.153-2H20V5H4v3.153A13.1 13.1 0 0 0 2 8V4a1 1 0 0 1 1-1Zm10 18h-2a9 9 0 0 0-9-9v-2c6.075 0 11 4.925 11 11Zm-4 0H7a5 5 0 0 0-5-5v-2a7 7 0 0 1 7 7Zm-4 0H2v-3a3 3 0 0 1 3 3Zm9.373-4A13.032 13.032 0 0 0 6 8.627V7h12v10h-3.627Z"/>'
      }, props)
  }
  export function RiDeviceCastLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-6c0-.68-.052-1.348-.153-2H20V5H4v3.153A13.1 13.1 0 0 0 2 8V4a1 1 0 0 1 1-1Zm10 18h-2a9 9 0 0 0-9-9v-2c6.075 0 11 4.925 11 11Zm-4 0H7a5 5 0 0 0-5-5v-2a7 7 0 0 1 7 7Zm-4 0H2v-3a3 3 0 0 1 3 3Z"/>'
      }, props)
  }
  export function RiDeviceCellphoneFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 2h11a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V0h2v2Zm0 2v5h10V4H7Z"/>'
      }, props)
  }
  export function RiDeviceCellphoneLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 2h11a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V0h2v2Zm0 7h10V4H7v5Zm0 2v9h10v-9H7Z"/>'
      }, props)
  }
  export function RiDeviceComputerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 18v2h4v2H7v-2h4v-2H2.992A.998.998 0 0 1 2 16.992V4.008C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007v12.985c0 .557-.455 1.008-.992 1.008H13Z"/>'
      }, props)
  }
  export function RiDeviceComputerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 16h16V5H4v11Zm9 2v2h4v2H7v-2h4v-2H2.992A.998.998 0 0 1 2 16.992V4.008C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007v12.985c0 .557-.455 1.008-.992 1.008H13Z"/>'
      }, props)
  }
  export function RiDeviceCpuFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 20h-4v2H8v-2H5a1 1 0 0 1-1-1v-3H2v-2h2v-4H2V8h2V5a1 1 0 0 1 1-1h3V2h2v2h4V2h2v2h3a1 1 0 0 1 1 1v3h2v2h-2v4h2v2h-2v3a1 1 0 0 1-1 1h-3v2h-2v-2ZM7 7v4h4V7H7Z"/>'
      }, props)
  }
  export function RiDeviceCpuLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 18h12V6H6v12Zm8 2h-4v2H8v-2H5a1 1 0 0 1-1-1v-3H2v-2h2v-4H2V8h2V5a1 1 0 0 1 1-1h3V2h2v2h4V2h2v2h3a1 1 0 0 1 1 1v3h2v2h-2v4h2v2h-2v3a1 1 0 0 1-1 1h-3v2h-2v-2ZM8 8h8v8H8V8Z"/>'
      }, props)
  }
  export function RiDeviceDashboard2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 3a7 7 0 0 0-5.106 11.789l.156.16 1.414-1.414a5 5 0 0 1 4.83-8.366l1.564-1.56A6.976 6.976 0 0 0 12 5Zm6.392 4.143-1.561 1.562a5.008 5.008 0 0 1-1.295 4.83l1.414 1.415A6.978 6.978 0 0 0 19 12a6.975 6.975 0 0 0-.608-2.857Zm-2.15-2.8-3.725 3.725A2.003 2.003 0 0 0 10 12a2 2 0 1 0 3.932-.517l3.725-3.726-1.414-1.414Z"/>'
      }, props)
  }
  export function RiDeviceDashboard2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 1c1.018 0 1.985.217 2.858.608L13.295 7.17a5 5 0 0 0-4.83 8.366L7.05 16.95l-.156-.161A7 7 0 0 1 12 5Zm6.392 4.143c.39.872.608 1.84.608 2.857a6.978 6.978 0 0 1-2.05 4.95l-1.414-1.414a5.008 5.008 0 0 0 1.295-4.83l1.561-1.563Zm-2.15-2.8 1.415 1.414-3.725 3.726A2.003 2.003 0 0 1 12 14a2 2 0 1 1 .517-3.932l3.726-3.725Z"/>'
      }, props)
  }
  export function RiDeviceDashboard3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm4.596 5.404a.596.596 0 0 0-.763-.067c-2.89 2.028-4.52 3.23-4.894 3.602a1.5 1.5 0 0 0 2.122 2.122c.219-.22 1.418-1.851 3.598-4.897a.59.59 0 0 0-.063-.76ZM17.5 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-11 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm2.318-3.596a1 1 0 1 0-1.414 1.414 1 1 0 0 0 1.414-1.414ZM12 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiDeviceDashboard3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm3.833 3.337a.596.596 0 0 1 .763.067.59.59 0 0 1 .063.76c-2.18 3.046-3.38 4.678-3.598 4.897a1.5 1.5 0 0 1-2.122-2.122c.374-.373 2.005-1.574 4.894-3.602ZM17.5 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-11 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm2.318-3.596a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414ZM12 5.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"/>'
      }, props)
  }
  export function RiDeviceDatabase2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 9.5v3c0 2.485-4.03 4.5-9 4.5s-9-2.015-9-4.5v-3c0 2.485 4.03 4.5 9 4.5s9-2.015 9-4.5Zm-18 5c0 2.485 4.03 4.5 9 4.5s9-2.015 9-4.5v3c0 2.485-4.03 4.5-9 4.5s-9-2.015-9-4.5v-3Zm9-2.5c-4.97 0-9-2.015-9-4.5S7.03 3 12 3s9 2.015 9 4.5-4.03 4.5-9 4.5Z"/>'
      }, props)
  }
  export function RiDeviceDatabase2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 12.5c0 .313.461.858 1.53 1.393C7.914 14.585 9.877 15 12 15c2.123 0 4.086-.415 5.47-1.107 1.069-.535 1.53-1.08 1.53-1.393v-2.171C17.35 11.349 14.827 12 12 12s-5.35-.652-7-1.671V12.5Zm14 2.829C17.35 16.349 14.827 17 12 17s-5.35-.652-7-1.671V17.5c0 .313.461.858 1.53 1.393C7.914 19.585 9.877 20 12 20c2.123 0 4.086-.415 5.47-1.107 1.069-.535 1.53-1.08 1.53-1.393v-2.171ZM3 17.5v-10C3 5.015 7.03 3 12 3s9 2.015 9 4.5v10c0 2.485-4.03 4.5-9 4.5s-9-2.015-9-4.5Zm9-7.5c2.123 0 4.086-.415 5.47-1.107C18.538 8.358 19 7.813 19 7.5c0-.313-.461-.858-1.53-1.393C16.085 5.415 14.123 5 12 5c-2.123 0-4.086.415-5.47 1.107C5.461 6.642 5 7.187 5 7.5c0 .313.461.858 1.53 1.393C7.914 9.585 9.877 10 12 10Z"/>'
      }, props)
  }
  export function RiDeviceDatabaseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 7V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h8Zm-6 9v2h5v-2H5Zm9 0v2h5v-2h-5Zm0-3v2h5v-2h-5Zm0-3v2h5v-2h-5Zm-9 3v2h5v-2H5Z"/>'
      }, props)
  }
  export function RiDeviceDatabaseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 19V9H4v10h7Zm0-12V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h8Zm2-2v14h7V5h-7ZM5 16h5v2H5v-2Zm9 0h5v2h-5v-2Zm0-3h5v2h-5v-2Zm0-3h5v2h-5v-2Zm-9 3h5v2H5v-2Z"/>'
      }, props)
  }
  export function RiDeviceDeviceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 6h-8a1 1 0 0 0-1 1v13H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3Zm-6 2h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiDeviceDeviceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v5Zm-2 0V4H5v14h7V9a1 1 0 0 1 1-1h4Zm-3 2v10h6V10h-6Z"/>'
      }, props)
  }
  export function RiDeviceDeviceRecoverFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14Zm-7 5a5 5 0 1 0 .955 9.909L12 15a3 3 0 1 1 0-6c1.598 0 3 1.34 3 3h-2.5l2.128 4.254A5 5 0 0 0 12 7Z"/>'
      }, props)
  }
  export function RiDeviceDeviceRecoverLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14Zm-1 2H6v16h12V4Zm-6 3a5 5 0 0 1 2.628 9.254L12.5 12H15a3 3 0 1 0-3 3l.955 1.909A5 5 0 1 1 12 7Z"/>'
      }, props)
  }
  export function RiDeviceDualSim1Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15 2 4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10Zm-2 6h-3v2h1v6h2V8Z"/>'
      }, props)
  }
  export function RiDeviceDualSim1Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15 2 4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10Zm-.829 2H6v16h12V7.829L14.171 4ZM13 16h-2v-6h-1V8h3v8Z"/>'
      }, props)
  }
  export function RiDeviceDualSim2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15 2 4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10Zm-3 5.5a3 3 0 0 0-2.995 2.824L9 10.5h2a1 1 0 1 1 1.751.66l-.082.083L9 14.547 9 16h6v-2h-2.405l1.412-1.27-.006-.01.008.008A3 3 0 0 0 12 7.5Z"/>'
      }, props)
  }
  export function RiDeviceDualSim2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15 2 4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h10Zm-.829 2H6v16h12V7.829L14.171 4ZM12 7.5a3 3 0 0 1 2.009 5.228l-.008-.008.006.01L12.595 14H15v2H9v-1.453l3.67-3.304A1 1 0 1 0 11 10.5H9a3 3 0 0 1 3-3Z"/>'
      }, props)
  }
  export function RiDeviceFingerprint2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 1a9 9 0 0 1 9 9v4a8.989 8.989 0 0 1-3.811 7.355c.527-1.692.811-3.49.811-5.355v-2.001h-2V16l-.003.315a15.93 15.93 0 0 1-1.431 6.315 9.055 9.055 0 0 1-3.576.314A12.925 12.925 0 0 0 13 16V9h-2v7l-.004.288c-.059 2.301-.825 4.426-2.088 6.167a8.988 8.988 0 0 1-2.625-1.503A7.962 7.962 0 0 0 8 16v-6l.005-.2c.033-.667.229-1.29.549-1.832L7.109 6.523A5.973 5.973 0 0 0 6 10v6l-.004.225a5.966 5.966 0 0 1-1.12 3.272A8.952 8.952 0 0 1 3 14v-4a9 9 0 0 1 9-9Zm0 3c-1.296 0-2.496.41-3.476 1.11l1.444 1.444A4 4 0 0 1 16 10v2h2v-2a6 6 0 0 0-6-6Z"/>'
      }, props)
  }
  export function RiDeviceFingerprint2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 1a9 9 0 0 1 9 9v4a9 9 0 0 1-12.092 8.455c.128-.177.251-.357.369-.542l.17-.28a10.918 10.918 0 0 0 1.55-5.345L11 16V9h2v7c0 1.772-.355 3.462-.997 5.002a7.028 7.028 0 0 0 2.27-.38c.442-1.36.693-2.807.724-4.308L15 16v-3.001h2V16c0 1.088-.102 2.153-.298 3.185a6.978 6.978 0 0 0 2.294-4.944L19 14v-4A7 7 0 0 0 7.808 4.394L6.383 2.968A8.962 8.962 0 0 1 12 1Zm-5 9a5 5 0 0 1 10 0v1h-2v-1a3 3 0 0 0-5.995-.176L9 10v6c0 1.567-.4 3.04-1.104 4.323l-.024.04c-.23.414-.491.808-.782 1.179a9.034 9.034 0 0 1-1.237-.97l-.308-.3A8.97 8.97 0 0 1 3 14v-4c0-2.125.736-4.078 1.968-5.617l1.426 1.425a6.966 6.966 0 0 0-1.39 3.951L5 10v4a6.97 6.97 0 0 0 1.57 4.417 6.91 6.91 0 0 0 .426-2.176L7 16v-6Z"/>'
      }, props)
  }
  export function RiDeviceFingerprintFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 13v1c0 2.77-.664 5.445-1.915 7.846l-.227.42-1.746-.974c1.16-2.08 1.81-4.41 1.881-6.836L15 14v-1h2Zm-6-3h2v4l-.005.379a12.94 12.94 0 0 1-2.691 7.549l-.231.29-1.549-1.264a10.944 10.944 0 0 0 2.47-6.588L11 14v-4Zm1-4a5 5 0 0 1 5 5h-2a3 3 0 0 0-6 0v3c0 2.235-.82 4.344-2.27 5.977l-.212.23-1.448-1.38a6.97 6.97 0 0 0 1.924-4.524L7 14v-3a5 5 0 0 1 5-5Zm0-4a9 9 0 0 1 9 9v3c0 1.698-.201 3.37-.596 4.99l-.14.539-1.93-.526c.392-1.437.614-2.922.658-4.435L19 14v-3A7 7 0 0 0 7.808 5.394L6.383 3.968A8.962 8.962 0 0 1 12 2ZM4.968 5.383l1.426 1.425a6.966 6.966 0 0 0-1.39 3.951L5 11 5.004 13c0 1.12-.264 2.203-.761 3.177l-.157.29-1.736-.992c.379-.665.6-1.407.645-2.183L3.004 13v-2a8.94 8.94 0 0 1 1.964-5.617Z"/>'
      }, props)
  }
  export function RiDeviceFingerprintLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 13v1c0 2.77-.664 5.445-1.915 7.846l-.227.42-1.746-.974c1.16-2.08 1.81-4.41 1.881-6.836L15 14v-1h2Zm-6-3h2v4l-.005.379a12.94 12.94 0 0 1-2.691 7.549l-.231.29-1.549-1.264a10.944 10.944 0 0 0 2.47-6.588L11 14v-4Zm1-4a5 5 0 0 1 5 5h-2a3 3 0 0 0-6 0v3c0 2.235-.82 4.344-2.27 5.977l-.212.23-1.448-1.38a6.97 6.97 0 0 0 1.924-4.524L7 14v-3a5 5 0 0 1 5-5Zm0-4a9 9 0 0 1 9 9v3c0 1.698-.201 3.37-.596 4.99l-.14.539-1.93-.526c.392-1.437.614-2.922.658-4.435L19 14v-3A7 7 0 0 0 7.808 5.394L6.383 3.968A8.962 8.962 0 0 1 12 2ZM4.968 5.383l1.426 1.425a6.966 6.966 0 0 0-1.39 3.951L5 11 5.004 13c0 1.12-.264 2.203-.761 3.177l-.157.29-1.736-.992c.379-.665.6-1.407.645-2.183L3.004 13v-2a8.94 8.94 0 0 1 1.964-5.617Z"/>'
      }, props)
  }
  export function RiDeviceGamepadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 4a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H7a6 6 0 0 1-6-6v-4a6 6 0 0 1 6-6h10Zm-7 5H8v2H6v2h1.999L8 15h2l-.001-2H12v-2h-2V9Zm8 4h-2v2h2v-2Zm-2-4h-2v2h2V9Z"/>'
      }, props)
  }
  export function RiDeviceGamepadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 4a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H7a6 6 0 0 1-6-6v-4a6 6 0 0 1 6-6h10Zm0 2H7a4 4 0 0 0-3.995 3.8L3 10v4a4 4 0 0 0 3.8 3.995L7 18h10a4 4 0 0 0 3.995-3.8L21 14v-4a4 4 0 0 0-3.8-3.995L17 6Zm-7 3v2h2v2H9.999L10 15H8l-.001-2H6v-2h2V9h2Zm8 4v2h-2v-2h2Zm-2-4v2h-2V9h2Z"/>'
      }, props)
  }
  export function RiDeviceGpsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 16 3 6H9l3-6Zm-2.627.255a5 5 0 1 1 5.255 0l-1.356-2.711a2 2 0 1 0-2.544 0l-1.355 2.71Zm-2.241 4.482A9.997 9.997 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.997 9.997 0 0 1-5.131 8.737l-1.344-2.688a7 7 0 1 0-7.05 0l-1.343 2.688Z"/>'
      }, props)
  }
  export function RiDeviceGpsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.132 20.737A9.997 9.997 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.997 9.997 0 0 1-5.132 8.737l-.896-1.791a8 8 0 1 0-7.945 0l-.895 1.791Zm1.792-3.584a6 6 0 1 1 6.151 0l-.898-1.797a4 4 0 1 0-4.354 0l-.899 1.797ZM12 16l3 6H9l3-6Z"/>'
      }, props)
  }
  export function RiDeviceGradienterFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10ZM8.126 11H4.062a8.079 8.079 0 0 0 0 2h4.064a4.007 4.007 0 0 1 0-2Zm7.748 0a4.01 4.01 0 0 1 0 2h4.064a8.069 8.069 0 0 0 0-2h-4.064ZM12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiDeviceGradienterLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.049 13H4.06a8.001 8.001 0 0 0 15.877 0h2.012c-.502 5.053-4.765 9-9.95 9-5.186 0-9.45-3.947-9.951-9Zm0-2c.502-5.053 4.765-9 9.95-9 5.186 0 9.45 3.947 9.951 9h-2.012A8.001 8.001 0 0 0 4.06 11H2.05Zm9.95 3a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiDeviceHardDrive2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1ZM5 16v4h14v-4H5Zm10 1h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiDeviceHardDrive2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 14h14V4H5v10Zm0 2v4h14v-4H5ZM4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm11 15h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiDeviceHardDrive3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.5 2a1 1 0 0 0-.992.876l-1.5 12A1 1 0 0 0 3 15v6a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-6c0-.041-.003-.083-.008-.124l-1.5-12A1 1 0 0 0 18.5 2h-13ZM5 16h14v4H5v-4Zm10 1h2v2h-2v-2Zm-2 0h-2v2h2v-2Z"/>'
      }, props)
  }
  export function RiDeviceHardDrive3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.508 2.876A1 1 0 0 1 5.5 2h13a1 1 0 0 1 .992.876l1.5 12c.005.041.008.083.008.124v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 .008-.124l1.5-12ZM6.383 4l-1.25 10h13.734l-1.25-10H6.383ZM19 16H5v4h14v-4Zm-4 1h2v2h-2v-2Zm-2 0h-2v2h2v-2Z"/>'
      }, props)
  }
  export function RiDeviceHardDriveFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.95 2H20a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8.05c.329.033.663.05 1 .05 5.523 0 10-4.477 10-10 0-.337-.017-.671-.05-1ZM15 16v2h2v-2h-2ZM11.938 2A8 8 0 0 1 3 10.938V3a1 1 0 0 1 1-1h7.938Z"/>'
      }, props)
  }
  export function RiDeviceHardDriveLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 10.938A8.004 8.004 0 0 0 11.938 4H5v6.938Zm0 2.013V20h14V4h-5.05A10.003 10.003 0 0 1 5 12.95ZM4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm11 14h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiDeviceHotspotFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2v9h7v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h6Zm2 5a2 2 0 0 1 2 2h-2V7Zm0-3a5 5 0 0 1 5 5h-2a3 3 0 0 0-3-3V4Zm0-3a8 8 0 0 1 8 8h-2a6 6 0 0 0-6-6V1Z"/>'
      }, props)
  }
  export function RiDeviceHotspotLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2v2H7v16h10v-9h2v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h5Zm2 5a2 2 0 0 1 2 2h-2V7Zm0-3a5 5 0 0 1 5 5h-2a3 3 0 0 0-3-3V4Zm0-3a8 8 0 0 1 8 8h-2a6 6 0 0 0-6-6V1Z"/>'
      }, props)
  }
  export function RiDeviceInstallFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2v5H8l4 4 4-4h-3V2h7a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h7Zm8 14H5v4h14v-4Zm-2 1v2h-2v-2h2Z"/>'
      }, props)
  }
  export function RiDeviceInstallLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 2v2H5l-.001 10h14L19 4h-4V2h5a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h5Zm9.999 14h-14L5 20h14l-.001-4ZM17 17v2h-2v-2h2ZM13 2v5h3l-4 4-4-4h3V2h2Z"/>'
      }, props)
  }
  export function RiDeviceInstanceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 9.5 5.5v11L12 23l-9.5-5.5v-11L12 1ZM6.499 9.97 11 12.578v5.048h2v-5.048l4.501-2.606-1.002-1.731L12 10.845 7.501 8.24 6.499 9.97Z"/>'
      }, props)
  }
  export function RiDeviceInstanceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.5 7.653v8.694l7.5 4.342 7.5-4.342V7.653L12 3.311 4.5 7.653ZM12 1l9.5 5.5v11L12 23l-9.5-5.5v-11L12 1ZM6.499 9.97 11 12.577v5.049h2v-5.049l4.501-2.605-1.002-1.731L12 10.844 7.501 8.24 6.499 9.97Z"/>'
      }, props)
  }
  export function RiDeviceKeyboardBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm2 4v2h2V7H5Zm0 4v2h2v-2H5Zm0 4v2h14v-2H5Zm4-4v2h2v-2H9Zm0-4v2h2V7H9Zm4 0v2h2V7h-2Zm4 0v2h2V7h-2Zm-4 4v2h2v-2h-2Zm4 0v2h2v-2h-2Z"/>'
      }, props)
  }
  export function RiDeviceKeyboardBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 5v14h16V5H4ZM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm3 4h2v2H6V7Zm0 4h2v2H6v-2Zm0 4h12v2H6v-2Zm5-4h2v2h-2v-2Zm0-4h2v2h-2V7Zm5 0h2v2h-2V7Zm0 4h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiDeviceKeyboardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 17h18v2H3v-2Zm0-6h3v3H3v-3Zm5 0h3v3H8v-3ZM3 5h3v3H3V5Zm10 0h3v3h-3V5Zm5 0h3v3h-3V5Zm-5 6h3v3h-3v-3Zm5 0h3v3h-3v-3ZM8 5h3v3H8V5Z"/>'
      }, props)
  }
  export function RiDeviceKeyboardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 17h18v2H3v-2Zm0-6h3v3H3v-3Zm5 0h3v3H8v-3ZM3 5h3v3H3V5Zm10 0h3v3h-3V5Zm5 0h3v3h-3V5Zm-5 6h3v3h-3v-3Zm5 0h3v3h-3v-3ZM8 5h3v3H8V5Z"/>'
      }, props)
  }
  export function RiDeviceMacFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 18v2l2 1v1H8l-.004-.996L10 20v-2H2.992A.998.998 0 0 1 2 16.992V4.008C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007v12.985c0 .557-.455 1.008-.992 1.008H14ZM4 14v2h16v-2H4Z"/>'
      }, props)
  }
  export function RiDeviceMacLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 18v2l2 1v1H8l-.004-.996L10 20v-2H2.992A.998.998 0 0 1 2 16.992V4.008C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007v12.985c0 .557-.455 1.008-.992 1.008H14ZM4 5v9h16V5H4Z"/>'
      }, props)
  }
  export function RiDeviceMacbookFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 4.007C2 3.45 2.455 3 2.992 3h18.016c.548 0 .992.45.992 1.007V17H2V4.007ZM1 19h22v2H1v-2Z"/>'
      }, props)
  }
  export function RiDeviceMacbookLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 5v11h16V5H4Zm-2-.993C2 3.451 2.455 3 2.992 3h18.016c.548 0 .992.449.992 1.007V18H2V4.007ZM1 19h22v2H1v-2Z"/>'
      }, props)
  }
  export function RiDeviceMouseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.141 2h1.718c2.014 0 3.094.278 4.071.801A5.452 5.452 0 0 1 19.2 5.07c.522.978.801 2.058.801 4.072v5.718c0 2.014-.279 3.094-.801 4.071A5.452 5.452 0 0 1 16.93 21.2c-.977.522-2.057.801-4.071.801H11.14c-2.014 0-3.094-.279-4.072-.801a5.452 5.452 0 0 1-2.268-2.269C4.278 17.953 4 16.873 4 14.86V9.14c0-2.014.278-3.094.801-4.072A5.452 5.452 0 0 1 7.07 2.801C8.047 2.278 9.127 2 11.141 2ZM11 6v5h2V6h-2Z"/>'
      }, props)
  }
  export function RiDeviceMouseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.141 4c-1.582 0-2.387.169-3.128.565a3.453 3.453 0 0 0-1.448 1.448C6.169 6.753 6 7.559 6 9.14v5.718c0 1.582.169 2.387.565 3.128.337.63.818 1.112 1.448 1.448.74.396 1.546.565 3.128.565h1.718c1.582 0 2.387-.169 3.128-.565a3.452 3.452 0 0 0 1.448-1.448c.396-.74.565-1.546.565-3.128V9.14c0-1.582-.169-2.387-.565-3.128a3.452 3.452 0 0 0-1.448-1.448C15.247 4.169 14.441 4 12.86 4H11.14Zm0-2h1.718c2.014 0 3.094.278 4.071.801A5.452 5.452 0 0 1 19.2 5.07c.522.978.801 2.058.801 4.072v5.718c0 2.014-.279 3.094-.801 4.071A5.452 5.452 0 0 1 16.93 21.2c-.977.522-2.057.801-4.071.801H11.14c-2.014 0-3.094-.279-4.072-.801a5.452 5.452 0 0 1-2.268-2.269C4.278 17.953 4 16.873 4 14.86V9.14c0-2.014.278-3.094.801-4.072A5.452 5.452 0 0 1 7.07 2.801C8.047 2.278 9.127 2 11.141 2ZM11 6h2v5h-2V6Z"/>'
      }, props)
  }
  export function RiDevicePhoneFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 16.42v3.536a1 1 0 0 1-.93.998c-.437.03-.794.046-1.07.046-8.837 0-16-7.163-16-16 0-.276.015-.633.046-1.07A1 1 0 0 1 4.044 3H7.58a.5.5 0 0 1 .498.45c.023.23.044.413.064.552A13.901 13.901 0 0 0 9.35 8.003c.095.2.033.439-.147.567l-2.158 1.542a13.047 13.047 0 0 0 6.844 6.844l1.54-2.154a.462.462 0 0 1 .573-.149 13.897 13.897 0 0 0 4 1.205c.139.02.322.041.55.064a.5.5 0 0 1 .449.498Z"/>'
      }, props)
  }
  export function RiDevicePhoneFindFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1v8.529A6 6 0 0 0 9 16c0 3.238 2.76 6 6 6H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12Zm-3 10a4 4 0 0 1 3.446 6.032l2.21 2.21-1.413 1.415-2.211-2.21A4 4 0 1 1 15 12Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>'
      }, props)
  }
  export function RiDevicePhoneFindLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1v8h-2V4H7v16h4v2H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12Zm-3 10a4 4 0 0 1 3.446 6.032l2.21 2.21-1.413 1.415-2.212-2.21A4 4 0 1 1 15 12Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>'
      }, props)
  }
  export function RiDevicePhoneLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.366 10.682a10.556 10.556 0 0 0 3.952 3.952l.884-1.238a1 1 0 0 1 1.294-.296 11.421 11.421 0 0 0 4.583 1.364 1 1 0 0 1 .921.997v4.462a1 1 0 0 1-.898.995c-.53.055-1.064.082-1.602.082C9.94 21 3 14.06 3 5.5c0-.538.027-1.072.082-1.602A1 1 0 0 1 4.077 3h4.462a1 1 0 0 1 .997.921A11.421 11.421 0 0 0 10.9 8.504a1 1 0 0 1-.296 1.294l-1.238.884Zm-2.522-.657 1.9-1.357A13.41 13.41 0 0 1 7.647 5H5.01c-.006.166-.009.333-.009.5C5 12.956 11.044 19 18.5 19c.167 0 .334-.003.5-.01v-2.637a13.41 13.41 0 0 1-3.668-1.097l-1.357 1.9a12.45 12.45 0 0 1-1.588-.75l-.058-.033a12.556 12.556 0 0 1-4.702-4.702l-.033-.058a12.441 12.441 0 0 1-.75-1.588Z"/>'
      }, props)
  }
  export function RiDevicePhoneLockFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1l.001 7.1A5.002 5.002 0 0 0 13.1 14H12v8H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12Zm0 10a3 3 0 0 1 3 3v1h1v5a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-5h1v-1a3 3 0 0 1 3-3Zm0 2c-.513 0-1 .45-1 1v1h2v-1a1 1 0 0 0-1-1Z"/>'
      }, props)
  }
  export function RiDevicePhoneLockLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1v7h-2V4H7v16h5v2H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12Zm0 10a3 3 0 0 1 3 3v1h1v5a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-5h1v-1a3 3 0 0 1 3-3Zm2 6h-4v2h4v-2Zm-2-4c-.508 0-1 .45-1 1v1h2v-1a1 1 0 0 0-1-1Z"/>'
      }, props)
  }
  export function RiDeviceQrCodeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 17v-1h-3v-3h3v2h2v2h-1v2h-2v2h-2v-3h2v-1h1Zm5 4h-4v-2h2v-2h2v4ZM3 3h8v8H3V3Zm10 0h8v8h-8V3ZM3 13h8v8H3v-8Zm15 0h3v2h-3v-2ZM6 6v2h2V6H6Zm0 10v2h2v-2H6ZM16 6v2h2V6h-2Z"/>'
      }, props)
  }
  export function RiDeviceQrCodeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 17v-1h-3v-3h3v2h2v2h-1v2h-2v2h-2v-3h2v-1h1Zm5 4h-4v-2h2v-2h2v4ZM3 3h8v8H3V3Zm2 2v4h4V5H5Zm8-2h8v8h-8V3Zm2 2v4h4V5h-4ZM3 13h8v8H3v-8Zm2 2v4h4v-4H5Zm13-2h3v2h-3v-2ZM6 6h2v2H6V6Zm0 10h2v2H6v-2ZM16 6h2v2h-2V6Z"/>'
      }, props)
  }
  export function RiDeviceQrScan2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 3h6v6h-6V3ZM9 3v6H3V3h6Zm6 18v-6h6v6h-6Zm-6 0H3v-6h6v6ZM3 11h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiDeviceQrScan2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 3h6v5h-2V5h-4V3ZM9 3v2H5v3H3V3h6Zm6 18v-2h4v-3h2v5h-6Zm-6 0H3v-5h2v3h4v2ZM3 11h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiDeviceQrScanFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 15v5.007a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 20.007V15h18ZM2 11h20v2H2v-2Zm19-2H3V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993V9Z"/>'
      }, props)
  }
  export function RiDeviceQrScanLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 16v5H3v-5h2v3h14v-3h2ZM3 11h18v2H3v-2Zm18-3h-2V5H5v3H3V3h18v5Z"/>'
      }, props)
  }
  export function RiDeviceRadarFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14.368 4.398-3.484 6.035 1.732 1 3.485-6.035c4.169 2.772 6.305 7.08 4.56 10.102-1.86 3.222-7.19 3.355-11.91.63C4.028 13.403 1.48 8.721 3.34 5.5c1.745-3.023 6.543-3.327 11.028-1.102Zm1.516-2.625 1.732 1-1.5 2.598-1.732-1 1.5-2.598ZM6.732 20H17v2H5.018a.998.998 0 0 1-1.015-.922.995.995 0 0 1 .131-.578l2.25-3.897 1.732 1L6.732 20Z"/>'
      }, props)
  }
  export function RiDeviceRadarLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.507 3.623-1.024 1.772c-2.91-.879-5.513-.45-6.41 1.105-1.178 2.04.79 5.653 4.677 7.897 3.888 2.245 8.001 2.142 9.178.103.898-1.555-.032-4.024-2.248-6.105l1.023-1.772c3.082 2.71 4.462 6.27 2.957 8.877-1.86 3.222-7.188 3.355-11.91.63C4.03 13.403 1.48 8.721 3.34 5.5c1.505-2.606 5.28-3.191 9.166-1.877Zm3.377-1.85 1.732 1-5 8.66-1.732-1 5-8.66ZM6.732 20H17v2H5.018a.998.998 0 0 1-1.015-.922.995.995 0 0 1 .131-.578l2.25-3.897 1.732 1L6.732 20Z"/>'
      }, props)
  }
  export function RiDeviceRemoteControl2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12Zm-3 13h-2v2h2v-2Zm-4 0H9v2h2v-2Zm2-9h-2v2H9v2h1.999L11 12h2l-.001-2H15V8h-2V6Z"/>'
      }, props)
  }
  export function RiDeviceRemoteControl2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h12Zm-1 2H7v16h10V4Zm-2 11v2h-2v-2h2Zm-4 0v2H9v-2h2Zm2-9v2h2v2h-2.001L13 12h-2l-.001-2H9V8h2V6h2Z"/>'
      }, props)
  }
  export function RiDeviceRemoteControlFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 12a1 1 0 0 1 1 1v9H6v-9a1 1 0 0 1 1-1h10Zm-7 2H8v2h2v-2Zm2-8a6 6 0 0 1 5.368 3.316l-1.79.895a4 4 0 0 0-7.156 0l-1.79-.895A6 6 0 0 1 12 6Zm0-4a10 10 0 0 1 8.947 5.527l-1.79.895A8 8 0 0 0 12 4a8 8 0 0 0-7.157 4.422l-1.79-.895A10 10 0 0 1 12 2Z"/>'
      }, props)
  }
  export function RiDeviceRemoteControlLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 12a1 1 0 0 1 1 1v9h-2v-8H8v8H6v-9a1 1 0 0 1 1-1h10Zm-5 4v2h-2v-2h2Zm0-10a6 6 0 0 1 5.368 3.316l-1.79.895a4 4 0 0 0-7.156 0l-1.79-.895A6 6 0 0 1 12 6Zm0-4a10 10 0 0 1 8.947 5.527l-1.79.895A8 8 0 0 0 12 4a8 8 0 0 0-7.157 4.422l-1.79-.895A10 10 0 0 1 12 2Z"/>'
      }, props)
  }
  export function RiDeviceRestartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm4.82-4.924a7 7 0 1 0-1.853 1.266l-.974-1.755A5 5 0 1 1 17 12h-3l2.82 5.076Z"/>'
      }, props)
  }
  export function RiDeviceRestartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.537 19.567A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10c0 2.136-.67 4.116-1.81 5.74L17 12h3a8 8 0 1 0-2.46 5.772l.997 1.795Z"/>'
      }, props)
  }
  export function RiDeviceRotateLockFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10 0 2.136-.67 4.116-1.811 5.741L17 12h3a8 8 0 1 0-2.46 5.772l.998 1.795A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2Zm0 5a3 3 0 0 1 3 3v1h1v5H8v-5h1v-1a3 3 0 0 1 3-3Zm0 2a1 1 0 0 0-.993.883L11 10v1h2v-1a1 1 0 0 0-.883-.993L12 9Z"/>'
      }, props)
  }
  export function RiDeviceRotateLockLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10 0 2.136-.67 4.116-1.811 5.741L17 12h3a8 8 0 1 0-2.46 5.772l.998 1.795A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2Zm0 5a3 3 0 0 1 3 3v1h1v5H8v-5h1v-1a3 3 0 0 1 3-3Zm2 6h-4v1h4v-1Zm-2-4a1 1 0 0 0-.993.883L11 10v1h2v-1a1 1 0 0 0-.883-.993L12 9Z"/>'
      }, props)
  }
  export function RiDeviceRouterFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 14v-3h2v3h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h5ZM2.51 8.837C3.835 4.864 7.584 2 12 2c4.418 0 8.166 2.864 9.49 6.837l-1.898.632a8.004 8.004 0 0 0-15.183 0L2.51 8.837Zm3.796 1.265a6.003 6.003 0 0 1 11.388 0l-1.898.633a4.002 4.002 0 0 0-7.592 0l-1.898-.633Z"/>'
      }, props)
  }
  export function RiDeviceRouterLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 14v-3h2v3h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h5ZM2.51 8.837C3.835 4.864 7.584 2 12 2c4.418 0 8.166 2.864 9.49 6.837l-1.898.632a8.004 8.004 0 0 0-15.183 0L2.51 8.837Zm3.796 1.265a6.003 6.003 0 0 1 11.388 0l-1.898.633a4.002 4.002 0 0 0-7.592 0l-1.898-.633ZM7 16v4h10v-4H7Z"/>'
      }, props)
  }
  export function RiDeviceRssFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3c9.941 0 18 8.059 18 18h-3c0-8.284-6.716-15-15-15V3Zm0 7c6.075 0 11 4.925 11 11h-3a8 8 0 0 0-8-8v-3Zm0 7a4 4 0 0 1 4 4H3v-4Z"/>'
      }, props)
  }
  export function RiDeviceRssLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 17a4 4 0 0 1 4 4H3v-4Zm0-7c6.075 0 11 4.925 11 11h-2a9 9 0 0 0-9-9v-2Zm0-7c9.941 0 18 8.059 18 18h-2c0-8.837-7.163-16-16-16V3Z"/>'
      }, props)
  }
  export function RiDeviceSave2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h13l3.707 3.707a1 1 0 0 1 .293.707V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm8 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM5 5v4h10V5H5Z"/>'
      }, props)
  }
  export function RiDeviceSave2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 5v14h14V7.828L16.172 5H5ZM4 3h13l3.707 3.707a1 1 0 0 1 .293.707V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm8 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6ZM6 6h9v4H6V6Z"/>'
      }, props)
  }
  export function RiDeviceSave3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h14l2.707 2.707a1 1 0 0 1 .293.707V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm3 1v5h9V4H7Zm-1 8v7h12v-7H6Zm7-7h2v3h-2V5Z"/>'
      }, props)
  }
  export function RiDeviceSave3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 19h1V6.828L17.172 5H16v4H7V5H5v14h1v-7h12v7ZM4 3h14l2.707 2.707a1 1 0 0 1 .293.707V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm4 11v5h8v-5H8Z"/>'
      }, props)
  }
  export function RiDeviceSaveFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 21v-8H6v8H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h13l4 4v13a1 1 0 0 1-1 1h-2Zm-2 0H8v-6h8v6Z"/>'
      }, props)
  }
  export function RiDeviceSaveLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 19v-6h10v6h2V7.828L16.172 5H5v14h2ZM4 3h13l4 4v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm5 12v4h6v-4H9Z"/>'
      }, props)
  }
  export function RiDeviceScan2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4.257 5.671 2.137 2.137a7 7 0 1 0 1.414-1.414L5.67 4.257A9.959 9.959 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-2.401.846-4.605 2.257-6.329Zm3.571 3.572L12 13.414 13.414 12 9.243 7.828a5 5 0 1 1-1.414 1.414Z"/>'
      }, props)
  }
  export function RiDeviceScan2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.671 4.257 13.414 12 12 13.414 8.554 9.968a4 4 0 1 0 3.696-1.96l-1.804-1.805a6 6 0 1 1-3.337 2.32L5.68 7.094a8 8 0 1 0 3.196-2.461L7.374 3.132A9.957 9.957 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12a9.98 9.98 0 0 1 3.671-7.743Z"/>'
      }, props)
  }
  export function RiDeviceScanFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.257 5.671 12 13.414 13.414 12 5.671 4.257A9.959 9.959 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-2.401.846-4.605 2.257-6.329Z"/>'
      }, props)
  }
  export function RiDeviceScanLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.671 4.257 13.414 12 12 13.414l-6.32-6.32a8 8 0 1 0 3.706-2.658L7.85 2.9A9.963 9.963 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12a9.98 9.98 0 0 1 3.671-7.743Z"/>'
      }, props)
  }
  export function RiDeviceSdCardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.293 6.707 9 2h10a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.414a1 1 0 0 1 .293-.707ZM15 5v4h2V5h-2Zm-3 0v4h2V5h-2ZM9 5v4h2V5H9Z"/>'
      }, props)
  }
  export function RiDeviceSdCardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 7.828V20h12V4H9.828L6 7.828Zm-1.707-1.12L9 2h10a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.414a1 1 0 0 1 .293-.707ZM15 5h2v4h-2V5Zm-3 0h2v4h-2V5ZM9 6h2v3H9V6Z"/>'
      }, props)
  }
  export function RiDeviceSdCardMiniFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8.58a1 1 0 0 1 .292-.707l1.562-1.567A.5.5 0 0 0 6 9.793V3a1 1 0 0 1 1-1Zm8 2v4h2V4h-2Zm-3 0v4h2V4h-2ZM9 4v4h2V4H9Z"/>'
      }, props)
  }
  export function RiDeviceSdCardMiniLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 4v5.793a2.5 2.5 0 0 1-.73 1.765L6 12.833V20h12V4H8ZM7 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8.58a1 1 0 0 1 .292-.707l1.562-1.567A.5.5 0 0 0 6 9.793V3a1 1 0 0 1 1-1Zm8 3h2v4h-2V5Zm-3 0h2v4h-2V5ZM9 5h2v4H9V5Z"/>'
      }, props)
  }
  export function RiDeviceSensorFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 8v2h12V8h-3V2h2v4h5v2h-2v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V2h2v6H6Zm7-6v6h-2V2h2Z"/>'
      }, props)
  }
  export function RiDeviceSensorLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 8v11h12V8h-3V2h2v4h5v2h-2v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V2h2v6H6Zm7-6v6h-2V2h2Z"/>'
      }, props)
  }
  export function RiDeviceServerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v7H3V4a1 1 0 0 1 1-1ZM3 13h18v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-7Zm4 3v2h3v-2H7ZM7 6v2h3V6H7Z"/>'
      }, props)
  }
  export function RiDeviceServerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 11h14V5H5v6Zm16-7v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1Zm-2 9H5v6h14v-6ZM7 15h3v2H7v-2Zm0-8h3v2H7V7Z"/>'
      }, props)
  }
  export function RiDeviceShutDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2.05V12h2V2.05c5.053.501 9 4.765 9 9.95 0 5.523-4.477 10-10 10S2 17.523 2 12c0-5.185 3.947-9.449 9-9.95Z"/>'
      }, props)
  }
  export function RiDeviceShutDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m6.265 3.807 1.147 1.639a8 8 0 1 0 9.176 0l1.147-1.639A9.988 9.988 0 0 1 22 12c0 5.523-4.477 10-10 10S2 17.523 2 12a9.988 9.988 0 0 1 4.265-8.193ZM11 12V2h2v10h-2Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifi1Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 3c4.284 0 8.22 1.497 11.31 3.996L12 21 .691 6.997A17.925 17.925 0 0 1 12 3Zm0 2c-3.028 0-5.923.842-8.42 2.392l5.108 6.324A7.971 7.971 0 0 1 12.001 13c1.181 0 2.303.256 3.312.716L20.42 7.39A15.921 15.921 0 0 0 12 5Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifi1Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 3c4.284 0 8.22 1.497 11.31 3.996L12 21 .691 6.997A17.925 17.925 0 0 1 12 3Zm0 12c-.693 0-1.367.117-2 .34l2 2.477 2-2.477a6.066 6.066 0 0 0-2-.34Zm0-10c-3.028 0-5.923.842-8.42 2.392l5.108 6.324A7.971 7.971 0 0 1 12.001 13c1.181 0 2.303.256 3.312.716L20.42 7.39A15.921 15.921 0 0 0 12 5Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifi2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 3c4.284 0 8.22 1.497 11.31 3.996L12 21 .691 6.997A17.925 17.925 0 0 1 12 3Zm0 2c-3.028 0-5.923.842-8.42 2.392l3.178 3.935A10.95 10.95 0 0 1 12.001 10c1.898 0 3.683.48 5.242 1.327L20.42 7.39A15.921 15.921 0 0 0 12 5Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifi2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 3c4.284 0 8.22 1.497 11.31 3.996L12 21 .691 6.997A17.925 17.925 0 0 1 12 3Zm0 9c-1.42 0-2.764.33-3.959.915l3.959 4.902 3.958-4.902A8.963 8.963 0 0 0 12.001 12Zm0-7c-3.028 0-5.923.842-8.42 2.392l3.178 3.935A10.95 10.95 0 0 1 12.001 10c1.898 0 3.683.48 5.242 1.327L20.42 7.39A15.921 15.921 0 0 0 12 5Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifi3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 3c4.284 0 8.22 1.497 11.31 3.996L12 21 .691 6.997A17.925 17.925 0 0 1 12 3Zm0 2c-3.028 0-5.923.842-8.42 2.392l1.904 2.357A12.94 12.94 0 0 1 12 8c2.375 0 4.6.637 6.516 1.749l1.904-2.358A15.921 15.921 0 0 0 12 5Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifi3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 3c4.284 0 8.22 1.497 11.31 3.996L12 21 .691 6.997A17.925 17.925 0 0 1 12 3Zm0 7c-1.898 0-3.683.48-5.241 1.327l5.24 6.49 5.242-6.49A10.95 10.95 0 0 0 12.001 10Zm0-5c-3.028 0-5.923.842-8.42 2.392l1.904 2.357A12.94 12.94 0 0 1 12 8c2.375 0 4.6.637 6.516 1.749l1.904-2.358A15.921 15.921 0 0 0 12 5Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifiErrorFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 3c4.284 0 8.22 1.497 11.31 3.996L22.499 8h-4.498v5.571L12 21 .691 6.997A17.925 17.925 0 0 1 12 3Zm10 16v2h-2v-2h2Zm0-9v7h-2v-7h2Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifiErrorLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 3c4.284 0 8.22 1.497 11.31 3.996l-1.257 1.556A15.933 15.933 0 0 0 12.001 5c-3.089 0-5.973.875-8.419 2.392l8.419 10.425 6-7.429v3.183L12 21 .691 6.997A17.925 17.925 0 0 1 12 3Zm10 16v2h-2v-2h2Zm0-9v7h-2v-7h2Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifiFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 3c4.284 0 8.22 1.497 11.31 3.996L12 21 .691 6.997A17.925 17.925 0 0 1 12 3Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifiLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 3c4.284 0 8.22 1.497 11.31 3.996L12 21 .691 6.997A17.925 17.925 0 0 1 12 3Zm0 2c-3.028 0-5.923.842-8.42 2.392L12 17.817 20.42 7.39A15.921 15.921 0 0 0 12 5Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifiOffFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.809 1.394 20.486 19.07l-1.414 1.414-3.683-3.682L12.001 21 .691 6.997c.914-.74 1.902-1.391 2.95-1.942L1.395 2.808 2.81 1.394ZM12 3c4.284 0 8.22 1.497 11.31 3.996l-5.407 6.693L7.726 3.511c1.37-.334 2.802-.51 4.275-.51Z"/>'
      }, props)
  }
  export function RiDeviceSignalWifiOffLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.809 1.394 20.486 19.07l-1.414 1.414-3.683-3.681L12.001 21 .691 6.997c.914-.74 1.902-1.391 2.95-1.942L1.395 2.808 2.81 1.394Zm.771 5.998L12 17.817l1.967-2.436-8.835-8.836c-.532.253-1.05.536-1.552.847ZM12.001 3c4.284 0 8.22 1.497 11.31 3.996l-5.407 6.693-1.422-1.422 3.939-4.876A15.921 15.921 0 0 0 12 5.001c-.873 0-1.735.07-2.58.206L7.727 3.51c1.37-.334 2.802-.51 4.275-.51Z"/>'
      }, props)
  }
  export function RiDeviceSimCard2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 2h10l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm8 16v-8H8v2h3v6h2Zm-5-5v2h2v-2H8Zm6 0v2h2v-2h-2Zm0-3v2h2v-2h-2Zm-6 6v2h2v-2H8Zm6 0v2h2v-2h-2Z"/>'
      }, props)
  }
  export function RiDeviceSimCard2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 4v16h12V7.828L14.172 4H6ZM5 2h10l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm8 8v8h-2v-6H8v-2h5Zm-5 3h2v2H8v-2Zm6 0h2v2h-2v-2Zm0-3h2v2h-2v-2Zm-6 6h2v2H8v-2Zm6 0h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiDeviceSimCardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 2h10l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm3 10v6h8v-6H8Z"/>'
      }, props)
  }
  export function RiDeviceSimCardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 4v16h12V7.828L14.172 4H6ZM5 2h10l4.707 4.707a1 1 0 0 1 .293.707V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm3 10h8v6H8v-6Z"/>'
      }, props)
  }
  export function RiDeviceSmartphoneFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm6 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiDeviceSmartphoneLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 4v16h10V4H7ZM6 2h12a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm6 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"/>'
      }, props)
  }
  export function RiDeviceTabletFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm7 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiDeviceTabletLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 4v16h12V4H6ZM5 2h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm7 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"/>'
      }, props)
  }
  export function RiDeviceTv2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 4c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 18V4Zm3 16h14v2H5v-2Z"/>'
      }, props)
  }
  export function RiDeviceTv2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 4c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 18V4Zm2 1v12h16V5H4Zm1 15h14v2H5v-2Z"/>'
      }, props)
  }
  export function RiDeviceTvFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.414 5h5.594c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 20V6c0-.552.455-1 .992-1h5.594L6.05 2.465 7.464 1.05 11.414 5h1.172l3.95-3.95 1.414 1.415L15.414 5Z"/>'
      }, props)
  }
  export function RiDeviceTvLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.414 5h5.594c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 20V6c0-.552.455-1 .992-1h5.594L6.05 2.465 7.464 1.05 11.414 5h1.172l3.95-3.95 1.414 1.415L15.414 5ZM4 7v12h16V7H4Z"/>'
      }, props)
  }
  export function RiDeviceUDiskFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 12h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1ZM5 2h14v8H5V2Zm4 3v2h2V5H9Zm4 0v2h2V5h-2Z"/>'
      }, props)
  }
  export function RiDeviceUDiskLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 12H5v8h14v-8ZM5 10V2h14v8h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1Zm2 0h10V4H7v6Zm2-4h2v2H9V6Zm4 0h2v2h-2V6Z"/>'
      }, props)
  }
  export function RiDeviceUninstallFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16Zm-1 14H5v4h14v-4Zm-2 1v2h-2v-2h2ZM12 2 8 6h3v5h2V6h3l-4-4Z"/>'
      }, props)
  }
  export function RiDeviceUninstallLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 2v2H5l-.001 10h14L19 4h-3V2h4a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4Zm10.999 14h-14L5 20h14l-.001-4ZM17 17v2h-2v-2h2ZM12 2l4 4h-3v5h-2V6H8l4-4Z"/>'
      }, props)
  }
  export function RiDeviceUsbFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 3 5h-2v7.381l3-1.499-.001-.882H15V7h4v4h-1.001L18 13.118l-5 2.5v1.553A3.001 3.001 0 0 1 12 23a3 3 0 0 1-1.31-5.7L6 14l-.001-2.268a2 2 0 1 1 2.001 0V13l3 2.086V6H9l3-5Z"/>'
      }, props)
  }
  export function RiDeviceUsbLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 3 5h-2v7.381l3-1.499-.001-.882H15V7h4v4h-1.001L18 13.118l-5 2.5v1.553A3.001 3.001 0 0 1 12 23a3 3 0 0 1-1.31-5.7L6 14l-.001-2.268a2 2 0 1 1 2.001 0V13l3 2.086V6H9l3-5Zm0 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiDeviceWifiFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M.69 6.997A17.925 17.925 0 0 1 12 3c4.285 0 8.22 1.497 11.31 3.997L21.425 9.33A14.938 14.938 0 0 0 12 6C8.43 6 5.15 7.248 2.575 9.33L.689 6.997Zm3.141 3.89A12.946 12.946 0 0 1 12 8c3.094 0 5.936 1.081 8.169 2.886l-1.886 2.334A9.958 9.958 0 0 0 12 11c-2.38 0-4.567.832-6.284 2.22l-1.885-2.334Zm3.142 3.89A7.966 7.966 0 0 1 12 13c1.904 0 3.653.665 5.027 1.776l-1.885 2.334A4.979 4.979 0 0 0 12 16c-1.19 0-2.283.416-3.142 1.11l-1.885-2.334Zm3.142 3.89A2.988 2.988 0 0 1 12 18c.714 0 1.37.25 1.885.666L12 21l-1.885-2.334Z"/>'
      }, props)
  }
  export function RiDeviceWifiLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M.69 6.997A17.925 17.925 0 0 1 12 3c4.285 0 8.22 1.497 11.31 3.997l-1.256 1.556A15.933 15.933 0 0 0 12 5C8.19 5 4.694 6.33 1.946 8.553L.69 6.997Zm3.141 3.89A12.946 12.946 0 0 1 12 8c3.094 0 5.936 1.081 8.169 2.886l-1.257 1.556A10.954 10.954 0 0 0 12 10c-2.618 0-5.023.915-6.912 2.442l-1.257-1.556Zm3.142 3.89A7.966 7.966 0 0 1 12 13c1.904 0 3.653.665 5.027 1.776l-1.257 1.556A5.975 5.975 0 0 0 12 15c-1.428 0-2.74.499-3.77 1.332l-1.257-1.556Zm3.142 3.89A2.988 2.988 0 0 1 12 18c.714 0 1.37.25 1.885.666L12 21l-1.885-2.334Z"/>'
      }, props)
  }
  export function RiDeviceWifiOffFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 18c.714 0 1.37.25 1.886.667L12 21l-1.886-2.333A2.988 2.988 0 0 1 12 18ZM2.808 1.394 20.485 19.07l-1.414 1.414-3.682-3.68-.246.306A4.98 4.98 0 0 0 12 16 4.98 4.98 0 0 0 8.86 17.11l-1.885-2.334a7.963 7.963 0 0 1 4.622-1.766l-1.773-1.772a9.962 9.962 0 0 0-4.106 1.982L3.83 10.887A12.985 12.985 0 0 1 7.416 8.83L5.885 7.3a15 15 0 0 0-3.31 2.032L.689 6.997c.915-.74 1.903-1.391 2.952-1.942L1.393 2.808l1.415-1.414ZM16.084 11.87l-3.867-3.867L12 8c3.095 0 5.937 1.082 8.17 2.887l-1.886 2.334a10.005 10.005 0 0 0-2.2-1.351ZM12 3c4.285 0 8.22 1.497 11.31 3.997l-1.885 2.334A14.937 14.937 0 0 0 12 6c-.572 0-1.136.031-1.69.093L7.724 3.511c1.37-.334 2.802-.51 4.275-.51Z"/>'
      }, props)
  }
  export function RiDeviceWifiOffLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 18c.714 0 1.37.25 1.886.667L12 21l-1.886-2.333A2.988 2.988 0 0 1 12 18ZM2.808 1.394 20.485 19.07l-1.414 1.414-5.18-5.18a5.995 5.995 0 0 0-1.89-.305c-1.43 0-2.74.5-3.771 1.332l-1.256-1.556a7.963 7.963 0 0 1 4.622-1.766L9 10.414a10.967 10.967 0 0 0-3.912 2.029L3.83 10.887A12.985 12.985 0 0 1 7.416 8.83L5.132 6.545a16.01 16.01 0 0 0-3.185 2.007L.689 6.997c.915-.74 1.903-1.391 2.952-1.942L1.393 2.808l1.415-1.414ZM14.5 10.286l-2.284-2.283L12 8c3.095 0 5.937 1.082 8.17 2.887l-1.258 1.556a10.96 10.96 0 0 0-4.412-2.157ZM12 3c4.285 0 8.22 1.497 11.31 3.997l-1.257 1.555A15.933 15.933 0 0 0 12 5c-.878 0-1.74.07-2.58.207L7.726 3.511c1.37-.334 2.802-.51 4.275-.51Z"/>'
      }, props)
  }
  export function RiDeviceWirelessChargingFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3.929 4.929 1.414 1.414A7.975 7.975 0 0 0 3 12c0 2.209.895 4.209 2.343 5.657L3.93 19.07A9.969 9.969 0 0 1 1 12a9.969 9.969 0 0 1 2.929-7.071Zm16.142 0A9.968 9.968 0 0 1 23 11.999a9.969 9.969 0 0 1-2.929 7.072l-1.414-1.414A7.975 7.975 0 0 0 21 12a7.975 7.975 0 0 0-2.342-5.656l1.413-1.415ZM13 4.999v6h3l-5 8v-6H8l5-8ZM6.757 7.758l1.415 1.414A3.988 3.988 0 0 0 7 12c0 1.104.448 2.104 1.172 2.828l-1.415 1.415A5.981 5.981 0 0 1 5 12c0-1.657.672-3.157 1.757-4.243Zm10.487.001A5.981 5.981 0 0 1 19 12a5.981 5.981 0 0 1-1.757 4.242l-1.415-1.414A3.988 3.988 0 0 0 17 12a3.987 3.987 0 0 0-1.17-2.828l1.414-1.414Z"/>'
      }, props)
  }
  export function RiDeviceWirelessChargingLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3.929 4.929 1.414 1.414A7.975 7.975 0 0 0 3 12c0 2.209.895 4.209 2.343 5.657L3.93 19.07A9.969 9.969 0 0 1 1 12a9.969 9.969 0 0 1 2.929-7.071Zm16.142 0A9.968 9.968 0 0 1 23 11.999a9.969 9.969 0 0 1-2.929 7.072l-1.414-1.414A7.975 7.975 0 0 0 21 12a7.975 7.975 0 0 0-2.342-5.656l1.413-1.415ZM13 4.999v6h3l-5 8v-6H8l5-8ZM6.757 7.758l1.415 1.414A3.988 3.988 0 0 0 7 12c0 1.104.448 2.104 1.172 2.828l-1.415 1.415A5.981 5.981 0 0 1 5 12c0-1.657.672-3.157 1.757-4.243Zm10.487.001A5.981 5.981 0 0 1 19 12a5.981 5.981 0 0 1-1.757 4.242l-1.415-1.414A3.988 3.988 0 0 0 17 12a3.987 3.987 0 0 0-1.17-2.828l1.414-1.414Z"/>'
      }, props)
  }
  export function RiDocumentArticleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1ZM7 6v4h4V6H7Zm0 6v2h10v-2H7Zm0 4v2h10v-2H7Zm6-9v2h4V7h-4Z"/>'
      }, props)
  }
  export function RiDocumentArticleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1Zm-1-2V4H5v16h14ZM7 6h4v4H7V6Zm0 6h10v2H7v-2Zm0 4h10v2H7v-2Zm6-9h4v2h-4V7Z"/>'
      }, props)
  }
  export function RiDocumentBillFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1ZM8 9v2h8V9H8Zm0 4v2h8v-2H8Z"/>'
      }, props)
  }
  export function RiDocumentBillLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1Zm-1-2V4H5v16h14ZM8 9h8v2H8V9Zm0 4h8v2H8v-2Z"/>'
      }, props)
  }
  export function RiDocumentBook2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 18H6a1 1 0 1 0 0 2h15v2H6a3 3 0 0 1-3-3V4a2 2 0 0 1 2-2h16v16Zm-5-9V7H8v2h8Z"/>'
      }, props)
  }
  export function RiDocumentBook2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 18H6a1 1 0 1 0 0 2h15v2H6a3 3 0 0 1-3-3V4a2 2 0 0 1 2-2h16v16ZM5 16.05c.162-.033.329-.05.5-.05H19V4H5v12.05ZM16 9H8V7h8v2Z"/>'
      }, props)
  }
  export function RiDocumentBook3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 4H7a2 2 0 1 0 0 4h14v13a1 1 0 0 1-1 1H7a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h13a1 1 0 0 1 1 1v1Zm-1 3H7a1 1 0 0 1 0-2h13v2Z"/>'
      }, props)
  }
  export function RiDocumentBook3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 4H7a2 2 0 1 0 0 4h14v13a1 1 0 0 1-1 1H7a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h13a1 1 0 0 1 1 1v1ZM5 18a2 2 0 0 0 2 2h12V10H7a3.982 3.982 0 0 1-2-.535V18ZM20 7H7a1 1 0 0 1 0-2h13v2Z"/>'
      }, props)
  }
  export function RiDocumentBookFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H6.5A3.5 3.5 0 0 1 3 18.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1Zm-1-2v-3H6.5a1.5 1.5 0 0 0 0 3H19Z"/>'
      }, props)
  }
  export function RiDocumentBookLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 18.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5A3.5 3.5 0 0 1 3 18.5ZM19 20v-3H6.5a1.5 1.5 0 0 0 0 3H19ZM5 15.337A3.486 3.486 0 0 1 6.5 15H19V4H6a1 1 0 0 0-1 1v10.337Z"/>'
      }, props)
  }
  export function RiDocumentBookMarkFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H6.5A3.5 3.5 0 0 1 3 18.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1Zm-1-2v-3H6.5a1.5 1.5 0 0 0 0 3H19ZM10 4v8l3.5-2 3.5 2V4h-7Z"/>'
      }, props)
  }
  export function RiDocumentBookMarkLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 18.5V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5A3.5 3.5 0 0 1 3 18.5ZM19 20v-3H6.5a1.5 1.5 0 0 0 0 3H19ZM10 4H6a1 1 0 0 0-1 1v10.337A3.486 3.486 0 0 1 6.5 15H19V4h-2v8l-3.5-2-3.5 2V4Z"/>'
      }, props)
  }
  export function RiDocumentBookOpenFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 21h-8V6a3 3 0 0 1 3-3h5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1Zm-10 0H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a3 3 0 0 1 3 3v15Zm0 0h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiDocumentBookOpenLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 21v2h-2v-2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a3.99 3.99 0 0 1 3 1.354A3.99 3.99 0 0 1 15 3h6a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-8Zm7-2V5h-5a2 2 0 0 0-2 2v12h7Zm-9 0V7a2 2 0 0 0-2-2H4v14h7Z"/>'
      }, props)
  }
  export function RiDocumentBookReadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993ZM12 5v14h8V5h-8Zm1 2h6v2h-6V7Zm0 3h6v2h-6v-2Z"/>'
      }, props)
  }
  export function RiDocumentBookReadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993ZM11 5H4v14h7V5Zm2 0v14h7V5h-7Zm1 2h5v2h-5V7Zm0 3h5v2h-5v-2Z"/>'
      }, props)
  }
  export function RiDocumentBookletFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 2v20H4v-4H2v-2h2v-3H2v-2h2V8H2V6h2V2h4Zm12.005 0C21.107 2 22 2.898 22 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H10V2h10.005Z"/>'
      }, props)
  }
  export function RiDocumentBookletLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.005 2C21.107 2 22 2.898 22 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H4v-4H2v-2h2v-3H2v-2h2V8H2V6h2V2h16.005ZM8 4H6v16h2V4Zm12 0H10v16h10V4Z"/>'
      }, props)
  }
  export function RiDocumentClipboardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 4v4h12V4h2.007c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 21.007V4.993C3 4.445 3.445 4 3.993 4H6Zm2-2h8v4H8V2Z"/>'
      }, props)
  }
  export function RiDocumentClipboardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 4V2h10v2h3.007c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 21.007V4.993C3 4.445 3.445 4 3.993 4H7Zm0 2H5v14h14V6h-2v2H7V6Zm2-2v2h6V4H9Z"/>'
      }, props)
  }
  export function RiDocumentContactsBook2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1Zm-1-2v-2H6a1 1 0 1 0 0 2h13Zm-7-10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-3 4h6a3 3 0 1 0-6 0Z"/>'
      }, props)
  }
  export function RiDocumentContactsBook2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1Zm-1-2v-2H6a1 1 0 1 0 0 2h13ZM5 16.17c.313-.11.65-.17 1-.17h13V4H6a1 1 0 0 0-1 1v11.17ZM12 10a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-3 4a3 3 0 1 1 6 0H9Z"/>'
      }, props)
  }
  export function RiDocumentContactsBookFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 2v20H3V2h4Zm2 0h10.005C20.107 2 21 2.898 21 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H9V2Zm13 4h2v4h-2V6Zm0 6h2v4h-2v-4Zm-7 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-3 4h6a3 3 0 1 0-6 0Z"/>'
      }, props)
  }
  export function RiDocumentContactsBookLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 2h16.005C20.107 2 21 2.898 21 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H3V2Zm4 2H5v16h2V4Zm2 16h10V4H9v16Zm2-4a3 3 0 1 1 6 0h-6Zm3-4a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm8-6h2v4h-2V6Zm0 6h2v4h-2v-4Z"/>'
      }, props)
  }
  export function RiDocumentContactsBookUploadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 2v20H3V2h4Zm12.005 0C20.107 2 21 2.898 21 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H9V2h10.005ZM15 8l-4 4h3v4h2v-4h3l-4-4Zm9 4v4h-2v-4h2Zm0-6v4h-2V6h2Z"/>'
      }, props)
  }
  export function RiDocumentContactsBookUploadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.005 2C20.107 2 21 2.898 21 3.99v16.02c0 1.099-.893 1.99-1.995 1.99H3V2h16.005ZM7 4H5v16h2V4Zm12 0H9v16h10V4Zm-5 4 4 4h-3v4h-2v-4h-3l4-4Zm10 4v4h-2v-4h2Zm0-6v4h-2V6h2Z"/>'
      }, props)
  }
  export function RiDocumentDraftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v3.757l-8.999 9-.006 4.238 4.246.006L21 15.242V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16Zm1.778 6.808 1.414 1.414L15.414 18l-1.416-.002.002-1.412 7.778-7.778ZM12 12H7v2h5v-2Zm3-4H7v2h8V8Z"/>'
      }, props)
  }
  export function RiDocumentDraftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v3.757l-2 2V4H5v16h14v-2.758l2-2V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16Zm1.778 6.808 1.414 1.414L15.414 18l-1.416-.002.002-1.412 7.778-7.778ZM13 12v2H8v-2h5Zm3-4v2H8V8h8Z"/>'
      }, props)
  }
  export function RiDocumentFile2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 9h6a1 1 0 0 0 1-1V2h10.002c.551 0 .998.455.998.992v18.016a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.992V9Zm0-2 5-4.997V7H3Z"/>'
      }, props)
  }
  export function RiDocumentFile2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3 8 6.003-6h10.995C20.55 2 21 2.455 21 2.992v18.016a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.993V8Zm7-4v5H5v11h14V4h-9Z"/>'
      }, props)
  }
  export function RiDocumentFile3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 9v11.992A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.447 2 3.998 2H14v6a1 1 0 0 0 1 1h6Zm0-2h-5V2.003L21 7Z"/>'
      }, props)
  }
  export function RiDocumentFile3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 8v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8Zm-2 1h-5V4H5v16h14V9Z"/>'
      }, props)
  }
  export function RiDocumentFile4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 15h-7v7H3.998C3.447 22 3 21.545 3 21.008V2.992C3 2.444 3.445 2 3.993 2h16.014A1 1 0 0 1 21 3.007V15Zm0 2-5 4.997V17h5Z"/>'
      }, props)
  }
  export function RiDocumentFile4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m21 16-6.003 6H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v13Zm-2-1V4H5v16h9v-5h5Z"/>'
      }, props)
  }
  export function RiDocumentFileAddFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-5 9H8v2h3v3h2v-3h3v-2h-3V8h-2v3Z"/>'
      }, props)
  }
  export function RiDocumentFileAddLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992ZM11 11V8h2v3h3v2h-3v3h-2v-3H8v-2h3Z"/>'
      }, props)
  }
  export function RiDocumentFileChart2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-4 6a4 4 0 1 0 4 4h-4V8Z"/>'
      }, props)
  }
  export function RiDocumentFileChart2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992ZM12 8v4h4a4 4 0 1 1-4-4Z"/>'
      }, props)
  }
  export function RiDocumentFileChartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-5 5v10h2V7h-2Zm4 4v6h2v-6h-2Zm-8 2v4h2v-4H7Z"/>'
      }, props)
  }
  export function RiDocumentFileChartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 7h2v10h-2V7Zm4 4h2v6h-2v-6Zm-8 2h2v4H7v-4Zm8-9H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z"/>'
      }, props)
  }
  export function RiDocumentFileCloudFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.997 2 21 8l.001 4.26A5.466 5.466 0 0 0 17.5 11l-.221.004a5.503 5.503 0 0 0-5.127 4.205l-.016.074-.03.02A4.75 4.75 0 0 0 10.878 22L3.993 22a.993.993 0 0 1-.986-.876L3 21.008V2.992c0-.498.387-.927.885-.985L4.002 2h10.995ZM17.5 13a3.5 3.5 0 0 1 3.5 3.5l-.002.103a2.75 2.75 0 0 1-.58 5.392L20.25 22h-5.5l-.168-.005a2.75 2.75 0 0 1-.579-5.393L14 16.5a3.5 3.5 0 0 1 3.5-3.5Z"/>'
      }, props)
  }
  export function RiDocumentFileCloudLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.997 2 21 8l.001 4.26a5.472 5.472 0 0 0-2-1.053L19 9h-5V4H5v16h5.06a4.73 4.73 0 0 0 .817 2H3.993a.993.993 0 0 1-.986-.876L3 21.008V2.992c0-.498.387-.927.885-.985L4.002 2h10.995ZM17.5 13a3.5 3.5 0 0 1 3.5 3.5l-.002.103a2.75 2.75 0 0 1-.58 5.392L20.25 22h-5.5l-.168-.005a2.75 2.75 0 0 1-.579-5.393L14 16.5a3.5 3.5 0 0 1 3.5-3.5Zm0 2a1.5 1.5 0 0 0-1.473 1.215l-.02.14L16 16.5v1.62l-1.444.406a.75.75 0 0 0 .08 1.465l.109.01h5.51a.75.75 0 0 0 .19-1.475l-1.013-.283L19 18.12V16.5l-.007-.145A1.5 1.5 0 0 0 17.5 15Z"/>'
      }, props)
  }
  export function RiDocumentFileCodeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm1.657 10L14.12 8.464 12.707 9.88 14.828 12l-2.12 2.121 1.413 1.415L17.657 12ZM6.343 12l3.536 3.536 1.414-1.415L9.172 12l2.12-2.121L9.88 8.464 6.343 12Z"/>'
      }, props)
  }
  export function RiDocumentFileCodeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992ZM17.657 12l-3.536 3.536-1.414-1.415L14.828 12l-2.12-2.121 1.413-1.415L17.657 12ZM6.343 12 9.88 8.464l1.414 1.415L9.172 12l2.12 2.121-1.413 1.415L6.343 12Z"/>'
      }, props)
  }
  export function RiDocumentFileCopy2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.006-1H7Zm2 0h8v10h2V4H9v2Zm-2 5v2h6v-2H7Zm0 4v2h6v-2H7Z"/>'
      }, props)
  }
  export function RiDocumentFileCopy2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.006-1H7ZM5.002 8 5 20h10V8H5.002ZM9 6h8v10h2V4H9v2Zm-2 5h6v2H7v-2Zm0 4h6v2H7v-2Z"/>'
      }, props)
  }
  export function RiDocumentFileCopyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.006-1H7Zm2 0h8v10h2V4H9v2Z"/>'
      }, props)
  }
  export function RiDocumentFileCopyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.006-1H7ZM5.002 8 5 20h10V8H5.002ZM9 6h8v10h2V4H9v2Z"/>'
      }, props)
  }
  export function RiDocumentFileDamageFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3 14 4 2.5 3-3.5 3 4 2-2.5 3 .5-3-3-2 2.5-3-5-3.5 3.75L3 10V2.992C3 2.455 3.447 2 3.998 2H14v6a1 1 0 0 0 1 1h6v11.992A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V14Zm18-7h-5V2.003L21 7Z"/>'
      }, props)
  }
  export function RiDocumentFileDamageLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 9h-5V4H5v7.857l1.5 1.393L10 9.5l3 5 2-2.5 3 3-3-.5-2 2.5-3-4-3 3.5-2-1.25V20h14V9Zm2-1v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8Z"/>'
      }, props)
  }
  export function RiDocumentFileDownloadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-3 10V8h-2v4H8l4 4 4-4h-3Z"/>'
      }, props)
  }
  export function RiDocumentFileDownloadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 12h3l-4 4-4-4h3V8h2v4Zm2-8H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z"/>'
      }, props)
  }
  export function RiDocumentFileEditFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 15.243v5.765a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.992V9h6a1 1 0 0 0 1-1V2h10.002c.551 0 .998.455.998.992v3.765l-8.999 9-.006 4.238 4.246.006L21 15.243Zm.778-6.435 1.414 1.414L15.414 18l-1.416-.002.002-1.412 7.778-7.778ZM3 7l5-4.997V7H3Z"/>'
      }, props)
  }
  export function RiDocumentFileEditLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m21 6.757-2 2V4h-9v5H5v11h14v-2.757l2-2v5.765a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.993V8l6.003-6h10.995C20.55 2 21 2.455 21 2.992v3.765Zm.778 2.05 1.414 1.415L15.414 18l-1.416-.002.002-1.412 7.778-7.778Z"/>'
      }, props)
  }
  export function RiDocumentFileExcel2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2.859 2.878 12.57-1.796a.5.5 0 0 1 .571.495v20.847a.5.5 0 0 1-.57.495L2.858 21.123a1 1 0 0 1-.859-.99V3.868a1 1 0 0 1 .859-.99ZM17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4V3Zm-6.8 9L13 8h-2.4L9 10.286 7.4 8H5l2.8 4L5 16h2.4L9 13.714 10.6 16H13l-2.8-4Z"/>'
      }, props)
  }
  export function RiDocumentFileExcel2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2.859 2.878 12.57-1.796a.5.5 0 0 1 .571.495v20.847a.5.5 0 0 1-.57.495L2.858 21.123a1 1 0 0 1-.859-.99V3.868a1 1 0 0 1 .859-.99ZM4 4.735v14.53l10 1.43V3.305L4 4.735ZM17 19h3V5h-3V3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4v-2Zm-6.8-7 2.8 4h-2.4L9 13.714 7.4 16H5l2.8-4L5 8h2.4L9 10.286 10.6 8H13l-2.8 4Z"/>'
      }, props)
  }
  export function RiDocumentFileExcelFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-2.8 10L16 8h-2.4L12 10.286 10.4 8H8l2.8 4L8 16h2.4l1.6-2.286L13.6 16H16l-2.8-4Z"/>'
      }, props)
  }
  export function RiDocumentFileExcelLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.2 12 2.8 4h-2.4L12 13.714 10.4 16H8l2.8-4L8 8h2.4l1.6 2.286L13.6 8H15V4H5v16h14V8h-3l-2.8 4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z"/>'
      }, props)
  }
  export function RiDocumentFileFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3 8 6.003-6h10.995C20.55 2 21 2.455 21 2.992v18.016a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.993V8Zm7-4.5L4.5 9H10V3.5Z"/>'
      }, props)
  }
  export function RiDocumentFileForbidFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 11.674A7 7 0 0 0 12.255 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16l5 5v4.674ZM18 23a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm-1.293-2.292a3 3 0 0 0 4.001-4.001l-4.001 4Zm-1.415-1.415 4.001-4a3 3 0 0 0-4.001 4.001Z"/>'
      }, props)
  }
  export function RiDocumentFileForbidLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.29 20c.215.722.543 1.396.965 2H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.998 2H16l5 5v4.674a6.95 6.95 0 0 0-2-.603V8h-4V4H5v16h6.29ZM18 23a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm-1.293-2.292a3 3 0 0 0 4.001-4.001l-4.001 4Zm-1.415-1.415 4.001-4a3 3 0 0 0-4.001 4.001Z"/>'
      }, props)
  }
  export function RiDocumentFileGifFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.998 2H16Zm-3 8h-1v5h1v-5Zm-2 0H9a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1a1 1 0 0 0 1-1v-2H9v1h1v1H9a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2v-1Zm6 0h-3v5h1v-2h2v-1h-2v-1h2v-1Z"/>'
      }, props)
  }
  export function RiDocumentFileGifLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.998 2H16Zm-1 2H5v16h14V8h-4V4Zm-2 6v5h-1v-5h1Zm-2 0v1H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v-1H9v-1h2v2a1 1 0 0 1-1 1H9a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h2Zm6 0v1h-2v1h2v1h-2v2h-1v-5h3Z"/>'
      }, props)
  }
  export function RiDocumentFileHistoryFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 4.999v14.01a.993.993 0 0 1-.993.991H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-3 7h-2v6h5v-2h-3V9Z"/>'
      }, props)
  }
  export function RiDocumentFileHistoryLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.998 2H16Zm-1 2H5v16h14V8h-4V4Zm-2 5v4h3v2h-5V9h2Z"/>'
      }, props)
  }
  export function RiDocumentFileHwpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.998 2H16ZM9.333 14.667H8V18h8v-1.333l-6.667-.001v-2ZM12 14.333a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM12 9a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 1.333a1.167 1.167 0 1 1 0 2.334 1.167 1.167 0 0 1 0-2.334ZM12.667 6h-1.334v1.333H8v1.334h8V7.333h-3.334V6Z"/>'
      }, props)
  }
  export function RiDocumentFileHwpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.447 2 3.998 2H16Zm0 6.667H8V7.333h3.333V6h1.334l-.001 1.333h2.333L15 4H5v16h14V8l-3-.001v.668Zm-6.667 6v1.999H16V18H8v-3.333h1.333ZM12 14.333a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 9a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 1.333a1.167 1.167 0 1 0 0 2.334 1.167 1.167 0 0 0 0-2.334Z"/>'
      }, props)
  }
  export function RiDocumentFileInfoFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-5 5v2h2V7h-2Zm0 4v6h2v-6h-2Z"/>'
      }, props)
  }
  export function RiDocumentFileInfoLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992ZM11 11h2v6h-2v-6Zm0-4h2v2h-2V7Z"/>'
      }, props)
  }
  export function RiDocumentFileLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 2.003V2h10.998C20.55 2 21 2.455 21 2.992v18.016a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 20.993V8l6-5.997ZM5.83 8H9V4.83L5.83 8ZM11 4v5a1 1 0 0 1-1 1H5v10h14V4h-8Z"/>'
      }, props)
  }
  export function RiDocumentFileList2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1ZM8 7v2h8V7H8Zm0 4v2h8v-2H8Zm0 4v2h5v-2H8Z"/>'
      }, props)
  }
  export function RiDocumentFileList2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1Zm-1-2V4H5v16h14ZM8 7h8v2H8V7Zm0 4h8v2H8v-2Zm0 4h5v2H8v-2Z"/>'
      }, props)
  }
  export function RiDocumentFileList3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 22H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12h4v4a3 3 0 0 1-3 3Zm-1-5v2a1 1 0 1 0 2 0v-2h-2ZM6 7v2h8V7H6Zm0 4v2h8v-2H6Zm0 4v2h5v-2H6Z"/>'
      }, props)
  }
  export function RiDocumentFileList3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 22H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v12h4v4a3 3 0 0 1-3 3Zm-1-5v2a1 1 0 1 0 2 0v-2h-2Zm-2 3V4H4v15a1 1 0 0 0 1 1h11ZM6 7h8v2H6V7Zm0 4h8v2H6v-2Zm0 4h5v2H6v-2Z"/>'
      }, props)
  }
  export function RiDocumentFileListFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1ZM8 7v2h8V7H8Zm0 4v2h8v-2H8Zm0 4v2h8v-2H8Z"/>'
      }, props)
  }
  export function RiDocumentFileListLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1Zm-1-2V4H5v16h14ZM8 7h8v2H8V7Zm0 4h8v2H8v-2Zm0 4h8v2H8v-2Z"/>'
      }, props)
  }
  export function RiDocumentFileLockFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-1 9v-1a3 3 0 1 0-6 0v1H8v5h8v-5h-1Zm-2 0h-2v-1a1 1 0 1 1 2 0v1Z"/>'
      }, props)
  }
  export function RiDocumentFileLockLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992ZM15 11h1v5H8v-5h1v-1a3 3 0 1 1 6 0v1Zm-2 0v-1a1 1 0 1 0-2 0v1h2Z"/>'
      }, props)
  }
  export function RiDocumentFileMarkFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 2.992v18.016a1 1 0 0 1-.993.992H3.993A.993.993 0 0 1 3 21.008V2.992A1 1 0 0 1 3.993 2h16.014c.548 0 .993.444.993.992ZM7 4v9l3.5-2 3.5 2V4H7Z"/>'
      }, props)
  }
  export function RiDocumentFileMarkLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1ZM7 4H5v16h14V4h-5v9l-3.5-2L7 13V4Z"/>'
      }, props)
  }
  export function RiDocumentFileMusicFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-5 10.05a2.5 2.5 0 1 0 2 2.45V10h3V8h-5v4.05Z"/>'
      }, props)
  }
  export function RiDocumentFileMusicLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 8v2h-3v4.5a2.5 2.5 0 1 1-2-2.45V8h4V4H5v16h14V8h-3ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z"/>'
      }, props)
  }
  export function RiDocumentFilePaper2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 2a3 3 0 0 1 3 3v2h-2v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2h16v2a1 1 0 0 0 .883.993L18 20a1 1 0 0 0 .993-.883L19 19v-4H3V5a3 3 0 0 1 3-3h14Z"/>'
      }, props)
  }
  export function RiDocumentFilePaper2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 2a3 3 0 0 1 3 3v2h-2v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2h16v2a1 1 0 0 0 .883.993L18 20a1 1 0 0 0 .993-.883L19 19V4H6a1 1 0 0 0-.993.883L5 5v10H3V5a3 3 0 0 1 3-3h14Z"/>'
      }, props)
  }
  export function RiDocumentFilePaperFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 15V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2h16v2a1 1 0 1 0 2 0v-4H3Z"/>'
      }, props)
  }
  export function RiDocumentFilePaperLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 17v2a1 1 0 1 0 2 0V4H5v11H3V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3v-2h16Z"/>'
      }, props)
  }
  export function RiDocumentFilePdfFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-4 14a4 4 0 0 0 0-8H8v8h4Zm-2-6h2a2 2 0 1 1 0 4h-2v-4Z"/>'
      }, props)
  }
  export function RiDocumentFilePdfLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 16H8V8h4a4 4 0 0 1 0 8Zm-2-6v4h2a2 2 0 1 0 0-4h-2Zm5-6H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z"/>'
      }, props)
  }
  export function RiDocumentFilePpt2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4V3ZM2.859 2.878l12.57-1.796a.5.5 0 0 1 .571.495v20.847a.5.5 0 0 1-.57.495L2.858 21.123a1 1 0 0 1-.859-.99V3.868a1 1 0 0 1 .859-.99ZM5 8v8h2v-2h6V8H5Zm2 2h4v2H7v-2Z"/>'
      }, props)
  }
  export function RiDocumentFilePpt2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2.859 2.878 12.57-1.796a.5.5 0 0 1 .571.495v20.847a.5.5 0 0 1-.57.495L2.858 21.123a1 1 0 0 1-.859-.99V3.868a1 1 0 0 1 .859-.99ZM4 4.735v14.53l10 1.43V3.305L4 4.735ZM17 19h3V5h-3V3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4v-2ZM5 8h8v6H7v2H5V8Zm2 2v2h4v-2H7Z"/>'
      }, props)
  }
  export function RiDocumentFilePptFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16ZM8 8v8h2v-2h6V8H8Zm2 2h4v2h-4v-2Z"/>'
      }, props)
  }
  export function RiDocumentFilePptLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992ZM5 4v16h14V8h-3v6h-6v2H8V8h7V4H5Zm5 6v2h4v-2h-4Z"/>'
      }, props)
  }
  export function RiDocumentFileReduceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-8 9v2h8v-2H8Z"/>'
      }, props)
  }
  export function RiDocumentFileReduceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992ZM16 11v2H8v-2h8Z"/>'
      }, props)
  }
  export function RiDocumentFileSearchFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-2.471 12.446 2.21 2.21 1.415-1.413-2.21-2.21a4.001 4.001 0 0 0-6.276-4.861 4 4 0 0 0 4.861 6.274Zm-.618-2.032a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828Z"/>'
      }, props)
  }
  export function RiDocumentFileSearchLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Zm10.529 11.454a4.001 4.001 0 0 1-4.86-6.274 4 4 0 0 1 6.274 4.86l2.21 2.21-1.413 1.415-2.211-2.21Zm-.618-2.032a2 2 0 1 0-2.828-2.828 2 2 0 0 0 2.828 2.828Z"/>'
      }, props)
  }
  export function RiDocumentFileSettingsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16ZM8.595 12.812l-.992.572 1 1.732.992-.573c.393.372.873.654 1.405.812V16.5h2v-1.145a3.495 3.495 0 0 0 1.405-.812l.992.573 1-1.732-.991-.573a3.51 3.51 0 0 0 0-1.623l.991-.572-1-1.732-.992.573A3.496 3.496 0 0 0 13 8.645V7.5h-2v1.145a3.496 3.496 0 0 0-1.405.812l-.992-.573-1 1.732.992.573a3.51 3.51 0 0 0 0 1.623ZM12 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiDocumentFileSettingsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.595 12.812a3.51 3.51 0 0 1 0-1.623l-.992-.573 1-1.732.992.573A3.496 3.496 0 0 1 11 8.645V7.5h2v1.145c.532.158 1.012.44 1.405.812l.992-.573 1 1.732-.992.572a3.507 3.507 0 0 1 0 1.623l.992.573-1 1.732-.992-.573a3.495 3.495 0 0 1-1.405.812V16.5h-2v-1.145a3.495 3.495 0 0 1-1.405-.812l-.992.573-1-1.732.992-.572ZM12 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z"/>'
      }, props)
  }
  export function RiDocumentFileShield2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 10H11v7.382c0 1.563.777 3.023 2.074 3.892l1.083.726H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.447 2 3.998 2h11.999L21 7v3Zm-8 2h8v5.382c0 .897-.446 1.734-1.188 2.23L17 21.499l-2.813-1.885A2.684 2.684 0 0 1 13 17.383V12Z"/>'
      }, props)
  }
  export function RiDocumentFileShield2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 9V4H5v16h6.056c.328.417.724.785 1.18 1.085l1.39.915H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8v1h-7Zm-2 2h9v5.949c0 .99-.501 1.916-1.336 2.465L16.5 21.498l-3.164-2.084A2.954 2.954 0 0 1 12 16.95V11Zm2 5.949c0 .316.162.614.436.795l2.064 1.36 2.064-1.36a.954.954 0 0 0 .436-.795V13h-5v3.949Z"/>'
      }, props)
  }
  export function RiDocumentFileShieldFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 7v13.992A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.447 2 3.998 2h11.999L21 7ZM8 8v5.6c0 .85.446 1.643 1.187 2.114L12 17.5l2.813-1.786A2.51 2.51 0 0 0 16 13.6V8H8Zm2 2h4v3.6c0 .158-.09.318-.26.425L12 15.131l-1.74-1.106c-.17-.107-.26-.267-.26-.425V10Z"/>'
      }, props)
  }
  export function RiDocumentFileShieldLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 8V4H5v16h14V9h-3v4.62c0 .844-.446 1.633-1.188 2.102L12 17.498 9.187 15.72C8.446 15.254 8 14.465 8 13.62V8h6Zm7 0v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8Zm-11 5.62c0 .15.087.304.255.41L12 15.133l1.745-1.101c.168-.107.255-.261.255-.412V10h-4v3.62Z"/>'
      }, props)
  }
  export function RiDocumentFileShredFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12v2H2v-2h2V2.995c0-.55.445-.995.996-.995H15l5 5v5h2ZM3 16h2v6H3v-6Zm16 0h2v6h-2v-6Zm-4 0h2v6h-2v-6Zm-4 0h2v6h-2v-6Zm-4 0h2v6H7v-6Z"/>'
      }, props)
  }
  export function RiDocumentFileShredLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 12h12V8h-4V4H6v8Zm-2 0V2.995c0-.55.445-.995.996-.995H15l5 5v5h2v2H2v-2h2Zm-1 4h2v6H3v-6Zm16 0h2v6h-2v-6Zm-4 0h2v6h-2v-6Zm-4 0h2v6h-2v-6Zm-4 0h2v6H7v-6Z"/>'
      }, props)
  }
  export function RiDocumentFileTextFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 9v11.992A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.447 2 3.998 2H14v6a1 1 0 0 0 1 1h6Zm0-2h-5V2.003L21 7ZM8 7v2h3V7H8Zm0 4v2h8v-2H8Zm0 4v2h8v-2H8Z"/>'
      }, props)
  }
  export function RiDocumentFileTextLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 8v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8Zm-2 1h-5V4H5v16h14V9ZM8 7h3v2H8V7Zm0 4h8v2H8v-2Zm0 4h8v2H8v-2Z"/>'
      }, props)
  }
  export function RiDocumentFileTransferFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-4 9H8v2h4v3l4-4-4-4v3Z"/>'
      }, props)
  }
  export function RiDocumentFileTransferLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992ZM12 11V8l4 4-4 4v-3H8v-2h4Z"/>'
      }, props)
  }
  export function RiDocumentFileUnknowFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-5 13v2h2v-2h-2Zm2-1.645A3.502 3.502 0 0 0 12 6.5a3.501 3.501 0 0 0-3.433 2.813l1.962.393A1.5 1.5 0 1 1 12 11.5a1 1 0 0 0-1 1V14h2v-.645Z"/>'
      }, props)
  }
  export function RiDocumentFileUnknowLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 15h2v2h-2v-2Zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.501 3.501 0 1 1 13 13.355ZM15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z"/>'
      }, props)
  }
  export function RiDocumentFileUploadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-3 10h3l-4-4-4 4h3v4h2v-4Z"/>'
      }, props)
  }
  export function RiDocumentFileUploadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992ZM13 12v4h-2v-4H8l4-4 4 4h-3Z"/>'
      }, props)
  }
  export function RiDocumentFileUserFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-4 9.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM7.527 17h8.945a4.5 4.5 0 0 0-8.945 0Z"/>'
      }, props)
  }
  export function RiDocumentFileUserLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Zm9 8.508a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM7.527 17a4.5 4.5 0 0 1 8.945 0H7.527Z"/>'
      }, props)
  }
  export function RiDocumentFileWarningFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-5 13v2h2v-2h-2Zm0-8v6h2V7h-2Z"/>'
      }, props)
  }
  export function RiDocumentFileWarningLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4H5v16h14V8h-4V4ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992ZM11 15h2v2h-2v-2Zm0-8h2v6h-2V7Z"/>'
      }, props)
  }
  export function RiDocumentFileWord2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4V3ZM2.859 2.878l12.57-1.796a.5.5 0 0 1 .571.495v20.847a.5.5 0 0 1-.57.495L2.858 21.123a1 1 0 0 1-.859-.99V3.868a1 1 0 0 1 .859-.99ZM11 8v4.99L9 11l-1.99 2L7 8H5v8h2l2-2 2 2h2V8h-2Z"/>'
      }, props)
  }
  export function RiDocumentFileWord2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 19h3V5h-3V3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4v-2ZM2.859 2.878l12.57-1.796a.5.5 0 0 1 .571.495v20.847a.5.5 0 0 1-.57.495L2.858 21.123a1 1 0 0 1-.859-.99V3.868a1 1 0 0 1 .859-.99ZM4 4.735v14.53l10 1.43V3.305L4 4.735ZM11 8h2v8h-2l-2-2-2 2H5V8h2l.01 5L9 11l2 1.99V8Z"/>'
      }, props)
  }
  export function RiDocumentFileWordFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 2 5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16Zm-2 6v4.989L12 11l-1.99 2L10 8H8v8h2l2-2 2 2h2V8h-2Z"/>'
      }, props)
  }
  export function RiDocumentFileWordLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 8v8h-2l-2-2-2 2H8V8h2v5l2-2 2 2V8h1V4H5v16h14V8h-3ZM3 2.992C3 2.444 3.447 2 3.998 2H16l5 5v13.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Z"/>'
      }, props)
  }
  export function RiDocumentFileZipFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 2v2h2V2h8.007c.548 0 .993.444.993.992v18.016a1 1 0 0 1-.993.992H3.993A.993.993 0 0 1 3 21.008V2.992A1 1 0 0 1 3.993 2H10Zm2 2v2h2V4h-2Zm-2 2v2h2V6h-2Zm2 2v2h2V8h-2Zm-2 2v2h2v-2h-2Zm2 2v2h-2v3h4v-5h-2Z"/>'
      }, props)
  }
  export function RiDocumentFileZipLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1Zm-1-2V4H5v16h14Zm-5-8v5h-4v-3h2v-2h2Zm-2-8h2v2h-2V4Zm-2 2h2v2h-2V6Zm2 2h2v2h-2V8Zm-2 2h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiDocumentFolder2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 11v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9h20Zm0-2H2V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v3Z"/>'
      }, props)
  }
  export function RiDocumentFolder2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM20 11H4v8h16v-8Zm0-2V7h-8.414l-2-2H4v4h16Z"/>'
      }, props)
  }
  export function RiDocumentFolder3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 8v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7h19a1 1 0 0 1 1 1Zm-9.586-3H2V4a1 1 0 0 1 1-1h7.414l2 2Z"/>'
      }, props)
  }
  export function RiDocumentFolder3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 7v12h16V7H4Z"/>'
      }, props)
  }
  export function RiDocumentFolder4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 21V11h14v9a1 1 0 0 1-1 1H8Zm-2 0H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v3H7a1 1 0 0 0-1 1v11Z"/>'
      }, props)
  }
  export function RiDocumentFolder4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM8 19h12v-8H8v8Zm-2 0v-9a1 1 0 0 1 1-1h13V7h-8.414l-2-2H4v14h2Z"/>'
      }, props)
  }
  export function RiDocumentFolder5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.414 5H20a1 1 0 0 1 1 1v1H3V4a1 1 0 0 1 1-1h7.414l2 2ZM3.087 9h17.826a1 1 0 0 1 .997 1.083l-.833 10a1 1 0 0 1-.997.917H3.92a1 1 0 0 1-.996-.917l-.834-10A1 1 0 0 1 3.087 9Z"/>'
      }, props)
  }
  export function RiDocumentFolder5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.087 9h17.826a1 1 0 0 1 .997 1.083l-.833 10a1 1 0 0 1-.997.917H3.92a1 1 0 0 1-.996-.917l-.834-10A1 1 0 0 1 3.087 9ZM4.84 19h14.32l.667-8H4.174l.666 8Zm8.574-14H20a1 1 0 0 1 1 1v1H3V4a1 1 0 0 1 1-1h7.414l2 2Z"/>'
      }, props)
  }
  export function RiDocumentFolderAddFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM11 12H8v2h3v3h2v-3h3v-2h-3V9h-2v3Z"/>'
      }, props)
  }
  export function RiDocumentFolderAddLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm7 7V9h2v3h3v2h-3v3h-2v-3H8v-2h3Z"/>'
      }, props)
  }
  export function RiDocumentFolderChart2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM12 9a4 4 0 1 0 4 4h-4V9Z"/>'
      }, props)
  }
  export function RiDocumentFolderChart2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm8 4v4h4a4 4 0 1 1-4-4Z"/>'
      }, props)
  }
  export function RiDocumentFolderChartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM11 9v8h2V9h-2Zm4 3v5h2v-5h-2Zm-8 2v3h2v-3H7Z"/>'
      }, props)
  }
  export function RiDocumentFolderChartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm7 4h2v8h-2V9Zm4 3h2v5h-2v-5Zm-8 2h2v3H7v-3Z"/>'
      }, props)
  }
  export function RiDocumentFolderDownloadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM13 13V9h-2v4H8l4 4 4-4h-3Z"/>'
      }, props)
  }
  export function RiDocumentFolderDownloadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm9 8h3l-4 4-4-4h3V9h2v4Z"/>'
      }, props)
  }
  export function RiDocumentFolderFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2Z"/>'
      }, props)
  }
  export function RiDocumentFolderForbidFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 11.255A7 7 0 0 0 12.255 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v5.255ZM18 22a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm-1.293-2.292a3 3 0 0 0 4.001-4.001l-4.001 4Zm-1.415-1.415 4.001-4a3 3 0 0 0-4.001 4.001Z"/>'
      }, props)
  }
  export function RiDocumentFolderForbidLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 11.255a6.972 6.972 0 0 0-2-.965V7h-8.414l-2-2H4v14h7.29c.215.722.543 1.396.965 2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v5.255ZM18 22a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm-1.293-2.292a3 3 0 0 0 4.001-4.001l-4.001 4Zm-1.415-1.415 4.001-4a3 3 0 0 0-4.001 4.001Z"/>'
      }, props)
  }
  export function RiDocumentFolderHistoryFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.414 3 2 2H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414ZM13 9h-2v6h5v-2h-3V9Z"/>'
      }, props)
  }
  export function RiDocumentFolderHistoryLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.414 3 2 2H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414Zm-.828 2H4v14h16V7h-8.414l-2-2ZM13 9v4h3v2h-5V9h2Z"/>'
      }, props)
  }
  export function RiDocumentFolderInfoFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM11 9v2h2V9h-2Zm0 3v5h2v-5h-2Z"/>'
      }, props)
  }
  export function RiDocumentFolderInfoLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm7 7h2v5h-2v-5Zm0-3h2v2h-2V9Z"/>'
      }, props)
  }
  export function RiDocumentFolderKeyholeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.414 3 2 2H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414ZM12 9a2 2 0 0 0-1 3.732V17h2l.001-4.268A2 2 0 0 0 12 9Z"/>'
      }, props)
  }
  export function RiDocumentFolderKeyholeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.414 3 2 2H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414Zm-.828 2H4v14h16V7h-8.414l-2-2ZM12 9a2 2 0 0 1 1.001 3.732L13 17h-2v-4.268A2 2 0 0 1 12 9Z"/>'
      }, props)
  }
  export function RiDocumentFolderLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 5v14h16V7h-8.414l-2-2H4Zm8.414 0H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2Z"/>'
      }, props)
  }
  export function RiDocumentFolderLockFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM15 13v-1a3 3 0 1 0-6 0v1H8v4h8v-4h-1Zm-2 0h-2v-1a1 1 0 1 1 2 0v1Z"/>'
      }, props)
  }
  export function RiDocumentFolderLockLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm11 8h1v4H8v-4h1v-1a3 3 0 1 1 6 0v1Zm-2 0v-1a1 1 0 1 0-2 0v1h2Z"/>'
      }, props)
  }
  export function RiDocumentFolderMusicFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM11 13.05a2.5 2.5 0 1 0 2 2.45V11h3V9h-5v4.05Z"/>'
      }, props)
  }
  export function RiDocumentFolderMusicLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm7 8.05V9h5v2h-3v4.5a2.5 2.5 0 1 1-2-2.45Z"/>'
      }, props)
  }
  export function RiDocumentFolderOpenFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H20a1 1 0 0 1 1 1v3H4v9.996L6 11h16.5l-2.31 9.242a1 1 0 0 1-.97.758H3Z"/>'
      }, props)
  }
  export function RiDocumentFolderOpenLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 21a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H20a1 1 0 0 1 1 1v3h-2V7h-7.414l-2-2H4v11.998L5.5 11h17l-2.31 9.242a1 1 0 0 1-.97.758H3Zm16.938-8H7.062l-1.5 6h12.876l1.5-6Z"/>'
      }, props)
  }
  export function RiDocumentFolderReceivedFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13.126A6 6 0 0 0 13.303 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v7.126ZM20 17h3v2h-3v3.5L15 18l5-4.5V17Z"/>'
      }, props)
  }
  export function RiDocumentFolderReceivedLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13h-2V7h-8.414l-2-2H4v14h9v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v7Zm-2 4h3v2h-3v3.5L15 18l5-4.5V17Z"/>'
      }, props)
  }
  export function RiDocumentFolderReduceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM8 12v2h8v-2H8Z"/>'
      }, props)
  }
  export function RiDocumentFolderReduceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm4 7h8v2H8v-2Z"/>'
      }, props)
  }
  export function RiDocumentFolderSettingsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2Zm-3.823 8.809-.991.572 1 1.731.991-.572c.393.371.872.653 1.405.811v1.145h1.998V16.35a3.495 3.495 0 0 0 1.405-.811l.992.572.999-1.73-.991-.573a3.507 3.507 0 0 0 0-1.622l.991-.572-1-1.732-.992.573a3.495 3.495 0 0 0-1.404-.812V8.5h-1.999v1.144a3.494 3.494 0 0 0-1.404.812L8.6 9.883 7.6 11.615l.991.572a3.508 3.508 0 0 0 0 1.622Zm3.404.688a1.5 1.5 0 1 1 0-2.998 1.5 1.5 0 0 1 0 2.998Z"/>'
      }, props)
  }
  export function RiDocumentFolderSettingsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm4.591 8.809a3.508 3.508 0 0 1 0-1.622l-.991-.572 1-1.732.991.573a3.494 3.494 0 0 1 1.404-.812V8.5h2v1.144c.532.159 1.01.44 1.404.812l.991-.573 1 1.732-.991.572a3.508 3.508 0 0 1 0 1.622l.991.572-1 1.731-.991-.572a3.495 3.495 0 0 1-1.404.811v1.145h-2V16.35a3.495 3.495 0 0 1-1.404-.811l-.991.572-1-1.73.991-.573Zm3.404.688a1.5 1.5 0 1 0 0-2.999 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiDocumentFolderSharedFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13.126A6 6 0 0 0 13.303 21H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v7.126ZM18 17v-3.5l5 4.5-5 4.5V19h-3v-2h3Z"/>'
      }, props)
  }
  export function RiDocumentFolderSharedLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13h-2V7h-8.414l-2-2H4v14h9v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v7Zm-4 4v-3.5l5 4.5-5 4.5V19h-3v-2h3Z"/>'
      }, props)
  }
  export function RiDocumentFolderShield2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 10H12v7.382c0 1.409.632 2.734 1.705 3.618H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v4Zm-8 2h8v5.382c0 .897-.446 1.734-1.188 2.23L18 21.499l-2.813-1.885A2.684 2.684 0 0 1 14 17.383V12Z"/>'
      }, props)
  }
  export function RiDocumentFolderShield2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 9h-2V7h-8.414l-2-2H4v14h7.447a4.97 4.97 0 0 0 1.664 2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H21a1 1 0 0 1 1 1v3Zm-9 2h9v5.949c0 .99-.501 1.916-1.336 2.465L17.5 21.498l-3.164-2.084A2.954 2.954 0 0 1 13 16.95V11Zm2 5.949c0 .316.162.614.436.795l2.064 1.36 2.064-1.36a.954.954 0 0 0 .436-.795V13h-5v3.949Z"/>'
      }, props)
  }
  export function RiDocumentFolderShieldFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM8 9v4.904c0 .892.446 1.724 1.187 2.219L12 17.998l2.813-1.875A2.667 2.667 0 0 0 16 13.904V9H8Zm2 4.904V11h4v2.904a.667.667 0 0 1-.297.555L12 15.594l-1.703-1.135a.667.667 0 0 1-.297-.555Z"/>'
      }, props)
  }
  export function RiDocumentFolderShieldLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm4 4h8v4.904c0 .892-.446 1.724-1.188 2.219L12 17.998l-2.813-1.875A2.667 2.667 0 0 1 8 13.904V9Zm2 4.904c0 .223.111.431.297.555L12 15.594l1.703-1.135a.667.667 0 0 0 .297-.555V11h-4v2.904Z"/>'
      }, props)
  }
  export function RiDocumentFolderTransferFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM12 12H8v2h4v3l4-4-4-4v3Z"/>'
      }, props)
  }
  export function RiDocumentFolderTransferLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm8 7V9l4 4-4 4v-3H8v-2h4Z"/>'
      }, props)
  }
  export function RiDocumentFolderUnknowFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM11 16v2h2v-2h-2Zm-2.433-5.187 1.962.393A1.5 1.5 0 1 1 12 13h-1v2h1a3.5 3.5 0 1 0-3.433-4.187Z"/>'
      }, props)
  }
  export function RiDocumentFolderUnknowLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm7 11h2v2h-2v-2Zm-2.433-5.187A3.501 3.501 0 1 1 12 15h-1v-2h1a1.5 1.5 0 1 0-1.471-1.794l-1.962-.393Z"/>'
      }, props)
  }
  export function RiDocumentFolderUploadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM13 13h3l-4-4-4 4h3v4h2v-4Z"/>'
      }, props)
  }
  export function RiDocumentFolderUploadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm9 8v4h-2v-4H8l4-4 4 4h-3Z"/>'
      }, props)
  }
  export function RiDocumentFolderUserFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM12 13a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-4 5h8a4 4 0 0 0-8 0Z"/>'
      }, props)
  }
  export function RiDocumentFolderUserLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm4 13a4 4 0 0 1 8 0H8Zm4-5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"/>'
      }, props)
  }
  export function RiDocumentFolderWarningFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM11 9v5h2V9h-2Zm0 6v2h2v-2h-2Z"/>'
      }, props)
  }
  export function RiDocumentFolderWarningLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2ZM4 5v14h16V7h-8.414l-2-2H4Zm7 10h2v2h-2v-2Zm0-6h2v5h-2V9Z"/>'
      }, props)
  }
  export function RiDocumentFolderZipFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2H16v2h2V5h3Zm-3 8h-2v2h-2v3h4v-5Zm-2-2h-2v2h2v-2Zm2-2h-2v2h2V9Zm-2-2h-2v2h2V7Z"/>'
      }, props)
  }
  export function RiDocumentFolderZipLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.414 3 2 2H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414ZM18 18h-4v-3h2v-2h-2v-2h2V9h-2V7h-2.414l-2-2H4v14h16V7h-4v2h2v2h-2v2h2v5Z"/>'
      }, props)
  }
  export function RiDocumentFoldersFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 7V4a1 1 0 0 1 1-1h6.414l2 2H21a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3Zm0 2H4v10h12v-2H6V9Z"/>'
      }, props)
  }
  export function RiDocumentFoldersLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 7V4a1 1 0 0 1 1-1h6.414l2 2H21a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3Zm0 2H4v10h12v-2H6V9Zm2-4v10h12V7h-5.414l-2-2H8Z"/>'
      }, props)
  }
  export function RiDocumentKeynoteFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 2c.552 0 1.086.43 1.195.977l1.61 8.046c.108.54-.26.977-.797.977H13v8h4v2H7v-2h4v-8H2.992c-.548 0-.906-.43-.797-.977l1.61-8.046C3.913 2.437 4.445 2 5 2h13.998Z"/>'
      }, props)
  }
  export function RiDocumentKeynoteLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.44 10h15.12l-1.2-6H5.64l-1.2 6ZM13 12v8h4v2H7v-2h4v-8H2.992c-.548 0-.906-.43-.797-.977l1.61-8.046C3.913 2.437 4.445 2 5 2h13.998c.553 0 1.087.43 1.197.977l1.609 8.046c.108.54-.26.977-.797.977H13Z"/>'
      }, props)
  }
  export function RiDocumentMarkdownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm4 12.5v-4l2 2 2-2v4h2v-7h-2l-2 2-2-2H5v7h2Zm11-3v-4h-2v4h-2l3 3 3-3h-2Z"/>'
      }, props)
  }
  export function RiDocumentMarkdownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h16V5H4Zm3 10.5H5v-7h2l2 2 2-2h2v7h-2v-4l-2 2-2-2v4Zm11-3h2l-3 3-3-3h2v-4h2v4Z"/>'
      }, props)
  }
  export function RiDocumentNewspaperFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 22H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v7h4v9a3 3 0 0 1-3 3Zm-1-10v7a1 1 0 1 0 2 0v-7h-2ZM5 6v6h6V6H5Zm0 7v2h10v-2H5Zm0 3v2h10v-2H5Zm2-8h2v2H7V8Z"/>'
      }, props)
  }
  export function RiDocumentNewspaperLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 20V4H4v15a1 1 0 0 0 1 1h11Zm3 2H5a3 3 0 0 1-3-3V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v7h4v9a3 3 0 0 1-3 3Zm-1-10v7a1 1 0 1 0 2 0v-7h-2ZM6 6h6v6H6V6Zm2 2v2h2V8H8Zm-2 5h8v2H6v-2Zm0 3h8v2H6v-2Z"/>'
      }, props)
  }
  export function RiDocumentNumbersFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 18H4v-8h5v8Zm6 0h-5V6h5v12Zm6 0h-5V2h5v16Zm1 4H3v-2h19v2Z"/>'
      }, props)
  }
  export function RiDocumentNumbersLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 18H4v-8h5v8Zm-2-2v-4H6v4h1Zm6 0V8h-1v8h1Zm2 2h-5V6h5v12Zm4-2V4h-1v12h1Zm2 2h-5V2h5v16Zm1 4H3v-2h19v2Z"/>'
      }, props)
  }
  export function RiDocumentPagesFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4a1 1 0 0 1-1-1V8h18v13a1 1 0 0 1-1 1Zm1-16H3V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v3ZM7 11v4h4v-4H7Zm0 6v2h10v-2H7Zm6-5v2h4v-2h-4Z"/>'
      }, props)
  }
  export function RiDocumentPagesLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 8v12h14V8H5Zm0-2h14V4H5v2Zm15 16H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1ZM7 10h4v4H7v-4Zm0 6h10v2H7v-2Zm6-5h4v2h-4v-2Z"/>'
      }, props)
  }
  export function RiDocumentStickyNote2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m21 16-5.003 5H3.998A.996.996 0 0 1 3 20.007V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.447.993.998V16Z"/>'
      }, props)
  }
  export function RiDocumentStickyNote2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.998 21A.996.996 0 0 1 3 20.007V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.447.993.998V16l-5.003 5H3.998ZM5 19h10.169L19 15.171V5H5v14Z"/>'
      }, props)
  }
  export function RiDocumentStickyNoteFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15 14-.117.007a1 1 0 0 0-.876.876L14 15v6H3.998A.996.996 0 0 1 3 20.007V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.447.993.998V14h-6Zm6 2-5 4.997V16h5Z"/>'
      }, props)
  }
  export function RiDocumentStickyNoteLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m21 15-6 5.996L4.002 21A.998.998 0 0 1 3 20.007V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.456.993 1.002V15ZM19 5H5v14h8v-5a1 1 0 0 1 .883-.993L14 13l5-.001V5Zm-.829 9.999L15 15v3.169l3.171-3.17Z"/>'
      }, props)
  }
  export function RiDocumentSurveyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 4v4h12V4h2.007c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 21.007V4.993C3 4.445 3.445 4 3.993 4H6Zm3 13H7v2h2v-2Zm0-3H7v2h2v-2Zm0-3H7v2h2v-2Zm7-9v4H8V2h8Z"/>'
      }, props)
  }
  export function RiDocumentSurveyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 2v2h3.007c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 21.007V4.993C3 4.445 3.445 4 3.993 4H7V2h10ZM7 6H5v14h14V6h-2v2H7V6Zm2 10v2H7v-2h2Zm0-3v2H7v-2h2Zm0-3v2H7v-2h2Zm6-6H9v2h6V4Z"/>'
      }, props)
  }
  export function RiDocumentTaskFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3v18.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H20a1 1 0 0 1 1 1Zm-9.707 10.121-2.475-2.475-1.414 1.415 3.889 3.889 5.657-5.657-1.414-1.414-4.243 4.242Z"/>'
      }, props)
  }
  export function RiDocumentTaskLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 4H5v16h14V4ZM3 2.992C3 2.444 3.447 2 3.998 2H20a1 1 0 0 1 1 1v17.992A1 1 0 0 1 20.007 22H3.993A1 1 0 0 1 3 21.008V2.992Zm8.293 10.13 4.243-4.243 1.414 1.414-5.657 5.657-3.89-3.89 1.415-1.414 2.475 2.475Z"/>'
      }, props)
  }
  export function RiDocumentTodoFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 2h3a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3V0h2v2h6V0h2v2ZM7 8v2h10V8H7Zm0 4v2h10v-2H7Z"/>'
      }, props)
  }
  export function RiDocumentTodoLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 2h3a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3V0h2v2h6V0h2v2Zm0 2v2h-2V4H9v2H7V4H5v16h14V4h-2ZM7 8h10v2H7V8Zm0 4h10v2H7v-2Z"/>'
      }, props)
  }
  export function RiEditorAB(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 15v2c0 1.054.95 2 2 2h3v2H7a4 4 0 0 1-4-4v-2h2Zm13-5 4.4 11h-2.155l-1.201-3h-4.09l-1.199 3h-2.154L16 10h2Zm-1 2.885L15.753 16h2.492L17 12.885ZM3 3h6a3 3 0 0 1 2.235 5A3 3 0 0 1 9 13H3V3Zm6 6H5v2h4a1 1 0 1 0 0-2Zm8-6a4 4 0 0 1 4 4v2h-2V7a2 2 0 0 0-2-2h-3V3h3ZM9 5H5v2h4a1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiEditorAiGenerate(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 5.25A3.25 3.25 0 0 0 18.25 2h1.5A3.25 3.25 0 0 0 23 5.25v1.5A3.25 3.25 0 0 0 19.75 10h-1.5A3.25 3.25 0 0 0 15 6.75v-1.5ZM4 7a2 2 0 0 1 2-2h7V3H6a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-5h-2v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7Z"/>'
      }, props)
  }
  export function RiEditorAlignBottom(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 19h18v2H3v-2Zm5-6h3l-4 4-4-4h3V3h2v10Zm10 0h3l-4 4-4-4h3V3h2v10Z"/>'
      }, props)
  }
  export function RiEditorAlignCenter(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm2 15h14v2H5v-2Zm-2-5h18v2H3v-2Zm2-5h14v2H5V9Z"/>'
      }, props)
  }
  export function RiEditorAlignJustify(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm0 15h18v2H3v-2Zm0-5h18v2H3v-2Zm0-5h18v2H3V9Z"/>'
      }, props)
  }
  export function RiEditorAlignLeft(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm0 15h14v2H3v-2Zm0-5h18v2H3v-2Zm0-5h14v2H3V9Z"/>'
      }, props)
  }
  export function RiEditorAlignRight(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm4 15h14v2H7v-2Zm-4-5h18v2H3v-2Zm4-5h14v2H7V9Z"/>'
      }, props)
  }
  export function RiEditorAlignTop(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18v2H3V3Zm5 8v10H6V11H3l4-4 4 4H8Zm10 0v10h-2V11h-3l4-4 4 4h-3Z"/>'
      }, props)
  }
  export function RiEditorAlignVertically(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 11h18v2H3v-2Zm15 7v3h-2v-3h-3l4-4 4 4h-3ZM8 18v3H6v-3H3l4-4 4 4H8ZM18 6h3l-4 4-4-4h3V3h2v3ZM8 6h3l-4 4-4-4h3V3h2v3Z"/>'
      }, props)
  }
  export function RiEditorAsterisk(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 3v7.267l6.294-3.633 1 1.732L14 11.999l6.294 3.635-1 1.732-6.295-3.634V21h-2v-7.268l-6.294 3.634-1-1.732L9.998 12 3.705 8.366l1-1.732L11 10.267V3h2Z"/>'
      }, props)
  }
  export function RiEditorAttachment2(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14.829 7.757-5.657 5.657a1 1 0 1 0 1.414 1.415l5.657-5.657A3 3 0 0 0 12 4.929l-5.657 5.657a5 5 0 0 0 7.071 7.07L19.071 12l1.414 1.414-5.656 5.657a7 7 0 1 1-9.9-9.9l5.657-5.656a5 5 0 0 1 7.071 7.07L12 16.244A3 3 0 1 1 7.758 12l5.656-5.657 1.415 1.414Z"/>'
      }, props)
  }
  export function RiEditorBold(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 11h4.5a2.5 2.5 0 0 0 0-5H8v5Zm10 4.5a4.5 4.5 0 0 1-4.5 4.5H6V4h6.5a4.5 4.5 0 0 1 3.256 7.606A4.498 4.498 0 0 1 18 15.5ZM8 13v5h5.5a2.5 2.5 0 0 0 0-5H8Z"/>'
      }, props)
  }
  export function RiEditorBringForward(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 3a1 1 0 0 1 1 1v5h5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-5H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10Zm-1 2H5v8h8V5Z"/>'
      }, props)
  }
  export function RiEditorBringToFront(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 3a1 1 0 0 1 1 1v2h5a1 1 0 0 1 1 1v5h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-2H7a1 1 0 0 1-1-1v-5H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7Zm5 5H8v8h8V8Z"/>'
      }, props)
  }
  export function RiEditorCodeView(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.95 8.465 1.414-1.415 4.95 4.95-4.95 4.95-1.414-1.414L20.485 12 16.95 8.465Zm-9.9 0L3.515 12l3.535 3.536-1.414 1.414L.686 12l4.95-4.95L7.05 8.465Z"/>'
      }, props)
  }
  export function RiEditorDeleteColumn(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3a1 1 0 0 1 1 1v8a5 5 0 1 1 .213 8.152L13 20a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm-1 2H7v14h4V5Zm8 10h-6v2h6v-2Z"/>'
      }, props)
  }
  export function RiEditorDeleteRow(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1 5 5 0 1 1-8 0H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h16Zm-7 10v2h6v-2h-6Zm6-8H5v4h14V7Z"/>'
      }, props)
  }
  export function RiEditorDoubleQuotesL(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179Zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179Z"/>'
      }, props)
  }
  export function RiEditorDoubleQuotesR(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.417 6.679C20.447 7.773 21 9 21 10.989c0 3.5-2.456 6.637-6.03 8.188l-.893-1.378c3.335-1.804 3.987-4.145 4.248-5.621-.537.278-1.24.375-1.93.311-1.804-.167-3.226-1.648-3.226-3.489a3.5 3.5 0 0 1 3.5-3.5c1.073 0 2.1.49 2.748 1.179Zm-10 0C10.447 7.773 11 9 11 10.989c0 3.5-2.456 6.637-6.03 8.188l-.893-1.378c3.335-1.804 3.987-4.145 4.247-5.621-.537.278-1.24.375-1.929.311C4.591 12.322 3.17 10.841 3.17 9a3.5 3.5 0 0 1 3.5-3.5c1.073 0 2.1.49 2.748 1.179Z"/>'
      }, props)
  }
  export function RiEditorDraggable(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM15.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-1.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiEditorEmphasisCn(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 19a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-5.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM13 2v2h6v2h-1.968a18.222 18.222 0 0 1-3.621 6.302 14.683 14.683 0 0 0 5.327 3.042l-.536 1.93A16.686 16.686 0 0 1 12 13.726 16.697 16.697 0 0 1 5.8 17.273l-.536-1.929a14.7 14.7 0 0 0 5.327-3.042 18.077 18.077 0 0 1-2.822-4.3h2.24A16.03 16.03 0 0 0 12 10.876a16.17 16.17 0 0 0 2.91-4.876L5 6V4h6V2h2Z"/>'
      }, props)
  }
  export function RiEditorEmphasis(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 19a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-5.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM18 3v2H8v4h9v2H8v4h10v2H6V3h12Z"/>'
      }, props)
  }
  export function RiEditorEnglishInput(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 10h2v.757a4.5 4.5 0 0 1 7 3.743V20h-2v-5.5c0-1.43-1.174-2.5-2.5-2.5S16 13.07 16 14.5V20h-2V10Zm-2-6v2H4v5h8v2H4v5h8v2H2V4h10Z"/>'
      }, props)
  }
  export function RiEditorFlowChart(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 21.5A3.5 3.5 0 1 1 9.355 17H15v-2h2V9.242L14.757 7H9V9H3V3h6v2h5.757L18 1.756 22.243 6 19 9.241V15L21 15v6h-6v-2H9.355A3.502 3.502 0 0 1 6 21.5Zm0-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm13 .5h-2v2h2v-2ZM18 4.586 16.586 6 18 7.414 19.414 6 18 4.586ZM7 5H5v2h2V5Z"/>'
      }, props)
  }
  export function RiEditorFontColor(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.246 14H8.754l-1.6 4H5l6-15h2l6 15h-2.154l-1.6-4Zm-.8-2L12 5.885 9.554 12h4.892ZM3 20h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiEditorFontFamily(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.554 22H3.4L11 3h2l7.6 19h-2.154l-2.4-6H7.954l-2.4 6Zm3.2-8h6.492L12 5.885 8.754 14Z"/>'
      }, props)
  }
  export function RiEditorFontMono(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 4h13v2H8v6h10v2H8v7H6V4Z"/>'
      }, props)
  }
  export function RiEditorFontSansSerif(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 4h14v4h-1.5C17 6 17 5 15 5h-5v7h3c1 0 2-.5 2-2h1v5h-1c0-1.5-1-2-2-2h-3v4.5c0 2.5 3.5 2.5 3.5 2.5v1H5v-1c2-.5 2-1.5 2-2.5v-10c0-1 0-2-2-2.5V4Z"/>'
      }, props)
  }
  export function RiEditorFontSans(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 4h12v2h-9v6h8v2h-8v7H7V4Z"/>'
      }, props)
  }
  export function RiEditorFontSize2(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 6v15H8V6H2V4h14v2h-6Zm8 8v7h-2v-7h-3v-2h8v2h-3Z"/>'
      }, props)
  }
  export function RiEditorFontSize(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.245 15H4.755l-2 5H.6L7 4h2l6.4 16h-2.155l-2-5Zm-.8-2L8 6.885 5.554 13h4.891ZM21 12.535V12h2v8h-2v-.535a4 4 0 1 1 0-6.93ZM19 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiEditorFormatClear(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.651 14.065 11.605 20H9.574l1.35-7.661-7.41-7.41L4.93 3.515 20.485 19.07l-1.414 1.414-6.42-6.42Zm-.878-6.535.27-1.53h-1.8l-2-2H20v2h-5.927L13.5 9.256 11.773 7.53Z"/>'
      }, props)
  }
  export function RiEditorFunctions(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m5 18 7.68-6L5 6V4h14v2H8.263L16 12l-7.737 6H19v2H5v-2Z"/>'
      }, props)
  }
  export function RiEditorH1(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16Zm8-12v12h-2v-9.796l-2 .536V8.67L19.5 8H21Z"/>'
      }, props)
  }
  export function RiEditorH2(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 4v7h7V4h2v16h-2v-7H4v7H2V4h2Zm14.5 4a3.75 3.75 0 0 1 2.978 6.03l-.148.18L18.034 18H22v2h-7v-1.556l4.82-5.546a1.75 1.75 0 1 0-3.065-1.292l-.005.144h-2A3.75 3.75 0 0 1 18.5 8Z"/>'
      }, props)
  }
  export function RiEditorH3(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m22 8-.002 2-2.505 2.883a3.752 3.752 0 0 1-.993 7.367 3.751 3.751 0 0 1-3.682-3.033l1.964-.382a1.75 1.75 0 1 0 .924-1.895l-1.307-1.547L19.35 10H15V8h7ZM4 4v7h7V4h2v16h-2v-7H4v7H2V4h2Z"/>'
      }, props)
  }
  export function RiEditorH4(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16Zm9-12v8h1.5v2H22v2h-2v-2h-5.5v-1.34l5-8.66H22Zm-2 3.133L17.19 16H20v-4.867Z"/>'
      }, props)
  }
  export function RiEditorH5(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 8v2h-4.323l-.464 2.636A4.006 4.006 0 0 1 22.25 16.5a4 4 0 0 1-7.846 1.103l1.923-.551a2 2 0 1 0 .363-1.804l-1.81-.904L16 8h6ZM4 4v7h7V4h2v16h-2v-7H4v7H2V4h2Z"/>'
      }, props)
  }
  export function RiEditorH6(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m21.097 8-2.598 4.5a4 4 0 1 1-3.453 1.981L18.788 8h2.309ZM4 4v7h7V4h2v16h-2v-7H4v7H2V4h2Zm14.5 10.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>'
      }, props)
  }
  export function RiEditorHashtag(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m7.784 14 .42-4H4V8h4.415l.525-5h2.011l-.525 5h3.989l.525-5h2.011l-.525 5H20v2h-3.784l-.42 4H20v2h-4.415l-.525 5h-2.011l.525-5H9.585l-.525 5H7.049l.525-5H4v-2h3.784Zm2.011 0h3.99l.42-4h-3.99l-.42 4Z"/>'
      }, props)
  }
  export function RiEditorHeading(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 11V4h2v17h-2v-8H7v8H5V4h2v7h10Z"/>'
      }, props)
  }
  export function RiEditorIndentDecrease(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm0 15h18v2H3v-2Zm8-5h10v2H11v-2Zm0-5h10v2H11V9Zm-8 3.5L7 9v7l-4-3.5Z"/>'
      }, props)
  }
  export function RiEditorIndentIncrease(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm0 15h18v2H3v-2Zm8-5h10v2H11v-2Zm0-5h10v2H11V9Zm-4 3.5L3 16V9l4 3.5Z"/>'
      }, props)
  }
  export function RiEditorInputCursorMove(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 21v-2h3V5H8V3h8v2h-3v14h3v2H8ZM18.05 7.05 23 12l-4.95 4.95-1.414-1.414L20.172 12l-3.536-3.536L18.05 7.05Zm-12.1 0 1.414 1.414L3.828 12l3.536 3.536L5.95 16.95 1 12l4.95-4.95Z"/>'
      }, props)
  }
  export function RiEditorInsertColumnLeft(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm-1 2h-4v14h4V5ZM6 7a5 5 0 1 1 0 10A5 5 0 0 1 6 7Zm1 2H5v1.999L3 11v2l2-.001V15h2v-2.001L9 13v-2l-2-.001V9Z"/>'
      }, props)
  }
  export function RiEditorInsertColumnRight(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6ZM9 5H5v14h4V5Zm9 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm1 2h-2v1.999L15 11v2l2-.001V15h2v-2.001L21 13v-2l-2-.001V9Z"/>'
      }, props)
  }
  export function RiEditorInsertRowBottom(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 13a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm1 2h-2v1.999L9 17v2l2-.001V21h2v-2.001L15 19v-2l-2-.001V15Zm7-12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16ZM5 5v4h14V5H5Z"/>'
      }, props)
  }
  export function RiEditorInsertRowTop(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 13a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h16Zm-1 2H5v4h14v-4ZM12 1a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm1 2h-2v1.999L9 5v2l2-.001V9h2V6.999L15 7V5l-2-.001V3Z"/>'
      }, props)
  }
  export function RiEditorItalic(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15v2Z"/>'
      }, props)
  }
  export function RiEditorLineHeight(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 4h10v2H11V4ZM6 7v4H4V7H1l4-4 4 4H6Zm0 10h3l-4 4-4-4h3v-4h2v4Zm5 1h10v2H11v-2Zm-2-7h12v2H9v-2Z"/>'
      }, props)
  }
  export function RiEditorLinkM(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.657 14.828-1.414-1.414L17.657 12A4 4 0 1 0 12 6.343l-1.414 1.414-1.414-1.414 1.414-1.414a6 6 0 0 1 8.485 8.485l-1.414 1.414Zm-2.828 2.829-1.415 1.414a6 6 0 0 1-8.485-8.485L6.343 9.17l1.415 1.415L6.343 12A4 4 0 0 0 12 17.657l1.415-1.415 1.414 1.415Zm0-9.9 1.414 1.414-7.071 7.072-1.414-1.415 7.07-7.07Z"/>'
      }, props)
  }
  export function RiEditorLinkUnlinkM(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.657 14.829-1.414-1.415L17.657 12A4 4 0 1 0 12 6.343l-1.414 1.414-1.414-1.414 1.414-1.414a6 6 0 0 1 8.485 8.485l-1.414 1.415Zm-2.828 2.828-1.415 1.414a6 6 0 0 1-8.485-8.485l1.414-1.414 1.414 1.414L6.343 12A4 4 0 0 0 12 17.657l1.414-1.414 1.415 1.414Zm0-9.9 1.414 1.415-7.071 7.07-1.415-1.413 7.072-7.072ZM5.775 2.293l1.932-.518L8.743 5.64l-1.932.518-1.036-3.864Zm9.483 16.068 1.932-.518 1.035 3.864-1.932.518-1.035-3.864ZM2.293 5.775l3.864 1.036-.518 1.932-3.864-1.036.518-1.932Zm16.068 9.483 3.864 1.035-.518 1.932-3.864-1.035.518-1.932Z"/>'
      }, props)
  }
  export function RiEditorLinkUnlink(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 17h5v2h-3v3h-2v-5ZM7 7H2V5h3V2h2v5Zm11.364 8.536L16.95 14.12l1.414-1.414a5 5 0 0 0-7.071-7.071L9.879 7.05 8.464 5.636 9.88 4.222a7 7 0 0 1 9.9 9.9l-1.415 1.414Zm-2.829 2.828-1.414 1.414a7 7 0 0 1-9.9-9.9l1.415-1.414L7.05 9.88l-1.414 1.414a5 5 0 0 0 7.071 7.071l1.414-1.414 1.415 1.414Zm-.707-10.607 1.415 1.415-7.071 7.07-1.415-1.414 7.071-7.07Z"/>'
      }, props)
  }
  export function RiEditorLink(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.364 15.535-1.414-1.414 1.414-1.414a5 5 0 0 0-7.07-7.071L9.878 7.05 8.465 5.636l1.414-1.414a7 7 0 0 1 9.9 9.9l-1.415 1.413Zm-2.828 2.829-1.414 1.414a7 7 0 1 1-9.9-9.9l1.414-1.414 1.415 1.414-1.415 1.415a5 5 0 0 0 7.071 7.07l1.415-1.413 1.414 1.414Zm-.707-10.607 1.414 1.414-7.071 7.072-1.414-1.415 7.07-7.07Z"/>'
      }, props)
  }
  export function RiEditorListCheck2(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 4h10v2H11V4Zm0 4h6v2h-6V8Zm0 6h10v2H11v-2Zm0 4h6v2h-6v-2ZM3 4h6v6H3V4Zm2 2v2h2V6H5Zm-2 8h6v6H3v-6Zm2 2v2h2v-2H5Z"/>'
      }, props)
  }
  export function RiEditorListCheck3(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 6v3H5V6h3ZM3 4v7h7V4H3Zm10 0h8v2h-8V4Zm0 7h8v2h-8v-2Zm0 7h8v2h-8v-2Zm-2.293-1.793-1.414-1.414L6 18.086l-1.793-1.793-1.414 1.414L6 20.914l4.707-4.707Z"/>'
      }, props)
  }
  export function RiEditorListCheck(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 4h13v2H8V4Zm-5-.5h3v3H3v-3Zm0 7h3v3H3v-3Zm0 7h3v3H3v-3ZM8 11h13v2H8v-2Zm0 7h13v2H8v-2Z"/>'
      }, props)
  }
  export function RiEditorListIndefinite(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 4h8v2h-8V4Zm0 7h8v2h-8v-2Zm0 7h8v2h-8v-2Zm-6.5 1a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM5 6v3h3V6H5ZM3 4h7v7H3V4Z"/>'
      }, props)
  }
  export function RiEditorListOrdered2(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.75 3.5H4.717l-1.467.393v1.553l1-.268V8.5H3V10h4V8.5H5.75v-5ZM10 4h11v2H10V4Zm0 7h11v2H10v-2Zm0 7h11v2H10v-2Zm-7.125-2.375a2.125 2.125 0 1 1 3.812 1.292l-.004.006L5.316 18.5H7V20H3v-1.121l2.472-2.844a.625.625 0 1 0-1.094-.466l-.013.306h-1.49v-.25Z"/>'
      }, props)
  }
  export function RiEditorListOrdered(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 4h13v2H8V4ZM5 3v3h1v1H3V6h1V4H3V3h2ZM3 14v-2.5h2V11H3v-1h3v2.5H4v.5h2v1H3Zm2 5.5H3v-1h2V18H3v-1h3v4H3v-1h2v-.5ZM8 11h13v2H8v-2Zm0 7h13v2H8v-2Z"/>'
      }, props)
  }
  export function RiEditorListRadio(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.5 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0Zm2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM21 4h-8v2h8V4Zm0 7h-8v2h8v-2Zm0 7h-8v2h8v-2ZM6.5 19a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiEditorListUnordered(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 4h13v2H8V4ZM4.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 6.9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM8 11h13v2H8v-2Zm0 7h13v2H8v-2Z"/>'
      }, props)
  }
  export function RiEditorMergeCellsHorizontal(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16Zm-9 2H5v5.999h2V9l3 3-3 3v-2H5v6h6v-2h2v2h6v-6h-2v2l-3-3 3-3v1.999h2V5h-6v2h-2V5Zm2 8v2h-2v-2h2Zm0-4v2h-2V9h2Z"/>'
      }, props)
  }
  export function RiEditorMergeCellsVertical(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16Zm-2-9V5h-5.999v2H15l-3 3-3-3h2V5H5v6h2v2H5v6h6v-2H9l3-3 3 3h-1.999v2H19v-6h-2v-2h2Zm-8 2H9v-2h2v2Zm4 0h-2v-2h2v2Z"/>'
      }, props)
  }
  export function RiEditorMindMap(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 3a3 3 0 1 1 0 6h-3a3.001 3.001 0 0 1-2.829-2H11c-1.1 0-2 .9-2 2v.171a3.001 3.001 0 0 1 0 5.658V15c0 1.1.9 2 2 2h1.17A3.001 3.001 0 0 1 15 15h3a3 3 0 1 1 0 6h-3a3.001 3.001 0 0 1-2.829-2H11c-2.21 0-4-1.79-4-4H5a3 3 0 1 1 0-6h2a4 4 0 0 1 4-4h1.17A3.001 3.001 0 0 1 15 3h3Zm0 14h-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2ZM8 11H5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2Zm10-6h-3a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2Z"/>'
      }, props)
  }
  export function RiEditorNodeTree(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H8v2h5V9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1H8v6h5v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1H7a1 1 0 0 1-1-1V8H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h6Zm9 16h-4v2h4v-2Zm0-8h-4v2h4v-2ZM9 4H5v2h4V4Z"/>'
      }, props)
  }
  export function RiEditorNumber0(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 1.5c1.321 0 2.484.348 3.447.994.963.645 1.726 1.588 2.249 2.778.522 1.19.804 2.625.804 4.257v4.942c0 1.632-.282 3.068-.804 4.257-.523 1.19-1.286 2.133-2.25 2.778-.962.646-2.125.994-3.446.994-1.321 0-2.484-.348-3.447-.994-.963-.645-1.726-1.588-2.249-2.778-.522-1.19-.804-2.625-.804-4.257V9.529c0-1.632.282-3.068.804-4.257.523-1.19 1.286-2.133 2.25-2.778C9.515 1.848 10.678 1.5 12 1.5Zm0 2c-.916 0-1.694.226-2.333.655-.637.427-1.158 1.07-1.532 1.92-.412.94-.635 2.108-.635 3.454v4.942c0 1.346.223 2.514.635 3.453.374.852.895 1.494 1.532 1.921.639.428 1.417.655 2.333.655.916 0 1.694-.227 2.333-.655.637-.427 1.158-1.07 1.531-1.92.413-.94.636-2.108.636-3.454V9.529c0-1.346-.223-2.514-.636-3.453-.373-.851-.894-1.494-1.53-1.921-.64-.429-1.418-.655-2.334-.655Z"/>'
      }, props)
  }
  export function RiEditorNumber1(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 1.5V22h-2V3.704L7.5 4.91V2.839l5-1.339H14Z"/>'
      }, props)
  }
  export function RiEditorNumber2(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 7.5a4 4 0 1 0-8 0H6a6 6 0 1 1 10.663 3.776l-7.319 8.723L18 20v2H6v-1.127l9.064-10.802A3.982 3.982 0 0 0 16 7.5Z"/>'
      }, props)
  }
  export function RiEditorNumber3(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 2v1.362L12.81 9.55a6.501 6.501 0 1 1-7.117 8.028l1.941-.486A4.502 4.502 0 0 0 16.5 16a4.5 4.5 0 0 0-6.505-4.03l-.228.122-.69-1.207L14.856 4 6.502 4V2H18Z"/>'
      }, props)
  }
  export function RiEditorNumber4(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 1.5V16h3v2h-3v4h-2v-4H4v-1.102L14 1.5h2ZM14 16V5.171L6.968 16H14Z"/>'
      }, props)
  }
  export function RiEditorNumber5(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 2v2H9.3l-.676 6.445a6.5 6.5 0 1 1-2.93 7.133l1.94-.486A4.502 4.502 0 0 0 16.5 16a4.5 4.5 0 0 0-4.5-4.5c-2.022 0-3.277.639-3.96 1.53l-1.575-1.182L7.501 2H18Z"/>'
      }, props)
  }
  export function RiEditorNumber6(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14.886 2-4.438 7.686A6.5 6.5 0 1 1 6.4 12.7L12.576 2h2.31ZM12 11.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z"/>'
      }, props)
  }
  export function RiEditorNumber7(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 2v1.5L10.763 22H8.574l8.013-18H6V2h13Z"/>'
      }, props)
  }
  export function RiEditorNumber8(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 1.5a5.5 5.5 0 0 1 3.352 9.86C17.24 12.41 18.5 14.32 18.5 16.5c0 3.314-2.91 6-6.5 6s-6.5-2.686-6.5-6c0-2.181 1.261-4.09 3.147-5.141A5.5 5.5 0 0 1 12 1.5Zm0 11c-2.52 0-4.5 1.828-4.5 4 0 2.172 1.98 4 4.5 4s4.5-1.828 4.5-4c0-2.172-1.98-4-4.5-4Zm0-9a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z"/>'
      }, props)
  }
  export function RiEditorNumber9(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 1.5a6.5 6.5 0 0 1 5.619 9.77l-6.196 10.729H9.114l4.439-7.686A6.5 6.5 0 1 1 12 1.5Zm0 2a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z"/>'
      }, props)
  }
  export function RiEditorOmega(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 20v-2.157c1.863-1.192 3.5-3.875 3.5-6.959 0-3.073-2-6.029-5.5-6.029s-5.5 2.956-5.5 6.03c0 3.083 1.637 5.766 3.5 6.958V20H3v-2h4.76C5.666 16.505 4 13.989 4 10.884 4 6.247 7.5 3 12 3s8 3.247 8 7.884c0 3.105-1.666 5.621-3.76 7.116H21v2h-7Z"/>'
      }, props)
  }
  export function RiEditorOrganizationChart(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2v2h4a1 1 0 0 1 1 1v3h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2v-2H8v2h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2v-3a1 1 0 0 1 1-1h4V9H9a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6ZM9 17H5v2h4v-2Zm10 0h-4v2h4v-2ZM14 5h-4v2h4V5Z"/>'
      }, props)
  }
  export function RiEditorOverline(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.246 18H8.754l-1.6 4H5l6-15h2l6 15h-2.154l-1.6-4Zm-.8-2L12 9.885 9.554 16h4.892ZM4 3h16v2H4V3Z"/>'
      }, props)
  }
  export function RiEditorPageSeparator(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 21v-4H7v4H5v-5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5h-2ZM7 3v4h10V3h2v5a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3h2ZM2 9l4 3-4 3V9Zm20 0v6l-4-3 4-3Z"/>'
      }, props)
  }
  export function RiEditorParagraph(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 6v15h-2v-5a6 6 0 0 1 0-12h10v2h-3v15h-2V6h-3Zm-2 0a4 4 0 1 0 0 8V6Z"/>'
      }, props)
  }
  export function RiEditorPinyinInput(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.934 3.036 1.732 1L18.531 6H21v2h-2v4h2v2h-2v7h-2v-7h-3.084c-.325 2.862-1.564 5.394-3.37 7.193l-1.562-1.27c1.52-1.438 2.596-3.522 2.917-5.922L10 14v-2l2-.001V8h-2V6h2.467l-1.133-1.964 1.732-1L14.777 6h1.444l1.713-2.964ZM5 13.803l-2 .536v-2.071l2-.536V8H3V6h2V3h2v3h2v2H7v3.197l2-.536v2.07l-2 .536V18.5A2.5 2.5 0 0 1 4.5 21H3v-2h1.5a.5.5 0 0 0 .492-.41L5 18.5v-4.697ZM17 8h-3v4h3V8Z"/>'
      }, props)
  }
  export function RiEditorQuestionMark(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 19a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm0-17a6 6 0 0 1 6 6c0 2.165-.753 3.29-2.674 4.923C13.399 14.56 13 15.297 13 17h-2c0-2.474.787-3.695 3.031-5.601C15.548 10.11 16 9.434 16 8a4 4 0 0 0-8 0v1H6V8a6 6 0 0 1 6-6Z"/>'
      }, props)
  }
  export function RiEditorQuoteText(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 4H3v2h18V4Zm0 7H8v2h13v-2Zm0 7H8v2h13v-2ZM5 11H3v9h2v-9Z"/>'
      }, props)
  }
  export function RiEditorRoundedCorner(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 19v2h-2v-2h2Zm-4 0v2h-2v-2h2Zm-4 0v2h-2v-2h2Zm-4 0v2H7v-2h2Zm-4 0v2H3v-2h2Zm16-4v2h-2v-2h2ZM5 15v2H3v-2h2Zm0-4v2H3v-2h2Zm11-8a5.002 5.002 0 0 1 4.995 4.783L21 8v5h-2V8a3.01 3.01 0 0 0-2.824-2.995L16 5h-5V3h5ZM5 7v2H3V7h2Zm0-4v2H3V3h2Zm4 0v2H7V3h2Z"/>'
      }, props)
  }
  export function RiEditorSendBackward(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 3a1 1 0 0 1 1 1v5h5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-5H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10Zm-1 2H5v8h4v-3a1 1 0 0 1 1-1h3V5Z"/>'
      }, props)
  }
  export function RiEditorSendToBack(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 3a1 1 0 0 1 1 1v2h5a1 1 0 0 1 1 1v5h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-2H7a1 1 0 0 1-1-1v-5H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7Zm5 5h-4v3a1 1 0 0 1-1 1H8v4h4v-3a1 1 0 0 1 1-1h3V8Z"/>'
      }, props)
  }
  export function RiEditorSeparator(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 11h2v2H2v-2Zm4 0h12v2H6v-2Zm14 0h2v2h-2v-2Z"/>'
      }, props)
  }
  export function RiEditorSingleQuotesL(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.583 17.321C8.553 16.227 8 15 8 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179Z"/>'
      }, props)
  }
  export function RiEditorSingleQuotesR(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.417 6.679C15.447 7.773 16 9 16 10.989c0 3.5-2.456 6.637-6.03 8.188l-.893-1.378c3.335-1.804 3.987-4.145 4.248-5.621-.537.278-1.24.375-1.93.311C9.591 12.322 8.17 10.841 8.17 9a3.5 3.5 0 0 1 3.5-3.5c1.073 0 2.1.49 2.748 1.179Z"/>'
      }, props)
  }
  export function RiEditorSketching(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.036 7.698c-1.651 1.861-3.523 4.546-5.141 7.784a1 1 0 1 1-1.79-.895c1.692-3.383 3.66-6.215 5.434-8.216.886-.999 1.74-1.81 2.506-2.38.382-.285.76-.523 1.123-.693.351-.166.753-.298 1.166-.298a1.24 1.24 0 0 1 1.116.69c.157.312.174.645.17.87-.008.477-.135 1.073-.298 1.68-.335 1.243-.923 2.891-1.507 4.518l-.082.228c-.566 1.574-1.123 3.123-1.485 4.36-.098.334-.177.633-.239.895.694-.557 1.55-1.396 2.457-2.288l.03-.029c.881-.866 1.814-1.782 2.6-2.411.391-.312.812-.609 1.218-.78.34-.145 1.12-.38 1.727.227.384.384.49.884.518 1.256.03.39-.016.81-.087 1.21-.14.8-.424 1.733-.683 2.575l-.041.135c-.232.751-.438 1.422-.555 1.96.26-.26.58-.674.954-1.285a1 1 0 1 1 1.706 1.045c-.543.886-1.105 1.606-1.701 2.053-.624.468-1.44.732-2.266.319-.608-.305-.746-.91-.777-1.246-.033-.363.02-.759.089-1.115.13-.673.385-1.497.625-2.276l.055-.178c.267-.868.51-1.679.625-2.334l.024-.145a8.35 8.35 0 0 0-.181.14c-.698.559-1.561 1.405-2.478 2.306l-.03.03c-.881.865-1.814 1.782-2.6 2.41-.391.313-.813.61-1.218.781-.34.145-1.12.38-1.727-.227-.309-.309-.388-.699-.413-.936a3.488 3.488 0 0 1 .023-.803c.068-.528.226-1.17.426-1.85.38-1.298.955-2.9 1.512-4.449l.092-.255c.593-1.652 1.149-3.214 1.457-4.36l.074-.286a6.896 6.896 0 0 0-.224.16c-.623.464-1.377 1.17-2.204 2.103Z"/>'
      }, props)
  }
  export function RiEditorSlashCommands(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h2v4H3V3Zm6.788 18H7.66l6.551-18h2.129L9.788 21ZM21 3h-2v4h2V3Z"/>'
      }, props)
  }
  export function RiEditorSortAsc(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19 3 4 5h-3v12h-2V8h-3l4-5Zm-5 15v2H3v-2h11Zm0-7v2H3v-2h11Zm-2-7v2H3V4h9Z"/>'
      }, props)
  }
  export function RiEditorSortDesc(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 4v12h3l-4 5-4-5h3V4h2Zm-8 14v2H3v-2h9Zm2-7v2H3v-2h11Zm0-7v2H3V4h11Z"/>'
      }, props)
  }
  export function RiEditorSpace(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 9v4h16V9h2v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V9h2Z"/>'
      }, props)
  }
  export function RiEditorSplitCellsHorizontal(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16Zm-9 2H5v14h6v-4h2v4h6V5h-6v4h-2V5Zm4 4 3 3-3 3v-2H9v2l-3-3 3-3v2h6V9Z"/>'
      }, props)
  }
  export function RiEditorSplitCellsVertical(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16Zm-1 2H5v5.999L9 11v2H5v6h14v-6h-4v-2l4-.001V5Zm-7 1 3 3h-2v6h2l-3 3-3-3h2V9H9l3-3Z"/>'
      }, props)
  }
  export function RiEditorStrikethrough2(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 9h-2V6H5V4h14v2h-6v3Zm0 6v5h-2v-5h2ZM3 11h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiEditorStrikethrough(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.154 14c.23.516.346 1.09.346 1.72 0 1.342-.524 2.392-1.571 3.147C14.88 19.622 13.434 20 11.586 20c-1.64 0-3.263-.381-4.87-1.145v-2.254c1.52.877 3.075 1.316 4.666 1.316 2.551 0 3.83-.732 3.839-2.197a2.21 2.21 0 0 0-.648-1.603l-.12-.117H3v-2h18v2h-3.846Zm-4.078-3H7.629a4.086 4.086 0 0 1-.481-.522C6.716 9.92 6.5 9.246 6.5 8.452c0-1.236.466-2.287 1.397-3.153C8.83 4.433 10.271 4 12.222 4c1.471 0 2.879.328 4.222.984v2.152c-1.2-.687-2.515-1.03-3.946-1.03-2.48 0-3.719.782-3.719 2.346 0 .42.218.786.654 1.099.436.313.974.563 1.613.75.62.18 1.297.414 2.03.699Z"/>'
      }, props)
  }
  export function RiEditorSubscript2(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 6v13H9V6H3V4h14v2h-6Zm8.55 10.58a.8.8 0 1 0-1.32-.36l-1.154.33A2.001 2.001 0 1 1 21 16c0 .573-.24 1.09-.627 1.454L18.744 19H21v1h-4v-1l2.55-2.42Z"/>'
      }, props)
  }
  export function RiEditorSubscript(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.596 4 10.5 9.928 15.404 4H18l-6.202 7.497L18 18.994V19h-2.59l-4.91-5.934L5.59 19H3v-.006l6.202-7.497L3 4h2.596ZM21.8 16a.8.8 0 1 0-1.57.22l-1.154.33A2.001 2.001 0 1 1 23 16c0 .573-.24 1.09-.627 1.454L20.744 19H23v1h-4v-1l2.55-2.42a.798.798 0 0 0 .25-.58Z"/>'
      }, props)
  }
  export function RiEditorSuperscript2(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 7v13H9V7H3V5h12v2h-4Zm8.55-.42a.8.8 0 1 0-1.32-.36l-1.154.33A2.001 2.001 0 1 1 21 6c0 .573-.24 1.09-.627 1.454L18.744 9H21v1h-4V9l2.55-2.42Z"/>'
      }, props)
  }
  export function RiEditorSuperscript(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m5.596 5 4.904 5.928L15.404 5H18l-6.202 7.497L18 19.994V20h-2.59l-4.91-5.934L5.59 20H3v-.006l6.202-7.497L3 5h2.596ZM21.55 6.58a.8.8 0 1 0-1.32-.36l-1.155.33A2.001 2.001 0 1 1 23 6c0 .573-.24 1.09-.627 1.454L20.744 9H23v1h-4V9l2.55-2.42Z"/>'
      }, props)
  }
  export function RiEditorTable2(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 10v4h6v-4h-6Zm-2 0H5v4h6v-4Zm2 9h6v-3h-6v3Zm-2 0v-3H5v3h6Zm2-14v3h6V5h-6Zm-2 0H5v3h6V5ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiEditorTextDirectionL(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 5v10H9v-4a4 4 0 1 1 0-8h8v2h-2v10h-2V5h-2ZM9 5a2 2 0 1 0 0 4V5Zm8 12v-2.5l4 3.5-4 3.5V19H5v-2h12Z"/>'
      }, props)
  }
  export function RiEditorTextDirectionR(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 5v10H9v-4a4 4 0 1 1 0-8h8v2h-2v10h-2V5h-2ZM9 5a2 2 0 1 0 0 4V5ZM7 17h12v2H7v2.5L3 18l4-3.5V17Z"/>'
      }, props)
  }
  export function RiEditorTextSpacing(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 17h10v-2.5l3.5 3.5-3.5 3.5V19H7v2.5L3.5 18 7 14.5V17Zm6-11v9h-2V6H5V4h14v2h-6Z"/>'
      }, props)
  }
  export function RiEditorTextWrap(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 18h1.5a2.5 2.5 0 0 0 0-5H3v-2h13.5a4.5 4.5 0 1 1 0 9H15v2l-4-3 4-3v2ZM3 4h18v2H3V4Zm6 14v2H3v-2h6Z"/>'
      }, props)
  }
  export function RiEditorText(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 6v15h-2V6H5V4h14v2h-6Z"/>'
      }, props)
  }
  export function RiEditorTranslate2(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.5 10 4.4 11h-2.155l-1.201-3h-4.09l-1.199 3h-2.154L16.5 10h2ZM10 2v2h6v2h-1.968a18.221 18.221 0 0 1-3.62 6.301 14.865 14.865 0 0 0 2.335 1.707l-.75 1.878A17.016 17.016 0 0 1 9 13.725a16.677 16.677 0 0 1-6.201 3.548l-.536-1.929a14.7 14.7 0 0 0 5.327-3.042A18.078 18.078 0 0 1 4.767 8h2.24A16.031 16.031 0 0 0 9 10.877a16.165 16.165 0 0 0 2.91-4.876L2 6V4h6V2h2Zm7.5 10.885L16.253 16h2.492L17.5 12.885Z"/>'
      }, props)
  }
  export function RiEditorTranslate(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 15v2a2 2 0 0 0 1.85 1.994L7 19h3v2H7a4 4 0 0 1-4-4v-2h2Zm13-5 4.4 11h-2.155l-1.201-3h-4.09l-1.199 3h-2.154L16 10h2Zm-1 2.885L15.753 16h2.492L17 12.885ZM8 2v2h4v7H8v3H6v-3H2V4h4V2h2Zm9 1a4 4 0 0 1 4 4v2h-2V7a2 2 0 0 0-2-2h-3V3h3ZM6 6H4v3h2V6Zm4 0H8v3h2V6Z"/>'
      }, props)
  }
  export function RiEditorUnderline(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 3v9a4 4 0 0 0 8 0V3h2v9a6 6 0 0 1-12 0V3h2ZM4 20h16v2H4v-2Z"/>'
      }, props)
  }
  export function RiEditorWubiInput(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 21v-2h3.662l1.234-7H5v-2h3.249l.881-5H4V3h16v2h-8.839l-.882 5H18v9h3v2H3Zm13-9H9.927l-1.235 7H16v-7Z"/>'
      }, props)
  }
  export function RiFinance24HoursFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 13.003a3 3 0 0 1 2.08 5.162l-1.91 1.838h2.83v2h-6l-.001-1.724 3.694-3.555a1 1 0 1 0-1.693-.72h-2a3 3 0 0 1 3-3.001Zm6 0v4h2v-4h2v9h-2v-3h-4v-6h2Zm-14-1a7.985 7.985 0 0 0 3 6.246v2.416a9.996 9.996 0 0 1-5-8.662h2Zm8-10c5.185 0 9.449 3.947 9.95 9h-2.012A8.001 8.001 0 0 0 5.87 6.868l2.135 2.135h-6v-6L4.45 5.449a9.977 9.977 0 0 1 7.554-3.446Z"/>'
      }, props)
  }
  export function RiFinance24HoursLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 13.003a3 3 0 0 1 2.08 5.162l-1.91 1.838h2.83v2h-6l-.001-1.724 3.694-3.555a1 1 0 1 0-1.693-.72h-2a3 3 0 0 1 3-3.001Zm6 0v4h2v-4h2v9h-2v-3h-4v-6h2Zm-14-1a7.985 7.985 0 0 0 3 6.246v2.416a9.996 9.996 0 0 1-5-8.662h2Zm8-10c5.185 0 9.449 3.947 9.95 9h-2.012a8.001 8.001 0 0 0-14.554-3.5h2.616v2h-6v-6h2v2.5a9.985 9.985 0 0 1 8-4Z"/>'
      }, props)
  }
  export function RiFinanceAuctionFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.005 20.003v2h-12v-2h12ZM14.59.689l7.778 7.778-1.414 1.414-1.061-.353-2.475 2.475 5.657 5.657-1.414 1.414-5.657-5.657L13.6 15.82l.283 1.131-1.415 1.415-7.778-7.779 1.414-1.414 1.132.283 6.293-6.293-.353-1.06L14.59.688Z"/>'
      }, props)
  }
  export function RiFinanceAuctionLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.005 20.003v2h-12v-2h12ZM14.59.689l7.778 7.778-1.414 1.414-1.061-.353-2.475 2.475 5.657 5.657-1.414 1.414-5.657-5.657L13.6 15.82l.283 1.131-1.415 1.415-7.778-7.779 1.414-1.414 1.132.283 6.293-6.293-.353-1.06L14.59.688Zm.707 3.535-7.071 7.072 3.535 3.535 7.071-7.071-3.535-3.535Z"/>'
      }, props)
  }
  export function RiFinanceBankCard2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.005 11v9a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-9h20Zm0-4h-20V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3Z"/>'
      }, props)
  }
  export function RiFinanceBankCard2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm17 9h-16v7h16v-7Zm0-4V5h-16v3h16Z"/>'
      }, props)
  }
  export function RiFinanceBankCardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.005 10v10a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V10h20Zm0-2h-20V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v4Zm-7 8v2h4v-2h-4Z"/>'
      }, props)
  }
  export function RiFinanceBankCardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm17 8h-16v8h16v-8Zm0-2V5h-16v4h16Zm-6 6h4v2h-4v-2Z"/>'
      }, props)
  }
  export function RiFinanceBitCoinFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm-1-6v2h2v-2h1a2.5 2.5 0 0 0 2-4 2.5 2.5 0 0 0-2-4h-1v-2h-2v2h-3v8h3Zm-1-3h4a.5.5 0 0 1 0 1h-4v-1Zm0-3h4a.5.5 0 0 1 0 1h-4v-1Z"/>'
      }, props)
  }
  export function RiFinanceBitCoinLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1-4h-3v-8h3v-2h2v2h1a2.5 2.5 0 0 1 2 4 2.5 2.5 0 0 1-2 4h-1v2h-2v-2Zm-1-3v1h4a.5.5 0 1 0 0-1h-4Zm0-3v1h4a.5.5 0 1 0 0-1h-4Z"/>'
      }, props)
  }
  export function RiFinanceCashFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 4.003h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1ZM6.5 6H4v2.5A2.5 2.5 0 0 0 6.5 6Zm11 0A2.5 2.5 0 0 0 20 8.5V6h-2.5ZM4 15.5V18h2.5A2.5 2.5 0 0 0 4 15.5ZM17.5 18H20v-2.5a2.5 2.5 0 0 0-2.5 2.5ZM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/>'
      }, props)
  }
  export function RiFinanceCashLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm9.005-11.997h-18a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-14a1 1 0 0 0-1-1Zm-17 11.643V8.354a3.508 3.508 0 0 0 2.35-2.351h11.291a3.508 3.508 0 0 0 2.359 2.353v7.288a3.508 3.508 0 0 0-2.36 2.359H6.355a3.508 3.508 0 0 0-2.351-2.357Z"/>'
      }, props)
  }
  export function RiFinanceCoinFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M23.005 12.003v2c0 3.314-4.925 6-11 6-5.967 0-10.824-2.591-10.995-5.823l-.005-.177v-2c0 3.314 4.925 6 11 6s11-2.686 11-6Zm-11-8c6.075 0 11 2.686 11 6s-4.925 6-11 6-11-2.686-11-6 4.925-6 11-6Z"/>'
      }, props)
  }
  export function RiFinanceCoinLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 4.003c6.075 0 11 2.686 11 6v4c0 3.314-4.925 6-11 6-5.967 0-10.824-2.591-10.995-5.823l-.005-.177v-4c0-3.314 4.925-6 11-6Zm0 12c-3.72 0-7.01-1.008-9-2.55v.55c0 1.882 3.883 4 9 4 5.01 0 8.838-2.03 8.995-3.882l.005-.118.001-.55c-1.99 1.542-5.28 2.55-9.001 2.55Zm0-10c-5.117 0-9 2.118-9 4 0 1.882 3.883 4 9 4s9-2.118 9-4c0-1.882-3.883-4-9-4Z"/>'
      }, props)
  }
  export function RiFinanceCoinsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.005 2.003a8 8 0 0 1 3.292 15.293A8 8 0 1 1 6.711 6.71a8.003 8.003 0 0 1 7.294-4.707Zm-3 7h-2v1a2.5 2.5 0 0 0-.164 4.995l.164.005h2l.09.008a.5.5 0 0 1 0 .984l-.09.008h-4v2h2v1h2v-1a2.5 2.5 0 0 0 .164-4.995l-.164-.005h-2l-.09-.008a.5.5 0 0 1 0-.984l.09-.008h4v-2h-2v-1Zm3-5A5.985 5.985 0 0 0 9.52 6.016a8 8 0 0 1 8.47 8.471 6 6 0 0 0-3.986-10.484Z"/>'
      }, props)
  }
  export function RiFinanceCoinsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.005 2.003a8 8 0 0 1 3.292 15.293A8 8 0 1 1 6.711 6.71a8.003 8.003 0 0 1 7.294-4.707Zm-4 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm1 1v1h2v2h-4a.5.5 0 0 0-.09.992l.09.008h2a2.5 2.5 0 0 1 0 5v1h-2v-1h-2v-2h4a.5.5 0 0 0 .09-.992l-.09-.008h-2a2.5 2.5 0 0 1 0-5v-1h2Zm3-5A5.985 5.985 0 0 0 9.52 6.016a8 8 0 0 1 8.47 8.471 6 6 0 0 0-3.986-10.484Z"/>'
      }, props)
  }
  export function RiFinanceCopperCoinFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-14.243-4.243 4.243 4.243 4.243 4.242-4.243-4.242-4.243Z"/>'
      }, props)
  }
  export function RiFinanceCopperCoinLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-12.95 4.95 4.95-4.95 4.95-4.95-4.95 4.95-4.95Zm0 2.829-2.121 2.12 2.12 2.122 2.122-2.121-2.121-2.121Z"/>'
      }, props)
  }
  export function RiFinanceCopperDiamondFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm-2.5-13-2.5 2.5 5 5 5-5-2.5-2.5h-5Z"/>'
      }, props)
  }
  export function RiFinanceCopperDiamondLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-3-12h6l2.5 3.5-5.5 5.5-5.5-5.5 2.5-3.5Zm1.03 2-.92 1.29 2.89 2.89 2.89-2.89-.92-1.29h-3.94Z"/>'
      }, props)
  }
  export function RiFinanceCoupon2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.005 3v18h-11a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5V4a1 1 0 0 1 1-1h11Zm2 0h5a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-5V3Z"/>'
      }, props)
  }
  export function RiFinanceCoupon2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.005 9.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5Zm12-4.5h-10v2.968a4.5 4.5 0 0 1 0 8.064V19h10V5Zm2 0v14h4v-2.968a4.5 4.5 0 0 1 0-8.064V5h-4Z"/>'
      }, props)
  }
  export function RiFinanceCoupon3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.005 21a1.5 1.5 0 0 0-3 0h-5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a1.5 1.5 0 0 0 3 0h10a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-10Zm-1.5-10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiFinanceCoupon3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.005 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4ZM8.09 19a1.5 1.5 0 0 1 2.83 0h9.085v-2.968a4.5 4.5 0 0 1 0-8.064V5H10.92a1.5 1.5 0 0 1-2.83 0H4.005v14H8.09Zm1.415-8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiFinanceCoupon4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.005 21h-7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7a2 2 0 1 0 4 0h7a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-7a2 2 0 1 0-4 0Zm-4-13v8h2V8h-2Zm10 0v8h2V8h-2Z"/>'
      }, props)
  }
  export function RiFinanceCoupon4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.005 21h-7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7a2 2 0 1 0 4 0h7a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-7a2 2 0 1 0-4 0ZM8.54 19a3.998 3.998 0 0 1 3.465-2c1.48 0 2.773.804 3.465 2h4.535V5H15.47a3.999 3.999 0 0 1-3.465 2A3.998 3.998 0 0 1 8.54 5H4.005v14H8.54ZM6.005 8h2v8h-2V8Zm10 0h2v8h-2V8Z"/>'
      }, props)
  }
  export function RiFinanceCoupon5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.005 14v7a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-7a2 2 0 1 0 0-4V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 1 0 0 4Zm-12-8v2h6V6h-6Zm0 10v2h6v-2h-6Z"/>'
      }, props)
  }
  export function RiFinanceCoupon5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.005 14v7a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-7a2 2 0 1 0 0-4V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v7a2 2 0 1 0 0 4Zm-2 1.465a3.998 3.998 0 0 1-2-3.465c0-1.48.804-2.773 2-3.465V4h-14v4.535c1.195.692 2 1.984 2 3.465 0 1.48-.805 2.773-2 3.465V20h14v-4.535ZM9.005 6h6v2h-6V6Zm0 10h6v2h-6v-2Z"/>'
      }, props)
  }
  export function RiFinanceCouponFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.005 9.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5Zm7-.5v2h6V9h-6Zm0 4v2h6v-2h-6Z"/>'
      }, props)
  }
  export function RiFinanceCouponLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.005 9.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5Zm2-1.532a4.5 4.5 0 0 1 0 8.064V19h16v-2.968a4.5 4.5 0 0 1 0-8.064V5h-16v2.968Zm5 1.032h6v2h-6V9Zm0 4h6v2h-6v-2Z"/>'
      }, props)
  }
  export function RiFinanceCurrencyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.005 16.003h2v-12h-10v2h8v10Zm0 2v3c0 .552-.45 1-1.007 1H4.012a1.001 1.001 0 0 1-1.007-1l.002-14c0-.552.45-1 1.007-1h2.99v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3Zm-10-2v2h2v1h2v-1h.5a2.5 2.5 0 0 0 0-5h-3a.5.5 0 1 1 0-1h4.5v-2h-2v-1h-2v1h-.5a2.5 2.5 0 0 0 0 5h3a.5.5 0 0 1 0 1h-4.5Z"/>'
      }, props)
  }
  export function RiFinanceCurrencyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.005 16.003h2v-12h-10v2h8v10Zm0 2v3c0 .552-.45 1-1.007 1H4.012a1.001 1.001 0 0 1-1.007-1l.002-14c0-.552.45-1 1.007-1h2.99v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3Zm-11.998-10-.002 12h10v-12H5.007Zm1.998 8h4.5a.5.5 0 1 0 0-1h-3a2.5 2.5 0 0 1 0-5h.5v-1h2v1h2v2h-4.5a.5.5 0 0 0 0 1h3a2.5 2.5 0 0 1 0 5h-.5v1h-2v-1h-2v-2Z"/>'
      }, props)
  }
  export function RiFinanceExchangeBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm9 6h-4v2h9l-5-5v3Zm-5 4 5 5v-3h4v-2h-9Z"/>'
      }, props)
  }
  export function RiFinanceExchangeBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.005 5.003v14h16v-14h-16Zm-1-2h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm9 6v-3l5 5h-9v-2h4Zm-5 4h9v2h-4v3l-5-5Z"/>'
      }, props)
  }
  export function RiFinanceExchangeCnyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.378 4.514a9.962 9.962 0 0 1 6.627-2.511c5.523 0 10 4.477 10 10a9.954 9.954 0 0 1-1.793 5.715l-2.707-5.715h2.5A8 8 0 0 0 6.279 6.416l-.9-1.902Zm13.253 14.978a9.962 9.962 0 0 1-6.626 2.51c-5.523 0-10-4.476-10-10 0-2.124.663-4.094 1.793-5.714l2.707 5.715h-2.5A8 8 0 0 0 17.73 17.59l.901 1.902Zm-5.626-5.954h3v2h-3v2h-2v-2h-3v-2h3v-1h-3v-2h2.586l-2.122-2.12 1.415-1.415 2.12 2.121 2.122-2.121 1.414 1.414-2.12 2.122h2.585v2h-3v1Z"/>'
      }, props)
  }
  export function RiFinanceExchangeCnyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.379 15.106A8.001 8.001 0 0 0 8.035 5.056l-.993-1.737a9.996 9.996 0 0 1 9.962.023c4.49 2.593 6.21 8.143 4.118 12.77l1.341.775-4.165 2.214-.165-4.714 1.246.719ZM4.629 8.9a8.001 8.001 0 0 0 11.345 10.05l.992 1.737a9.995 9.995 0 0 1-9.962-.024C2.514 18.07.794 12.52 2.887 7.893L1.545 7.12 5.71 4.905l.165 4.714-1.245-.72Zm8.375 4.638h3v2h-3v2h-2v-2h-3v-2h3v-1h-3v-2h2.586L8.469 8.417l1.414-1.414 2.121 2.121 2.122-2.121 1.414 1.414-2.122 2.121h2.586v2h-3v1Z"/>'
      }, props)
  }
  export function RiFinanceExchangeDollarFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.378 4.514a9.962 9.962 0 0 1 6.627-2.511c5.523 0 10 4.477 10 10a9.954 9.954 0 0 1-1.793 5.715l-2.707-5.715h2.5A8 8 0 0 0 6.279 6.416l-.9-1.902Zm13.253 14.978a9.962 9.962 0 0 1-6.626 2.51c-5.523 0-10-4.476-10-10 0-2.124.663-4.094 1.793-5.714l2.707 5.715h-2.5A8 8 0 0 0 17.73 17.59l.901 1.902Zm-10.126-5.49h5.5a.5.5 0 1 0 0-1h-4a2.5 2.5 0 1 1 0-5h1v-1h2v1h2.5v2h-5.5a.5.5 0 0 0 0 1h4a2.5 2.5 0 0 1 0 5h-1v1h-2v-1h-2.5v-2Z"/>'
      }, props)
  }
  export function RiFinanceExchangeDollarLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.379 15.106A8.001 8.001 0 0 0 8.035 5.056l-.993-1.737a9.996 9.996 0 0 1 9.962.023c4.49 2.593 6.21 8.143 4.118 12.77l1.341.775-4.165 2.214-.165-4.714 1.246.719ZM4.629 8.9a8.001 8.001 0 0 0 11.345 10.05l.992 1.737a9.995 9.995 0 0 1-9.962-.024C2.514 18.07.794 12.52 2.887 7.893L1.545 7.12 5.71 4.905l.165 4.714-1.245-.72Zm3.875 5.103h5.5a.5.5 0 1 0 0-1h-4a2.5 2.5 0 1 1 0-5h1v-1h2v1h2.5v2h-5.5a.5.5 0 0 0 0 1h4a2.5 2.5 0 0 1 0 5h-1v1h-2v-1h-2.5v-2Z"/>'
      }, props)
  }
  export function RiFinanceExchangeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-13h-4v2h9l-5-5v3Zm-5 4 5 5v-3h4v-2h-9Z"/>'
      }, props)
  }
  export function RiFinanceExchangeFundsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.378 4.514a9.962 9.962 0 0 1 6.627-2.511c5.523 0 10 4.477 10 10a9.954 9.954 0 0 1-1.793 5.715l-2.707-5.715h2.5A8 8 0 0 0 6.279 6.416l-.9-1.902Zm13.253 14.978a9.962 9.962 0 0 1-6.626 2.51c-5.523 0-10-4.476-10-10 0-2.124.663-4.094 1.793-5.714l2.707 5.715h-2.5A8 8 0 0 0 17.73 17.59l.901 1.902Zm-5.212-4.66-2.828-2.83-2.829 2.83-1.414-1.415 4.243-4.242 2.828 2.828 2.828-2.829 1.415 1.415-4.243 4.242Z"/>'
      }, props)
  }
  export function RiFinanceExchangeFundsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.379 15.106A8.001 8.001 0 0 0 8.035 5.056l-.993-1.737a9.996 9.996 0 0 1 9.962.023c4.49 2.593 6.21 8.143 4.118 12.77l1.341.775-4.165 2.214-.165-4.714 1.246.719ZM4.629 8.9a8.001 8.001 0 0 0 11.345 10.05l.992 1.737a9.995 9.995 0 0 1-9.962-.024C2.514 18.07.794 12.52 2.887 7.893L1.545 7.12 5.71 4.905l.165 4.714-1.245-.72Zm8.79 5.931-2.829-2.828-2.828 2.828-1.415-1.414 4.243-4.243 2.828 2.829 2.829-2.829 1.414 1.414-4.243 4.243Z"/>'
      }, props)
  }
  export function RiFinanceExchangeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-5-7h9v2h-4v3l-5-5Zm5-4v-3l5 5h-9v-2h4Z"/>'
      }, props)
  }
  export function RiFinanceFundsBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm11.793 6.793-2.45 2.45-2.121-2.122-4.243 4.243 1.414 1.414 2.829-2.828 2.121 2.121 3.864-3.864 1.793 1.793v-5h-5l1.793 1.793Z"/>'
      }, props)
  }
  export function RiFinanceFundsBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.005 5.003v14h16v-14h-16Zm-1-2h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm11.793 6.793-1.793-1.793h5v5l-1.793-1.793-3.864 3.864-2.121-2.121-2.829 2.828-1.414-1.414 4.243-4.243 2.121 2.122 2.45-2.45Z"/>'
      }, props)
  }
  export function RiFinanceFundsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3.901 17.864 3.911-3.911 2.829 2.828 4.571-4.571 1.793 1.793v-5h-5l1.793 1.793-3.157 3.157-2.829-2.829-4.945 4.946a9.965 9.965 0 0 1-.862-4.067c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10a9.987 9.987 0 0 1-8.104-4.14Z"/>'
      }, props)
  }
  export function RiFinanceFundsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4.41 14.526 3.402-3.402 2.829 2.829 3.157-3.157-1.793-1.793h5v5l-1.793-1.793-4.571 4.571-2.829-2.828-2.474 2.474a8 8 0 1 0-.927-1.9Zm-1.537 1.558-.01-.01.004-.004a9.965 9.965 0 0 1-.862-4.067c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10c-4.07 0-7.57-2.43-9.132-5.919Z"/>'
      }, props)
  }
  export function RiFinanceGift2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.005 13.003v7a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-7h16Zm-5.5-11a3.5 3.5 0 0 1 3.163 5.001l3.337-.001a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1l3.337.001a3.5 3.5 0 0 1 5.664-3.95 3.48 3.48 0 0 1 2.499-1.051Zm-5 2a1.5 1.5 0 0 0-.145 2.993l.145.007h1.5v-1.5A1.5 1.5 0 0 0 9.649 4.01l-.144-.007Zm5 0-.145.007a1.5 1.5 0 0 0-1.348 1.348l-.007.145v1.5h1.5l.144-.007a1.5 1.5 0 0 0 0-2.986l-.144-.007Z"/>'
      }, props)
  }
  export function RiFinanceGift2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.505 2.003a3.5 3.5 0 0 1 3.163 5.001l3.337-.001a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v8a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-8h-1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1l3.337.001a3.5 3.5 0 0 1 5.664-3.95 3.48 3.48 0 0 1 2.499-1.051Zm3.5 11h-12v7h12v-7Zm2-4h-16v2h16v-2Zm-10.5-5a1.5 1.5 0 0 0-.145 2.993l.145.007h1.5v-1.5A1.5 1.5 0 0 0 9.649 4.01l-.144-.007Zm5 0-.145.007a1.5 1.5 0 0 0-1.348 1.348l-.007.145v1.5h1.5l.144-.007a1.5 1.5 0 0 0 0-2.986l-.144-.007Z"/>'
      }, props)
  }
  export function RiFinanceGiftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.005 2.003a4 4 0 0 1 3.464 6.001l4.536-.001v2h-2v10a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-10h-2v-2l4.536.001a4 4 0 0 1 6.465-4.646 3.983 3.983 0 0 1 2.999-1.355Zm-2 8h-2v10h2v-10Zm-4-6a2 2 0 0 0-.15 3.994l.15.006h2v-2a2 2 0 0 0-1.697-1.977l-.154-.018-.15-.005Zm6 0a2 2 0 0 0-1.995 1.85l-.005.15v2h2a2 2 0 0 0 1.994-1.85l.006-.15a2 2 0 0 0-2-2Z"/>'
      }, props)
  }
  export function RiFinanceGiftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.005 2.003a4 4 0 0 1 3.464 6.001l4.536-.001v2h-2v10a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-10h-2v-2l4.536.001a4 4 0 0 1 6.465-4.646 3.983 3.983 0 0 1 2.999-1.355Zm-4 8h-6v9h6v-9Zm8 0h-6v9h6v-9Zm-10-6a2 2 0 0 0-.15 3.994l.15.006h2v-2a2 2 0 0 0-1.697-1.977l-.154-.018-.15-.005Zm6 0a2 2 0 0 0-1.995 1.85l-.005.15v2h2a2 2 0 0 0 1.994-1.85l.006-.15a2 2 0 0 0-2-2Z"/>'
      }, props)
  }
  export function RiFinanceHandCoinFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.335 11.502h2.17a4.5 4.5 0 0 1 4.5 4.5H9.004v1h8v-1a5.578 5.578 0 0 0-.885-3h2.886a5 5 0 0 1 4.516 2.852c-2.365 3.121-6.194 5.149-10.516 5.149-2.761 0-5.1-.59-7-1.625v-9.304a6.966 6.966 0 0 1 3.33 1.428Zm-4.33 7.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9Zm13-14a3 3 0 1 1 0 6.001 3 3 0 0 1 0-6Zm-7-3a3 3 0 1 1 0 6.001 3 3 0 0 1 0-6Z"/>'
      }, props)
  }
  export function RiFinanceHandCoinLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.005 9.003a1 1 0 0 1 1 1 6.97 6.97 0 0 1 4.33 1.5h2.17c1.332 0 2.53.58 3.354 1.5h3.146a5 5 0 0 1 4.516 2.851c-2.365 3.121-6.194 5.149-10.516 5.149-2.79 0-5.15-.603-7.061-1.658a.998.998 0 0 1-.94.658h-3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h3Zm1 3v5.022l.045.032c1.794 1.26 4.133 1.946 6.955 1.946 3.004 0 5.798-1.156 7.835-3.13l.133-.133-.12-.1a2.994 2.994 0 0 0-1.643-.63l-.205-.007h-2.112c.073.322.112.656.112 1v1h-9v-2l6.79-.001-.034-.079a2.501 2.501 0 0 0-2.092-1.415l-.164-.005h-2.93a4.985 4.985 0 0 0-3.57-1.5Zm-2-1h-1v7h1v-7Zm14-6a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-7-5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiFinanceHandHeartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.335 11.502h2.17a4.5 4.5 0 0 1 4.5 4.5H9.004v1h8v-1a5.578 5.578 0 0 0-.885-3h2.886a5 5 0 0 1 4.516 2.852c-2.365 3.12-6.194 5.149-10.516 5.149-2.761 0-5.1-.591-7-1.625v-9.304a6.966 6.966 0 0 1 3.33 1.428Zm-5.33-2.5a1 1 0 0 1 .993.884l.007.116v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h2Zm9.646-5.424.354.354.353-.354a2.5 2.5 0 0 1 3.536 3.535l-3.89 3.89-3.888-3.89a2.5 2.5 0 1 1 3.535-3.535Z"/>'
      }, props)
  }
  export function RiFinanceHandHeartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.005 9.003a1 1 0 0 1 1 1 6.97 6.97 0 0 1 4.33 1.5h2.17c1.332 0 2.529.578 3.353 1.498l3.147.002a5 5 0 0 1 4.516 2.851c-2.365 3.12-6.194 5.149-10.516 5.149-2.79 0-5.15-.604-7.061-1.658a.998.998 0 0 1-.94.658h-3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h3Zm1 3v5.02l.045.034c1.794 1.26 4.133 1.946 6.955 1.946 3.004 0 5.798-1.156 7.835-3.13l.133-.133-.12-.1a2.994 2.994 0 0 0-1.643-.63l-.205-.007-2.112-.001c.073.321.112.656.112 1v1h-9v-2h6.79l-.034-.079a2.5 2.5 0 0 0-2.092-1.415l-.164-.005h-2.93a4.984 4.984 0 0 0-3.57-1.5Zm-2-1h-1v7h1v-7Zm9.646-7.425.354.354.353-.354a2.5 2.5 0 0 1 3.536 3.535l-3.89 3.89-3.888-3.89a2.5 2.5 0 1 1 3.535-3.535ZM11.53 4.992a.5.5 0 0 0-.059.637l.058.07 2.475 2.475 2.476-2.475a.5.5 0 0 0 .058-.638l-.058-.069a.5.5 0 0 0-.638-.058l-.07.058-1.769 1.769-1.767-1.77-.068-.057a.5.5 0 0 0-.638.058Z"/>'
      }, props)
  }
  export function RiFinanceIncreaseDecreaseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm6 8v-2h-2v2h-2v2h2v2h2v-2h2v-2h-2Zm4 0v2h6v-2h-6Z"/>'
      }, props)
  }
  export function RiFinanceIncreaseDecreaseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm1 2v14h16v-14h-16Zm5 6h2v2h-2v2h-2v-2h-2v-2h2v-2h2v2Zm4 0h6v2h-6v-2Z"/>'
      }, props)
  }
  export function RiFinanceMoneyCnyBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm10 10v-1h3v-2h-2.586l2.121-2.121-1.414-1.415-2.121 2.122-2.121-2.122-1.415 1.415 2.122 2.12H8.005v2h3v1h-3v2h3v2h2v-2h3v-2h-3Z"/>'
      }, props)
  }
  export function RiFinanceMoneyCnyBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm1 2v14h16v-14h-16Zm9 8h3v2h-3v2h-2v-2h-3v-2h3v-1h-3v-2h2.586L8.469 7.882l1.415-1.415 2.12 2.122 2.122-2.122 1.414 1.415-2.12 2.12h2.585v2h-3v1Z"/>'
      }, props)
  }
  export function RiFinanceMoneyCnyCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm1-9v-1h3v-2h-2.586l2.121-2.121-1.414-1.415-2.121 2.122-2.121-2.122-1.415 1.415 2.122 2.12H8.005v2h3v1h-3v2h3v2h2v-2h3v-2h-3Z"/>'
      }, props)
  }
  export function RiFinanceMoneyCnyCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-7h3v2h-3v2h-2v-2h-3v-2h3v-1h-3v-2h2.586L8.469 7.882l1.415-1.415 2.12 2.122 2.122-2.122 1.414 1.415-2.12 2.12h2.585v2h-3v1Z"/>'
      }, props)
  }
  export function RiFinanceMoneyDollarBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm5.5 11v2h2.5v2h2v-2h1a2.5 2.5 0 0 0 0-5h-4a.5.5 0 1 1 0-1h5.5v-2h-2.5v-2h-2v2h-1a2.5 2.5 0 1 0 0 5h4a.5.5 0 0 1 0 1h-5.5Z"/>'
      }, props)
  }
  export function RiFinanceMoneyDollarBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm1 2v14h16v-14h-16Zm4.5 9h5.5a.5.5 0 1 0 0-1h-4a2.5 2.5 0 1 1 0-5h1v-2h2v2h2.5v2h-5.5a.5.5 0 0 0 0 1h4a2.5 2.5 0 0 1 0 5h-1v2h-2v-2h-2.5v-2Z"/>'
      }, props)
  }
  export function RiFinanceMoneyDollarCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm-3.5-8v2h2.5v2h2v-2h1a2.5 2.5 0 0 0 0-5h-4a.5.5 0 1 1 0-1h5.5v-2h-2.5v-2h-2v2h-1a2.5 2.5 0 1 0 0 5h4a.5.5 0 0 1 0 1h-5.5Z"/>'
      }, props)
  }
  export function RiFinanceMoneyDollarCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-3.5-6h5.5a.5.5 0 1 0 0-1h-4a2.5 2.5 0 1 1 0-5h1v-2h2v2h2.5v2h-5.5a.5.5 0 0 0 0 1h4a2.5 2.5 0 0 1 0 5h-1v2h-2v-2h-2.5v-2Z"/>'
      }, props)
  }
  export function RiFinanceMoneyEuroBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm7.05 8a2.5 2.5 0 0 1 4.064-1.41l1.7-1.133a4.5 4.5 0 0 0-7.787 2.543H7.005v2h1.027a4.5 4.5 0 0 0 7.788 2.543l-1.701-1.134a2.5 2.5 0 0 1-4.064-1.41h4.95v-2h-4.95Z"/>'
      }, props)
  }
  export function RiFinanceMoneyEuroBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm1 2v14h16v-14h-16Zm6.05 6h4.95v2h-4.95a2.5 2.5 0 0 0 4.064 1.41l1.7 1.133a4.5 4.5 0 0 1-7.787-2.543H7.005v-2h1.027A4.5 4.5 0 0 1 15.82 8.46l-1.701 1.134a2.5 2.5 0 0 0-4.064 1.41Z"/>'
      }, props)
  }
  export function RiFinanceMoneyEuroCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm-1.95-11a2.5 2.5 0 0 1 4.064-1.41l1.7-1.133a4.5 4.5 0 0 0-7.787 2.543H7.005v2h1.027a4.5 4.5 0 0 0 7.788 2.543l-1.701-1.134a2.5 2.5 0 0 1-4.064-1.41h4.95v-2h-4.95Z"/>'
      }, props)
  }
  export function RiFinanceMoneyEuroCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1.95-9h4.95v2h-4.95a2.5 2.5 0 0 0 4.064 1.41l1.7 1.133a4.5 4.5 0 0 1-7.787-2.543H7.005v-2h1.027A4.5 4.5 0 0 1 15.82 8.46l-1.701 1.134a2.5 2.5 0 0 0-4.064 1.41Z"/>'
      }, props)
  }
  export function RiFinanceMoneyPoundBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm6 10v2h-1v2h8v-2h-5v-2h3v-2h-3v-1a1.5 1.5 0 0 1 2.76-.815l1.986-.497a3.501 3.501 0 0 0-6.746 1.312v1h-1v2h1Z"/>'
      }, props)
  }
  export function RiFinanceMoneyPoundBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm1 2v14h16v-14h-16Zm5 8h-1v-2h1v-1A3.5 3.5 0 0 1 15.75 8.69l-1.987.497a1.499 1.499 0 0 0-2.76.815v1h3v2h-3v2h5v2h-8v-2h1v-2Z"/>'
      }, props)
  }
  export function RiFinanceMoneyPoundCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm-3-9v2h-1v2h8v-2h-5v-2h3v-2h-3v-1a1.5 1.5 0 0 1 2.76-.815l1.986-.497a3.501 3.501 0 0 0-6.746 1.312v1h-1v2h1Z"/>'
      }, props)
  }
  export function RiFinanceMoneyPoundCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-3-7h-1v-2h1v-1A3.5 3.5 0 0 1 15.75 8.69l-1.987.497a1.499 1.499 0 0 0-2.76.815v1h3v2h-3v2h5v2h-8v-2h1v-2Z"/>'
      }, props)
  }
  export function RiFinanceNftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-11 9.5 5.5v11L12 23l-9.5-5.5v-11L12 1ZM4.5 7.653v8.694l2.372 1.373 8.073-5.92 4.555 2.734v-6.88L12 3.31 4.5 7.653Z"/>'
      }, props)
  }
  export function RiFinanceNftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12.5-5.5L12 1 2.5 6.5v11L12 23l9.5-5.5v-11ZM12 3.311l7.5 4.342v6.88l-4.562-2.736-7.971 5.978L4.5 16.347V7.653L12 3.311Zm0 17.378-3.152-1.825 6.214-4.66 3.998 2.398L12 20.689Z"/>'
      }, props)
  }
  export function RiFinanceP2pFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM7 3a4 4 0 0 0-4 4v2h2V7a2 2 0 0 1 2-2h3V3H7Zm10 18a4 4 0 0 0 4-4v-2h-2v2a2 2 0 0 1-2 2h-3v2h3ZM7 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm10-7a4 4 0 0 0-4 4h8a4 4 0 0 0-4-4ZM3 21a4 4 0 0 1 8 0H3Z"/>'
      }, props)
  }
  export function RiFinanceP2pLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM7 3a4 4 0 0 0-4 4v2h2V7a2 2 0 0 1 2-2h3V3H7Zm10 18a4 4 0 0 0 4-4v-2h-2v2a2 2 0 0 1-2 2h-3v2h3Zm-9-8a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm7-2a2 2 0 0 0-2 2h-2a4 4 0 0 1 8 0h-2a2 2 0 0 0-2-2ZM5 21a2 2 0 1 1 4 0h2a4 4 0 0 0-8 0h2Z"/>'
      }, props)
  }
  export function RiFinancePercentFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.505 21.003a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm-11-11a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm12.571-6.485 1.414 1.414L4.934 20.488 3.52 19.074 19.076 3.518Z"/>'
      }, props)
  }
  export function RiFinancePercentLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.505 21.003a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-11-9a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm12.571-4.485 1.414 1.414L4.934 20.488 3.52 19.074 19.076 3.518Z"/>'
      }, props)
  }
  export function RiFinancePriceTag2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3.005 7 8.445-5.63a1 1 0 0 1 1.11 0L21.005 7v14a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V7Zm9 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-4 5v2h8v-2h-8Zm0-3v2h8v-2h-8Z"/>'
      }, props)
  }
  export function RiFinancePriceTag2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3.005 7 8.445-5.63a1 1 0 0 1 1.11 0L21.005 7v14a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V7Zm2 1.07V20h14V8.07l-7-4.666-7 4.666Zm3 7.93h8v2h-8v-2Zm0-3h8v2h-8v-2Zm4-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiFinancePriceTag3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.904 2.1 9.9 1.414 1.414 9.9-9.193 9.192a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.413L10.905 2.1Zm2.829 8.485a2 2 0 1 0 2.828-2.828 2 2 0 0 0-2.828 2.828Z"/>'
      }, props)
  }
  export function RiFinancePriceTag3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.904 2.1 9.9 1.414 1.414 9.9-9.193 9.192a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.413L10.905 2.1Zm.707 2.121L3.833 12l8.485 8.485 7.779-7.778-1.061-7.425-7.425-1.06Zm2.122 6.364a2 2 0 1 1 2.828-2.828 2 2 0 0 1-2.828 2.828Z"/>'
      }, props)
  }
  export function RiFinancePriceTagFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3.005 7 8.445-5.63a1 1 0 0 1 1.11 0L21.005 7v14a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V7Zm9 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiFinancePriceTagLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3.005 7 8.445-5.63a1 1 0 0 1 1.11 0L21.005 7v14a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V7Zm2 1.07V20h14V8.07l-7-4.666-7 4.666Zm7 2.93a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiFinanceRedPacketFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.005 5.94a11.985 11.985 0 0 1-6.806 3.863 2.5 2.5 0 0 0-4.388 0A11.985 11.985 0 0 1 3.005 5.94V3.003a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1V5.94Zm0 2.787v12.276a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V8.727a13.944 13.944 0 0 0 6.63 3.076 2.501 2.501 0 0 0 4.739 0 13.944 13.944 0 0 0 6.63-3.076Z"/>'
      }, props)
  }
  export function RiFinanceRedPacketLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.178 9.766a9.981 9.981 0 0 0 4.827-2.622V4.003h-14v3.141a9.98 9.98 0 0 0 4.827 2.622 2.5 2.5 0 0 1 4.346 0Zm.208 2a2.501 2.501 0 0 1-4.762 0 11.94 11.94 0 0 1-4.62-2.015v10.252h14V9.75a11.94 11.94 0 0 1-4.618 2.016ZM4.005 2.004h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-18a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiFinanceRefund2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.96 9.96 0 0 1-6.383-2.302l-.244-.209.901-1.902a8 8 0 1 0-2.27-5.837l-.004.25h2.5l-2.706 5.716A9.954 9.954 0 0 1 2.005 12c0-5.523 4.477-10 10-10Zm1 4v2h2.5v2h-5.5a.5.5 0 0 0-.09.992l.09.008h4a2.5 2.5 0 0 1 0 5h-1v2h-2v-2h-2.5v-2h5.5a.5.5 0 0 0 .09-.992l-.09-.008h-4a2.5 2.5 0 1 1 0-5h1V6h2Z"/>'
      }, props)
  }
  export function RiFinanceRefund2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.676 4.257c3.928-3.219 9.733-2.995 13.4.672 3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0a9.993 9.993 0 0 1-2.678-9.304l.077-.313 1.934.51a8 8 0 1 0 3.053-4.45L7.1 5.68l1.017 1.017-4.596 1.06 1.06-4.596 1.096 1.096ZM13.005 6v2h2.5v2h-5.5a.5.5 0 0 0-.09.992l.09.008h4a2.5 2.5 0 0 1 0 5h-1v2h-2v-2h-2.5v-2h5.5a.5.5 0 0 0 .09-.992l-.09-.008h-4a2.5 2.5 0 1 1 0-5h1V6h2Z"/>'
      }, props)
  }
  export function RiFinanceRefundFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.005 7h-20V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3Zm0 2v11a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V9h20Zm-11 5v-2.5l-4.5 4.5h10.5v-2h-6Z"/>'
      }, props)
  }
  export function RiFinanceRefundLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.005 8V5h-16v3h16Zm0 2h-16v9h16v-9Zm-17-7h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm8 11h6v2h-10.5l4.5-4.5V14Z"/>'
      }, props)
  }
  export function RiFinanceSafe2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.005 20h-4v2h-2v-2h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7V1.59a.5.5 0 0 1 .582-.493L21.17 2.86a1 1 0 0 1 .836.987V6h1v2h-1v7h1v2h-1v2.152a1 1 0 0 1-.836.987l-1.164.194V22h-2v-1.334l-7.418 1.237a.5.5 0 0 1-.582-.494V20Zm2-.361 8-1.334V4.694l-8-1.333v16.278Zm4.5-5.64c-.828 0-1.5-1.119-1.5-2.5 0-1.38.671-2.5 1.5-2.5.828 0 1.5 1.12 1.5 2.5 0 1.381-.672 2.5-1.5 2.5Z"/>'
      }, props)
  }
  export function RiFinanceSafe2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.005 20.333V22h-2v-1.334l-7.418 1.237a.5.5 0 0 1-.582-.494V20h-4v2h-2v-2h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7V1.59a.5.5 0 0 1 .582-.492L21.17 2.86a1 1 0 0 1 .836.987V6h1v2h-1v7h1v2h-1v2.152a1 1 0 0 1-.836.987l-1.164.194ZM4.005 5v13h6V5h-6Zm8 14.639 8-1.334V4.694l-8-1.333v16.278Zm4.5-5.64c-.828 0-1.5-1.119-1.5-2.5 0-1.38.671-2.5 1.5-2.5.828 0 1.5 1.12 1.5 2.5 0 1.381-.672 2.5-1.5 2.5Z"/>'
      }, props)
  }
  export function RiFinanceSafeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.005 20h-12v2h-2v-2h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-1v2h-2v-2Zm-7-6.126V17h2v-3.126a4.002 4.002 0 0 0-1-7.874 4 4 0 0 0-1 7.874Zm1-1.874a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiFinanceSafeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.005 20h-12v2h-2v-2h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-1v2h-2v-2Zm-14-2h16V5h-16v13Zm9-4.126V17h-2v-3.126a4.002 4.002 0 0 1 1-7.874 4 4 0 0 1 1 7.874Zm-1-1.874a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiFinanceSecurePaymentFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.005 2 7.298 2.28a1 1 0 0 1 .702.955V7h2a1 1 0 0 1 1 1v2h-13V8a1 1 0 0 1 1-1h7V5.97l-6-1.876-6 1.876v7.404a4 4 0 0 0 1.558 3.169l.189.136 4.253 2.9L14.787 17h-4.782a1 1 0 0 1-1-1v-4h13v4a1 1 0 0 1-1 1l-3.22.001c-.387.51-.857.96-1.4 1.33L11.005 22l-5.38-3.668a6 6 0 0 1-2.62-4.958V5.235a1 1 0 0 1 .702-.954L11.005 2Z"/>'
      }, props)
  }
  export function RiFinanceSecurePaymentLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.005 2 7.298 2.28a1 1 0 0 1 .702.955V7h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1l-3.22.001c-.387.51-.857.96-1.4 1.33L11.005 22l-5.38-3.668a6 6 0 0 1-2.62-4.958V5.235a1 1 0 0 1 .702-.954L11.005 2Zm0 2.094-6 1.876v7.404a4 4 0 0 0 1.558 3.169l.189.136 4.253 2.9L14.787 17h-4.782a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h7V5.97l-6-1.876Zm0 7.906v3h9v-3h-9Zm0-2h9V9h-9v1Z"/>'
      }, props)
  }
  export function RiFinanceShoppingBag2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.005 22h-16a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1Zm-11-16h-2v2a5 5 0 0 0 10 0V6h-2v2a3 3 0 0 1-6 0V6Z"/>'
      }, props)
  }
  export function RiFinanceShoppingBag2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.005 22h-16a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1Zm-1-2V4h-14v16h14Zm-10-14v2a3 3 0 1 0 6 0V6h2v2a5 5 0 0 1-10 0V6h2Z"/>'
      }, props)
  }
  export function RiFinanceShoppingBag3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.505 2h11a1 1 0 0 1 .8.4l2.7 3.6v15a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V6l2.7-3.6a1 1 0 0 1 .8-.4Zm12 4-1.5-2h-10l-1.5 2h13Zm-9.5 4h-2v2a5 5 0 0 0 10 0v-2h-2v2a3 3 0 0 1-6 0v-2Z"/>'
      }, props)
  }
  export function RiFinanceShoppingBag3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.505 2h11a1 1 0 0 1 .8.4l2.7 3.6v15a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V6l2.7-3.6a1 1 0 0 1 .8-.4Zm12.5 6h-14v12h14V8Zm-.5-2-1.5-2h-10l-1.5 2h13Zm-9.5 4v2a3 3 0 1 0 6 0v-2h2v2a5 5 0 0 1-10 0v-2h2Z"/>'
      }, props)
  }
  export function RiFinanceShoppingBagFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 1a5 5 0 0 1 5 5v2h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3V6a5 5 0 0 1 5-5Zm5 10h-2v1a1 1 0 0 0 1.993.116l.007-.117v-1Zm-8 0h-2v1a1 1 0 0 0 1.993.116L9.005 12v-1Zm3-8A3 3 0 0 0 9.01 5.823L9.005 6v2h6V6a3 3 0 0 0-2.824-2.995L12.005 3Z"/>'
      }, props)
  }
  export function RiFinanceShoppingBagLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.005 8V6a5 5 0 0 1 10 0v2h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3Zm0 2h-2v10h14V10h-2v2h-2v-2h-6v2h-2v-2Zm2-2h6V6a3 3 0 0 0-6 0v2Z"/>'
      }, props)
  }
  export function RiFinanceShoppingBasket2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.37 3.44 3.212 5.562h3.423v2h-1.167l-.757 9.083a1 1 0 0 1-.996.917H4.925a1 1 0 0 1-.997-.917l-.757-9.083H2.005v-2h3.422L8.639 3.44l1.732 1-2.634 4.562h8.535L13.639 4.44l1.732-1Zm-2.365 9.562h-2v4h2v-4Zm-4 0h-2v4h2v-4Zm8 0h-2v4h2v-4Z"/>'
      }, props)
  }
  export function RiFinanceShoppingBasket2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.37 3.44 3.212 5.562h3.423v2h-1.167l-.757 9.083a1 1 0 0 1-.996.917H4.925a1 1 0 0 1-.997-.917l-.757-9.083H2.005v-2h3.422L8.639 3.44l1.732 1-2.634 4.562h8.535L13.639 4.44l1.732-1Zm3.46 7.562H5.179l.667 8h12.319l.667-8Zm-5.825 2v4h-2v-4h2Zm-4 0v4h-2v-4h2Zm8 0v4h-2v-4h2Z"/>'
      }, props)
  }
  export function RiFinanceShoppingBasketFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 2a6 6 0 0 1 6 6v1h4v2h-1.167l-.757 9.083a1 1 0 0 1-.996.917H4.925a1 1 0 0 1-.997-.917L3.171 11H2.005V9h4V8a6 6 0 0 1 6-6Zm1 11h-2v4h2v-4Zm-4 0h-2v4h2v-4Zm8 0h-2v4h2v-4Zm-5-9A4 4 0 0 0 8.01 7.8l-.005.2v1h8V8a4 4 0 0 0-3.8-3.995l-.2-.005Z"/>'
      }, props)
  }
  export function RiFinanceShoppingBasketLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 2a6 6 0 0 1 6 6v1h4v2h-1.167l-.757 9.083a1 1 0 0 1-.996.917H4.925a1 1 0 0 1-.997-.917L3.171 11H2.005V9h4V8a6 6 0 0 1 6-6Zm6.826 9H5.178l.667 8h12.319l.667-8Zm-5.826 2v4h-2v-4h2Zm-4 0v4h-2v-4h2Zm8 0v4h-2v-4h2Zm-5-9A4 4 0 0 0 8.01 7.8l-.005.2v1h8V8a4 4 0 0 0-3.8-3.995l-.2-.005Z"/>'
      }, props)
  }
  export function RiFinanceShoppingCart2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.004 6.417.762 3.174 2.176 1.76l3.243 3.242H20.66a1 1 0 0 1 .958 1.288l-2.4 8a1 1 0 0 1-.958.712H6.004v2h11v2h-12a1 1 0 0 1-1-1V6.417Zm1.5 16.585a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiFinanceShoppingCart2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.004 6.417.762 3.174 2.176 1.76l3.243 3.242H20.66a1 1 0 0 1 .958 1.288l-2.4 8a1 1 0 0 1-.958.712H6.004v2h11v2h-12a1 1 0 0 1-1-1V6.417Zm2 .585v6h11.512l1.8-6H6.004Zm-.5 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiFinanceShoppingCartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.005 9h13.938l.5-2H8.005V5h13.72a1 1 0 0 1 .97 1.243l-2.5 10a1 1 0 0 1-.97.757H5.004a1 1 0 0 1-1-1V4h-2V2h3a1 1 0 0 1 1 1v6Zm0 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm12 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiFinanceShoppingCartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.005 16V4h-2V2h3a1 1 0 0 1 1 1v12h12.438l2-8H8.005V5h13.72a1 1 0 0 1 .97 1.243l-2.5 10a1 1 0 0 1-.97.757H5.004a1 1 0 0 1-1-1Zm2 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm12 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiFinanceStockFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.005 5.003h3v9h-3v3h-2v-3h-3v-9h3v-3h2v3Zm10 5h3v9h-3v3h-2v-3h-3v-9h3v-3h2v3Z"/>'
      }, props)
  }
  export function RiFinanceStockLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.005 5.003h3v9h-3v3h-2v-3h-3v-9h3v-3h2v3Zm-3 2v5h4v-5h-4Zm13 3h3v9h-3v3h-2v-3h-3v-9h3v-3h2v3Zm-3 2v5h4v-5h-4Z"/>'
      }, props)
  }
  export function RiFinanceSwapBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3.003h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm12 4v2h-4v2h4v2l3.5-3-3.5-3Zm-6 10v-2h4v-2h-4v-2l-3.5 3 3.5 3Z"/>'
      }, props)
  }
  export function RiFinanceSwapBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.005 5.003v14h16v-14h-16Zm-1-2h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1Zm12 4 3.5 3-3.5 3v-2h-4v-2h4v-2Zm-6 10-3.5-3 3.5-3v2h4v2h-4v2Z"/>'
      }, props)
  }
  export function RiFinanceSwapFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm-5-13h2v4h2v-4h2l-3-3.5-3 3.5Zm10 6h-2v-4h-2v4h-2l3 3.5 3-3.5Z"/>'
      }, props)
  }
  export function RiFinanceSwapLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 22.003c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-5-11 3-3.5 3 3.5h-2v4h-2v-4h-2Zm10 6-3 3.5-3-3.5h2v-4h2v4h2Z"/>'
      }, props)
  }
  export function RiFinanceTicket2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.005 3a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5V4a1 1 0 0 1 1-1h18Zm-5 6h-8v6h8V9Z"/>'
      }, props)
  }
  export function RiFinanceTicket2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.005 3a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5V4a1 1 0 0 1 1-1h18Zm-1 2h-16v2.968l.156.081A4.5 4.5 0 0 1 6.5 11.79l.005.211a4.499 4.499 0 0 1-2.344 3.95l-.156.081V19h16v-2.969l-.156-.08a4.5 4.5 0 0 1-2.34-3.74L17.506 12c0-1.704.947-3.187 2.344-3.95l.156-.082V5Zm-4 4v6h-8V9h8Z"/>'
      }, props)
  }
  export function RiFinanceTicketFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.005 3a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5V4a1 1 0 0 1 1-1h18Z"/>'
      }, props)
  }
  export function RiFinanceTicketLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.005 3a1 1 0 0 1 1 1v5.5a2.5 2.5 0 0 0 0 5V20a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1v-5.5a2.5 2.5 0 0 0 0-5V4a1 1 0 0 1 1-1h18Zm-1 2h-16v2.968l.156.081A4.5 4.5 0 0 1 6.5 11.79l.005.211a4.499 4.499 0 0 1-2.344 3.95l-.156.081V19h16v-2.969l-.156-.08a4.5 4.5 0 0 1-2.34-3.74L17.506 12c0-1.704.947-3.187 2.344-3.95l.156-.082V5Z"/>'
      }, props)
  }
  export function RiFinanceTokenSwapFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.5 9a6.502 6.502 0 0 1-4 6.002V15A8.5 8.5 0 0 0 9 6.5h-.002A6.502 6.502 0 0 1 21.5 9ZM7 3a4 4 0 0 0-4 4v1.5h2V7a2 2 0 0 1 2-2h1.5V3H7Zm12 12.5V17a2 2 0 0 1-2 2h-1.5v2H17a4 4 0 0 0 4-4v-1.5h-2Zm-10 6a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm0-9 2.5 2.5L9 17.5 6.5 15 9 12.5Z"/>'
      }, props)
  }
  export function RiFinanceTokenSwapLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 12.5 6.5 15 9 17.5l2.5-2.5L9 12.5Zm6-10a6.5 6.5 0 0 0-6.482 6.018 6.5 6.5 0 1 0 6.964 6.964A6.5 6.5 0 0 0 15 2.5Zm.323 10.989a6.51 6.51 0 0 0-4.812-4.812 4.5 4.5 0 1 1 4.812 4.812ZM13.5 15a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM3 7a4 4 0 0 1 4-4h1.5v2H7a2 2 0 0 0-2 2v1.5H3V7Zm16 10v-1.5h2V17a4 4 0 0 1-4 4h-1.5v-2H17a2 2 0 0 0 2-2Z"/>'
      }, props)
  }
  export function RiFinanceTrophyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.005 16.941v2.062h5v2h-12v-2h5V16.94a8.001 8.001 0 0 1-7-7.938v-6h16v6a8.001 8.001 0 0 1-7 7.938Zm-12-11.938h2v4h-2v-4Zm20 0h2v4h-2v-4Z"/>'
      }, props)
  }
  export function RiFinanceTrophyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.005 16.941v2.062h5v2h-12v-2h5V16.94a8.001 8.001 0 0 1-7-7.938v-6h16v6a8.001 8.001 0 0 1-7 7.938Zm-7-11.938v4a6 6 0 0 0 12 0v-4h-12Zm-5 0h2v4h-2v-4Zm20 0h2v4h-2v-4Z"/>'
      }, props)
  }
  export function RiFinanceVipCrown2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.806 5.2 7.005 8l4.186-5.86a1 1 0 0 1 1.628-.001L17.005 8l4.2-2.799a1 1 0 0 1 1.547.95L21.11 20.116a1 1 0 0 1-.993.883H3.894a1 1 0 0 1-.993-.883L1.258 6.149A1 1 0 0 1 2.806 5.2Zm9.2 9.8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiFinanceVipCrown2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.497 8.065 4.784 19h14.443l1.286-10.935-4.01 2.673-4.498-6.297-4.498 6.297-4.01-2.673ZM2.806 5.2 7.005 8l4.186-5.86a1 1 0 0 1 1.628-.001L17.005 8l4.2-2.799a1 1 0 0 1 1.547.95L21.11 20.116a1 1 0 0 1-.993.883H3.894a1 1 0 0 1-.993-.883L1.258 6.149A1 1 0 0 1 2.806 5.2Zm9.2 9.8a2 2 0 1 1-.001-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiFinanceVipCrownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.005 19h20v2h-20v-2Zm0-14 5 3 5-6 5 6 5-3v12h-20V5Z"/>'
      }, props)
  }
  export function RiFinanceVipCrownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.005 19h20v2h-20v-2Zm0-14 5 3.5 5-6.5 5 6.5 5-3.5v12h-20V5Zm2 3.841V15h16V8.841l-3.42 2.394-4.58-5.955-4.58 5.955-3.42-2.394Z"/>'
      }, props)
  }
  export function RiFinanceVipDiamondFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.878 3.003h14.254a1 1 0 0 1 .809.412l3.822 5.256a.5.5 0 0 1-.037.633l-11.354 12.3a.5.5 0 0 1-.735 0L.283 9.305a.5.5 0 0 1-.037-.633l3.823-5.256a1 1 0 0 1 .809-.412Z"/>'
      }, props)
  }
  export function RiFinanceVipDiamondLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.878 3.003h14.254a1 1 0 0 1 .809.412l3.822 5.256a.5.5 0 0 1-.037.633l-11.354 12.3a.5.5 0 0 1-.706.03L.283 9.303a.5.5 0 0 1-.037-.633l3.823-5.256a1 1 0 0 1 .809-.412Zm.509 2-2.8 3.85 9.418 10.201 9.417-10.202-2.8-3.85H5.388Z"/>'
      }, props)
  }
  export function RiFinanceVipFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.005 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm8 5.5v7h2v-7h-2Zm-.285 0H8.606l-1.497 4.113L5.612 8.5H3.498l2.611 6.964h2L10.72 8.5Zm5.285 5h1.5a2.5 2.5 0 0 0 0-5h-3.5v7h2v-2Zm0-2v-1h1.5a.5.5 0 0 1 0 1h-1.5Z"/>'
      }, props)
  }
  export function RiFinanceVipLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.005 19h20v2h-20v-2Zm9-11h2v8h-2V8ZM7.97 8l-1.86 5.113L4.247 8H2.123l2.986 7.964h2L10.095 8H7.97Zm9.035 6v2h-2V8h4a3 3 0 0 1 0 6h-2Zm0-4v2h2a1 1 0 1 0 0-2h-2Zm-15-7h20v2h-20V3Z"/>'
      }, props)
  }
  export function RiFinanceWallet2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.005 8h-9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h9v4a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v4Zm-7 3h3v2h-3v-2Z"/>'
      }, props)
  }
  export function RiFinanceWallet2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.005 7V5h-16v14h16v-2h-8a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h8Zm-17-4h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm10 6v6h7V9h-7Zm2 2h3v2h-3v-2Z"/>'
      }, props)
  }
  export function RiFinanceWallet3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.005 6h-7a6 6 0 0 0 0 12h7v2a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2Zm-7 2h8v8h-8a4 4 0 1 1 0-8Zm0 3v2h3v-2h-3Z"/>'
      }, props)
  }
  export function RiFinanceWallet3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.005 7h1v10h-1v3a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v3Zm-2 10h-6a5 5 0 0 1 0-10h6V5h-16v14h16v-2Zm1-2V9h-7a3 3 0 1 0 0 6h7Zm-7-4h3v2h-3v-2Z"/>'
      }, props)
  }
  export function RiFinanceWalletFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.005 9h19a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V9Zm1-6h15v4h-16V4a1 1 0 0 1 1-1Zm12 11v2h3v-2h-3Z"/>'
      }, props)
  }
  export function RiFinanceWalletLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.005 7h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h15v4Zm-14 2v10h16V9h-16Zm0-4v2h12V5h-12Zm11 8h3v2h-3v-2Z"/>'
      }, props)
  }
  export function RiFinanceWaterFlashFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.64 6.639 12.006.275l6.364 6.364a9 9 0 1 1-12.728 0Zm7.365 4.364v-4.5l-4.5 6.5h2.5v4.5l4.5-6.5h-2.5Z"/>'
      }, props)
  }
  export function RiFinanceWaterFlashLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.005 3.103-4.95 4.95a7 7 0 1 0 9.9 0l-4.95-4.95Zm0-2.828 6.364 6.364a9 9 0 1 1-12.728 0L12.005.275Zm1 10.728h2.5l-4.5 6.5v-4.5h-2.5l4.5-6.5v4.5Z"/>'
      }, props)
  }
  export function RiHealthMedicalBrainFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2.535A4 4 0 0 0 5 6v1.774c-.851.342-1.549.874-2.059 1.575C2.292 10.242 2 11.335 2 12.5c0 1.561.795 2.936 2 3.742V17.5a4.5 4.5 0 0 0 7 3.742V17.5c0-1.333-.33-2.185-.86-2.76-.543-.587-1.424-1.024-2.804-1.254l.328-1.972c1.302.216 2.442.623 3.336 1.313V2.535Zm2 0v10.292c.894-.69 2.034-1.097 3.336-1.313l.328 1.972c-1.38.23-2.261.667-2.804 1.255-.53.574-.86 1.426-.86 2.759v3.742a4.5 4.5 0 0 0 7-3.742v-1.258c1.205-.806 2-2.18 2-3.742 0-1.165-.292-2.258-.941-3.15-.51-.702-1.208-1.234-2.059-1.576V6a4 4 0 0 0-6-3.465Z"/>'
      }, props)
  }
  export function RiHealthMedicalBrainLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 4a2 2 0 0 1 2 2v6.827c-.894-.69-2.034-1.097-3.336-1.313l-.328 1.972c1.38.23 2.261.667 2.804 1.255.53.574.86 1.426.86 2.759a2.5 2.5 0 0 1-5 0v-.35c.43.143.876.26 1.336.336l.328-1.972c-.743-.124-1.489-.4-2.235-.754A2.496 2.496 0 0 1 4 12.5c0-.835.208-1.492.559-1.974.345-.476.883-.856 1.684-1.056L7 9.28V6a2 2 0 0 1 2-2Zm3-.646A4 4 0 0 0 5 6v1.774c-.851.342-1.549.874-2.059 1.575C2.292 10.242 2 11.335 2 12.5a4.49 4.49 0 0 0 2 3.742V17.5a4.5 4.5 0 0 0 8 2.829 4.5 4.5 0 0 0 8-2.829v-1.258a4.49 4.49 0 0 0 2-3.742c0-1.165-.292-2.258-.941-3.15-.51-.702-1.208-1.234-2.059-1.576V6a4 4 0 0 0-7-2.646Zm6 13.795v.351a2.5 2.5 0 0 1-5 0c0-1.333.33-2.185.86-2.76.543-.587 1.424-1.024 2.804-1.254l-.328-1.972c-1.302.216-2.442.623-3.336 1.313V6a2 2 0 1 1 4 0v3.28l.758.19c.8.2 1.338.58 1.683 1.056.351.482.559 1.14.559 1.974 0 .999-.582 1.857-1.43 2.26-.745.354-1.492.63-2.234.754l.328 1.972c.46-.076.906-.193 1.336-.337Z"/>'
      }, props)
  }
  export function RiHealthMedicalCapsuleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.779 4.222a6 6 0 0 1 0 8.485l-2.122 2.12-4.95 4.951a6 6 0 0 1-8.485-8.485l7.071-7.071a6 6 0 0 1 8.486 0Zm-4.95 10.606L9.172 9.171l-3.536 3.536a4 4 0 1 0 5.657 5.657l3.536-3.536Z"/>'
      }, props)
  }
  export function RiHealthMedicalCapsuleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.779 4.222a6 6 0 0 1 0 8.485l-7.072 7.071a6 6 0 0 1-8.485-8.485l7.071-7.071a6 6 0 0 1 8.486 0Zm-5.657 11.313L8.466 9.878l-2.83 2.829a4 4 0 1 0 5.657 5.657l2.83-2.83Zm4.242-9.9a4 4 0 0 0-5.657 0L9.88 8.465l5.657 5.656 2.827-2.827a4 4 0 0 0 0-5.657Z"/>'
      }, props)
  }
  export function RiHealthMedicalDislikeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2.808 1.394 18.384 18.384-1.414 1.415-3.746-3.747L12 21.486l-8.478-8.493a6 6 0 0 1 .033-8.023L1.394 2.808l1.414-1.414Zm17.435 3.364a6 6 0 0 1 .236 8.235l-1.635 1.636L7.26 3.046a5.99 5.99 0 0 1 4.741 1.483 5.998 5.998 0 0 1 8.242.229Z"/>'
      }, props)
  }
  export function RiHealthMedicalDislikeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2.808 1.394 18.384 18.384-1.414 1.415-3.746-3.747L12 21.486l-8.478-8.493a6 6 0 0 1 .033-8.023L1.394 2.808l1.414-1.414Zm2.172 10.23 7.02 7.03 2.618-2.622-9.646-9.646a4 4 0 0 0 .008 5.237Zm15.263-6.866a6 6 0 0 1 .236 8.235l-1.635 1.636-1.414-1.414 1.59-1.592a4 4 0 0 0-5.683-5.606l-1.335 1.198-1.336-1.197a3.975 3.975 0 0 0-1.155-.723l-2.25-2.25A5.99 5.99 0 0 1 12 4.53a5.998 5.998 0 0 1 8.242.229Z"/>'
      }, props)
  }
  export function RiHealthMedicalDossierFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 2v2h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V2h10Zm-4 9h-2v2H9v2h1.999L11 17h2l-.001-2H15v-2h-2v-2Zm2-7H9v2h6V4Z"/>'
      }, props)
  }
  export function RiHealthMedicalDossierLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 2v2h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3V2h10ZM7 6H5v14h14V6h-2v2H7V6Zm6 5v2h2v2h-2.001L13 17h-2l-.001-2H9v-2h2v-2h2Zm2-7H9v2h6V4Z"/>'
      }, props)
  }
  export function RiHealthMedicalEmpathizeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.364 10.98a4 4 0 0 1 0 5.656l-5.657 5.657a1 1 0 0 1-1.414 0l-5.657-5.657a4 4 0 1 1 5.657-5.657l.707.707.707-.707a4 4 0 0 1 5.657 0ZM12 1a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"/>'
      }, props)
  }
  export function RiHealthMedicalEmpathizeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.364 10.98a4 4 0 0 1 0 5.656l-5.657 5.657a1 1 0 0 1-1.414 0l-5.657-5.657a4 4 0 1 1 5.657-5.657l.707.707.707-.707a4 4 0 0 1 5.657 0ZM7.051 12.392a2 2 0 0 0 0 2.829l4.95 4.95 4.95-4.95a2 2 0 1 0-2.83-2.827l-2.123 2.118-2.119-2.12a2 2 0 0 0-2.828 0ZM12 1a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>'
      }, props)
  }
  export function RiHealthMedicalFirstAidKitFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4V2a1 1 0 0 1 1-1h8Zm-3 8h-2v3H8v2h2.999L11 17h2l-.001-3H16v-2h-3V9Zm2-6H9v2h6V3Z"/>'
      }, props)
  }
  export function RiHealthMedicalFirstAidKitLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v3h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4V2a1 1 0 0 1 1-1h8Zm4 6H4v12h16V7Zm-7 2v3h3v2h-3.001L13 17h-2l-.001-3H8v-2h3V9h2Zm2-6H9v2h6V3Z"/>'
      }, props)
  }
  export function RiHealthMedicalFlaskFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 2v2h-1v3.243a8 8 0 0 0 .736 3.352l4.281 9.276A1.5 1.5 0 0 1 18.655 22H5.344a1.5 1.5 0 0 1-1.362-2.129l4.281-9.276A8 8 0 0 0 9 7.243V4H8V2h8Zm-3 2h-2v4h2V4Z"/>'
      }, props)
  }
  export function RiHealthMedicalFlaskLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 2v2h-1v3.243a8 8 0 0 0 .736 3.352l4.281 9.276A1.5 1.5 0 0 1 18.655 22H5.344a1.5 1.5 0 0 1-1.362-2.129l4.281-9.276A8 8 0 0 0 9 7.243V4H8V2h8Zm-2.613 8.001h-2.776c-.104.363-.229.721-.374 1.071l-.158.362L6.124 20h11.75l-3.954-8.566A9.99 9.99 0 0 1 13.387 10ZM11 7.243c0 .253-.01.506-.028.758h2.057a9.59 9.59 0 0 1-.02-.364l-.009-.394V4h-2v3.243Z"/>'
      }, props)
  }
  export function RiHealthMedicalHandSanitizerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 2v2l-4-.001V6h3v2a4 4 0 0 1 4 4v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8a4 4 0 0 1 4-4V6h3V3.999L7.5 4c-.63 0-1.37.49-2.2 1.6L3.7 4.4C4.87 2.84 6.13 2 7.5 2H17Zm-4 10h-2v2H9v2h2v2h2v-2h2v-2h-2v-2Z"/>'
      }, props)
  }
  export function RiHealthMedicalHandSanitizerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 2v2l-4-.001V6h3v2a4 4 0 0 1 4 4v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8a4 4 0 0 1 4-4V6h3V3.999L7.5 4c-.63 0-1.37.49-2.2 1.6L3.7 4.4C4.87 2.84 6.13 2 7.5 2H17Zm-1 8H8a2 2 0 0 0-2 2v8h12v-8a2 2 0 0 0-2-2Zm-3 2v2h2v2h-2v2h-2v-2H9v-2h2v-2h2Z"/>'
      }, props)
  }
  export function RiHealthMedicalHealthBookFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2H3v-2h2v-2H3v-2h2v-2H3V9h2V7H3V5h2V3a1 1 0 0 1 1-1h14Zm-6 6h-2v3H9v2h2.999L12 16h2l-.001-3H17v-2h-3V8Z"/>'
      }, props)
  }
  export function RiHealthMedicalHealthBookLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2H3v-2h2v-2H3v-2h2v-2H3V9h2V7H3V5h2V3a1 1 0 0 1 1-1h14Zm-1 2H7v16h12V4Zm-5 4v3h3v2h-3.001L14 16h-2l-.001-3H9v-2h3V8h2Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeart2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.243 4.757a6 6 0 0 1 .236 8.236l-8.48 8.492-8.478-8.492a6 6 0 0 1 6.74-9.553L6.343 7.358l1.414 1.415L12 4.53l-.013-.014.014.013a5.998 5.998 0 0 1 8.242.228Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeart2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.243 4.757a6 6 0 0 1 .236 8.236l-8.48 8.492-8.478-8.492a6 6 0 0 1 8.48-8.464 5.998 5.998 0 0 1 8.242.228ZM5.172 6.172a4 4 0 0 0-.192 5.451L12 18.654l7.02-7.03a4 4 0 0 0-5.646-5.64l-4.202 4.203-1.415-1.414 2.825-2.827-.082-.069a4.001 4.001 0 0 0-5.328.295Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeart3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5C9.5 20 2 16 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeart3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5C9.5 20 2 16 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2Zm-3.566 15.604a26.752 26.752 0 0 0 2.42-1.701C18.335 14.533 20 11.943 20 9c0-2.36-1.537-4-3.5-4-1.076 0-2.24.57-3.086 1.414L12 7.828l-1.414-1.414C9.74 5.57 8.576 5 7.5 5 5.56 5 4 6.657 4 9c0 2.944 1.666 5.533 4.645 7.903.745.593 1.54 1.146 2.421 1.7.299.189.595.37.934.572.339-.202.635-.383.934-.571Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeartAddFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 14v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Zm1.243-9.243a6 6 0 0 1 .507 7.91 6 6 0 0 0-8.06 8.127l-.69.691-8.479-8.492a6 6 0 0 1 8.48-8.464 5.998 5.998 0 0 1 8.242.228Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeartAddLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 14v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Zm1.243-9.243a6 6 0 0 1 .237 8.235l-1.42-1.418c1.33-1.524 1.26-3.914-.233-5.404a4.001 4.001 0 0 0-5.49-.153l-1.335 1.198-1.336-1.197a4 4 0 0 0-5.686 5.605l8.432 8.446L12 21.485 3.52 12.993a6 6 0 0 1 8.48-8.464 5.998 5.998 0 0 1 8.242.228Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 4.529a5.998 5.998 0 0 1 8.242.228 6 6 0 0 1 .236 8.236l-8.48 8.492-8.478-8.492a6 6 0 0 1 8.48-8.464Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 4.529a5.998 5.998 0 0 1 8.242.228 6 6 0 0 1 .236 8.236l-8.48 8.492-8.478-8.492a6 6 0 0 1 8.48-8.464Zm6.826 1.641a3.998 3.998 0 0 0-5.49-.153l-1.335 1.198-1.336-1.197a4 4 0 0 0-5.686 5.605L12 18.654l7.02-7.03a4 4 0 0 0-.193-5.454Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeartPulseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5-1.978-1.186-7.084-3.937-9.131-8.5h4.697l.934-1.556 3 5L13.566 13H17v-2h-4.566l-.934 1.556-3-5L6.434 11H2.21A9.552 9.552 0 0 1 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeartPulseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.5 3C19.538 3 22 5.5 22 9c0 7-7.5 11-10 12.5-1.977-1.186-7.083-3.937-9.131-8.499L1 13v-2h1.21A9.552 9.552 0 0 1 2 9c0-3.5 2.5-6 5.5-6C9.36 3 11 4 12 5c1-1 2.64-2 4.5-2Zm0 2c-1.076 0-2.24.57-3.086 1.414L12 7.828l-1.414-1.414C9.74 5.57 8.576 5 7.5 5 5.56 5 4 6.657 4 9c0 .685.09 1.352.267 2h2.167L8.5 7.556l3 5L12.434 11H17v2h-3.434L11.5 16.444l-3-5L7.566 13H5.108c.79 1.374 1.985 2.668 3.537 3.903.745.593 1.54 1.146 2.421 1.7.299.189.595.37.934.572.339-.202.635-.383.934-.571a26.752 26.752 0 0 0 2.42-1.701C18.335 14.533 20 11.943 20 9c0-2.36-1.537-4-3.5-4Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeartsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.363 11.045a3.614 3.614 0 0 1 5.084 0 3.55 3.55 0 0 1 0 5.047L17 21.5l-5.447-5.408a3.55 3.55 0 0 1 0-5.047 3.614 3.614 0 0 1 5.084 0l.363.36.363-.36Zm1.88-6.288a5.986 5.986 0 0 1 1.689 3.338A5.619 5.619 0 0 0 17 8.808a5.617 5.617 0 0 0-6.856.818 5.55 5.55 0 0 0-.178 7.701l.178.185 2.421 2.404L11 21.485 2.52 12.993a6 6 0 0 1 8.48-8.464 5.998 5.998 0 0 1 8.242.228Z"/>'
      }, props)
  }
  export function RiHealthMedicalHeartsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.243 4.757a5.998 5.998 0 0 1 1.65 5.38c.568.16 1.106.463 1.554.908a3.55 3.55 0 0 1 0 5.047L17 21.5l-3.022-3L11 21.485 2.52 12.993a6 6 0 0 1 8.48-8.464 5.998 5.998 0 0 1 8.242.228Zm-6.281 7.708a1.55 1.55 0 0 0 0 2.208L17 18.682l4.038-4.009a1.55 1.55 0 0 0 0-2.208 1.614 1.614 0 0 0-2.268.002l-1.772 1.754-1.407-1.396-.363-.36a1.613 1.613 0 0 0-2.266 0Zm-8.79-6.293a4 4 0 0 0-.192 5.451L11 18.654l1.559-1.562-1.006-1a3.55 3.55 0 0 1 0-5.047 3.614 3.614 0 0 1 5.084 0l.363.36.363-.36a3.584 3.584 0 0 1 1.465-.882 4.003 4.003 0 0 0-1.001-3.993 3.998 3.998 0 0 0-5.49-.153l-1.335 1.198-1.336-1.197a4 4 0 0 0-5.494.154Z"/>'
      }, props)
  }
  export function RiHealthMedicalInfraredThermometerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 2v9h-3.001L18 12a4 4 0 0 1-4 4h-1.379l-.613 3.111.911 1.321A1 1 0 0 1 12.096 22H3l2.313-10.024L3 11l4-9h14Zm-5.001 9h-2.394l-.591 3H14a2 2 0 0 0 2-2l-.001-1Z"/>'
      }, props)
  }
  export function RiHealthMedicalInfraredThermometerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 2v9h-3.001L18 12a4 4 0 0 1-4 4h-1.379l-.613 3.111.911 1.321A1 1 0 0 1 12.096 22H3l2.313-10.024L3 11l4-9h14Zm-2 2H8.3L5.655 9.95l1.985.837L5.514 20h4.678l-.309-.448L11.96 9H19V4Zm-3.001 7h-2.394l-.591 3H14a2 2 0 0 0 2-2l-.001-1Z"/>'
      }, props)
  }
  export function RiHealthMedicalLungsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.5 5.5c1.412.47 2.048 2.159 2.327 4.023l-4.523 2.611 1 1.732 3.71-2.141C11.06 13.079 11 14.309 11 15c0 3-1 6-5 6s-4 0-4-4C2 9.5 5.5 4.5 8.5 5.5ZM22.001 17v.436c-.005 3.564-.15 3.564-4 3.564-4 0-5-3-5-6 0-.691-.06-1.92-.014-3.274l3.71 2.14 1-1.732-4.523-2.61c.279-1.865.915-3.553 2.327-4.024 3-1 6.5 4 6.5 11.5ZM13 2v9h-2V2h2Z"/>'
      }, props)
  }
  export function RiHealthMedicalLungsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.001 17c-.001 4-.001 4-4 4-4 0-5-3-5-6 0-.378-.018-.918-.026-1.55l2.023 1.169L15 15c0 2.776.816 4 3 4 1.14 0 1.61-.007 1.963-.038.03-.351.037-.822.037-1.962 0-3.205-.703-6.033-1.835-7.9-.838-1.382-1.613-1.842-2.032-1.703-.293.098-.605.65-.831 1.623l-1.79-1.033c.369-1.197.982-2.151 1.988-2.487 3-1 6.503 4 6.5 11.5ZM8.5 5.5c1.007.336 1.62 1.29 1.989 2.487L8.699 9.02c-.226-.973-.539-1.525-.831-1.623-.42-.14-1.195.32-2.032 1.702C4.703 10.967 4 13.795 4 17c0 1.14.007 1.61.037 1.962C4.39 18.993 4.86 19 6 19c2.184 0 3-1.224 3-4l.004-.382 2.023-1.168c-.01.633-.027 1.172-.027 1.55 0 3-1 6-5 6s-4 0-4-4C2 9.5 5.5 4.5 8.5 5.5ZM13 2v7.422l4.696 2.712-1 1.732L12 11.155l-4.696 2.711-1-1.732L11 9.422V2h2Z"/>'
      }, props)
  }
  export function RiHealthMedicalMedicineBottleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 5v2a3 3 0 0 1 3 3v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V10a3 3 0 0 1 3-3V5h10Zm-4 6h-2v2H9v2h1.999L11 17h2l-.001-2H15v-2h-2v-2Zm6-9v2H5V2h14Z"/>'
      }, props)
  }
  export function RiHealthMedicalMedicineBottleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 2v2h-2v3a3 3 0 0 1 3 3v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V10a3 3 0 0 1 3-3V4H5V2h14Zm-2 7H7a1 1 0 0 0-1 1v10h12V10a1 1 0 0 0-1-1Zm-4 2v2h2v2h-2.001L13 17h-2l-.001-2H9v-2h2v-2h2Zm2-7H9v3h6V4Z"/>'
      }, props)
  }
  export function RiHealthMedicalMentalHealthFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2a8.002 8.002 0 0 1 7.934 6.965l2.25 3.539c.148.233.118.58-.225.728L19 14.07V17a2 2 0 0 1-2 2h-1.999L15 22H6v-3.694c0-1.18-.436-2.297-1.245-3.305A8 8 0 0 1 11 2Zm-.53 5.763a1.75 1.75 0 0 0-2.475 2.474L11 13.243l3.005-3.006a1.75 1.75 0 1 0-2.475-2.474l-.53.53-.53-.53Z"/>'
      }, props)
  }
  export function RiHealthMedicalMentalHealthLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2a8.002 8.002 0 0 1 7.934 6.965l2.25 3.539c.148.233.118.58-.225.728L19 14.07V17a2 2 0 0 1-2 2h-1.999L15 22H6v-3.694c0-1.18-.436-2.297-1.245-3.305A8 8 0 0 1 11 2Zm0 2a6 6 0 0 0-4.684 9.75C7.41 15.114 8 16.667 8 18.306V20h5l.002-3H17v-4.248l1.55-.664-1.543-2.425-.057-.442A6.001 6.001 0 0 0 11 4Zm-.53 3.763.53.53.53-.53a1.75 1.75 0 0 1 2.475 2.474L11 13.243l-3.005-3.006a1.75 1.75 0 1 1 2.475-2.474Z"/>'
      }, props)
  }
  export function RiHealthMedicalMicroscopeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.196 2.268 3.25 5.63a1 1 0 0 1-.366 1.365l-1.3.75 1.001 1.732-1.732 1-1-1.733-1.299.751a1 1 0 0 1-1.366-.366L8.546 8.215a5.002 5.002 0 0 0-3.222 6.56A4.976 4.976 0 0 1 8 14c1.684 0 3.174.833 4.08 2.109l7.688-4.439 1 1.732-7.878 4.549A5.022 5.022 0 0 1 12.9 20L21 20v2l-17 .001A4.978 4.978 0 0 1 3 19c0-1.007.298-1.945.81-2.73a7.003 7.003 0 0 1 3.717-9.82l-.393-.682a2 2 0 0 1 .732-2.732l2.598-1.5a2 2 0 0 1 2.732.732Z"/>'
      }, props)
  }
  export function RiHealthMedicalMicroscopeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.196 2.268 3.25 5.63a1 1 0 0 1-.366 1.365l-1.3.75 1.001 1.732-1.732 1-1-1.733-1.299.751a1 1 0 0 1-1.366-.366L8.546 8.215a5.002 5.002 0 0 0-3.222 6.56A4.976 4.976 0 0 1 8 14c1.684 0 3.174.833 4.08 2.109l7.688-4.439 1 1.732-7.878 4.549A5.022 5.022 0 0 1 12.9 20L21 20v2l-17 .001A4.978 4.978 0 0 1 3 19c0-1.007.298-1.945.81-2.73a7.003 7.003 0 0 1 3.717-9.82l-.393-.682a2 2 0 0 1 .732-2.732l2.598-1.5a2 2 0 0 1 2.732.732ZM8 16a3 3 0 0 0-2.83 4h5.66A3 3 0 0 0 8 16Zm3.464-12.732-2.598 1.5 2.75 4.763 2.598-1.5-2.75-4.763Z"/>'
      }, props)
  }
  export function RiHealthMedicalNurseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.957 15.564A8.009 8.009 0 0 1 19.94 22H4.062a8.009 8.009 0 0 1 4.982-6.436L12.001 20l2.956-4.436ZM18.001 2v6A6 6 0 0 1 6 8V2h12Zm-2 6H8a4 4 0 0 0 8 0Z"/>'
      }, props)
  }
  export function RiHealthMedicalNurseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 15a8.001 8.001 0 0 1 7.939 7H4.062a8.001 8.001 0 0 1 7.939-7Zm-1.813 2.28A6.022 6.022 0 0 0 6.803 20h5.199l-1.813-2.72Zm3.627 0L12.001 20h5.198a6.022 6.022 0 0 0-3.385-2.72ZM18.001 2v6A6 6 0 0 1 6 8V2h12ZM8 8a4 4 0 0 0 8 0H8Zm8-4H8v2h8V4Z"/>'
      }, props)
  }
  export function RiHealthMedicalPsychotherapyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2a8.002 8.002 0 0 1 7.934 6.965l2.25 3.539c.148.233.118.58-.225.728L19 14.07V17a2 2 0 0 1-2 2h-1.999L15 22H6v-3.694c0-1.18-.436-2.297-1.245-3.305A8 8 0 0 1 11 2Zm0 5a1 1 0 0 0-1 1v.999L9 9a1 1 0 0 0 0 2l1-.001V12a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1V8a1 1 0 0 0-1-1Z"/>'
      }, props)
  }
  export function RiHealthMedicalPsychotherapyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2a8.002 8.002 0 0 1 7.934 6.965l2.25 3.539c.148.233.118.58-.225.728L19 14.07V17a2 2 0 0 1-2 2h-1.999L15 22H6v-3.694c0-1.18-.436-2.297-1.245-3.305A8 8 0 0 1 11 2Zm0 2a6 6 0 0 0-4.684 9.75C7.41 15.114 8 16.667 8 18.306V20h5l.002-3H17v-4.248l1.55-.664-1.543-2.425-.057-.442A6.001 6.001 0 0 0 11 4Zm0 3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1.001L9 11a1 1 0 1 1 0-2l1-.001V8a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiHealthMedicalPulseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m9 7.539 6 14L18.66 13H23v-2h-5.66L15 16.461l-6-14L5.34 11H1v2h5.66L9 7.539Z"/>'
      }, props)
  }
  export function RiHealthMedicalPulseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m9 7.539 6 14L18.66 13H23v-2h-5.66L15 16.461l-6-14L5.34 11H1v2h5.66L9 7.539Z"/>'
      }, props)
  }
  export function RiHealthMedicalRestTimeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 6v8h8a8 8 0 1 1-16 0c0-4.335 3.58-8 8-8Zm10-4v2l-5.327 6H21v2h-8v-2l5.326-6H13V2h8Z"/>'
      }, props)
  }
  export function RiHealthMedicalRestTimeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 6v2a6 6 0 1 0 5.996 6.225L17 14h2a8 8 0 1 1-16 0c0-4.335 3.58-8 8-8Zm10-4v2l-5.327 6H21v2h-8v-2l5.326-6H13V2h8Z"/>'
      }, props)
  }
  export function RiHealthMedicalStethoscopeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 3v2H6v4a4 4 0 0 0 8 0V5h-2V3h3a1 1 0 0 1 1 1v5a6.002 6.002 0 0 1-5 5.917V16.5a3.5 3.5 0 0 0 6.775 1.238 3 3 0 1 1 2.05.148A5.502 5.502 0 0 1 8.999 16.5v-1.583A6.002 6.002 0 0 1 4 9V4a1 1 0 0 1 1-1h3Z"/>'
      }, props)
  }
  export function RiHealthMedicalStethoscopeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 3v2H6v4a4 4 0 0 0 8 0V5h-2V3h3a1 1 0 0 1 1 1v5a6.002 6.002 0 0 1-5 5.917V16.5a3.5 3.5 0 0 0 6.775 1.238 3 3 0 1 1 2.05.148A5.502 5.502 0 0 1 8.999 16.5v-1.583A6.002 6.002 0 0 1 4 9V4a1 1 0 0 1 1-1h3Zm11 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiHealthMedicalSurgicalMaskFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.485 3.121 7.758 1.94a1 1 0 0 1 .757.97V7h1c1.1 0 2 .9 2 2v3a3 3 0 0 1-3 3h-.421a5.999 5.999 0 0 1-2.896 3.158l-4.789 2.395a2 2 0 0 1-1.788 0l-4.79-2.395A5.999 5.999 0 0 1 3.422 15H3a3 3 0 0 1-3-3V9a2 2 0 0 1 2-2h1v-.97a1 1 0 0 1 .757-.97l7.758-1.939a2 2 0 0 1 .97 0ZM3 9H2v3a1 1 0 0 0 1 1V9Zm19 0h-1v4a1 1 0 0 0 1-1V9Z"/>'
      }, props)
  }
  export function RiHealthMedicalSurgicalMaskLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.485 3.121 7.758 1.94a1 1 0 0 1 .757.97V7h1c1.1 0 2 .9 2 2v3a3 3 0 0 1-3 3h-.421a5.999 5.999 0 0 1-2.896 3.158l-4.789 2.395a2 2 0 0 1-1.788 0l-4.79-2.395A5.999 5.999 0 0 1 3.422 15H3a3 3 0 0 1-3-3V9a2 2 0 0 1 2-2h1v-.97a1 1 0 0 1 .757-.97l7.758-1.939a2 2 0 0 1 .97 0ZM12 5.061l-7 1.75v5.98a4 4 0 0 0 2.211 3.578L12 18.764l4.789-2.395A4 4 0 0 0 19 12.792v-5.98l-7-1.75ZM3 9H2v3a1 1 0 0 0 1 1V9Zm19 0h-1v4a1 1 0 0 0 1-1V9Z"/>'
      }, props)
  }
  export function RiHealthMedicalSyringeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m21.678 7.98-1.414 1.413-2.122-2.121-2.121 2.121 3.536 3.536-1.415 1.414-.707-.707L11.071 20H5.414l-2.12 2.121-1.415-1.414L4 18.586v-5.657l6.364-6.364-.707-.707 1.414-1.414 3.536 3.535 2.121-2.121-2.121-2.122 1.414-1.414 5.657 5.657Zm-12.02 6.363-2.83-2.828-1.414 1.414 2.829 2.828 1.414-1.414Zm2.828-2.828L9.656 8.686 8.243 10.1l2.828 2.829 1.415-1.414Z"/>'
      }, props)
  }
  export function RiHealthMedicalSyringeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m21.678 7.98-1.414 1.413-2.122-2.121-2.121 2.121 3.536 3.536-1.415 1.414-.707-.707L11.071 20H5.414l-2.12 2.121-1.415-1.414L4 18.586v-5.657l6.364-6.364-.707-.707 1.414-1.414 3.536 3.535 2.121-2.121-2.121-2.122 1.414-1.414 5.657 5.657Zm-5.657 4.242-4.243-4.243-1.414 1.414 2.121 2.122-1.414 1.414-2.121-2.122-1.414 1.415 2.121 2.121-1.414 1.414-2.121-2.121-.122.121V18h4.243l5.778-5.778Z"/>'
      }, props)
  }
  export function RiHealthMedicalTestTubeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 2v2h-1v14a4 4 0 0 1-8 0V4H7V2h10Zm-4 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm3-8h-4v4h4V4Z"/>'
      }, props)
  }
  export function RiHealthMedicalTestTubeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 2v2h-1v14a4 4 0 0 1-8 0V4H7V2h10Zm-3 8h-4v8a2 2 0 1 0 4 0v-8Zm-1 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-2-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm3-8h-4v4h4V4Z"/>'
      }, props)
  }
  export function RiHealthMedicalThermometerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.556 3.444a4 4 0 0 1 0 5.656l-8.2 8.2a4 4 0 0 1-2.386 1.148l-3.38.374-2.297 2.3a1 1 0 0 1-1.414-1.415l2.298-2.299.375-3.378A4 4 0 0 1 6.7 11.645l8.2-8.2a4 4 0 0 1 5.658 0Zm-9.192 9.192L9.95 14.05l2.121 2.122 1.414-1.415-2.12-2.121Zm2.829-2.828-1.415 1.414 2.122 2.121 1.414-1.414-2.121-2.121Zm2.828-2.829-1.414 1.414 2.121 2.122L19.142 9.1l-2.121-2.12Z"/>'
      }, props)
  }
  export function RiHealthMedicalThermometerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.556 3.444a4 4 0 0 1 0 5.656l-8.2 8.2a4 4 0 0 1-2.386 1.148l-3.38.374-2.297 2.3a1 1 0 0 1-1.414-1.415l2.298-2.299.375-3.378A4 4 0 0 1 6.7 11.645l8.2-8.2a4 4 0 0 1 5.658 0Zm-4.242 1.414-8.2 8.2a2 2 0 0 0-.574 1.193l-.276 2.485 2.485-.276a2 2 0 0 0 1.193-.574l.422-.422L9.95 14.05l1.414-1.414 1.414 1.414 1.414-1.414-1.414-1.414 1.415-1.414 1.414 1.414 1.414-1.415-1.414-1.414L17.02 6.98l1.414 1.414.707-.707a2 2 0 0 0-2.828-2.828Z"/>'
      }, props)
  }
  export function RiHealthMedicalVirusFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.716 1.947 3.735 1.434-.717 1.867-.934-.359-.746 1.945a6.03 6.03 0 0 1 1.945 1.846l1.902-.848-.406-.913 1.827-.814 1.627 3.655-1.827.813-.407-.914-1.902.848a6.012 6.012 0 0 1 .07 2.68l1.944.745.358-.932 1.867.716-1.433 3.735-1.867-.717.357-.933-1.944-.747a6.03 6.03 0 0 1-1.846 1.945l.848 1.902.914-.406.813 1.827-3.654 1.627-.813-1.827.913-.407-.847-1.902a6.012 6.012 0 0 1-2.68.07l-.747 1.944.934.358-.717 1.867L6.55 20.62l.717-1.867.932.358.748-1.945A6.032 6.032 0 0 1 7 15.32l-1.903.848.407.914-1.827.813L2.05 14.24l1.827-.813.406.914 1.903-.848a6.01 6.01 0 0 1-.07-2.68l-1.945-.746-.358.933-1.867-.717L3.381 6.55l1.867.717-.36.932 1.946.748A6.031 6.031 0 0 1 8.68 7l-.848-1.903-.913.407-.814-1.827L9.76 2.05l.813 1.827-.914.407.848 1.902a6.01 6.01 0 0 1 2.68-.07l.745-1.945L13 3.814l.716-1.867Zm-3.582 11.285a1 1 0 1 0 1.732 1 1 1 0 0 0-1.732-1ZM14 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-3.5-1.598a1 1 0 1 0 1 1.732 1 1 0 0 0-1-1.732Z"/>'
      }, props)
  }
  export function RiHealthMedicalVirusLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.716 1.947 3.735 1.434-.717 1.867-.934-.359-.746 1.945a6.03 6.03 0 0 1 1.945 1.846l1.902-.848-.406-.913 1.827-.814 1.627 3.655-1.827.813-.407-.914-1.902.848a6.012 6.012 0 0 1 .07 2.68l1.944.745.358-.932 1.867.716-1.433 3.735-1.867-.717.357-.933-1.944-.747a6.03 6.03 0 0 1-1.846 1.945l.848 1.902.914-.406.813 1.827-3.654 1.627-.813-1.827.913-.407-.847-1.902a6.012 6.012 0 0 1-2.68.07l-.747 1.944.934.358-.717 1.867L6.55 20.62l.717-1.867.932.358.748-1.945A6.032 6.032 0 0 1 7 15.32l-1.903.848.407.914-1.827.813L2.05 14.24l1.827-.813.406.914 1.903-.848a6.01 6.01 0 0 1-.07-2.68l-1.945-.746-.358.933-1.867-.717L3.381 6.55l1.867.717-.36.932 1.946.748A6.031 6.031 0 0 1 8.68 7l-.848-1.903-.913.407-.814-1.827L9.76 2.05l.813 1.827-.914.407.848 1.902a6.01 6.01 0 0 1 2.68-.07l.745-1.945L13 3.814l.716-1.867ZM12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-.5 4.866a1 1 0 1 1-1 1.732 1 1 0 0 1 1-1.732ZM14 11a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-2.134-1.232a1 1 0 1 1-1.732 1 1 1 0 0 1 1.732-1Z"/>'
      }, props)
  }
  export function RiHealthMedicalZzzFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 11v2l-5.327 6H11v2H3v-2l5.326-6H3v-2h8Zm10-8v2l-5.327 6H21v2h-8v-2l5.326-6H13V3h8Z"/>'
      }, props)
  }
  export function RiHealthMedicalZzzLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 11v2l-5.327 6H11v2H3v-2l5.326-6H3v-2h8Zm10-8v2l-5.327 6H21v2h-8v-2l5.326-6H13V3h8Z"/>'
      }, props)
  }
  export function RiLogosAlipayFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.422 15.358c-3.83-1.153-6.055-1.84-6.678-2.062a12.41 12.41 0 0 0 1.32-3.32H12.8V8.872h4v-.68h-4V6.344h-1.536c-.28 0-.312.248-.312.248v1.592H7.2v.68h3.752v1.104H7.88v.616h6.224a10.972 10.972 0 0 1-.888 2.176c-1.408-.464-2.192-.784-3.912-.944-3.256-.312-4.008 1.48-4.128 2.576C5 16.064 6.48 17.424 8.688 17.424s3.68-1.024 5.08-2.72c1.167.558 3.338 1.525 6.514 2.902A9.99 9.99 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10a9.983 9.983 0 0 1-.578 3.358Zm-12.99 1.01c-2.336 0-2.704-1.48-2.584-2.096.12-.616.8-1.416 2.104-1.416 1.496 0 2.832.384 4.44 1.16-1.136 1.48-2.52 2.352-3.96 2.352Z"/>'
      }, props)
  }
  export function RiLogosAlipayLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.408 16.79c-2.173-.95-3.72-1.646-4.64-2.086-1.4 1.696-2.872 2.72-5.08 2.72S5 16.064 5.176 14.392c.12-1.096.872-2.888 4.128-2.576 1.72.16 2.504.48 3.912.944.36-.664.664-1.4.888-2.176H7.88v-.616h3.072V8.864H7.2v-.68h3.752V6.592s.032-.248.312-.248H12.8v1.848h4v.68h-4v1.104h3.264a12.41 12.41 0 0 1-1.32 3.32c.51.182 2.097.676 4.76 1.482a8 8 0 1 0-1.096 2.012ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-3.568-5.632c1.44 0 2.824-.872 3.96-2.352-1.608-.776-2.944-1.16-4.44-1.16-1.304 0-1.984.8-2.104 1.416-.12.616.248 2.096 2.584 2.096Z"/>'
      }, props)
  }
  export function RiLogosAmazonFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.997 18.23c0 .727-.405 2.127-1.315 2.896-.182.14-.364.061-.284-.143.265-.648.871-2.147.587-2.492-.201-.262-1.031-.242-1.739-.182-.323.041-.607.06-.827.105-.204.016-.245-.163-.041-.303a3.09 3.09 0 0 1 .87-.428c1.15-.344 2.479-.137 2.67.083.036.042.079.16.079.463Zm-1.922 1.294a7.426 7.426 0 0 1-.829.55c-2.122 1.275-4.871 1.943-7.258 1.943-3.843 0-7.28-1.417-9.888-3.788-.224-.182-.039-.446.223-.303 2.81 1.64 6.288 2.632 9.888 2.632 2.266 0 4.708-.424 7.035-1.336.163-.061.345-.144.504-.202.367-.165.69.242.325.504Zm-6.17-11.03c0-1.041.042-1.654-.303-2.18-.306-.433-.833-.693-1.569-.652-.798.044-1.655.567-1.873 1.526-.043.22-.171.436-.437.483l-2.435-.31c-.174-.04-.439-.173-.352-.521C7.459 4.088 9.81 3.129 12.034 3h.522c1.22 0 2.788.349 3.791 1.264 1.217 1.136 1.087 2.662 1.087 4.32v3.927c0 1.178.478 1.7.958 2.314.13.219.175.477-.044.655a77.915 77.915 0 0 1-1.917 1.654c-.175.133-.489.147-.61.045-.77-.645-.958-1.003-1.435-1.658-.83.871-1.527 1.352-2.356 1.613a7.038 7.038 0 0 1-1.784.216c-2.09 0-3.745-1.303-3.745-3.88 0-2.049 1.09-3.442 2.7-4.101 1.61-.66 3.95-.87 4.704-.874Zm-.477 5.192c.52-.872.477-1.586.477-3.185-.652 0-1.306.045-1.871.178-1.045.303-1.875.96-1.875 2.355 0 1.09.568 1.832 1.526 1.832.132 0 .248-.016.348-.045.67-.186 1.088-.522 1.395-1.135Z"/>'
      }, props)
  }
  export function RiLogosAmazonLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.626 14.62c-1.107 1.618-2.728 2.384-4.625 2.384-2.304 0-4.277-1.773-3.993-4.124.314-2.608 2.34-3.73 5.708-4.143.601-.074.85-.094 2.147-.19l.138-.01v-.215C15 6.526 13.933 5.3 12.5 5.3c-1.437 0-2.44.747-3.055 2.526l-1.89-.653C8.442 4.603 10.193 3.3 12.5 3.3c2.602 0 4.5 2.178 4.5 5.022 0 2.648.163 4.755.483 5.557.356.892.486 1.117.884 1.613l-1.56 1.251c-.524-.652-.753-1.049-1.182-2.122v-.001Zm5.631 5.925c-.27.2-.741.081-.528-.44.264-.648.547-1.408.262-1.753-.21-.254-.468-.381-1.027-.381-.46 0-.69.06-.995.08-.204.013-.294-.297-.091-.44a2.96 2.96 0 0 1 .87-.428c1.15-.344 2.505-.156 2.67.083.365.53-.2 2.569-1.16 3.279Zm-1.182-1.084a7.548 7.548 0 0 1-.829.695c-2.122 1.615-4.871 2.46-7.258 2.46-3.843 0-7.28-1.794-9.888-4.795-.224-.23-.039-.566.223-.384 2.81 2.076 6.288 3.333 9.888 3.333 2.266 0 4.708-.537 7.035-1.693.163-.077.345-.181.504-.254.367-.21.69.306.325.638Zm-5.064-8.92c-1.259.093-1.496.113-2.052.181-2.553.313-3.797 1.003-3.966 2.398-.125 1.043.81 1.884 2.008 1.884 2.039 0 3.517-1.228 4.022-4.464l-.012.001Z"/>'
      }, props)
  }
  export function RiLogosAndroidFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.382 3.968A8.962 8.962 0 0 1 12 2c2.125 0 4.078.736 5.618 1.968l1.453-1.453 1.414 1.414-1.453 1.453A8.962 8.962 0 0 1 21 11v1H3v-1c0-2.125.736-4.078 1.968-5.618L3.515 3.93l1.414-1.414 1.453 1.453ZM3 14h18v7a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-7Zm6-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiLogosAndroidLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 13H5v7h14v-7Zm0-2a7 7 0 1 0-14 0h14ZM6.382 3.968A8.962 8.962 0 0 1 12 2c2.125 0 4.078.736 5.618 1.968l1.453-1.453 1.414 1.414-1.453 1.453A8.962 8.962 0 0 1 21 11v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11c0-2.125.736-4.078 1.968-5.618L3.515 3.93l1.414-1.414 1.453 1.453ZM9 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm6 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/>'
      }, props)
  }
  export function RiLogosAngularjsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 2 9.3 3.32-1.418 12.31L12 22 4.12 17.63 2.7 5.32 12 2Zm0 2.21L6.186 17.26h2.168l1.169-2.92h4.935l1.168 2.92h2.168L12 4.21Zm1.698 8.33h-3.396L12 8.45l1.698 4.09Z"/>'
      }, props)
  }
  export function RiLogosAngularjsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.523 16.65.49-.27 1.118-9.71-7.13-2.546-7.132 2.545 1.119 9.71.474.263L12 4.21l5.523 12.44Zm-1.098.61h-.799l-1.168-2.92H9.523l-1.169 2.92h-.778L12 19.713l4.425-2.453ZM12 2l9.3 3.32-1.418 12.31L12 22 4.12 17.63 2.7 5.32 12 2Zm1.698 10.54L12 8.45l-1.698 4.09h3.396Z"/>'
      }, props)
  }
  export function RiLogosAppStoreFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM8.823 15.343c-.395-.477-.886-.647-1.479-.509l-.15.041-.59 1.016a.823.823 0 0 0 1.366.916l.062-.093.79-1.371ZM13.21 8.66c-.488.404-.98 1.597-.29 2.787l3.04 5.266a.824.824 0 0 0 1.476-.722l-.049-.1-.802-1.392h1.19a.82.82 0 0 0 .822-.823.82.82 0 0 0-.72-.816l-.103-.006h-2.14L13.44 9.057l-.23-.396Zm.278-3.044a.825.825 0 0 0-1.063.21l-.062.092-.367.633-.359-.633a.824.824 0 0 0-1.476.722l.049.1.838 1.457-2.685 4.653H6.266a.82.82 0 0 0-.822.822c0 .421.312.766.719.817l.103.006h7.48c.34-.64-.06-1.549-.81-1.638l-.121-.007h-2.553l3.528-6.11a.823.823 0 0 0-.302-1.124Z"/>'
      }, props)
  }
  export function RiLogosAppStoreLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM8.823 15.343l-.79 1.37a.823.823 0 1 1-1.428-.822l.589-1.016c.66-.206 1.201-.048 1.629.468ZM13.21 8.66l2.423 4.194h2.141c.456 0 .823.367.823.822a.82.82 0 0 1-.823.823h-1.19l.803 1.391a.824.824 0 0 1-1.427.823l-3.04-5.266c-.69-1.19-.198-2.383.29-2.787Zm.278-3.044c.395.226.528.73.302 1.125l-3.528 6.109h2.553c.826 0 1.29.972.931 1.645h-7.48a.82.82 0 0 1-.822-.823.82.82 0 0 1 .822-.822h2.097l2.685-4.653-.838-1.456a.824.824 0 0 1 1.427-.823l.359.633.367-.633a.823.823 0 0 1 1.125-.302Z"/>'
      }, props)
  }
  export function RiLogosAppleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.673 7.222c-.876 0-2.232-.996-3.66-.96-1.884.024-3.612 1.092-4.584 2.784-1.956 3.396-.504 8.412 1.404 11.172.936 1.344 2.04 2.856 3.504 2.808 1.404-.06 1.932-.912 3.636-.912 1.692 0 2.172.912 3.66.876 1.512-.024 2.472-1.368 3.396-2.724 1.068-1.56 1.512-3.072 1.536-3.156-.036-.012-2.94-1.128-2.976-4.488-.024-2.808 2.292-4.152 2.4-4.212-1.32-1.932-3.348-2.148-4.056-2.196-1.848-.144-3.396 1.008-4.26 1.008Zm3.12-2.832c.78-.936 1.296-2.244 1.152-3.54-1.116.048-2.46.744-3.264 1.68-.72.828-1.344 2.16-1.176 3.432 1.236.096 2.508-.636 3.288-1.572Z"/>'
      }, props)
  }
  export function RiLogosAppleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.778 8.208c-.473-.037-.98.076-1.758.373.065-.025-.742.29-.969.37-.502.175-.915.271-1.378.271-.458 0-.88-.091-1.365-.255-.156-.052-.312-.11-.505-.186l-.449-.177c-.648-.254-1.012-.35-1.315-.342-1.153.015-2.243.68-2.877 1.782-1.292 2.244-.576 6.299 1.313 9.031 1.005 1.444 1.556 1.96 1.777 1.953.222-.01.386-.057.784-.225l.166-.071c1.006-.429 1.71-.618 2.771-.618 1.021 0 1.703.186 2.669.602l.168.072c.397.17.54.208.792.202.357-.005.798-.417 1.777-1.854.268-.391.505-.803.71-1.22a7.375 7.375 0 0 1-.391-.347c-1.29-1.228-2.087-2.884-2.109-4.93A6.625 6.625 0 0 1 17 8.46a4.124 4.124 0 0 0-1.221-.25Zm.155-1.994c.708.048 2.736.264 4.056 2.196-.108.06-2.424 1.404-2.4 4.212.036 3.36 2.94 4.476 2.976 4.488-.024.084-.468 1.596-1.536 3.156-.924 1.356-1.884 2.7-3.396 2.724-1.488.036-1.968-.876-3.66-.876-1.704 0-2.232.852-3.636.912-1.464.048-2.568-1.464-3.504-2.808-1.908-2.76-3.36-7.776-1.404-11.172.972-1.692 2.7-2.76 4.584-2.784 1.428-.036 2.784.96 3.66.96.864 0 2.412-1.152 4.26-1.008Zm-1.14-1.824c-.78.936-2.052 1.668-3.288 1.572-.168-1.272.456-2.604 1.176-3.432.804-.936 2.148-1.632 3.264-1.68.144 1.296-.372 2.604-1.152 3.54Z"/>'
      }, props)
  }
  export function RiLogosBaiduFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.926 12.496c2.063-.443 1.782-2.908 1.72-3.447-.1-.83-1.078-2.282-2.404-2.167-1.67.15-1.914 2.561-1.914 2.561-.226 1.115.54 3.497 2.598 3.053Zm2.191 4.289c-.06.173-.195.616-.079 1.002.23.866.982.905.982.905h1.08v-2.64H8.944c-.52.154-.77.559-.827.733Zm1.638-8.422c1.14 0 2.06-1.312 2.06-2.933 0-1.62-.92-2.93-2.06-2.93-1.138 0-2.06 1.31-2.06 2.93 0 1.621.923 2.933 2.06 2.933Zm4.907.193c1.523.198 2.502-1.427 2.697-2.659.198-1.23-.784-2.658-1.862-2.904-1.08-.248-2.43 1.483-2.552 2.61-.147 1.38.197 2.758 1.717 2.953Zm0 3.448c-1.865-2.905-4.513-1.723-5.399-.245-.882 1.477-2.256 2.41-2.452 2.658-.198.244-2.846 1.673-2.258 4.284.588 2.609 2.653 2.56 2.653 2.56s1.521.15 3.286-.246c1.766-.391 3.286.098 3.286.098s4.124 1.38 5.253-1.278c1.127-2.66-.638-4.038-.638-4.038s-2.356-1.823-3.731-3.793Zm-6.007 7.75c-1.158-.231-1.62-1.021-1.677-1.156-.057-.137-.386-.772-.212-1.853.5-1.619 1.927-1.735 1.927-1.735h1.427v-1.755l1.216.02v6.479H8.655Zm4.59-.019c-1.196-.308-1.252-1.158-1.252-1.158v-3.412l1.252-.02v3.066c.076.328.482.387.482.387H15v-3.433h1.331v4.57h-3.085Zm7.453-9.11c0-.59-.49-2.364-2.305-2.364-1.818 0-2.061 1.675-2.061 2.859 0 1.13.095 2.707 2.354 2.657 2.26-.05 2.012-2.56 2.012-3.152Z"/>'
      }, props)
  }
  export function RiLogosBaiduLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.563 19.28a9.693 9.693 0 0 0 2.496-.217 8.798 8.798 0 0 1 2.98-.131 7.78 7.78 0 0 1 1.289.257c1.077.275 2.61.223 3.005-.41.29-.468.253-.787-.026-1.199-.06-.09-.126-.17-.188-.235l-.024-.025a25.109 25.109 0 0 1-.743-.618 25.578 25.578 0 0 1-1.753-1.66 16.153 16.153 0 0 1-1.577-1.893l-.036-.053c-.742-1.139-1.558-1.067-2.002-.318a9.593 9.593 0 0 1-.955 1.332c-.41.482-.83.89-1.306 1.297-.122.105-.502.42-.411.344-.004.003-.017.015.05-.071-.098.12-.95.877-1.2 1.162-.515.583-.722 1.08-.645 1.48.073.376.22.587.45.745a1.433 1.433 0 0 0 .48.206c.033.003.072.005.116.007Zm7.099-7.276c1.375 1.97 3.731 3.793 3.731 3.793s2.064 1.748.638 4.038c-1.426 2.29-5.253 1.278-5.253 1.278s-1.52-.49-3.286-.098c-1.765.395-3.286.245-3.286.245S5 21.015 4.553 18.701c-.446-2.314 2.06-4.04 2.258-4.284.196-.247 1.512-1.073 2.452-2.658.94-1.586 3.584-2.54 5.399.245Zm5.538-1.42c0 .457.191 2.393-1.552 2.432-1.743.038-1.816-1.178-1.816-2.05 0-.913.187-2.205 1.59-2.205 1.4 0 1.778 1.369 1.778 1.824Zm-5.429-2.777c-1.18-.152-1.447-1.222-1.333-2.293.095-.875 1.142-2.219 1.981-2.026.837.19 1.6 1.3 1.446 2.254-.152.957-.912 2.218-2.094 2.065ZM9.755 7.44c-.861 0-1.56-.993-1.56-2.22 0-1.227.698-2.22 1.56-2.22.863 0 1.56.993 1.56 2.22 0 1.227-.697 2.22-1.56 2.22Zm-3.793 4.566c-1.695.365-2.327-1.597-2.14-2.515 0 0 .2-1.987 1.576-2.11 1.093-.095 1.898 1.101 1.98 1.785.052.444.283 2.475-1.416 2.84Z"/>'
      }, props)
  }
  export function RiLogosBardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.614 17.796.878-2.01a7.742 7.742 0 0 1 3.94-3.992l2.416-1.072c.768-.341.768-1.458 0-1.8l-2.34-1.038a7.747 7.747 0 0 1-3.997-4.125l-.89-2.142a.946.946 0 0 0-1.758 0l-.889 2.142a7.747 7.747 0 0 1-3.997 4.125l-2.34 1.039c-.768.34-.768 1.458 0 1.799l2.415 1.072a7.742 7.742 0 0 1 3.94 3.991l.878 2.01a.946.946 0 0 0 1.744 0Zm8.787 4.894.247-.566a4.365 4.365 0 0 1 2.221-2.25l.76-.339a.53.53 0 0 0 0-.963l-.717-.319a4.368 4.368 0 0 1-2.253-2.326l-.254-.611a.507.507 0 0 0-.942 0l-.254.61a4.368 4.368 0 0 1-2.253 2.327l-.718.32a.53.53 0 0 0 0 .962l.76.338a4.365 4.365 0 0 1 2.222 2.251l.247.566c.18.414.754.414.934 0Z"/>'
      }, props)
  }
  export function RiLogosBardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.614 17.796a.946.946 0 0 1-1.744 0l-.877-2.01a7.742 7.742 0 0 0-3.94-3.992l-2.416-1.072c-.768-.341-.768-1.458 0-1.8l2.34-1.038a7.747 7.747 0 0 0 3.997-4.125l.89-2.142a.946.946 0 0 1 1.757 0l.89 2.142a7.747 7.747 0 0 0 3.997 4.125l2.34 1.039c.768.34.768 1.458 0 1.799l-2.415 1.072a7.742 7.742 0 0 0-3.941 3.991l-.878 2.01ZM4.54 9.822c2.285 1.015 4.144 2.683 5.202 4.978 1.059-2.295 2.917-3.963 5.203-4.978-2.313-1.026-4.177-2.776-5.203-5.111-1.025 2.335-2.89 4.085-5.202 5.111ZM19.4 22.69l.247-.566a4.365 4.365 0 0 1 2.221-2.25l.76-.339a.53.53 0 0 0 0-.963l-.717-.319a4.368 4.368 0 0 1-2.253-2.326l-.254-.611a.507.507 0 0 0-.942 0l-.254.61a4.368 4.368 0 0 1-2.253 2.327l-.718.32a.53.53 0 0 0 0 .962l.76.338a4.365 4.365 0 0 1 2.222 2.251l.247.566c.18.414.754.414.934 0Zm-1.026-3.643.562-.559.55.559-.55.543-.563-.543Z"/>'
      }, props)
  }
  export function RiLogosBehanceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.443 5.35c.639 0 1.23.05 1.77.198.541.099.984.297 1.377.544.394.248.689.594.885 1.039.197.445.296.99.296 1.583 0 .693-.148 1.286-.492 1.731-.295.446-.787.841-1.377 1.138.836.248 1.475.693 1.869 1.287.393.593.639 1.335.639 2.176 0 .693-.148 1.286-.394 1.781-.245.495-.639.94-1.082 1.237a5.08 5.08 0 0 1-1.573.692c-.59.149-1.18.248-1.77.248H1V5.35h6.443Zm-.394 5.54c.541 0 .984-.148 1.328-.395.344-.247.492-.693.492-1.237 0-.297-.05-.593-.148-.791-.098-.198-.246-.347-.442-.495-.197-.099-.394-.198-.64-.247-.246-.05-.491-.05-.787-.05H4v3.216h3.05Zm.148 5.838c.295 0 .59-.05.836-.099.246-.05.492-.148.688-.297a1.76 1.76 0 0 0 .492-.544c.098-.247.197-.544.197-.89 0-.693-.197-1.188-.59-1.534-.394-.297-.935-.445-1.574-.445H4v3.81h3.197Zm9.492-.05c.393.396.983.594 1.77.594.541 0 1.033-.148 1.426-.395.394-.297.64-.594.738-.89h2.41c-.394 1.186-.984 2.027-1.77 2.572-.788.494-1.722.791-2.853.791a5.751 5.751 0 0 1-2.115-.396 3.928 3.928 0 0 1-1.574-1.088 3.93 3.93 0 0 1-.983-1.633c-.246-.643-.345-1.335-.345-2.127 0-.742.099-1.434.345-2.078a5.34 5.34 0 0 1 1.033-1.681c.442-.446.983-.841 1.573-1.089a5.49 5.49 0 0 1 2.066-.396c.836 0 1.574.149 2.213.495.64.346 1.131.742 1.524 1.336.394.544.69 1.187.886 1.88.098.692.147 1.385.098 2.176H16c0 .792.295 1.534.689 1.93Zm3.098-5.194c-.344-.346-.885-.544-1.525-.544-.442 0-.787.1-1.082.248-.295.148-.491.346-.688.544a1.323 1.323 0 0 0-.345.692c-.049.248-.098.446-.098.643h4.426c-.098-.742-.344-1.236-.688-1.583ZM15.459 6.29h5.508v1.336H15.46V6.29Z"/>'
      }, props)
  }
  export function RiLogosBehanceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.5 11a2 2 0 1 0 0-4H3v4h4.5Zm1 2H3v4h5.5a2 2 0 1 0 0-4Zm2.063-1.428A4 4 0 0 1 8.5 19H1V5h6.5a4 4 0 0 1 3.063 6.572ZM15.5 6H21v1.5h-5.5V6Zm7.5 8.5h-7.5v.25A2.75 2.75 0 0 0 20.7 16h2.134a4.752 4.752 0 0 1-9.334-1.25v-1.5a4.75 4.75 0 1 1 9.5 0v1.25Zm-2.104-2a2.751 2.751 0 0 0-5.293 0h5.293Z"/>'
      }, props)
  }
  export function RiLogosBilibiliFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.223 3.086a1.25 1.25 0 0 1 0 1.768L17.08 5.996h1.17A3.75 3.75 0 0 1 22 9.746v7.5a3.75 3.75 0 0 1-3.75 3.75H5.75A3.75 3.75 0 0 1 2 17.246v-7.5a3.75 3.75 0 0 1 3.75-3.75h1.166L5.775 4.855a1.25 1.25 0 0 1 1.767-1.768l2.652 2.651c.079.08.145.166.198.258h3.213c.053-.092.12-.18.199-.259l2.651-2.651a1.25 1.25 0 0 1 1.768 0Zm.027 5.42H5.75a1.25 1.25 0 0 0-1.247 1.157l-.003.093v7.5c0 .66.51 1.2 1.157 1.247l.093.003h12.5a1.25 1.25 0 0 0 1.247-1.156l.003-.094v-7.5c0-.69-.56-1.25-1.25-1.25Zm-10 2.5c.69 0 1.25.56 1.25 1.25v1.25a1.25 1.25 0 0 1-2.5 0v-1.25c0-.69.56-1.25 1.25-1.25Zm7.5 0c.69 0 1.25.56 1.25 1.25v1.25a1.25 1.25 0 0 1-2.5 0v-1.25c0-.69.56-1.25 1.25-1.25Z"/>'
      }, props)
  }
  export function RiLogosBilibiliLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.172 2.757 10.414 6h3.171l3.243-3.242a1 1 0 1 1 1.415 1.414L16.414 6H18.5A3.5 3.5 0 0 1 22 9.5v8a3.5 3.5 0 0 1-3.5 3.5h-13A3.5 3.5 0 0 1 2 17.5v-8A3.5 3.5 0 0 1 5.5 6h2.085L5.757 4.171a1 1 0 0 1 1.415-1.414ZM18.5 8h-13a1.5 1.5 0 0 0-1.493 1.355L4 9.5v8a1.5 1.5 0 0 0 1.356 1.493L5.5 19h13a1.5 1.5 0 0 0 1.493-1.356L20 17.5v-8A1.5 1.5 0 0 0 18.5 8ZM8 11a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Zm8 0a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiLogosBlenderFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.79 15.714c-.144-.456-.24-1.039-.245-1.339-.006-.299.06-.797.06-.797l-4.509 3.69c-.787.636-1.846.635-2.344-.004-.491-.628-.24-1.62.54-2.217l8.293-6.364-4.628.006c-.785-.003-1.298-.532-1.15-1.17.143-.626.869-1.121 1.624-1.122l9.146-.01-2.995-2.439c-.466-.382-.407-.989.118-1.355.518-.363 1.31-.364 1.782-.002l7.204 5.53-.002.002a7.43 7.43 0 0 1 1.775 1.958 6.823 6.823 0 0 1 1.021 4.13 6.7 6.7 0 0 1-.287 1.478 7.124 7.124 0 0 1-1.526 2.648A7.942 7.942 0 0 1 19 20.263a8.592 8.592 0 0 1-3.505.74 8.584 8.584 0 0 1-3.508-.728 7.884 7.884 0 0 1-2.67-1.918 7.064 7.064 0 0 1-1.527-2.643Zm7.703 1.815c1.408-.003 2.708-.54 3.637-1.486.454-.462.787-.992.993-1.558.201-.555.28-1.143.229-1.736a4.103 4.103 0 0 0-.5-1.634 4.49 4.49 0 0 0-1.104-1.31 5.141 5.141 0 0 0-3.257-1.127 5.151 5.151 0 0 0-3.255 1.136c-.46.376-.834.822-1.105 1.314a4.1 4.1 0 0 0-.27 3.372c.206.565.54 1.094.994 1.555.929.945 2.23 1.477 3.638 1.474Zm-2.018-6.626a3.28 3.28 0 0 1 2.12-.758c.815 0 1.564.288 2.12.758.566.48.942 1.155.985 1.922.043.788-.274 1.52-.83 2.063a3.249 3.249 0 0 1-2.275.899 3.25 3.25 0 0 1-2.277-.9c-.556-.542-.872-1.274-.828-2.062.043-.767.418-1.442.985-1.922Zm0 0c-.567.48-.942 1.155-.985 1.922-.044.788.272 1.52.829 2.063a3.25 3.25 0 0 0 2.276.899c.903 0 1.709-.347 2.276-.9.555-.542.872-1.274.83-2.062-.044-.767-.42-1.442-.986-1.922a3.282 3.282 0 0 0-2.12-.758 3.28 3.28 0 0 0-2.12.758ZM7.79 15.714c-.143-.456-.239-1.039-.244-1.339-.006-.299.06-.797.06-.797l-4.509 3.69c-.787.636-1.846.635-2.344-.004-.491-.628-.24-1.62.54-2.217l8.293-6.364-4.628.006c-.785-.003-1.298-.532-1.15-1.17.143-.626.869-1.121 1.624-1.122l9.146-.01-2.995-2.439c-.466-.382-.407-.989.118-1.355.518-.363 1.31-.364 1.782-.002l7.204 5.53-.002.002a7.43 7.43 0 0 1 1.775 1.958 6.823 6.823 0 0 1 1.021 4.13 6.7 6.7 0 0 1-.287 1.478 7.124 7.124 0 0 1-1.526 2.648A7.942 7.942 0 0 1 19 20.263a8.592 8.592 0 0 1-3.505.74 8.584 8.584 0 0 1-3.508-.728 7.884 7.884 0 0 1-2.67-1.918 7.064 7.064 0 0 1-1.527-2.643Zm7.704 1.815c1.408-.003 2.708-.54 3.637-1.486.454-.462.787-.992.993-1.558.201-.555.28-1.143.229-1.736a4.103 4.103 0 0 0-.5-1.634 4.49 4.49 0 0 0-1.104-1.31 5.141 5.141 0 0 0-3.257-1.127 5.151 5.151 0 0 0-3.255 1.136c-.46.376-.834.822-1.105 1.314a4.1 4.1 0 0 0-.27 3.372c.206.565.54 1.094.994 1.555.929.945 2.23 1.477 3.638 1.474Z"/>'
      }, props)
  }
  export function RiLogosBlenderLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.122 2.217a1 1 0 1 0-1.244 1.566L15.297 6.5H4.5a1 1 0 1 0 0 2h5.472L.878 15.717a1 1 0 0 0 1.244 1.566l5.423-4.303c-.03.252-.045.51-.045.77 0 4.108 3.691 7.25 8 7.25s8-3.142 8-7.25c0-2.247-1.124-4.227-2.835-5.539l-7.543-5.994ZM11.565 9.79C12.61 8.992 13.983 8.5 15.5 8.5c1.52 0 2.895.494 3.942 1.295 1.284.98 2.058 2.403 2.058 3.955 0 2.796-2.577 5.25-6 5.25s-6-2.454-6-5.25c0-1.48.704-2.842 1.882-3.816l.183-.145Zm2.913 4.303c-.277-.26-.399-.566-.381-.882.032-.565.623-1.21 1.498-1.21.873 0 1.465.644 1.498 1.209.018.33-.108.633-.378.887-.285.27-.697.44-1.12.44-.414 0-.827-.17-1.117-.444ZM15.595 10c-1.746 0-3.394 1.295-3.495 3.1-.108 1.945 1.625 3.436 3.495 3.436 1.876 0 3.602-1.477 3.495-3.438C18.988 11.294 17.34 10 15.595 10Z"/>'
      }, props)
  }
  export function RiLogosBootstrapFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.423 3.038c-1.284 0-2.233 1.124-2.19 2.342.04 1.171-.013 2.687-.395 3.924-.383 1.24-1.03 2.026-2.088 2.127v1.138c1.058.101 1.705.887 2.088 2.127.382 1.236.435 2.753.394 3.923-.042 1.219.907 2.343 2.192 2.343h13.154c1.284 0 2.234-1.124 2.192-2.343-.041-1.17.012-2.687.393-3.923.384-1.24 1.03-2.026 2.087-2.127v-1.138c-1.058-.101-1.703-.887-2.087-2.127-.381-1.236-.434-2.753-.393-3.924.042-1.218-.908-2.342-2.192-2.342H5.423Zm10.581 11.033c0 1.678-1.251 2.696-3.328 2.696H9.14a.381.381 0 0 1-.382-.381V7.614a.381.381 0 0 1 .382-.381h3.515c1.732 0 2.869.938 2.869 2.379 0 1.01-.765 1.916-1.739 2.074v.053c1.326.145 2.22 1.064 2.22 2.332Zm-3.714-5.63h-2.016v2.848h1.698c1.313 0 2.036-.528 2.036-1.473 0-.885-.622-1.374-1.718-1.374Zm-2.016 3.978v3.139h2.09c1.367 0 2.09-.549 2.09-1.58 0-1.03-.743-1.559-2.178-1.559h-2.002Z"/>'
      }, props)
  }
  export function RiLogosBootstrapLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1 11v2s2 0 2 4v1a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-1c0-4 2-4 2-4v-2s-2 0-2-4V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v1c0 4-2 4-2 4Zm19.674 1c-.03.028-.059.056-.088.086C19.578 13.093 19 14.692 19 17v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-1c0-2.308-.578-3.907-1.586-4.914A3.887 3.887 0 0 0 3.326 12c.03-.028.059-.056.088-.086C4.422 10.907 5 9.308 5 7V6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1c0 2.308.578 3.907 1.586 4.914l.088.086ZM8.5 7v10h5a3 3 0 0 0 1.615-5.529A3 3 0 0 0 12.5 7h-4Zm2 4V9h2a1 1 0 1 1 0 2h-2Zm0 2h3a1 1 0 1 1 0 2h-3v-2Z"/>'
      }, props)
  }
  export function RiLogosCentosFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 13.06 4.47 4.471L12 22l-4.47-4.47L12 13.06Zm-8 3.06L7.879 20H4v-3.88Zm16 0V20h-3.88L20 16.12Zm-2.47-8.59L22 12l-4.469 4.47-4.47-4.47 4.469-4.47Zm-11.06 0L10.94 12l-4.471 4.469L2 12l4.47-4.47ZM12 2l4.469 4.469L12 10.939 7.53 6.47 12 2ZM7.879 4l-3.88 3.879L4 4h3.879ZM20 4v3.879l-3.88-3.88L20 4Z"/>'
      }, props)
  }
  export function RiLogosCentosLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 2 4.292 4.292 1.061-1.06L16.121 4H20v3.879l-1.233-1.233-1.06 1.061L22 12l-4.292 4.293 1.059 1.059L20 16.121V20h-3.88l1.232-1.233-1.059-1.06L12 22l-4.293-4.293-1.061 1.06L7.879 20H4v-3.88l1.231 1.232 1.061-1.06L2 12l4.293-4.293-1.062-1.061L4 7.879V4h3.879L6.646 5.23l1.062 1.062L12 2Zm0 11.413-2.88 2.879 2.88 2.88 2.879-2.88L12 13.412ZM7.707 9.12 4.828 12l2.878 2.878 2.88-2.88-2.879-2.877Zm8.585 0-2.877 2.878 2.878 2.879L19.172 12l-2.88-2.879ZM12 4.828 9.122 7.707l2.879 2.878 2.877-2.879L12 4.828Z"/>'
      }, props)
  }
  export function RiLogosChromeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.827 21.763C5.35 20.771 2 16.777 2 12c0-1.822.487-3.53 1.339-5.002l4.283 7.419a4.999 4.999 0 0 0 4.976 2.548l-2.77 4.798ZM12 22l4.287-7.425A4.977 4.977 0 0 0 17 12a4.978 4.978 0 0 0-1-3h5.542c.298.947.458 1.955.458 3 0 5.523-4.477 10-10 10Zm2.572-8.455a2.999 2.999 0 0 1-5.17-.045l-.029-.05a3 3 0 1 1 5.225.05l-.026.045Zm-9.94-8.306A9.974 9.974 0 0 1 12 2a9.996 9.996 0 0 1 8.662 5H12a5.001 5.001 0 0 0-4.599 3.034L4.632 5.24Z"/>'
      }, props)
  }
  export function RiLogosChromeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.364 19.833 1.93-3.342a4.499 4.499 0 0 1-4.234-2.315L4.795 8.52a8.003 8.003 0 0 0 5.57 11.313Zm2.226.146A8 8 0 0 0 19.602 9.5h-3.86c.479.715.758 1.575.758 2.5 0 .848-.234 1.64-.642 2.318l-3.268 5.66Zm1.553-6.691.022-.038a2.5 2.5 0 1 0-4.354-.042l.024.042a2.499 2.499 0 0 0 4.308.037Zm-8.108-6.62 1.928 3.34A4.5 4.5 0 0 1 12 7.5h6.615A7.992 7.992 0 0 0 12 4a7.98 7.98 0 0 0-5.965 2.669ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z"/>'
      }, props)
  }
  export function RiLogosCodepenFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 10.202 9.303 12 12 13.798 14.697 12 12 10.202Zm4.5.596L19.197 9 13 4.869v3.596l3.5 2.333Zm3.5.07L18.303 12 20 13.132v-2.264Zm-3.5 2.334L13 15.535v3.596L19.197 15 16.5 13.202ZM11 8.465V4.869L4.803 9 7.5 10.798 11 8.465ZM4.803 15 11 19.131v-3.596l-3.5-2.333L4.803 15Zm.894-3L4 10.868v2.264L5.697 12ZM2 9a1 1 0 0 1 .445-.832l9-6a1 1 0 0 1 1.11 0l9 6A1 1 0 0 1 22 9v6a1 1 0 0 1-.445.832l-9 6a1 1 0 0 1-1.11 0l-9-6A1 1 0 0 1 2 15V9Z"/>'
      }, props)
  }
  export function RiLogosCodepenLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.5 13.202 13 15.535v3.596L19.197 15 16.5 13.202ZM14.697 12 12 10.202 9.303 12 12 13.798 14.697 12ZM20 10.868 18.303 12 20 13.132v-2.264ZM19.197 9 13 4.869v3.596l3.5 2.333L19.197 9ZM7.5 10.798 11 8.465V4.869L4.803 9 7.5 10.798ZM4.803 15 11 19.131v-3.596l-3.5-2.333L4.803 15ZM4 13.132 5.697 12 4 10.868v2.264ZM2 9a1 1 0 0 1 .445-.832l9-6a1 1 0 0 1 1.11 0l9 6A1 1 0 0 1 22 9v6a1 1 0 0 1-.445.832l-9 6a1 1 0 0 1-1.11 0l-9-6A1 1 0 0 1 2 15V9Z"/>'
      }, props)
  }
  export function RiLogosCopilotFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.662 14.484a1.001 1.001 0 1 1 2.003 0v1.997a1.001 1.001 0 1 1-2.003 0v-1.997Zm6.675 0a1.001 1.001 0 1 0-2.003 0v1.997a1.001 1.001 0 1 0 2.003 0v-1.997ZM11.999 4.028c-.845-1.219-2.598-1.31-3.945-1.188-1.543.154-2.843.685-3.574 1.464-1.268 1.386-1.326 4.291-.715 5.89-.061.274-.12.551-.162.845-1.13.297-2.283 1.898-2.283 3.043v2.162c0 .6.28 1.148.775 1.522C4.919 19.864 8.439 21.49 12 21.49c3.56 0 7.08-1.626 9.904-3.724a1.89 1.89 0 0 0 .775-1.521v-2.163c0-1.145-1.153-2.746-2.283-3.043-.042-.294-.1-.57-.162-.844.611-1.6.552-4.505-.715-5.89-.731-.78-2.03-1.31-3.574-1.465-1.347-.121-3.1-.03-3.946 1.188Zm6.675 13.46c-1.535.854-4.085 2-6.675 2s-5.139-1.146-6.674-2v-5.799c2.477.96 5.327.465 6.673-1.758H12c1.346 2.223 4.196 2.717 6.673 1.758v5.798Zm-8.01-10.66c0 1.586-.48 3.312-2.67 3.312s-2.606-.524-2.606-1.997c0-2.336.356-3.336 3.316-3.336 1.71 0 1.96.55 1.96 2.022Zm2.67 0c0-1.472.25-2.02 1.961-2.02 2.96 0 3.316 1 3.316 3.335 0 1.473-.417 1.997-2.607 1.997-2.19 0-2.67-1.726-2.67-3.311Z"/>'
      }, props)
  }
  export function RiLogosCopilotLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.4 7.8c0-2.088 1.178-3 3.172-3 1.196 0 2.129.264 2.129 1.6 0 1.814-.575 3.75-2.7 3.75-1.229 0-1.798-.176-2.09-.424-.247-.21-.51-.67-.51-1.926Zm3.172-5C5.497 2.8 3.4 4.626 3.4 7.8c0 1 .137 1.89.53 2.605l-.183.364a6.26 6.26 0 0 0-1.425 1.107c-1.061 1.126-.973 2.389-.973 3.824 0 2.267 2.512 3.62 4.315 4.373 2.133.89 4.677 1.427 6.336 1.427 1.658 0 4.202-.537 6.335-1.427 1.803-.752 4.315-2.106 4.315-4.373 0-1.435.088-2.698-.973-3.823a6.262 6.262 0 0 0-1.425-1.108l-.182-.364c.392-.716.53-1.606.53-2.605 0-3.174-2.097-5-5.172-5-1.24 0-2.618.26-3.428 1.283C11.19 3.06 9.813 2.8 8.57 2.8ZM8 12.15c1.692 0 3.224-.815 4-2.334.775 1.519 2.307 2.334 4 2.334.894 0 1.769-.074 2.517-.38.511.596 1.17.912 1.705 1.479.639.677.428 1.584.428 2.451 0 1.272-2.166 2.144-3.086 2.527-1.942.81-4.223 1.273-5.565 1.273-1.341 0-3.623-.463-5.565-1.273-.919-.383-3.085-1.255-3.085-2.527 0-.867-.21-1.774.428-2.451.56-.595 1.341-.75 1.705-1.479.748.306 1.623.38 2.518.38Zm5.3-5.75c0-1.336.932-1.6 2.128-1.6 1.994 0 3.171.912 3.171 3 0 1.257-.263 1.716-.51 1.926-.292.248-.861.424-2.09.424-2.125 0-2.7-1.936-2.7-3.75Zm-4.638 8.084a1.001 1.001 0 1 1 2.002 0v1.997a1.001 1.001 0 1 1-2.002 0v-1.997Zm6.675 0a1.001 1.001 0 1 0-2.003 0v1.997a1.001 1.001 0 1 0 2.003 0v-1.997Z"/>'
      }, props)
  }
  export function RiLogosCoreosFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-3.671-9.696c-.04.85.037 1.697.118 2.544.005.06.027.074.08.08.406.054.813.102 1.222.127.964.061 1.928.139 2.896.085.55-.03 1.1-.048 1.648-.095.78-.068 1.56-.155 2.33-.312.958-.194 1.907-.425 2.8-.845.406-.19.79-.415 1.114-.736.238-.235.408-.507.41-.86a8.893 8.893 0 0 0-.045-.94 9.02 9.02 0 0 0-.482-2.18c-.583-1.618-1.509-2.989-2.825-4.07a8.87 8.87 0 0 0-3.851-1.863c-.5-.105-1.006-.144-1.514-.18-.573-.041-1.064.12-1.488.514-.495.457-.837 1.025-1.122 1.633-.667 1.427-.973 2.954-1.166 4.508-.106.857-.166 1.721-.125 2.59Zm3.57-5.03c.959.03 1.77.324 2.494.856a4.326 4.326 0 0 1 1.714 2.612c.068.304.097.612.103.922.005.209-.11.362-.262.49-.307.258-.67.401-1.05.508a10.32 10.32 0 0 1-2.265.366c-.5.026-1 .035-1.5.01-.192-.01-.384-.024-.577-.032-.06-.002-.08-.02-.083-.081-.024-.434-.058-.868-.051-1.302.016-1.026.094-2.045.397-3.034.1-.329.223-.65.42-.936.173-.25.378-.437.66-.38Z"/>'
      }, props)
  }
  export function RiLogosCoreosLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.454 4.414a8 8 0 1 0 10.202 9.91c-3.4 1.46-7.248 1.98-11.545 1.565-.711-4.125-.264-7.95 1.343-11.475ZM11.902 4a16.806 16.806 0 0 0-1.541 3.768 5.98 5.98 0 0 1 4.114 1.756 5.978 5.978 0 0 1 1.745 3.861c1.33-.341 2.589-.82 3.78-1.433A7.994 7.994 0 0 0 11.902 4ZM4.93 19.07c-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0Zm5.02-9.293a17.885 17.885 0 0 0-.076 4.229 23.142 23.142 0 0 0 4.36-.219 3.988 3.988 0 0 0-1.172-2.849 3.99 3.99 0 0 0-3.112-1.161Z"/>'
      }, props)
  }
  export function RiLogosDingdingFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm4.49 9.04-.006.014c-.42.898-1.516 2.66-1.516 2.66l-.005-.012-.32.558h1.543l-2.948 3.919.67-2.666h-1.215l.422-1.763c-.341.082-.745.195-1.223.349 0 0-.646.378-1.862-.729 0 0-.82-.722-.344-.902.202-.077.981-.175 1.595-.257a80.204 80.204 0 0 1 1.338-.172s-2.555.039-3.161-.057c-.606-.095-1.375-1.107-1.539-1.996 0 0-.253-.488.545-.257.798.231 4.101.9 4.101.9S8.27 9.312 7.983 8.99c-.286-.32-.841-1.754-.769-2.634 0 0 .031-.22.257-.16 0 0 3.176 1.45 5.347 2.245 2.172.795 4.06 1.199 3.816 2.228-.02.087-.072.216-.144.37Z"/>'
      }, props)
  }
  export function RiLogosDingdingLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0-2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm4.49 9.04-.006.014c-.42.898-1.516 2.66-1.516 2.66l-.005-.012-.32.558h1.543l-2.948 3.919.67-2.666h-1.215l.422-1.763c-.341.082-.745.195-1.223.349 0 0-.646.378-1.862-.729 0 0-.82-.722-.344-.902.202-.077.981-.175 1.595-.257a80.204 80.204 0 0 1 1.338-.172s-2.555.039-3.161-.057c-.606-.095-1.375-1.107-1.539-1.996 0 0-.253-.488.545-.257.798.231 4.101.9 4.101.9S8.27 9.312 7.983 8.99c-.286-.32-.841-1.754-.769-2.634 0 0 .031-.22.257-.16 0 0 3.176 1.45 5.347 2.245 2.172.795 4.06 1.199 3.816 2.228-.02.087-.072.216-.144.37Z"/>'
      }, props)
  }
  export function RiLogosDiscordFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.303 5.337A17.32 17.32 0 0 0 14.963 4c-.191.329-.403.775-.552 1.125a16.592 16.592 0 0 0-4.808 0C9.454 4.775 9.23 4.329 9.05 4a17.075 17.075 0 0 0-4.342 1.337C1.961 9.391 1.218 13.35 1.59 17.255a17.69 17.69 0 0 0 5.318 2.664 12.94 12.94 0 0 0 1.136-1.836c-.627-.234-1.22-.52-1.794-.86.149-.106.297-.223.435-.34 3.46 1.582 7.207 1.582 10.624 0 .149.117.287.234.435.34-.573.34-1.167.626-1.793.86a12.94 12.94 0 0 0 1.135 1.836 17.594 17.594 0 0 0 5.318-2.664c.457-4.52-.722-8.448-3.1-11.918ZM8.52 14.846c-1.04 0-1.889-.945-1.889-2.101 0-1.157.828-2.102 1.89-2.102 1.05 0 1.91.945 1.888 2.102 0 1.156-.838 2.1-1.889 2.1Zm6.974 0c-1.04 0-1.89-.945-1.89-2.101 0-1.157.828-2.102 1.89-2.102 1.05 0 1.91.945 1.889 2.102 0 1.156-.828 2.1-1.89 2.1Z"/>'
      }, props)
  }
  export function RiLogosDiscordLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.52 13.846c-1.04 0-1.888-.945-1.888-2.102 0-1.156.827-2.1 1.889-2.1 1.05 0 1.91.944 1.889 2.1 0 1.157-.839 2.102-1.89 2.102Zm6.974 0c-1.04 0-1.89-.945-1.89-2.102 0-1.156.829-2.1 1.89-2.1 1.05 0 1.91.944 1.89 2.1 0 1.157-.829 2.102-1.89 2.102Zm-5.369-9.523-.308-.563-.634.105a16.353 16.353 0 0 0-4.158 1.28l-.228.106-.142.209c-2.613 3.854-3.33 7.648-2.975 11.376l.039.406.33.24a16.909 16.909 0 0 0 5.078 2.543l.79.242L9.03 17.55c1.91.472 4.03.473 5.939 0l1.107 2.718.79-.243a16.822 16.822 0 0 0 5.08-2.544l.327-.238.04-.402c.436-4.32-.697-8.084-2.958-11.385l-.142-.207-.228-.104a16.575 16.575 0 0 0-4.154-1.28l-.618-.103-.314.541c-.088.151-.177.321-.263.494a15.878 15.878 0 0 0-3.263 0 14.12 14.12 0 0 0-.248-.474ZM6.715 16.61c.197.114.405.226.61.328l-.449 1.096a15.022 15.022 0 0 1-3.428-1.778c-.225-3.139.413-6.305 2.564-9.57a14.551 14.551 0 0 1 2.824-.913c.06.125.116.247.162.356l.273.643.692-.101a14.107 14.107 0 0 1 4.09 0l.69.1.272-.642c.047-.112.102-.234.16-.356.977.21 1.923.519 2.828.915 1.875 2.82 2.821 5.966 2.546 9.567a14.905 14.905 0 0 1-3.43 1.778l-.445-1.094c.206-.103.414-.215.613-.329.49-.282 1.017-.634 1.353-.97l-1.28-1.28c-.163.164-.523.42-.977.682-.444.256-.885.463-1.167.556-2.003.663-4.428.663-6.432 0-.281-.093-.722-.3-1.166-.556-.454-.261-.814-.518-.978-.682l-1.28 1.28c.337.336.864.688 1.354.97Z"/>'
      }, props)
  }
  export function RiLogosDisqusFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-2.53 0-4.84-.94-6.601-2.488L1.5 20l1.424-3.797A9.962 9.962 0 0 1 2 12C2 6.477 6.477 2 12 2ZM8 7v10h3.733l.263-.004c3.375-.103 5.337-2.211 5.337-5.025v-.027l-.003-.215C17.23 8.956 15.21 7 11.79 7H8Zm3.831 2.458c1.628 0 2.709.928 2.709 2.529v.028l-.005.183c-.079 1.5-1.138 2.345-2.704 2.345h-1.108V9.458h1.108Z"/>'
      }, props)
  }
  export function RiLogosDisqusLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.997 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.961 9.961 0 0 1-6.249-2.192l-4.718.59 1.72-4.586A9.972 9.972 0 0 1 1.996 12c0-5.523 4.477-10 10-10Zm0 2a8 8 0 0 0-7.262 11.362l.177.38-.848 2.26 2.315-.289.338.297a7.965 7.965 0 0 0 5.28 1.99 8 8 0 1 0 0-16Zm-3.95 3h3.79c3.42 0 5.44 1.956 5.54 4.729l.004.215v.027c0 2.814-1.963 4.922-5.338 5.025l-.262.004H8.047V7h3.79-3.79Zm3.832 2.458H10.77v5.085h1.109c1.565 0 2.624-.845 2.703-2.345l.005-.183v-.028c0-1.6-1.08-2.53-2.708-2.53Z"/>'
      }, props)
  }
  export function RiLogosDoubanFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.314 19.138h4.065a.62.62 0 0 1 .621.62v.621a.62.62 0 0 1-.62.621H3.62a.62.62 0 0 1-.62-.62v-.621a.62.62 0 0 1 .62-.621h3.754l-.96-3.104h2.19a.62.62 0 0 1 .59.425l.892 2.679H13.6l1.225-4.035H5.172a.62.62 0 0 1-.62-.62V7.345a.62.62 0 0 1 .62-.62h13.656a.62.62 0 0 1 .62.62v7.138a.62.62 0 0 1-.62.62h-1.289l-1.225 4.035ZM3.931 3h16.138a.62.62 0 0 1 .62.62v.621a.62.62 0 0 1-.62.621H3.931a.62.62 0 0 1-.62-.62V3.62A.62.62 0 0 1 3.93 3ZM7.19 8.586a.155.155 0 0 0-.156.155v4.035c0 .086.07.155.156.155h9.62c.086 0 .155-.07.155-.155V8.74a.155.155 0 0 0-.155-.155H7.19Z"/>'
      }, props)
  }
  export function RiLogosDoubanLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.274 15H5V7h14v8h-1.624l-1.3 4H21v2H3v-2h4.612L6.8 16.5l1.902-.618L9.715 19h4.259l1.3-4ZM3.5 3h17v2h-17V3ZM7 9v4h10V9H7Z"/>'
      }, props)
  }
  export function RiLogosDribbbleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c5.51 0 10-4.48 10-10S17.51 2 12 2Zm6.605 4.61a8.502 8.502 0 0 1 1.93 5.314c-.281-.054-3.101-.629-5.943-.271-.065-.141-.12-.293-.184-.445a25.276 25.276 0 0 0-.564-1.236c3.145-1.28 4.577-3.124 4.761-3.362ZM12 3.475c2.17 0 4.154.814 5.662 2.148-.152.216-1.443 1.941-4.48 3.08-1.399-2.57-2.95-4.675-3.189-5A8.686 8.686 0 0 1 12 3.475Zm-3.633.803a53.9 53.9 0 0 1 3.167 4.935c-3.992 1.063-7.517 1.04-7.896 1.04a8.581 8.581 0 0 1 4.729-5.975ZM3.453 12.01v-.26c.37.01 4.512.065 8.775-1.215.25.477.477.965.694 1.453-.109.033-.228.065-.336.098-4.404 1.42-6.747 5.303-6.942 5.629a8.521 8.521 0 0 1-2.19-5.705ZM12 20.547a8.482 8.482 0 0 1-5.239-1.8c.152-.315 1.888-3.656 6.703-5.337.022-.01.033-.01.054-.022a35.316 35.316 0 0 1 1.823 6.475 8.4 8.4 0 0 1-3.341.684Zm4.761-1.465c-.086-.52-.542-3.015-1.66-6.084 2.68-.423 5.023.271 5.315.369a8.468 8.468 0 0 1-3.655 5.715Z"/>'
      }, props)
  }
  export function RiLogosDribbbleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.989 11.572a7.96 7.96 0 0 0-1.573-4.351 9.757 9.757 0 0 1-.92.87 13.156 13.156 0 0 1-3.313 2.01c.167.35.32.689.455 1.009v.003c.027.061.05.118.094.229l.017.04c1.513-.17 3.109-.107 4.656.103.206.027.4.056.584.087Zm-9.385-7.45a46.15 46.15 0 0 1 2.692 4.27c1.223-.482 2.234-1.09 3.048-1.767.33-.274.594-.532.796-.755A7.968 7.968 0 0 0 12 4c-.476 0-.942.042-1.396.121ZM4.253 9.997a29.21 29.21 0 0 0 2.04-.123 31.53 31.53 0 0 0 4.862-.822 54.36 54.36 0 0 0-2.7-4.227 8.018 8.018 0 0 0-4.202 5.172Zm1.53 7.038a14.21 14.21 0 0 1 1.575-1.899c1.454-1.49 3.17-2.65 5.156-3.29l.062-.018c-.165-.364-.32-.689-.476-.995-1.836.535-3.77.869-5.697 1.042-.94.085-1.783.122-2.403.128a7.966 7.966 0 0 0 1.784 5.032Zm9.221 2.38a35.951 35.951 0 0 0-1.632-5.709c-2 .727-3.596 1.79-4.829 3.058a9.77 9.77 0 0 0-1.317 1.655A7.964 7.964 0 0 0 12 20a7.977 7.977 0 0 0 3.005-.583Zm1.874-1.075a7.998 7.998 0 0 0 2.987-4.87c-.34-.085-.771-.17-1.245-.236a12.025 12.025 0 0 0-3.18-.033 39.39 39.39 0 0 1 1.438 5.14ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z"/>'
      }, props)
  }
  export function RiLogosDriveFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m7.94 4.146 3.482 6.03-5.94 10.293L2 14.44 7.94 4.146Zm2.176 10.294H22l-3.482 6.029H6.635l3.481-6.029Zm4.343-1L8.518 3.145h6.964l5.94 10.295H14.46Z"/>'
      }, props)
  }
  export function RiLogosDriveLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.097 6.15 4.31 14.443l1.755 3.031 4.785-8.288L9.097 6.15Zm-1.3 12.324h9.568l1.751-3.034H9.55l-1.752 3.034Zm11.314-5.034-4.786-8.29H10.83l4.787 8.29h3.495ZM8.52 3.15h6.96L22 14.444l-3.48 6.03H5.49L2 14.444 8.52 3.15Zm3.485 8.036-1.302 2.254h2.603l-1.301-2.254Z"/>'
      }, props)
  }
  export function RiLogosDropboxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.285 10.668 5.215 3.323-5.252 3.346L12 13.993l-5.248 3.344L1.5 13.99l5.215-3.323L1.5 7.346 6.752 4 12 7.343 17.248 4 22.5 7.346l-5.215 3.322Zm-.074 0L12 7.348l-5.211 3.32L12 13.988l5.211-3.32ZM6.786 18.446l5.252-3.346 5.252 3.346-5.252 3.346-5.252-3.346Z"/>'
      }, props)
  }
  export function RiLogosDropboxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m8.65 17.26 3.392 2.161 3.392-2.16 1.86 1.184-5.252 3.346-5.252-3.346 1.86-1.184Zm-.876-8.28 2.393-1.553L7.74 5.853 5.286 7.37l2.488 1.61Zm1.84 1.19 2.39 1.548 2.391-1.547-2.39-1.552-2.392 1.551Zm4.231 2.74 2.424 1.568 2.45-1.502-2.486-1.613-2.388 1.546Zm-1.84-6.675 4.236-2.749 6.225 3.844-4.393 2.843 4.394 2.85-6.227 3.819-4.235-2.742-4.236 2.742-6.229-3.818 4.395-2.852L1.543 7.33l6.225-3.844 4.236 2.75Zm1.836 1.192 2.394 1.553 2.488-1.61-2.455-1.517-2.427 1.574Zm-3.677 5.482-2.39-1.546-2.485 1.613 2.451 1.502 2.424-1.569Z"/>'
      }, props)
  }
  export function RiLogosEdgeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.645 8.586c-.17-.711-.441-1.448-.774-2.021-.771-1.329-1.464-2.237-3.177-3.32C14.981 2.162 13.077 2 12.171 2c-2.415 0-4.211.86-5.525 1.887C3.345 6.47 3.001 11 3.001 11s1.221-2.045 3.54-3.526C7.944 6.579 9.942 6 11.569 6c4.317 0 4.432 4 4.432 4h-7c0-2 1-3 1-3s-5 2-5 7.044c0 .487-.003 1.372.248 2.283.232.843.7 1.705 1.132 2.353 1.221 1.832 3.045 2.614 3.916 2.904.996.332 2.029.416 3.01.416 2.72 0 4.877-.886 5.694-1.275v-4.172c-.758.454-2.679 1.447-5 1.447-5 0-5-4-5-4h12v-2.49s-.039-1.593-.356-2.924Z"/>'
      }, props)
  }
  export function RiLogosEdgeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.008 14.001A4.566 4.566 0 0 0 8 14.25c0 2.382 1.753 4.75 5 4.75 2.373 0 4.528-.655 6-1.553v3.35c-1.789.767-3.888 1.203-6 1.203-5.502 0-8-3.47-8-7.75 0-3.231 2.041-6 4.943-7.164C8.54 8.663 8 10.341 8 10.996l10 .004c0-3.406-2.548-6-6-6-5 0-8.001 3.988-9 5.999.29-4.762 4.01-8.999 9-8.999 5.2 0 9 4.03 9 9v3h-13l.007.001Z"/>'
      }, props)
  }
  export function RiLogosEdgeNewFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.817 21.835c-.106.003-.212.005-.317.005-1.073 0-2.374-.62-3.42-1.758A6.753 6.753 0 0 1 8.3 15.5c0-1.418.518-2.565 1.201-3.406C9.558 14.58 11.86 17.7 16.5 17.7c1.678 0 2.717-.452 3.28-.697.208-.09.35-.153.436-.153.184 0 .284.1.284.3 0 .187-.101.321-.426.752l-.073.098a9.999 9.999 0 0 1-6.184 3.835Zm-3.115.081C5.792 21.28 2 17.084 2 12c0-1.28.74-2.329 1.897-3.08C5.058 8.164 6.587 7.75 8 7.75c2.276 0 3.635.765 4.428 1.647.05.056.098.112.144.169A2.506 2.506 0 0 0 12 9.5h-.004a2.49 2.49 0 0 0-1.2.309 4.723 4.723 0 0 0-.236.117 6 6 0 0 0-1.51 1.168A6.345 6.345 0 0 0 7.3 15.5c0 2.137.855 3.965 2.044 5.258.414.45.874.841 1.358 1.159Zm3.15-8.32c.266-.28.648-.684.648-1.596 0-.86-.338-2.171-1.328-3.272C12.165 7.61 10.524 6.75 8 6.75c-1.587 0-3.308.46-4.647 1.33-.28.183-.546.384-.79.605C3.93 4.79 7.639 2 12 2c5.523 0 10 4 10 8.5 0 2.8-2.2 4.85-5 4.85-2 0-3.4-.65-3.4-1.35 0-.14.11-.254.252-.404Z"/>'
      }, props)
  }
  export function RiLogosEdgeNewLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.949 18.204C6.3 16.775 6 15.201 6 14c0-1.496.59-3.093 1.603-4.323.64-.778 1.474-1.436 2.465-1.818-.48-.07-1.003-.109-1.568-.109C5.99 7.75 4 9.612 4 12a7.985 7.985 0 0 0 2.949 6.204ZM12 20a7.99 7.99 0 0 0 2.649-.449c-3.364-.557-5.648-2.613-6.62-4.963.095 1.026.43 2.296 1.03 3.357C9.776 19.217 10.752 20 12 20Zm4.5-8c0 .474-.064.912-.188 1.315.206.022.435.035.688.035 1.776 0 3-1.234 3-2.85C20 7.37 16.704 4 12 4a7.97 7.97 0 0 0-5.272 1.983A6.834 6.834 0 0 1 8.5 5.75c2.407 0 4.396.601 5.807 1.715C15.737 8.595 16.5 10.198 16.5 12ZM12 9.5A2.5 2.5 0 0 0 9.5 12c0 2.5 2.3 5.7 7 5.7.442 0 .84-.031 1.196-.082a7.4 7.4 0 0 0 1.736-.468c.132-.053.247-.103.347-.147.209-.09.352-.153.437-.153.184 0 .284.1.284.3 0 .156-.07.276-.284.563l-.142.19-.073.097a10.044 10.044 0 0 1-1.365 1.48A9.963 9.963 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4 10 8.5c0 2.8-2.2 4.85-5 4.85-2 0-3.4-.65-3.4-1.35 0-.14.11-.254.252-.404.266-.28.648-.684.648-1.596A2.5 2.5 0 0 0 12 9.5Z"/>'
      }, props)
  }
  export function RiLogosEvernoteFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.63 7.754c-.215.201-.545.217-.742.217h-2.11c-.61 0-.974 0-1.22.033-.134.017-.298.084-.381.117-.033.016-.033 0-.017-.016l4.816-4.94c.017-.017.033-.017.017.017a1.734 1.734 0 0 0-.116.382c-.033.249-.033.615-.033 1.23v2.212c0 .2-.017.533-.214.748Zm4.683 14.184c-.56-.366-.857-.848-.973-1.147a2.444 2.444 0 0 1-.181-.915 2.513 2.513 0 0 1 2.507-2.51c.412 0 .742.332.742.748a.736.736 0 0 1-.38.648.95.95 0 0 1-.28.1c-.082.017-.396.05-.543.183a.776.776 0 0 0-.298.582.92.92 0 0 0 .264.649c.297.299.693.465 1.122.465a2.035 2.035 0 0 0 2.028-2.045c0-1.014-.676-1.913-1.567-2.311-.132-.067-.346-.117-.544-.167a6.723 6.723 0 0 0-.495-.083c-.693-.084-2.424-.632-2.54-2.178 0 0-.51 2.328-1.534 2.96-.098.05-.23.1-.379.133-.148.033-.312.05-.363.05-1.665.1-3.43-.433-4.65-1.696 0 0-.825-.682-1.253-2.594-.099-.466-.297-1.298-.412-2.08-.05-.282-.067-.498-.083-.698 0-.814.495-1.363 1.121-1.445h3.365c.576 0 .907-.15 1.121-.35.28-.266.347-.649.347-1.098V3.631c.08-.615.627-1.131 1.434-1.131h.396c.165 0 .363.017.544.033.132.017.247.05.445.1 1.006.25 1.22 1.28 1.22 1.28l2.854.5c.907.166 3.15.316 3.578 2.594 1.006 5.42.396 10.675.347 10.675-.71 5.121-4.931 4.871-4.931 4.871a3.426 3.426 0 0 1-2.03-.615Zm2.622-10.309c-.033.084-.066.183-.05.233.018.05.051.066.084.083.198.1.527.15 1.006.2.478.05.808.083 1.022.05.033 0 .067-.017.1-.067.032-.05.016-.15.016-.233-.05-.449-.462-.781-1.006-.848-.545-.05-1.006.167-1.172.582Z"/>'
      }, props)
  }
  export function RiLogosEvernoteLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.501 8.5a1 1 0 0 1-1 1H6.002c-.336 0-.501.261-.501.532 0 1.32.254 2.371.664 3.193.216.433.399.67.523.79.735.76 1.886 1.16 3.092 1.089.095-.006.199-.064.332-.208.121-.132.203-.268.214-.293a2 2 0 0 1 2.531-1.073c.693.258 1.277.434 1.813.56.196.046.375.083.586.123-.077-.015.402.073.518.097.34.07.598.146.883.29a5.088 5.088 0 0 1 1.775 1.475c.045-.591.077-1.268.087-2.026a34.185 34.185 0 0 0-.558-6.673c-.075-.398-.237-.562-.664-.718a3.846 3.846 0 0 0-.587-.155c-.146-.028-.65-.11-.693-.118l-.011-.002a1296.337 1296.337 0 0 1-2.33-.407l-.527-.092a2 2 0 0 1-1.524-1.26 11.726 11.726 0 0 0-.034-.088 5.594 5.594 0 0 0-.702-.036c-.271 0-.388.124-.388.463V8.5Zm6.23 11.639c.352-.356.56-.829.587-1.327.054-1.036-.824-2.48-2.317-2.634-.617-.063-1.586-.306-2.842-.774 0 0-.7 1.603-2.26 1.696-1.665.1-3.43-.433-4.65-1.696 0 0-1.748-1.64-1.748-5.372 0-.814.29-1.422.648-1.904.96-1.292 2.505-2.78 4.133-4.304C9.001 3.15 9.702 2.5 10.89 2.5c2.04 0 2.32.664 2.605 1.414l2.854.499c.907.166 3.15.316 3.578 2.594 1.006 5.42.458 9.87.347 10.675-.71 5.121-4.772 4.871-4.931 4.871-2.059 0-3.178-1.373-3.183-2.677a2.494 2.494 0 0 1 1.038-2.034 2.586 2.586 0 0 1 1.527-.478c.304 0 .687.318.687.753 0 .37-.255.575-.383.645-.223.123-1.12.174-1.12.865 0 .317.348 1.114 1.385 1.114.588 0 1.094-.256 1.437-.602Zm-1.796-9.51c.166-.415.627-.632 1.172-.582.544.067.956.4 1.006.848 0 .083.017.183-.017.233-.032.05-.066.067-.1.067-.213.033-.543 0-1.021-.05-.48-.05-.808-.1-1.006-.2-.033-.017-.066-.033-.083-.083s.016-.15.05-.233Z"/>'
      }, props)
  }
  export function RiLogosFacebookBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.402 21v-6.966h2.333l.349-2.708h-2.682V9.598c0-.784.218-1.319 1.342-1.319h1.434V5.857a19.19 19.19 0 0 0-2.09-.107c-2.067 0-3.482 1.262-3.482 3.58v1.996h-2.338v2.708h2.338V21H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4.598Z"/>'
      }, props)
  }
  export function RiLogosFacebookBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 19h5V5H5v14h7v-5h-2v-2h2v-1.654c0-1.337.14-1.822.4-2.311A2.726 2.726 0 0 1 13.536 6.9c.382-.205.857-.328 1.687-.381.329-.021.755.005 1.278.08v1.9H16c-.917 0-1.296.043-1.522.164a.728.728 0 0 0-.314.314c-.12.226-.164.45-.164 1.368V12h2.5l-.5 2h-2v5ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiLogosFacebookCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c-5.523 0-10 4.477-10 10 0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12c0-5.523-4.477-10-10-10Z"/>'
      }, props)
  }
  export function RiLogosFacebookCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.001 19.938a8.001 8.001 0 0 0-1-15.938 8 8 0 0 0-1 15.938V14h-2v-2h2v-1.654c0-1.337.14-1.822.4-2.311A2.725 2.725 0 0 1 12.537 6.9c.382-.205.857-.328 1.687-.381.329-.021.755.005 1.278.08v1.9h-.5c-.917 0-1.296.043-1.522.164a.728.728 0 0 0-.314.314c-.12.226-.164.45-.164 1.368V12h2.5l-.5 2h-2v5.938Zm-1 2.062c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Z"/>'
      }, props)
  }
  export function RiLogosFacebookFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5Z"/>'
      }, props)
  }
  export function RiLogosFacebookLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 9h4.5l-.5 2h-4v9h-2v-9H7V9h4V7.128c0-1.783.186-2.43.534-3.082a3.635 3.635 0 0 1 1.512-1.512C13.698 2.186 14.345 2 16.128 2c.522 0 .98.05 1.372.15V4h-1.372c-1.324 0-1.727.078-2.139.298-.303.162-.529.388-.691.692-.22.411-.298.814-.298 2.138V9Z"/>'
      }, props)
  }
  export function RiLogosFinderFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.001 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-1 2h-8.465c-.69 1.977-1.035 4.644-1.035 8h3a17.15 17.15 0 0 0-.107 2.877c1.226-.211 2.704-.777 4.027-1.71l1.135 1.665c-1.642 1.095-3.303 1.779-4.976 2.043.052.37.113.745.184 1.125h6.237V5ZM6.556 14.168l-1.11 1.664C7.603 17.27 9.793 18 12.001 18v-2c-1.792 0-3.602-.603-5.445-1.832ZM17 7a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-10 0c-.552 0-1 .452-1 1v1a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1Z"/>'
      }, props)
  }
  export function RiLogosFinderLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.001 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-10.52 1.999L4.002 5v14h8.746a25.078 25.078 0 0 1-.163-1.02c-.297.013-.491.02-.583.02-2.208 0-4.398-.73-6.555-2.168l1.11-1.664C8.399 15.397 10.209 16 12 16c.133 0 .265-.003.398-.01a23.56 23.56 0 0 1 .007-1.99H9.501v-1c0-3.275.32-5.94.98-8.001Zm2.12 0c-.665 1.583-1.044 4.412-1.09 7.001h3.123l-.14 1.124c-.101.805-.137 1.645-.108 2.52 1.013-.3 2.031-.79 3.06-1.476l1.11 1.664c-1.32.88-2.652 1.495-3.993 1.84.057.433.13.876.219 1.327L20 19V5l-7.4-.001ZM7.001 7a1 1 0 0 1 1 1v1a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1Zm10 0a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiLogosFirefoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10c0-1.463.314-2.854.88-4.106.466-.939 1.233-1.874 1.85-2.194-.653 1.283-.973 2.54-1.04 3.383.454-1.5 1.315-2.757 2.52-3.644 2.066-1.519 4.848-1.587 5.956-.62-2.056.707-4.296 3.548-3.803 6.876.08.55.245 1.083.489 1.582-.384-1.01-.418-2.433.202-3.358.692-1.03 1.678-1.248 2.206-1.136-.208-.044-.668.836-.736.991-.173.394-.259.82-.251 1.25a3.394 3.394 0 0 0 1.03 2.38c1.922 1.871 5.023 1.135 6.411-1.002.954-1.471 1.07-3.968-.154-5.952a6.916 6.916 0 0 0-1.084-1.32c-1.85-1.766-4.48-2.57-6.982-2.205-1.106.177-2.047.496-2.824.956C7.756 2.798 9.912 2 12 2Z"/>'
      }, props)
  }
  export function RiLogosFirefoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10c0-1.463.314-2.854.88-4.106.466-.939 1.233-1.874 1.85-2.194-.653 1.283-.973 2.54-1.04 3.383.454-1.5 1.315-2.757 2.52-3.644 2.066-1.519 4.848-1.587 5.956-.62-2.056.707-4.296 3.548-3.803 6.876.08.55.245 1.083.489 1.582-.384-1.01-.418-2.433.202-3.358.692-1.03 1.678-1.248 2.206-1.136-.208-.044-.668.836-.736.991-.173.394-.259.82-.251 1.25a3.394 3.394 0 0 0 1.03 2.38c1.922 1.871 5.023 1.135 6.411-1.002.954-1.471 1.07-3.968-.154-5.952a6.916 6.916 0 0 0-1.084-1.32c-1.85-1.766-4.48-2.57-6.982-2.205-1.106.177-2.047.496-2.824.956C7.756 2.798 9.912 2 12 2ZM6.876 7.705c-2.253.781-3.501 3.17-2.579 6.46a8.004 8.004 0 0 0 7.455 5.831L12 20a8 8 0 0 0 7.985-7.504l.009-.212c-.13.349-.283.674-.463.98l-.14.227c-2.104 3.239-6.681 4.075-9.48 1.348a5.392 5.392 0 0 1-.962-1.257l-.106-.201c-1.736-.387-2.584-1.326-2.543-2.817.027-.991.23-1.96.575-2.86Z"/>'
      }, props)
  }
  export function RiLogosFlickrFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm12 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"/>'
      }, props)
  }
  export function RiLogosFlickrLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 17A5 5 0 1 0 6 7a5 5 0 0 0 0 10Zm3-5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm9 5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm3-5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>'
      }, props)
  }
  export function RiLogosFlutterFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.504 2.001-10 10 3.083 3.083 13.08-13.083h-6.163Zm-.005 9.198-5.376 5.42L13.496 22h6.188l-5.387-5.4 5.389-5.4h-6.188Z"/>'
      }, props)
  }
  export function RiLogosFlutterLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.598 10.684h2.828l-5.657 5.658 5.657 5.656h-2.828L8.94 16.341l5.657-5.657Zm-.194-8.68h2.829L5.919 13.318l-1.414-1.414 9.9-9.9Z"/>'
      }, props)
  }
  export function RiLogosGatsbyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10ZM6.43 17.571c-1.5-1.5-2.286-3.5-2.286-5.428l7.786 7.714c-2-.071-4-.786-5.5-2.286Zm7.285 2.072-9.357-9.357c.786-3.5 3.929-6.143 7.643-6.143 2.643 0 4.929 1.286 6.357 3.214l-1.071.929C16.072 6.643 14.144 5.57 12 5.57c-2.786 0-5.143 1.786-6.071 4.286l8.214 8.214c2.071-.714 3.643-2.5 4.143-4.642h-3.429V12h5c0 3.714-2.643 6.857-6.143 7.643Z"/>'
      }, props)
  }
  export function RiLogosGatsbyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.752 21.997c-5.221-.128-9.45-4.257-9.736-9.438l-.012-.313 9.748 9.751ZM12 2a9.988 9.988 0 0 1 8.193 4.265l-1.638 1.148A8.003 8.003 0 0 0 4.535 9.12L14.88 19.466A8.018 8.018 0 0 0 19.749 14H15.5v-2H22c0 4.726-3.279 8.686-7.686 9.73L2.27 9.686C3.314 5.28 7.275 2 12 2Z"/>'
      }, props)
  }
  export function RiLogosGithubFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c-5.525 0-10 4.475-10 10a9.994 9.994 0 0 0 6.837 9.488c.5.087.688-.213.688-.476 0-.237-.013-1.024-.013-1.862-2.512.463-3.162-.612-3.362-1.175-.113-.288-.6-1.175-1.025-1.413-.35-.187-.85-.65-.013-.662.788-.013 1.35.725 1.538 1.025.9 1.512 2.337 1.087 2.912.825.088-.65.35-1.087.638-1.337-2.225-.25-4.55-1.113-4.55-4.938 0-1.088.387-1.987 1.025-2.688-.1-.25-.45-1.275.1-2.65 0 0 .837-.262 2.75 1.026a9.28 9.28 0 0 1 2.5-.338c.85 0 1.7.112 2.5.337 1.913-1.3 2.75-1.024 2.75-1.024.55 1.375.2 2.4.1 2.65.637.7 1.025 1.587 1.025 2.687 0 3.838-2.337 4.688-4.563 4.938.363.312.676.912.676 1.85 0 1.337-.013 2.412-.013 2.75 0 .262.188.574.688.474A10.016 10.016 0 0 0 22 12c0-5.525-4.475-10-10-10Z"/>'
      }, props)
  }
  export function RiLogosGithubLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.884 18.653c-.3-.2-.558-.456-.86-.816a50.59 50.59 0 0 1-.466-.579c-.463-.575-.755-.841-1.056-.95a1 1 0 1 1 .675-1.882c.752.27 1.261.735 1.947 1.588-.094-.117.34.427.433.539.19.227.33.365.44.438.204.137.588.196 1.15.14.024-.382.094-.753.202-1.096-2.968-.725-4.648-2.64-4.648-6.396 0-1.238.37-2.355 1.058-3.291-.218-.894-.185-1.975.302-3.192a1 1 0 0 1 .63-.583c.081-.024.127-.034.208-.047.803-.123 1.937.17 3.415 1.097a11.731 11.731 0 0 1 2.687-.308c.912 0 1.819.103 2.684.308 1.477-.933 2.614-1.227 3.422-1.097.085.014.158.032.218.051a1 1 0 0 1 .616.58c.487 1.215.52 2.296.302 3.19.691.936 1.058 2.045 1.058 3.292 0 3.758-1.674 5.666-4.642 6.393.125.415.19.878.19 1.38 0 .664-.002 1.299-.007 2.01 0 .19-.002.394-.005.706a1 1 0 0 1-.018 1.957c-1.14.228-1.984-.532-1.984-1.524l.002-.447.005-.705c.005-.707.008-1.338.008-1.997 0-.697-.184-1.152-.426-1.361-.661-.57-.326-1.654.541-1.751 2.966-.334 4.336-1.483 4.336-4.66 0-.955-.312-1.745-.913-2.405a1 1 0 0 1-.189-1.044c.166-.415.236-.957.095-1.614l-.01.002c-.491.14-1.11.44-1.858.95a1 1 0 0 1-.833.135 9.626 9.626 0 0 0-2.592-.35c-.89 0-1.772.12-2.592.35a1 1 0 0 1-.829-.133c-.753-.507-1.374-.807-1.87-.947-.143.653-.072 1.194.093 1.607a1 1 0 0 1-.189 1.044c-.597.656-.913 1.459-.913 2.404 0 3.172 1.371 4.33 4.322 4.66.865.098 1.202 1.178.545 1.749-.193.167-.43.732-.43 1.364v3.149c0 .986-.834 1.726-1.96 1.529a1 1 0 0 1-.04-1.963v-.99c-.91.062-1.661-.087-2.254-.484Z"/>'
      }, props)
  }
  export function RiLogosGitlabFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m21.663 9.987-.028-.072-2.719-7.094a.71.71 0 0 0-.706-.449.711.711 0 0 0-.654.522L15.72 8.52H8.282L6.443 2.895a.711.711 0 0 0-.652-.524.72.72 0 0 0-.707.45L2.362 9.925l-.028.07a5.057 5.057 0 0 0 1.674 5.838l.01.007.024.019 4.147 3.104 2.05 1.553 1.247.944a.843.843 0 0 0 1.016 0l1.247-.944 2.05-1.553 4.172-3.123.01-.008a5.055 5.055 0 0 0 1.682-5.845Z"/>'
      }, props)
  }
  export function RiLogosGitlabLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.544 2.673a1.549 1.549 0 0 1 1.8.098c.246.198.426.466.515.769l1.446 4.428h5.39L16.14 3.54c.089-.303.268-.571.515-.769l.004-.003a1.554 1.554 0 0 1 1.795-.096l.002.002c.274.173.486.43.605.73l.004.011 2.473 6.451a5.45 5.45 0 0 1-1.813 6.303l-6.73 5.064h-.002a1.659 1.659 0 0 1-2 0l-6.731-5.065a5.452 5.452 0 0 1-1.806-6.294l2.48-6.469c.12-.302.333-.558.607-.732Zm.811 2.063L4.16 10.464c-.28.737-.337 1.604-.12 2.362.217.755.671 1.42 1.295 1.896l6.66 5.01 6.653-5.005a3.65 3.65 0 0 0 1.308-1.904c.22-.76.159-1.638-.123-2.378l-2.189-5.71L16 9.769H8L6.355 4.736Z"/>'
      }, props)
  }
  export function RiLogosGoogleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.064 7.51A9.996 9.996 0 0 1 12 2c2.695 0 4.959.991 6.69 2.605l-2.867 2.868C14.786 6.482 13.468 5.977 12 5.977c-2.605 0-4.81 1.76-5.595 4.123-.2.6-.314 1.24-.314 1.9 0 .66.114 1.3.314 1.9.786 2.364 2.99 4.123 5.595 4.123 1.345 0 2.49-.355 3.386-.955a4.6 4.6 0 0 0 1.996-3.018H12v-3.868h9.418c.118.654.182 1.336.182 2.045 0 3.046-1.09 5.61-2.982 7.35C16.964 21.105 14.7 22 12 22A9.996 9.996 0 0 1 2 12c0-1.614.386-3.14 1.064-4.49Z"/>'
      }, props)
  }
  export function RiLogosGoogleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 11h8.533c.044.385.067.78.067 1.184 0 2.734-.98 5.036-2.678 6.6-1.485 1.371-3.518 2.175-5.942 2.175A8.976 8.976 0 0 1 3 11.98 8.976 8.976 0 0 1 11.98 3c2.42 0 4.453.89 6.008 2.339L16.526 6.8C15.368 5.681 13.803 5 12 5a7 7 0 0 0 0 14c3.527 0 6.144-2.608 6.577-6H12v-2Z"/>'
      }, props)
  }
  export function RiLogosGooglePlayFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.61 1.814 13.793 12 3.611 22.186a.996.996 0 0 1-.61-.92V2.735a1 1 0 0 1 .609-.921ZM14.5 12.707l2.302 2.302-10.937 6.333 8.635-8.635Zm3.199-3.198 2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.207 12l2.492-2.491ZM5.865 2.658 16.803 8.99 14.5 11.293 5.865 2.658Z"/>'
      }, props)
  }
  export function RiLogosGooglePlayLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.001 1.734a1 1 0 0 1 .501.135l16.004 9.265a1 1 0 0 1 0 1.731L4.502 22.131a1 1 0 0 1-1.501-.866V2.735a1 1 0 0 1 1-1Zm8.292 11.68-4.498 4.498 5.699-3.299-1.2-1.2ZM5 6.118v11.76l5.88-5.88L5 6.12Zm10.284 4.302L13.707 12l1.578 1.577L18.009 12l-2.725-1.579Zm-7.49-4.336 4.5 4.5 1.199-1.2-5.699-3.3Z"/>'
      }, props)
  }
  export function RiLogosHonorOfKingsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.16 4.258c.033 3.5.59 4.81.787 6.701a9.98 9.98 0 0 1-2.875 8.112c-3.666 3.666-9.471 3.89-13.4.673l2.852-2.853a6.002 6.002 0 0 0 8.368-8.368l4.267-4.265Zm-2.83-.002-2.852 2.853a6.002 6.002 0 0 0-8.368 8.368l-4.267 4.265c-.034-3.5-.591-4.811-.788-6.701A9.98 9.98 0 0 1 4.93 4.929c3.666-3.666 9.471-3.89 13.4-.673ZM12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>'
      }, props)
  }
  export function RiLogosHonorOfKingsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.33 4.256-1.424 1.423a8.001 8.001 0 0 0-12.272 9.444l2.417-2.417a5.002 5.002 0 0 1 7.707-4.879l-1.464 1.465a3.001 3.001 0 0 0-4.001 4l-6.45 6.45c-.034-3.5-.591-4.811-.788-6.701A9.98 9.98 0 0 1 4.93 4.929c3.666-3.666 9.471-3.89 13.4-.673Zm2.83.002c.033 3.5.59 4.81.787 6.701a9.98 9.98 0 0 1-2.875 8.112c-3.666 3.666-9.471 3.89-13.4.673l1.424-1.423a8.001 8.001 0 0 0 12.272-9.444l-2.417 2.417a5.002 5.002 0 0 1-7.707 4.878l1.464-1.464a3.001 3.001 0 0 0 4.001-4l6.45-6.45Z"/>'
      }, props)
  }
  export function RiLogosIeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.613 20.12c-2.744 1.49-5.113 1.799-6.422.49-1.344-1.34-.628-4.851 1.313-8.373A23.204 23.204 0 0 1 7.128 7.32c.187-.187 1.125-1.123 1.187-1.123 0 0-.5.312-.562.312-1.95 1.095-3.663 3.08-4.037 3.525a9.004 9.004 0 0 1 9.468-7.009c3.095-1.402 5.974-1.726 7.192-.51 1.125 1.123 1.062 2.995.125 5.242-.01.021-.018.043-.027.064a8.96 8.96 0 0 1 1.027 4.18c0 .378-.024.752-.07 1.12h-.804a4.037 4.037 0 0 1-.142.002H8.69v.187c.062 1.997 1.812 3.744 3.937 3.744 1.5 0 2.937-.811 3.562-1.997h4.78A9.003 9.003 0 0 1 8.613 20.12Zm-.607-.32a9.03 9.03 0 0 1-3.972-4.743c-1.161 2.282-1.46 4.19-.469 5.18.813.812 2.438.624 4.438-.436l.003-.002ZM20.173 7.291l.015-.034c.75-1.622.813-2.994.125-3.806-.869-.867-2.54-.75-4.522.168a9.032 9.032 0 0 1 4.382 3.672Zm-3.609 3.461v-.062c-.125-2.06-1.75-3.62-3.75-3.62-2.125 0-3.936 1.685-4.061 3.62v.062h7.811Z"/>'
      }, props)
  }
  export function RiLogosIeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.16 10a6.003 6.003 0 0 0-11.318 0H18.16ZM6.584 13a6.002 6.002 0 0 0 11.08 2.057h3.304A9.003 9.003 0 0 1 8.613 20.12c-2.744 1.491-5.113 1.8-6.422.492-1.344-1.342-.628-4.852 1.313-8.374a23.625 23.625 0 0 1 2.498-3.665c.36-.433.735-.851 1.126-1.252-.275.055-1.88.851-3.412 2.714a9.004 9.004 0 0 1 9.468-7.009c3.095-1.402 5.974-1.726 7.192-.51 1.125 1.123 1.062 2.995.125 5.242-.01.021-.018.043-.027.064a8.96 8.96 0 0 1 1.027 4.18c0 .337-.019.67-.055 1H6.584Zm1.422 6.8a9.03 9.03 0 0 1-3.972-4.743c-1.161 2.282-1.46 4.19-.469 5.18.813.812 2.438.624 4.438-.436l.003-.002ZM20.173 7.291l.015-.034c.75-1.622.813-2.994.125-3.806-.869-.867-2.54-.75-4.522.168a9.032 9.032 0 0 1 4.382 3.672Z"/>'
      }, props)
  }
  export function RiLogosInstagramFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.028 2.001a78.82 78.82 0 0 1 2.189.022l.194.007c.224.008.445.018.712.03 1.064.05 1.79.218 2.427.465.66.254 1.216.598 1.772 1.154a4.908 4.908 0 0 1 1.153 1.771c.247.637.415 1.364.465 2.428.012.266.022.488.03.712l.006.194a79 79 0 0 1 .023 2.188l.001.746v1.31a78.836 78.836 0 0 1-.023 2.189l-.006.194c-.008.224-.018.445-.03.712-.05 1.064-.22 1.79-.466 2.427a4.884 4.884 0 0 1-1.153 1.772 4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465-.267.012-.488.022-.712.03l-.194.006a79 79 0 0 1-2.189.023l-.746.001h-1.309a78.836 78.836 0 0 1-2.189-.023l-.194-.006a60.64 60.64 0 0 1-.712-.03c-1.064-.05-1.79-.22-2.428-.466a4.89 4.89 0 0 1-1.771-1.153 4.904 4.904 0 0 1-1.154-1.772c-.247-.637-.415-1.363-.465-2.427a74.367 74.367 0 0 1-.03-.712l-.005-.194A79.053 79.053 0 0 1 2 13.028v-2.056a78.82 78.82 0 0 1 .022-2.188l.007-.194c.008-.224.018-.446.03-.712.05-1.065.218-1.79.465-2.428A4.88 4.88 0 0 1 3.68 3.68 4.897 4.897 0 0 1 5.45 2.525c.638-.247 1.363-.415 2.428-.465l.712-.03.194-.005A79.053 79.053 0 0 1 10.972 2h2.056Zm-1.028 5A5 5 0 1 0 12 17a5 5 0 0 0 0-10Zm0 2A3 3 0 1 1 12.001 15a3 3 0 0 1 0-6Zm5.25-3.5a1.25 1.25 0 0 0 0 2.498 1.25 1.25 0 0 0 0-2.5Z"/>'
      }, props)
  }
  export function RiLogosInstagramLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0-2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm6.5-.25a1.25 1.25 0 0 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM12.001 4c-2.474 0-2.878.007-4.029.058-.784.037-1.31.142-1.798.332-.434.168-.747.369-1.08.703a2.89 2.89 0 0 0-.704 1.08c-.19.49-.295 1.015-.331 1.798C4.007 9.075 4 9.461 4 12c0 2.475.007 2.878.058 4.029.037.783.142 1.31.331 1.797.17.435.37.748.702 1.08.337.336.65.537 1.08.703.494.191 1.02.297 1.8.333 1.104.052 1.49.058 4.029.058 2.475 0 2.878-.007 4.029-.058.782-.037 1.308-.142 1.797-.331.433-.169.748-.37 1.08-.703.337-.336.538-.649.704-1.08.19-.492.296-1.018.332-1.8.052-1.103.058-1.49.058-4.028 0-2.474-.007-2.878-.058-4.029-.037-.782-.143-1.31-.332-1.798a2.912 2.912 0 0 0-.703-1.08 2.884 2.884 0 0 0-1.08-.704c-.49-.19-1.016-.295-1.798-.331C14.926 4.006 14.54 4 12 4Zm0-2c2.717 0 3.056.01 4.123.06 1.064.05 1.79.217 2.427.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.884 4.884 0 0 1-1.153 1.772 4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465-1.067.047-1.406.06-4.123.06-2.717 0-3.056-.01-4.123-.06-1.064-.05-1.789-.218-2.427-.465a4.89 4.89 0 0 1-1.772-1.153 4.905 4.905 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428-.048-1.066-.06-1.405-.06-4.122 0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772 4.897 4.897 0 0 1 1.772-1.153c.637-.248 1.362-.415 2.427-.465C8.945 2.013 9.284 2 12.001 2Z"/>'
      }, props)
  }
  export function RiLogosInvisionFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.001 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm2.988 11.065c-.06.267-.091.555-.091.79 0 .927.483 1.542 1.51 1.542.85 0 1.54-.526 2.037-1.375l-.303 1.267h1.69l.966-4.031c.242-1.02.71-1.55 1.419-1.55.558 0 .905.36.905.957 0 .173-.015.361-.075.565l-.498 1.853a2.893 2.893 0 0 0-.106.785c0 .88.498 1.523 1.54 1.523.89 0 1.6-.596 1.992-2.025l-.664-.267c-.332.958-.62 1.13-.846 1.13-.226 0-.347-.156-.347-.47 0-.141.03-.298.076-.487l.483-1.805c.12-.424.166-.8.166-1.145 0-1.35-.785-2.055-1.736-2.055-.89 0-1.796.835-2.248 1.715l.331-1.579h-2.58l-.362 1.39h1.207l-.744 3.098c-.584 1.35-1.656 1.372-1.79 1.34-.222-.051-.363-.139-.363-.438 0-.172.03-.42.106-.718l1.132-4.672H6.928l-.362 1.39h1.192l-.77 3.272Zm1.637-5.44a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"/>'
      }, props)
  }
  export function RiLogosInvisionLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.001 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h14V5h-14Zm1.988 9.065.77-3.271H6.565l.362-1.39h2.868l-1.132 4.67a3.071 3.071 0 0 0-.106.72c0 .298.141.386.362.437.135.032 1.207.01 1.791-1.34l.744-3.097h-1.207l.362-1.39h2.58l-.332 1.578c.453-.88 1.359-1.715 2.25-1.715.95 0 1.735.704 1.735 2.055 0 .345-.046.721-.166 1.145l-.483 1.805a2.158 2.158 0 0 0-.076.487c0 .314.121.47.347.47.227 0 .514-.172.846-1.13l.664.267c-.393 1.429-1.102 2.025-1.993 2.025-1.041 0-1.539-.643-1.539-1.523 0-.25.03-.518.106-.785l.498-1.853c.06-.204.075-.392.075-.565 0-.596-.347-.958-.905-.958-.71 0-1.178.53-1.419 1.55l-.966 4.032h-1.69l.303-1.267c-.497.85-1.187 1.375-2.038 1.375-1.026 0-1.509-.615-1.509-1.542 0-.235.03-.523.09-.79Zm1.637-5.44a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Z"/>'
      }, props)
  }
  export function RiLogosKakaoTalkFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3c5.8 0 10.501 3.664 10.501 8.185 0 4.52-4.701 8.184-10.5 8.184a13.51 13.51 0 0 1-1.727-.11l-4.408 2.883c-.501.265-.678.236-.472-.413l.892-3.678c-2.88-1.46-4.785-3.99-4.785-6.866 0-4.52 4.7-8.185 10.5-8.185Zm5.908 8.06 1.47-1.424a.472.472 0 0 0-.656-.678l-1.928 1.866V9.282a.472.472 0 0 0-.944 0v2.557a.472.472 0 0 0 0 .222V13.5a.472.472 0 0 0 .944 0v-1.363l.427-.413 1.428 2.033a.472.472 0 1 0 .773-.543l-1.514-2.155Zm-2.958 1.924h-1.46V9.297a.472.472 0 0 0-.943 0v4.159c0 .26.21.472.471.472h1.932a.472.472 0 1 0 0-.944Zm-5.857-1.091.696-1.708.638 1.707H9.093Zm2.523.487.002-.016a.469.469 0 0 0-.127-.32l-1.046-2.8a.69.69 0 0 0-.627-.474.696.696 0 0 0-.653.447l-1.662 4.075a.472.472 0 0 0 .874.357l.332-.813h2.07l.298.8a.472.472 0 1 0 .884-.33l-.345-.926ZM8.294 9.302a.472.472 0 0 0-.471-.472H4.578a.472.472 0 1 0 0 .944h1.16v3.736a.472.472 0 0 0 .944 0V9.774h1.14c.261 0 .472-.212.472-.472Z"/>'
      }, props)
  }
  export function RiLogosKakaoTalkLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.679 18.123C3.093 16.566 1.5 14.112 1.5 11.405 1.501 6.701 6.249 3 12.001 3s10.5 3.701 10.5 8.405c0 4.704-4.748 8.405-10.5 8.405-.442 0-.881-.022-1.318-.065l-3.765 2.458c-.615.326-.957.425-1.485.066-.62-.424-.596-.892-.382-1.56l.628-2.586ZM3.5 11.405c0 2.132 1.418 4.123 3.781 5.32l.706.359-.186.77-.401 1.648 2.8-1.83.365.046c.474.061.953.092 1.435.092 4.741 0 8.5-2.93 8.5-6.405S16.742 5 12.001 5s-8.5 2.93-8.5 6.405Zm14.407-.346 1.514 2.155a.472.472 0 1 1-.773.543l-1.428-2.033-.427.413V13.5a.472.472 0 1 1-.944 0v-1.439a.472.472 0 0 1 0-.222V9.282a.472.472 0 0 1 .944 0v1.542l1.928-1.866a.472.472 0 0 1 .656.678l-1.47 1.423Zm-2.958 1.925a.472.472 0 1 1 0 .944h-1.932a.472.472 0 0 1-.471-.472V9.297a.472.472 0 1 1 .943 0v3.687h1.46Zm-5.857-1.091h1.334l-.638-1.708-.696 1.707Zm2.523.487.345.925a.472.472 0 1 1-.884.33l-.298-.799h-2.07l-.332.813a.472.472 0 1 1-.874-.357l1.662-4.075a.696.696 0 0 1 .653-.447.69.69 0 0 1 .627.474l1.046 2.8a.469.469 0 0 1 .127.32l-.002.016ZM8.294 9.302c0 .26-.21.472-.471.472h-1.14v3.736a.472.472 0 0 1-.945 0V9.774h-1.16a.472.472 0 1 1 0-.944h3.245c.26 0 .471.211.471.472Z"/>'
      }, props)
  }
  export function RiLogosKickFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18v18H3V3Zm7.564 2.536h-4.31v12.928h4.31V15.59H12v1.436h1.436v1.436h4.31v-4.309h-1.437v-1.436h-1.436v-1.436h1.436V9.845h1.436V5.536h-4.309v1.436H12V8.41h-1.436V5.536Z"/>'
      }, props)
  }
  export function RiLogosKickLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 2h8v2h2V2h8v8h-2v4h2v8h-8v-2h-2v2H3V2Zm10 16h2v2h4v-4h-2v-2h-2v-4h2V8h2V4h-4v2h-2v2H9V4H5v16h4v-4h4v2Z"/>'
      }, props)
  }
  export function RiLogosLineFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.663 10.84a.526.526 0 0 1-.524.526h-1.463v.937h1.463a.525.525 0 1 1 0 1.05H16.15a.526.526 0 0 1-.522-.525V8.852c0-.287.235-.525.525-.525h1.988a.526.526 0 0 1-.002 1.05h-1.463v.938h1.463c.29 0 .524.237.524.526Zm-4.097 2.485a.539.539 0 0 1-.166.026.515.515 0 0 1-.425-.209l-2.036-2.764v2.45a.525.525 0 0 1-1.047 0V8.852a.522.522 0 0 1 .52-.523c.162 0 .312.087.412.212l2.052 2.775V8.852c0-.287.235-.525.525-.525.287 0 .525.238.525.525v3.976a.525.525 0 0 1-.36.497Zm-4.95.027a.526.526 0 0 1-.523-.524V8.852c0-.287.235-.525.525-.525.289 0 .524.238.524.525v3.976a.527.527 0 0 1-.526.524Zm-1.53 0H6.099a.528.528 0 0 1-.525-.524V8.852c0-.287.238-.525.525-.525.29 0 .525.238.525.525v3.451h1.464a.525.525 0 0 1 0 1.05Zm3.915-10.78c-5.513 0-10 3.643-10 8.119 0 4.009 3.558 7.368 8.363 8.006.325.069.769.215.881.492.1.25.066.638.032.9l-.137.85c-.037.25-.2.988.874.537 1.076-.449 5.764-3.398 7.864-5.812C21.314 14.09 22 12.477 22 10.69c0-4.476-4.488-8.119-10-8.119Z"/>'
      }, props)
  }
  export function RiLogosLineLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.001 10.69c0 1.787-.687 3.4-2.123 4.974-2.1 2.414-6.788 5.363-7.864 5.812-1.074.451-.911-.286-.874-.537l.137-.85c.034-.262.068-.65-.032-.9-.112-.277-.556-.423-.881-.492C5.559 18.06 2 14.7 2 10.691c0-4.476 4.487-8.119 10-8.119s10 3.643 10 8.119Zm-3.6 3.626c1.113-1.22 1.6-2.362 1.6-3.625 0-3.269-3.51-6.119-8-6.119s-8 2.85-8 6.119c0 2.904 2.728 5.506 6.626 6.024l.147.025c1.079.226 1.884.614 2.329 1.708l.037.096c1.805-1.176 4.173-2.979 5.26-4.228Zm-.262-4.001a.526.526 0 0 1 0 1.05h-1.463v.938h1.463a.525.525 0 1 1 0 1.05H16.15a.526.526 0 0 1-.522-.525V8.852c0-.287.235-.525.525-.525h1.988a.526.526 0 0 1-.002 1.05h-1.463v.938h1.463Zm-3.213 2.513a.525.525 0 0 1-.526.523.515.515 0 0 1-.425-.209l-2.036-2.764v2.45a.525.525 0 0 1-1.047 0V8.852a.522.522 0 0 1 .52-.523c.162 0 .312.087.412.212l2.052 2.775V8.852c0-.287.235-.525.525-.525.287 0 .525.238.525.525v3.976Zm-4.784 0a.527.527 0 0 1-.526.524.526.526 0 0 1-.523-.524V8.852c0-.287.235-.525.525-.525.289 0 .524.238.524.525v3.976Zm-2.055.524H6.098a.528.528 0 0 1-.525-.524V8.852c0-.287.238-.525.525-.525.29 0 .525.238.525.525v3.451h1.464a.525.525 0 0 1 0 1.05Z"/>'
      }, props)
  }
  export function RiLogosLinkedinBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.336 18.339h-2.665v-4.177c0-.996-.02-2.278-1.39-2.278-1.389 0-1.601 1.084-1.601 2.205v4.25h-2.666V9.75h2.56v1.17h.035c.358-.674 1.228-1.387 2.528-1.387 2.7 0 3.2 1.778 3.2 4.091v4.715ZM7.004 8.575a1.546 1.546 0 0 1-1.548-1.549 1.548 1.548 0 1 1 1.547 1.549Zm1.336 9.764H5.667V9.75H8.34v8.589ZM19.67 3H4.33C3.594 3 3 3.58 3 4.297v15.406c0 .717.594 1.297 1.328 1.297h15.339C20.4 21 21 20.42 21 19.703V4.297c0-.716-.6-1.297-1.334-1.297h.003Z"/>'
      }, props)
  }
  export function RiLogosLinkedinBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.001 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h14V5h-14Zm2.5 4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-1 1h2v7.5h-2V10Zm5.5.43c.584-.565 1.266-.93 2-.93 2.071 0 3.5 1.679 3.5 3.75v4.25h-2v-4.25a1.75 1.75 0 1 0-3.5 0v4.25h-2V10h2v.43Z"/>'
      }, props)
  }
  export function RiLogosLinkedinFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.94 5a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002ZM7 8.48H3V21h4V8.48Zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68Z"/>'
      }, props)
  }
  export function RiLogosLinkedinLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 9.55c.917-.937 2.111-1.55 3.5-1.55a5.5 5.5 0 0 1 5.5 5.5V21h-2v-7.5a3.5 3.5 0 1 0-7 0V21h-2V8.5h2v1.05Zm-7-3.05a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-1 2h2V21h-2V8.5Z"/>'
      }, props)
  }
  export function RiLogosMastercardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 6.654a6.786 6.786 0 0 1 2.596 5.344A6.786 6.786 0 0 1 12 17.342a6.786 6.786 0 0 1-2.596-5.344 6.786 6.786 0 0 1 2.596-5.344Zm-.87-.582A7.783 7.783 0 0 0 8.402 12a7.782 7.782 0 0 0 2.728 5.926 6.798 6.798 0 1 1 .003-11.854Zm1.742 11.854A7.783 7.783 0 0 0 15.601 12a7.783 7.783 0 0 0-2.73-5.928 6.798 6.798 0 1 1 .003 11.854Z"/>'
      }, props)
  }
  export function RiLogosMastercardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 18.294a7.3 7.3 0 1 1 0-12.588 7.3 7.3 0 1 1 0 12.588Zm1.702-1.383a5.3 5.3 0 1 0 0-9.82A7.273 7.273 0 0 1 15.6 12c0 1.89-.719 3.613-1.898 4.91ZM10.299 7.09a5.3 5.3 0 1 0 0 9.82A7.274 7.274 0 0 1 8.401 12c0-1.89.719-3.614 1.898-4.91Zm1.702 1.115a5.284 5.284 0 0 0-1.6 3.795c0 1.488.613 2.832 1.6 3.795a5.284 5.284 0 0 0 1.6-3.795 5.284 5.284 0 0 0-1.6-3.795Z"/>'
      }, props)
  }
  export function RiLogosMastodonFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.26 13.99c-.275 1.41-2.457 2.955-4.963 3.254-1.306.156-2.593.3-3.965.236-2.244-.103-4.014-.535-4.014-.535 0 .218.014.426.04.62.292 2.215 2.196 2.347 4 2.41 1.82.061 3.44-.45 3.44-.45l.075 1.646s-1.273.684-3.54.81c-1.252.068-2.805-.032-4.613-.51-3.923-1.039-4.598-5.22-4.701-9.464-.032-1.26-.012-2.447-.012-3.44 0-4.34 2.843-5.611 2.843-5.611C7.283 2.298 9.742 2.021 12.3 2h.062c2.557.02 5.018.298 6.451.956 0 0 2.843 1.272 2.843 5.61 0 0 .036 3.201-.396 5.424Zm-2.957-5.087c0-1.074-.274-1.927-.823-2.558-.566-.631-1.307-.955-2.228-.955-1.065 0-1.872.41-2.405 1.228l-.518.87-.519-.87C11.277 5.8 10.47 5.39 9.406 5.39c-.921 0-1.663.324-2.229.955-.549.631-.822 1.484-.822 2.558v5.253h2.081V9.057c0-1.075.452-1.62 1.357-1.62 1 0 1.501.647 1.501 1.927v2.79h2.07v-2.79c0-1.28.5-1.927 1.5-1.927.905 0 1.358.545 1.358 1.62v5.1h2.08V8.902Z"/>'
      }, props)
  }
  export function RiLogosMastodonLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.019 12.008c-.032-1.26-.012-2.448-.012-3.442 0-4.338 2.843-5.61 2.843-5.61C7.283 2.298 9.742 2.021 12.3 2h.062c2.557.02 5.018.298 6.451.956 0 0 2.843 1.272 2.843 5.61 0 0 .036 3.201-.396 5.424-.275 1.41-2.457 2.955-4.963 3.254-1.306.156-2.593.3-3.965.236-2.244-.102-4.014-.535-4.014-.535 0 .218.014.426.04.62.084.633.299 1.095.605 1.435.766.85 2.106.93 3.395.974 1.82.063 3.44-.449 3.44-.449l.075 1.646s-1.273.684-3.54.81c-1.252.068-2.804-.032-4.613-.51-1.532-.406-2.568-1.29-3.27-2.471-1.093-1.843-1.368-4.406-1.431-6.992Zm3.3 4.937v-2.548l2.474.605a20.628 20.628 0 0 0 1.303.245c.752.116 1.538.2 2.328.235 1.019.047 1.9-.017 3.636-.224 1.663-.199 3.148-1.196 3.236-1.65.082-.422.151-.922.206-1.482.07-.705.114-1.47.137-2.245.015-.51.02-.945.017-1.256v-.059c0-1.43-.369-2.438-.963-3.158a3.008 3.008 0 0 0-.584-.548c-.09-.064-.135-.089-.13-.087-1.013-.465-3.093-.752-5.617-.773h-.046c-2.54.02-4.62.308-5.65.782.023-.01-.021.014-.112.078a3.008 3.008 0 0 0-.584.548c-.594.72-.963 1.729-.963 3.158 0 .232 0 .397-.003.875a77.501 77.501 0 0 0 .014 2.518c.054 2.197.264 3.835.7 5.041.212.587.472 1.07.78 1.45a5.701 5.701 0 0 1-.18-1.505ZM8.085 6.37a1.143 1.143 0 1 1 0 2.287 1.143 1.143 0 0 1 0-2.287Z"/>'
      }, props)
  }
  export function RiLogosMediumFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.001 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm13.3 12.94c-.1-.05-.15-.2-.15-.301V8.006c0-.1.05-.25.15-.351l.955-1.105V6.5h-3.415l-2.56 6.478L9.367 6.5H5.852v.05l.904 1.256c.201.2.251.502.251.753v5.523c.05.302 0 .653-.15.954L5.5 16.894v.05h3.616v-.05L7.76 15.087c-.15-.302-.201-.603-.15-.954V9.11c.05.1.1.1.15.301l3.414 7.633h.05L14.54 8.76c-.05.3-.05.652-.05.904v5.925c0 .15-.05.25-.15.351l-1.005.954v.05h4.921v-.05l-.954-.954Z"/>'
      }, props)
  }
  export function RiLogosMediumLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.001 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h14V5h-14Zm12.3 10.94.955.954v.05h-4.921v-.05l1.004-.954c.1-.1.15-.2.15-.351V9.664c0-.252 0-.603.051-.904l-3.314 8.285h-.05L7.76 9.412c-.05-.2-.1-.2-.15-.3v5.02c-.051.352 0 .653.15.955l1.356 1.807v.05H5.5v-.05l1.356-1.858c.15-.3.2-.652.15-.954V8.56c0-.251-.05-.553-.25-.753L5.851 6.55V6.5h3.516l2.912 6.478L14.841 6.5h3.415v.05l-.954 1.105c-.1.1-.15.251-.15.351v7.633c0 .1.05.251.15.301Z"/>'
      }, props)
  }
  export function RiLogosMessengerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c5.633 0 10 4.127 10 9.7 0 5.573-4.367 9.7-10 9.7a10.893 10.893 0 0 1-2.895-.384.8.8 0 0 0-.534.039l-1.985.876a.8.8 0 0 1-1.123-.707l-.054-1.78a.797.797 0 0 0-.269-.57c-1.945-1.74-3.14-4.258-3.14-7.174 0-5.573 4.366-9.7 10-9.7ZM5.996 14.537c-.282.447.268.951.689.631l3.155-2.394a.6.6 0 0 1 .723 0l2.336 1.75a1.5 1.5 0 0 0 2.17-.4l2.937-4.66c.282-.448-.268-.952-.689-.633l-3.155 2.396a.6.6 0 0 1-.723 0l-2.337-1.75a1.5 1.5 0 0 0-2.169.4l-2.937 4.66Z"/>'
      }, props)
  }
  export function RiLogosMessengerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.765 19.225c.59-.26 1.25-.309 1.868-.139.77.21 1.565.316 2.368.314 4.585 0 8-3.287 8-7.7s-3.415-7.7-8-7.7-8 3.287-8 7.7c0 2.27.896 4.272 2.466 5.676a2.8 2.8 0 0 1 .942 2.006l.356-.157ZM12.001 2c5.633 0 10 4.127 10 9.7 0 5.573-4.367 9.7-10 9.7a10.893 10.893 0 0 1-2.895-.384.8.8 0 0 0-.534.039l-1.985.876a.8.8 0 0 1-1.123-.707l-.054-1.78a.797.797 0 0 0-.269-.57c-1.945-1.74-3.14-4.258-3.14-7.174 0-5.573 4.366-9.7 10-9.7ZM5.996 14.537l2.937-4.66a1.5 1.5 0 0 1 2.17-.4l2.336 1.75a.6.6 0 0 0 .723 0l3.155-2.396c.421-.319.971.185.689.633l-2.938 4.66a1.5 1.5 0 0 1-2.168.4l-2.337-1.75a.6.6 0 0 0-.723 0l-3.155 2.395c-.421.319-.971-.185-.689-.633Z"/>'
      }, props)
  }
  export function RiLogosMetaFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.92 4.5c-1.851 0-3.298 1.394-4.608 3.165C10.512 5.373 9.007 4.5 7.206 4.5 3.534 4.5.72 9.28.72 14.338c0 3.165 1.531 5.162 4.096 5.162 1.846 0 3.174-.87 5.535-4.997 0 0 .984-1.737 1.66-2.934.238.383.487.795.75 1.238l1.107 1.862c2.156 3.608 3.358 4.831 5.534 4.831 2.5 0 3.89-2.024 3.89-5.255 0-5.297-2.877-9.745-6.372-9.745Zm-8.37 8.886c-1.913 3-2.575 3.673-3.64 3.673-1.097 0-1.749-.963-1.749-2.68 0-3.672 1.831-7.427 4.014-7.427 1.182 0 2.17.682 3.683 2.848-1.437 2.204-2.307 3.586-2.307 3.586Zm7.224-.377L14.45 10.8a45.161 45.161 0 0 0-1.032-1.608c1.193-1.841 2.176-2.759 3.347-2.759 2.43 0 4.375 3.58 4.375 7.976 0 1.676-.549 2.649-1.686 2.649-1.09 0-1.61-.72-3.68-4.05Z"/>'
      }, props)
  }
  export function RiLogosMetaLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.974 16.163c-.285.892-.775 1.337-1.47 1.337-.877 0-1.74-.526-2.587-1.58-.589-.73-1.414-2.12-2.477-4.168a58.288 58.288 0 0 0-1.269-2.33c.31-.488.586-.88.829-1.176.957-1.164 1.959-1.746 3.005-1.746.835 0 1.63.536 2.386 1.608.776 1.101 1.32 2.461 1.632 4.08.306 1.594.29 2.919-.049 3.975Zm-8.97-4.733c.21.385.43.8.66 1.242 1.125 2.167 2.023 3.668 2.695 4.503 1.248 1.55 2.63 2.325 4.146 2.325.856 0 1.588-.27 2.197-.81.525-.467.917-1.105 1.177-1.916.443-1.38.479-3.035.108-4.963-.366-1.901-1.02-3.52-1.962-4.856-1.154-1.637-2.494-2.455-4.02-2.455-1.676 0-3.193.825-4.55 2.476-.142.173-.292.37-.45.594a10.318 10.318 0 0 0-.45-.594C10.198 5.326 8.68 4.5 7.005 4.5c-1.526 0-2.866.818-4.02 2.455-.942 1.336-1.596 2.955-1.962 4.856-.37 1.928-.335 3.582.108 4.963.26.81.652 1.45 1.177 1.915.609.54 1.341.811 2.197.811 1.516 0 2.898-.775 4.146-2.325.672-.835 1.57-2.336 2.694-4.502.23-.444.45-.858.66-1.243Zm-1.166-2.008c-.39.674-.812 1.45-1.268 2.33C8.507 13.8 7.68 15.188 7.093 15.92c-.848 1.053-1.71 1.579-2.588 1.579-.694 0-1.184-.445-1.47-1.337-.338-1.056-.354-2.381-.048-3.974.311-1.62.855-2.98 1.632-4.081C5.375 7.036 6.17 6.5 7.005 6.5c1.046 0 2.048.582 3.005 1.746.243.296.519.688.828 1.176Z"/>'
      }, props)
  }
  export function RiLogosMicrosoftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.501 3v8.5h-8.5V3h8.5Zm0 18h-8.5v-8.5h8.5V21Zm1-18h8.5v8.5h-8.5V3Zm8.5 9.5V21h-8.5v-8.5h8.5Z"/>'
      }, props)
  }
  export function RiLogosMicrosoftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.001 5h-6v6h6V5Zm2 0v6h6V5h-6Zm6 8h-6v6h6v-6Zm-8 6v-6h-6v6h6Zm-8-16h18v18h-18V3Z"/>'
      }, props)
  }
  export function RiLogosMicrosoftLoopFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12c0 5.523-4.477 10-10 10H6.665A7.99 7.99 0 0 0 10 15.5h2A3.5 3.5 0 1 0 8.5 12v3.5A6.5 6.5 0 0 1 2 22V12C2 6.477 6.477 2 12 2s10 4.477 10 10Z"/>'
      }, props)
  }
  export function RiLogosMicrosoftLoopLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 4a8 8 0 1 1 0 16H7.69a6.48 6.48 0 0 0 1.734-3.5H12A4.5 4.5 0 1 0 7.5 12v3.5A4.502 4.502 0 0 1 4 19.889V12a8 8 0 0 1 8-8Zm0 18c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12v10h10Zm-2.5-7.5V12a2.5 2.5 0 1 1 2.5 2.5H9.5Z"/>'
      }, props)
  }
  export function RiLogosMiniProgramFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.84 12.691-.066.02a1.524 1.524 0 0 1-.414.062c-.61 0-.954-.412-.77-.921.136-.372.491-.686.925-.831.672-.245 1.142-.804 1.142-1.455 0-.877-.853-1.587-1.905-1.587s-1.905.71-1.905 1.587v4.868c0 1.17-.678 2.197-1.693 2.778a3.829 3.829 0 0 1-1.904.502c-1.984 0-3.598-1.471-3.598-3.28 0-.576.164-1.117.451-1.587.444-.73 1.184-1.287 2.07-1.541.152-.048.307-.073.46-.073.612 0 .958.414.773.924-.126.347-.466.645-.861.803a2.229 2.229 0 0 0-.139.052c-.628.26-1.061.798-1.061 1.422 0 .877.853 1.587 1.905 1.587s1.904-.71 1.904-1.587V9.566c0-1.17.679-2.197 1.694-2.778a3.83 3.83 0 0 1 1.904-.502c1.984 0 3.598 1.471 3.598 3.28 0 .576-.165 1.117-.451 1.587-.442.726-1.178 1.282-2.058 1.538ZM2.002 12c0 5.523 4.477 10 10 10s10-4.477 10-10-4.477-10-10-10-10 4.477-10 10Z"/>'
      }, props)
  }
  export function RiLogosMiniProgramLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-6a3.5 3.5 0 1 1-4.977-3.174 1 1 0 1 1 .845 1.813A1.5 1.5 0 1 0 11 14v-4a3.5 3.5 0 1 1 4.977 3.174 1 1 0 0 1-.845-1.813A1.5 1.5 0 1 0 13.001 10v4Z"/>'
      }, props)
  }
  export function RiLogosNeteaseCloudMusicFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm-1.086-10.432c.24-.84 1.075-1.541 1.99-1.648.187.694.388 1.373.545 2.063.053.23.037.495-.018.727-.213.892-1.248 1.242-1.978.685-.53-.405-.742-1.12-.539-1.827Zm3.817-.197c-.125-.465-.256-.927-.393-1.42.5.13.907.36 1.255.697 1.257 1.222 1.385 3.3.294 4.732-1.135 1.49-3.155 2.134-5.028 1.605-2.302-.65-3.808-2.952-3.441-5.316.274-1.768 1.27-3.004 2.9-3.733.407-.182.58-.56.42-.93-.157-.364-.54-.504-.944-.343-2.721 1.088-4.32 4.134-3.67 6.987.713 3.118 3.495 5.162 6.675 4.859 1.732-.166 3.164-.948 4.216-2.347 1.506-2.002 1.297-4.783-.463-6.499-.666-.65-1.471-1.018-2.39-1.153-.083-.013-.217-.052-.232-.106-.087-.313-.18-.632-.206-.954-.029-.357.29-.64.65-.645.253-.003.434.13.603.3.303.3.704.322.988.062.29-.264.296-.678.018-1.008-.566-.672-1.586-.891-2.43-.523-.847.37-1.321 1.187-1.2 2.093.038.28.11.557.167.842l-.26.072c-.856.24-1.561.704-2.098 1.414-.921 1.22-.936 2.828-.041 3.947 1.274 1.594 3.747 1.284 4.523-.568.284-.677.275-1.368.087-2.065Z"/>'
      }, props)
  }
  export function RiLogosNeteaseCloudMusicLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.422 11.375c-.294 1.028.012 2.065.784 2.653 1.061.81 2.565.3 2.874-.995.08-.337.103-.722.027-1.056-.23-1.001-.521-1.988-.792-2.996-1.33.154-2.543 1.172-2.893 2.394Zm5.548-.287c.273 1.012.285 2.017-.127 3-1.128 2.69-4.722 3.14-6.573.826-1.302-1.627-1.28-3.961.06-5.734.78-1.032 1.804-1.707 3.048-2.054l.379-.104c-.084-.415-.188-.816-.243-1.224-.176-1.317.512-2.503 1.744-3.04 1.226-.535 2.708-.216 3.53.76.406.479.395 1.08-.025 1.464-.412.377-.997.346-1.435-.09-.247-.246-.51-.44-.877-.436-.525.006-.987.418-.945.937.037.468.172.93.3 1.386.022.078.216.135.338.153 1.333.197 2.504.731 3.472 1.676 2.558 2.493 2.861 6.531.672 9.44-1.529 2.032-3.61 3.169-6.127 3.409-4.621.44-8.664-2.53-9.7-7.058C2.516 10.255 4.84 5.831 8.796 4.25c.586-.234 1.143-.031 1.371.498.232.537-.019 1.086-.61 1.35-2.368 1.06-3.817 2.855-4.215 5.423-.533 3.434 1.656 6.777 5 7.722 2.723.769 5.658-.167 7.308-2.33 1.586-2.08 1.4-5.1-.427-6.874A3.978 3.978 0 0 0 15.4 9.026c.198.716.389 1.388.57 2.062Z"/>'
      }, props)
  }
  export function RiLogosNetflixFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.292 3.814 2.018 5.707.396 1.116.007-4.81.01-4.818h4.27L18 11.871c.003 5.98-.003 10.89-.015 10.9-.012.009-.209 0-.436-.027-.989-.118-2.29-.236-3.34-.282a14.57 14.57 0 0 1-.636-.038c-.003-.003-.273-.762-.776-2.184v-.004l-2.144-6.061-.34-.954-.008 4.586c-.006 4.365-.01 4.61-.057 4.61-.163 0-1.57.09-2.04.136-.308.027-.926.09-1.37.145-.446.051-.816.085-.823.078C6.007 22.77 6 17.867 6 11.883V1.002h.005V1h4.288l.028.08c.007.016.065.176.157.437l.641 1.778.173.496-.001.023Z"/>'
      }, props)
  }
  export function RiLogosNetflixLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.985 17.208 16.001 2h2v20a7.593 7.593 0 0 0-2.02-.5L8 6.302V21.5a7.335 7.335 0 0 0-2 .5V2h2l7.984 15.208Z"/>'
      }, props)
  }
  export function RiLogosNotionFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.104 5.91c.584.474.802.438 1.898.365l10.332-.62c.22 0 .037-.22-.036-.256l-1.716-1.24c-.329-.255-.767-.548-1.606-.475l-10.005.73c-.364.036-.437.219-.292.365l1.425 1.13Zm.62 2.408v10.87c0 .585.292.803.95.767l11.354-.657c.657-.036.73-.438.73-.912V7.588c0-.474-.182-.73-.584-.693l-11.866.693c-.438.036-.584.255-.584.73Zm11.21.583c.072.328 0 .657-.33.694l-.547.109v8.025c-.475.256-.913.402-1.278.402-.584 0-.73-.183-1.168-.73l-3.579-5.618v5.436l1.133.255s0 .657-.914.657l-2.519.146c-.073-.146 0-.51.256-.584l.657-.182v-7.187l-.913-.073c-.073-.329.11-.803.621-.84l2.702-.181 3.724 5.69V9.887l-.95-.109c-.072-.402.22-.693.585-.73l2.52-.146ZM4.131 3.429l10.406-.766c1.277-.11 1.606-.036 2.41.547l3.321 2.335c.548.401.731.51.731.948v12.805c0 .803-.292 1.277-1.314 1.35l-12.085.73c-.767.036-1.132-.073-1.534-.584L3.62 17.62C3.182 17.036 3 16.599 3 16.087V4.706c0-.657.292-1.204 1.132-1.277Z"/>'
      }, props)
  }
  export function RiLogosNotionLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.285 2.955a1.889 1.889 0 0 0-1.211-.31l-11.06.961a.989.989 0 0 0-.903.986v11.575c0 .408.133.806.378 1.133l2.767 3.69c.203.27.53.418.867.392l12.853-.989a.989.989 0 0 0 .913-.986V6.527a.939.939 0 0 0-.418-.781l-4.186-2.791Zm-1.057 1.46a.111.111 0 0 1 .071.02l2.746 1.83-10.207.816-1.86-1.86 9.25-.805Zm3.883 14.262-10.722.825V8.82l10.722-.858v10.714ZM4.89 6.646l1.722 1.722V18.5l-1.7-2.267a.111.111 0 0 1-.022-.066V6.646Zm7.09 3.477-1.977.13v7.562l1.996-.13v-4.337l3.512 4.169 1.976-.13V9.825l-1.996.13v4.337l-3.511-4.169Z"/>'
      }, props)
  }
  export function RiLogosNpmjsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.001 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16Zm-3 4h-10v10h5V9.5h2.5V17h2.5V7Z"/>'
      }, props)
  }
  export function RiLogosNpmjsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.001 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16Zm-1 2h-14v14h14V5Zm-2 2v10h-2.5V9.5h-2.5V17h-5V7h10Z"/>'
      }, props)
  }
  export function RiLogosOpenSourceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10 0 4.13-2.504 7.676-6.077 9.201l-2.518-6.55A3 3 0 0 0 12 9a3 3 0 0 0-1.404 5.652l-2.518 6.55A10.003 10.003 0 0 1 2 12c0-5.523 4.477-10 10-10Z"/>'
      }, props)
  }
  export function RiLogosOpenSourceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10 0 4.4-2.841 8.136-6.789 9.473l-.226.074-2.904-7.55A2.016 2.016 0 0 0 14.001 12a2 2 0 1 0-2.083 1.998l-2.903 7.549-.225-.074C4.842 20.136 2 16.4 2 12c0-5.523 4.477-10 10-10Zm0 2a8 8 0 0 0-4.099 14.872l1.48-3.849a4 4 0 1 1 5.239 0c.565 1.474 1.059 2.757 1.479 3.85A8 8 0 0 0 12 4Z"/>'
      }, props)
  }
  export function RiLogosOpenaiFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.562 10.188c.25-.688.313-1.376.25-2.063-.062-.688-.312-1.375-.625-2-.562-.938-1.375-1.688-2.312-2.125-1-.438-2.063-.563-3.125-.313-.5-.5-1.063-.937-1.688-1.25C12.437 2.126 11.687 2 11 2a5.17 5.17 0 0 0-3 .938c-.875.624-1.5 1.5-1.813 2.5-.75.187-1.375.5-2 .875-.562.437-1 1-1.375 1.562-.562.938-.75 2-.625 3.063a5.438 5.438 0 0 0 1.25 2.874 4.695 4.695 0 0 0-.25 2.063c.063.688.313 1.375.625 2 .563.938 1.375 1.688 2.313 2.125 1 .438 2.062.563 3.125.313.5.5 1.062.937 1.687 1.25.625.312 1.375.437 2.063.437a5.17 5.17 0 0 0 3-.938c.875-.625 1.5-1.5 1.812-2.5a4.543 4.543 0 0 0 1.938-.875c.562-.437 1.062-.937 1.375-1.562.562-.938.75-2 .625-3.063-.125-1.062-.5-2.062-1.188-2.874Zm-7.5 10.5c-1 0-1.75-.313-2.437-.875 0 0 .062-.063.125-.063l4-2.313a.488.488 0 0 0 .25-.25c.062-.125.062-.187.062-.312V11.25l1.688 1v4.625a3.685 3.685 0 0 1-3.688 3.813ZM5 17.25c-.438-.75-.625-1.625-.438-2.5 0 0 .063.063.125.063l4 2.312a.563.563 0 0 0 .313.063c.125 0 .25 0 .312-.063l4.875-2.813v1.938l-4.062 2.375A3.71 3.71 0 0 1 7.312 19c-1-.25-1.812-.875-2.312-1.75ZM3.937 8.562a3.807 3.807 0 0 1 1.938-1.624v4.75c0 .124 0 .25.062.312a.488.488 0 0 0 .25.25l4.875 2.813-1.687 1-4-2.313a3.697 3.697 0 0 1-1.75-2.25c-.25-.938-.188-2.063.312-2.938ZM17.75 11.75l-4.875-2.813 1.687-1 4 2.313c.625.375 1.125.875 1.438 1.5.312.625.5 1.313.437 2.063a3.718 3.718 0 0 1-.75 1.937c-.437.563-1 1-1.687 1.25v-4.75c0-.125 0-.25-.063-.313 0 0-.062-.124-.187-.187Zm1.687-2.5s-.062-.063-.125-.063l-4-2.312c-.125-.063-.187-.063-.312-.063s-.25 0-.313.063L9.812 9.688V7.75l4.063-2.375c.625-.375 1.312-.5 2.062-.5.688 0 1.375.25 2 .688.563.437 1.063 1 1.313 1.625s.312 1.375.187 2.062Zm-10.5 3.5-1.687-1V7.062c0-.687.187-1.437.562-2C8.187 4.438 8.75 4 9.375 3.688a3.365 3.365 0 0 1 2.062-.312c.688.063 1.375.375 1.938.813 0 0-.063.062-.125.062l-4 2.313a.488.488 0 0 0-.25.25c-.063.125-.063.187-.063.312v5.625Zm.875-2L12 9.5l2.187 1.25v2.5L12 14.5l-2.188-1.25v-2.5Z"/>'
      }, props)
  }
  export function RiLogosOpenaiLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 4c.649 0 1.25.206 1.741.556-1.292.673-2.48 1.52-3.741 2.248l1 1.732c1.575-.91 3.052-2.05 4.76-2.706a3.001 3.001 0 0 1 4.057 3.09C17.588 8.137 16.26 7.531 15 6.804l-1 1.732c1.575.91 3.302 1.618 4.723 2.77a3.001 3.001 0 0 1-.648 5.058C18.14 14.908 18 13.455 18 12h-2c0 1.818.25 3.668-.037 5.476a3.001 3.001 0 0 1-4.705 1.967c1.293-.673 2.482-1.52 3.742-2.247l-1-1.732c-1.575.91-3.052 2.05-4.76 2.706a3.001 3.001 0 0 1-4.057-3.09c1.23.782 2.557 1.388 3.817 2.116l1-1.732c-1.575-.91-3.302-1.618-4.724-2.77a3.001 3.001 0 0 1 .649-5.058C5.86 9.092 6 10.545 6 12h2c0-1.818-.25-3.669.037-5.476A3.001 3.001 0 0 1 11 4Zm3.793-.258a5.001 5.001 0 0 0-8.548 1.71 5.001 5.001 0 0 0-2.793 8.258 5.001 5.001 0 0 0 5.756 6.548 5.001 5.001 0 0 0 8.548-1.71 5.001 5.001 0 0 0 2.793-8.258 5.001 5.001 0 0 0-5.756-6.548Z"/>'
      }, props)
  }
  export function RiLogosOpenbaseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 2.76 10 3.236-.9 9.468-9.1 6.86-9.1-6.864L2.01 6 12 2.76Zm0 .825L3.19 6.435 12 20.793l8.806-14.358L12 3.585Z"/>'
      }, props)
  }
  export function RiLogosOpenbaseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3 2 5.996l1 9.464 9 7.04 9-7.04 1-9.464L12 3Zm7.837 4.436L12 19.96 4.163 7.436 12 5.088l7.837 2.348Z"/>'
      }, props)
  }
  export function RiLogosOperaFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.71 6.365c-1.107 1.305-1.822 3.236-1.872 5.4v.47c.051 2.165.765 4.093 1.872 5.4 1.434 1.862 3.566 3.044 5.95 3.044a7.208 7.208 0 0 0 4.005-1.226 9.94 9.94 0 0 1-7.139 2.535A9.998 9.998 0 0 1 2.001 12c0-5.524 4.477-10 10-10h.038a9.97 9.97 0 0 1 6.627 2.546 7.24 7.24 0 0 0-4.008-1.226c-2.382 0-4.514 1.183-5.95 3.045h.002ZM22.001 12a9.969 9.969 0 0 1-3.335 7.454c-2.565 1.25-4.955.376-5.747-.17 2.52-.554 4.423-3.6 4.423-7.284 0-3.685-1.903-6.73-4.423-7.283.791-.545 3.182-1.42 5.747-.171A9.967 9.967 0 0 1 22.001 12Z"/>'
      }, props)
  }
  export function RiLogosOperaLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.767 19.51a8.003 8.003 0 0 0 0-15.02C16.712 5.977 18 8.935 18 12s-1.289 6.024-3.235 7.51ZM9.235 4.49a8.003 8.003 0 0 0 0 15.02C7.29 18.023 6.001 15.065 6.001 12S7.29 5.976 9.235 4.49ZM12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-3.5c2 0 4-3.033 4-6.5s-2-6.5-4-6.5-4 3.033-4 6.5 2 6.5 4 6.5Z"/>'
      }, props)
  }
  export function RiLogosPatreonFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.001 17a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Zm-13-15h4v20h-4V2Z"/>'
      }, props)
  }
  export function RiLogosPatreonLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.001 17a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Zm0-2a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Zm-13-13h5v20h-5V2Zm2 2v16h1V4h-1Z"/>'
      }, props)
  }
  export function RiLogosPaypalFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.067 8.478c.492.88.557 2.014.3 3.327-.74 3.806-3.275 5.12-6.513 5.12h-.5a.805.805 0 0 0-.794.68l-.041.22-.63 3.993-.032.17a.804.804 0 0 1-.794.679H7.72a.483.483 0 0 1-.477-.558L7.418 21h1.519l.949-6.02h1.386c4.678 0 7.749-2.203 8.795-6.502Zm-2.96-5.09c.762.868.984 1.81.753 3.285-.02.123-.04.24-.063.36-.735 3.773-3.088 5.446-6.955 5.446H8.957c-.63 0-1.173.414-1.353 1.002l-.015-.002-.93 5.894H3.123a.051.051 0 0 1-.051-.06l2.598-16.51A.95.95 0 0 1 6.608 2h5.975c2.183 0 3.717.469 4.524 1.388Z"/>'
      }, props)
  }
  export function RiLogosPaypalLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.496 20.667h1.551l.538-3.376a2.805 2.805 0 0 1 2.77-2.366h.5c2.677 0 4.06-.983 4.55-3.503.208-1.066.117-1.73-.171-2.102-1.207 3.054-3.79 4.16-6.962 4.16h-.884c-.384 0-.793.209-.852.58l-1.04 6.607Zm-4.944-.294a.551.551 0 0 1-.544-.637l2.674-16.96A.92.92 0 0 1 6.59 2h6.424c2.213 0 3.942.467 4.9 1.558.869.99 1.122 2.084.87 3.692.36.191.668.425.916.706.819.933.979 2.26.669 3.85-.741 3.805-3.276 5.12-6.514 5.12h-.5a.805.805 0 0 0-.795.679l-.702 4.383a.804.804 0 0 1-.794.679H6.72a.483.483 0 0 1-.477-.558l.274-1.736H3.552Zm6.836-8.894h.885c3.189 0 4.894-1.212 5.482-4.229.02-.101.037-.203.054-.309.166-1.06.05-1.553-.399-2.063-.465-.53-1.603-.878-3.396-.878h-5.5L5.247 18.373h1.561l.73-4.628.008.001a2.915 2.915 0 0 1 2.842-2.267Z"/>'
      }, props)
  }
  export function RiLogosPinterestFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.372 2.094a10.003 10.003 0 0 0-5.369 19.074 7.756 7.756 0 0 1 .162-2.292c.185-.839 1.296-5.463 1.296-5.463a3.738 3.738 0 0 1-.324-1.577c0-1.485.857-2.593 1.923-2.593a1.334 1.334 0 0 1 1.342 1.508c0 .9-.578 2.262-.88 3.54a1.544 1.544 0 0 0 1.575 1.923c1.897 0 3.17-2.431 3.17-5.301 0-2.201-1.457-3.848-4.143-3.848a4.746 4.746 0 0 0-4.93 4.794 2.96 2.96 0 0 0 .648 1.97.48.48 0 0 1 .162.554c-.046.184-.162.623-.208.785a.354.354 0 0 1-.51.253c-1.384-.554-2.036-2.077-2.036-3.816 0-2.847 2.384-6.255 7.154-6.255 3.796 0 6.319 2.777 6.319 5.747 0 3.909-2.176 6.848-5.393 6.848a2.861 2.861 0 0 1-2.454-1.246s-.579 2.316-.692 2.754a8.025 8.025 0 0 1-1.019 2.131c.923.28 1.882.42 2.846.416a9.988 9.988 0 0 0 9.996-10.002 10.002 10.002 0 0 0-8.635-9.904Z"/>'
      }, props)
  }
  export function RiLogosPinterestLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.492 19.191c.023-.336.071-.671.143-1.001.063-.295.254-1.13.534-2.34l.007-.03.387-1.668c.079-.34.14-.604.181-.692a3.46 3.46 0 0 1-.284-1.423c0-1.337.756-2.373 1.736-2.373.36-.006.704.15.942.426s.348.643.302.996c0 .453-.085.798-.454 2.035a28.2 28.2 0 0 0-.165.571c-.051.188-.095.358-.132.522-.096.386-.008.797.237 1.105a1.2 1.2 0 0 0 1.006.457c1.492 0 2.6-1.985 2.6-4.548 0-1.97-1.29-3.274-3.432-3.274A3.878 3.878 0 0 0 9.201 9.1a4.13 4.13 0 0 0-1.195 2.961 2.553 2.553 0 0 0 .512 1.644c.181.14.25.383.175.59-.041.168-.14.552-.177.68a.41.41 0 0 1-.215.296.388.388 0 0 1-.355.003c-1.16-.479-1.796-1.778-1.796-3.44 0-2.985 2.491-5.584 6.192-5.584 3.135 0 5.481 2.329 5.481 5.14 0 3.532-1.932 6.104-4.69 6.104a2.508 2.508 0 0 1-2.046-.959l-.043.177-.207.852-.002.008c-.146.6-.248 1.017-.288 1.173-.106.355-.24.703-.4 1.04a8 8 0 1 0-1.655-.593ZM12 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Z"/>'
      }, props)
  }
  export function RiLogosPixelfedFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10Zm1.031 6.099h-2.624c-.988 0-1.789.776-1.789 1.733v6.748l2.595-2.471h1.818c1.713 0 3.101-1.345 3.101-3.005s-1.388-3.005-3.1-3.005Z"/>'
      }, props)
  }
  export function RiLogosPixelfedLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm1.031 4.099c1.713 0 3.101 1.345 3.101 3.005s-1.388 3.005-3.1 3.005h-1.819L8.62 16.58V9.832c0-.957.801-1.733 1.79-1.733h2.623Z"/>'
      }, props)
  }
  export function RiLogosPlaystationFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.585 17.011c-.43.543-1.483.93-1.483.93l-7.832 2.817V18.68l5.764-2.057c.654-.234.754-.566.223-.74-.531-.175-1.492-.125-2.147.111l-3.84 1.354v-2.155l.221-.076s1.11-.393 2.67-.566c1.561-.172 3.472.024 4.972.593 1.69.535 1.88 1.323 1.452 1.866Zm-8.57-3.537V8.162c0-.624-.115-1.198-.7-1.36-.447-.144-.725.272-.725.895V21l-3.583-1.139V4c1.523.283 3.743.953 4.936 1.355 3.035 1.043 4.064 2.342 4.064 5.267 0 2.851-1.758 3.932-3.992 2.852Zm-11.583 4.99c-1.736-.49-2.025-1.51-1.234-2.097.731-.542 1.975-.95 1.975-.95l5.138-1.83v2.086l-3.698 1.325c-.653.234-.753.566-.223.74.532.175 1.493.125 2.147-.11l1.774-.644v1.865l-.354.06c-1.774.29-3.663.169-5.525-.445Z"/>'
      }, props)
  }
  export function RiLogosPlaystationLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.585 17.011c-.43.543-1.483.93-1.483.93l-7.832 2.817V18.68l5.764-2.057c.654-.234.754-.566.223-.74-.531-.175-1.492-.125-2.147.111l-3.84 1.354v-2.155l.221-.076s1.11-.393 2.67-.566c1.561-.172 3.472.024 4.972.593 1.69.535 1.88 1.323 1.452 1.866Zm-8.57-3.537V8.162c0-.624-.115-1.198-.7-1.36-.447-.144-.725.272-.725.895V21l-3.583-1.139V4c1.523.283 3.743.953 4.936 1.355 3.035 1.043 4.064 2.342 4.064 5.267 0 2.851-1.758 3.932-3.992 2.852Zm-11.583 4.99c-1.736-.49-2.025-1.51-1.234-2.097.731-.542 1.975-.95 1.975-.95l5.138-1.83v2.086l-3.698 1.325c-.653.234-.753.566-.223.74.532.175 1.493.125 2.147-.11l1.774-.644v1.865l-.354.06c-1.774.29-3.663.169-5.525-.445Z"/>'
      }, props)
  }
  export function RiLogosProductHuntFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm1.334-10H10.5V9h2.834a1.5 1.5 0 0 1 0 3Zm0-5H8.5v10h2v-3h2.834a3.5 3.5 0 1 0 0-7Z"/>'
      }, props)
  }
  export function RiLogosProductHuntLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1.334-8a1.5 1.5 0 0 0 0-3H10.5v3h2.834Zm0-5a3.5 3.5 0 1 1 0 7H10.5v3h-2V7h4.834Z"/>'
      }, props)
  }
  export function RiLogosQqFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.914 14.529a32.024 32.024 0 0 0-.676-1.886l-.91-2.246c.002-.026.013-.468.013-.696C18.34 5.86 16.508 2 12 2 7.494 2 5.66 5.86 5.66 9.7c0 .229.011.671.012.697l-.91 2.246a31.99 31.99 0 0 0-.675 1.886c-.86 2.737-.581 3.87-.369 3.895.455.054 1.771-2.06 1.771-2.06 0 1.224.637 2.822 2.016 3.976-.515.157-1.147.399-1.554.695-.365.267-.319.54-.253.65.289.481 4.955.307 6.303.157 1.347.15 6.014.324 6.302-.158.066-.11.112-.382-.253-.649-.407-.296-1.039-.538-1.555-.695 1.379-1.154 2.016-2.752 2.016-3.977 0 0 1.316 2.115 1.771 2.06.212-.025.49-1.157-.37-3.894Z"/>'
      }, props)
  }
  export function RiLogosQqLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.536 12.514-.696-1.796c0-.021.01-.375.01-.558C16.85 7.088 15.447 4 12 4c-3.446 0-4.848 3.088-4.848 6.16 0 .183.009.537.01.557l-.696 1.797c-.19.514-.38 1.05-.517 1.51-.657 2.189-.444 3.095-.282 3.115.348.043 1.354-1.648 1.354-1.648 0 .98.487 2.258 1.542 3.18-.394.127-.878.32-1.188.557-.28.214-.245.431-.194.52.22.385 3.79.245 4.82.125 1.03.12 4.599.26 4.82-.126.05-.088.085-.305-.194-.519-.311-.237-.795-.43-1.19-.556 1.055-.923 1.542-2.202 1.542-3.181 0 0 1.007 1.691 1.355 1.648.162-.02.378-.928-.283-3.116a26.91 26.91 0 0 0-.516-1.509Zm1.021 8.227c-.373.652-.833.892-1.438 1.057-.24.065-.498.108-.794.138-.44.045-.986.065-1.613.064a33.217 33.217 0 0 1-2.71-.116c-.692.065-1.785.114-2.71.116a16.048 16.048 0 0 1-1.614-.064 4.917 4.917 0 0 1-.793-.138c-.605-.164-1.065-.405-1.44-1.059a2.274 2.274 0 0 1-.239-1.652c-.592-.132-1.001-.482-1.279-.911a2.43 2.43 0 0 1-.309-.71 4.027 4.027 0 0 1-.116-1.106c.013-.785.187-1.762.532-2.912.14-.466.327-1.008.567-1.655l.554-1.43a15.362 15.362 0 0 1-.002-.203C5.153 5.605 7.589 2 12 2c4.413 0 6.848 3.605 6.848 8.16l-.001.203.553 1.43.01.026c.225.606.413 1.153.556 1.626.348 1.15.522 2.128.535 2.916.007.407-.03.776-.118 1.108-.066.246-.161.48-.31.708-.276.427-.684.776-1.277.91.13.554.055 1.14-.24 1.654Z"/>'
      }, props)
  }
  export function RiLogosReactjsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.448 16.24a21.883 21.883 0 0 1-1.747 2.175c1.673 1.623 3.228 2.383 4.091 1.884.863-.498.982-2.225.413-4.484-.853.19-1.779.334-2.757.424Zm-1.31.087a27.48 27.48 0 0 1-2.275 0c.376.492.758.948 1.137 1.363.38-.415.761-.871 1.138-1.364Zm5.04-7.894c2.665.764 4.406 2.034 4.406 3.567 0 1.533-1.74 2.803-4.405 3.567.67 2.69.44 4.832-.887 5.598-1.327.767-3.297-.105-5.292-2.031-1.994 1.925-3.964 2.798-5.291 2.031-1.328-.766-1.557-2.908-.887-5.598-2.665-.764-4.405-2.034-4.405-3.567 0-1.533 1.74-2.803 4.405-3.567-.67-2.69-.44-4.832.887-5.599 1.327-.766 3.297.106 5.291 2.032 1.995-1.926 3.965-2.798 5.292-2.032 1.327.767 1.557 2.909.887 5.599Zm-.973-.248c.57-2.26.45-3.986-.413-4.485-.863-.498-2.418.262-4.09 1.885.591.643 1.179 1.373 1.746 2.175.978.09 1.904.234 2.757.425Zm-10.41 7.63c-.569 2.26-.45 3.986.414 4.484.863.498 2.418-.261 4.09-1.884a21.866 21.866 0 0 1-1.746-2.176 21.883 21.883 0 0 1-2.757-.425Zm4.068-8.142a27.507 27.507 0 0 1 2.275 0A20.537 20.537 0 0 0 12 6.31c-.38.416-.76.872-1.137 1.364Zm-1.31.087a21.865 21.865 0 0 1 1.746-2.175C9.627 3.962 8.072 3.202 7.21 3.7c-.863.499-.983 2.226-.413 4.485.853-.19 1.779-.334 2.757-.425Zm4.34 7.52A25.373 25.373 0 0 0 15.788 12a25.363 25.363 0 0 0-1.893-3.28 25.37 25.37 0 0 0-3.787 0A25.368 25.368 0 0 0 8.213 12a25.39 25.39 0 0 0 1.894 3.28 25.398 25.398 0 0 0 3.787 0Zm1.285-.132c.615-.08 1.2-.182 1.75-.303a20.512 20.512 0 0 0-.612-1.667 27.546 27.546 0 0 1-1.137 1.97ZM8.822 8.851c-.615.08-1.2.183-1.75.304.17.536.375 1.094.613 1.667a27.518 27.518 0 0 1 1.137-1.97Zm-1.75 5.994c.55.121 1.135.223 1.75.303a27.528 27.528 0 0 1-1.137-1.97 20.51 20.51 0 0 0-.613 1.667Zm-.978-.245c.262-.834.6-1.708 1.01-2.6a21.88 21.88 0 0 1-1.01-2.6c-2.241.636-3.677 1.604-3.677 2.6s1.436 1.963 3.677 2.6ZM16.93 9.155c-.55-.121-1.136-.224-1.75-.304a27.541 27.541 0 0 1 1.137 1.97c.238-.572.442-1.13.613-1.666Zm.977.245c-.26.834-.6 1.708-1.01 2.6.41.892.75 1.766 1.01 2.6 2.242-.637 3.678-1.604 3.678-2.6s-1.436-1.963-3.678-2.6ZM12 13.879a1.88 1.88 0 1 1 0-3.758 1.88 1.88 0 0 1 0 3.758Z"/>'
      }, props)
  }
  export function RiLogosReactjsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-.528 2.994c.175.211.35.414.528.609.177-.195.353-.398.528-.609a24.932 24.932 0 0 1-1.056 0Zm-1.995-.125a20.686 20.686 0 0 1-2.285-.367c-.075.35-.132.688-.17 1.015-.19 1.583.075 2.545.478 2.777.403.233 1.368-.019 2.645-.974.263-.197.528-.416.794-.655a20.665 20.665 0 0 1-1.462-1.796Zm7.331-.367a20.69 20.69 0 0 1-2.285.367 20.665 20.665 0 0 1-1.462 1.796c.266.24.531.458.794.655 1.277.955 2.242 1.207 2.645.974.403-.232.667-1.194.479-2.777a11.374 11.374 0 0 0-.17-1.015Zm1.45-.388c.577 2.639.274 4.74-1.008 5.48-1.282.74-3.253-.048-5.25-1.867-1.997 1.819-3.968 2.606-5.25 1.866-1.282-.74-1.585-2.84-1.009-5.48-2.574-.82-4.241-2.133-4.241-3.613s1.667-2.793 4.241-3.613c-.576-2.64-.273-4.74 1.009-5.48 1.282-.74 3.253.047 5.25 1.866 1.997-1.819 3.968-2.606 5.25-1.866 1.282.74 1.585 2.84 1.009 5.48C20.833 9.207 22.5 10.52 22.5 12s-1.668 2.793-4.241 3.614Zm-7.32-9.779c-.265-.239-.53-.458-.793-.655-1.277-.955-2.242-1.207-2.645-.974-.403.232-.667 1.194-.479 2.777.04.327.096.666.17 1.016a20.677 20.677 0 0 1 2.286-.368c.475-.653.965-1.254 1.462-1.796Zm3.585 1.796c.802.085 1.568.209 2.285.368.075-.35.132-.69.17-1.015.19-1.584-.075-2.546-.478-2.778-.403-.233-1.368.019-2.645.974-.263.197-.528.416-.794.655.497.542.987 1.143 1.462 1.796Zm-1.995-.125c-.175-.21-.351-.414-.528-.609-.177.195-.353.398-.528.609a24.868 24.868 0 0 1 1.056 0Zm-4.156 7.198a24.907 24.907 0 0 1-.528-.914c-.095.257-.183.51-.263.762.257.055.521.106.79.152Zm1.932.234a22.915 22.915 0 0 0 3.392 0A22.957 22.957 0 0 0 15.393 12a22.863 22.863 0 0 0-1.696-2.938 22.896 22.896 0 0 0-3.392 0A22.91 22.91 0 0 0 8.609 12a22.926 22.926 0 0 0 1.696 2.938Zm5.852-4.728c.095-.257.183-.51.263-.761a17.974 17.974 0 0 0-.79-.153 25.076 25.076 0 0 1 .527.914ZM6.131 9.837c-.34.11-.662.23-.964.36-1.465.628-2.166 1.338-2.166 1.803 0 .465.7 1.175 2.166 1.803.302.13.624.25.964.36.222-.7.497-1.426.825-2.163a20.678 20.678 0 0 1-.825-2.163Zm1.45-.388c.081.25.169.504.264.76a24.929 24.929 0 0 1 .528-.913c-.27.046-.534.097-.791.153Zm10.29 4.714c.34-.11.662-.23.964-.36C20.3 13.175 21 12.465 21 12c0-.465-.7-1.175-2.166-1.803-.302-.13-.625-.25-.965-.36-.22.7-.496 1.426-.824 2.163.328.737.603 1.463.825 2.163Zm-1.45.389c-.081-.251-.169-.505-.264-.762a25.108 25.108 0 0 1-.528.914c.27-.046.534-.097.791-.152Z"/>'
      }, props)
  }
  export function RiLogosRedditFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm6.67-10a1.46 1.46 0 0 0-2.47-1 7.12 7.12 0 0 0-3.85-1.23l.65-3.12 2.14.45a1 1 0 1 0 .13-.61L12.821 6a.31.31 0 0 0-.37.24l-.74 3.47a7.14 7.14 0 0 0-3.9 1.23 1.46 1.46 0 1 0-1.61 2.39 2.87 2.87 0 0 0 0 .44c0 2.24 2.61 4.06 5.83 4.06s5.83-1.82 5.83-4.06a2.885 2.885 0 0 0 0-.44 1.46 1.46 0 0 0 .81-1.33Zm-10 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm5.81 2.75a3.84 3.84 0 0 1-2.47.77 3.84 3.84 0 0 1-2.47-.77.27.27 0 0 1 .38-.38 3.27 3.27 0 0 0 2.08.63 3.28 3.28 0 0 0 2.09-.61.28.28 0 1 1 .39.4v-.04Zm-.18-1.71a1 1 0 1 1 1-1 1 1 0 0 1-1.01 1.04l.01-.04Z"/>'
      }, props)
  }
  export function RiLogosRedditLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.053 7.815.751-3.536a2 2 0 0 1 2.372-1.54l3.196.68a2 2 0 1 1-.415 1.956l-3.197-.68-.666 3.135c1.785.137 3.558.73 5.164 1.7A3.192 3.192 0 0 1 23 12.203v.021a3.193 3.193 0 0 1-1.207 2.55 2.852 2.852 0 0 1-.008.123c0 3.998-4.45 7.03-9.799 7.03-5.333 0-9.708-3.024-9.705-6.953a5.316 5.316 0 0 1-.01-.181 3.193 3.193 0 0 1 3.454-5.35 11.446 11.446 0 0 1 5.329-1.628Zm9.285 5.526c.409-.203.665-.62.662-1.075a1.192 1.192 0 0 0-2.016-.806l-.585.56-.67-.455c-1.615-1.098-3.452-1.725-5.23-1.764h-1.006c-1.875.028-3.652.6-5.237 1.675l-.664.45-.583-.55a1.192 1.192 0 1 0-1.315 1.952l.633.29-.053.695a3.95 3.95 0 0 0 .003.584c0 2.71 3.356 5.03 7.708 5.03 4.371 0 7.799-2.336 7.802-5.107a3.304 3.304 0 0 0 0-.507l-.052-.672.604-.3ZM6.951 13.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm7 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-1.985 5.103c-1.397 0-2.766-.37-3.881-1.21a.424.424 0 0 1 .597-.597c.945.693 2.123.99 3.269.99s2.33-.275 3.284-.959a.439.439 0 0 1 .732.206.469.469 0 0 1-.12.423c-.683.797-2.483 1.147-3.88 1.147Z"/>'
      }, props)
  }
  export function RiLogosRemixiconFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.53 17.53 20.001 21h-17V4h10.667v.008A7.118 7.118 0 0 1 14.137 4c-.089.37-.136.76-.136 1.166 0 2.318 2.015 4.333 4.667 4.333.724 0 1.419-.197 2.032-.538a7.002 7.002 0 0 1-4.17 8.567ZM18.501 7.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"/>'
      }, props)
  }
  export function RiLogosRemixiconLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m6.365 6 8.784 9.663.72-.283c1.685-.661 2.864-2.156 3.092-3.896A6.502 6.502 0 0 1 12.078 6H6.364ZM14 5a4.5 4.5 0 0 0 6.714 3.918c.186.618.286 1.271.286 1.947 0 2.891-1.822 5.365-4.4 6.377L20 21h-17V4h11.111a4.512 4.512 0 0 0-.111 1Zm4.5 2.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm-13.5-.03V19h10.48L5.001 7.47Z"/>'
      }, props)
  }
  export function RiLogosSafariFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.701 6.8-6.114 3.786L6.802 16.7l-.104-.104-1.415 1.414.708.707 1.414-1.414L7.3 17.2l6.114-3.785L17.2 7.3l.104.104L18.72 5.99l-.708-.708-1.414 1.415.104.104Zm-4.7 15.2c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm-.5-19v2h1V3h-1Zm0 16v2h1v-2h-1ZM8.095 3.876l.765 1.848.924-.383-.765-1.847-.924.382Zm6.123 14.783.765 1.847.924-.382-.765-1.848-.924.383Zm.765-15.165-.765 1.847.924.383.765-1.848-.924-.382ZM8.86 18.276l-.765 1.848.924.382.765-1.848-.924-.382ZM21.001 11.5h-2v1h2v-1Zm-16 0h-2v1h2v-1Zm15.458 3.616-1.835-.795-.397.918 1.835.794.397-.918ZM5.775 8.76 3.94 7.967l-.397.918 1.835.794.397-.918Zm14.35-.667-1.848.765.383.924 1.847-.765-.383-.924ZM5.342 14.217l-1.847.765.382.924 1.848-.765-.383-.924ZM18.72 18.01l-1.415-1.414-.707.707 1.414 1.415.707-.708ZM7.404 6.697 5.99 5.282l-.708.708 1.415 1.414.707-.707Zm3.908 4.615 3.611-2.235-2.235 3.61-1.376-1.375Z"/>'
      }, props)
  }
  export function RiLogosSafariLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.813 6.503-4.398 6.911-6.911 4.398A7.973 7.973 0 0 0 11 19.938V18h2v1.938a7.96 7.96 0 0 0 3.906-1.618l-1.37-1.37 1.414-1.414 1.37 1.37A7.96 7.96 0 0 0 19.939 13h-1.938v-2h1.938a7.974 7.974 0 0 0-2.126-4.497Zm-.315-.315a7.973 7.973 0 0 0-4.497-2.126V6h-2V4.062A7.96 7.96 0 0 0 7.095 5.68l1.37 1.37-1.414 1.414-1.37-1.37A7.96 7.96 0 0 0 4.063 11H6v2H4.063a7.973 7.973 0 0 0 2.126 4.497l4.398-6.911 6.911-4.398ZM12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Z"/>'
      }, props)
  }
  export function RiLogosSkypeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.31 20.4a8.5 8.5 0 0 1-9.71-9.71 5.25 5.25 0 0 1 7.09-7.09 8.5 8.5 0 0 1 9.71 9.71 5.25 5.25 0 0 1-7.09 7.09Zm-1.257-3.244h-.04c2.872 0 4.303-1.386 4.303-3.243 0-1.198-.551-2.471-2.726-2.958l-1.983-.44c-.755-.172-1.622-.4-1.622-1.115s.62-1.213 1.724-1.213c2.23 0 2.027 1.528 3.131 1.528.576 0 1.093-.342 1.093-.93 0-1.37-2.197-2.4-4.056-2.4-2.021 0-4.173.859-4.173 3.144 0 1.098.394 2.27 2.56 2.813l2.689.671c.816.202 1.018.659 1.018 1.072 0 .687-.684 1.358-1.918 1.358-2.417 0-2.078-1.857-3.374-1.857-.58 0-1.003.398-1.003.971 0 1.114 1.352 2.598 4.377 2.598Z"/>'
      }, props)
  }
  export function RiLogosSkypeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.005 18.423a2 2 0 0 1 1.237.207 3.25 3.25 0 0 0 4.389-4.389 2 2 0 0 1-.207-1.237 6.5 6.5 0 0 0-7.427-7.427A2 2 0 0 1 9.76 5.37 3.25 3.25 0 0 0 5.371 9.76a2 2 0 0 1 .207 1.237 6.5 6.5 0 0 0 7.427 7.427ZM12.001 20.5a8.5 8.5 0 0 1-8.4-9.81 5.25 5.25 0 0 1 7.09-7.09 8.5 8.5 0 0 1 9.71 9.71 5.25 5.25 0 0 1-7.09 7.09c-.427.066-.865.1-1.31.1Zm.053-3.5C9.252 17 8 15.62 8 14.586c0-.532.39-.902.928-.902 1.2 0 .887 1.725 3.125 1.725 1.143 0 1.776-.624 1.776-1.261 0-.384-.188-.808-.943-.995l-2.49-.624c-2.006-.504-2.37-1.592-2.37-2.612C8.027 7.797 10.019 7 11.89 7c1.72 0 3.755.956 3.755 2.228 0 .545-.479.863-1.011.863-1.023 0-.835-1.418-2.9-1.418-1.023 0-1.596.462-1.596 1.126 0 .663.803.876 1.502 1.035l1.836.409c2.014.452 2.524 1.633 2.524 2.746 0 1.724-1.325 3.011-3.985 3.011h.038Z"/>'
      }, props)
  }
  export function RiLogosSlackFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.527 14.514a1.973 1.973 0 0 1-1.967 1.968 1.973 1.973 0 0 1-1.968-1.968c0-1.083.885-1.968 1.968-1.968h1.967v1.968Zm.992 0c0-1.083.885-1.968 1.968-1.968s1.967.885 1.967 1.968v4.927a1.973 1.973 0 0 1-1.967 1.968 1.973 1.973 0 0 1-1.968-1.968v-4.927Zm1.968-7.987A1.973 1.973 0 0 1 7.519 4.56c0-1.083.885-1.968 1.968-1.968s1.967.885 1.967 1.968v1.967H9.487Zm0 .992c1.083 0 1.967.885 1.967 1.968a1.973 1.973 0 0 1-1.967 1.967H4.56a1.973 1.973 0 0 1-1.968-1.967c0-1.083.885-1.968 1.968-1.968h4.927Zm7.986 1.968c0-1.083.885-1.968 1.968-1.968s1.968.885 1.968 1.968a1.973 1.973 0 0 1-1.968 1.967h-1.968V9.487Zm-.991 0a1.973 1.973 0 0 1-1.968 1.967 1.973 1.973 0 0 1-1.968-1.967V4.56c0-1.083.885-1.968 1.968-1.968s1.968.885 1.968 1.968v4.927Zm-1.968 7.986c1.083 0 1.968.885 1.968 1.968a1.973 1.973 0 0 1-1.968 1.968 1.973 1.973 0 0 1-1.968-1.968v-1.968h1.968Zm0-.991a1.973 1.973 0 0 1-1.968-1.968c0-1.083.885-1.968 1.968-1.968h4.927c1.083 0 1.968.885 1.968 1.968a1.973 1.973 0 0 1-1.968 1.968h-4.927Z"/>'
      }, props)
  }
  export function RiLogosSlackLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.501 3a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-3 0v-5a1.5 1.5 0 0 1 1.5-1.5Zm-10 10h1.5v1.5a1.5 1.5 0 1 1-1.5-1.5Zm8.5 5h1.5a1.5 1.5 0 1 1-1.5 1.5V18Zm1.5-5h5a1.5 1.5 0 0 1 0 3h-5a1.5 1.5 0 1 1 0-3Zm5-5a1.5 1.5 0 0 1 0 3h-1.5V9.5a1.5 1.5 0 0 1 1.5-1.5Zm-15 0h5a1.5 1.5 0 1 1 0 3h-5a1.5 1.5 0 0 1 0-3Zm5-5a1.5 1.5 0 0 1 1.5 1.5V6h-1.5a1.5 1.5 0 1 1 0-3Zm0 10a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-3 0v-5a1.5 1.5 0 0 1 1.5-1.5Z"/>'
      }, props)
  }
  export function RiLogosSnapchatFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.872 21.765c-1.19 0-1.984-.562-2.693-1.057-.504-.357-.976-.696-1.533-.79a4.562 4.562 0 0 0-.803-.066c-.472 0-.847.071-1.114.125-.17.03-.312.058-.424.058-.116 0-.263-.032-.32-.228-.05-.16-.081-.312-.112-.459-.08-.37-.147-.597-.286-.62-1.489-.227-2.38-.57-2.554-.976-.014-.044-.031-.09-.031-.125-.01-.124.08-.227.205-.25 1.181-.195 2.242-.824 3.138-1.858.696-.803 1.035-1.579 1.066-1.663 0-.01.009-.01.009-.01.17-.351.205-.65.102-.895-.192-.46-.825-.656-1.257-.79-.111-.03-.205-.066-.285-.093-.37-.147-.986-.46-.905-.892.058-.312.472-.535.811-.535.094 0 .174.014.24.05.38.173.723.262 1.017.262.366 0 .54-.138.584-.182a24.904 24.904 0 0 0-.035-.593c-.09-1.365-.192-3.059.24-4.03 1.298-2.907 4.053-3.14 4.869-3.14L12.157 3h.05c.815 0 3.57.227 4.868 3.139.437.971.33 2.67.24 4.03l-.009.067c-.008.182-.022.356-.03.535.044.035.204.169.534.173.286-.008.598-.102.954-.263a.805.805 0 0 1 .312-.066c.125 0 .25.03.357.066h.009c.299.112.495.321.495.54.009.205-.152.517-.914.825-.08.03-.174.067-.285.093-.424.13-1.057.335-1.258.79-.111.24-.067.548.103.896 0 .008.009.008.009.008.049.125 1.337 3.05 4.204 3.527a.246.246 0 0 1 .205.25c0 .044-.009.089-.031.129-.174.41-1.057.744-2.555.976-.138.022-.205.25-.285.62a6.889 6.889 0 0 1-.111.459c-.045.147-.139.227-.3.227h-.021c-.103 0-.241-.013-.424-.049a5.282 5.282 0 0 0-1.115-.116c-.263 0-.535.023-.802.067-.553.09-1.03.433-1.534.79-.718.49-1.516 1.052-2.697 1.052h-.254Z"/>'
      }, props)
  }
  export function RiLogosSnapchatLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.383 10.58.02-.249c.01-.147.021-.304.031-.48.032-.558.051-1.174.051-1.845 0-.872-.294-1.487-.914-2.064-.66-.614-1.459-.942-2.59-.942-1.137 0-1.958.335-2.51.888-.696.695-.957 1.218-.957 2.1 0 .521.06 1.994.095 2.619a2 2 0 0 1-.468 1.4c.054.1.105.205.152.318.3.771.198 1.543-.152 2.271-.392.818-.73 1.393-1.41 2.154a7.973 7.973 0 0 1-.642.643 1.999 1.999 0 0 1 .412.564 5.886 5.886 0 0 1 1.585.075c.81.146 1.324.434 2.194 1.061l.016.011.213.152c.62.44.877.546 1.473.546.609 0 .91-.121 1.523-.552l.207-.146c.877-.632 1.407-.927 2.231-1.076a6.663 6.663 0 0 1 1.56-.074 1.998 1.998 0 0 1 .417-.567 8.415 8.415 0 0 1-.617-.617 9.23 9.23 0 0 1-1.447-2.159c-.363-.749-.47-1.54-.137-2.321.04-.098.085-.19.132-.276a2 2 0 0 1-.468-1.435Zm-10.316-.102c.42 0 .601.305 1.22.305.156 0 .26-.035.325-.066-.008-.156-.098-1.986-.098-2.729 0-1.688.719-2.69 1.542-3.514C8.879 3.65 10.162 3 11.982 3c1.82 0 3.066.653 3.952 1.478.886.825 1.551 1.93 1.551 3.528 0 1.555-.099 2.594-.107 2.716a.59.59 0 0 0 .278.065c.63 0 .63-.31 1.33-.31.686 0 .983.57.983.823 0 .621-.832.967-1.33 1.126-.369.117-.931.291-1.075.635-.073.174-.043.4.092.678.004.008 1.26 2.883 3.93 3.326.235.035.392.241.392.483 0 .333-.37.617-.727.782-.443.2-1.09.37-1.952.505-.043.078-.134.485-.235.887-.135.542-.8.366-.99.326A4.997 4.997 0 0 0 16.277 20c-.483.087-.913.378-1.396.726-.713.504-1.465 1.076-2.9 1.076-1.435 0-2.144-.572-2.857-1.076-.482-.348-.904-.637-1.395-.726-.899-.163-1.57.036-1.796.056-.226.021-.841.245-.996-.326-.044-.166-.19-.808-.234-.895-.857-.135-1.509-.313-1.953-.513-.365-.165-.726-.443-.726-.778 0-.236.158-.44.392-.483 2.643-.483 3.765-3.005 3.921-3.33.133-.276.161-.5.092-.679-.144-.343-.705-.513-1.074-.635-.105-.034-1.335-.373-1.335-1.117 0-.24.204-.573.581-.73.162-.066.359-.092.465-.092Z"/>'
      }, props)
  }
  export function RiLogosSoundcloudFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.464 8.597c.265 0 .48 2.106.48 4.704l-.001.35c-.019 2.435-.226 4.354-.479 4.354-.256 0-.465-1.965-.48-4.44v-.353c.005-2.557.218-4.615.48-4.615Zm-1.664.96c.259 0 .47 1.8.48 4.054v.34c-.01 2.253-.221 4.053-.48 4.053-.255 0-.464-1.755-.48-3.97v-.339l.002-.34c.025-2.133.23-3.798.478-3.798Zm-1.664 0c.255 0 .464 1.755.48 3.97v.339l-.002.34c-.025 2.133-.23 3.799-.478 3.799-.259 0-.47-1.8-.48-4.055v-.34c.01-2.253.221-4.053.48-4.053Zm-1.664.575c.265 0 .48 1.763.48 3.937l-.002.335c-.02 2.017-.227 3.6-.478 3.6-.262 0-.474-1.716-.48-3.851v-.169c.006-2.135.218-3.851.48-3.851Zm-1.664 1.729c.265 0 .48 1.375.48 3.071v.159c-.013 1.623-.223 2.914-.48 2.914-.265 0-.48-1.376-.48-3.072v-.159c.013-1.623.223-2.913.48-2.913Zm10.784-4.8c2.58 0 4.72 1.885 5.118 4.354a3.36 3.36 0 1 1 .993 6.589H12.48a.768.768 0 0 1-.768-.768V7.933a5.16 5.16 0 0 1 2.88-.872ZM2.144 11.668c.265 0 .48 1.333.48 2.977v.155c-.014 1.571-.223 2.82-.48 2.82-.26 0-.473-1.29-.48-2.897v-.079c0-1.643.215-2.976.48-2.976Zm-1.664.96c.265 0 .48.946.48 2.113v.13c-.016 1.106-.225 1.981-.48 1.981-.265 0-.48-.945-.48-2.111v-.131c.016-1.106.225-1.981.48-1.981Z"/>'
      }, props)
  }
  export function RiLogosSoundcloudLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 10a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1Zm3 1a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Zm3-4a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm5-1a6 6 0 0 1 5.996 5.775l.003.26a3.5 3.5 0 0 1-.307 6.96L20.5 19h-3.501a1 1 0 0 1-.117-1.993L17 17h3.447l.138-.002a1.5 1.5 0 0 0 .267-2.957l-.135-.026-1.77-.252.053-1.787-.004-.176A4 4 0 0 0 15.2 8.005L15 8c-.268 0-.531.026-.788.077L14 8.126V18a1 1 0 0 1-.883.993L13 19a1 1 0 0 1-1-1V6.803A5.973 5.973 0 0 1 15 6ZM1 12a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiLogosSpectrumFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.2 2.006c8.041.088 8.8 1.245 8.8 9.995l-.005 1.199C21.908 21.24 20.75 22 12 22l-1.2-.005c-7.658-.083-8.712-1.137-8.794-8.795L2 11.69l.006-.89c.085-7.85 1.19-8.76 9.381-8.799l1.812.004ZM8.25 7.001h-.583a.667.667 0 0 0-.66.568l-.006.098v3.667c0 .335.246.612.568.66l.098.007h.584a3.75 3.75 0 0 1 3.744 3.55l.006.2v.583c0 .335.246.612.568.66l.098.007h3.667a.667.667 0 0 0 .66-.569l.007-.098v-.583a8.75 8.75 0 0 0-8.492-8.747l-.258-.003Z"/>'
      }, props)
  }
  export function RiLogosSpectrumLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.389 2.001 1.81.005.844.014c7.162.165 7.939 1.512 7.957 9.667l-.005 1.512-.014.844c-.165 7.161-1.512 7.938-9.667 7.957l-1.512-.006-.888-.015c-6.854-.163-7.828-1.427-7.907-8.78L2 11.691l.006-.89.014-.865c.165-7.053 1.486-7.897 9.368-7.935ZM14.12 4.01 10.883 4l-1.322.01c-5.489.082-5.544.82-5.56 7.403l.002 2.175.01 1.04c.088 4.982.793 5.343 6.399 5.37l3.455-.002.776-.01c5.108-.091 5.346-.836 5.357-6.877l-.002-2.742-.012-1.056c-.094-4.796-.785-5.25-5.866-5.303ZM8.25 7A8.75 8.75 0 0 1 17 15.75v.583a.667.667 0 0 1-.666.667h-3.667a.667.667 0 0 1-.666-.667v-.583A3.75 3.75 0 0 0 8.25 12h-.584a.667.667 0 0 1-.666-.667V7.667C7 7.299 7.299 7 7.667 7h.584Z"/>'
      }, props)
  }
  export function RiLogosSpotifyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.45-10-10-10Zm3.75 14.65c-2.35-1.45-5.3-1.75-8.8-.95-.35.1-.65-.15-.75-.45-.1-.35.15-.65.45-.75 3.8-.85 7.1-.5 9.7 1.1.35.15.4.55.25.85-.2.3-.55.4-.85.2Zm1-2.7c-2.7-1.65-6.8-2.15-9.95-1.15-.4.1-.85-.1-.95-.5-.1-.4.1-.85.5-.95 3.65-1.1 8.15-.55 11.25 1.35.3.15.45.65.2 1s-.7.5-1.05.25ZM6.3 9.75c-.5.15-1-.15-1.15-.6-.15-.5.15-1 .6-1.15 3.55-1.05 9.4-.85 13.1 1.35.45.25.6.85.35 1.3-.25.35-.85.5-1.3.25-3.2-1.9-8.55-2.1-11.6-1.15Z"/>'
      }, props)
  }
  export function RiLogosSpotifyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c5.55 0 10 4.5 10 10s-4.5 10-10 10-10-4.5-10-10 4.5-10 10-10Zm0 2c-4.395 0-8 3.605-8 8s3.605 8 8 8 8-3.605 8-8c0-4.414-3.573-8-8-8Zm3.75 12.65c-2.35-1.45-5.3-1.75-8.8-.95-.35.1-.65-.15-.75-.45-.1-.35.15-.65.45-.75 3.8-.85 7.1-.5 9.7 1.1.35.15.4.55.25.85-.2.3-.55.4-.85.2Zm1-2.7c-2.7-1.65-6.8-2.15-9.95-1.15-.4.1-.85-.1-.95-.5-.1-.4.1-.85.5-.95 3.65-1.1 8.15-.55 11.25 1.35.3.15.45.65.2 1s-.7.5-1.05.25ZM6.3 9.75c-.5.15-1-.15-1.15-.6-.15-.5.15-1 .6-1.15 3.55-1.05 9.4-.85 13.1 1.35.45.25.6.85.35 1.3-.25.35-.85.5-1.3.25-3.2-1.9-8.55-2.1-11.6-1.15Z"/>'
      }, props)
  }
  export function RiLogosStackOverflowFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.001 20.003V14.67h2v7.333h-16V14.67h2v5.333h12ZM7.6 14.736l.313-1.979 8.837 1.7-.113 1.586L7.6 14.736Zm1.2-4.531.732-1.6 7.998 3.732-.733 1.6-7.998-3.732Zm2.265-3.932 1.133-1.333 6.798 5.664-1.133 1.333-6.798-5.664Zm4.332-4.132 5.265 7.064-1.4 1.066-5.264-7.064 1.4-1.066ZM7.333 18.668V16.67h9.33v2h-9.33Z"/>'
      }, props)
  }
  export function RiLogosStackOverflowLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.001 20.003V15h2v7.003h-16V15h2v5.003h12ZM7.501 18v-2h9v2h-9Zm.077-4.38.347-1.97 8.864 1.563-.348 1.97-8.863-1.563Zm1.634-5.504 1-1.732 7.794 4.5-1 1.732-7.794-4.5Zm3.417-4.613 1.532-1.285 5.785 6.894-1.532 1.286-5.785-6.895Z"/>'
      }, props)
  }
  export function RiLogosStackshareFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.001 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-4.208 2.621a2.222 2.222 0 0 0-2.133 1.6h-1.998l-2.46 4.185H8.764a2.222 2.222 0 1 0 0 1.242h1.471l2.417 4.134h2.018a2.222 2.222 0 1 0 0-1.243h-1.317l-2.056-3.537 2.053-3.538h1.31a2.222 2.222 0 1 0 2.133-2.843Zm.011 9.427a1.168 1.168 0 1 1-1.145 1.394s-.03-.226 0-.453c.107-.535.58-.94 1.145-.94Zm-10.152-4.21a1.169 1.169 0 0 1 0 2.335 1.168 1.168 0 0 1 0-2.335Zm10.15-4.209a1.168 1.168 0 0 1 0 2.335 1.169 1.169 0 0 1-1.144-.941c-.026-.206 0-.446 0-.446a1.168 1.168 0 0 1 1.144-.948Z"/>'
      }, props)
  }
  export function RiLogosStackshareLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.537 13H7.33a3.001 3.001 0 0 1-5.829-1 3 3 0 0 1 5.83-1h2.206l3.464-6h3.17a3.001 3.001 0 0 1 5.83 1 3 3 0 0 1-5.829 1h-2.017l-2.886 4.999L14.156 17h2.016A3.001 3.001 0 0 1 22 18a3 3 0 0 1-5.829 1h-3.171l-3.464-6Zm9.464 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-14.5-6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm14.5-6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiLogosSteamFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.005 2c-5.25 0-9.556 4.05-9.964 9.197l5.36 2.216a2.823 2.823 0 0 1 1.593-.492c.053 0 .105.003.157.005l2.384-3.452v-.049c0-2.08 1.69-3.77 3.77-3.77a3.776 3.776 0 0 1 3.77 3.772c0 2.08-1.691 3.771-3.77 3.771h-.087l-3.397 2.426c0 .043.003.088.003.133A2.826 2.826 0 0 1 9 18.587a2.844 2.844 0 0 1-2.775-2.273l-3.838-1.589C3.574 18.922 7.428 22 12.006 22c5.522 0 9.998-4.477 9.998-10 0-5.522-4.477-10-9.999-10ZM7.08 16.667c.218.452.595.832 1.095 1.041a2.126 2.126 0 0 0 2.78-2.77 2.123 2.123 0 0 0-2.712-1.178l1.269.526a1.565 1.565 0 0 1-1.204 2.889l-1.228-.508Zm10.74-7.245a2.516 2.516 0 0 0-2.513-2.512 2.513 2.513 0 1 0 2.513 2.512ZM15.312 7.53A1.89 1.89 0 0 1 17.2 9.418a1.89 1.89 0 0 1-1.888 1.888 1.887 1.887 0 1 1 0-3.776Z"/>'
      }, props)
  }
  export function RiLogosSteamLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.001 4a5 5 0 1 1-.892 9.92l-2.651 1.989a4 4 0 1 1-7.923.068L1.709 14.43l.75-1.854 3.826 1.545a3.994 3.994 0 0 1 3.697-1.592l2.04-3.061A5 5 0 0 1 17.002 4Zm-7.5 10.5c-.464 0-.892.158-1.231.424l1.606.649a1 1 0 0 1-.75 1.854L7.52 16.78A2 2 0 1 0 9.501 14.5Zm3.364-2.69-.983 1.476c.284.21.54.458.758.735l1.36-1.02a5.027 5.027 0 0 1-1.135-1.191ZM17 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"/>'
      }, props)
  }
  export function RiLogosSupabaseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.084 15.25c-1.664 0-2.6-1.912-1.58-3.226L10.21.807C10.794.054 12 .467 12 1.42v7.33h8.916c1.663 0 2.6 1.913 1.58 3.227L13.79 23.194c-.584.753-1.79.34-1.79-.613v-7.33H3.084Z"/>'
      }, props)
  }
  export function RiLogosSupabaseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2.598V13.97H3.9c-.67 0-1.07-.785-.643-1.336L11 2.598Zm2 5.432V2.333C13 .52 10.703-.292 9.582 1.162L1.673 11.41C.246 13.26 1.548 15.969 3.9 15.969H11v5.698c0 1.811 2.296 2.624 3.418 1.171l7.908-10.249c1.427-1.85.126-4.559-2.227-4.559H13Zm0 2h7.1c.669 0 1.069.785.643 1.337L13 21.402V10.03Z"/>'
      }, props)
  }
  export function RiLogosSwitchFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.62 21c-.085 0-.141-.057-.127-.127V3.127c0-.056.042-.113.113-.113h2.785a4.61 4.61 0 0 1 4.61 4.61v8.766a4.61 4.61 0 0 1-4.61 4.61H13.62Zm3.422-9.926c-1.004 0-1.824.82-1.824 1.824s.82 1.824 1.824 1.824 1.824-.82 1.824-1.824-.82-1.824-1.824-1.824ZM5.8 8.4c0-.933.763-1.696 1.696-1.696.934 0 1.697.763 1.697 1.696 0 .934-.763 1.697-1.697 1.697a1.702 1.702 0 0 1-1.696-1.697ZM11.54 3c.085 0 .142.057.128.127V20.86c0 .07-.057.127-.128.127h-3.93A4.61 4.61 0 0 1 3 16.376V7.61A4.61 4.61 0 0 1 7.611 3h3.93Zm-1.315 16.544V4.442H7.611c-.849 0-1.64.34-2.235.933a3.088 3.088 0 0 0-.933 2.235v8.766c0 .849.34 1.64.933 2.234a3.088 3.088 0 0 0 2.235.934h2.615Z"/>'
      }, props)
  }
  export function RiLogosSwitchLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 3v18h-4.4a4.6 4.6 0 0 1-4.6-4.6V7.6a4.6 4.6 0 0 1 4.6-4.6h4.4Zm-2 2h-2.4a2.6 2.6 0 0 0-2.6 2.6v8.8a2.6 2.6 0 0 0 2.6 2.6h2.4V5Zm-2.5 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm6.5-7h2.4a4.6 4.6 0 0 1 4.6 4.6v8.8a4.6 4.6 0 0 1-4.6 4.6h-2.4V3Zm3 11.7a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z"/>'
      }, props)
  }
  export function RiLogosTaobaoFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.576 8.277 2.383 10.12l2.201 1.37s1.464.754.762 2.17C4.697 14.997 1.5 17.928 1.5 17.928l2.862 1.798c1.984-4.326 1.85-3.75 2.347-5.306.512-1.58.625-2.793-.242-3.676-1.113-1.125-1.238-1.23-2.89-2.468Zm1.565-.693c1.04 0 1.882-.758 1.882-1.693 0-.944-.842-1.702-1.882-1.702-1.049 0-1.887.762-1.887 1.702.004.93.838 1.693 1.887 1.693Zm17.005.21s-.625-4.87-11.208-1.855c.455-.794.67-1.306.67-1.306l-2.642-.75s-1.068 3.507-2.97 5.14c0 0 1.846 1.072 1.826 1.04a17.065 17.065 0 0 0 1.407-1.596c.423-.19.83-.363 1.225-.524-.492.887-1.278 2.217-2.068 3.056l1.113.983s.762-.737 1.588-1.62h.944v1.636H8.345v1.307h3.684v3.132l-.14-.004c-.408-.02-1.037-.089-1.287-.484-.298-.483-.076-1.358-.064-1.903H7.995l-.093.053s-.935 4.205 2.69 4.112c3.386.093 5.329-.955 6.264-1.677l.371 1.395 2.089-.883-1.415-3.483-1.694.536.315 1.19c-.428.33-.932.572-1.468.753v-2.737h3.592v-1.31h-3.592v-1.637h3.604V9.05h-6.41c.464-.568.823-1.088.92-1.415l-1.121-.306c4.797-1.734 7.47-1.435 7.45 1.403v7.474s.282 2.564-2.637 2.383l-1.58-.343-.367 1.512s6.817 1.968 7.374-3.314c.552-5.281-.141-8.652-.141-8.652Z"/>'
      }, props)
  }
  export function RiLogosTaobaoLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.173 14H14.5v1.375c.55-.222 1.153-.491 1.812-.81l-.082-.239.942-.327Zm.828-.288.12-.041c.641 1.85 1.034 3.011 1.185 3.5l-1.912.589c-.073-.24-.216-.672-.427-1.292-6.081 2.884-8.671 2.054-9.008-1.908l1.993-.17c.1 1.166.344 1.622.897 1.753.393.093.94.063 1.652-.105V14h-3.5v-2h.513l-1.167-1.39c1.043-.876 1.858-1.83 2.449-2.863a41.29 41.29 0 0 0-1.552.434 13.953 13.953 0 0 1-1.754 2.11L6.09 8.86c1.273-1.247 2.333-2.909 3.176-4.994l1.854.75c-.153.379-.313.746-.48 1.101 3.702-.935 7.275-1.317 9.138-.68 1.223.418 1.919 1.392 2.188 2.585.17.755.313 2.688.313 5.122 0 2.808-.056 3.771-.34 4.622-.298.89-.697 1.418-1.408 1.984-.657.523-1.553.764-2.645.823-.673.038-1.368.003-2.095-.079-.119-.013-.234-.027-.354-.043l-.242-.032.264-1.983a70.813 70.813 0 0 0 .556.07c.625.071 1.216.1 1.762.07.714-.039 1.245-.181 1.508-.39.426-.34.591-.558.756-1.053.186-.555.238-1.449.238-3.989 0-2.298-.134-4.102-.265-4.683-.13-.576-.41-.97-.883-1.131-1.207-.413-3.801-.194-6.652.416l.615.262c-.13.303-.273.6-.43.89h5.337v2h-3.5V12h3.5v1.713Zm-5.5-3.213h-1.208A13.678 13.678 0 0 1 9.799 12h2.702v-1.5Zm-10.038-.438L3.54 8.376c1.062.679 2.935 2.427 3.338 3.162 1.239 2.26.198 4.175-3.122 7.997l-1.51-1.312c2.687-3.094 3.5-4.59 2.878-5.724-.214-.39-1.857-1.923-2.661-2.438ZM5.14 7.583c-1.048 0-1.882-.762-1.886-1.693 0-.94.838-1.702 1.886-1.702 1.04 0 1.883.758 1.883 1.702 0 .935-.843 1.693-1.883 1.693Z"/>'
      }, props)
  }
  export function RiLogosTelegramFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm-3.11-8.83.013-.007.87 2.87c.112.311.266.367.453.341.188-.025.287-.126.41-.244l1.188-1.148 2.55 1.888c.466.257.801.124.917-.432l1.658-7.822c.183-.728-.139-1.02-.703-.788l-9.733 3.76c-.664.266-.66.638-.12.803l2.497.78Z"/>'
      }, props)
  }
  export function RiLogosTelegramLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm-3.11-8.83-2.498-.779c-.54-.165-.543-.537.121-.804l9.733-3.76c.564-.23.886.061.703.79l-1.658 7.82c-.116.557-.451.69-.916.433l-2.551-1.888-1.189 1.148c-.122.118-.221.219-.409.244-.187.026-.341-.03-.454-.34l-.87-2.871-.012.008Z"/>'
      }, props)
  }
  export function RiLogosTiktokFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 8.245V15.5a6.5 6.5 0 1 1-5-6.326v3.163a3.5 3.5 0 1 0 2 3.163V2h3a5 5 0 0 0 5 5v3a7.966 7.966 0 0 1-5-1.755Z"/>'
      }, props)
  }
  export function RiLogosTiktokLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2v6.414a6.85 6.85 0 1 0 5.6 6.736v-3.736a8.603 8.603 0 0 0 3.4.686h1V6.5h-1c-1.903 0-3.4-1.537-3.4-3.5V2H11Zm2 2h1.688c.394 2.22 2.08 3.996 4.312 4.41v1.618c-1.038-.152-1.975-.542-2.843-1.123L14.6 7.863v7.287a4.85 4.85 0 1 1-4.6-4.844v1.604a3.25 3.25 0 1 0 3 3.24V4ZM8.5 15.15a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z"/>'
      }, props)
  }
  export function RiLogosTrelloFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.251 3h13.5a2.25 2.25 0 0 1 2.25 2.25v13.5a2.25 2.25 0 0 1-2.25 2.25h-13.5a2.25 2.25 0 0 1-2.25-2.25V5.25A2.25 2.25 0 0 1 5.251 3Zm7.92 3.42v5.76c0 .596.484 1.08 1.08 1.08h3.33a1.08 1.08 0 0 0 1.08-1.08V6.42a1.08 1.08 0 0 0-1.08-1.08h-3.33a1.08 1.08 0 0 0-1.08 1.08Zm-7.83 0v10.26c0 .596.484 1.08 1.08 1.08h3.33a1.08 1.08 0 0 0 1.08-1.08V6.42a1.08 1.08 0 0 0-1.08-1.08h-3.33a1.08 1.08 0 0 0-1.08 1.08Z"/>'
      }, props)
  }
  export function RiLogosTrelloLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.001 5v14h14V5h-14Zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm3 4h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Zm6 0h2a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiLogosTumblrFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.27 7.63A5.76 5.76 0 0 0 10.817 2h3.03v5.152h3.637v3.636h-3.637v5.454c0 .515.198 1.207.91 1.667.474.307 1.484.458 3.03.455V22h-4.243a4.546 4.546 0 0 1-4.545-4.546v-6.666H6.27V7.63Z"/>'
      }, props)
  }
  export function RiLogosTumblrLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.001 8c1.075 0 3.497-.673 3.497-4.5V2h1.5v6h5.003v2h-5.003v2.91c.003 2.48.003 3.686.003 4.09-.002 2.208 1.615 3.4 4.785 3.4V22h-2.242c-2.402.002-4.546-2.035-4.546-4.546V10H7.001V8h1Z"/>'
      }, props)
  }
  export function RiLogosTwitchFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.001 3v11.74l-4.696 4.695h-3.913l-2.437 2.348H6.914v-2.348H3.001V6.13L4.228 3h16.773Zm-1.565 1.565H6.13v11.74h3.13v2.347l2.349-2.348h4.695l3.13-3.13V4.565Zm-3.13 3.13v4.696H14.74V7.696h1.565Zm-3.914 0v4.696h-1.565V7.696h1.565Z"/>'
      }, props)
  }
  export function RiLogosTwitchLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.301 3h16.7v11.7l-4.7 4.7h-3.9l-2.5 2.4h-2.9v-2.4h-4V6.2l1.3-3.2Zm.7 14.4h4v2.4h.095l2.5-2.4h3.877L19 13.872V5h-14v12.4Zm10-9.4h2v4.7h-2V8Zm0 0h2v4.7h-2V8Zm-5 0h2v4.7h-2V8Z"/>'
      }, props)
  }
  export function RiLogosTwitterFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.212 5.656a8.384 8.384 0 0 1-2.401.658A4.195 4.195 0 0 0 21.649 4c-.82.488-1.719.83-2.655 1.015a4.182 4.182 0 0 0-7.126 3.814 11.874 11.874 0 0 1-8.621-4.37 4.168 4.168 0 0 0-.566 2.103c0 1.45.739 2.731 1.86 3.481a4.169 4.169 0 0 1-1.894-.523v.051a4.185 4.185 0 0 0 3.355 4.102 4.205 4.205 0 0 1-1.89.072A4.185 4.185 0 0 0 8.02 16.65a8.394 8.394 0 0 1-6.192 1.732 11.831 11.831 0 0 0 6.41 1.88c7.694 0 11.9-6.373 11.9-11.9 0-.18-.004-.362-.012-.541a8.497 8.497 0 0 0 2.086-2.164Z"/>'
      }, props)
  }
  export function RiLogosTwitterLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.35 5.55a2.9 2.9 0 0 0-2.9 2.846l-.028 1.575a.6.6 0 0 1-.68.584l-1.562-.213c-2.053-.28-4.021-1.225-5.91-2.798-.597 3.31.57 5.603 3.383 7.372L9.4 16.014a.6.6 0 0 1 .035.992L7.843 18.17c.947.06 1.846.018 2.592-.13 4.718-.942 7.855-4.492 7.855-10.348 0-.478-1.013-2.141-2.94-2.141Zm-4.9 2.81a4.9 4.9 0 0 1 8.385-3.355c.711-.005 1.316.175 2.668-.646-.334 1.64-.5 2.353-1.213 3.332 0 7.641-4.697 11.358-9.464 12.309-3.267.652-8.02-.419-9.38-1.842.693-.053 3.513-.356 5.143-1.55-1.38-.91-6.868-4.14-3.261-12.822 1.693 1.977 3.41 3.322 5.15 4.037 1.157.475 1.442.465 1.973.538Z"/>'
      }, props)
  }
  export function RiLogosUbuntuFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.001 12c0 5.522-4.477 10-10 10s-10-4.478-10-10c0-5.523 4.477-10 10-10s10 4.477 10 10Zm-16.8-1.336a1.335 1.335 0 1 0 0 2.67 1.335 1.335 0 0 0 0-2.67Zm9.533 6.069a1.334 1.334 0 1 0 1.334 2.31 1.334 1.334 0 0 0-1.334-2.31ZM8.1 12c0-1.32.656-2.485 1.659-3.19l-.977-1.636a5.813 5.813 0 0 0-2.398 3.371 1.875 1.875 0 0 1 0 2.91 5.812 5.812 0 0 0 2.398 3.371l.977-1.636A3.892 3.892 0 0 1 8.1 12Zm3.9-3.9a3.9 3.9 0 0 1 3.884 3.554l1.903-.028a5.781 5.781 0 0 0-1.724-3.762 1.872 1.872 0 0 1-2.513-1.454 5.829 5.829 0 0 0-4.12.39l.927 1.663a3.885 3.885 0 0 1 1.643-.363Zm0 7.8c-.587 0-1.143-.13-1.643-.363l-.927 1.662a5.774 5.774 0 0 0 4.12.39 1.872 1.872 0 0 1 2.514-1.454 5.782 5.782 0 0 0 1.723-3.762l-1.903-.027A3.898 3.898 0 0 1 12 15.9Zm2.732-8.633a1.335 1.335 0 1 0 1.335-2.312 1.335 1.335 0 0 0-1.335 2.312Z"/>'
      }, props)
  }
  export function RiLogosUbuntuLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m8.668 19.273 1.006-1.742a6.001 6.001 0 0 0 8.282-4.781h2.012A7.972 7.972 0 0 1 18.929 16a8.002 8.002 0 0 1-1.452 1.835 2.493 2.493 0 0 0-1.976.227 2.493 2.493 0 0 0-1.184 1.595 7.979 7.979 0 0 1-5.65-.384Zm-1.3-.75a7.979 7.979 0 0 1-3.157-4.7c.486-.456.79-1.104.79-1.823 0-.72-.304-1.369-.791-1.825A8 8 0 0 1 5.073 8a7.97 7.97 0 0 1 2.295-2.524l1.006 1.742a6.001 6.001 0 0 0 0 9.563L7.37 18.523Zm1.3-13.796a8.007 8.007 0 0 1 5.648-.387c.152.65.562 1.238 1.185 1.598.623.36 1.337.42 1.976.227a8.007 8.007 0 0 1 2.49 5.085h-2.013a5.99 5.99 0 0 0-2.953-4.446 5.99 5.99 0 0 0-5.327-.335L8.668 4.727ZM16 5.072a1.5 1.5 0 1 1 1.5-2.598A1.5 1.5 0 0 1 16 5.072ZM4.001 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm12 6.928a1.5 1.5 0 1 1 1.5 2.598 1.5 1.5 0 0 1-1.5-2.598Z"/>'
      }, props)
  }
  export function RiLogosUnsplashFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.501 11v5h7v-5h5.5v10h-18V11h5.5Zm7-8v5h-7V3h7Z"/>'
      }, props)
  }
  export function RiLogosUnsplashLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.001 10v4h4v-4h7v11h-18V10h7Zm-2 2h-3v7h14v-7h-3L16 16H8v-4Zm8-9v6h-8V3h8Zm-2 2h-4v2h4V5Z"/>'
      }, props)
  }
  export function RiLogosVimeoFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1.174 8.301c-.281-.413-.252-.413.328-.922 1.232-1.082 2.394-2.266 3.736-3.212 1.215-.852 2.826-1.402 3.927-.047 1.014 1.249 1.038 3.142 1.295 4.65.257 1.564.503 3.164 1.051 4.66.152.421.443 1.217.968 1.284.678.093 1.368-1.096 1.683-1.54.817-1.18 1.925-2.769 1.785-4.286-.138-1.612-1.878-1.309-2.966-.924.175-1.809 1.858-3.843 3.48-4.53 1.72-.714 4.276-.702 5.14 1.237.922 2.102.093 4.543-.912 6.448-1.096 2.068-2.509 3.982-4.018 5.77-1.331 1.588-2.906 3.33-4.89 4.089-2.267.864-3.61-.82-4.382-2.77-.843-2.123-1.262-4.506-1.87-6.716-.256-.935-.56-1.998-1.167-2.77-.792-.994-1.692-.059-2.474.478-.27-.267-.491-.607-.714-.899Z"/>'
      }, props)
  }
  export function RiLogosVimeoLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.994 3.004C20.427 3.004 22 4.516 22 7.499c0 1.72-.998 3.94-1.832 5.235-2.789 4.333-6.233 8.74-9.643 8.74-3.706 0-4.67-6.83-5.092-8.432-.422-1.6-.533-2.209-1.17-3.232-.317.219-.76.528-1.33.929a.5.5 0 0 1-.693-.116L.926 8.807a.5.5 0 0 1 .027-.62C3.78 4.914 6.129 3.277 8 3.277c2.392 0 3.125 2.815 3.324 4.222.3 2.117.69 4.738 1.245 5.872.556-.791 2.18-2.887 1.966-3.99-.094-.486-1.317.184-1.887.078-.425-.079-.805-.402-.805-1.026 0-1.31 1.851-5.43 6.15-5.43Zm.007 2c-2.194 0-3.251 1.532-3.653 2.207 1.25.046 1.97.819 2.134 1.804.388 2.329-1.917 4.92-2.34 5.564-.396.603-3.061 3.329-4.25-3.359-.112-.63-.367-2.164-.665-4.187-.17-1.15-.872-1.763-1.229-1.763-.843 0-1.92.65-3.856 2.515 1.905-.115 2.545 2.276 2.917 3.634.815 2.983 1.57 8.055 3.62 8.055 1.726 0 4.438-2.646 7.37-7.039.208-.312 1.965-3.025 1.965-5.036 0-2.395-1.469-2.395-2.013-2.395Z"/>'
      }, props)
  }
  export function RiLogosVisaFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1 4h22v2H1V4Zm0 14h22v2H1v-2Zm18.622-3.086-.174-.87h-1.949l-.31.863-1.562.004c1.005-2.407 1.75-4.19 2.236-5.35.127-.302.353-.456.685-.454.254.002.669.002 1.245 0L21 14.912l-1.378.003Zm-1.684-2.062h1.256l-.47-2.18-.786 2.18ZM7.872 9.106l1.57.002-2.427 5.806-1.59-.001c-.537-2.07-.932-3.606-1.184-4.605-.077-.307-.23-.521-.526-.622-.263-.09-.701-.23-1.315-.419v-.16h2.509c.434 0 .687.21.769.64l.62 3.289 1.574-3.93Zm3.727.002-1.24 5.805-1.495-.002 1.24-5.805 1.495.002ZM14.631 9c.446 0 1.01.138 1.334.267l-.262 1.204c-.293-.118-.775-.277-1.18-.27-.59.009-.954.256-.954.493 0 .384.632.578 1.284.999.743.48.84.91.832 1.378-.011.971-.832 1.929-2.565 1.929-.791-.012-1.076-.078-1.72-.306l.272-1.256c.656.274.935.361 1.495.361.515 0 .956-.207.96-.568.002-.257-.155-.384-.732-.702-.577-.317-1.386-.756-1.375-1.64C12.033 9.759 13.107 9 14.63 9Z"/>'
      }, props)
  }
  export function RiLogosVisaLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m22.221 15.768-.224-1.125h-2.514l-.4 1.117-2.015.004c1.295-3.113 2.257-5.418 2.884-6.917.164-.392.455-.592.884-.589.328.003.863.003 1.606.001L24 15.765l-1.779.003Zm-2.172-2.666h1.62l-.605-2.82-1.015 2.82ZM7.06 8.257l2.026.002-3.132 7.51-2.051-.002a951.26 951.26 0 0 1-1.528-5.956c-.1-.396-.298-.673-.679-.804C1.357 8.89.792 8.71 0 8.466v-.207h3.237c.56 0 .887.271.992.827.106.557.372 1.976.8 4.254L7.06 8.257Zm4.81.002-1.601 7.509-1.929-.003L9.94 8.257l1.93.002Zm3.91-.139c.577 0 1.304.18 1.722.346l-.338 1.556c-.378-.152-1-.357-1.523-.35-.76.013-1.23.332-1.23.638 0 .498.816.749 1.656 1.293.958.62 1.085 1.177 1.073 1.783-.013 1.255-1.073 2.494-3.309 2.494-1.02-.015-1.388-.1-2.22-.396l.352-1.624c.847.354 1.206.467 1.93.467.663 0 1.232-.268 1.237-.735.004-.332-.2-.497-.944-.907-.744-.411-1.788-.979-1.774-2.122.017-1.462 1.402-2.443 3.368-2.443Z"/>'
      }, props)
  }
  export function RiLogosVuejsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1.001 3h4l7 12 7-12h4l-11 19-11-19Zm8.667 0L12 7l2.333-4h4.035l-6.368 11L5.633 3h4.035Z"/>'
      }, props)
  }
  export function RiLogosVuejsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.317 3 12 18l8.684-15h2.316l-11 19-11-19h2.316Zm4.342 0L12 10.5 16.343 3h2.316L12 14.5 5.343 3H7.66Z"/>'
      }, props)
  }
  export function RiLogosWechat2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.458 18.184C3.359 16.676 2 14.4 2 11.907c0-4.584 4.475-8.307 10-8.307s10 3.723 10 8.307c0 4.585-4.475 8.308-10 8.308-1.142 0-2.253-.154-3.272-.462-.092-.03-.216-.03-.308-.03-.185 0-.37.061-.525.154l-2.191 1.261c-.062.03-.124.062-.186.062a.342.342 0 0 1-.339-.339c0-.092.03-.154.062-.246.03-.03.308-1.046.463-1.662 0-.061.03-.153.03-.215 0-.246-.092-.43-.277-.554Zm3.21-7.673c.717 0 1.285-.568 1.285-1.286 0-.717-.568-1.286-1.285-1.286-.718 0-1.285.569-1.285 1.286 0 .718.567 1.286 1.285 1.286Zm6.666 0c.718 0 1.285-.568 1.285-1.286 0-.717-.567-1.286-1.285-1.286-.717 0-1.285.569-1.285 1.286 0 .718.568 1.286 1.285 1.286Z"/>'
      }, props)
  }
  export function RiLogosWechat2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.667 11.512a1.276 1.276 0 0 1-1.285-1.286c0-.718.568-1.286 1.285-1.286.718 0 1.285.568 1.285 1.286 0 .717-.567 1.286-1.285 1.286Zm6.667 0a1.276 1.276 0 0 1-1.285-1.286c0-.718.568-1.286 1.285-1.286s1.285.568 1.285 1.286c0 .717-.568 1.286-1.285 1.286Zm-8.511 7.704.715-.437a4 4 0 0 1 2.706-.536c.211.033.385.059.52.077.406.053.819.08 1.237.08 4.42 0 7.9-3.022 7.9-6.6 0-3.577-3.48-6.6-7.9-6.6-4.421 0-7.9 3.023-7.9 6.6 0 1.366.5 2.673 1.431 3.781.049.058.12.137.215.235a4 4 0 0 1 1.1 3.102l-.024.298Zm-.63 2.726a1 1 0 0 1-1.527-.93l.189-2.26a2 2 0 0 0-.55-1.551 6.935 6.935 0 0 1-.303-.332C2.806 15.447 2.1 13.695 2.1 11.8c0-4.75 4.432-8.6 9.9-8.6 5.467 0 9.9 3.85 9.9 8.6s-4.433 8.6-9.9 8.6c-.51 0-1.01-.033-1.5-.098-.152-.02-.342-.048-.568-.084a2 2 0 0 0-1.353.269l-2.387 1.456Z"/>'
      }, props)
  }
  export function RiLogosWechatChannelsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.194 3.181c1.162-.47 2.155-.019 2.672 1.277C23.26 7.944 20 21.133 17.441 21.133c-.828 0-1.657-.688-2.624-1.926a23.045 23.045 0 0 1-1.357-1.974c-.374-.6-.742-1.232-1.095-1.87L12 14.69l-.018.032a44.08 44.08 0 0 1-1.442 2.511c-.467.75-.922 1.416-1.358 1.974-.966 1.238-1.795 1.926-2.623 1.926C4 21.133.74 7.943 2.133 4.458 2.651 3.162 3.644 2.71 4.806 3.18c.842.34 1.772 1.156 2.81 2.376A31.772 31.772 0 0 1 9.548 8.11a59.03 59.03 0 0 1 2.137 3.36l.316.538.316-.538a61.531 61.531 0 0 1 1.696-2.71l.44-.65a31.79 31.79 0 0 1 1.931-2.553c1.039-1.22 1.968-2.035 2.81-2.376ZM4.324 4.353c-.49-.199-.743-.084-1.005.57-.457 1.145-.265 4.028.413 7.264l.158.724.174.733c.856 3.46 2.087 6.224 2.495 6.224.28 0 .889-.506 1.615-1.436.405-.518.835-1.148 1.28-1.863.362-.581.72-1.194 1.063-1.816l.415-.767.348-.671-.364-.638-.332-.566a57.76 57.76 0 0 0-2.09-3.287 30.556 30.556 0 0 0-1.852-2.45c-.916-1.077-1.716-1.778-2.318-2.021Zm16.356.57c-.261-.654-.514-.769-1.005-.57-.602.243-1.402.944-2.317 2.02a30.544 30.544 0 0 0-1.852 2.45 55.503 55.503 0 0 0-1.687 2.615l-.574.962-.527.915.181.35.245.465c.445.832.919 1.664 1.401 2.438a21.81 21.81 0 0 0 1.28 1.864c.727.93 1.336 1.436 1.616 1.436.408 0 1.639-2.763 2.494-6.224l.174-.733c.805-3.523 1.063-6.758.571-7.987Z"/>'
      }, props)
  }
  export function RiLogosWechatChannelsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.66 18.964a2.37 2.37 0 0 1-.155-.21c-.238-.353-.515-.905-.805-1.627-.575-1.432-1.138-3.372-1.536-5.326-.4-1.965-.616-3.869-.537-5.244.04-.7.153-1.161.283-1.416A.692.692 0 0 1 4.002 5c.292 0 .74.162 1.356.651.6.476 1.25 1.174 1.927 2.032 1.236 1.565 2.464 3.532 3.552 5.326-.18.315-.37.66-.565 1.014l-.278.502c-.419.755-.864 1.537-1.324 2.245-.465.715-.918 1.312-1.344 1.72-.3.289-.52.42-.665.474ZM12 11.076c-.962-1.562-2.042-3.236-3.145-4.632-.721-.914-1.481-1.747-2.254-2.36C5.846 3.486 4.959 3 4.001 3c-.923 0-1.537.57-1.874 1.234-.315.62-.45 1.408-.496 2.209-.094 1.625.16 3.721.573 5.756.416 2.046 1.01 4.106 1.64 5.674.313.778.65 1.476 1 1.997.175.26.378.514.614.713.225.192.582.417 1.042.417.895 0 1.648-.526 2.211-1.067.589-.565 1.14-1.31 1.636-2.073.5-.77.973-1.603 1.396-2.364l.249-.45.024.045.21.393c.41.76.867 1.595 1.358 2.367.486.766 1.035 1.518 1.639 2.088C15.812 20.495 16.58 21 17.5 21c.46 0 .817-.226 1.043-.417.235-.2.439-.453.613-.712.35-.522.688-1.22 1-1.998.63-1.568 1.224-3.628 1.64-5.674.414-2.034.668-4.131.574-5.756-.046-.8-.18-1.589-.496-2.209C21.536 3.57 20.924 3 20 3c-.958 0-1.846.485-2.6 1.084-.773.613-1.533 1.446-2.255 2.36-1.102 1.396-2.183 3.07-3.145 4.632Zm1.162 1.935c1.089-1.795 2.317-3.763 3.553-5.328.677-.857 1.327-1.556 1.927-2.032.617-.49 1.064-.65 1.356-.651a.69.69 0 0 1 .093.14c.13.256.242.718.282 1.417.08 1.375-.137 3.279-.537 5.244-.397 1.954-.96 3.894-1.536 5.326-.29.722-.566 1.274-.804 1.628-.066.097-.12.168-.164.218-.173-.052-.417-.186-.736-.488-.426-.403-.871-.994-1.324-1.706a36.167 36.167 0 0 1-1.284-2.242l-.2-.374c-.215-.401-.425-.795-.626-1.152Z"/>'
      }, props)
  }
  export function RiLogosWechatFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.575 13.711a.91.91 0 0 0 .898-.898c0-.498-.399-.898-.898-.898a.894.894 0 0 0-.898.898c0 .5.4.898.898.898Zm-4.425 0a.91.91 0 0 0 .898-.898c0-.498-.4-.898-.898-.898a.894.894 0 0 0-.898.898c0 .5.399.898.898.898Zm6.567 5.04a.347.347 0 0 0-.172.37c0 .048 0 .098.025.147.098.417.294 1.081.294 1.106 0 .073.025.122.025.172a.22.22 0 0 1-.221.22c-.05 0-.074-.024-.123-.048l-1.449-.836a.8.8 0 0 0-.344-.098c-.073 0-.147 0-.196.024-.688.197-1.4.295-2.161.295-3.66 0-6.607-2.457-6.607-5.505 0-3.047 2.947-5.505 6.607-5.505 3.659 0 6.606 2.458 6.606 5.505 0 1.647-.884 3.146-2.284 4.154ZM16.674 8.099a9.112 9.112 0 0 0-.28-.005c-4.174 0-7.606 2.86-7.606 6.505 0 .554.08 1.09.228 1.6h-.089a9.966 9.966 0 0 1-2.584-.368c-.074-.025-.148-.025-.222-.025a.832.832 0 0 0-.419.123l-1.747 1.005a.35.35 0 0 1-.148.05.273.273 0 0 1-.27-.27c0-.074.024-.123.049-.197.024-.024.246-.834.369-1.324 0-.05.024-.123.024-.172a.556.556 0 0 0-.221-.441C2.059 13.376 1 11.585 1 9.598 1.001 5.944 4.571 3 8.951 3c3.765 0 6.93 2.169 7.723 5.098Zm-5.154.418c.573 0 1.026-.477 1.026-1.026 0-.573-.453-1.026-1.026-1.026s-1.026.453-1.026 1.026.453 1.026 1.026 1.026Zm-5.26 0c.573 0 1.027-.477 1.027-1.026 0-.573-.454-1.026-1.027-1.026-.572 0-1.026.453-1.026 1.026s.454 1.026 1.026 1.026Z"/>'
      }, props)
  }
  export function RiLogosWechatLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.001 14.676v-.062c0-2.508 2.017-4.618 4.753-5.233-.364-2.302-2.794-4.18-5.853-4.18-3.32 0-5.9 2.213-5.9 4.779 0 .969.36 1.9 1.04 2.698.032.038.083.094.152.165a3.568 3.568 0 0 1 1.002 2.238 3.613 3.613 0 0 1 2.363-.442c.166.026.302.046.405.06a7.253 7.253 0 0 0 2.038-.023Zm.457 1.951a9.204 9.204 0 0 1-2.753.055 18.997 18.997 0 0 1-.454-.066 1.613 1.613 0 0 0-1.08.211l-1.904 1.148a.806.806 0 0 1-.49.117.791.791 0 0 1-.729-.851l.15-1.781a1.565 1.565 0 0 0-.439-1.223 5.558 5.558 0 0 1-.241-.262c-.954-1.12-1.517-2.502-1.517-3.995 0-3.745 3.537-6.78 7.9-6.78 4.06 0 7.403 2.627 7.85 6.008 3.371.154 6.05 2.515 6.05 5.406 0 1.193-.456 2.296-1.229 3.19-.051.06-.116.13-.195.21a1.24 1.24 0 0 0-.356.977l.121 1.422a.635.635 0 0 1-.59.68.66.66 0 0 1-.396-.094l-1.544-.917a1.322 1.322 0 0 0-.874-.169c-.147.023-.27.04-.368.053-.316.04-.64.062-.969.062-2.694 0-4.998-1.408-5.943-3.4Zm6.977 1.31a3.326 3.326 0 0 1 1.675.174 3.25 3.25 0 0 1 .842-1.501c.05-.051.087-.09.106-.113.489-.565.743-1.213.743-1.883 0-1.804-1.903-3.414-4.4-3.414-2.497 0-4.4 1.61-4.4 3.414s1.903 3.414 4.4 3.414a5.6 5.6 0 0 0 .714-.045c.08-.01.188-.026.32-.046Z"/>'
      }, props)
  }
  export function RiLogosWechatPayFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.271 14.669a.661.661 0 0 1-.88-.269l-.043-.095-1.818-3.998a.473.473 0 0 1 0-.146.327.327 0 0 1 .335-.327.305.305 0 0 1 .196.066l2.18 1.527a.988.988 0 0 0 .546.167.894.894 0 0 0 .342-.066l10.047-4.5a10.73 10.73 0 0 0-8.171-3.526C6.479 3.502 2 7.232 2 11.87a7.83 7.83 0 0 0 3.46 6.296.662.662 0 0 1 .24.727l-.45 1.701a.945.945 0 0 0-.051.24.327.327 0 0 0 .334.334.416.416 0 0 0 .19-.058l2.18-1.265c.16-.098.343-.151.53-.152.1 0 .198.014.292.043 1.062.3 2.16.452 3.264.45 5.525 0 10.011-3.729 10.011-8.33a7.228 7.228 0 0 0-1.098-3.883L9.351 14.625l-.08.044Z"/>'
      }, props)
  }
  export function RiLogosWechatPayLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19.146 8.993-9.799 5.608-.07.046a.647.647 0 0 1-.3.069.655.655 0 0 1-.58-.345l-.046-.092-1.831-3.95c-.023-.046-.023-.092-.023-.138 0-.183.139-.321.324-.321.07 0 .139.023.209.069l2.155 1.515c.162.092.347.161.556.161a.938.938 0 0 0 .348-.069l8.274-3.648C16.935 6.273 14.635 5.2 12.001 5.2c-4.421 0-7.9 3.023-7.9 6.6 0 1.366.5 2.673 1.431 3.781.049.058.12.137.215.235a4 4 0 0 1 1.1 3.102l-.024.298.715-.437a4 4 0 0 1 2.706-.536c.211.033.385.059.52.077.406.053.819.08 1.237.08 4.42 0 7.9-3.022 7.9-6.6 0-.996-.27-1.95-.755-2.807ZM6.193 21.943a1 1 0 0 1-1.527-.931l.189-2.26a2 2 0 0 0-.55-1.551 6.935 6.935 0 0 1-.303-.332C2.806 15.447 2.1 13.695 2.1 11.8c0-4.75 4.432-8.6 9.9-8.6 5.467 0 9.9 3.85 9.9 8.6s-4.433 8.6-9.9 8.6c-.51 0-1.01-.033-1.5-.098-.152-.02-.342-.048-.568-.084a2 2 0 0 0-1.353.269l-2.387 1.456Z"/>'
      }, props)
  }
  export function RiLogosWeiboFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.278 8.592c2.773-2.77 6.004-4.033 7.219-2.816.537.537.588 1.464.244 2.572-.178.557.524.25.524.25 2.241-.938 4.197-.994 4.91.027.38.542.343 1.306-.008 2.19-.163.407.048.47.36.563 1.262.392 2.668 1.336 2.668 3.004 0 2.763-3.98 6.239-9.964 6.239-4.565 0-9.23-2.213-9.23-5.852 0-1.902 1.204-4.102 3.277-6.177Zm12.133 5.742c-.237-2.391-3.382-4.039-7.023-3.677-3.64.359-6.403 2.59-6.167 4.98.237 2.394 3.382 4.039 7.023 3.68 3.641-.362 6.401-2.592 6.167-4.983Zm-10.249.104c.754-1.528 2.712-2.39 4.446-1.94 1.792.463 2.707 2.154 1.976 3.799-.744 1.683-2.883 2.58-4.695 1.994-1.752-.566-2.493-2.295-1.727-3.853Zm2.715.578c-.563-.237-1.291.008-1.64.553-.354.547-.189 1.201.371 1.456.568.257 1.325.013 1.676-.55.346-.568.163-1.217-.408-1.459Zm1.387-.578c-.216-.084-.486.018-.613.232-.123.214-.054.458.163.547.219.092.501-.012.628-.231.123-.22.044-.466-.178-.548Zm5.694-11.514A5.831 5.831 0 0 1 21.5 4.72a5.836 5.836 0 0 1 1.22 5.704.838.838 0 0 1-1.06.54.844.844 0 0 1-.542-1.062 4.142 4.142 0 0 0-4.808-5.327.845.845 0 0 1-.353-1.65Zm.626 2.926a2.836 2.836 0 0 1 3.29 3.648.725.725 0 1 1-1.378-.45 1.38 1.38 0 0 0-.287-1.357 1.395 1.395 0 0 0-1.322-.426.723.723 0 1 1-.303-1.415Z"/>'
      }, props)
  }
  export function RiLogosWeiboLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.195 14.197c0 3.362-4.53 6.424-9.926 6.424-4.95 0-9.268-2.432-9.268-6.087 0-1.947 1.18-4.087 3.24-6.088C7.072 5.7 10.47 4.413 12.098 5.998c.498.482.723 1.122.719 1.858 1.975-.576 3.65-.404 4.483.752.449.623.532 1.38.326 2.207 1.511.61 2.568 1.77 2.568 3.382Zm-4.44-2.07c-.386-.41-.4-.92-.198-1.41.208-.508.213-.812.12-.94-.264-.368-1.533-.363-3.194.311a2.101 2.101 0 0 1-.509.14c-.344.046-.671.001-.983-.265-.419-.359-.473-.855-.322-1.316.214-.67.18-1.076.037-1.215-.186-.18-.777-.191-1.659.143C7.978 7.98 6.75 8.799 5.633 9.88c-1.707 1.659-2.632 3.337-2.632 4.653 0 2.242 3.276 4.087 7.268 4.087 4.42 0 7.926-2.37 7.926-4.424 0-.738-.637-1.338-1.673-1.652-.394-.113-.536-.171-.767-.417Zm7.054-1.617a1 1 0 1 1-1.936-.502 4 4 0 0 0-4.693-4.924 1 1 0 0 1-.407-1.958 6 6 0 0 1 7.036 7.384Z"/>'
      }, props)
  }
  export function RiLogosWhatsappFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.005 22l1.352-4.968A9.953 9.953 0 0 1 2.001 12c0-5.523 4.477-10 10-10ZM8.593 7.3l-.2.008a.961.961 0 0 0-.372.1 1.293 1.293 0 0 0-.294.228c-.12.113-.188.211-.261.306A2.73 2.73 0 0 0 6.9 9.62c.002.49.13.967.33 1.413.409.902 1.082 1.857 1.97 2.742.214.213.424.427.65.626a9.448 9.448 0 0 0 3.84 2.046l.568.087c.185.01.37-.004.556-.013a1.99 1.99 0 0 0 .833-.231c.166-.088.244-.132.383-.22 0 0 .043-.028.125-.09.135-.1.218-.171.33-.288.083-.086.155-.187.21-.302.078-.163.156-.474.188-.733.024-.198.017-.306.014-.373-.004-.107-.093-.218-.19-.265l-.582-.261s-.87-.379-1.402-.621a.497.497 0 0 0-.176-.041.482.482 0 0 0-.378.127c-.005-.002-.072.055-.795.931a.35.35 0 0 1-.368.13 1.43 1.43 0 0 1-.191-.066c-.124-.052-.167-.072-.252-.108a6.025 6.025 0 0 1-1.575-1.003c-.126-.11-.243-.23-.363-.346a6.297 6.297 0 0 1-1.02-1.268l-.059-.095a.923.923 0 0 1-.102-.205c-.038-.147.061-.265.061-.265s.243-.266.356-.41c.11-.14.203-.276.263-.373.118-.19.155-.385.093-.536-.28-.684-.57-1.365-.868-2.041-.059-.134-.234-.23-.393-.249-.054-.006-.108-.012-.162-.016a3.385 3.385 0 0 0-.403.004l.201-.008Z"/>'
      }, props)
  }
  export function RiLogosWhatsappLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m7.254 18.494.724.423A7.953 7.953 0 0 0 12.001 20a8 8 0 1 0-8-8c0 1.436.377 2.813 1.084 4.024l.422.724-.653 2.401 2.4-.655ZM2.005 22l1.352-4.968A9.953 9.953 0 0 1 2.001 12c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.005 22ZM8.392 7.308c.134-.01.269-.01.403-.004.054.004.108.01.162.016.159.018.334.115.393.249.298.676.588 1.357.868 2.04.062.152.025.347-.093.537-.06.097-.154.233-.263.372-.113.145-.356.411-.356.411s-.099.118-.061.265c.014.056.06.137.102.205l.059.095c.256.427.6.86 1.02 1.268.12.116.237.235.363.346.468.413.998.75 1.57 1l.005.002c.085.037.128.057.252.11.062.026.126.048.191.066a.35.35 0 0 0 .367-.13c.724-.877.79-.934.796-.934v.002a.482.482 0 0 1 .378-.127c.06.004.121.015.177.04.531.243 1.4.622 1.4.622l.582.261c.098.047.187.158.19.265.004.067.01.175-.013.373-.032.259-.11.57-.188.733a1.158 1.158 0 0 1-.21.302 2.381 2.381 0 0 1-.33.288c-.082.062-.125.09-.125.09a5.063 5.063 0 0 1-.383.22 1.99 1.99 0 0 1-.833.23c-.185.01-.37.024-.556.014-.008 0-.568-.087-.568-.087a9.448 9.448 0 0 1-3.84-2.046c-.226-.199-.436-.413-.65-.626-.888-.885-1.561-1.84-1.97-2.742a3.472 3.472 0 0 1-.33-1.413 2.73 2.73 0 0 1 .565-1.68c.073-.094.142-.192.261-.305.126-.12.207-.184.294-.228a.961.961 0 0 1 .371-.1Z"/>'
      }, props)
  }
  export function RiLogosWindowsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m3.001 5.479 7.377-1.016v7.127H3V5.48Zm0 13.042 7.377 1.017v-7.04H3v6.023Zm8.188 1.125L21.001 21v-8.502h-9.812v7.148Zm0-15.292v7.236h9.812V3l-9.812 1.354Z"/>'
      }, props)
  }
  export function RiLogosWindowsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.001 2.5v19l-18-2v-15l18-2Zm-2 10.499-7 .001v5.487l7 .779v-6.267Zm-14 4.71 5 .556V13l-5-.001v4.71Zm14-6.71V4.735l-7 .777V11l7-.001Zm-9-5.265-5 .556V11l5 .001V5.734Z"/>'
      }, props)
  }
  export function RiLogosWordpressFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.323 12c0 3.438 2 6.4 4.892 7.808L4.077 8.469A8.646 8.646 0 0 0 3.323 12ZM12 20.677a8.77 8.77 0 0 0 2.885-.492l-.062-.116-2.67-7.307-2.6 7.561c.77.23 1.593.354 2.447.354ZM13.192 7.93l3.139 9.33.869-2.892c.37-1.2.654-2.061.654-2.807 0-1.077-.385-1.816-.708-2.385-.446-.723-.854-1.33-.854-2.039 0-.8.6-1.538 1.462-1.538h.107A8.646 8.646 0 0 0 12 3.323a8.67 8.67 0 0 0-7.246 3.908l.554.015c.907 0 2.307-.115 2.307-.115.477-.023.531.661.062.715 0 0-.47.062-1 .085l3.17 9.4 1.9-5.692-1.355-3.708a15.49 15.49 0 0 1-.907-.077c-.47-.03-.416-.746.053-.723 0 0 1.431.115 2.285.115.908 0 2.308-.115 2.308-.115.469-.023.53.661.061.715 0 0-.469.054-1 .085Zm3.17 11.569a8.676 8.676 0 0 0 3.253-11.662 8.192 8.192 0 0 1-.6 4L16.361 19.5ZM12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20Z"/>'
      }, props)
  }
  export function RiLogosWordpressLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-7.394 7.566-2.155-5.985-2.181 6.232a8.03 8.03 0 0 0 4.336-.247Zm2.468-1.38A7.984 7.984 0 0 0 20 12a7.981 7.981 0 0 0-.545-2.908c-.25 1.454-.692 3.35-.976 4.315l-1.405 4.778Zm-.201-12.531A7.965 7.965 0 0 0 12 4a7.985 7.985 0 0 0-6.245 3h1.39v2h-.75l2.755 7.958 2.227-6.362L10.802 9H8.645V7h5v2h-.717l2.621 7.282 1.012-3.44c.523-1.832.092-2.631-.339-3.429-.289-.534-.577-1.068-.577-1.913a2 2 0 0 1 1.228-1.845ZM4.425 9.42A7.99 7.99 0 0 0 4 12a7.993 7.993 0 0 0 3.64 6.708L4.425 9.421Z"/>'
      }, props)
  }
  export function RiLogosXboxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.42 19.527A9.956 9.956 0 0 0 12 22a9.967 9.967 0 0 0 6.585-2.473c1.564-1.593-3.597-7.257-6.585-9.514-2.985 2.257-8.15 7.921-6.582 9.514Zm9.3-12.005c2.083 2.468 6.236 8.595 5.063 10.76A9.952 9.952 0 0 0 22 12.003a9.958 9.958 0 0 0-2.975-7.113s-.023-.018-.068-.035a.686.686 0 0 0-.234-.038c-.494 0-1.655.362-4.005 2.705ZM5.045 4.856c-.048.017-.068.034-.072.035a9.963 9.963 0 0 0-2.973 7.113c0 2.379.832 4.561 2.217 6.278C3.051 16.11 7.201 9.988 9.285 7.523 6.935 5.178 5.772 4.818 5.28 4.818a.604.604 0 0 0-.234.039v-.002Zm6.955.104s-2.454-1.436-4.37-1.504c-.753-.027-1.213.246-1.268.282C8.15 2.538 10.05 2 11.988 2H12c1.945 0 3.838.538 5.638 1.737-.056-.038-.512-.31-1.266-.282-1.917.068-4.372 1.5-4.372 1.5v.004Z"/>'
      }, props)
  }
  export function RiLogosXboxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.798 15.485c1.123-2.52 3.2-5.44 4.487-6.962-1.248-1.246-2.162-1.931-2.818-2.3A7.977 7.977 0 0 0 4.001 12c0 1.25.286 2.432.797 3.485Zm4.051-10.84c1.6.406 3.152 1.314 3.152 1.314v-.005s1.552-.904 3.151-1.31A7.974 7.974 0 0 0 12.001 4c-1.12 0-2.185.23-3.152.645Zm8.686 1.578c-.655.37-1.568 1.055-2.816 2.3 1.287 1.523 3.362 4.441 4.486 6.961A7.968 7.968 0 0 0 20 12c0-2.27-.946-4.32-2.466-5.777Zm.408 11.134c-1.403-2.237-4.09-4.945-5.942-6.344-1.85 1.4-4.539 4.108-5.941 6.345A7.98 7.98 0 0 0 12 20a7.98 7.98 0 0 0 5.942-2.643ZM12.001 22c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Z"/>'
      }, props)
  }
  export function RiLogosXingFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.462 3.23c.154 0 .308.077.384.154a.49.49 0 0 1 0 .462l-6.076 10.77 3.846 7.076a.49.49 0 0 1 0 .462.587.587 0 0 1-.385.153h-2.77c-.384 0-.614-.307-.768-.538l-3.923-7.154C11 14.307 16.924 3.77 16.924 3.77c.153-.308.384-.539.769-.539h2.769ZM8.923 7c.385 0 .616.307.77.538l1.923 3.308c-.154.154-3 5.23-3 5.23-.154.231-.385.54-.77.54H5.155a.587.587 0 0 1-.384-.155.49.49 0 0 1 0-.461l2.846-5.154-1.846-3.23a.49.49 0 0 1 0-.462A.588.588 0 0 1 6.154 7h2.77Z"/>'
      }, props)
  }
  export function RiLogosXingLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.444 3.5 13.81 14.99 17.857 22h-2.31l-4.045-7.009H11.5L18.134 3.5h2.31ZM8.31 7l2.422 4.196-.002.001L7.67 16.5H5.36l3.061-5.305L6.002 7H8.31Z"/>'
      }, props)
  }
  export function RiLogosYoutubeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.244 4c.534.003 1.87.016 3.29.073l.504.022c1.429.067 2.857.183 3.566.38.945.266 1.687 1.04 1.938 2.022.4 1.56.45 4.602.456 5.339l.001.152v.174c-.007.737-.057 3.78-.457 5.339-.254.985-.997 1.76-1.938 2.022-.709.197-2.137.313-3.566.38l-.504.023c-1.42.056-2.756.07-3.29.072l-.235.001h-.255c-1.13-.007-5.856-.058-7.36-.476-.944-.266-1.687-1.04-1.938-2.022-.4-1.56-.45-4.602-.456-5.339v-.326c.006-.737.056-3.78.456-5.339.254-.985.997-1.76 1.939-2.021 1.503-.419 6.23-.47 7.36-.476h.489ZM9.999 8.5v7l6-3.5-6-3.5Z"/>'
      }, props)
  }
  export function RiLogosYoutubeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.607 6.995c-.076-.298-.292-.523-.539-.592C18.63 6.28 16.501 6 12.001 6s-6.628.28-7.069.403c-.244.068-.46.293-.537.592-.109.424-.394 2.2-.394 5.005 0 2.804.285 4.58.394 5.006.076.297.292.522.538.59C5.373 17.72 7.5 18 12 18s6.629-.28 7.069-.403c.244-.068.46-.293.537-.592C19.716 16.581 20 14.8 20 12s-.285-4.58-.394-5.005Zm1.937-.497c.457 1.782.457 5.502.457 5.502s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.897 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.108 4 12.001 4 12.001 4s5.896 0 7.605.476c.944.266 1.687 1.04 1.938 2.022ZM10.001 15.5v-7l6 3.5-6 3.5Z"/>'
      }, props)
  }
  export function RiLogosYuqueFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.28 2.955c2.97.203 3.756 2.342 3.84 2.597l1.297.096c.13 0 .169.18.054.236-1.323.716-1.727 2.17-1.49 3.118.09.358.254.69.412 1.02.307.642.651 1.418.707 2.981.117 3.24-2.51 6.175-5.789 6.593 1.17-1.187 1.815-2.444 2.12-3.375.606-1.846.508-3.316.055-4.44a4.458 4.458 0 0 0-1.782-2.141c-1.683-1.02-3.22-1.09-4.444-.762.465-.594.876-1.201 1.2-1.864.584-1.65-.102-2.848-.704-3.519-.192-.246-.061-.655.305-.655 1.41 0 2.813.02 4.22.115ZM3.32 19.107c1.924-2.202 4.712-5.394 7.162-8.15.559-.63 2.769-2.338 5.748-.533.878.532 2.43 2.165 1.332 5.51-.803 2.446-4.408 7.796-15.76 5.844-.227-.039-.511-.354-.218-.688.415-.472 1.015-1.158 1.736-1.983Z"/>'
      }, props)
  }
  export function RiLogosYuqueLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.505 3.043a.917.917 0 0 1 .795-.459c1.547 0 3.09.049 4.637.153 2.51.172 3.7 1.591 4.18 2.431.596.092 1.388.088 1.571.806.14.552-.217.834-.554 1.149-.483.45-1.133 1.176-.954 1.887.055.222.159.438.316.765l.002.004c.318.667.684 1.51.742 3.115.156 4.34-3.596 6.896-7.252 7.079-2.41 1.816-6.345 3.025-12.557 1.957a1.328 1.328 0 0 1-.945-.708 1.245 1.245 0 0 1-.12-.736c.039-.275.165-.51.33-.699 3.228-3.675 6.635-7.246 9.654-11.098.526-.671.96-1.28 1.15-1.648.309-.92-.009-1.444-.625-2.463-.282-.467-.69-.978-.37-1.535Zm1.989 5.844c.874.005 1.85.248 2.885.875 2.124 1.287 2.334 3.996 1.625 6.157a7.62 7.62 0 0 1-.836 1.726c1.936-.796 3.319-2.483 3.24-4.685-.047-1.28-.317-1.872-.564-2.39l-.03-.06c-.132-.277-.31-.646-.412-1.054-.271-1.08.175-2.039.614-2.677a.917.917 0 0 1-.387-.493v-.002a2.578 2.578 0 0 0-.58-.816c-.407-.394-1.094-.824-2.236-.902a65.316 65.316 0 0 0-2.89-.13c.452.879.758 1.941.289 3.268-.151.425-.46.819-.718 1.183Zm-.832 1.944c-.719.203-1.214.63-1.378.815-2.717 3.057-5.881 6.69-7.576 8.627 5.45.748 8.601-.49 10.378-1.921 1.295-1.044 1.925-2.24 2.176-3.005.434-1.323.537-3.186-.834-4.017-1.153-.7-2.088-.69-2.766-.499Z"/>'
      }, props)
  }
  export function RiLogosZcoolFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.903 21.839a7.903 7.903 0 0 1-7.902-7.903c0-3.646 2.467-6.876 5.824-7.627C11.746 5.43 13.529 4.742 14.902 2c.998 1.935.323 3.71 0 4.677 4.698-1.129 6.371-3.28 6.774-3.548 0 3.952-1.231 6.452-2.419 8.065 1.476-.056 2.009-.484 2.744-.587-.325 1.448-1.501 3.49-4.331 4.795a7.905 7.905 0 0 1-7.767 6.437Zm3.71-6.452c0 .323-.053.484-.403.484l-3.15.002 2.96-3.248c.86-.86.86-1.29.86-2.388 0-.334-.048-.717.048-1.05.047-.144-.048-.192-.191-.144-.335.095-.908.095-1.863.095H7.576c-.239 0-.335-.143-.239-.334 0-.048 0-.191-.096-.191-.62.286-.764 1.576-.716 2.388 0 .43.239.669.573.669h3.391l-3.486 3.725c-.24.287-.478.669-.478 1.194v1.051c0 .478.287.764.812.86h5.988c.555 0 .933-.233.933-.855v-1.129c0-.208 0-.968-.645-1.129Z"/>'
      }, props)
  }
  export function RiLogosZcoolLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.262 8.26C5.838 8.803 4 11.208 4 13.935a5.903 5.903 0 0 0 11.703 1.098 2 2 0 0 1 1.129-1.447c.482-.223.91-.474 1.284-.744-.863-.603-1.186-1.862-.47-2.834a9.8 9.8 0 0 0 1.391-2.651c-1.084.51-2.3.936-3.668 1.265-1.261.303-2.392-.638-2.466-1.814-1.18.572-2.67 1.01-4.642 1.452Zm10.995 2.934c1.166 0 1.916-.424 2.744-.587-.325 1.448-1.501 3.49-4.331 4.795a7.903 7.903 0 0 1-15.669-1.466c0-3.646 2.467-6.876 5.824-7.627C11.746 5.43 13.529 4.742 14.902 2c.689 1.333.689 2.892 0 4.677 2.816-.67 5.074-1.852 6.774-3.548 0 4.802-1.822 7.186-2.419 8.065Zm-5.84 3.932c.584.146.584.832.584 1.02v1.021c0 .562-.342.773-.844.773H7.743c-.475-.086-.734-.345-.734-.777v-.95c0-.475.216-.82.431-1.08l3.153-3.369H7.527c-.302 0-.518-.216-.518-.604-.044-.735.086-1.9.647-2.16.087 0 .087.13.087.173-.087.173 0 .302.216.302h3.886c.864 0 1.382 0 1.685-.086.13-.043.216 0 .173.13-.087.302-.044.647-.044.95 0 .993 0 1.382-.777 2.159l-2.678 2.937 2.85-.002c.316 0 .364-.146.364-.437Z"/>'
      }, props)
  }
  export function RiLogosZhihuFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.373 18.897h1.453l.478 1.637 2.604-1.637h3.071V5.395h-7.605v13.502ZM14.92 6.861h4.515v10.57h-1.732l-1.73 1.088-.315-1.085-.738-.002V6.86Zm-2.83 4.712H8.846a70.3 70.3 0 0 0 .136-4.56h3.172s.122-1.4-.532-1.383H6.135c.217-.815.488-1.655.814-2.525 0 0-1.493 0-2.001 1.34-.21.551-.82 2.677-1.903 4.848.365-.04 1.573-.074 2.284-1.379.13-.365.156-.413.318-.902h1.79c0 .652-.074 4.152-.105 4.559h-3.24c-.728 0-.964 1.466-.964 1.466h4.065c-.272 3.094-1.737 5.702-4.392 7.764 1.27.363 2.536-.058 3.162-.615 0 0 1.425-1.297 2.206-4.298l3.345 4.03s.491-1.668-.076-2.481c-.47-.554-1.74-2.052-2.281-2.595l-.907.72c.27-.867.433-1.71.488-2.524h3.822s-.005-1.466-.47-1.466v.001Z"/>'
      }, props)
  }
  export function RiLogosZhihuLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.345 17.963-1.688 1.074-2.132-3.35c-.44 1.402-1.171 2.665-2.138 3.825-.402.483-.82.918-1.301 1.376-.155.146-.775.716-.878.82l-1.414-1.415c.139-.139.787-.735.914-.856.43-.408.796-.79 1.143-1.205C6.117 16.712 6.88 15.02 6.988 13H3v-2h4V7h-.868c-.689 1.266-1.558 2.222-2.618 2.858L2.486 8.143c1.396-.838 2.426-2.603 3.039-5.36l1.952.434c-.14.633-.303 1.228-.489 1.783h4.513v2H9v4h2.5v2H9.186l3.159 4.963Zm3.838-.07L17.3 17h1.702V7h-4v10h.736l.446.893ZM13.001 5h8v14h-3l-2.5 2-1-2H13V5Z"/>'
      }, props)
  }
  export function RiMapAnchorFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 9.874v10.054c3.619-.454 6.487-3.336 6.938-6.972H17L20.704 7A10.042 10.042 0 0 1 22 11.95C22 17.5 17.523 22 12 22S2 17.5 2 11.95c0-1.8.471-3.489 1.296-4.95L7 12.956H4.062c.451 3.636 3.32 6.518 6.938 6.972V9.874A4.002 4.002 0 0 1 12 2a4 4 0 0 1 1 7.874ZM12 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapAnchorLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.05 11H7v2H4.062A8.004 8.004 0 0 0 11 19.938V9.874A4.002 4.002 0 0 1 12 2a4 4 0 0 1 1 7.874v10.064A8.004 8.004 0 0 0 19.938 13H17v-2h4.95c.033.329.05.662.05 1 0 5.523-4.477 10-10 10S2 17.523 2 12c0-.338.017-.671.05-1ZM12 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapBarricadeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.556 19H21v2H3v-2h1.444l.89-4h13.333l.889 4ZM17.333 9l.89 4H5.777l.889-4h10.666Zm-.444-2H7.11l.715-3.217A1 1 0 0 1 8.802 3h6.396a1 1 0 0 1 .976.783L16.889 7Z"/>'
      }, props)
  }
  export function RiMapBarricadeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.493 19h11.014l-.667-3H7.16l-.667 3Zm13.063 0H21v2H3v-2h1.444L7.826 3.783A1 1 0 0 1 8.802 3h6.396a1 1 0 0 1 .976.783L19.556 19ZM7.604 14h8.792l-.89-4H8.494l-.889 4Zm1.334-6h6.124l-.666-3H9.604l-.666 3Z"/>'
      }, props)
  }
  export function RiMapBikeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.5 12H4V7H2V5h6v2H6v2.796l9.813-2.63L15.233 5H12V3h3.978a1 1 0 0 1 .988.741l1.553 5.796-1.932.518-.256-.957L5.5 12ZM5 21a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm13 3a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0-4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiMapBikeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.5 12H4V7H2V5h6v2H6v2.796l9.813-2.63L15.233 5H12V3h3.978a1 1 0 0 1 .988.741l1.553 5.796-1.932.518-.256-.957L5.5 12ZM5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm13-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z"/>'
      }, props)
  }
  export function RiMapBus2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 20H7v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9H2V8h1V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3h1v4h-1v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1ZM5 5v7h14V5H5Zm2.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiMapBus2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 20H7v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9H2V8h1V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3h1v4h-1v9a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1ZM5 5v6h14V5H5Zm14 8H5v5h14v-5ZM7.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMapBusFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 20H7v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1H3v-8H2V8h1V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3h1v4h-1v8h-1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM5 5v9h14V5H5Zm0 11v2h4v-2H5Zm10 0v2h4v-2h-4Z"/>'
      }, props)
  }
  export function RiMapBusLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 20H7v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1H3v-8H2V8h1V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3h1v4h-1v8h-1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1Zm2-8V5H5v7h14Zm0 2H5v4h14v-4ZM6 15h4v2H6v-2Zm8 0h4v2h-4v-2Z"/>'
      }, props)
  }
  export function RiMapBusWifiFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3v2H5v9h14v-2h2v8h-1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H7v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1H3v-8H2V8h1V5a2 2 0 0 1 2-2h7ZM9 16H5v2h4v-2Zm10 0h-4v2h4v-2Zm-.5-15a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a1.994 1.994 0 0 0-1.413-.585Zm0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165.944.942a3.323 3.323 0 0 1 2.357-.977 3.32 3.32 0 0 1 2.201.83l.156.147.943-.943A4.652 4.652 0 0 0 18.5 3.5Z"/>'
      }, props)
  }
  export function RiMapBusWifiLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3v2H5v7h16v8h-1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H7v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1H3v-8H2V8h1V5a2 2 0 0 1 2-2h7Zm7 11H5v4h14v-4Zm-9 1v2H6v-2h4Zm8 0v2h-4v-2h4Zm.5-14a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a1.994 1.994 0 0 0-1.413-.585Zm0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165.944.942a3.323 3.323 0 0 1 2.357-.977 3.32 3.32 0 0 1 2.201.83l.156.147.943-.943A4.652 4.652 0 0 0 18.5 3.5Z"/>'
      }, props)
  }
  export function RiMapCarFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 20H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9l2.513-6.702A2 2 0 0 1 6.386 4h11.228a2 2 0 0 1 1.873 1.298L22 12v9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM4.136 12h15.728l-2.25-6H6.386l-2.25 6ZM6.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm11 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiMapCarLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 20H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V11l2.48-5.788A2 2 0 0 1 6.32 4H17.68a2 2 0 0 1 1.838 1.212L22 11v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1Zm1-7H4v5h16v-5ZM4.176 11h15.648l-2.143-5H6.32l-2.143 5ZM6.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm11 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMapCarWashingFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 21H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9l2.417-4.029a2 2 0 0 1 1.715-.97h11.736a2 2 0 0 1 1.715.97L22 13.001v9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1ZM4.332 13h15.336l-1.8-3H6.132l-1.8 3ZM6.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm11 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM5.44 3.44 6.5 2.379l1.06 1.06a1.5 1.5 0 1 1-2.121 0Zm5.5 0L12 2.379l1.06 1.06a1.5 1.5 0 1 1-2.121 0Zm5.5 0 1.06-1.061 1.06 1.06a1.5 1.5 0 1 1-2.121 0Z"/>'
      }, props)
  }
  export function RiMapCarWashingLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 21H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V12l2.417-4.029a2 2 0 0 1 1.715-.97h11.736a2 2 0 0 1 1.715.97L22 12.001v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1Zm1-7H4v5h16v-5ZM4.332 12h15.336l-1.8-3H6.132l-1.8 3ZM5.44 3.44 6.5 2.379l1.06 1.06a1.5 1.5 0 1 1-2.121 0Zm5.5 0L12 2.379l1.06 1.06a1.5 1.5 0 1 1-2.121 0Zm5.5 0L17.5 2.379l1.06 1.06a1.5 1.5 0 1 1-2.121 0ZM6.5 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm11 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMapCaravanFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.172 3a2 2 0 0 1 1.414.586l4.828 4.828A2 2 0 0 1 21 9.828V17h2v2h-8.126a4.002 4.002 0 0 1-7.748 0H3a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2h10.172ZM11 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm3-9H6v6h8V7Zm-2 2v2H8V9h4Z"/>'
      }, props)
  }
  export function RiMapCaravanLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.172 3a2 2 0 0 1 1.414.586l4.828 4.828A2 2 0 0 1 21 9.828V17h2v2h-8.126a4.002 4.002 0 0 1-7.748 0H3a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2h10.172ZM11 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm3.172-11H4v12h3.126a4.002 4.002 0 0 1 7.748 0H19V9.828L14.172 5ZM14 7v6H6V7h8Zm-2 2H8v2h4V9Z"/>'
      }, props)
  }
  export function RiMapChargingPile2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 11h-1V7h1V4h2v3h1v4h-1v7a3 3 0 1 1-6 0v-4h-2v5h1v2H2v-2h1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0v-7ZM9 11V7l-4 6h3v4l4-6H9Z"/>'
      }, props)
  }
  export function RiMapChargingPile2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 11h-1V7h1V4h2v3h1v4h-1v7a3 3 0 1 1-6 0v-4h-2v5h1v2H2v-2h1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0v-7Zm-8 8V5H5v14h7Zm-3-8h3l-4 6v-4H5l4-6v4Z"/>'
      }, props)
  }
  export function RiMapChargingPileFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 19V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0v-7h-2a1 1 0 0 1-1-1V6.414l-1.657-1.657 1.414-1.414 4.95 4.95A.997.997 0 0 1 22 9v9a3 3 0 1 1-6 0v-4h-2v5h1v2H2v-2h1Zm6-8V7l-4 6h3v4l4-6H9Z"/>'
      }, props)
  }
  export function RiMapChargingPileLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 19h1v2H2v-2h1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0v-7h-2a1 1 0 0 1-1-1V6.414l-1.657-1.657 1.414-1.414 4.95 4.95A.997.997 0 0 1 22 9v9a3 3 0 1 1-6 0v-4h-2v5Zm-9 0h7V5H5v14Zm4-8h3l-4 6v-4H5l4-6v4Z"/>'
      }, props)
  }
  export function RiMapChinaRailwayFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 19v-6l-2-1V9h6v3l-2 1v6l5 1v2H6v-2l5-1ZM10 2.223V1h4v1.223a9.003 9.003 0 0 1 2.993 16.266l-1.11-1.664a7 7 0 1 0-7.767 0l-1.109 1.664A9.003 9.003 0 0 1 10 2.223Z"/>'
      }, props)
  }
  export function RiMapChinaRailwayLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 20v-7H9v-3h6v3h-2v7h5v2H6v-2h5ZM10 2.223V1h4v1.223a9.003 9.003 0 0 1 2.993 16.266l-1.11-1.664a7 7 0 1 0-7.767 0l-1.109 1.664A9.003 9.003 0 0 1 10 2.223Z"/>'
      }, props)
  }
  export function RiMapCompass2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.328 4.258 10.586 12 12 13.414l7.742-7.742A9.957 9.957 0 0 1 22 12c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2c2.4 0 4.604.847 6.328 2.258Z"/>'
      }, props)
  }
  export function RiMapCompass2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.625 3.133-1.5 1.5A7.98 7.98 0 0 0 12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8a7.979 7.979 0 0 0-.633-3.125l1.5-1.5A9.951 9.951 0 0 1 22 12c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2c1.668 0 3.242.41 4.625 1.133Zm1.739 1.089 1.414 1.414L12 13.414 10.586 12l7.778-7.778Z"/>'
      }, props)
  }
  export function RiMapCompass3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm4.5-14.5L10 10l-2.5 6.5L14 14l2.5-6.5ZM12 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/>'
      }, props)
  }
  export function RiMapCompass3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm4.5-12.5L14 14l-6.5 2.5L10 10l6.5-2.5ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiMapCompass4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm3.446-12.032a4.02 4.02 0 0 0-1.414-1.414l-5.478 5.478a4.02 4.02 0 0 0 1.414 1.414l5.478-5.478Z"/>'
      }, props)
  }
  export function RiMapCompass4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.446-10.032-5.478 5.478a4.02 4.02 0 0 1-1.414-1.414l5.478-5.478a4.02 4.02 0 0 1 1.414 1.414Z"/>'
      }, props)
  }
  export function RiMapCompassDiscoverFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 22C7.477 22 3 17.523 3 12S7.477 2 13 2s10 4.477 10 10-4.477 10-10 10ZM8 11.5l4 1.5 1.5 4.002L17 8l-9 3.5Z"/>'
      }, props)
  }
  export function RiMapCompassDiscoverLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-5-8.5L16 8l-3.5 9.002L11 13l-4-1.5Z"/>'
      }, props)
  }
  export function RiMapCompassFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm3.5-13.5-5 2-2 5 5-2 2-5Z"/>'
      }, props)
  }
  export function RiMapCompassLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.5-11.5-2 5-5 2 2-5 5-2Z"/>'
      }, props)
  }
  export function RiMapCupFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 3h15a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V4a1 1 0 0 1 1-1Zm13 2v3h2V5h-2ZM2 19h18v2H2v-2Z"/>'
      }, props)
  }
  export function RiMapCupLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 13V5H6v8a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2ZM5 3h15a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V4a1 1 0 0 1 1-1Zm13 2v3h2V5h-2ZM2 19h18v2H2v-2Z"/>'
      }, props)
  }
  export function RiMapDirectionFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 10a1 1 0 0 0-1 1v4h2v-3h3v2.5l3.5-3.5L13 7.5V10H9Zm3.707-8.607 9.9 9.9a1 1 0 0 1 0 1.414l-9.9 9.9a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414l9.9-9.9a1 1 0 0 1 1.414 0Z"/>'
      }, props)
  }
  export function RiMapDirectionLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3.515 3.515 12 12 20.485 20.485 12 12 3.515Zm.707-2.122 9.9 9.9a1 1 0 0 1 0 1.414l-9.9 9.9a1 1 0 0 1-1.414 0l-9.9-9.9a1 1 0 0 1 0-1.414l9.9-9.9a1 1 0 0 1 1.414 0ZM13 10V7.5l3.5 3.5-3.5 3.5V12h-3v3H8v-4a1 1 0 0 1 1-1h4Z"/>'
      }, props)
  }
  export function RiMapEBike2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v1h5v6h-2.019l2.746 7.545A4 4 0 1 1 15.126 19h-4.252a4.002 4.002 0 0 1-7.8-.226A2 2 0 0 1 2 17V7a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3h-3V1h4Zm3 15a2 2 0 1 0 1.88 1.316l-.017-.044A2 2 0 0 0 19 16ZM7 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm2-8H4v2h5V8Zm11-3h-3v2h3V5Z"/>'
      }, props)
  }
  export function RiMapEBike2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v1h5v6h-2.019l2.746 7.544a4 4 0 1 1-7.6 2.456h-4.253a4.002 4.002 0 0 1-7.8-.226A2 2 0 0 1 2 17V7a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V3h-3V1h4ZM7 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12-.001a2 2 0 1 0 1.88 1.316l-.017-.044A2 2 0 0 0 19 16ZM17.853 9H17v3a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3H4v3.354A4.002 4.002 0 0 1 10.874 17h4.252a4.002 4.002 0 0 1 4.568-2.94L17.853 9ZM9 8H4v2h5V8Zm11-3h-3v2h3V5Z"/>'
      }, props)
  }
  export function RiMapEBikeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.5 6.937A6.997 6.997 0 0 1 19 13v8h-4.17a3.001 3.001 0 0 1-5.66 0H5v-8a6.997 6.997 0 0 1 3.5-6.063A3.974 3.974 0 0 1 8.125 6H5V4h3.126a4.002 4.002 0 0 1 7.748 0H19v2h-3.126c-.085.33-.212.645-.373.937ZM12 14a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1Zm0-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapEBikeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.5 6.937A6.997 6.997 0 0 1 19 13v8h-4.17a3.001 3.001 0 0 1-5.66 0H5v-8a6.997 6.997 0 0 1 3.5-6.063A3.974 3.974 0 0 1 8.125 6H5V4h3.126a4.002 4.002 0 0 1 7.748 0H19v2h-3.126c-.085.33-.212.645-.373.937Zm-1.453 1.5C13.448 8.795 12.748 9 12 9a3.982 3.982 0 0 1-2.047-.563A5.001 5.001 0 0 0 7 13v6h2v-4a3 3 0 1 1 6 0v4h2v-6a5.001 5.001 0 0 0-2.953-4.563ZM12 14a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-5a1 1 0 0 0-1-1Zm0-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapEarthFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm4.004 10.878c-.345-.525-.594-.903-1.542-.753-1.79.284-1.989.597-2.074 1.113l-.024.156-.025.166c-.097.683-.094.941.22 1.27 1.265 1.328 2.023 2.285 2.253 2.845.112.273.4 1.1.202 1.918a8.185 8.185 0 0 0 3.151-2.237c.11-.374.19-.84.19-1.404v-.105c0-.922 0-1.343-.652-1.716a7.354 7.354 0 0 0-.645-.325c-.367-.167-.61-.276-.938-.756-.04-.057-.078-.114-.116-.172ZM12 3.833c-2.317 0-4.41.966-5.896 2.516.177.123.331.296.437.534.204.457.204.928.204 1.345 0 .328 0 .64.105.865.144.308.766.44 1.315.554.197.042.399.084.583.135.506.14.898.595 1.211.96.13.151.323.374.42.43.05-.036.211-.211.29-.498.062-.22.044-.414-.045-.52-.56-.66-.529-1.93-.356-2.399.272-.739 1.122-.684 1.744-.644.232.015.45.03.614.009.622-.078.814-1.025.949-1.21.292-.4 1.186-1.003 1.74-1.375A8.138 8.138 0 0 0 12 3.833Z"/>'
      }, props)
  }
  export function RiMapEarthLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.235 6.453a8 8 0 0 0 8.817 12.944c.115-.75-.137-1.47-.24-1.722-.23-.56-.988-1.517-2.253-2.844-.338-.355-.316-.627-.195-1.437l.013-.091c.082-.554.22-.882 2.085-1.178.948-.15 1.197.228 1.542.753l.116.172c.328.48.571.59.938.756.165.075.37.17.645.325.652.373.652.794.652 1.716v.105c0 .391-.038.735-.098 1.034a8.002 8.002 0 0 0-3.105-12.341c-.553.373-1.312.902-1.577 1.265-.135.185-.327 1.132-.95 1.21-.162.02-.381.006-.613-.009-.622-.04-1.472-.095-1.744.644-.173.468-.203 1.74.356 2.4.09.105.107.3.046.519-.08.287-.241.462-.292.498-.096-.056-.288-.279-.419-.43-.313-.366-.705-.82-1.211-.96-.184-.051-.386-.093-.583-.135-.549-.115-1.17-.246-1.315-.554-.106-.226-.105-.537-.105-.865 0-.417 0-.888-.204-1.345a1.276 1.276 0 0 0-.306-.43ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z"/>'
      }, props)
  }
  export function RiMapFlightLandFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.949 14.888a1.5 1.5 0 0 1-1.837 1.06L3.445 11.752a1 1 0 0 1-.74-.983l.09-5.403 1.449.388.915 3.351 5.095 1.366-.37-8.382 1.933.518 2.81 9.035 5.261 1.41a1.5 1.5 0 0 1 1.061 1.837ZM4 19h16v2H4v-2Z"/>'
      }, props)
  }
  export function RiMapFlightLandLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.949 14.888a1.5 1.5 0 0 1-1.837 1.06L3.445 11.752a1 1 0 0 1-.74-.983l.09-5.403 1.449.388.915 3.351 5.095 1.366-.37-8.382 1.933.518 2.81 9.035 5.261 1.41a1.5 1.5 0 0 1 1.061 1.837ZM4 19h16v2H4v-2Z"/>'
      }, props)
  }
  export function RiMapFlightTakeoffFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.949 10.112a1.5 1.5 0 0 1-1.06 1.837L5.221 16.147a1 1 0 0 1-1.133-.48l-2.623-4.725 1.449-.389 2.468 2.445 5.095-1.365-4.51-7.074 1.931-.518 6.952 6.42 5.26-1.41a1.5 1.5 0 0 1 1.838 1.061ZM4 19h16v2H4v-2Z"/>'
      }, props)
  }
  export function RiMapFlightTakeoffLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.949 10.112a1.5 1.5 0 0 1-1.06 1.837L5.221 16.147a1 1 0 0 1-1.133-.48l-2.623-4.725 1.449-.389 2.468 2.445 5.095-1.365-4.51-7.074 1.931-.518 6.952 6.42 5.26-1.41a1.5 1.5 0 0 1 1.838 1.061ZM4 19h16v2H4v-2Z"/>'
      }, props)
  }
  export function RiMapFootprintFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 18h5.5v1.25a2.75 2.75 0 1 1-5.5 0V18ZM8 6.12c2 0 3 2.88 3 4.88 0 1-.5 2-1 3.5L9.5 16H4c0-1-.5-2.5-.5-5S5.498 6.12 8 6.12Zm12.054 7.978-.217 1.231a2.75 2.75 0 1 1-5.416-.955l.216-1.23 5.417.954ZM18.178 1.705c2.464.434 4.018 3.124 3.584 5.586-.434 2.462-1.187 3.853-1.36 4.838l-5.417-.955-.232-1.565c-.232-1.564-.55-2.635-.377-3.62.347-1.97 1.832-4.632 3.802-4.284Z"/>'
      }, props)
  }
  export function RiMapFootprintLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 18h5.5v1.25a2.75 2.75 0 1 1-5.5 0V18Zm4.058-4 .045-.133C8.87 11.762 9 11.371 9 11c0-.75-.203-1.643-.528-2.273C8.23 8.257 8.06 8.12 8 8.12c-1.28 0-2.5 1.364-2.5 2.88 0 .959.075 1.773.227 2.758l.038.242h2.293ZM8 6.12c2 0 3 2.88 3 4.88 0 1-.5 2-1 3.5L9.5 16H4c0-1-.5-2.5-.5-5S5.498 6.12 8 6.12Zm12.054 7.978-.217 1.231a2.75 2.75 0 1 1-5.416-.955l.216-1.23 5.417.954Zm-1.05-4.247c.165-.5.301-.894.303-.9.202-.658.361-1.302.485-2.007.263-1.493-.702-3.048-1.962-3.27-.059-.01-.25.095-.57.515-.43.565-.784 1.41-.915 2.147-.058.33-.049.404.27 2.263.045.255.082.486.116.717l.02.138 2.253.397Zm-.826-8.146c2.464.434 4.018 3.124 3.584 5.586-.434 2.462-1.187 3.853-1.36 4.838l-5.417-.955-.232-1.565c-.232-1.564-.55-2.635-.377-3.62.347-1.97 1.832-4.632 3.802-4.284Z"/>'
      }, props)
  }
  export function RiMapGasStationFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 19V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0v-7h-2a1 1 0 0 1-1-1V6.414l-1.657-1.657 1.414-1.414 4.95 4.95A.997.997 0 0 1 22 9v9a3 3 0 1 1-6 0v-4h-2v5h1v2H2v-2h1ZM5 5v6h7V5H5Z"/>'
      }, props)
  }
  export function RiMapGasStationLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 19h1v2H2v-2h1V4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v8h2a2 2 0 0 1 2 2v4a1 1 0 1 0 2 0v-7h-2a1 1 0 0 1-1-1V6.414l-1.657-1.657 1.414-1.414 4.95 4.95A.997.997 0 0 1 22 9v9a3 3 0 1 1-6 0v-4h-2v5Zm-9 0h7v-6H5v6ZM5 5v6h7V5H5Z"/>'
      }, props)
  }
  export function RiMapGlobeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 21h5v2H6v-2h5v-1.05a10.002 10.002 0 0 1-7.684-4.988l1.737-.992A8 8 0 1 0 15.97 3.053l.993-1.737A9.996 9.996 0 0 1 22 10c0 5.185-3.946 9.449-9 9.95V21Zm-1-4a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z"/>'
      }, props)
  }
  export function RiMapGlobeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 21h5v2H6v-2h5v-1.05a10.002 10.002 0 0 1-7.684-4.988l1.737-.992A8 8 0 1 0 15.97 3.053l.993-1.737A9.996 9.996 0 0 1 22 10c0 5.185-3.946 9.449-9 9.95V21Zm-1-4a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm0-2a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"/>'
      }, props)
  }
  export function RiMapGobletFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 19v-5.111L3 5V3h18v2l-8 8.889V19h5v2H6v-2h5ZM7.49 7h9.02l1.8-2H5.69l1.8 2Z"/>'
      }, props)
  }
  export function RiMapGobletLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 19v-5.111L3 5V3h18v2l-8 8.889V19h5v2H6v-2h5ZM7.49 7h9.02l1.8-2H5.69l1.8 2Zm1.8 2L12 12.01 14.71 9H9.29Z"/>'
      }, props)
  }
  export function RiMapGuideFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 8v8a3 3 0 0 1-3 3H7.83a3.001 3.001 0 1 1 0-2H10a1 1 0 0 0 1-1V8a3 3 0 0 1 3-3h3V2l5 4-5 4V7h-3a1 1 0 0 0-1 1Z"/>'
      }, props)
  }
  export function RiMapGuideLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 8v8a3 3 0 0 1-3 3H7.83a3.001 3.001 0 1 1 0-2H10a1 1 0 0 0 1-1V8a3 3 0 0 1 3-3h3V2l5 4-5 4V7h-3a1 1 0 0 0-1 1ZM5 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiMapHotelBedFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 11v9h-2v-3H4v3H2V4h2v10h8V7h6a4 4 0 0 1 4 4ZM8 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiMapHotelBedLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 11v9h-2v-3H4v3H2V4h2v10h8V7h6a4 4 0 0 1 4 4Zm-2 3v-3a2 2 0 0 0-2-2h-4v5h6ZM8 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiMapLifebuoyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM7.197 14.682l-2.175 2.173a8.547 8.547 0 0 0 1.818 1.9l.305.223 2.173-2.175a5.527 5.527 0 0 1-1.98-1.883l-.14-.238Zm9.606 0a5.527 5.527 0 0 1-1.883 1.98l-.238.14 2.173 2.176a8.552 8.552 0 0 0 1.9-1.818l.223-.305-2.175-2.173ZM12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM7.145 5.022a8.549 8.549 0 0 0-1.9 1.818l-.223.305 2.175 2.173a5.527 5.527 0 0 1 1.883-1.98l.238-.14-2.173-2.176Zm9.71 0-2.173 2.175a5.527 5.527 0 0 1 1.98 1.883l.14.238 2.176-2.173a8.548 8.548 0 0 0-1.818-1.9l-.305-.223Z"/>'
      }, props)
  }
  export function RiMapLifebuoyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 15a4.987 4.987 0 0 1-1.828-.345l-2.236 2.237A7.963 7.963 0 0 0 12 20a7.963 7.963 0 0 0 4.064-1.108l-2.236-2.236A4.987 4.987 0 0 1 12 17Zm-8-5c0 1.484.404 2.873 1.108 4.064l2.237-2.236A4.987 4.987 0 0 1 7 12c0-.645.122-1.261.345-1.828L5.108 7.936A7.963 7.963 0 0 0 4 12Zm14.892-4.064-2.236 2.236c.222.567.344 1.183.344 1.828s-.122 1.261-.345 1.828l2.237 2.236A7.963 7.963 0 0 0 20 12a7.963 7.963 0 0 0-1.108-4.064ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0-5a7.963 7.963 0 0 0-4.064 1.108l2.236 2.237A4.987 4.987 0 0 1 12 7c.645 0 1.261.122 1.828.345l2.236-2.237A7.963 7.963 0 0 0 12 4Z"/>'
      }, props)
  }
  export function RiMapLuggageCartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.5 20a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm13 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM2.172 1.758 6 5.586V17h14v2H5a1 1 0 0 1-1-1V6.414L.758 3.172l1.414-1.414ZM16 3a1 1 0 0 1 1 1v2h2.994C20.55 6 21 6.456 21 6.996v8.01a1 1 0 0 1-1.006.994H8.007A1.008 1.008 0 0 1 7 15.005v-8.01A1 1 0 0 1 8.007 6H11V4a1 1 0 0 1 1-1h4Zm-5 5h-1v6h1V8Zm7 0h-1v6h1V8Zm-3-3h-2v1h2V5Z"/>'
      }, props)
  }
  export function RiMapLuggageCartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.5 20a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm13 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM2.172 1.758 6 5.586V17h14v2H5a1 1 0 0 1-1-1V6.414L.758 3.172l1.414-1.414ZM16 3a1 1 0 0 1 1 1v2h2.994C20.55 6 21 6.456 21 6.996v8.01a1 1 0 0 1-1.006.994H8.007A1.008 1.008 0 0 1 7 15.005v-8.01A1 1 0 0 1 8.007 6H11V4a1 1 0 0 1 1-1h4Zm-6 5H9v6h1V8Zm6 0h-4v6h4V8Zm3 0h-1v6h1V8Zm-4-3h-2v1h2V5Z"/>'
      }, props)
  }
  export function RiMapLuggageDepositFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 3a1 1 0 0 1 1 1v2h4a1 1 0 0 1 1 1v12h2v2H1v-2h2V7a1 1 0 0 1 1-1h4V4a1 1 0 0 1 1-1h6Zm-5 5H8v11h2V8Zm6 0h-2v11h2V8Zm-2-3h-4v1h4V5Z"/>'
      }, props)
  }
  export function RiMapLuggageDepositLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 3a1 1 0 0 1 1 1v2h4a1 1 0 0 1 1 1v12h2v2H1v-2h2V7a1 1 0 0 1 1-1h4V4a1 1 0 0 1 1-1h6ZM8 8H5v11h3V8Zm6 0h-4v11h4V8Zm5 0h-3v11h3V8Zm-5-3h-4v1h4V5Z"/>'
      }, props)
  }
  export function RiMapMap2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2 5 7-3 6 3 6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3-6-3-6.303 2.701a.5.5 0 0 1-.697-.46V5Zm13 14.764V7.176l-.065.028L9 4.236v12.588l.065-.028L15 19.764Z"/>'
      }, props)
  }
  export function RiMapMap2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2 5 7-3 6 3 6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3-6-3-6.303 2.701a.5.5 0 0 1-.697-.46V5Zm14 14.395 4-1.714V5.033l-4 1.714v12.648Zm-2-.131V6.736l-4-2v12.528l4 2Zm-6-2.011V4.605L4 6.319v12.648l4-1.714Z"/>'
      }, props)
  }
  export function RiMapMapFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2 5 7-3 6 3 6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3-6-3-6.303 2.701a.5.5 0 0 1-.697-.46V5Z"/>'
      }, props)
  }
  export function RiMapMapLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2 5 7-3 6 3 6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3-6-3-6.303 2.701a.5.5 0 0 1-.697-.46V5Zm12.935 2.204-6-3L4 6.319v12.648l5.065-2.17 6 3L20 17.68V5.033l-5.065 2.17Z"/>'
      }, props)
  }
  export function RiMapMapPin2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.364 17.364 12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0ZM12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapMapPin2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 23.728-6.364-6.364a9 9 0 1 1 12.728 0L12 23.728Zm4.95-7.778a7 7 0 1 0-9.9 0L12 20.9l4.95-4.95ZM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMapMapPin3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 19.945A9.001 9.001 0 0 1 12 2a9 9 0 0 1 1 17.945V24h-2v-4.055Z"/>'
      }, props)
  }
  export function RiMapMapPin3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 19.945A9.001 9.001 0 0 1 12 2a9 9 0 0 1 1 17.945V24h-2v-4.055ZM12 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"/>'
      }, props)
  }
  export function RiMapMapPin4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938V21h-2v-3.062ZM5 22h14v2H5v-2Z"/>'
      }, props)
  }
  export function RiMapMapPin4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938V21h-2v-3.062ZM12 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm-7 6h14v2H5v-2Z"/>'
      }, props)
  }
  export function RiMapMapPin5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.657 15.657 12 21.314l-5.657-5.657a8 8 0 1 1 11.314 0ZM5 22h14v2H5v-2Z"/>'
      }, props)
  }
  export function RiMapMapPin5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 18.485 4.243-4.242a6 6 0 1 0-8.486 0L12 18.485Zm5.657-2.828L12 21.314l-5.657-5.657a8 8 0 1 1 11.314 0ZM5 22h14v2H5v-2Z"/>'
      }, props)
  }
  export function RiMapMapPinAddFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.364 17.364 12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0ZM11 10H8v2h3v3h2v-3h3v-2h-3V7h-2v3Z"/>'
      }, props)
  }
  export function RiMapMapPinAddLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 20.9 4.95-4.95a7 7 0 1 0-9.9 0L12 20.9Zm0 2.828-6.364-6.364a9 9 0 1 1 12.728 0L12 23.728ZM11 10V7h2v3h3v2h-3v3h-2v-3H8v-2h3Z"/>'
      }, props)
  }
  export function RiMapMapPinFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.364 17.364 12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0ZM12 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMapMapPinLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 20.9 4.95-4.95a7 7 0 1 0-9.9 0L12 20.9Zm0 2.828-6.364-6.364a9 9 0 1 1 12.728 0L12 23.728ZM12 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"/>'
      }, props)
  }
  export function RiMapMapPinRangeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938v2.074c3.946.092 7 .723 7 1.488 0 .828-3.582 1.5-8 1.5s-8-.672-8-1.5c0-.765 3.054-1.396 7-1.488v-2.074ZM12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapMapPinRangeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 17.938A8.001 8.001 0 0 1 12 2a8 8 0 0 1 1 15.938v2.074c3.946.092 7 .723 7 1.488 0 .828-3.582 1.5-8 1.5s-8-.672-8-1.5c0-.765 3.054-1.396 7-1.488v-2.074ZM12 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0-4a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMapMapPinTimeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 11V6h-2v7h6v-2h-4Zm5.364 6.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0Z"/>'
      }, props)
  }
  export function RiMapMapPinTimeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.95 15.95a7 7 0 1 0-9.9 0L12 20.9l4.95-4.95ZM12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0L12 23.728ZM13 11h4v2h-6V6h2v5Z"/>'
      }, props)
  }
  export function RiMapMapPinUserFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.084 15.812a7 7 0 1 0-10.168 0A5.996 5.996 0 0 1 12 13a5.996 5.996 0 0 1 5.084 2.812ZM12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0L12 23.728ZM12 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiMapMapPinUserLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.084 15.812a7 7 0 1 0-10.168 0A5.996 5.996 0 0 1 12 13a5.996 5.996 0 0 1 5.084 2.812Zm-8.699 1.473L12 20.899l3.615-3.614a4 4 0 0 0-7.23 0ZM12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0L12 23.728ZM12 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiMapMotorbikeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.365 10 11.2 8h3.492L13.6 5H11V3h4l1.092 3H20v3h-2.816l1.456 4.002a4.5 4.5 0 1 1-1.985.392L15.419 10h-.947l-1.582 5.87-2.925 1.069A4.5 4.5 0 1 1 4 13.256V12H2v-2h6.365ZM5.5 20a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm13 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>'
      }, props)
  }
  export function RiMapMotorbikeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 13.256V12H2v-2h6.365L11.2 8h3.492L13.6 5H11V3h4l1.092 3H20v3h-2.816l1.456 4.002a4.5 4.5 0 1 1-1.985.392L15.419 10h-.947l-1.582 5.87-.002-.001.002.005-2.925 1.065A4.5 4.5 0 1 1 4 13.256Zm2-.229a4.5 4.5 0 0 1 3.281 2.033l1.957-.713L12.403 10h-.547L9 12H6v1.027ZM5.5 20a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm13 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>'
      }, props)
  }
  export function RiMapNavigationFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.9 2.3 21.704 8.57a.5.5 0 0 1 .028.938L13 13l-4.425 8.85a.5.5 0 0 1-.928-.086L2.261 2.912a.5.5 0 0 1 .638-.612Z"/>'
      }, props)
  }
  export function RiMapNavigationLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4.965 5.096 3.546 12.41 3.04-6.08 5.637-2.255L4.965 5.096ZM2.899 2.3l18.806 6.268a.5.5 0 0 1 .028.939L13 13l-4.425 8.85a.5.5 0 0 1-.928-.086L2.261 2.91a.5.5 0 0 1 .638-.611Z"/>'
      }, props)
  }
  export function RiMapOilFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 5h11a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V11l4-6Zm5-4h5a1 1 0 0 1 1 1v2h-7V2a1 1 0 0 1 1-1ZM6 12v7h2v-7H6Z"/>'
      }, props)
  }
  export function RiMapOilLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.07 7 6 11.606V20h12V7H9.07ZM8 5h11a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V11l4-6Zm5-4h5a1 1 0 0 1 1 1v2h-7V2a1 1 0 0 1 1-1ZM8 12h2v6H8v-6Z"/>'
      }, props)
  }
  export function RiMapParkingBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 14h1.5a3.5 3.5 0 1 0 0-7H9v10h2v-3ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm7 6h1.5a1.5 1.5 0 0 1 0 3H11V9Z"/>'
      }, props)
  }
  export function RiMapParkingBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h14V5H5Zm4 2h3.5a3.5 3.5 0 1 1 0 7H11v3H9V7Zm2 2v3h1.5a1.5 1.5 0 0 0 0-3H11Z"/>'
      }, props)
  }
  export function RiMapParkingFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 3h7a6 6 0 0 1 0 12h-3v6H6V3Zm4 4v4h3a2 2 0 1 0 0-4h-3Z"/>'
      }, props)
  }
  export function RiMapParkingLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 3h7a6 6 0 0 1 0 12H8v6H6V3Zm2 2v8h5a4 4 0 0 0 0-8H8Z"/>'
      }, props)
  }
  export function RiMapPassportFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16Zm-4 14H8v2h8v-2ZM12 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"/>'
      }, props)
  }
  export function RiMapPassportLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16Zm-1 2H5v16h14V4Zm-3 12v2H8v-2h8ZM12 6a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>'
      }, props)
  }
  export function RiMapPinDistanceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.39 10.39 7.5 14.277 3.61 10.39a5.5 5.5 0 1 1 7.78 0ZM7.5 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12.89 10.89-3.89 3.888-3.89-3.889a5.5 5.5 0 1 1 7.78 0ZM16.5 17.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapPinDistanceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.975 8.975a3.5 3.5 0 1 0-4.95 0L7.5 11.45l2.475-2.475ZM7.5 14.278 3.61 10.39a5.5 5.5 0 1 1 7.78 0L7.5 14.28ZM7.5 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm9 12.45 2.475-2.475a3.5 3.5 0 1 0-4.95 0L16.5 20.45Zm3.89-1.06-3.89 3.888-3.89-3.889a5.5 5.5 0 1 1 7.78 0ZM16.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMapPlaneFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 8.947 22 14v2l-8-2.526v5.36l3 1.666V22l-4.5-1L8 22v-1.5l3-1.667v-5.36L3 16v-2l8-5.053V3.5a1.5 1.5 0 0 1 3 0v5.447Z"/>'
      }, props)
  }
  export function RiMapPlaneLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 8.947 22 14v2l-8-2.526v5.36l3 1.666V22l-4.5-1L8 22v-1.5l3-1.667v-5.36L3 16v-2l8-5.053V3.5a1.5 1.5 0 0 1 3 0v5.447Z"/>'
      }, props)
  }
  export function RiMapPlanetFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.322 5.966A9.169 9.169 0 0 1 7.2 4.386a4.482 4.482 0 0 0-.844-.157c-.572-.043-.823.093-.93.2-.106.107-.242.357-.2.93.015.183.047.386.097.607Zm15.404 8.245c.061.123.12.245.177.366.476 1.02.791 2.018.859 2.914.067.891-.106 1.82-.78 2.494-.674.674-1.603.847-2.495.78-.78-.06-1.637-.306-2.52-.683h-.003a13.258 13.258 0 0 1-.462-.207c-2.033-.962-4.359-2.654-6.542-4.838-2.181-2.181-3.872-4.505-4.835-6.536-.073-.155-.143-.31-.209-.463l.001-.002c-.379-.885-.626-1.745-.685-2.527-.068-.892.105-1.82.78-2.495.673-.674 1.602-.847 2.494-.78.896.068 1.892.383 2.913.86.124.057.248.117.373.18a8.996 8.996 0 0 1 8.572 2.362 8.996 8.996 0 0 1 2.362 8.575Zm-1.113 2.593a9.035 9.035 0 0 1-1.576 1.871c.218.05.419.082.6.095.573.044.824-.092.93-.2.108-.106.244-.357.2-.93a4.468 4.468 0 0 0-.154-.836Zm-13.977 1.56a8.993 8.993 0 0 1-2.417-8.341c1.082 1.98 2.705 4.1 4.68 6.075 1.977 1.977 4.098 3.6 6.08 4.683a8.993 8.993 0 0 1-8.343-2.417Z"/>'
      }, props)
  }
  export function RiMapPlanetLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.918 8.037A9 9 0 0 0 15.966 20.08c.873.373 1.719.618 2.49.681.902.074 1.844-.096 2.526-.777.752-.752.88-1.816.746-2.812-.123-.91-.48-1.92-1.002-2.962A9 9 0 0 0 9.791 3.273c-1.044-.523-2.055-.881-2.965-1.005-.997-.135-2.062-.007-2.815.746-.682.683-.851 1.626-.777 2.528.064.773.31 1.62.684 2.495Zm1.404-2.071a4.135 4.135 0 0 1-.095-.587c-.048-.587.09-.843.198-.95.12-.12.423-.275 1.132-.179.198.027.413.072.643.135a9.04 9.04 0 0 0-1.878 1.58Zm14.29 10.837a4.9 4.9 0 0 1 .134.637c.096.708-.06 1.011-.178 1.13-.109.108-.364.246-.95.199a4.116 4.116 0 0 1-.581-.094 9.04 9.04 0 0 0 1.575-1.872Zm-3.73 1.023c-1.677-.878-3.625-2.323-5.507-4.205-1.88-1.88-3.324-3.825-4.203-5.5A7.018 7.018 0 0 1 9.97 5.298a7 7 0 0 1 5.912 12.528Zm-2.277.99a7 7 0 0 1-8.42-8.419c.964 1.516 2.25 3.112 3.776 4.638 1.528 1.528 3.126 2.815 4.644 3.78Z"/>'
      }, props)
  }
  export function RiMapPoliceCarFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13.5V21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7.5l-1.243-.31A1 1 0 0 1 0 12.22v-.72a.5.5 0 0 1 .5-.5h1.929L4.48 6.212A2 2 0 0 1 6.319 5H8V3h3v2h2V3h3v2h1.681a2 2 0 0 1 1.838 1.212L21.572 11H23.5a.5.5 0 0 1 .5.5v.72a1 1 0 0 1-.758.97L22 13.5ZM4 15v2a1 1 0 0 0 1 1h3.245a.5.5 0 0 0 .44-.736C7.88 15.754 6.318 15 4 15Zm16 0c-2.317 0-3.879.755-4.686 2.264a.5.5 0 0 0 .441.736H19a1 1 0 0 0 1-1v-2ZM6 7l-1.451 3.629A1 1 0 0 0 5.477 12h13.046a1.001 1.001 0 0 0 .928-1.371L18 7H6Z"/>'
      }, props)
  }
  export function RiMapPoliceCarLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 13v5h16v-5H4Zm1.618-2h12.764a1 1 0 0 0 .894-1.447L18 7H6L4.724 9.553A1 1 0 0 0 5.618 11ZM22 13.5V21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7.5l-1.243-.31A1 1 0 0 1 0 12.22v-.72a.5.5 0 0 1 .5-.5H2l2.447-4.894A2 2 0 0 1 6.237 5H8V3h3v2h2V3h3v2h1.764a2 2 0 0 1 1.789 1.106L22 11h1.5a.5.5 0 0 1 .5.5v.72a1 1 0 0 1-.758.97L22 13.5ZM5 14c2.317 0 3.879.755 4.686 2.264a.5.5 0 0 1-.441.736H6a1 1 0 0 1-1-1v-2Zm14 0v2a1 1 0 0 1-1 1h-3.245a.5.5 0 0 1-.44-.736C15.12 14.754 16.682 14 19 14Z"/>'
      }, props)
  }
  export function RiMapPushpin2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 3v2h-1v6l2 3v2h-6v7h-2v-7H5v-2l2-3V5H6V3h12Z"/>'
      }, props)
  }
  export function RiMapPushpin2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 3v2h-1v6l2 3v2h-6v7h-2v-7H5v-2l2-3V5H6V3h12ZM9 5v6.606L7.404 14h9.192L15 11.606V5H9Z"/>'
      }, props)
  }
  export function RiMapPushpinFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m22.313 10.175-1.415 1.414-.707-.707-4.242 4.243-.707 3.535-1.415 1.415-4.242-4.243-4.95 4.95-1.414-1.414 4.95-4.95-4.243-4.243 1.414-1.414 3.536-.707L13.12 3.81l-.707-.707 1.414-1.414 8.486 8.485Z"/>'
      }, props)
  }
  export function RiMapPushpinLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.827 1.69 8.486 8.485-1.415 1.414-.707-.707-4.242 4.243-.707 3.535-1.415 1.415-4.242-4.243-4.95 4.95-1.414-1.414 4.95-4.95-4.243-4.243 1.414-1.414 3.536-.707L13.12 3.81l-.707-.707 1.414-1.414Zm.707 3.535-4.67 4.671-2.822.565 6.5 6.5.564-2.822 4.671-4.67-4.243-4.244Z"/>'
      }, props)
  }
  export function RiMapRestaurant2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4.222 3.808 6.718 6.717-2.829 2.829-3.889-3.89a4 4 0 0 1 0-5.656Zm10.046 8.339-.853.853 7.07 7.071-1.413 1.414L12 14.415l-7.072 7.07-1.414-1.414 9.339-9.339c-.588-1.457.02-3.555 1.621-5.156 1.953-1.953 4.644-2.428 6.01-1.061 1.368 1.367.893 4.058-1.06 6.01-1.602 1.602-3.7 2.21-5.157 1.622Z"/>'
      }, props)
  }
  export function RiMapRestaurant2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14.268 12.147-.853.853 7.07 7.071-1.413 1.414L12 14.415l-7.072 7.07-1.414-1.414 9.339-9.339c-.588-1.457.02-3.555 1.621-5.156 1.953-1.953 4.644-2.428 6.01-1.061 1.368 1.367.893 4.058-1.06 6.01-1.602 1.602-3.7 2.21-5.157 1.622ZM4.222 3.807l6.718 6.718-2.829 2.829-3.889-3.89a4 4 0 0 1 0-5.656Zm13.789 5.304c1.257-1.257 1.516-2.726 1.06-3.182-.455-.456-1.924-.196-3.181 1.06-1.258 1.258-1.517 2.727-1.061 3.183.456.455 1.925.196 3.182-1.06Z"/>'
      }, props)
  }
  export function RiMapRestaurantFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 2v20h-2v-8h-3V7a5 5 0 0 1 5-5ZM9 13.9V22H7v-8.1A5.002 5.002 0 0 1 3 9V3h2v7h2V3h2v7h2V3h2v6a5.002 5.002 0 0 1-4 4.9Z"/>'
      }, props)
  }
  export function RiMapRestaurantLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 2v20h-2v-7h-4V8a6 6 0 0 1 6-6Zm-2 2.53C18.17 5 17 6.17 17 8v5h2V4.53ZM9 13.9V22H7v-8.1A5.002 5.002 0 0 1 3 9V3h2v7h2V3h2v7h2V3h2v6a5.002 5.002 0 0 1-4 4.9Z"/>'
      }, props)
  }
  export function RiMapRidingFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.5 21a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm13 3a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-6.969-8.203L13 12v6h-2v-5l-2.719-2.266A2 2 0 0 1 8 7.671l2.828-2.828a2 2 0 0 1 2.829 0l1.414 1.414a6.969 6.969 0 0 0 3.917 1.975l-.01 2.015a8.962 8.962 0 0 1-5.321-2.575L11.53 9.797ZM16 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMapRidingLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.5 21a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm13 2a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-7.477-8.695L13 12v6h-2v-5l-2.719-2.266A2 2 0 0 1 8 7.671l2.828-2.828a2 2 0 0 1 2.829 0l1.414 1.414a6.969 6.969 0 0 0 3.917 1.975l-.01 2.015a8.962 8.962 0 0 1-5.321-2.575l-2.634 2.633ZM16 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMapRoadMapFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.95 11.95a6.996 6.996 0 0 0 1.858-6.582l2.495-1.07a.5.5 0 0 1 .697.46V19l-7 3-6-3-6.303 2.701a.5.5 0 0 1-.697-.46V7l3.129-1.341a6.993 6.993 0 0 0 1.921 6.29L12 16.9l4.95-4.95Zm-1.414-1.414L12 14.07l-3.536-3.535a5 5 0 1 1 7.072 0Z"/>'
      }, props)
  }
  export function RiMapRoadMapLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 6.143v12.824l5.065-2.17 6 3L20 17.68V4.857l1.303-.558a.5.5 0 0 1 .697.46V19l-7 3-6-3-6.303 2.701a.5.5 0 0 1-.697-.46V7l2-.857Zm12.243 5.1L12 15.485l-4.243-4.242a6 6 0 1 1 8.486 0ZM12 12.657l2.828-2.829a4 4 0 1 0-5.656 0L12 12.657Z"/>'
      }, props)
  }
  export function RiMapRoadsterFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 13.5V21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7.5l-1.243-.31A1 1 0 0 1 0 12.22v-.72a.5.5 0 0 1 .5-.5h1.875l2.138-5.702A2 2 0 0 1 6.386 4h11.228a2 2 0 0 1 1.873 1.298L21.625 11H23.5a.5.5 0 0 1 .5.5v.72a1 1 0 0 1-.758.97L22 13.5ZM4 15v2a1 1 0 0 0 1 1h3.245a.5.5 0 0 0 .44-.736C7.88 15.754 6.318 15 4 15Zm16 0c-2.317 0-3.879.755-4.686 2.264a.5.5 0 0 0 .441.736H19a1 1 0 0 0 1-1v-2ZM6 6l-1.561 4.684A1 1 0 0 0 5.387 12h13.226a1 1 0 0 0 .948-1.316L18 6H6Z"/>'
      }, props)
  }
  export function RiMapRoadsterLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 20H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7.5l-1.243-.31A1 1 0 0 1 0 12.22v-.72a.5.5 0 0 1 .5-.5H2l2.48-5.788A2 2 0 0 1 6.32 4H17.68a2 2 0 0 1 1.838 1.212L22 11h1.5a.5.5 0 0 1 .5.5v.72a1 1 0 0 1-.758.97L22 13.5V21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1Zm1-2v-5H4v5h16ZM5.477 11h13.046a1.001 1.001 0 0 0 .928-1.371L18 6H6L4.549 9.629A1 1 0 0 0 5.477 11ZM5 14c2.317 0 3.879.755 4.686 2.264a.5.5 0 0 1-.441.736H6a1 1 0 0 1-1-1v-2Zm14 0v2a1 1 0 0 1-1 1h-3.245a.5.5 0 0 1-.44-.736C15.12 14.754 16.682 14 19 14Z"/>'
      }, props)
  }
  export function RiMapRocket2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.498 20.005h7.004A6.522 6.522 0 0 1 12 23.507a6.522 6.522 0 0 1-3.502-3.502ZM18 14.81l2 2.268v1.927H4v-1.927l2-2.268V9.005C6 5.52 8.504 2.558 12 1.46c3.496 1.098 6 4.061 6 7.545v5.804Zm-6-3.805a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapRocket2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.502 20.005A6.522 6.522 0 0 1 12 23.507a6.522 6.522 0 0 1-3.502-3.502h2.26c.326.488.747.912 1.242 1.243.495-.33.916-.755 1.242-1.243h2.26ZM18 14.81l2 2.268v1.927H4v-1.927l2-2.268V9.005C6 5.52 8.504 2.558 12 1.46c3.496 1.098 6 4.061 6 7.545v5.804Zm-.73 2.195L16 15.565v-6.56c0-2.318-1.57-4.43-4-5.421-2.43.99-4 3.103-4 5.42v6.561l-1.27 1.44h10.54Zm-5.27-6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMapRocketFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.33 15.929a13.064 13.064 0 0 1-.33-2.93c0-5.087 2.903-9.436 7-11.181C16.099 3.563 19 7.912 19 13c0 1.01-.114 1.991-.33 2.929l2.02 1.795a.5.5 0 0 1 .097.631l-2.457 4.096a.5.5 0 0 1-.782.096l-2.255-2.254a1 1 0 0 0-.707-.293H9.415a1 1 0 0 0-.707.293l-2.255 2.254a.5.5 0 0 1-.782-.096l-2.457-4.096a.5.5 0 0 1 .096-.63l2.02-1.796Zm6.67-2.93a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapRocketLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 13c0-5.088 2.902-9.437 7-11.182C16.097 3.563 19 7.912 19 13c0 .823-.076 1.626-.221 2.403l1.94 1.832a.5.5 0 0 1 .096.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.235-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.235 2.234a.5.5 0 0 1-.792-.114l-2.496-4.575a.5.5 0 0 1 .096-.603l1.94-1.832C5.076 14.626 5 13.823 5 13Zm1.475 6.695.817-.817A3 3 0 0 1 9.414 18h5.171a3 3 0 0 1 2.122.878l.817.817.982-1.8-1.1-1.038a2 2 0 0 1-.593-1.82A11.11 11.11 0 0 0 17 13c0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.186 2.036a2 2 0 0 1-.593 1.82l-1.1 1.04.982 1.8ZM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMapRouteFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 15V8.5a4.5 4.5 0 0 1 9 0v7a2.5 2.5 0 0 0 5 0V8.83a3.001 3.001 0 1 1 2 0v6.67a4.5 4.5 0 1 1-9 0v-7a2.5 2.5 0 0 0-5 0V15h3l-4 5-4-5h3Z"/>'
      }, props)
  }
  export function RiMapRouteLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 15V8.5a4.5 4.5 0 0 1 9 0v7a2.5 2.5 0 0 0 5 0V8.83a3.001 3.001 0 1 1 2 0v6.67a4.5 4.5 0 1 1-9 0v-7a2.5 2.5 0 0 0-5 0V15h3l-4 5-4-5h3Zm15-8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiMapRunFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.83 8.79 8 9.456V13H6V8.05h.015l5.268-1.918c.244-.093.51-.14.782-.131a2.616 2.616 0 0 1 2.427 1.82c.186.583.356.977.51 1.181A4.992 4.992 0 0 0 19 11v2a6.986 6.986 0 0 1-5.402-2.547l-.581 3.297L15 15.67V23h-2v-5.986l-2.05-1.987-.947 4.298-6.894-1.215.348-1.97 4.924.868L9.83 8.79ZM13.5 5.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMapRunLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.83 8.79 8 9.456V13H6V8.05h.015l5.268-1.918c.244-.093.51-.14.782-.131a2.616 2.616 0 0 1 2.427 1.82c.186.583.356.977.51 1.181A4.992 4.992 0 0 0 19 11v2a6.986 6.986 0 0 1-5.402-2.547l-.697 3.956L15 16.17V23h-2v-5.898l-2.27-1.904-.727 4.127-6.894-1.215.348-1.97 4.924.868L9.83 8.79ZM13.5 5.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMapSailboatFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 18h18a.5.5 0 0 1 .4.8l-2.1 2.8a1 1 0 0 1-.8.4h-13a1 1 0 0 1-.8-.4l-2.1-2.8A.5.5 0 0 1 3 18ZM15 2.425V15a1 1 0 0 1-1 1H4.04a.5.5 0 0 1-.39-.812L14.11 2.113a.5.5 0 0 1 .89.312Z"/>'
      }, props)
  }
  export function RiMapSailboatLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 18h18a.5.5 0 0 1 .4.8l-2.1 2.8a1 1 0 0 1-.8.4h-13a1 1 0 0 1-.8-.4l-2.1-2.8A.5.5 0 0 1 3 18Zm4.161-4H13V6.7L7.161 14ZM15 2.425V15a1 1 0 0 1-1 1H4.04a.5.5 0 0 1-.39-.812L14.11 2.113a.5.5 0 0 1 .89.312Z"/>'
      }, props)
  }
  export function RiMapShip2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 4h5.446a1 1 0 0 1 .848.47L18.75 10h4.408a.5.5 0 0 1 .439.74l-3.937 7.217A4.992 4.992 0 0 1 15 16 4.992 4.992 0 0 1 11 18a4.992 4.992 0 0 1-4-2 4.992 4.992 0 0 1-4.55 1.97l-1.236-6.791A1 1 0 0 1 2.198 10H3V5a1 1 0 0 1 1-1h1V1h4v3Zm-4 6h11.392l-2.5-4H5v4ZM3 20a5.978 5.978 0 0 0 4-1.528A5.978 5.978 0 0 0 11 20a5.978 5.978 0 0 0 4-1.528A5.978 5.978 0 0 0 19 20h2v2h-2a7.963 7.963 0 0 1-4-1.07A7.963 7.963 0 0 1 11 22a7.963 7.963 0 0 1-4-1.07A7.963 7.963 0 0 1 3 22H1v-2h2Z"/>'
      }, props)
  }
  export function RiMapShip2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 4h5.446a1 1 0 0 1 .848.47L18.75 10h4.408a.5.5 0 0 1 .439.74L19.637 18H19a6.01 6.01 0 0 1-1.535-.198L20.63 12H3.4l1.048 5.824A6.012 6.012 0 0 1 3 18h-.545l-1.24-6.821A1 1 0 0 1 2.197 10H3V5a1 1 0 0 1 1-1h1V1h4v3Zm-4 6h11.392l-2.5-4H5v4ZM3 20a5.978 5.978 0 0 0 4-1.528A5.978 5.978 0 0 0 11 20a5.978 5.978 0 0 0 4-1.528A5.978 5.978 0 0 0 19 20h2v2h-2a7.963 7.963 0 0 1-4-1.07A7.963 7.963 0 0 1 11 22a7.963 7.963 0 0 1-4-1.07A7.963 7.963 0 0 1 3 22H1v-2h2Z"/>'
      }, props)
  }
  export function RiMapShipFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 10.4V4a1 1 0 0 1 1-1h5V1h4v2h5a1 1 0 0 1 1 1v6.4l1.086.326a1 1 0 0 1 .683 1.2l-1.517 6.068A4.992 4.992 0 0 1 16 16 4.992 4.992 0 0 1 12 18a4.992 4.992 0 0 1-4-2 4.992 4.992 0 0 1-4.252 1.994l-1.516-6.068a1 1 0 0 1 .682-1.2L4 10.4Zm2-.6L12 8l2.754.826 1.809.543L18 9.8V5H6v4.8ZM4 20a5.978 5.978 0 0 0 4-1.528A5.978 5.978 0 0 0 12 20a5.978 5.978 0 0 0 4-1.528A5.978 5.978 0 0 0 20 20h2v2h-2a7.963 7.963 0 0 1-4-1.07A7.963 7.963 0 0 1 12 22a7.963 7.963 0 0 1-4-1.07A7.963 7.963 0 0 1 4 22H2v-2h2Z"/>'
      }, props)
  }
  export function RiMapShipLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 10.4V4a1 1 0 0 1 1-1h5V1h4v2h5a1 1 0 0 1 1 1v6.4l1.086.326a1 1 0 0 1 .683 1.2l-1.517 6.068a4.99 4.99 0 0 1-1.902-.273l1.25-5.351L12 10l-7.6 2.37 1.25 5.351a4.99 4.99 0 0 1-1.902.273l-1.516-6.068a1 1 0 0 1 .682-1.2L4 10.4Zm2-.6L12 8l6 1.8V5H6v4.8ZM4 20a5.978 5.978 0 0 0 4-1.528A5.978 5.978 0 0 0 12 20a5.978 5.978 0 0 0 4-1.528A5.978 5.978 0 0 0 20 20h2v2h-2a7.963 7.963 0 0 1-4-1.07A7.963 7.963 0 0 1 12 22a7.963 7.963 0 0 1-4-1.07A7.963 7.963 0 0 1 4 22H2v-2h2Z"/>'
      }, props)
  }
  export function RiMapSignalTowerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.116 20.087A9.986 9.986 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.986 9.986 0 0 1-4.116 8.087l-1.015-1.739a8 8 0 1 0-9.738 0l-1.015 1.739Zm2.034-3.485a6 6 0 1 1 7.7 0l-1.03-1.766a4 4 0 1 0-5.64 0l-1.03 1.766ZM11 13h2l1 9h-4l1-9Z"/>'
      }, props)
  }
  export function RiMapSignalTowerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m6.116 20.087 1.015-1.739a8 8 0 1 1 9.738 0l1.015 1.739A9.986 9.986 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.986 9.986 0 0 0 4.116 8.087Zm2.034-3.485a6 6 0 1 1 7.7 0l-1.03-1.766a4 4 0 1 0-5.64 0l-1.03 1.766ZM11 13h2v9h-2v-9Z"/>'
      }, props)
  }
  export function RiMapSpaceShipFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.88 18.05A35.897 35.897 0 0 1 11.41 1.728a.8.8 0 0 1 1.178 0 35.897 35.897 0 0 1 8.531 16.32c-2.141.452-4.34.747-6.584.875L12.447 23.1a.5.5 0 0 1-.894 0l-2.089-4.177a44.015 44.015 0 0 1-6.584-.875ZM12 14.995a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiMapSpaceShipLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.88 18.05A35.897 35.897 0 0 1 11.41 1.728a.8.8 0 0 1 1.178 0 35.897 35.897 0 0 1 8.531 16.32c-2.141.452-4.34.747-6.584.875L12.447 23.1a.5.5 0 0 1-.894 0l-2.089-4.177a44.028 44.028 0 0 1-6.584-.875Zm6.697-1.123 1.158.066L12 19.523l1.265-2.53 1.157-.066a42.139 42.139 0 0 0 4.227-.454 33.914 33.914 0 0 0-6.65-12.387 33.913 33.913 0 0 0-6.648 12.387 42.14 42.14 0 0 0 4.226.454ZM12 14.996a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiMapSteering2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM8 13l-3.938.001A8.004 8.004 0 0 0 11 19.938V16a3 3 0 0 1-3-3Zm11.938.001L16 13a3 3 0 0 1-3 3l.001 3.938a8.004 8.004 0 0 0 6.937-6.937ZM12 4a8.001 8.001 0 0 0-7.938 7H8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h3.938A8.001 8.001 0 0 0 12 4Z"/>'
      }, props)
  }
  export function RiMapSteering2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM8 13l-3.938.001A8.004 8.004 0 0 0 11 19.938V16a3 3 0 0 1-3-3Zm11.938.001L16 13a3 3 0 0 1-3 3l.001 3.938a8.004 8.004 0 0 0 6.937-6.937ZM14 12h-4v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1Zm-2-8a8.001 8.001 0 0 0-7.938 7H8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h3.938A8.001 8.001 0 0 0 12 4Z"/>'
      }, props)
  }
  export function RiMapSteeringFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.8 14.001a10.009 10.009 0 0 1-8.401 7.902v-2.025A8.01 8.01 0 0 0 19.747 14l2.052.001Zm-17.548 0a8.01 8.01 0 0 0 6.247 5.859v2.028a10.01 10.01 0 0 1-8.3-7.887h2.053ZM17.999 11v2h-1a4 4 0 0 0-3.995 3.8L13 17v1h-2v-1a4 4 0 0 0-3.8-3.995L7 13H6v-2h12Zm-6-9c5.186 0 9.45 3.947 9.951 9h-2.012A8.001 8.001 0 0 0 4.06 11H2.05c.502-5.053 4.765-9 9.95-9Z"/>'
      }, props)
  }
  export function RiMapSteeringLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.8 14.001a10.009 10.009 0 0 1-8.401 7.902v-2.025A8.01 8.01 0 0 0 19.747 14l2.052.001Zm-17.548 0a8.01 8.01 0 0 0 6.247 5.859v2.028a10.01 10.01 0 0 1-8.3-7.887h2.053ZM17.999 11v2h-3a2 2 0 0 0-1.994 1.85l-.006.15v3h-2v-3a2 2 0 0 0-1.85-1.995L8.999 13H6v-2h12Zm-6-9c5.186 0 9.45 3.947 9.951 9h-2.012A8.001 8.001 0 0 0 4.06 11H2.05c.502-5.053 4.765-9 9.95-9Z"/>'
      }, props)
  }
  export function RiMapSubwayFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.2 20 1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v11a2 2 0 0 1-2 2h-1.8ZM11 12V5H7a2 2 0 0 0-2 2v5h6Zm2 0h6V7a2 2 0 0 0-2-2h-4v7Zm-5.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiMapSubwayLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.2 20 1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v11a2 2 0 0 1-2 2h-1.8ZM13 5v6h6V7a2 2 0 0 0-2-2h-4Zm-2 0H7a2 2 0 0 0-2 2v4h6V5Zm8 8H5v5h14v-5ZM7.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMapSubwayWifiFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 3v9h8v6a2 2 0 0 1-2 2h-1.8l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h6ZM7.5 15a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm9 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM11 5H7a2 2 0 0 0-1.995 1.85L5 7v5h6V5Zm7.5-4a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a1.994 1.994 0 0 0-1.413-.585Zm0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165.944.942a3.323 3.323 0 0 1 2.357-.977 3.32 3.32 0 0 1 2.201.83l.156.147.943-.943A4.652 4.652 0 0 0 18.5 3.5Z"/>'
      }, props)
  }
  export function RiMapSubwayWifiLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 18a2 2 0 0 1-2 2h-1.8l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h6v8h8v7Zm-2-5H5v5h14v-5ZM7.5 14a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM11 5H7a2 2 0 0 0-1.995 1.85L5 7v4h6V5Zm7.5-4a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a1.994 1.994 0 0 0-1.413-.585Zm0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165.944.942a3.323 3.323 0 0 1 2.357-.977 3.32 3.32 0 0 1 2.201.83l.156.147.943-.943A4.652 4.652 0 0 0 18.5 3.5Z"/>'
      }, props)
  }
  export function RiMapSuitcase2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 23h-2v-1H8v1H6v-1H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3V3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h3a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-1v1ZM10 9H8v9h2V9Zm6 0h-2v9h2V9Zm-2-5h-4v1h4V4Z"/>'
      }, props)
  }
  export function RiMapSuitcase2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 23h-2v-1H8v1H6v-1H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3V3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h3a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-1v1Zm1-16H5v13h14V7Zm-9 2v9H8V9h2Zm6 0v9h-2V9h2Zm-2-5h-4v1h4V4Z"/>'
      }, props)
  }
  export function RiMapSuitcase3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 1a1 1 0 0 1 1 1v5h1V6h2v1h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1v1h-2v-1H7v1H5v-1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6h2v1h1V2a1 1 0 0 1 1-1h6Zm-6 9H7v8h2v-8Zm4 0h-2v8h2v-8Zm4 0h-2v8h2v-8Zm-3-7h-4v4h4V3Z"/>'
      }, props)
  }
  export function RiMapSuitcase3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 1a1 1 0 0 1 1 1v5h1V6h2v1h1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1v1h-2v-1H7v1H5v-1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6h2v1h1V2a1 1 0 0 1 1-1h6Zm4 8H5v10h14V9ZM9 10v8H7v-8h2Zm4 0v8h-2v-8h2Zm4 0v8h-2v-8h2Zm-3-7h-4v4h4V3Z"/>'
      }, props)
  }
  export function RiMapSuitcaseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 3a1 1 0 0 1 1 1v2h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5V4a1 1 0 0 1 1-1h6ZM8 8H6v11h2V8Zm10 0h-2v11h2V8Zm-4-3h-4v1h4V5Z"/>'
      }, props)
  }
  export function RiMapSuitcaseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 3a1 1 0 0 1 1 1v2h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5V4a1 1 0 0 1 1-1h6Zm1 5H8v11h8V8ZM4 8v11h2V8H4Zm10-3h-4v1h4V5Zm4 3v11h2V8h-2Z"/>'
      }, props)
  }
  export function RiMapTakeawayFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v.999L22 3v6l-2.02-.001 2.767 7.596A4 4 0 1 1 15.127 19h-4.253a4.002 4.002 0 0 1-7.8-.227A1.998 1.998 0 0 1 2 17v-5h9a1 1 0 0 0 .883.993L12 13h2a1 1 0 0 0 .993-.883L15 12V3h-3V1h4ZM7 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM10 3a1 1 0 0 1 1 1v7H2V4a1 1 0 0 1 1-1h7Zm10 2h-3v2h3V5ZM9 5H4v1h5V5Z"/>'
      }, props)
  }
  export function RiMapTakeawayLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 1a1 1 0 0 1 1 1v.999L22 3v6l-2.02-.001 2.767 7.596A4 4 0 1 1 15.127 19h-4.253a4.002 4.002 0 0 1-7.8-.227A1.998 1.998 0 0 1 2 17V4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v8a1 1 0 0 0 .883.993L12 13h2a1 1 0 0 0 .993-.883L15 12V3h-3V1h4ZM7 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm12-.001a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-1.148-7H17V12a3 3 0 0 1-3 3h-2a3.001 3.001 0 0 1-2.829-2H4v2.354A4.002 4.002 0 0 1 10.874 17h4.252a4.002 4.002 0 0 1 4.57-2.94l-1.844-5.061ZM9 8H4v3h5V8Zm11-3h-3v2h3V5ZM9 5H4v1h5V5Z"/>'
      }, props)
  }
  export function RiMapTaxiFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12v9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9l2.48-5.788A2 2 0 0 1 6.32 5H9V3h6v2h2.681a2 2 0 0 1 1.838 1.212L22 12ZM4.176 12h15.648l-2.143-5H6.32l-2.143 5ZM6.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm11 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiMapTaxiLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 11v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V11l2.447-4.894A2 2 0 0 1 6.237 5H9V3h6v2h2.764a2 2 0 0 1 1.789 1.106L22 11Zm-2 2H4v5h16v-5ZM4.236 11h15.528l-2-4H6.236l-2 4ZM6.5 17a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm11 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMapTaxiWifiFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3v4H6.319l-2.144 5H22v9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9l2.48-5.788A2 2 0 0 1 6.32 5H9V3h3ZM6.5 14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm11 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm1-13a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a1.994 1.994 0 0 0-1.413-.585Zm0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165.944.942a3.323 3.323 0 0 1 2.357-.977 3.32 3.32 0 0 1 2.201.83l.156.147.943-.943A4.652 4.652 0 0 0 18.5 3.5Z"/>'
      }, props)
  }
  export function RiMapTaxiWifiLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3v4H6.236l-2.001 4H22v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V11l2.447-4.894A2 2 0 0 1 6.237 5H9V3h3Zm8 10H4v5h16v-5ZM6.5 14a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm11 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm1-13a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a1.994 1.994 0 0 0-1.413-.585Zm0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165.944.942a3.323 3.323 0 0 1 2.357-.977 3.32 3.32 0 0 1 2.201.83l.156.147.943-.943A4.652 4.652 0 0 0 18.5 3.5Z"/>'
      }, props)
  }
  export function RiMapTrafficLightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 4V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1h3c0 2.5-2.5 3.5-3 3.5V10h3c0 2.5-2.5 3.5-3 3.5V16h3c0 2.5-2.5 3.5-3 3.5V21a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1.5c-.5 0-3-1-3-3.5h3v-2.5c-.5 0-3-1-3-3.5h3V7.5c-.5 0-3-1-3-3.5h3Zm5 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapTrafficLightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 4V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1h3c0 2.5-2.5 3.5-3 3.5V10h3c0 2.5-2.5 3.5-3 3.5V16h3c0 2.5-2.5 3.5-3 3.5V21a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1.5c-.5 0-3-1-3-3.5h3v-2.5c-.5 0-3-1-3-3.5h3V7.5c-.5 0-3-1-3-3.5h3Zm5 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapTrainFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.2 20 1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v11a2 2 0 0 1-2 2h-1.8ZM5 7v4h14V7H5Zm7 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMapTrainLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.2 20 1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v11a2 2 0 0 1-2 2h-1.8ZM7 5a2 2 0 0 0-2 2v11h14V7a2 2 0 0 0-2-2H7Zm5 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM6 7h12v4H6V7Z"/>'
      }, props)
  }
  export function RiMapTrainWifiFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.498 3a6.52 6.52 0 0 0-.324 4H5v4h10.035a6.47 6.47 0 0 0 3.465 1 6.48 6.48 0 0 0 2.5-.498V18a2 2 0 0 1-2 2h-1.8l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h5.498ZM12 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm6.5-13a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a1.994 1.994 0 0 0-1.413-.585Zm0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165.944.942a3.323 3.323 0 0 1 2.357-.977 3.32 3.32 0 0 1 2.201.83l.156.147.943-.943A4.652 4.652 0 0 0 18.5 3.5Z"/>'
      }, props)
  }
  export function RiMapTrainWifiLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.498 3a6.463 6.463 0 0 0-.479 2H7a2 2 0 0 0-1.995 1.85L5 7v11h14v-6.019a6.463 6.463 0 0 0 2-.48V18a2 2 0 0 1-2 2h-1.8l1.8 1.5v.5H5v-.5L6.8 20H5a2 2 0 0 1-2-2V7a4 4 0 0 1 4-4h5.498ZM12 13a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm.174-6a6.51 6.51 0 0 0 2.862 4.001L6 11V7h6.174ZM18.5 1a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 5.167c-.491 0-.94.177-1.289.47l-.125.115L18.5 8.167l1.413-1.415a1.994 1.994 0 0 0-1.413-.585Zm0-2.667a4.65 4.65 0 0 0-3.128 1.203l-.173.165.944.942a3.323 3.323 0 0 1 2.357-.977 3.32 3.32 0 0 1 2.201.83l.156.147.943-.943A4.652 4.652 0 0 0 18.5 3.5Z"/>'
      }, props)
  }
  export function RiMapTreasureMapFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m2 5 7-3 6 3 6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3-6-3-6.303 2.701a.5.5 0 0 1-.697-.46V5Zm4 6v2h2v-2H6Zm4 0v2h2v-2h-2Zm6-.06-1.237-1.238-1.061 1.06L14.939 12l-1.237 1.237 1.06 1.061L16 13.061l1.237 1.237 1.061-1.06L17.061 12l1.237-1.237-1.06-1.061L16 10.939Z"/>'
      }, props)
  }
  export function RiMapTreasureMapLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14.935 7.204-6-3L4 6.319v12.648l5.065-2.17 6 3L20 17.68V5.033l-5.065 2.17ZM2 5l7-3 6 3 6.303-2.701a.5.5 0 0 1 .697.46V19l-7 3-6-3-6.303 2.701a.5.5 0 0 1-.697-.46V5Zm4 6h2v2H6v-2Zm4 0h2v2h-2v-2Zm5.998-.063L17.235 9.7l1.061 1.06-1.237 1.238 1.237 1.238-1.06 1.06-1.238-1.237-1.237 1.237-1.061-1.06 1.237-1.238-1.237-1.237L14.76 9.7l1.238 1.237Z"/>'
      }, props)
  }
  export function RiMapTruckFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 8h3l3 4.056V18h-2.035a3.501 3.501 0 0 1-6.93 0h-5.07a3.5 3.5 0 0 1-6.93 0H1V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2Zm0 2v3h4v-.285L18.992 10H17Z"/>'
      }, props)
  }
  export function RiMapTruckLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.965 18a3.5 3.5 0 0 1-6.93 0H1V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2h3l3 4.056V18h-2.035a3.501 3.501 0 0 1-6.93 0h-5.07ZM15 7H3v8.05a3.5 3.5 0 0 1 5.663.95h5.674c.168-.353.393-.674.663-.95V7Zm2 6h4v-.285L18.992 10H17v3Zm.5 6a1.5 1.5 0 1 0 0-3.001 1.5 1.5 0 0 0 0 3.001ZM7 17.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z"/>'
      }, props)
  }
  export function RiMapUnpinFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20.971 17.172-1.414 1.414-3.535-3.535-.073.074-.707 3.535-1.415 1.415-4.242-4.243-4.95 4.95-1.414-1.414 4.95-4.95-4.243-4.243 1.414-1.414 3.536-.707.073-.074-3.536-3.536 1.414-1.415L20.97 17.172Zm-2.12-4.95 1.34-1.34.707.707 1.415-1.414-8.486-8.485-1.414 1.414.707.707-1.34 1.34 7.07 7.072Z"/>'
      }, props)
  }
  export function RiMapUnpinLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20.97 17.172-1.414 1.414-3.535-3.535-.073.074-.707 3.535-1.415 1.415-4.242-4.243-4.95 4.95-1.414-1.414 4.95-4.95-4.243-4.243L5.34 8.761l3.536-.707.073-.074-3.536-3.536 1.414-1.415L20.97 17.172ZM10.365 9.394l-.502.502-2.822.565 6.5 6.5.564-2.822.502-.502-4.242-4.243Zm8.411.074-1.34 1.34 1.414 1.415 1.34-1.34.707.706 1.415-1.414-8.486-8.485-1.414 1.414.707.707-1.34 1.34 1.414 1.415 1.34-1.34 4.243 4.242Z"/>'
      }, props)
  }
  export function RiMapWalkFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m7.617 8.712 3.205-2.328A1.995 1.995 0 0 1 12.065 6a2.616 2.616 0 0 1 2.427 1.82c.186.583.356.977.51 1.181A4.992 4.992 0 0 0 19 11v2a6.986 6.986 0 0 1-5.401-2.547l-.698 3.956 2.061 1.729 2.223 6.108-1.88.684-2.039-5.604-3.39-2.845a2 2 0 0 1-.714-1.904l.509-2.885-.677.492-2.127 2.928-1.618-1.176L7.6 8.7l.017.012ZM13.5 5.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM10.53 18.681l-3.214 3.83-1.532-1.285 2.975-3.546.746-2.18 1.791 1.5-.766 1.681Z"/>'
      }, props)
  }
  export function RiMapWalkLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m7.617 8.712 3.205-2.328A1.995 1.995 0 0 1 12.065 6a2.616 2.616 0 0 1 2.427 1.82c.186.583.356.977.51 1.181A4.992 4.992 0 0 0 19 11v2a6.986 6.986 0 0 1-5.401-2.547l-.698 3.956 2.061 1.729 2.223 6.108-1.88.684-2.039-5.604-3.39-2.845a2 2 0 0 1-.714-1.904l.509-2.885-.677.492-2.127 2.928-1.618-1.176L7.6 8.7l.017.012ZM13.5 5.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM10.53 18.681l-3.214 3.83-1.532-1.285 2.975-3.546.746-2.18 1.791 1.5-.766 1.681Z"/>'
      }, props)
  }
  export function RiMedia4kFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm8.5 10.5V12h-1V9H9v3H7.5V9H6v4.5h3V15h1.5v-1.5h1ZM18 15l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5v-2.25L16.25 15H18Z"/>'
      }, props)
  }
  export function RiMedia4kLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 5v14h16V5H4ZM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm8.5 10.5h-1V15H9v-1.5H6V9h1.5v3H9V9h1.5v3h1v1.5ZM18 15h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15Z"/>'
      }, props)
  }
  export function RiMediaAlbumFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 14c2.213 0 4-1.787 4-4s-1.787-4-4-4-4 1.787-4 4 1.787 4 4 4Zm0-5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1Z"/>'
      }, props)
  }
  export function RiMediaAlbumLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"/>'
      }, props)
  }
  export function RiMediaAspectRatioFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-3 9h-2v3h-3v2h5v-5Zm-7-5H6v5h2V9h3V7Z"/>'
      }, props)
  }
  export function RiMediaAspectRatioLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-1 2H4v14h16V5Zm-7 12v-2h3v-3h2v5h-5ZM11 7v2H8v3H6V7h5Z"/>'
      }, props)
  }
  export function RiMediaBroadcastFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4.929 2.929 1.414 1.414A7.975 7.975 0 0 0 4 10c0 2.209.895 4.209 2.343 5.657L4.93 17.07A9.969 9.969 0 0 1 2 10a9.969 9.969 0 0 1 2.929-7.071Zm14.142 0A9.969 9.969 0 0 1 22 9.999a9.969 9.969 0 0 1-2.929 7.072l-1.414-1.414A7.975 7.975 0 0 0 20 10c0-2.21-.895-4.21-2.343-5.657l1.414-1.414ZM7.757 5.757l1.415 1.414A3.987 3.987 0 0 0 8 10c0 1.104.448 2.104 1.172 2.828l-1.415 1.414A5.981 5.981 0 0 1 6 10c0-1.657.672-3.157 1.757-4.243Zm8.486 0A5.981 5.981 0 0 1 18 10a5.981 5.981 0 0 1-1.757 4.242l-1.415-1.414A3.987 3.987 0 0 0 16 10a3.987 3.987 0 0 0-1.172-2.829l1.415-1.414ZM12 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 2c.58 0 1.077.413 1.184.983L14.5 22h-5l1.316-7.017c.107-.57.604-.983 1.184-.983Z"/>'
      }, props)
  }
  export function RiMediaBroadcastLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m4.929 2.929 1.414 1.414A7.975 7.975 0 0 0 4 10c0 2.209.895 4.209 2.343 5.657L4.93 17.07A9.969 9.969 0 0 1 2 10a9.969 9.969 0 0 1 2.929-7.071Zm14.142 0A9.969 9.969 0 0 1 22 9.999a9.969 9.969 0 0 1-2.929 7.072l-1.414-1.414A7.975 7.975 0 0 0 20 10c0-2.21-.895-4.21-2.343-5.657l1.414-1.414ZM7.757 5.757l1.415 1.414A3.987 3.987 0 0 0 8 10c0 1.104.448 2.104 1.172 2.828l-1.415 1.414A5.981 5.981 0 0 1 6 10c0-1.657.672-3.157 1.757-4.243Zm8.486 0A5.981 5.981 0 0 1 18 10a5.981 5.981 0 0 1-1.757 4.242l-1.415-1.414A3.987 3.987 0 0 0 16 10a3.987 3.987 0 0 0-1.172-2.829l1.415-1.414ZM12 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-1 2h2v8h-2v-8Z"/>'
      }, props)
  }
  export function RiMediaCamera2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993ZM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0 2a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm6-12v2h2V5h-2Z"/>'
      }, props)
  }
  export function RiMediaCamera2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993ZM4 5v14h16V5H4Zm8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm5-11h2v2h-2V6Z"/>'
      }, props)
  }
  export function RiMediaCamera3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 6c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 20V6Zm12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM4 7v2h3V7H4Zm0-5h6v2H4V2Z"/>'
      }, props)
  }
  export function RiMediaCamera3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 6c0-.552.455-1 .992-1h18.016c.548 0 .992.445.992 1v14c0 .552-.455 1-.992 1H2.992A.994.994 0 0 1 2 20V6Zm2 1v12h16V7H4Zm10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a5 5 0 1 1 0-10 5 5 0 0 1 0 10ZM4 2h6v2H4V2Z"/>'
      }, props)
  }
  export function RiMediaCameraFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 3h6l2 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4l2-2Zm3 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm0-2a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"/>'
      }, props)
  }
  export function RiMediaCameraLensFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.827 21.763 14.31 14l3.532 6.117A9.955 9.955 0 0 1 12 22c-.746 0-1.473-.082-2.173-.237ZM7.89 21.12A10.029 10.029 0 0 1 2.458 15h8.965L7.89 21.119ZM2.05 13a9.964 9.964 0 0 1 2.583-7.761L9.112 13H2.05Zm4.109-9.117A9.955 9.955 0 0 1 12 2c.746 0 1.473.082 2.173.237L9.69 10 6.159 3.883ZM16.11 2.88A10.028 10.028 0 0 1 21.542 9h-8.965l3.533-6.119ZM21.95 11a9.964 9.964 0 0 1-2.583 7.761L14.888 11h7.064Z"/>'
      }, props)
  }
  export function RiMediaCameraLensLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.858 19.71 12 16H5.07a8.018 8.018 0 0 0 4.788 3.71ZM4.252 14h4.284L5.07 7.999A7.963 7.963 0 0 0 4 12c0 .69.088 1.36.252 2Zm2.143-7.708L8.535 10 12 4a7.974 7.974 0 0 0-5.605 2.292Zm7.747-2.002L12 8h6.93a8.018 8.018 0 0 0-4.788-3.71ZM19.748 10h-4.284l3.465 6.001A7.964 7.964 0 0 0 20 12c0-.69-.087-1.36-.252-2Zm-2.143 7.708L15.465 14 12 20a7.974 7.974 0 0 0 5.605-2.292ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm1.155-12h-2.31l-1.154 2 1.154 2h2.31l1.154-2-1.154-2Z"/>'
      }, props)
  }
  export function RiMediaCameraLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m9.828 5-2 2H4v12h16V7h-3.828l-2-2H9.828ZM9 3h6l2 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4l2-2Zm3 15a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11Zm0-2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"/>'
      }, props)
  }
  export function RiMediaCameraOffFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.587 21H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h.586L1.395 2.808l1.414-1.414 19.799 19.798-1.415 1.415L19.587 21ZM7.557 8.97a6 6 0 0 0 8.475 8.475l-1.417-1.417a4 4 0 0 1-5.642-5.642L7.556 8.97ZM22 17.786l-4.045-4.045a6 6 0 0 0-6.695-6.695L8.108 3.892 9.001 3h6l2 2h4a1 1 0 0 1 1 1v11.786ZM13.51 9.294a4.014 4.014 0 0 1 2.198 2.198l-2.198-2.198Z"/>'
      }, props)
  }
  export function RiMediaCameraOffLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.587 21H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h.586L1.395 2.808l1.414-1.414 19.799 19.798-1.415 1.415L19.587 21Zm-14-14H4v12h13.586l-2.18-2.18a5.5 5.5 0 0 1-7.725-7.725L5.587 7Zm3.524 3.525a3.5 3.5 0 0 0 4.865 4.865l-4.865-4.865Zm12.89 7.261-2-2V7h-3.828l-2-2H9.83l-.308.307-1.414-1.414L9.001 3h6l2 2h4a1 1 0 0 1 1 1v11.786ZM11.264 7.049a5.5 5.5 0 0 1 6.188 6.188l-2.338-2.338a3.516 3.516 0 0 0-1.512-1.512l-2.338-2.338Z"/>'
      }, props)
  }
  export function RiMediaCameraSwitchFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 3h6l2 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4l2-2Zm5.684 15.368-.895-1.79A4 4 0 0 1 8 13h2.001L7.839 8.677a6 6 0 0 0 6.845 9.69ZM9.316 7.632l.895 1.79A4 4 0 0 1 16 13h-2.001l2.161 4.323a6 6 0 0 0-6.845-9.69Z"/>'
      }, props)
  }
  export function RiMediaCameraSwitchLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m9.828 5-2 2H4v12h16V7h-3.828l-2-2H9.828ZM9 3h6l2 2h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4l2-2Zm.64 4.53a5.5 5.5 0 0 1 6.187 8.92L13.75 12.6h1.749l.001-.1a3.5 3.5 0 0 0-4.928-3.196L9.64 7.53Zm4.678 9.96a5.5 5.5 0 0 1-6.18-8.905L10.25 12.5H8.5a3.5 3.5 0 0 0 4.886 3.215l.932 1.774Z"/>'
      }, props)
  }
  export function RiMediaClapperboardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.998 7 2.31-4h.7c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h3.006l-2.31 4h2.31l2.31-4h3.69l-2.31 4h2.31l2.31-4h3.69l-2.31 4h2.31Z"/>'
      }, props)
  }
  export function RiMediaClapperboardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m5.998 7 2.31-4h3.69l-2.31 4h-3.69Zm6 0 2.31-4h3.69l-2.31 4h-3.69Zm6 0 2.31-4h.7c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h3.006L4 6.46V19h16V7h-2.002Z"/>'
      }, props)
  }
  export function RiMediaClosedCaptioningFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18ZM9 8c-2.208 0-4 1.792-4 4s1.792 4 4 4c1.1 0 2.1-.45 2.828-1.172l-1.414-1.414a2 2 0 1 1 0-2.828l1.415-1.413A3.988 3.988 0 0 0 9 8Zm7 0c-2.208 0-4 1.792-4 4a4.001 4.001 0 0 0 6.828 2.828l-1.414-1.414a2 2 0 1 1 0-2.828l1.415-1.413A3.988 3.988 0 0 0 16 8Z"/>'
      }, props)
  }
  export function RiMediaClosedCaptioningLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm-1 2H4v14h16V5ZM9 8c1.104 0 2.105.448 2.829 1.173l-1.414 1.414a2 2 0 1 0 0 2.828l1.413 1.413A4.001 4.001 0 0 1 5 12c0-2.208 1.792-4 4-4Zm7 0c1.105 0 2.105.448 2.829 1.173l-1.414 1.414a2 2 0 1 0 0 2.828l1.413 1.413A4.001 4.001 0 0 1 12 12c0-2.208 1.792-4 4-4Z"/>'
      }, props)
  }
  export function RiMediaDiscFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 9.17A3 3 0 1 0 15 12V2.458c4.057 1.274 7 5.064 7 9.542 0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2c.338 0 .671.017 1 .05v7.12Z"/>'
      }, props)
  }
  export function RiMediaDiscLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 4.581V12a3 3 0 1 1-2-2.83V2.05c5.053.501 9 4.765 9 9.95 0 5.523-4.477 10-10 10S2 17.523 2 12c0-5.185 3.947-9.449 9-9.95v2.012A8.001 8.001 0 0 0 12 20 8 8 0 0 0 15 4.58Z"/>'
      }, props)
  }
  export function RiMediaDvFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 14.745a7 7 0 1 1 8 0V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6.255ZM8 14A5 5 0 1 0 8 4a5 5 0 0 0 0 10Zm-1 4v2h2v-2H7Zm1-6a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm6 5v-1.292A8.978 8.978 0 0 0 17 9a8.967 8.967 0 0 0-2.292-6H21a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-7Zm4-10v2h2V7h-2Z"/>'
      }, props)
  }
  export function RiMediaDvLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.608 3H21a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-7v-2h6V5h-6.255A6.968 6.968 0 0 1 15 9a6.992 6.992 0 0 1-3 5.745V21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6.255A7 7 0 0 1 11.608 3ZM6 13.584V20h4v-6.416A5.001 5.001 0 0 0 8 4a5 5 0 0 0-2 9.584ZM8 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm9-3h2v2h-2V7ZM7 17h2v2H7v-2Z"/>'
      }, props)
  }
  export function RiMediaDvdFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 11V6l-5 7h3v5l5-7h-3Zm-1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z"/>'
      }, props)
  }
  export function RiMediaDvdLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-9h3l-5 7v-5H8l5-7v5Z"/>'
      }, props)
  }
  export function RiMediaEjectFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.416 3.624 7.066 10.599a.5.5 0 0 1-.416.777H4.934a.5.5 0 0 1-.416-.777l7.066-10.599a.5.5 0 0 1 .832 0ZM5 17h14a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2Z"/>'
      }, props)
  }
  export function RiMediaEjectLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.737 13h8.526L12 6.606 7.737 13Zm4.679-9.376 7.066 10.599a.5.5 0 0 1-.416.777H4.934a.5.5 0 0 1-.416-.777l7.066-10.599a.5.5 0 0 1 .832 0ZM5 17h14a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2Z"/>'
      }, props)
  }
  export function RiMediaEqualizerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.17 18a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2v-2h4.17Zm6-7a3.001 3.001 0 0 1 5.66 0H22v2h-4.17a3.001 3.001 0 0 1-5.66 0H2v-2h10.17Zm-6-7a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2V4h4.17Z"/>'
      }, props)
  }
  export function RiMediaEqualizerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.17 18a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2v-2h4.17Zm6-7a3.001 3.001 0 0 1 5.66 0H22v2h-4.17a3.001 3.001 0 0 1-5.66 0H2v-2h10.17Zm-6-7a3.001 3.001 0 0 1 5.66 0H22v2H11.83a3.001 3.001 0 0 1-5.66 0H2V4h4.17ZM9 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiMediaFilmFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993ZM4 5v2h2V5H4Zm14 0v2h2V5h-2ZM4 9v2h2V9H4Zm14 0v2h2V9h-2ZM4 13v2h2v-2H4Zm14 0v2h2v-2h-2ZM4 17v2h2v-2H4Zm14 0v2h2v-2h-2Z"/>'
      }, props)
  }
  export function RiMediaFilmLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993ZM8 5v14h8V5H8ZM4 5v2h2V5H4Zm14 0v2h2V5h-2ZM4 9v2h2V9H4Zm14 0v2h2V9h-2ZM4 13v2h2v-2H4Zm14 0v2h2v-2h-2ZM4 17v2h2v-2H4Zm14 0v2h2v-2h-2Z"/>'
      }, props)
  }
  export function RiMediaForward10Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10h-2a8 8 0 1 1-1.865-5.135l-1.997 1.997A2.5 2.5 0 0 0 12 10.75v2.5a2.5 2.5 0 0 0 5 0v-2.5c0-.681-.273-1.3-.715-1.75H22V3l-2.447 2.446A9.977 9.977 0 0 0 12 2Zm3.5 8.75v2.5a1 1 0 1 1-2 0v-2.5a1 1 0 1 1 2 0ZM10 8.5H8.5v7H10v-7Z"/>'
      }, props)
  }
  export function RiMediaForward10Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10h-2a8 8 0 1 1-1.384-4.5H16v1.25a2.5 2.5 0 0 0-4 2v2.5a2.5 2.5 0 0 0 5 0v-2.5c0-.455-.122-.882-.334-1.25H22v-6h-2V6a9.985 9.985 0 0 0-8-4Zm3.5 8.75v2.5a1 1 0 1 1-2 0v-2.5a1 1 0 1 1 2 0ZM10 8.5H8.5v7H10v-7Z"/>'
      }, props)
  }
  export function RiMediaForward15Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10h-2a8 8 0 1 1-1.865-5.135L16.5 8.5H12v4.25h2.875a.625.625 0 1 1 0 1.25H12v1.5h2.875a2.125 2.125 0 0 0 0-4.25H13.5V10h3.25V9H22V3l-2.447 2.446A9.977 9.977 0 0 0 12 2ZM8.5 8.5H10v7H8.5v-7Z"/>'
      }, props)
  }
  export function RiMediaForward15Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10h-2a8 8 0 1 1-1.384-4.5H16v1h-4v4.25h2.875a.625.625 0 1 1 0 1.25H12v1.5h2.875a2.125 2.125 0 0 0 0-4.25H13.5V10h3.25v-.5H22v-6h-2V6a9.985 9.985 0 0 0-8-4ZM8.5 8.5H10v7H8.5v-7Z"/>'
      }, props)
  }
  export function RiMediaForward30Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 12C2 6.477 6.477 2 12 2a9.977 9.977 0 0 1 7.553 3.446L22 3v6h-5.215c.442.45.715 1.069.715 1.75v2.5a2.5 2.5 0 0 1-5 0v-2.5a2.5 2.5 0 0 1 3.853-2.103l1.782-1.782A8 8 0 1 0 20 12h2c0 5.523-4.477 10-10 10S2 17.523 2 12Zm13-2.25a1 1 0 0 0-1 1v2.5a1 1 0 1 0 2 0v-2.5a1 1 0 0 0-1-1Zm-5 3.625a.625.625 0 0 0-.625-.625H7.5v-1.5h1.875a.625.625 0 1 0 0-1.25H6.75V8.5h2.625a2.125 2.125 0 0 1 1.62 3.5 2.125 2.125 0 0 1-1.62 3.5H6.75V14h2.625c.345 0 .625-.28.625-.625Z"/>'
      }, props)
  }
  export function RiMediaForward30Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 12C2 6.477 6.477 2 12 2a9.985 9.985 0 0 1 8 4V3.5h2v6h-4.834c.212.368.334.795.334 1.25v2.5a2.5 2.5 0 0 1-5 0v-2.5A2.5 2.5 0 0 1 16 8.458V7.5h2.616A8 8 0 1 0 20 12h2c0 5.523-4.477 10-10 10S2 17.523 2 12Zm13-2.25a1 1 0 0 0-1 1v2.5a1 1 0 1 0 2 0v-2.5a1 1 0 0 0-1-1Zm-5.625 3a.625.625 0 1 1 0 1.25H6.75v1.5h2.625a2.125 2.125 0 0 0 1.62-3.5 2.125 2.125 0 0 0-1.62-3.5H6.75V10h2.625a.625.625 0 1 1 0 1.25H7.5v1.5h1.875Z"/>'
      }, props)
  }
  export function RiMediaForward5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 12C2 6.477 6.477 2 12 2a9.977 9.977 0 0 1 7.553 3.446L22 3v6h-6l2.135-2.135A8 8 0 1 0 20 12h2c0 5.523-4.477 10-10 10S2 17.523 2 12Zm12.5-2V8.5h-5v4.25h3.125a.625.625 0 1 1 0 1.25H9.5v1.5h3.125a2.125 2.125 0 0 0 0-4.25H11V10h3.5Z"/>'
      }, props)
  }
  export function RiMediaForward5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10h-2a8 8 0 1 1-1.384-4.5H16v2h6v-6h-2V6a9.985 9.985 0 0 0-8-4ZM9.5 8.5h5V10H11v1.25h1.625a2.125 2.125 0 0 1 0 4.25H9.5V14h3.125a.625.625 0 1 0 0-1.25H9.5V8.5Z"/>'
      }, props)
  }
  export function RiMediaFullscreenExitFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 7h4v2h-6V3h2v4ZM8 9H2V7h4V3h2v6Zm10 8v4h-2v-6h6v2h-4ZM8 15v6H6v-4H2v-2h6Z"/>'
      }, props)
  }
  export function RiMediaFullscreenExitLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 7h4v2h-6V3h2v4ZM8 9H2V7h4V3h2v6Zm10 8v4h-2v-6h6v2h-4ZM8 15v6H6v-4H2v-2h6Z"/>'
      }, props)
  }
  export function RiMediaFullscreenFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 3h6v6h-2V5h-4V3ZM2 3h6v2H4v4H2V3Zm18 16v-4h2v6h-6v-2h4ZM4 19h4v2H2v-6h2v4Z"/>'
      }, props)
  }
  export function RiMediaFullscreenLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 3v2H4v4H2V3h6ZM2 21v-6h2v4h4v2H2Zm20 0h-6v-2h4v-4h2v6Zm0-12h-2V5h-4V3h6v6Z"/>'
      }, props)
  }
  export function RiMediaGalleryFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.409 19c-.776-2.399-2.277-3.885-4.266-5.602A10.953 10.953 0 0 1 20 11V3h1.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6V1h2v4H4v7c5.22 0 9.662 2.462 11.313 7h2.096ZM18 1v4h-8V3h6V1h2Zm-1.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMediaGalleryLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 13c-1.678 0-3.249.46-4.593 1.259A14.984 14.984 0 0 1 18.147 19H20v-6Zm-3.996 6C14.044 14.302 9.408 11 4 11v8h12.004ZM4 9c3.83 0 7.323 1.435 9.974 3.796A10.949 10.949 0 0 1 20 11V3h1.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6V1h2v4H4v4Zm14-8v4h-8V3h6V1h2Zm-1.5 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMediaGalleryUploadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 1v2h8V1h2v2h3.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6V1h2Zm4 7-4 4h3v4h2v-4h3l-4-4Z"/>'
      }, props)
  }
  export function RiMediaGalleryUploadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 1v4H4v14h16V3h1.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6V1h2Zm4 7 4 4h-3v4h-2v-4H8l4-4Zm6-7v4h-8V3h6V1h2Z"/>'
      }, props)
  }
  export function RiMediaHdFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm4.5 8.25V9H6v6h1.5v-2.25h2V15H11V9H9.5v2.25h-2Zm7-.75H16a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1.5v-3ZM13 9v6h3a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-3Z"/>'
      }, props)
  }
  export function RiMediaHdLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 5v14h16V5H4ZM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm4.5 8.25h2V9H11v6H9.5v-2.25h-2V15H6V9h1.5v2.25Zm7-.75v3H16a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-1.5ZM13 9h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-3V9Z"/>'
      }, props)
  }
  export function RiMediaHeadphoneFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 12h3a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7C2 6.477 6.477 2 12 2s10 4.477 10 10v7a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h3a8 8 0 1 0-16 0Z"/>'
      }, props)
  }
  export function RiMediaHeadphoneLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 4a8 8 0 0 0-8 8h3a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7C2 6.477 6.477 2 12 2s10 4.477 10 10v7a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h3a8 8 0 0 0-8-8ZM4 14v5h3v-5H4Zm13 0v5h3v-5h-3Z"/>'
      }, props)
  }
  export function RiMediaHqFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm4.5 8.25V9H6v6h1.5v-2.25h2V15H11V9H9.5v2.25h-2ZM16.25 15H17a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h.75v1.5h1.5V15Zm-1.75-4.5h2v3h-2v-3Z"/>'
      }, props)
  }
  export function RiMediaHqLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 5v14h16V5H4ZM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm4.5 8.25h2V9H11v6H9.5v-2.25h-2V15H6V9h1.5v2.25ZM16.25 15v1.5h-1.5V15H14a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-.75Zm-1.75-4.5v3h2v-3h-2Z"/>'
      }, props)
  }
  export function RiMediaImage2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m5 11.1 2-2 5.5 5.5 3.5-3.5 3 3V5H5v6.1ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm11.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMediaImage2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m5 11.1 2-2 5.5 5.5 3.5-3.5 3 3V5H5v6.1Zm0 2.829V19h3.1l2.986-2.985L7 11.929l-2 2ZM10.929 19H19v-2.071l-3-3L10.929 19ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm11.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMediaImageAddFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Zm.008-12c.548 0 .992.445.992.993v9.349A5.99 5.99 0 0 0 20 13V5H4l.001 14 9.292-9.293a.999.999 0 0 1 1.32-.084l.094.085 3.545 3.55a6.003 6.003 0 0 0-3.91 7.743L2.992 21A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h18.016ZM8 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"/>'
      }, props)
  }
  export function RiMediaImageAddLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2Zm.008-12c.548 0 .992.445.992.993V13h-2V5H4v13.999L14 9l3 3v2.829l-3-3L6.827 19H14v2H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h18.016ZM8 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"/>'
      }, props)
  }
  export function RiMediaImageEditFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v1.757l-2 2V5H5v8.1l4-4 4.328 4.329-1.327 1.327-.006 4.239 4.246.006 1.33-1.33L18.899 19H19v-2.758l2-2V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16Zm1.778 4.808 1.414 1.414L15.414 17l-1.416-.002.002-1.412 7.778-7.778ZM15.5 7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>'
      }, props)
  }
  export function RiMediaImageEditLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 3a1 1 0 0 1 1 1v1.757l-2 2V5H5v8.1l4-4 4.328 4.329-1.415 1.413L9 11.93l-4 3.999V19h10.533l.708.001 1.329-1.33L18.9 19h.1v-2.758l2-2V20a1 1 0 0 1-1 1H4c-.55 0-1-.45-1-1V4a1 1 0 0 1 1-1h16Zm1.778 4.808 1.414 1.414L15.414 17l-1.416-.002.002-1.412 7.778-7.778ZM15.5 7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>'
      }, props)
  }
  export function RiMediaImageFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 5H4v14l9.292-9.294a1 1 0 0 1 1.415 0L20 15.01V5ZM2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993ZM8 11a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMediaImageLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.992 21A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992ZM20 15V5H4v14L14 9l6 6Zm0 2.828-6-6L6.828 19H20v-1.172ZM8 11a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMediaLandscapeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 21-4.762-8.73L15 6l8 15h-7ZM8 10l6 11H2l6-11ZM5.5 8a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"/>'
      }, props)
  }
  export function RiMediaLandscapeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.27 12.216 15 6l8 15H2L9 8l2.27 4.216Zm1.12 2.022L14.987 19h4.68l-4.77-8.942-2.507 4.18ZM5.348 19h7.304L9 12.219 5.348 19ZM5.5 8a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z"/>'
      }, props)
  }
  export function RiMediaLiveFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14ZM7.4 8.829a.4.4 0 0 0-.392.32L7 9.228v5.542a.4.4 0 0 0 .542.374l.073-.036 4.355-2.771a.401.401 0 0 0 .063-.625l-.063-.05L7.615 8.89A.4.4 0 0 0 7.4 8.83Z"/>'
      }, props)
  }
  export function RiMediaLiveLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14Zm-1 2H3v12h12V6ZM7.4 8.829a.4.4 0 0 1 .215.062l4.355 2.771a.4.4 0 0 1 0 .675L7.615 15.11A.4.4 0 0 1 7 14.77V9.23c0-.221.18-.4.4-.4ZM21 8.84l-4 2.8v.718l4 2.8V8.84Z"/>'
      }, props)
  }
  export function RiMediaMemoriesFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12c0-5.523-4.477-10-10-10a9.977 9.977 0 0 0-7.553 3.446L2 3v6h6L5.865 6.865A8 8 0 1 1 4 12H2c0 5.523 4.477 10 10 10s10-4.477 10-10ZM10.777 8.518l4.599 3.066a.5.5 0 0 1 0 .832l-4.599 3.066a.5.5 0 0 1-.777-.416V8.934a.5.5 0 0 1 .777-.416Z"/>'
      }, props)
  }
  export function RiMediaMemoriesLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12c0-5.523-4.477-10-10-10a9.985 9.985 0 0 0-8 4V3.5H2v6h6v-2H5.385A8 8 0 1 1 4 12H2c0 5.523 4.477 10 10 10s10-4.477 10-10ZM10.777 8.518l4.599 3.066a.5.5 0 0 1 0 .832l-4.599 3.066a.5.5 0 0 1-.777-.416V8.934a.5.5 0 0 1 .777-.416Z"/>'
      }, props)
  }
  export function RiMediaMic2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 1a5 5 0 0 1 5 5v6a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5ZM2.19 13.961l1.962-.392a8.003 8.003 0 0 0 15.692 0l1.962.392C20.895 18.545 16.85 22 11.999 22c-4.851 0-8.896-3.455-9.808-8.039Z"/>'
      }, props)
  }
  export function RiMediaMic2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3a3 3 0 0 0-3 3v6a3 3 0 1 0 6 0V6a3 3 0 0 0-3-3Zm0-2a5 5 0 0 1 5 5v6a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5ZM2.19 13.961l1.962-.392a8.003 8.003 0 0 0 15.692 0l1.962.392C20.895 18.545 16.85 22 11.999 22c-4.851 0-8.896-3.455-9.808-8.039Z"/>'
      }, props)
  }
  export function RiMediaMicFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 1a5 5 0 0 1 5 5v4a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5ZM3.055 11H5.07a7.002 7.002 0 0 0 13.858 0h2.016A9.004 9.004 0 0 1 13 18.945V23h-2v-4.055A9.004 9.004 0 0 1 3.055 11Z"/>'
      }, props)
  }
  export function RiMediaMicLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3a3 3 0 0 0-3 3v4a3 3 0 1 0 6 0V6a3 3 0 0 0-3-3Zm0-2a5 5 0 0 1 5 5v4a5 5 0 0 1-10 0V6a5 5 0 0 1 5-5ZM3.055 11H5.07a7.002 7.002 0 0 0 13.858 0h2.016A9.004 9.004 0 0 1 13 18.945V23h-2v-4.055A9.004 9.004 0 0 1 3.055 11Z"/>'
      }, props)
  }
  export function RiMediaMicOffFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.426 17.839A8.94 8.94 0 0 1 13 18.945V23h-2v-4.055A9.004 9.004 0 0 1 3.056 11h2.016a7.002 7.002 0 0 0 9.87 5.354l-1.55-1.55A5 5 0 0 1 7.001 10V8.414L1.394 2.808l1.414-1.415 19.799 19.8-1.415 1.414-4.767-4.768Zm2.95-2.679-1.443-1.442c.509-.81.856-1.73.997-2.718h2.016a8.95 8.95 0 0 1-1.57 4.16Zm-2.91-2.909-8.78-8.78A5 5 0 0 1 17 6v4c.001.81-.191 1.575-.533 2.251Z"/>'
      }, props)
  }
  export function RiMediaMicOffLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.426 17.839 4.768 4.768 1.414-1.415-19.8-19.799-1.413 1.415L7 8.414V10a5 5 0 0 0 6.39 4.804l1.55 1.55A7.002 7.002 0 0 1 5.071 11H3.057a9.004 9.004 0 0 0 7.945 7.945V23h2v-4.055a8.94 8.94 0 0 0 3.425-1.106Zm-4.872-4.872a3.002 3.002 0 0 1-2.52-2.52l2.52 2.52Zm7.822 2.193-1.443-1.442c.509-.81.856-1.73.997-2.718h2.016a8.95 8.95 0 0 1-1.57 4.16Zm-2.91-2.909-1.548-1.548c.055-.226.083-.46.083-.703V6a3 3 0 0 0-5.818-1.032L7.687 3.471A5 5 0 0 1 17 6v4c0 .81-.192 1.575-.534 2.251Z"/>'
      }, props)
  }
  export function RiMediaMovie2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.001 20H20v2h-8C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10a9.985 9.985 0 0 1-3.999 8ZM12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-4 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm8 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-4 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMediaMovie2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 20h8v2h-8C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10a9.956 9.956 0 0 1-2 6h-2.708A8 8 0 1 0 12 20Zm0-10a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-4 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm8 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-4 4a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMediaMovieFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993Zm8.622 4.422a.4.4 0 0 0-.622.332v6.506a.4.4 0 0 0 .622.332l4.879-3.252a.401.401 0 0 0 0-.666l-4.88-3.252Z"/>'
      }, props)
  }
  export function RiMediaMovieLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993ZM4 5v14h16V5H4Zm6.622 3.415 4.879 3.252a.4.4 0 0 1 0 .666l-4.88 3.252a.4.4 0 0 1-.621-.332V8.747a.4.4 0 0 1 .622-.332Z"/>'
      }, props)
  }
  export function RiMediaMusic2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 3v14a4 4 0 1 1-2-3.465V6H9v11a4 4 0 1 1-2-3.465V3h13Z"/>'
      }, props)
  }
  export function RiMediaMusic2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 3v14a4 4 0 1 1-2-3.465V5H9v12a4 4 0 1 1-2-3.465V3h13ZM5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMediaMusicFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 13.535V3h8v3h-6v11a4 4 0 1 1-2-3.465Z"/>'
      }, props)
  }
  export function RiMediaMusicLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 13.535V3h8v2h-6v12a4 4 0 1 1-2-3.465ZM10 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMediaMvFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993Zm10 8.178A3 3 0 1 0 14 15V7.999h3V6h-5v6.17Z"/>'
      }, props)
  }
  export function RiMediaMvLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3.993A1 1 0 0 1 2.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993ZM4 5v14h16V5H4Zm8 7.17V6h5v2h-3v7a3 3 0 1 1-2-2.83Z"/>'
      }, props)
  }
  export function RiMediaNotification2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 20H2v-2h1v-6.969C3 6.043 7.03 2 12 2s9 4.043 9 9.031V18h1v2ZM9.5 21h5a2.5 2.5 0 0 1-5 0Z"/>'
      }, props)
  }
  export function RiMediaNotification2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 20H2v-2h1v-6.969C3 6.043 7.03 2 12 2s9 4.043 9 9.031V18h1v2ZM5 18h14v-6.969C19 7.148 15.866 4 12 4s-7 3.148-7 7.031V18Zm4.5 3h5a2.5 2.5 0 0 1-5 0Z"/>'
      }, props)
  }
  export function RiMediaNotification3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 17h2v2H2v-2h2v-7a8 8 0 1 1 16 0v7ZM9 21h6v2H9v-2Z"/>'
      }, props)
  }
  export function RiMediaNotification3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 17h2v2H2v-2h2v-7a8 8 0 1 1 16 0v7Zm-2 0v-7a6 6 0 0 0-12 0v7h12Zm-9 4h6v2H9v-2Z"/>'
      }, props)
  }
  export function RiMediaNotification4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m20 18.667.4.533a.5.5 0 0 1-.4.8H4a.5.5 0 0 1-.4-.8l.4-.533V10a8 8 0 1 1 16 0v8.667ZM9.5 21h5a2.5 2.5 0 0 1-5 0Z"/>'
      }, props)
  }
  export function RiMediaNotification4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 10a6 6 0 0 0-12 0v8h12v-8Zm2 8.667.4.533a.5.5 0 0 1-.4.8H4a.5.5 0 0 1-.4-.8l.4-.533V10a8 8 0 1 1 16 0v8.667ZM9.5 21h5a2.5 2.5 0 0 1-5 0Z"/>'
      }, props)
  }
  export function RiMediaNotificationFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c4.97 0 9 4.043 9 9.031V20H3v-8.969C3 6.043 7.03 2 12 2ZM9.5 21h5a2.5 2.5 0 0 1-5 0Z"/>'
      }, props)
  }
  export function RiMediaNotificationLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 18h14v-6.969C19 7.148 15.866 4 12 4s-7 3.148-7 7.031V18Zm7-16c4.97 0 9 4.043 9 9.031V20H3v-8.969C3 6.043 7.03 2 12 2ZM9.5 21h5a2.5 2.5 0 0 1-5 0Z"/>'
      }, props)
  }
  export function RiMediaNotificationOffFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.587 20H4a.5.5 0 0 1-.4-.8l.4-.533V10c0-1.33.325-2.584.899-3.687L1.395 2.808l1.414-1.414 19.799 19.798-1.415 1.415L18.587 20ZM20 15.786 7.561 3.345A8 8 0 0 1 20 10v5.786ZM9.501 21h5a2.5 2.5 0 0 1-5 0Z"/>'
      }, props)
  }
  export function RiMediaNotificationOffLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.587 20H4a.5.5 0 0 1-.4-.8l.4-.533V10c0-1.33.325-2.584.899-3.687L1.395 2.808l1.414-1.414 19.799 19.798-1.415 1.415L18.587 20ZM6.409 7.822A5.985 5.985 0 0 0 6 10v8h10.586L6.409 7.822ZM20 15.786l-2-2V10a6 6 0 0 0-8.99-5.203l-1.45-1.452A8 8 0 0 1 20 10v5.786ZM9.501 21h5a2.5 2.5 0 0 1-5 0Z"/>'
      }, props)
  }
  export function RiMediaOrderPlayFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 4V2.067a.5.5 0 0 1 .82-.384l4.12 3.433a.5.5 0 0 1-.321.884H2V4h15ZM2 18h20v2H2v-2Zm0-7h20v2H2v-2Z"/>'
      }, props)
  }
  export function RiMediaOrderPlayLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 4V2.067a.5.5 0 0 1 .82-.384l4.12 3.433a.5.5 0 0 1-.321.884H2V4h15ZM2 18h20v2H2v-2Zm0-7h20v2H2v-2Z"/>'
      }, props)
  }
  export function RiMediaPauseCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10ZM9 9v6h2V9H9Zm4 0v6h2V9h-2Z"/>'
      }, props)
  }
  export function RiMediaPauseCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM9 9h2v6H9V9Zm4 0h2v6h-2V9Z"/>'
      }, props)
  }
  export function RiMediaPauseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 5h2v14H6V5Zm10 0h2v14h-2V5Z"/>'
      }, props)
  }
  export function RiMediaPauseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 5h2v14H6V5Zm10 0h2v14h-2V5Z"/>'
      }, props)
  }
  export function RiMediaPauseMiniFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 7a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0V7ZM7 7a1 1 0 0 1 2 0v10a1 1 0 1 1-2 0V7Z"/>'
      }, props)
  }
  export function RiMediaPauseMiniLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 7a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0V7ZM7 7a1 1 0 0 1 2 0v10a1 1 0 1 1-2 0V7Z"/>'
      }, props)
  }
  export function RiMediaPhoneCameraFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.803 4A6 6 0 0 0 23 12.197V19c0 .553-.44 1.001-1.003 1.001H2.002A1 1 0 0 1 1 19V5c0-.552.44-1 1.002-1h12.8ZM20 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-1 6v3h2v-3h-2Z"/>'
      }, props)
  }
  export function RiMediaPhoneCameraLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.803 4a5.958 5.958 0 0 0-.72 2H3v12h18v-5.083a5.958 5.958 0 0 0 2-.72V19c0 .553-.44 1.001-1.003 1.001H2.002A1 1 0 0 1 1 19V5c0-.552.44-1 1.002-1h12.8ZM20 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm-2 2h2v3h-2v-3Z"/>'
      }, props)
  }
  export function RiMediaPictureInPicture2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h8ZM6.707 6.293l2.25 2.25L11 6.5V12H5.5l2.043-2.043-2.25-2.25 1.414-1.414Z"/>'
      }, props)
  }
  export function RiMediaPictureInPicture2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h8Zm-1 2h-6v4h6v-4ZM6.707 6.293l2.25 2.25L11 6.5V12H5.5l2.043-2.043-2.25-2.25 1.414-1.414Z"/>'
      }, props)
  }
  export function RiMediaPictureInPictureExitFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h8Zm-9.5-6L9.457 9.043l2.25 2.25-1.414 1.414-2.25-2.25L6 12.5V7h5.5Z"/>'
      }, props)
  }
  export function RiMediaPictureInPictureExitLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h8Zm-1 2h-6v4h6v-4Zm-8.5-8L9.457 9.043l2.25 2.25-1.414 1.414-2.25-2.25L6 12.5V7h5.5Z"/>'
      }, props)
  }
  export function RiMediaPictureInPictureFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h8Z"/>'
      }, props)
  }
  export function RiMediaPictureInPictureLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 3a1 1 0 0 1 1 1v7h-2V5H4v14h6v2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18Zm0 10a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h8Zm-1 2h-6v4h6v-4Z"/>'
      }, props)
  }
  export function RiMediaPlayCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10ZM10.622 8.415a.4.4 0 0 0-.622.332v6.506a.4.4 0 0 0 .622.332l4.879-3.252a.401.401 0 0 0 0-.666l-4.88-3.252Z"/>'
      }, props)
  }
  export function RiMediaPlayCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM10.622 8.415l4.879 3.252a.4.4 0 0 1 0 .666l-4.88 3.252a.4.4 0 0 1-.621-.332V8.747a.4.4 0 0 1 .622-.332Z"/>'
      }, props)
  }
  export function RiMediaPlayFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.376 12.416 8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832Z"/>'
      }, props)
  }
  export function RiMediaPlayLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.394 12 10 7.737v8.526L16.394 12Zm2.982.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832Z"/>'
      }, props)
  }
  export function RiMediaPlayList2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 18v2H2v-2h20ZM2 3.5l8 5-8 5v-10ZM22 11v2H12v-2h10Zm0-7v2H12V4h10Z"/>'
      }, props)
  }
  export function RiMediaPlayList2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 18v2H2v-2h20ZM2 3.5l8 5-8 5v-10ZM22 11v2H12v-2h10ZM4 7.109v2.783L6.226 8.5 4 7.109ZM22 4v2H12V4h10Z"/>'
      }, props)
  }
  export function RiMediaPlayListAddFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 18h10v2H2v-2Zm0-7h20v2H2v-2Zm0-7h20v2H2V4Zm16 14v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3Z"/>'
      }, props)
  }
  export function RiMediaPlayListAddLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 18h10v2H2v-2Zm0-7h20v2H2v-2Zm0-7h20v2H2V4Zm16 14v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3Z"/>'
      }, props)
  }
  export function RiMediaPlayListFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 18h10v2H2v-2Zm0-7h14v2H2v-2Zm0-7h20v2H2V4Zm17 11.17V9h5v2h-3v7a3 3 0 1 1-2-2.83Z"/>'
      }, props)
  }
  export function RiMediaPlayListLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 18h10v2H2v-2Zm0-7h14v2H2v-2Zm0-7h20v2H2V4Zm17 11.17V9h5v2h-3v7a3 3 0 1 1-2-2.83ZM18 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiMediaPlayMiniFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m7.752 5.439 10.508 6.13a.5.5 0 0 1 0 .863l-10.508 6.13A.5.5 0 0 1 7 18.13V5.87a.5.5 0 0 1 .752-.431Z"/>'
      }, props)
  }
  export function RiMediaPlayMiniLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 8.482v7.036L15.03 12 9 8.482ZM7.752 5.44l10.508 6.13a.5.5 0 0 1 0 .863l-10.508 6.13A.5.5 0 0 1 7 18.13V5.87a.5.5 0 0 1 .752-.431Z"/>'
      }, props)
  }
  export function RiMediaPolaroid2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 20.007V3.993ZM6 17v2h12v-2H6ZM5 5v2h2V5H5Zm7 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/>'
      }, props)
  }
  export function RiMediaPolaroid2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 15V5H5v10h14ZM3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 20.007V3.993ZM12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8ZM6 6h2v2H6V6Zm0 11v2h12v-2H6Z"/>'
      }, props)
  }
  export function RiMediaPolaroidFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.659 10a6 6 0 1 0 0 4H21v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6h-.341ZM5 6v3h2V6H5Zm10 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMediaPolaroidLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 6h-2V5H5v14h14v-1h2v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2ZM6 6h2v3H6V6Zm9 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 2a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-4a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiMediaRadio2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 3V1h2v2h13.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6Zm3 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm5-6v2h4V9h-4Zm0 4v2h4v-2h-4Z"/>'
      }, props)
  }
  export function RiMediaRadio2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 3V1h2v2h13.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6ZM4 5v14h16V5H4Zm5 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm5-6h4v2h-4V9Zm0 4h4v2h-4v-2Z"/>'
      }, props)
  }
  export function RiMediaRadioFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 10h3V6H4v4h11V8h2v2ZM6 3V1h2v2h13.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6Zm1 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiMediaRadioLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 10V8h-2v2H5V6h14v4h-2ZM6 3V1h2v2h13.008c.548 0 .992.445.992.993v16.014a1 1 0 0 1-.992.993H2.992A.993.993 0 0 1 2 20.007V3.993A1 1 0 0 1 2.992 3H6ZM4 5v14h16V5H4Zm4 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiMediaRecordCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-7a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiMediaRecordCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiMediaRepeat2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 20v1.932a.5.5 0 0 1-.82.385l-4.12-3.433A.5.5 0 0 1 3.382 18H18a2 2 0 0 0 2-2V8h2v8a4 4 0 0 1-4 4H8Zm8-16V2.067a.5.5 0 0 1 .82-.384l4.12 3.433a.5.5 0 0 1-.321.884H6a2 2 0 0 0-2 2v8H2V8a4 4 0 0 1 4-4h10Z"/>'
      }, props)
  }
  export function RiMediaRepeat2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 20v1.932a.5.5 0 0 1-.82.384l-4.12-3.432A.5.5 0 0 1 3.382 18H18a2 2 0 0 0 2-2V8h2v8a4 4 0 0 1-4 4H8Zm8-16V2.067a.5.5 0 0 1 .82-.384l4.12 3.433a.5.5 0 0 1-.321.884H6a2 2 0 0 0-2 2v8H2V8a4 4 0 0 1 4-4h10Z"/>'
      }, props)
  }
  export function RiMediaRepeatFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 4h15a1 1 0 0 1 1 1v7h-2V6H6v3L1 5l5-4v3Zm12 16H3a1 1 0 0 1-1-1v-7h2v6h14v-3l5 4-5 4v-3Z"/>'
      }, props)
  }
  export function RiMediaRepeatLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 4h15a1 1 0 0 1 1 1v7h-2V6H6v3L1 5l5-4v3Zm12 16H3a1 1 0 0 1-1-1v-7h2v6h14v-3l5 4-5 4v-3Z"/>'
      }, props)
  }
  export function RiMediaRepeatOneFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 20v1.932a.5.5 0 0 1-.82.385l-4.12-3.433A.5.5 0 0 1 3.382 18H18a2 2 0 0 0 2-2V8h2v8a4 4 0 0 1-4 4H8Zm8-16V2.067a.5.5 0 0 1 .82-.384l4.12 3.433a.5.5 0 0 1-.321.884H6a2 2 0 0 0-2 2v8H2V8a4 4 0 0 1 4-4h10Zm-5 4h2v8h-2v-6H9V9l2-1Z"/>'
      }, props)
  }
  export function RiMediaRepeatOneLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 20v1.932a.5.5 0 0 1-.82.385l-4.12-3.433A.5.5 0 0 1 3.382 18H18a2 2 0 0 0 2-2V8h2v8a4 4 0 0 1-4 4H8Zm8-17.933a.5.5 0 0 1 .82-.384l4.12 3.433a.5.5 0 0 1-.321.884H6a2 2 0 0 0-2 2v8H2V8a4 4 0 0 1 4-4h10V2.067ZM11 8h2v8h-2v-6H9V9l2-1Z"/>'
      }, props)
  }
  export function RiMediaReplay10Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.865-5.135L8 9H2V3l2.447 2.446A9.977 9.977 0 0 1 12 2Zm2.5 6.25a2.5 2.5 0 0 0-2.5 2.5v2.5a2.5 2.5 0 0 0 5 0v-2.5a2.5 2.5 0 0 0-2.5-2.5Zm1 2.5v2.5a1 1 0 1 1-2 0v-2.5a1 1 0 1 1 2 0ZM10 8.5H8.5v7H10v-7Z"/>'
      }, props)
  }
  export function RiMediaReplay10Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.385-4.5H8v2H2v-6h2V6a9.985 9.985 0 0 1 8-4Zm3.5 11.25a1 1 0 1 1-2 0v-2.5a1 1 0 1 1 2 0v2.5Zm-1-5a2.5 2.5 0 0 0-2.5 2.5v2.5a2.5 2.5 0 0 0 5 0v-2.5a2.5 2.5 0 0 0-2.5-2.5Zm-6 7.25v-7H10v7H8.5Z"/>'
      }, props)
  }
  export function RiMediaReplay15Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.865-5.135L8 9H2V3l2.447 2.446A9.977 9.977 0 0 1 12 2ZM8.5 8.5H10v7H8.5v-7Zm8.25 0H12v4.25h2.875a.625.625 0 1 1 0 1.25H12v1.5h2.875a2.125 2.125 0 0 0 0-4.25H13.5V10h3.25V8.5Z"/>'
      }, props)
  }
  export function RiMediaReplay15Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.385-4.5H8v2H2v-6h2V6a9.985 9.985 0 0 1 8-4ZM8.5 15.5v-7H10v7H8.5Zm3.5-7h4.75V10H13.5v1.25h1.375a2.125 2.125 0 0 1 0 4.25H12V14h2.875a.625.625 0 1 0 0-1.25H12V8.5Z"/>'
      }, props)
  }
  export function RiMediaReplay30Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12c0-5.523-4.477-10-10-10a9.977 9.977 0 0 0-7.553 3.446L2 3v6h4.75v1h2.625a.625.625 0 1 1 0 1.25H7.5v1.5h1.875a.625.625 0 1 1 0 1.25H6.75v1.5h2.625a2.125 2.125 0 0 0 1.62-3.5 2.125 2.125 0 0 0-1.62-3.5H7.5L5.865 6.865A8 8 0 1 1 4 12H2c0 5.523 4.477 10 10 10s10-4.477 10-10Zm-9.5-1.25a2.5 2.5 0 0 1 5 0v2.5a2.5 2.5 0 0 1-5 0v-2.5Zm2.5-1a1 1 0 0 0-1 1v2.5a1 1 0 1 0 2 0v-2.5a1 1 0 0 0-1-1Z"/>'
      }, props)
  }
  export function RiMediaReplay30Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12c0-5.523-4.477-10-10-10a9.985 9.985 0 0 0-8 4V3.5H2v6h4.75v.5h2.625a.625.625 0 1 1 0 1.25H7.5v1.5h1.875a.625.625 0 1 1 0 1.25H6.75v1.5h2.625a2.125 2.125 0 0 0 1.62-3.5 2.125 2.125 0 0 0-1.62-3.5H8v-1H5.385A8 8 0 1 1 4 12H2c0 5.523 4.477 10 10 10s10-4.477 10-10Zm-9.5-1.25a2.5 2.5 0 0 1 5 0v2.5a2.5 2.5 0 0 1-5 0v-2.5Zm2.5-1a1 1 0 0 0-1 1v2.5a1 1 0 1 0 2 0v-2.5a1 1 0 0 0-1-1Z"/>'
      }, props)
  }
  export function RiMediaReplay5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 12c0-5.523-4.477-10-10-10a9.977 9.977 0 0 0-7.553 3.446L2 3v6h6L5.865 6.865A8 8 0 1 1 4 12H2c0 5.523 4.477 10 10 10s10-4.477 10-10Zm-7.5-2V8.5h-5v4.25h3.125a.625.625 0 1 1 0 1.25H9.5v1.5h3.125a2.125 2.125 0 0 0 0-4.25H11V10h3.5Z"/>'
      }, props)
  }
  export function RiMediaReplay5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.385-4.5H8v2H2v-6h2V6a9.985 9.985 0 0 1 8-4ZM9.5 8.5h5V10H11v1.25h1.625a2.125 2.125 0 0 1 0 4.25H9.5V14h3.125a.625.625 0 1 0 0-1.25H9.5V8.5Z"/>'
      }, props)
  }
  export function RiMediaRewindFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.001 10.666 9.223-6.148a.5.5 0 0 1 .777.416v14.132a.5.5 0 0 1-.777.416L12 13.333v5.733a.5.5 0 0 1-.777.416L.625 12.416a.5.5 0 0 1 0-.832l10.599-7.066a.5.5 0 0 1 .777.416v5.732Z"/>'
      }, props)
  }
  export function RiMediaRewindLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.001 10.666 9.223-6.148a.5.5 0 0 1 .777.416v14.132a.5.5 0 0 1-.777.416L12 13.333v5.733a.5.5 0 0 1-.777.416L.625 12.416a.5.5 0 0 1 0-.832l10.599-7.066a.5.5 0 0 1 .777.416v5.732Zm-2 5.597V7.737L3.607 12 10 16.263Zm10 0V7.737L13.607 12 20 16.263Z"/>'
      }, props)
  }
  export function RiMediaRewindMiniFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 17.035a.5.5 0 0 1-.788.408l-7.133-5.035a.5.5 0 0 1 0-.817l7.133-5.035a.5.5 0 0 1 .788.409v10.07Zm1.079-4.627a.5.5 0 0 1 0-.817l7.133-5.035a.5.5 0 0 1 .788.409v10.07a.5.5 0 0 1-.788.408l-7.133-5.035Z"/>'
      }, props)
  }
  export function RiMediaRewindMiniLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 9.86 5.968 12 9 14.14V9.86Zm1.909 7.463a.5.5 0 0 1-.697.12l-7.133-5.035a.5.5 0 0 1 0-.817l7.133-5.035a.5.5 0 0 1 .788.409v10.07a.5.5 0 0 1-.091.288ZM18 14.14V9.86L14.968 12 18 14.14Zm-5.921-1.732a.5.5 0 0 1 0-.817l7.133-5.035a.5.5 0 0 1 .788.409v10.07a.5.5 0 0 1-.788.408l-7.133-5.035Z"/>'
      }, props)
  }
  export function RiMediaRhythmFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 9h2v12H2V9Zm6-6h2v18H8V3Zm6 9h2v9h-2v-9Zm6-6h2v15h-2V6Z"/>'
      }, props)
  }
  export function RiMediaRhythmLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 9h2v12H2V9Zm6-6h2v18H8V3Zm6 9h2v9h-2v-9Zm6-6h2v15h-2V6Z"/>'
      }, props)
  }
  export function RiMediaShuffleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 17.883V16l5 3-5 3v-2.09a9 9 0 0 1-6.997-5.365L11 14.54l-.003.006A9 9 0 0 1 2.725 20H2v-2h.725a7 7 0 0 0 6.434-4.243L9.912 12l-.753-1.757A7 7 0 0 0 2.725 6H2V4h.725a9 9 0 0 1 8.272 5.455L11 9.46l.003-.006A9 9 0 0 1 18 4.09V2l5 3-5 3V6.117a7 7 0 0 0-5.159 4.126L12.088 12l.753 1.757A7 7 0 0 0 18 17.883Z"/>'
      }, props)
  }
  export function RiMediaShuffleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 17.883V16l5 3-5 3v-2.09a9 9 0 0 1-6.997-5.365L11 14.54l-.003.006A9 9 0 0 1 2.725 20H2v-2h.725a7 7 0 0 0 6.434-4.243L9.912 12l-.753-1.757A7 7 0 0 0 2.725 6H2V4h.725a9 9 0 0 1 8.272 5.455L11 9.46l.003-.006A9 9 0 0 1 18 4.09V2l5 3-5 3V6.117a7 7 0 0 0-5.159 4.126L12.088 12l.753 1.757A7 7 0 0 0 18 17.883Z"/>'
      }, props)
  }
  export function RiMediaSkipBackFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m8 11.333 10.223-6.815a.5.5 0 0 1 .777.416v14.132a.5.5 0 0 1-.777.416L8 12.667V19a1 1 0 1 1-2 0V5a1 1 0 0 1 2 0v6.333Z"/>'
      }, props)
  }
  export function RiMediaSkipBackLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 4a1 1 0 0 1 1 1v6.333l10.223-6.815a.5.5 0 0 1 .777.416v14.132a.5.5 0 0 1-.777.416L8 12.667V19a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1Zm10 3.737L10.606 12 17 16.263V7.737Z"/>'
      }, props)
  }
  export function RiMediaSkipBackMiniFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Zm2.079 6.409a.5.5 0 0 1 0-.818l7.133-5.035a.5.5 0 0 1 .788.409v10.07a.5.5 0 0 1-.788.409l-7.133-5.035Z"/>'
      }, props)
  }
  export function RiMediaSkipBackMiniLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 6a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Zm8 8.14V9.86L11.968 12 15 14.14Zm-5.921-1.732a.5.5 0 0 1 0-.816l7.133-5.036a.5.5 0 0 1 .788.409v10.07a.5.5 0 0 1-.788.409l-7.133-5.035Z"/>'
      }, props)
  }
  export function RiMediaSkipForwardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 12.667 5.777 19.482A.5.5 0 0 1 5 19.066V4.934a.5.5 0 0 1 .777-.416L16 11.333V5a1 1 0 1 1 2 0v14a1 1 0 1 1-2 0v-6.333Z"/>'
      }, props)
  }
  export function RiMediaSkipForwardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 12.667 5.777 19.482A.5.5 0 0 1 5 19.066V4.934a.5.5 0 0 1 .777-.416L16 11.333V5a1 1 0 1 1 2 0v14a1 1 0 1 1-2 0v-6.333Zm-9-4.93v8.526L13.394 12 7 7.737Z"/>'
      }, props)
  }
  export function RiMediaSkipForwardMiniFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.788 17.444A.5.5 0 0 1 7 17.035V6.965a.5.5 0 0 1 .788-.409l7.133 5.035a.499.499 0 0 1 0 .818l-7.133 5.034ZM16 7a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0V7Z"/>'
      }, props)
  }
  export function RiMediaSkipForwardMiniLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.032 12 9 9.86v4.28L12.032 12ZM7.5 17.535a.5.5 0 0 1-.5-.5V6.965a.5.5 0 0 1 .788-.409l7.133 5.035a.499.499 0 0 1 0 .818l-7.133 5.034a.5.5 0 0 1-.288.092ZM16 7a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0V7Z"/>'
      }, props)
  }
  export function RiMediaSlowDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 13c0 2.21.895 4.21 2.343 5.657L4.93 20.07A9.969 9.969 0 0 1 2 13C2 7.477 6.477 3 12 3s10 4.477 10 10a9.97 9.97 0 0 1-2.929 7.071l-1.414-1.414A8 8 0 1 0 4 13Zm4.707-4.707L13.5 12.5l-2 2-4.207-4.793 1.414-1.414Z"/>'
      }, props)
  }
  export function RiMediaSlowDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 13c0 2.21.895 4.21 2.343 5.657L4.93 20.07A9.969 9.969 0 0 1 2 13C2 7.477 6.477 3 12 3s10 4.477 10 10a9.97 9.97 0 0 1-2.929 7.071l-1.414-1.414A8 8 0 1 0 4 13Zm4.707-4.707 4.5 4.5-1.414 1.414-4.5-4.5 1.414-1.414Z"/>'
      }, props)
  }
  export function RiMediaSoundModuleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 18v3h-2v-3h-2v-3h6v3h-2ZM5 18v3H3v-3H1v-3h6v3H5Zm6-12V3h2v3h2v3H9V6h2Zm0 5h2v10h-2V11Zm-8 2V3h2v10H3Zm16 0V3h2v10h-2Z"/>'
      }, props)
  }
  export function RiMediaSoundModuleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 18v3h-2v-3h-2v-2h6v2h-2ZM5 18v3H3v-3H1v-2h6v2H5Zm6-12V3h2v3h2v2H9V6h2Zm0 4h2v11h-2V10Zm-8 4V3h2v11H3Zm16 0V3h2v11h-2Z"/>'
      }, props)
  }
  export function RiMediaSpeaker2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm8 14a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0 2a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiMediaSpeaker2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 5v14h14V5H5ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm8 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 2a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMediaSpeaker3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm8 13a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0 2a6 6 0 1 0 0-12 6 6 0 0 0 0 12ZM6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm12 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6-5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiMediaSpeaker3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 5v14h14V5H5ZM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm3 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm10 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM7 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm5-3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0-4a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/>'
      }, props)
  }
  export function RiMediaSpeakerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm8 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiMediaSpeakerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 4v16h14V4H5ZM4 2h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm8 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 2a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-10.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiMediaSpeedFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 13.333-9.223 6.149A.5.5 0 0 1 2 19.066V4.934a.5.5 0 0 1 .777-.416L12 10.666V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832l-10.599 7.066a.5.5 0 0 1-.777-.416v-5.733Z"/>'
      }, props)
  }
  export function RiMediaSpeedLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 13.333-9.223 6.149A.5.5 0 0 1 2 19.066V4.934a.5.5 0 0 1 .777-.416L12 10.666V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832l-10.599 7.066a.5.5 0 0 1-.777-.416v-5.733ZM10.394 12 4 7.737v8.526L10.394 12ZM14 7.737v8.526L20.394 12 14 7.737Z"/>'
      }, props)
  }
  export function RiMediaSpeedMiniFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.788 17.443A.5.5 0 0 1 4 17.035V6.965a.5.5 0 0 1 .788-.409l7.133 5.035a.5.5 0 0 1 0 .817l-7.133 5.035ZM13 6.965a.5.5 0 0 1 .788-.409l7.133 5.035a.5.5 0 0 1 0 .817l-7.133 5.035a.5.5 0 0 1-.788-.408V6.965Z"/>'
      }, props)
  }
  export function RiMediaSpeedMiniLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.032 12 6 9.86v4.28L9.032 12Zm-4.244 5.443A.5.5 0 0 1 4 17.035V6.965a.5.5 0 0 1 .788-.409l7.133 5.035a.5.5 0 0 1 0 .817l-7.133 5.035ZM15 14.14 18.032 12 15 9.86v4.28Zm-2-7.175a.5.5 0 0 1 .788-.409l7.133 5.035a.5.5 0 0 1 0 .817l-7.133 5.035a.5.5 0 0 1-.788-.408V6.965Z"/>'
      }, props)
  }
  export function RiMediaSpeedUpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 13c0 2.21-.895 4.21-2.343 5.657l1.414 1.414A9.97 9.97 0 0 0 22 13c0-5.523-4.477-10-10-10S2 7.477 2 13a9.969 9.969 0 0 0 2.929 7.071l1.414-1.414A8 8 0 1 1 20 13Zm-4.707-4.707L10.5 12.5l2 2 4.207-4.793-1.414-1.414Z"/>'
      }, props)
  }
  export function RiMediaSpeedUpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 13c0 2.21-.895 4.21-2.343 5.657l1.414 1.414A9.97 9.97 0 0 0 22 13c0-5.523-4.477-10-10-10S2 7.477 2 13a9.969 9.969 0 0 0 2.929 7.071l1.414-1.414A8 8 0 1 1 20 13Zm-4.707-4.707-4.5 4.5 1.414 1.414 4.5-4.5-1.414-1.414Z"/>'
      }, props)
  }
  export function RiMediaStopCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10ZM9 9v6h6V9H9Z"/>'
      }, props)
  }
  export function RiMediaStopCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM9 9h6v6H9V9Z"/>'
      }, props)
  }
  export function RiMediaStopFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 5h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiMediaStopLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 7v10h10V7H7ZM6 5h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiMediaStopMiniFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 7v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1Z"/>'
      }, props)
  }
  export function RiMediaStopMiniLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Zm2 1v8h8V8H8Z"/>'
      }, props)
  }
  export function RiMediaSurroundSoundFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm4.05 4.121A6.978 6.978 0 0 0 5 12.071c0 1.933.784 3.683 2.05 4.95l1.414-1.414A4.984 4.984 0 0 1 7 12.07c0-1.38.56-2.63 1.464-3.535L7.05 7.12Zm9.9 0-1.414 1.415A4.984 4.984 0 0 1 17 12.07c0 1.38-.56 2.63-1.464 3.536l1.414 1.414A6.978 6.978 0 0 0 19 12.07a6.978 6.978 0 0 0-2.05-4.95ZM12 15.071a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/>'
      }, props)
  }
  export function RiMediaSurroundSoundLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 5v14h16V5H4ZM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm4.05 4.121 1.414 1.415A4.984 4.984 0 0 0 7 12.07c0 1.38.56 2.63 1.464 3.536L7.05 17.02A6.978 6.978 0 0 1 5 12.07c0-1.933.784-3.683 2.05-4.95Zm9.9 0a6.978 6.978 0 0 1 2.05 4.95 6.978 6.978 0 0 1-2.05 4.95l-1.414-1.414A4.984 4.984 0 0 0 17 12.07c0-1.38-.56-2.63-1.464-3.535L16.95 7.12ZM12 13.071a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiMediaTapeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.83 13A3 3 0 1 0 8 15h8a3 3 0 1 0-2.83-2h-2.34ZM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm13 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/>'
      }, props)
  }
  export function RiMediaTapeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.83 13h2.34A3 3 0 1 1 16 15H8a3 3 0 1 1 2.83-2ZM4 5v14h16V5H4ZM3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm5 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiMediaVideoAddFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14ZM8 8v3H5v2h2.999L8 16h2l-.001-3H13v-2h-3V8H8Z"/>'
      }, props)
  }
  export function RiMediaVideoAddLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14Zm-1 2H3v12h12V6ZM8 8h2v3h3v2H9.999L10 16H8l-.001-3H5v-2h3V8Zm13 .841-4 2.8v.718l4 2.8V8.84Z"/>'
      }, props)
  }
  export function RiMediaVideoDownloadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14Zm-6 4H8v4H5l4 4 4-4h-3V8Z"/>'
      }, props)
  }
  export function RiMediaVideoDownloadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14Zm-1 2H3v12h12V6Zm-5 2v4h3l-4 4-4-4h3V8h2Zm11 .841-4 2.8v.718l4 2.8V8.84Z"/>'
      }, props)
  }
  export function RiMediaVideoFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 20.007V3.993Zm7.622 4.422a.4.4 0 0 0-.622.332v6.506a.4.4 0 0 0 .622.332l4.879-3.252a.401.401 0 0 0 0-.666l-4.88-3.252Z"/>'
      }, props)
  }
  export function RiMediaVideoLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.993.993 0 0 1 3 20.007V3.993ZM5 5v14h14V5H5Zm5.622 3.415 4.879 3.252a.4.4 0 0 1 0 .666l-4.88 3.252a.4.4 0 0 1-.621-.332V8.747a.4.4 0 0 1 .622-.332Z"/>'
      }, props)
  }
  export function RiMediaVideoUploadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14ZM9 8l-4 4h3v4h2v-4h3L9 8Z"/>'
      }, props)
  }
  export function RiMediaVideoUploadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 4a1 1 0 0 1 1 1v4.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14Zm-1 2H3v12h12V6ZM9 8l4 4h-3v4H8v-4H5l4-4Zm12 .841-4 2.8v.718l4 2.8V8.84Z"/>'
      }, props)
  }
  export function RiMediaVidicon2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 6V4H5V2h10v4h1a1 1 0 0 1 1 1v2.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h11Zm-8 4v2h2v-2H5Z"/>'
      }, props)
  }
  export function RiMediaVidicon2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 6V4H5V2h10v4h1a1 1 0 0 1 1 1v2.2l5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h11Zm2 2H3v10h12V8Zm2 4.359 4 2.8V8.84l-4 2.8v.718ZM5 10h2v2H5v-2Z"/>'
      }, props)
  }
  export function RiMediaVidiconFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17 9.2 5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v4.2ZM5 8v2h2V8H5Z"/>'
      }, props)
  }
  export function RiMediaVidiconLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17 9.2 5.213-3.65a.5.5 0 0 1 .787.41v12.08a.5.5 0 0 1-.787.41L17 14.8V19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v4.2Zm0 3.159 4 2.8V8.84l-4 2.8v.718ZM3 6v12h12V6H3Zm2 2h2v2H5V8Z"/>'
      }, props)
  }
  export function RiMediaVoiceprintFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 7h2v10H5V7Zm-4 3h2v4H1v-4Zm8-8h2v18H9V2Zm4 2h2v18h-2V4Zm4 3h2v10h-2V7Zm4 3h2v4h-2v-4Z"/>'
      }, props)
  }
  export function RiMediaVoiceprintLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 7h2v10H5V7Zm-4 3h2v4H1v-4Zm8-8h2v18H9V2Zm4 2h2v18h-2V4Zm4 3h2v10h-2V7Zm4 3h2v4h-2v-4Z"/>'
      }, props)
  }
  export function RiMediaVolumeDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.889 16H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387L8.89 16Zm9.974.591-1.422-1.422A3.994 3.994 0 0 0 19 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.991 5.991 0 0 1 21 12c0 1.842-.83 3.49-2.137 4.591Z"/>'
      }, props)
  }
  export function RiMediaVolumeDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 7.22 9.603 10H6v4h3.603L13 16.78V7.22ZM8.889 16H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387L8.89 16Zm9.974.591-1.422-1.422A3.994 3.994 0 0 0 19 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.991 5.991 0 0 1 21 12c0 1.842-.83 3.49-2.137 4.591Z"/>'
      }, props)
  }
  export function RiMediaVolumeMuteFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.889 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387L5.89 16Zm14.525-4 3.536 3.536-1.415 1.414L19 13.414l-3.536 3.536-1.414-1.414L17.586 12 14.05 8.465l1.414-1.415L19 10.586l3.535-3.536 1.415 1.415L20.414 12Z"/>'
      }, props)
  }
  export function RiMediaVolumeMuteLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 7.22 6.603 10H3v4h3.603L10 16.78V7.22ZM5.889 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387L5.89 16Zm14.525-4 3.536 3.536-1.415 1.414L19 13.414l-3.536 3.536-1.414-1.414L17.586 12 14.05 8.465l1.414-1.415L19 10.586l3.535-3.536 1.415 1.415L20.414 12Z"/>'
      }, props)
  }
  export function RiMediaVolumeOffVibrateFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19.39 3.161 1.414 1.414L18.33 7.05l2.475 2.475L18.33 12l2.475 2.476-2.475 2.475 2.475 2.475-1.414 1.414-3.889-3.89 2.475-2.474L15.5 12l2.475-2.475L15.5 7.05l3.89-3.889Zm-6.389 16.784a.5.5 0 0 1-.817.387L6.89 15.999 3.001 16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1l2.584-.002-3.776-3.776 1.414-1.414L13 12.586v7.359Zm-.113-16.206a.5.5 0 0 1 .113.316v5.702L9.283 6.04l2.901-2.372a.5.5 0 0 1 .704.07Z"/>'
      }, props)
  }
  export function RiMediaVolumeOffVibrateLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19.39 3.161 1.414 1.414L18.33 7.05l2.475 2.475L18.33 12l2.475 2.476-2.475 2.475 2.475 2.475-1.414 1.414-3.889-3.89 2.475-2.474L15.5 12l2.475-2.475L15.5 7.05l3.89-3.889Zm-6.389 16.784a.5.5 0 0 1-.817.387L6.89 15.999 3.001 16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1l2.584-.002-3.776-3.776 1.414-1.414L13 12.586v7.359ZM7.585 9.998 4.001 10V14l3.603-.001L11 16.779v-3.365L7.585 9.998Zm5.303-6.26a.5.5 0 0 1 .113.317v5.702l-2-2V7.22l-.296.241-1.421-1.42 2.9-2.373a.5.5 0 0 1 .704.07Z"/>'
      }, props)
  }
  export function RiMediaVolumeUpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 16h3.889l5.294 4.332a.5.5 0 0 0 .817-.387V4.055a.5.5 0 0 0-.817-.387L5.89 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1Zm21-4c0 3.292-1.446 6.246-3.738 8.262l-1.418-1.418A8.98 8.98 0 0 0 21 12a8.98 8.98 0 0 0-3.155-6.844l1.417-1.418A10.974 10.974 0 0 1 23 12Zm-5 0a5.99 5.99 0 0 0-2.287-4.713l-1.429 1.429A3.996 3.996 0 0 1 16 12c0 1.36-.679 2.561-1.716 3.284l1.43 1.43A5.99 5.99 0 0 0 18 12Z"/>'
      }, props)
  }
  export function RiMediaVolumeUpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.603 10 10 7.22v9.56L6.603 14H3v-4h3.603ZM2 16h3.889l5.294 4.332a.5.5 0 0 0 .817-.387V4.055a.5.5 0 0 0-.817-.387L5.89 8H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1Zm21-4c0 3.292-1.446 6.246-3.738 8.262l-1.418-1.418A8.98 8.98 0 0 0 21 12a8.98 8.98 0 0 0-3.155-6.844l1.417-1.418A10.974 10.974 0 0 1 23 12Zm-5 0a5.99 5.99 0 0 0-2.287-4.713l-1.429 1.429A3.996 3.996 0 0 1 16 12c0 1.36-.679 2.561-1.716 3.284l1.43 1.43A5.99 5.99 0 0 0 18 12Z"/>'
      }, props)
  }
  export function RiMediaVolumeVibrateFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19.39 3.161 1.413 1.414-2.475 2.475 2.475 2.475L18.328 12l2.475 2.476-2.475 2.475 2.475 2.475-1.414 1.414-3.889-3.89 2.475-2.474L15.5 12l2.475-2.475L15.5 7.05l3.89-3.889Zm-6.503.577a.5.5 0 0 1 .113.317v15.89a.5.5 0 0 1-.817.387L6.89 15.999 3 16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .704.07Z"/>'
      }, props)
  }
  export function RiMediaVolumeVibrateLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19.39 3.161 1.413 1.414-2.475 2.475 2.475 2.475L18.328 12l2.475 2.476-2.475 2.475 2.475 2.475-1.414 1.414-3.889-3.89 2.475-2.474L15.5 12l2.475-2.475L15.5 7.05l3.89-3.889Zm-6.503.577a.5.5 0 0 1 .113.317v15.89a.5.5 0 0 1-.817.387L6.89 15.999 3 16a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .704.07ZM11 7.22 7.603 9.999H4V14l3.603-.001L11 16.779V7.22Z"/>'
      }, props)
  }
  export function RiMediaWebcamFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 21v-1.07A7.001 7.001 0 0 1 5 13V8a7 7 0 0 1 14 0v5a7.001 7.001 0 0 1-6 6.93V21h4v2H7v-2h4Zm1-12a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiMediaWebcamLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 21v-1.07A7.001 7.001 0 0 1 5 13V8a7 7 0 0 1 14 0v5a7.001 7.001 0 0 1-6 6.93V21h4v2H7v-2h4Zm1-18a5 5 0 0 0-5 5v5a5 5 0 0 0 10 0V8a5 5 0 0 0-5-5Zm0 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 2a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiOthersBasketballFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.366 13.366 1.775 1.025a9.98 9.98 0 0 0-.311 7.44A9.91 9.91 0 0 1 12 22a9.964 9.964 0 0 1-4.11-.88l4.476-7.754Zm3.518 2.032 4.233 2.444a10.033 10.033 0 0 1-4.363 3.43 7.988 7.988 0 0 1 .008-5.57l.121-.304Zm-7.025-4.056 1.775 1.024-4.476 7.75a10.026 10.026 0 0 1-3.59-4.785 9.977 9.977 0 0 0 6.085-3.713l.206-.276Zm13.046-.726c.063.453.095.915.095 1.384a9.964 9.964 0 0 1-.88 4.11l-4.236-2.445a7.985 7.985 0 0 1 4.866-3.021l.155-.027ZM2.881 7.892l4.235 2.445a7.99 7.99 0 0 1-5.021 3.05A10.138 10.138 0 0 1 2 12c0-1.465.315-2.856.88-4.11Zm14.961-4.008a10.026 10.026 0 0 1 3.59 4.785 9.984 9.984 0 0 0-6.086 3.715l-.205.276-1.775-1.025 4.476-7.75ZM12 2c1.465 0 2.856.315 4.11.88l-4.476 7.754L9.859 9.61a9.98 9.98 0 0 0 .311-7.442A9.921 9.921 0 0 1 12 2Zm-3.753.73a7.992 7.992 0 0 1-.01 5.57l-.12.303-4.234-2.445a10.036 10.036 0 0 1 4.164-3.346l.2-.083Z"/>'
      }, props)
  }
  export function RiOthersBasketballLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm.366 11.366-3.469 6.01a8.056 8.056 0 0 0 4.459.51 9.938 9.938 0 0 1 .784-5.494l-1.774-1.026Zm3.518 2.031a7.957 7.957 0 0 0-.587 3.894 8.022 8.022 0 0 0 3.078-2.456l-2.492-1.438Zm-7.025-4.055a9.95 9.95 0 0 1-4.365 3.428 8.01 8.01 0 0 0 2.671 3.605l3.469-6.009-1.775-1.024Zm11.103-.13-.258.12a7.946 7.946 0 0 0-2.82 2.333l2.492 1.439a7.976 7.976 0 0 0 .586-3.893ZM4 12c0 .266.013.53.038.789a7.95 7.95 0 0 0 3.078-2.454L4.624 8.897A7.975 7.975 0 0 0 4 12Zm12.835-6.374-3.469 6.008 1.775 1.025a9.951 9.951 0 0 1 4.366-3.43 8.015 8.015 0 0 0-2.419-3.402l-.253-.201ZM12 4c-.463 0-.916.04-1.357.115a9.928 9.928 0 0 1-.784 5.494l1.775 1.025 3.469-6.01A7.975 7.975 0 0 0 12 4Zm-3.297.71-.191.088a8.033 8.033 0 0 0-2.886 2.367l2.49 1.438a7.956 7.956 0 0 0 .587-3.893Z"/>'
      }, props)
  }
  export function RiOthersBellFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.414 10.586.48.486.464.485.46.492c3.458 3.764 5.472 7.218 4.607 8.083-.4.4-1.356.183-2.64-.508a9.007 9.007 0 0 1-10.403-.591l2.98-2.98a2 2 0 1 0-1.45-1.57l.035.156-2.979 2.98a9.007 9.007 0 0 1-.592-10.405c-.692-1.283-.908-2.238-.508-2.639.977-.976 5.25 1.715 9.546 6.01Zm6.364-6.364a2 2 0 0 1-.165 2.976 9.015 9.015 0 0 1 .608 8.47c-1.189-1.955-3.07-4.174-5.393-6.497l-.537-.531c-2.128-2.079-4.156-3.765-5.958-4.861a9.015 9.015 0 0 1 8.471.608 2 2 0 0 1 2.974-.165Z"/>'
      }, props)
  }
  export function RiOthersBellLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.121 9.879c4.296 4.295 6.829 8.728 5.657 9.899-.475.475-1.486.341-2.807-.273a9.008 9.008 0 0 1-10.59-.473l-.038.039-1.414-1.414.038-.04A9.006 9.006 0 0 1 4.495 7.03c-.614-1.322-.748-2.333-.273-2.808 1.128-1.128 5.277 1.177 9.417 5.182l.482.475Zm-1.414 1.414C10.823 9.409 8.87 7.842 7.236 6.869l-.186.181a7.002 7.002 0 0 0-.657 9.142l1.846-1.846a2 2 0 0 1 3.347-1.932 2 2 0 0 1-1.931 3.347l-1.848 1.846a7.001 7.001 0 0 0 9.143-.657l.179-.188-.053-.089c-.976-1.615-2.52-3.53-4.369-5.38Zm7.071-7.071a2 2 0 0 1-.165 2.976 9.015 9.015 0 0 1 .663 8.345 21.16 21.16 0 0 0-1.386-2.306 6.99 6.99 0 0 0-1.94-6.187 6.992 6.992 0 0 0-6.187-1.94 21.096 21.096 0 0 0-2.306-1.386 9.017 9.017 0 0 1 8.347.663 2 2 0 0 1 2.974-.165Z"/>'
      }, props)
  }
  export function RiOthersBilliardsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm0 1.75a2.5 2.5 0 0 1 1.88 4.148c.565.456.92 1.117.92 1.852 0 1.38-1.254 2.5-2.8 2.5-1.546 0-2.8-1.12-2.8-2.5 0-.735.355-1.396.92-1.853A2.5 2.5 0 0 1 12 7.75Zm0 5c-.754 0-1.3.488-1.3 1s.546 1 1.3 1 1.3-.488 1.3-1-.546-1-1.3-1Zm0-3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiOthersBilliardsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 2a6 6 0 1 1 0 12 6 6 0 0 1 0-12Zm0 1.75a2.5 2.5 0 0 0-1.88 4.147c-.565.457-.92 1.118-.92 1.853 0 1.38 1.254 2.5 2.8 2.5 1.546 0 2.8-1.12 2.8-2.5 0-.735-.355-1.396-.92-1.852A2.5 2.5 0 0 0 12 7.75Zm0 5c.754 0 1.3.488 1.3 1s-.546 1-1.3 1-1.3-.488-1.3-1 .546-1 1.3-1Zm0-3.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"/>'
      }, props)
  }
  export function RiOthersBox1Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 9.5 5.5v11L13 22.421V11.423l-9.502-5.5L12 1ZM2.5 7.655V17.5l8.5 4.921v-9.845l-8.5-4.92Z"/>'
      }, props)
  }
  export function RiOthersBox1Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 9.5 5.5v11L12 23l-9.5-5.5v-11L12 1ZM5.494 7.078 13 11.423v8.687l6.5-3.763V7.653L12 3.311 5.494 7.078ZM4.5 8.813v7.534L11 20.11v-7.534L4.5 8.813Z"/>'
      }, props)
  }
  export function RiOthersBox2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 9.5 5.5v11L12 23l-9.5-5.5v-11L12 1ZM4.5 7.658v8.689l7.5 4.342V12L4.5 7.658Z"/>'
      }, props)
  }
  export function RiOthersBox2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 9.5 5.5v11L12 23l-9.5-5.5v-11L12 1ZM4.5 7.653v.005L12 12v8.689l7.5-4.342V7.653L12 3.311 4.5 7.653Z"/>'
      }, props)
  }
  export function RiOthersBox3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.502 5.922 12 1 3.498 5.922 12 10.845l8.502-4.923ZM2.5 7.656V17.5l8.5 4.921v-9.845l-8.5-4.92ZM13 22.42l8.5-4.921V7.655L13 12.576v9.845Z"/>'
      }, props)
  }
  export function RiOthersBox3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 9.5 5.5v11L12 23l-9.5-5.5v-11L12 1ZM5.494 7.078 12 10.844l6.506-3.766L12 3.31 5.494 7.078ZM4.5 8.813v7.534L11 20.11v-7.534L4.5 8.813ZM13 20.11l6.5-3.763V8.813L13 12.576v7.534Z"/>'
      }, props)
  }
  export function RiOthersBoxingFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m9.501 11 .144.007a1.5 1.5 0 0 1 1.35 1.348L11 12.5l-.007.145a1.5 1.5 0 0 1-1.349 1.348L9.501 14h-3.5v2h3.5c1.7 0 3.117-1.212 3.434-2.819l.03-.18L19.001 13c.711 0 1.388-.149 2-.416V17a3.001 3.001 0 0 1-2 2.829V21a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-1.17a3.001 3.001 0 0 1-2-2.83v-4a2 2 0 0 1 2-2h4.5Zm12.5-3.5V8l-.005.176a3 3 0 0 1-2.819 2.819l-.176.005h-6.337A3.501 3.501 0 0 0 9.71 9.006L9.5 9h-4.5c-.729 0-1.412.195-2.001.536L3.001 6a4 4 0 0 1 4-4h9.5a5.5 5.5 0 0 1 5.5 5.5Z"/>'
      }, props)
  }
  export function RiOthersBoxingLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16.5 2A5.5 5.5 0 0 1 22 7.5V10c0 .888-.386 1.686-1 2.235V17a3.001 3.001 0 0 1-2 2.829V21a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-1.17A3.001 3.001 0 0 1 3 17V6a4 4 0 0 1 4-4h9.5Zm-7 9H5v6a1 1 0 0 0 .883.993L6 18h12a1 1 0 0 0 .993-.883L19 17v-4h-6.036A3.5 3.5 0 0 1 9.5 16H6v-2h3.5a1.5 1.5 0 0 0 1.493-1.355L11 12.5a1.5 1.5 0 0 0-1.356-1.493L9.5 11Zm7-7H7a2 2 0 0 0-1.995 1.85L5 6v3h4.5a3.5 3.5 0 0 1 3.163 2H19a1 1 0 0 0 .993-.883L20 10V7.5a3.5 3.5 0 0 0-3.308-3.495L16.5 4Z"/>'
      }, props)
  }
  export function RiOthersCactusFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.998 2a4 4 0 0 1 4 4v9h1c.55 0 1-.45 1-1V8a1 1 0 0 1 2 0v6a3 3 0 0 1-3 3h-1v3h2v2h-12v-2h2v-6h-1a3 3 0 0 1-3-3V9a1 1 0 1 1 2 0v2c0 .55.45 1 1 1h1V6a4 4 0 0 1 4-4Z"/>'
      }, props)
  }
  export function RiOthersCactusLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.998 2a4 4 0 0 1 4 4v9h1c.55 0 1-.45 1-1V8a1 1 0 0 1 2 0v6c0 1.66-1.34 3-3 3h-1v3h2v2h-12v-2h2v-6h-1a3 3 0 0 1-3-3V9a1 1 0 1 1 2 0v2c0 .55.45 1 1 1h1V6a4 4 0 0 1 4-4Zm0 2a2 2 0 0 0-2 2v14h4V6a2 2 0 0 0-2-2Z"/>'
      }, props)
  }
  export function RiOthersCake2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 6v3.999h3V6h2v3.999h3V6h2v3.999L19 10a3 3 0 0 1 2.995 2.824L22 13v1c0 1.014-.377 1.94-.999 2.645L21 21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4.36a4.024 4.024 0 0 1-.972-2.182l-.022-.253L2 14v-1a3 3 0 0 1 2.824-2.995L5 10l1-.001V6h2Zm11 6H5a1 1 0 0 0-.993.883L4 13v.971l.003.147A2 2 0 0 0 6 16a1.999 1.999 0 0 0 1.98-1.7l.015-.153.005-.176c.036-1.248 1.827-1.293 1.989-.134l.01.134.004.147a2 2 0 0 0 3.992.031l.012-.282c.124-1.156 1.862-1.156 1.986 0l.013.282a2 2 0 0 0 3.988 0L20 14v-1a1 1 0 0 0-.883-.993L19 12ZM7 1c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 0 1-2.898-.776C5.85 2.002 7 2.5 7 1Zm5 0c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 1 1-2.898-.776C10.85 2.002 12 2.5 12 1Zm5 0c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 1 1-2.898-.776C15.85 2.002 17 2.5 17 1Z"/>'
      }, props)
  }
  export function RiOthersCake2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 6v3.999h3V6h2v3.999h3V6h2v3.999L19 10a3 3 0 0 1 2.995 2.824L22 13v1c0 1.014-.377 1.94-.999 2.645L21 21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4.36a4.024 4.024 0 0 1-.972-2.182l-.022-.253L2 14v-1a3 3 0 0 1 2.824-2.995L5 10l1-.001V6h2Zm1.002 10.641-.054.063a3.994 3.994 0 0 1-2.514 1.273l-.23.018L6 18c-.345 0-.68-.044-1-.126V20h14v-2.126a4.007 4.007 0 0 1-3.744-.963l-.15-.15-.106-.117-.107.118a3.99 3.99 0 0 1-2.451 1.214l-.242.02L12 18a3.977 3.977 0 0 1-2.797-1.144l-.15-.157-.051-.058ZM19 12H5a1 1 0 0 0-.993.883L4 13v.971l.003.147A2 2 0 0 0 6 16a1.999 1.999 0 0 0 1.98-1.7l.015-.153.005-.176c.036-1.248 1.827-1.293 1.989-.134l.01.134.004.147a2 2 0 0 0 3.992.031l.012-.282c.124-1.156 1.862-1.156 1.986 0l.013.282a2 2 0 0 0 3.988 0L20 14v-1a1 1 0 0 0-.883-.993L19 12ZM7 1c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 0 1-2.898-.776C5.85 2.002 7 2.5 7 1Zm5 0c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 1 1-2.898-.776C10.85 2.002 12 2.5 12 1Zm5 0c1.32.871 1.663 2.088 1.449 2.888a1.5 1.5 0 1 1-2.898-.776C15.85 2.002 17 2.5 17 1Z"/>'
      }, props)
  }
  export function RiOthersCake3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.5 2a3.5 3.5 0 0 1 3.437 4.163l-.015.066a4.502 4.502 0 0 1 .303 8.428l-1.086 6.507a1 1 0 0 1-.986.836H6.847a1 1 0 0 1-.986-.836l-1.029-6.17a3 3 0 0 1-.829-5.824L4 9a6 6 0 0 1 8.575-5.42A3.493 3.493 0 0 1 15.5 2ZM11 15H9v5h2v-5Zm4 0h-2v5h2v-5Zm2.5-2a2.5 2.5 0 1 0-.956-4.81l-.175.081a2 2 0 0 1-2.663-.804l-.07-.137A4 4 0 0 0 10 5C7.858 5 6.109 6.684 6.005 8.767L6 8.964l.003.17a2 2 0 0 1-1.186 1.863l-.15.059A1.001 1.001 0 0 0 5 13h12.5Z"/>'
      }, props)
  }
  export function RiOthersCake3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.5 2a3.5 3.5 0 0 1 3.437 4.163l-.015.066a4.502 4.502 0 0 1 .303 8.428l-1.086 6.507a1 1 0 0 1-.986.836H6.847a1 1 0 0 1-.986-.836l-1.029-6.17a3 3 0 0 1-.829-5.824L4 9a6 6 0 0 1 8.574-5.421A3.496 3.496 0 0 1 15.5 2ZM9 15H6.86l.834 5H9v-5Zm4 0h-2v5h2v-5Zm4.139 0H15v5h1.305l.834-5ZM10 5C7.858 5 6.109 6.684 6.005 8.767L6 8.964l.003.17a2 2 0 0 1-1.186 1.863l-.15.059A1.001 1.001 0 0 0 5 13h12.5a2.5 2.5 0 1 0-.956-4.81l-.175.081a2 2 0 0 1-2.663-.804l-.07-.137A4 4 0 0 0 10 5Zm5.5-1a1.5 1.5 0 0 0-1.287.729 6.006 6.006 0 0 1 1.24 1.764c.444-.228.93-.384 1.446-.453A1.5 1.5 0 0 0 15.5 4Z"/>'
      }, props)
  }
  export function RiOthersCakeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 7v4h7a1 1 0 0 1 1 1v8h2v2H1v-2h2v-8a1 1 0 0 1 1-1h7V7h2Zm.83-6.598A3 3 0 0 1 12.732 4.5L11 5.5a3 3 0 0 1 1.098-4.098l1.732-1Z"/>'
      }, props)
  }
  export function RiOthersCakeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 7v4h7a1 1 0 0 1 1 1v8h2v2H1v-2h2v-8a1 1 0 0 1 1-1h7V7h2Zm6 6H5v7h14v-7ZM13.83.402A3 3 0 0 1 12.732 4.5L11 5.5a3 3 0 0 1 1.098-4.098l1.732-1Z"/>'
      }, props)
  }
  export function RiOthersCandleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.172 9.331a4 4 0 0 1 0-5.656L12 .846l2.828 2.829A4 4 0 0 1 13 10.377V12h5a1 1 0 0 1 1 1v7h2v2H3v-2h2v-7a1 1 0 0 1 1-1h5v-1.623A3.982 3.982 0 0 1 9.172 9.33Zm1.414-4.242a2 2 0 1 0 2.828 0L12 3.675l-1.414 1.414Z"/>'
      }, props)
  }
  export function RiOthersCandleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.172 9.331a4 4 0 0 1 0-5.656L12 .846l2.828 2.829A4 4 0 0 1 13 10.377V12h5a1 1 0 0 1 1 1v7h2v2H3v-2h2v-7a1 1 0 0 1 1-1h5v-1.623A3.982 3.982 0 0 1 9.172 9.33Zm1.414-4.242a2 2 0 1 0 2.828 0L12 3.675l-1.414 1.414ZM7 14v6h10v-6H7Z"/>'
      }, props)
  }
  export function RiOthersCharacterRecognitionFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.998 3v18h-18V3h18Zm-8.001 3h-2L6.598 17h2.154l1.199-3h4.09l1.201 3h2.155l-4.4-11Zm-1 2.885L13.242 12H10.75l1.247-3.115Z"/>'
      }, props)
  }
  export function RiOthersCharacterRecognitionLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.998 15v4h4v2h-6v-6h2Zm16 0v6h-6v-2h4v-4h2Zm-8.001-9 4.4 11h-2.155l-1.201-3h-4.09l-1.199 3H6.598l4.399-11h2Zm-1 2.885L10.75 12h2.492l-1.245-3.115ZM8.998 3v2h-4v4h-2V3h6Zm12 0v6h-2V5h-4V3h6Z"/>'
      }, props)
  }
  export function RiOthersCrossFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 2h-4v6H4v4h6v10h4V12h6V8h-6V2Z"/>'
      }, props)
  }
  export function RiOthersCrossLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 2h6v5h5v6h-5v9H9v-9H4V7h5V2Zm2 2v5H6v2h5v9h2v-9h5V9h-5V4h-2Z"/>'
      }, props)
  }
  export function RiOthersDoorClosedFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.998 21v-2h2V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v15h2v2h-18Zm12-10h-2v2h2v-2Z"/>'
      }, props)
  }
  export function RiOthersDoorClosedLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.998 21v-2h2V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v15h2v2h-18Zm14-16h-10v14h10V5Zm-2 6v2h-2v-2h2Z"/>'
      }, props)
  }
  export function RiOthersDoorFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.998 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12Zm-4 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiOthersDoorLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.998 3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12Zm-1 2h-10v14h10V5Zm-2 6v2h-2v-2h2Z"/>'
      }, props)
  }
  export function RiOthersDoorLockBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm7 9.792V16h2v-3.208a2.5 2.5 0 1 0-2 0Z"/>'
      }, props)
  }
  export function RiOthersDoorLockBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h14V5H5Zm6 7.792a2.5 2.5 0 1 1 2 0V16h-2v-3.208Z"/>'
      }, props)
  }
  export function RiOthersDoorLockFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-1-9.208V16h2v-3.208a2.5 2.5 0 1 0-2 0Z"/>'
      }, props)
  }
  export function RiOthersDoorLockLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1-7.208a2.5 2.5 0 1 1 2 0V16h-2v-3.208Z"/>'
      }, props)
  }
  export function RiOthersDoorOpenFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1.998 21v-2h2V4.835a1 1 0 0 1 .821-.984l9.472-1.722a.6.6 0 0 1 .707.59V4h4a1 1 0 0 1 1 1v14h2v2h-4V6h-3v15h-13Zm10-10h-2v2h2v-2Z"/>'
      }, props)
  }
  export function RiOthersDoorOpenLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1.998 21v-2h2V4.835a1 1 0 0 1 .821-.984l9.472-1.722a.6.6 0 0 1 .707.59V4h4a1 1 0 0 1 1 1v14h2v2h-4V6h-3v15h-13Zm11-16.603-7 1.272V19h7V4.397Zm-1 6.603v2h-2v-2h2Z"/>'
      }, props)
  }
  export function RiOthersFootballFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm1.67 14h-3.34l-1.38 1.897.554 1.706A7.993 7.993 0 0 0 12 20c.871 0 1.71-.14 2.496-.397l.553-1.706L13.669 16Zm-8.376-5.128-1.292.938L4 12c0 1.73.549 3.331 1.482 4.64h1.91l1.323-1.82-1.028-3.17-2.393-.778Zm13.412 0-2.393.778-1.028 3.17 1.322 1.82h1.91A7.963 7.963 0 0 0 20 12l-.003-.191-1.291-.937ZM14.29 4.333 13 5.273V7.79l2.694 1.957 2.24-.727.554-1.703a8.014 8.014 0 0 0-4.196-2.984Zm-4.582 0a8.014 8.014 0 0 0-4.196 2.985l.554 1.702 2.239.727L11 7.79V5.273l-1.291-.94Z"/>'
      }, props)
  }
  export function RiOthersFootballLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm1.67 14h-3.34l-1.38 1.897.554 1.706A7.993 7.993 0 0 0 12 20c.871 0 1.71-.14 2.496-.397l.553-1.706L13.669 16Zm-8.376-5.128-1.292.938L4 12c0 1.73.549 3.331 1.482 4.64h1.91l1.323-1.82-1.028-3.17-2.393-.778Zm13.412 0-2.393.778-1.028 3.17 1.322 1.82h1.91A7.963 7.963 0 0 0 20 12l-.003-.19-1.291-.938ZM12 9.536l-2.344 1.702.896 2.762h2.895l.896-2.762L12 9.536Zm2.291-5.203L13 5.273V7.79l2.694 1.957 2.24-.727.554-1.703a8.014 8.014 0 0 0-4.196-2.984Zm-4.583 0a8.014 8.014 0 0 0-4.195 2.985l.554 1.702 2.239.727L11 7.79V5.273l-1.292-.94Z"/>'
      }, props)
  }
  export function RiOthersFridgeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.998 12v10a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V12h16Zm-11 2h-2v5h2v-5Zm10-13a1 1 0 0 1 1 1v8h-16V2a1 1 0 0 1 1-1h14Zm-10 3h-2v4h2V4Z"/>'
      }, props)
  }
  export function RiOthersFridgeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.998 1a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h14Zm-1 11h-12v9h12v-9Zm-8 2v4h-2v-4h2Zm8-11h-12v7h12V3Zm-8 2v3h-2V5h2Z"/>'
      }, props)
  }
  export function RiOthersGameFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a9.98 9.98 0 0 1 7.743 3.671L13.414 12l6.329 6.329A9.98 9.98 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2Zm0 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>'
      }, props)
  }
  export function RiOthersGameLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a9.98 9.98 0 0 1 7.743 3.671L13.414 12l6.329 6.329A9.98 9.98 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2Zm0 2a8 8 0 1 0 4.697 14.477l.208-.157-6.32-6.32 6.32-6.321-.208-.156a7.965 7.965 0 0 0-4.394-1.517L12 4Zm0 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>'
      }, props)
  }
  export function RiOthersGraduationCapFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2 0 9l12 7 10-5.833V17.5h2V9L12 2ZM3.999 13.49V18a9.985 9.985 0 0 0 8 4A9.985 9.985 0 0 0 20 18v-4.509l-8 4.667L4 13.49Z"/>'
      }, props)
  }
  export function RiOthersGraduationCapLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 11.333 0 9l12-7 12 7v8.5h-2v-7.333l-2 1.166v6.678l-.223.275A9.983 9.983 0 0 1 12 22a9.983 9.983 0 0 1-7.777-3.714L4 18.011v-6.678ZM6 12.5v4.792A7.979 7.979 0 0 0 12 20a7.978 7.978 0 0 0 6-2.708V12.5L12 16l-6-3.5ZM3.97 9 12 13.685 20.03 9 12 4.315 3.97 9Z"/>'
      }, props)
  }
  export function RiOthersHandbagFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a7 7 0 0 1 7 7h1.074a1 1 0 0 1 .997.923l.846 11a1 1 0 0 1-.92 1.074L20.92 22H3.08a1 1 0 0 1-1-1l.003-.077.846-11A1 1 0 0 1 3.926 9H5a7 7 0 0 1 7-7Zm2 11h-4v2h4v-2Zm-2-9a5 5 0 0 0-4.995 4.783L7 9h10a5 5 0 0 0-4.783-4.995L12 4Z"/>'
      }, props)
  }
  export function RiOthersHandbagLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a7 7 0 0 1 7 7h1.074a1 1 0 0 1 .997.923l.846 11a1 1 0 0 1-.92 1.074L20.92 22H3.08a1 1 0 0 1-1-1l.003-.077.846-11A1 1 0 0 1 3.926 9H5a7 7 0 0 1 7-7Zm7.147 9H4.852l-.693 9H19.84l-.693-9ZM14 13v2h-4v-2h4Zm-2-9a5 5 0 0 0-4.995 4.783L7 9h10a5 5 0 0 0-4.783-4.995L12 4Z"/>'
      }, props)
  }
  export function RiOthersKey2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.313 11.566 7.94-7.94 2.121 2.12-1.414 1.415 2.121 2.121-3.535 3.536-2.121-2.121-2.99 2.99a5.002 5.002 0 0 1-7.97 5.848 5 5 0 0 1 5.848-7.97Zm-.899 5.848a2 2 0 1 0-2.828-2.828 2 2 0 0 0 2.828 2.828Z"/>'
      }, props)
  }
  export function RiOthersKey2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.758 11.828 7.849-7.849 1.414 1.414-1.414 1.414 2.474 2.475-1.414 1.415-2.475-2.475-1.414 1.414 2.121 2.121-1.414 1.414-2.121-2.12-2.192 2.191a5.002 5.002 0 0 1-7.708 6.293 5 5 0 0 1 6.294-7.707Zm-.637 6.293A3 3 0 1 0 5.88 13.88a3 3 0 0 0 4.242 4.242Z"/>'
      }, props)
  }
  export function RiOthersKeyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 14h-4.341a6 6 0 1 1 0-4H23v4h-2v4h-4v-4ZM7 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiOthersKeyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.917 13A6.002 6.002 0 0 1 1 12a6 6 0 0 1 11.917-1H23v2h-2v4h-2v-4h-2v4h-2v-4h-2.083ZM7 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/>'
      }, props)
  }
  export function RiOthersKnifeBloodFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.343 1.408 22.374 19.44a1.5 1.5 0 1 1-2.121 2.122l-4.596-4.596L12.12 20.5l-4.12-4.12V19a1 1 0 1 1-2 0v-4a1 1 0 0 0-1.993-.117L4.001 15v1a1 1 0 1 1-2 0V7.214A7.976 7.976 0 0 1 4.17 1.587l.173-.179Z"/>'
      }, props)
  }
  export function RiOthersKnifeBloodLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.343 1.408 22.374 19.44a1.5 1.5 0 1 1-2.121 2.122l-4.596-4.596L12.12 20.5l-4.12-4.12V19a1 1 0 1 1-2 0v-4a1 1 0 0 0-1.993-.117L4.001 15v1a1 1 0 1 1-2 0V7.214A7.976 7.976 0 0 1 4.17 1.587l.173-.179Zm.241 3.07-.051.11a5.993 5.993 0 0 0-.522 2.103l-.01.31v.119a5.983 5.983 0 0 0 1.58 4.003l.176.185 6.364 6.364 2.828-2.829L4.584 4.478Z"/>'
      }, props)
  }
  export function RiOthersKnifeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22.374 19.44a1.5 1.5 0 1 1-2.121 2.12l-4.596-4.595L12.12 20.5l-7.778-7.778A8 8 0 0 1 4.17 1.587l.173-.179L22.374 19.44Z"/>'
      }, props)
  }
  export function RiOthersKnifeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.343 1.408 22.374 19.44a1.5 1.5 0 1 1-2.121 2.122l-4.596-4.596L12.12 20.5l-7.778-7.778A8 8 0 0 1 4.17 1.587l.173-.179Zm.241 3.07-.051.11a6.005 6.005 0 0 0 1.048 6.535l.176.185 6.364 6.364 2.828-2.829L4.584 4.478Z"/>'
      }, props)
  }
  export function RiOthersLeafFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.998 3v2c0 9.627-5.373 14-12 14H7.096c.212-3.012 1.15-4.835 3.598-7.001 1.204-1.065 1.102-1.68.509-1.327C7.119 13.102 5.09 16.386 5 21.63l-.003.37h-2c0-1.363.116-2.6.346-3.732-.23-1.294-.346-3.05-.346-5.268 0-5.523 4.477-10 10-10 2 0 4 1 8 0Z"/>'
      }, props)
  }
  export function RiOthersLeafLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.998 3v2c0 9.627-5.373 14-12 14H5.241a17.14 17.14 0 0 0-.243 3h-2c0-1.363.116-2.6.346-3.732-.23-1.294-.346-3.05-.346-5.268 0-5.523 4.477-10 10-10 2 0 4 1 8 0Zm-8 2a8 8 0 0 0-8 8c0 .362.003.711.01 1.046 1.254-1.978 3.091-3.541 5.494-4.914l.992 1.736C8.64 12.5 6.746 14.354 5.774 17h3.224c6.015 0 9.871-3.973 9.997-11.612-1.372.133-2.647.048-4.22-.188-1.15-.173-1.376-.2-1.777-.2Z"/>'
      }, props)
  }
  export function RiOthersLightbulbFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 18H7.941c-.297-1.273-1.637-2.314-2.187-3a8 8 0 1 1 12.49.002c-.55.685-1.888 1.726-2.185 2.998H13v-5h-2v5Zm5 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1h8Z"/>'
      }, props)
  }
  export function RiOthersLightbulbFlashFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.941 18c-.297-1.273-1.637-2.314-2.187-3a8 8 0 1 1 12.49.002c-.55.685-1.888 1.726-2.185 2.998H7.941ZM16 20v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1h8Zm-3-9.995V6l-4.5 6.005H11v4l4.5-6H13Z"/>'
      }, props)
  }
  export function RiOthersLightbulbFlashLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.973 18h4.054c.132-1.202.745-2.194 1.74-3.277.113-.122.832-.867.917-.973a6 6 0 1 0-9.37-.002c.086.107.807.853.918.974.996 1.084 1.609 2.076 1.741 3.278ZM14 20h-4v1h4v-1Zm-8.246-5a8 8 0 1 1 12.49.002C17.624 15.774 16 17 16 18.5V21a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2.5C8 17 6.375 15.774 5.754 15ZM13 10.004h2.5l-4.5 6v-4H8.5L13 6v4.005Z"/>'
      }, props)
  }
  export function RiOthersLightbulbLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.973 18H11v-5h2v5h1.027c.132-1.202.745-2.194 1.74-3.277.113-.122.832-.867.917-.973a6 6 0 1 0-9.37-.002c.086.107.807.853.918.974.996 1.084 1.609 2.076 1.741 3.278ZM10 20v1h4v-1h-4Zm-4.246-5a8 8 0 1 1 12.49.002C17.624 15.774 16 17 16 18.5V21a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2.5C8 17 6.375 15.774 5.754 15Z"/>'
      }, props)
  }
  export function RiOthersOutlet2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10ZM11 7v4h2V7h-2Zm3 5v4h2v-4h-2Zm-6 0v4h2v-4H8Z"/>'
      }, props)
  }
  export function RiOthersOutlet2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM11 7h2v4h-2V7Zm3 5h2v4h-2v-4Zm-6 0h2v4H8v-4Z"/>'
      }, props)
  }
  export function RiOthersOutletFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm2-12v4h2v-4h-2Zm-6 0v4h2v-4H8Z"/>'
      }, props)
  }
  export function RiOthersOutletLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm2-10h2v4h-2v-4Zm-6 0h2v4H8v-4Z"/>'
      }, props)
  }
  export function RiOthersPingPongFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.5 2a9.5 9.5 0 0 1 9.5 9.5c0 1.53-.361 2.974-1.003 4.254l2.463 2.464a1 1 0 0 1 0 1.414l-2.828 2.828a1 1 0 0 1-1.415 0l-2.463-2.463A9.462 9.462 0 0 1 11.5 21a9.5 9.5 0 0 1 0-19Zm5.303 13.388-1.414 1.414 3.536 3.535 1.414-1.414-3.536-3.535Zm1.864-6.105-9.384 9.384c.7.216 1.445.333 2.217.333a7.48 7.48 0 0 0 2.74-.516l-.972-.974a1 1 0 0 1 0-1.414l2.828-2.828a1 1 0 0 1 1.414 0l.974.972A7.48 7.48 0 0 0 19 11.5c0-.772-.117-1.516-.333-2.217Z"/>'
      }, props)
  }
  export function RiOthersPingPongLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.5 2a9.5 9.5 0 0 1 9.5 9.5c0 1.53-.361 2.974-1.003 4.254l2.463 2.464a1 1 0 0 1 0 1.414l-2.828 2.828a1 1 0 0 1-1.415 0l-2.463-2.463A9.462 9.462 0 0 1 11.5 21a9.5 9.5 0 0 1 0-19Zm5.303 13.388-1.414 1.414 3.536 3.535 1.414-1.414-3.536-3.535Zm1.864-6.105-9.384 9.384c.7.216 1.445.333 2.217.333a7.48 7.48 0 0 0 2.74-.516l-.972-.974a1 1 0 0 1 0-1.414l2.828-2.828a1 1 0 0 1 1.414 0l.974.972A7.48 7.48 0 0 0 19 11.5c0-.772-.117-1.516-.333-2.217ZM11.5 4a7.5 7.5 0 0 0-4.136 13.757L17.757 7.364A7.493 7.493 0 0 0 11.5 4Z"/>'
      }, props)
  }
  export function RiOthersPlantFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.998 3v2a7 7 0 0 1-7 7h-1v1h5v7a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-7h5v-3a7 7 0 0 1 7-7h3Zm-15.5-1a7.49 7.49 0 0 1 6.124 3.169A7.962 7.962 0 0 0 9.998 10v1h-.5a7.5 7.5 0 0 1-7.5-7.5V2h3.5Z"/>'
      }, props)
  }
  export function RiOthersPlantLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.998 2a6.999 6.999 0 0 1 6.197 3.741A6.491 6.491 0 0 1 17.498 3h3.5v2.5a6.5 6.5 0 0 1-6.5 6.5h-1.5v1h5v7a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-7h5v-2h-2a7 7 0 0 1-7-7V2h4Zm10 13h-8v5h8v-5Zm3-10h-1.5a4.5 4.5 0 0 0-4.5 4.5v.5h1.5a4.5 4.5 0 0 0 4.5-4.5V5Zm-13-1h-2a5 5 0 0 0 5 5h2a5 5 0 0 0-5-5Z"/>'
      }, props)
  }
  export function RiOthersPlug2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 18v2h6v2h-6a2 2 0 0 1-2-2v-2H8a4 4 0 0 1-4-4v-4h16v4a4 4 0 0 1-4 4h-3Zm4-12h2a1 1 0 0 1 1 1v2H4V7a1 1 0 0 1 1-1h2V2h2v4h6V2h2v4Zm-5 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM11 2h2v3h-2V2Z"/>'
      }, props)
  }
  export function RiOthersPlug2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 18v2h6v2h-6a2 2 0 0 1-2-2v-2H8a4 4 0 0 1-4-4V7a1 1 0 0 1 1-1h2V2h2v4h6V2h2v4h2a1 1 0 0 1 1 1v7a4 4 0 0 1-4 4h-3Zm-5-2h8a2 2 0 0 0 2-2v-3H6v3a2 2 0 0 0 2 2Zm10-8H6v1h12V8Zm-6 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM11 2h2v3h-2V2Z"/>'
      }, props)
  }
  export function RiOthersPlugFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 18v2h6v2h-6a2 2 0 0 1-2-2v-2H8a4 4 0 0 1-4-4v-4h16v4a4 4 0 0 1-4 4h-3Zm3-12h3a1 1 0 0 1 1 1v2H4V7a1 1 0 0 1 1-1h3V2h2v4h4V2h2v4Zm-4 8.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiOthersPlugLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 18v2h6v2h-6a2 2 0 0 1-2-2v-2H8a4 4 0 0 1-4-4V7a1 1 0 0 1 1-1h3V2h2v4h4V2h2v4h3a1 1 0 0 1 1 1v7a4 4 0 0 1-4 4h-3Zm-5-2h8a2 2 0 0 0 2-2v-3H6v3a2 2 0 0 0 2 2Zm10-8H6v1h12V8Zm-6 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/>'
      }, props)
  }
  export function RiOthersRecycleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19.561 12.098 1.532 2.652A3.5 3.5 0 0 1 18.06 20H16v2l-5-3.5 5-3.5v2h2.062a.5.5 0 0 0 .471-.668l-.038-.082-1.53-2.652 2.597-1.5ZM7.736 9.384l.531 6.08-1.731-1-1.032 1.786a.5.5 0 0 0 .343.742l.09.008H9v3H5.937a3.5 3.5 0 0 1-3.031-5.25l1.032-1.786-1.733-1 5.531-2.58ZM13.75 2.97A3.5 3.5 0 0 1 15.03 4.25l1.031 1.786 1.733-1-.532 6.08-5.53-2.58 1.73-1-1.03-1.786a.5.5 0 0 0-.814-.074l-.052.074-1.53 2.652-2.598-1.5 1.53-2.652A3.5 3.5 0 0 1 13.75 2.97Z"/>'
      }, props)
  }
  export function RiOthersRecycleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m19.56 12.098 1.532 2.652A3.5 3.5 0 0 1 18.061 20h-2.063v2.5l-5-3.5 5-3.5V18h2.063a1.5 1.5 0 0 0 1.299-2.25l-1.532-2.652 1.733-1ZM7.304 9.133l.53 6.08-2.165-1.25-1.03 1.786A1.5 1.5 0 0 0 5.937 18h3.062v2H5.937a3.5 3.5 0 0 1-3.032-5.25l1.031-1.787-2.165-1.249 5.532-2.58Zm6.446-6.165a3.5 3.5 0 0 1 1.28 1.281l1.032 1.786 2.165-1.25-.531 6.08-5.531-2.58 2.165-1.25-1.031-1.786a1.5 1.5 0 0 0-2.598 0L9.168 7.903l-1.732-1L8.968 4.25a3.5 3.5 0 0 1 4.78-1.281Z"/>'
      }, props)
  }
  export function RiOthersReservedFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 15v4h3v2H8v-2h3v-4H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-7ZM8 8v2h8V8H8Z"/>'
      }, props)
  }
  export function RiOthersReservedLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 15v4h3v2H8v-2h3v-4H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-7Zm-8-2h14V5H5v8Zm3-5h8v2H8V8Z"/>'
      }, props)
  }
  export function RiOthersScales2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.998 2c0 .513.49 1 1 1h10c.513 0 1-.49 1-1h2a3 3 0 0 1-3 3h-4l.001 2.062A8.001 8.001 0 0 1 19.998 15v6a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-6a8.001 8.001 0 0 1 7-7.938V5h-4c-1.66 0-3-1.34-3-3h2Zm6 9a4 4 0 1 0 3.446 1.968l-2.739 2.74-.094.082a1 1 0 0 1-1.32-1.497l2.739-2.74A3.981 3.981 0 0 0 11.998 11Z"/>'
      }, props)
  }
  export function RiOthersScales2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.998 2c0 .513.49 1 1 1h10c.513 0 1-.49 1-1h2a3 3 0 0 1-3 3h-4l.001 2.062A8.001 8.001 0 0 1 19.998 15v6a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-6a8.001 8.001 0 0 1 7-7.938V5h-4c-1.66 0-3-1.34-3-3h2Zm6 7c-3.238 0-6 2.76-6 6v5h12v-5c0-3.238-2.762-6-6-6Zm0 2c.742 0 1.437.202 2.032.554l-2.74 2.739a1 1 0 0 0 1.32 1.497l.095-.083 2.74-2.739A4 4 0 1 1 11.998 11Z"/>'
      }, props)
  }
  export function RiOthersScales3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.998 2v1.278l5 1.668 3.633-1.21.632 1.896-3.031 1.011 3.095 8.512A5.983 5.983 0 0 1 17.998 17a5.983 5.983 0 0 1-4.328-1.845l3.094-8.512-3.766-1.256V19h4v2h-10v-2h4V5.387L7.232 6.643l3.095 8.512A5.983 5.983 0 0 1 6 17a5.983 5.983 0 0 1-4.33-1.845l3.095-8.512-3.03-1.01.632-1.898L6 4.945l4.999-1.667V2h2Zm5 7.103L16.581 13h2.835l-1.418-3.897Zm-12 0L4.582 13h2.835L5.999 9.103Z"/>'
      }, props)
  }
  export function RiOthersScales3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.998 2v1.278l5 1.668 3.633-1.21.632 1.896-3.031 1.011 3.095 8.512A5.983 5.983 0 0 1 17.998 17a5.983 5.983 0 0 1-4.328-1.845l3.094-8.512-3.766-1.256V19h4v2h-10v-2h4V5.387L7.232 6.643l3.095 8.512A5.983 5.983 0 0 1 6 17a5.983 5.983 0 0 1-4.33-1.845l3.095-8.512-3.03-1.01.632-1.898L6 4.945l4.999-1.667V2h2Zm5 7.103-1.958 5.386c.588.331 1.258.511 1.959.511.7 0 1.37-.18 1.958-.51l-1.959-5.387Zm-12 0L4.04 14.489c.588.331 1.258.511 1.959.511.7 0 1.37-.18 1.958-.51L5.999 9.102Z"/>'
      }, props)
  }
  export function RiOthersScalesFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.998 2v1h7v2h-7v14h4v2h-10v-2h4V5h-7V3h7V2h2Zm-8 4.343 2.828 2.829a4 4 0 1 1-5.657 0L5 6.343Zm14 0 2.828 2.829a4 4 0 1 1-5.657 0l2.829-2.829Zm0 2.829-1.414 1.414A1.987 1.987 0 0 0 16.998 12l4 .001c0-.54-.212-1.041-.586-1.415l-1.414-1.414Zm-14 0-1.414 1.414A1.987 1.987 0 0 0 2.998 12l4 .001c0-.54-.212-1.041-.586-1.415L4.998 9.172Z"/>'
      }, props)
  }
  export function RiOthersScalesLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.998 2v1h7v2h-7v14h4v2h-10v-2h4V5h-7V3h7V2h2Zm-8 4.343 2.828 2.829a4 4 0 1 1-5.657 0L5 6.343Zm14 0 2.828 2.829a4 4 0 1 1-5.657 0l2.829-2.829Zm-14 2.829-1.414 1.414a2 2 0 1 0 2.828 0L4.998 9.172Zm14 0-1.414 1.414a2 2 0 1 0 2.828 0l-1.414-1.414Z"/>'
      }, props)
  }
  export function RiOthersSeedlingFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21.998 7v2.5a6.5 6.5 0 0 1-6.5 6.5h-2.5v5h-2v-7l.019-1a6.5 6.5 0 0 1 6.481-6h4.5Zm-16-4a7.003 7.003 0 0 1 6.643 4.786A7.48 7.48 0 0 0 10.014 13H8.998a7 7 0 0 1-7-7V3h4Z"/>'
      }, props)
  }
  export function RiOthersSeedlingLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.998 3a7.002 7.002 0 0 1 6.913 5.895A6.479 6.479 0 0 1 17.498 7h4.5v2.5a6.5 6.5 0 0 1-6.5 6.5h-2.5v5h-2v-8h-2a7 7 0 0 1-7-7V3h4Zm14 6h-2.5a4.5 4.5 0 0 0-4.5 4.5v.5h2.5a4.5 4.5 0 0 0 4.5-4.5V9Zm-14-4h-2v1a5 5 0 0 0 5 5h2v-1a5 5 0 0 0-5-5Z"/>'
      }, props)
  }
  export function RiOthersShirtFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.998 4v7l5-2.5 5 2.5V4h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3Zm5 4-4.5-5h9l-4.5 5Zm1 3.236-1-.5-1 .5V20h2v-8.764Zm2 2.764v2h4v-2h-4Z"/>'
      }, props)
  }
  export function RiOthersShirtLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.998 20h6v-4h-4v-2h4V6h-2v5l-4-1.6V20Zm-2 0V9.4l-4 1.6V6h-2v14h6Zm-4-16V3h10v1h3a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3Zm5 4 3.5-3h-7l3.5 3Z"/>'
      }, props)
  }
  export function RiOthersSwordFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m7.048 13.406 3.535 3.536-1.413 1.414 1.415 1.415-1.414 1.414-2.475-2.475-2.829 2.829-1.414-1.414 2.829-2.83-2.475-2.474 1.414-1.414 1.414 1.413 1.413-1.414ZM3 3l3.546.003 11.817 11.818 1.415-1.414 1.415 1.414-2.475 2.475 2.828 2.829-1.414 1.414-2.829-2.829-2.474 2.475-1.415-1.414 1.414-1.415L3.002 6.531 2.999 3Zm14.457 0L21 3.003l.002 3.523-4.053 4.052-3.536-3.535L17.456 3Z"/>'
      }, props)
  }
  export function RiOthersSwordLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.456 3 21 3.003l.002 3.523-5.467 5.466 2.828 2.829 1.415-1.414 1.415 1.414-2.475 2.475 2.828 2.829-1.414 1.414-2.829-2.829-2.474 2.475-1.415-1.414 1.414-1.415-2.829-2.828-2.828 2.828 1.415 1.415-1.414 1.414-2.475-2.475-2.829 2.829-1.414-1.414 2.829-2.83-2.475-2.474 1.414-1.414 1.414 1.413 2.827-2.828-5.46-5.46L2.999 3l3.546.003 5.453 5.454L17.456 3Zm-7.58 10.406-2.828 2.828.708.707 2.827-2.828-.707-.707ZM19 5.001h-.717l-4.87 4.869.706.707L19 5.698v-.697Zm-14 0v.7l11.241 11.241.707-.707L5.715 5.002 5 5.001Z"/>'
      }, props)
  }
  export function RiOthersTShirt2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.998 3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-2.001l.001 8a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1l-.001-8.001L2.998 12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a3 3 0 1 0 6 0h6Z"/>'
      }, props)
  }
  export function RiOthersTShirt2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.998 3a3 3 0 1 0 6 0h6a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-2.001l.001 8a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1l-.001-8.001L2.998 12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm11 1.999h-3.417l-.017.041a5.002 5.002 0 0 1-4.35 2.955L11.999 8a5.001 5.001 0 0 1-4.566-2.96L7.414 5H3.998v5l2.999-.001V19h10.001l-.001-9 3.001-.001v-5Z"/>'
      }, props)
  }
  export function RiOthersTShirtAirFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.705 17.793c.827.827 1.588 1.207 2.293 1.207.378 0 .68-.067 1.237-.276l.392-.152c1.05-.421 1.58-.572 2.371-.572 1.214 0 2.379.545 3.486 1.58l.221.213-1.414 1.414C20.464 20.38 19.703 20 18.998 20c-.378 0-.68.067-1.237.276l-.392.152c-1.05.421-1.58.572-2.371.572-1.214 0-2.379-.545-3.486-1.58l-.221-.213 1.414-1.414ZM8.998 3a3 3 0 1 0 6 0h6a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-9a2 2 0 0 0-1.994 1.85l-.006.15v7h-4a1 1 0 0 1-1-1l-.001-8.001L2.998 12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm3.707 10.793c.827.827 1.588 1.207 2.293 1.207.378 0 .68-.067 1.237-.276l.392-.152c1.05-.421 1.58-.572 2.371-.572 1.214 0 2.379.545 3.486 1.58l.221.213-1.414 1.414C20.464 16.38 19.703 16 18.998 16c-.378 0-.68.067-1.237.276l-.392.152c-1.05.421-1.58.572-2.371.572-1.214 0-2.379-.545-3.486-1.58l-.221-.213 1.414-1.414Z"/>'
      }, props)
  }
  export function RiOthersTShirtAirLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.705 17.793c.827.827 1.588 1.207 2.293 1.207.378 0 .68-.067 1.237-.276l.392-.152c1.05-.421 1.58-.572 2.371-.572 1.214 0 2.379.545 3.486 1.58l.221.213-1.414 1.414C20.464 20.38 19.703 20 18.998 20c-.378 0-.68.067-1.237.276l-.392.152c-1.05.421-1.58.572-2.371.572-1.214 0-2.379-.545-3.486-1.58l-.221-.213 1.414-1.414ZM8.998 3a3 3 0 1 0 6 0h6a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-4.002v-2l3.002-.001v-5h-3.417l-.017.041a5.002 5.002 0 0 1-4.35 2.955L11.999 8a5.001 5.001 0 0 1-4.566-2.96L7.414 5H3.998v5l2.999-.001V19h3.001v2h-4a1 1 0 0 1-1-1l-.001-8.001L2.998 12a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm3.707 10.793c.827.827 1.588 1.207 2.293 1.207.378 0 .68-.067 1.237-.276l.392-.152c1.05-.421 1.58-.572 2.371-.572 1.214 0 2.379.545 3.486 1.58l.221.213-1.414 1.414C20.464 16.38 19.703 16 18.998 16c-.378 0-.68.067-1.237.276l-.392.152c-1.05.421-1.58.572-2.371.572-1.214 0-2.379-.545-3.486-1.58l-.221-.213 1.414-1.414Z"/>'
      }, props)
  }
  export function RiOthersTShirtFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14.514 5 2.606-2.607a1 1 0 0 1 1.414 0l4.243 4.243a1 1 0 0 1 0 1.414l-3.778 3.778V21a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1V11.83L1.22 8.05a1 1 0 0 1 0-1.414l4.242-4.243a1 1 0 0 1 1.414 0L9.484 5h5.03Z"/>'
      }, props)
  }
  export function RiOthersTShirtLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14.514 5 2.606-2.607a1 1 0 0 1 1.414 0l4.243 4.243a1 1 0 0 1 0 1.414l-3.778 3.778V21a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1V11.83L1.22 8.05a1 1 0 0 1 0-1.414l4.242-4.243a1 1 0 0 1 1.414 0L9.484 5h5.03Zm.828 2H8.656L6.17 4.515 3.342 7.343 6.999 11v9h10v-9l3.657-3.657-2.829-2.828L15.342 7Z"/>'
      }, props)
  }
  export function RiOthersUmbrellaFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.998 2.05c5.053.501 9 4.765 9 9.95v1h-9v6a2 2 0 0 0 4 0v-1h2v1a4 4 0 1 1-8 0v-6h-9v-1c0-5.185 3.947-9.449 9-9.95V2a1 1 0 0 1 2 0v.05Z"/>'
      }, props)
  }
  export function RiOthersUmbrellaLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.998 2.05c5.053.501 9 4.765 9 9.95v1h-9v6a2 2 0 0 0 4 0v-1h2v1a4 4 0 1 1-8 0v-6h-9v-1c0-5.185 3.947-9.449 9-9.95V2a1 1 0 0 1 2 0v.05ZM19.936 11A8.001 8.001 0 0 0 4.06 11h15.876Z"/>'
      }, props)
  }
  export function RiOthersVoiceRecognitionFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20.998 3v18h-18V3h18Zm-8 3h-2v12h2V6Zm-4 3h-2v6h2V9Zm8 0h-2v6h2V9Z"/>'
      }, props)
  }
  export function RiOthersVoiceRecognitionLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.998 15v4h4v2h-6v-6h2Zm16 0v6h-6v-2h4v-4h2Zm-8-9v12h-2V6h2Zm-4 3v6h-2V9h2Zm8 0v6h-2V9h2Zm-8-6v2h-4v4h-2V3h6Zm12 0v6h-2V5h-4V3h6Z"/>'
      }, props)
  }
  export function RiOthersWheelchairFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.998 10.341v2.194A4 4 0 1 0 13.463 18h2.193a6 6 0 1 1-7.658-7.66Zm4 6.659a3 3 0 0 1-3-3v-4a3 3 0 1 1 6 0v5h1.434a2 2 0 0 1 1.626.836l.089.135 2.709 4.514-1.715 1.03L16.43 17h-4.433Zm0-15a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z"/>'
      }, props)
  }
  export function RiOthersWheelchairLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.998 10.341v2.194A4 4 0 1 0 13.463 18h2.193a6 6 0 1 1-7.658-7.66Zm4 6.659a3 3 0 0 1-3-3v-4c0-1.044.534-1.964 1.343-2.501a3 3 0 1 1 3.314.003A2.988 2.988 0 0 1 14.998 10v4.999l1.434.001a2 2 0 0 1 1.626.836l.089.135 2.709 4.514-1.715 1.03L16.43 17l-1.433-.001-3 .001Zm0-8a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h.999l.001-5a1 1 0 0 0-1-1Zm0-5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiSystemAddBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm7 8H7v2h4v4h2v-4h4v-2h-4V7h-2v4Z"/>'
      }, props)
  }
  export function RiSystemAddBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h14V5H5Zm6 6V7h2v4h4v2h-4v4h-2v-4H7v-2h4Z"/>'
      }, props)
  }
  export function RiSystemAddCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-1-11H7v2h4v4h2v-4h4v-2h-4V7h-2v4Z"/>'
      }, props)
  }
  export function RiSystemAddCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4Zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"/>'
      }, props)
  }
  export function RiSystemAddFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2h6Z"/>'
      }, props)
  }
  export function RiSystemAddLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2h6Z"/>'
      }, props)
  }
  export function RiSystemAlarmFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22a9 9 0 1 1 0-18 9 9 0 0 1 0 18Zm1-9V8h-2v7h5v-2h-3ZM1.745 6.283l3.536-3.536 1.414 1.414L3.16 7.697 1.746 6.283Zm16.97-3.536 3.536 3.536-1.414 1.414-3.536-3.536 1.415-1.414Z"/>'
      }, props)
  }
  export function RiSystemAlarmLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22a9 9 0 1 1 0-18 9 9 0 0 1 0 18Zm0-2a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm1-7h3v2h-5V8h2v5ZM1.745 6.283l3.536-3.536 1.414 1.414L3.16 7.697 1.746 6.283Zm16.97-3.536 3.536 3.536-1.414 1.414-3.536-3.536 1.415-1.414Z"/>'
      }, props)
  }
  export function RiSystemAlarmWarningFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.001 20v-6a8 8 0 0 1 16 0v6h1v2h-18v-2h1Zm2-6h2a4 4 0 0 1 4-4V8a6 6 0 0 0-6 6Zm5-12h2v3h-2V2Zm8.778 2.808 1.414 1.414-2.12 2.121-1.415-1.414 2.121-2.121ZM2.81 6.222l1.414-1.414 2.121 2.12L4.93 8.344 2.809 6.222Z"/>'
      }, props)
  }
  export function RiSystemAlarmWarningLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.001 20v-6a8 8 0 0 1 16 0v6h1v2h-18v-2h1Zm2 0h12v-6a6 6 0 0 0-12 0v6Zm5-18h2v3h-2V2Zm8.778 2.808 1.414 1.414-2.12 2.121-1.415-1.414 2.121-2.121ZM2.81 6.222l1.414-1.414 2.121 2.12L4.93 8.344 2.809 6.222ZM7 14a5 5 0 0 1 5-5v2a3 3 0 0 0-3 3h-2Z"/>'
      }, props)
  }
  export function RiSystemAlertFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.865 3 9.526 16.5a1 1 0 0 1-.866 1.5H2.473a1 1 0 0 1-.866-1.5L11.133 3a1 1 0 0 1 1.732 0Zm-1.866 13v2h2v-2h-2Zm0-7v5h2V9h-2Z"/>'
      }, props)
  }
  export function RiSystemAlertLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12.865 3 9.526 16.5a1 1 0 0 1-.866 1.5H2.473a1 1 0 0 1-.866-1.5L11.133 3a1 1 0 0 1 1.732 0Zm-8.66 16h15.588L12 5.5 4.205 19Zm6.794-3h2v2h-2v-2Zm0-7h2v5h-2V9Z"/>'
      }, props)
  }
  export function RiSystemApps2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 11.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0 10a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm10-10a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0 10a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z"/>'
      }, props)
  }
  export function RiSystemApps2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.5 11.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0 10a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm10-10a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0 10a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm-10-12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm10-10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>'
      }, props)
  }
  export function RiSystemAppsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.75 2.5A4.25 4.25 0 0 1 11 6.75V11H6.75a4.25 4.25 0 0 1 0-8.5Zm0 10.5H11v4.25A4.25 4.25 0 1 1 6.75 13Zm10.5-10.5a4.25 4.25 0 0 1 0 8.5H13V6.75a4.25 4.25 0 0 1 4.25-4.25ZM13 13h4.25A4.25 4.25 0 1 1 13 17.25V13Z"/>'
      }, props)
  }
  export function RiSystemAppsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.75 2.5A4.25 4.25 0 0 1 11 6.75V11H6.75a4.25 4.25 0 0 1 0-8.5ZM9 9V6.75A2.25 2.25 0 1 0 6.75 9H9Zm-2.25 4H11v4.25A4.25 4.25 0 1 1 6.75 13Zm0 2A2.25 2.25 0 1 0 9 17.25V15H6.75Zm10.5-12.5a4.25 4.25 0 0 1 0 8.5H13V6.75a4.25 4.25 0 0 1 4.25-4.25Zm0 6.5A2.25 2.25 0 1 0 15 6.75V9h2.25ZM13 13h4.25A4.25 4.25 0 1 1 13 17.25V13Zm2 2v2.25A2.25 2.25 0 1 0 17.25 15H15Z"/>'
      }, props)
  }
  export function RiSystemCheckDoubleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.602 13.76 1.412 1.412 8.466-8.466 1.414 1.415-9.88 9.88-6.364-6.365 1.414-1.414 2.125 2.125 1.413 1.412Zm.002-2.828 4.952-4.953 1.41 1.41-4.952 4.953-1.41-1.41Zm-2.827 5.655L7.364 18 1 11.636l1.414-1.414 1.413 1.413-.001.001 4.951 4.951Z"/>'
      }, props)
  }
  export function RiSystemCheckDoubleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.602 13.76 1.412 1.412 8.466-8.466 1.414 1.415-9.88 9.88-6.364-6.365 1.414-1.414 2.125 2.125 1.413 1.412Zm.002-2.828 4.952-4.953 1.41 1.41-4.952 4.953-1.41-1.41Zm-2.827 5.655L7.364 18 1 11.636l1.414-1.414 1.413 1.413-.001.001 4.951 4.951Z"/>'
      }, props)
  }
  export function RiSystemCheckFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10 15.17 9.193-9.191 1.414 1.414-10.606 10.606-6.364-6.364 1.414-1.414 4.95 4.95Z"/>'
      }, props)
  }
  export function RiSystemCheckLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10 15.17 9.193-9.191 1.414 1.414-10.606 10.606-6.364-6.364 1.414-1.414 4.95 4.95Z"/>'
      }, props)
  }
  export function RiSystemCheckboxBlankCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"/>'
      }, props)
  }
  export function RiSystemCheckboxBlankCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"/>'
      }, props)
  }
  export function RiSystemCheckboxBlankFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z"/>'
      }, props)
  }
  export function RiSystemCheckboxBlankLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h14V5H5Z"/>'
      }, props)
  }
  export function RiSystemCheckboxCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-.997-6 7.07-7.071-1.413-1.414-5.657 5.657-2.829-2.829-1.414 1.414L11.003 16Z"/>'
      }, props)
  }
  export function RiSystemCheckboxCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-.997-4L6.76 11.757l1.414-1.414 2.829 2.829 5.657-5.657 1.414 1.414L11.003 16Z"/>'
      }, props)
  }
  export function RiSystemCheckboxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm7.003 13 7.07-7.071-1.413-1.414-5.657 5.657-2.829-2.829-1.414 1.414L11.003 16Z"/>'
      }, props)
  }
  export function RiSystemCheckboxIndeterminateFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm3 8v2h10v-2H7Z"/>'
      }, props)
  }
  export function RiSystemCheckboxIndeterminateLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h14V5H5Zm2 6h10v2H7v-2Z"/>'
      }, props)
  }
  export function RiSystemCheckboxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm1 2v14h14V5H5Zm6.003 11L6.76 11.757l1.414-1.414 2.829 2.829 5.657-5.657 1.414 1.414L11.003 16Z"/>'
      }, props)
  }
  export function RiSystemCheckboxMultipleBlankFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.992C17 21.55 16.551 22 15.992 22H3.008A1.006 1.006 0 0 1 2 20.992l.003-12.985C2.003 7.451 2.452 7 3.01 7H7Zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3Z"/>'
      }, props)
  }
  export function RiSystemCheckboxMultipleBlankLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.992C17 21.55 16.551 22 15.992 22H3.008A1.006 1.006 0 0 1 2 20.992l.003-12.985C2.003 7.451 2.452 7 3.01 7H7Zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3ZM4.003 9 4 20h11V9H4.003Z"/>'
      }, props)
  }
  export function RiSystemCheckboxMultipleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.992C17 21.55 16.551 22 15.992 22H3.008A1.006 1.006 0 0 1 2 20.992l.003-12.985C2.003 7.451 2.452 7 3.01 7H7Zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3Zm-.498 11 5.657-5.657-1.414-1.414-4.243 4.243-2.12-2.122-1.415 1.414L8.502 18Z"/>'
      }, props)
  }
  export function RiSystemCheckboxMultipleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 7V3a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-4v3.992C17 21.55 16.551 22 15.992 22H3.008A1.006 1.006 0 0 1 2 20.992l.003-12.985C2.003 7.451 2.452 7 3.01 7H7Zm2 0h6.993C16.549 7 17 7.449 17 8.007V15h3V4H9v3Zm6 2H4.003L4 20h11V9Zm-6.498 9-3.535-3.536L6.38 13.05l2.121 2.122 4.243-4.243 1.414 1.414L8.502 18Z"/>'
      }, props)
  }
  export function RiSystemCloseCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586Z"/>'
      }, props)
  }
  export function RiSystemCloseCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-9.414 2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586Z"/>'
      }, props)
  }
  export function RiSystemCloseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 10.586 4.95-4.95 1.415 1.415-4.95 4.95 4.95 4.95-1.415 1.414-4.95-4.95-4.95 4.95-1.413-1.415 4.95-4.95-4.95-4.95L7.05 5.638l4.95 4.95Z"/>'
      }, props)
  }
  export function RiSystemCloseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 10.586 4.95-4.95 1.415 1.415-4.95 4.95 4.95 4.95-1.415 1.414-4.95-4.95-4.95 4.95-1.413-1.415 4.95-4.95-4.95-4.95L7.05 5.638l4.95 4.95Z"/>'
      }, props)
  }
  export function RiSystemDashboardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 13h8V3H3v10Zm0 8h8v-6H3v6Zm10 0h8V11h-8v10Zm0-18v6h8V3h-8Z"/>'
      }, props)
  }
  export function RiSystemDashboardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 21V11h8v10h-8ZM3 13V3h8v10H3Zm6-2V5H5v6h4ZM3 21v-6h8v6H3Zm2-2h4v-2H5v2Zm10 0h4v-6h-4v6ZM13 3h8v6h-8V3Zm2 2v2h4V5h-4Z"/>'
      }, props)
  }
  export function RiSystemDeleteBack2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.535 3h14.464a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6.535a1 1 0 0 1-.833-.445l-5.333-8a1 1 0 0 1 0-1.11l5.333-8A1 1 0 0 1 6.535 3Zm6.464 7.586-2.828-2.829-1.414 1.415L11.585 12l-2.828 2.828 1.414 1.415 2.828-2.829 2.829 2.829 1.414-1.415L14.413 12l2.829-2.828-1.414-1.415-2.829 2.829Z"/>'
      }, props)
  }
  export function RiSystemDeleteBack2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.535 3h14.464a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6.535a1 1 0 0 1-.833-.445l-5.333-8a1 1 0 0 1 0-1.11l5.333-8A1 1 0 0 1 6.535 3Zm.535 2-4.667 7 4.667 7H20V5H7.07ZM13 10.586l2.828-2.829 1.414 1.415L14.413 12l2.829 2.828-1.414 1.415-2.829-2.829-2.828 2.829-1.414-1.415L11.585 12 8.757 9.172l1.414-1.415 2.828 2.829Z"/>'
      }, props)
  }
  export function RiSystemDeleteBackFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.535 3h14.464a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6.535a1 1 0 0 1-.833-.445l-5.333-8a1 1 0 0 1 0-1.11l5.333-8A1 1 0 0 1 6.535 3Zm9.464 8H9v2h7v-2Z"/>'
      }, props)
  }
  export function RiSystemDeleteBackLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.535 3h14.464a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6.535a1 1 0 0 1-.833-.445l-5.333-8a1 1 0 0 1 0-1.11l5.333-8A1 1 0 0 1 6.535 3Zm.535 2-4.667 7 4.667 7H20V5H7.07ZM16 11v2H9v-2h7Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5Zm6.414 8 1.768-1.768-1.414-1.414L12 12.586l-1.768-1.768-1.414 1.414L10.586 14l-1.768 1.768 1.414 1.414L12 15.414l1.768 1.768 1.414-1.414L13.414 14ZM9 4v2h6V4H9Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3Zm1 2H6v12h12V8Zm-4.586 6 1.768 1.768-1.414 1.414L12 15.414l-1.768 1.768-1.414-1.414L10.586 14l-1.768-1.768 1.414-1.414L12 12.586l1.768-1.768 1.414 1.414L13.414 14ZM9 4v2h6V4H9Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 7v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7H2V5h20v2h-2Zm-9 2v2h2V9h-2Zm0 3v2h2v-2h-2Zm0 3v2h2v-2h-2ZM7 2h10v2H7V2Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 7v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7H2V5h20v2h-2ZM6 7v13h12V7H6Zm5 2h2v2h-2V9Zm0 3h2v2h-2v-2Zm0 3h2v2h-2v-2ZM7 2h10v2H7V2Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 7v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7H2V5h20v2h-2Zm-9 3v7h2v-7h-2ZM7 2h10v2H7V2Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 7v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7H2V5h20v2h-2ZM6 7v13h12V7H6Zm1-5h10v2H7V2Zm4 8h2v7h-2v-7Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 8h16v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8Zm3-3V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2h5v2H2V5h5Zm2-1v1h6V4H9Zm0 8v6h2v-6H9Zm4 0v6h2v-6h-2Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 8h16v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8Zm2 2v10h12V10H6Zm3 2h2v6H9v-6Zm4 0h2v6h-2v-6ZM7 5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2h5v2H2V5h5Zm2-1v1h6V4H9Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin6Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 4h5v2h-2v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6H2V4h5V2h10v2ZM9 9v8h2V9H9Zm4 0v8h2V9h-2Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin6Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 4V2h10v2h5v2h-2v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6H2V4h5ZM6 6v14h12V6H6Zm3 3h2v8H9V9Zm4 0h2v8h-2V9Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin7Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 6V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5Zm2-2v2h6V4H9Z"/>'
      }, props)
  }
  export function RiSystemDeleteBin7Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3Zm1 2H6v12h12V8ZM9 4v2h6V4H9Z"/>'
      }, props)
  }
  export function RiSystemDeleteBinFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3Zm-8 5v6h2v-6H9Zm4 0v6h2v-6h-2ZM9 4v2h6V4H9Z"/>'
      }, props)
  }
  export function RiSystemDeleteBinLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3Zm1 2H6v12h12V8Zm-9 3h2v6H9v-6Zm4 0h2v6h-2v-6ZM9 4v2h6V4H9Z"/>'
      }, props)
  }
  export function RiSystemDivideFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 11h14v2H5v-2Zm7-3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiSystemDivideLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 11h14v2H5v-2Zm7-3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 11a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiSystemDownload2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 19h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7ZM14 9h5l-7 7-7-7h5V3h4v6Z"/>'
      }, props)
  }
  export function RiSystemDownload2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 10h5l-6 6-6-6h5V3h2v7Zm-9 9h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7Z"/>'
      }, props)
  }
  export function RiSystemDownloadCloud2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 13v5.585l1.828-1.828 1.415 1.415L12 22.414l-4.243-4.242 1.415-1.415L11 18.585V13h2ZM12 2a7.001 7.001 0 0 1 6.954 6.194A5.5 5.5 0 0 1 18 18.978V17a6 6 0 0 0-11.996-.225L6 17v1.978a5.5 5.5 0 0 1-.954-10.784A7 7 0 0 1 12 2Z"/>'
      }, props)
  }
  export function RiSystemDownloadCloud2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 13v5.585l1.828-1.828 1.415 1.415L12 22.414l-4.243-4.242 1.415-1.415L11 18.585V13h2ZM12 2a7.001 7.001 0 0 1 6.954 6.194A5.5 5.5 0 0 1 18 18.978v-2.014a3.5 3.5 0 1 0-1.111-6.91 5 5 0 1 0-9.777 0 3.5 3.5 0 0 0-1.292 6.88l.18.03v2.014a5.5 5.5 0 0 1-.954-10.784A7 7 0 0 1 12 2Z"/>'
      }, props)
  }
  export function RiSystemDownloadCloudFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 20.981a6.5 6.5 0 0 1-2.936-12 8.001 8.001 0 0 1 15.872 0 6.5 6.5 0 0 1-2.936 12V21H7v-.019ZM13 12V8h-2v4H8l4 5 4-5h-3Z"/>'
      }, props)
  }
  export function RiSystemDownloadCloudLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1 14.5a6.496 6.496 0 0 1 3.064-5.519 8.001 8.001 0 0 1 15.872 0 6.5 6.5 0 0 1-2.936 12L7 21c-3.356-.274-6-3.078-6-6.5Zm15.848 4.487a4.5 4.5 0 0 0 2.03-8.309l-.807-.503-.12-.942a6.001 6.001 0 0 0-11.903 0l-.12.942-.805.503a4.5 4.5 0 0 0 2.029 8.309l.173.013h9.35l.173-.013ZM13 12h3l-4 5-4-5h3V8h2v4Z"/>'
      }, props)
  }
  export function RiSystemDownloadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 19h18v2H3v-2ZM13 9h7l-8 8-8-8h7V1h2v8Z"/>'
      }, props)
  }
  export function RiSystemDownloadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 19h18v2H3v-2Zm10-5.828L19.071 7.1l1.414 1.415L12 17 3.515 8.515 4.929 7.1 11 13.172V2h2v11.172Z"/>'
      }, props)
  }
  export function RiSystemEqualFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 8H5v2h14V8Zm0 6H5v2h14v-2Z"/>'
      }, props)
  }
  export function RiSystemEqualLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 8H5v2h14V8Zm0 6H5v2h14v-2Z"/>'
      }, props)
  }
  export function RiSystemErrorWarningFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-1-7v2h2v-2h-2Zm0-8v6h2V7h-2Z"/>'
      }, props)
  }
  export function RiSystemErrorWarningLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1-5h2v2h-2v-2Zm0-8h2v6h-2V7Z"/>'
      }, props)
  }
  export function RiSystemExternalLinkFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6Zm11-3v9l-3.794-3.793-5.999 6-1.414-1.414 5.999-6L12 3h9Z"/>'
      }, props)
  }
  export function RiSystemExternalLinkLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6Zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L17.585 5H13V3h8Z"/>'
      }, props)
  }
  export function RiSystemEye2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 5c-.513 0-1.008.077-1.473.22a2.5 2.5 0 1 1-3.306 3.307A5 5 0 1 0 12 7Z"/>'
      }, props)
  }
  export function RiSystemEye2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 3a5 5 0 1 1-4.78 3.527A2.499 2.499 0 0 0 12 9.5a2.5 2.5 0 0 0-1.473-2.28c.466-.143.96-.22 1.473-.22Z"/>'
      }, props)
  }
  export function RiSystemEyeCloseFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m10.13 15.842-.787 2.94-1.932-.517.787-2.94a10.988 10.988 0 0 1-3.237-1.871l-2.153 2.153-1.414-1.414 2.153-2.154a10.957 10.957 0 0 1-2.371-5.07l.9-.164A16.923 16.923 0 0 0 12 10c3.704 0 7.132-1.184 9.924-3.195l.9.163a10.958 10.958 0 0 1-2.37 5.071l2.153 2.154-1.414 1.414-2.154-2.153a10.989 10.989 0 0 1-3.237 1.872l.788 2.939-1.932.517-.788-2.94a11.078 11.078 0 0 1-3.74 0Z"/>'
      }, props)
  }
  export function RiSystemEyeCloseLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m9.343 18.782-1.932-.518.787-2.939a10.99 10.99 0 0 1-3.237-1.872l-2.153 2.154-1.414-1.414 2.153-2.154a10.957 10.957 0 0 1-2.371-5.07l1.968-.359C3.903 10.813 7.579 14 12 14s8.098-3.187 8.857-7.39l1.968.358a10.958 10.958 0 0 1-2.372 5.071l2.154 2.154-1.414 1.414-2.154-2.154a10.991 10.991 0 0 1-3.237 1.872l.788 2.94-1.932.517-.788-2.94a11.068 11.068 0 0 1-3.74 0l-.787 2.94Z"/>'
      }, props)
  }
  export function RiSystemEyeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1.182 12C2.122 6.88 6.608 3 12 3c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9-5.392 0-9.878-3.88-10.818-9ZM12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiSystemEyeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9-5.392 0-9.878-3.88-10.818-9C2.122 6.88 6.608 3 12 3Zm0 16a9.005 9.005 0 0 0 8.778-7 9.005 9.005 0 0 0-17.555 0A9.005 9.005 0 0 0 12 19Zm0-2.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>'
      }, props)
  }
  export function RiSystemEyeOffFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.52 5.935 1.394 2.808l1.414-1.414 19.799 19.798-1.414 1.415-3.31-3.31A10.949 10.949 0 0 1 12 21c-5.392 0-9.878-3.88-10.818-9A10.982 10.982 0 0 1 4.52 5.935Zm10.238 10.237-1.464-1.464a3 3 0 0 1-4.001-4.001L7.829 9.243a5 5 0 0 0 6.929 6.929ZM7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 0 1-2.012 4.593l-3.86-3.86a5 5 0 0 0-5.68-5.68L7.975 3.76Z"/>'
      }, props)
  }
  export function RiSystemEyeOffLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.883 19.297A10.949 10.949 0 0 1 12 21c-5.392 0-9.878-3.88-10.818-9A10.982 10.982 0 0 1 4.52 5.935L1.394 2.808l1.414-1.414 19.799 19.798-1.414 1.415-3.31-3.31ZM5.936 7.35A8.965 8.965 0 0 0 3.223 12a9.005 9.005 0 0 0 13.201 5.838l-2.028-2.028A4.5 4.5 0 0 1 8.19 9.604L5.936 7.35Zm6.978 6.978-3.242-3.241a2.5 2.5 0 0 0 3.241 3.241Zm7.893 2.265-1.431-1.431A8.935 8.935 0 0 0 20.778 12 9.005 9.005 0 0 0 9.552 5.338L7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 0 1-2.012 4.593Zm-9.084-9.084a4.5 4.5 0 0 1 4.769 4.769l-4.77-4.77Z"/>'
      }, props)
  }
  export function RiSystemFilter2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 14 4 5V3h16v2l-6 9v6l-4 2v-8Z"/>'
      }, props)
  }
  export function RiSystemFilter2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14v6l-4 2v-8L4 5V3h16v2l-6 9ZM6.404 5 12 13.394 17.596 5H6.404Z"/>'
      }, props)
  }
  export function RiSystemFilter3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 18h4v-2h-4v2ZM3 6v2h18V6H3Zm3 7h12v-2H6v2Z"/>'
      }, props)
  }
  export function RiSystemFilter3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 18h4v-2h-4v2ZM3 6v2h18V6H3Zm3 7h12v-2H6v2Z"/>'
      }, props)
  }
  export function RiSystemFilterFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 4v2h-1l-6 9v7h-4v-7L4 6H3V4h18Z"/>'
      }, props)
  }
  export function RiSystemFilterLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 4v2h-1l-5 7.5V22H9v-8.5L4 6H3V4h18ZM6.404 6 11 12.894V20h2v-7.106L17.596 6H6.404Z"/>'
      }, props)
  }
  export function RiSystemFilterOffFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.929.515 21.07 14.657l-1.414 1.414-3.823-3.822L14 14.999v7h-4v-7L4 6H3V4h4.585l-2.07-2.07L6.929.515ZM21 4v2h-1l-1.915 2.872L13.213 4H21Z"/>'
      }, props)
  }
  export function RiSystemFilterOffLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.929.515 21.07 14.657l-1.414 1.414-3.823-3.822-.834 1.25V22H9v-8.5L4 6H3V4h4.585l-2.07-2.07L6.929.515ZM9.585 6H6.404L11 12.894V20h2v-7.106l1.392-2.087L9.585 6ZM21 4v2h-1l-1.915 2.872-1.442-1.443.953-1.43h-2.383l-2-2H21Z"/>'
      }, props)
  }
  export function RiSystemFindReplaceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.031 16.617 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617ZM16.659 9A6 6 0 0 0 11 5c-3.315 0-6 2.685-6 6h2a4.001 4.001 0 0 1 5.91-3.515L12 9h4.659ZM17 11h-2a4.001 4.001 0 0 1-5.91 3.515L10 13H5.341A6 6 0 0 0 11 17c3.315 0 6-2.685 6-6Z"/>'
      }, props)
  }
  export function RiSystemFindReplaceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.033 16.618 4.28 4.282-1.413 1.414-4.282-4.281A8.963 8.963 0 0 1 11 20a8.998 8.998 0 0 1-8.065-5H9l-1.304 2.173A6.972 6.972 0 0 0 11 18a6.977 6.977 0 0 0 4.875-1.975l.15-.15A6.977 6.977 0 0 0 18 11c0-.695-.101-1.366-.29-2h2.067c.146.643.223 1.313.223 2a8.963 8.963 0 0 1-1.967 5.618ZM19.065 7H13l1.304-2.173A6.972 6.972 0 0 0 11 4c-3.867 0-7 3.133-7 7 0 .695.101 1.366.29 2H2.223A9.038 9.038 0 0 1 2 11c0-4.973 4.027-9 9-9a8.997 8.997 0 0 1 8.065 5Z"/>'
      }, props)
  }
  export function RiSystemForbid2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm4.891-13.477a6.036 6.036 0 0 0-1.414-1.414l-8.368 8.368a6.041 6.041 0 0 0 1.414 1.414l8.368-8.368Z"/>'
      }, props)
  }
  export function RiSystemForbid2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm4.891-11.477-8.368 8.368a6.036 6.036 0 0 1-1.414-1.414l8.368-8.368a6.041 6.041 0 0 1 1.414 1.414Z"/>'
      }, props)
  }
  export function RiSystemForbidFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10ZM8.523 7.109A6.04 6.04 0 0 0 7.11 8.523l8.368 8.368a6.037 6.037 0 0 0 1.414-1.414L8.523 7.109Z"/>'
      }, props)
  }
  export function RiSystemForbidLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.523 7.109l8.368 8.368a6.037 6.037 0 0 1-1.414 1.414L7.109 8.523A6.04 6.04 0 0 1 8.523 7.11Z"/>'
      }, props)
  }
  export function RiSystemFunctionFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h8v8H3V3Zm0 10h8v8H3v-8ZM13 3h8v8h-8V3Zm0 10h8v8h-8v-8Z"/>'
      }, props)
  }
  export function RiSystemFunctionLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h8v8H3V3Zm0 10h8v8H3v-8ZM13 3h8v8h-8V3Zm0 10h8v8h-8v-8Zm2-8v4h4V5h-4Zm0 10v4h4v-4h-4ZM5 5v4h4V5H5Zm0 10v4h4v-4H5Z"/>'
      }, props)
  }
  export function RiSystemHistoryFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.865-5.135L8 9H2V3l2.447 2.446A9.977 9.977 0 0 1 12 2Zm1 5v4.585l3.243 3.243-1.415 1.415L11 12.413V7h2Z"/>'
      }, props)
  }
  export function RiSystemHistoryLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.385-4.5H8v2H2v-6h2V6a9.985 9.985 0 0 1 8-4Zm1 5v4.585l3.243 3.243-1.415 1.415L11 12.413V7h2Z"/>'
      }, props)
  }
  export function RiSystemHourglass2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 2h16v4.46L13.537 12 20 17.54V22H4v-4.46L10.463 12 4 6.46V2Zm12.297 5L18 5.54V4H6v1.54L7.703 7h8.594ZM12 13.317 6 18.46V20h1l5-3 5 3h1v-1.54l-6-5.143Z"/>'
      }, props)
  }
  export function RiSystemHourglass2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 2h16v4.46L13.537 12 20 17.54V22H4v-4.46L10.463 12 4 6.46V2Zm8 8.683 6-5.143V4H6v1.54l6 5.143Zm0 2.634L6 18.46V20h12v-1.54l-6-5.143Z"/>'
      }, props)
  }
  export function RiSystemHourglassFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 4H4V2h16v2h-2v2c0 1.615-.816 2.915-1.844 3.977-.703.726-1.558 1.395-2.425 2.023.867.628 1.722 1.297 2.425 2.023C17.184 15.085 18 16.385 18 18v2h2v2H4v-2h2v-2c0-1.615.816-2.915 1.844-3.977.703-.726 1.558-1.395 2.425-2.023-.867-.628-1.722-1.297-2.425-2.023C6.816 8.915 6 7.615 6 6V4Zm2 0v2c0 .685.26 1.335.771 2h6.458c.51-.665.771-1.315.771-2V4H8Zm4 9.222c-1.045.738-1.992 1.441-2.719 2.192a6.84 6.84 0 0 0-.51.586h6.458a6.851 6.851 0 0 0-.51-.586c-.727-.751-1.674-1.454-2.719-2.192Z"/>'
      }, props)
  }
  export function RiSystemHourglassLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 4H4V2h16v2h-2v2c0 1.615-.816 2.915-1.844 3.977-.703.726-1.558 1.395-2.425 2.023.867.628 1.722 1.297 2.425 2.023C17.184 15.085 18 16.385 18 18v2h2v2H4v-2h2v-2c0-1.615.816-2.915 1.844-3.977.703-.726 1.558-1.395 2.425-2.023-.867-.628-1.722-1.297-2.425-2.023C6.816 8.915 6 7.615 6 6V4Zm2 0v2c0 .885.434 1.71 1.281 2.586.727.751 1.674 1.454 2.719 2.192 1.045-.738 1.992-1.441 2.719-2.192C15.566 7.71 16 6.885 16 6V4H8Zm4 9.222c-1.045.738-1.992 1.441-2.719 2.192C8.434 16.29 8 17.115 8 18v2h8v-2c0-.885-.434-1.71-1.281-2.586-.727-.751-1.674-1.454-2.719-2.192Z"/>'
      }, props)
  }
  export function RiSystemIndeterminateCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10ZM7 11v2h10v-2H7Z"/>'
      }, props)
  }
  export function RiSystemIndeterminateCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-5-9h10v2H7v-2Z"/>'
      }, props)
  }
  export function RiSystemInformationFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-1-11v6h2v-6h-2Zm0-4v2h2V7h-2Z"/>'
      }, props)
  }
  export function RiSystemInformationLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM11 7h2v2h-2V7Zm0 4h2v6h-2v-6Z"/>'
      }, props)
  }
  export function RiSystemListSettingsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 18h7v2H2v-2Zm0-7h9v2H2v-2Zm0-7h20v2H2V4Zm18.674 9.025 1.156-.391 1 1.732-.916.805a4.014 4.014 0 0 1 0 1.658l.916.805-1 1.732-1.156-.391c-.41.37-.898.654-1.435.83L19 21h-2l-.24-1.196a3.997 3.997 0 0 1-1.434-.83l-1.156.392-1-1.732.916-.805a4.014 4.014 0 0 1 0-1.658l-.916-.805 1-1.732 1.156.391c.41-.37.898-.655 1.435-.83L17 11h2l.24 1.196c.536.175 1.024.46 1.434.83ZM18 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiSystemListSettingsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 18h7v2H2v-2Zm0-7h9v2H2v-2Zm0-7h20v2H2V4Zm18.674 9.025 1.156-.391 1 1.732-.916.805a4.014 4.014 0 0 1 0 1.658l.916.805-1 1.732-1.156-.391c-.41.37-.898.654-1.435.83L19 21h-2l-.24-1.196a3.997 3.997 0 0 1-1.434-.83l-1.156.392-1-1.732.916-.805a4.014 4.014 0 0 1 0-1.658l-.916-.805 1-1.732 1.156.391c.41-.37.898-.655 1.435-.83L17 11h2l.24 1.196c.536.175 1.024.46 1.434.83ZM18 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiSystemLoader2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Zm0 15a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm10-5a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1ZM7 12a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1Zm12.071 7.071a1 1 0 0 1-1.414 0l-2.121-2.121a1 1 0 0 1 1.414-1.414l2.121 2.12a1 1 0 0 1 0 1.415ZM8.464 8.464a1 1 0 0 1-1.414 0L4.93 6.344a1 1 0 0 1 1.414-1.415L8.464 7.05a1 1 0 0 1 0 1.414ZM4.93 19.071a1 1 0 0 1 0-1.414l2.121-2.121a1 1 0 0 1 1.414 1.414l-2.12 2.121a1 1 0 0 1-1.415 0ZM15.536 8.464a1 1 0 0 1 0-1.414l2.12-2.121a1 1 0 1 1 1.415 1.414L16.95 8.464a1 1 0 0 1-1.414 0Z"/>'
      }, props)
  }
  export function RiSystemLoader2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Zm0 15a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm10-5a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1ZM7 12a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1Zm12.071 7.071a1 1 0 0 1-1.414 0l-2.121-2.121a1 1 0 0 1 1.414-1.414l2.121 2.12a1 1 0 0 1 0 1.415ZM8.464 8.464a1 1 0 0 1-1.414 0L4.93 6.344a1 1 0 0 1 1.414-1.415L8.464 7.05a1 1 0 0 1 0 1.414ZM4.93 19.071a1 1 0 0 1 0-1.414l2.121-2.121a1 1 0 0 1 1.414 1.414l-2.12 2.121a1 1 0 0 1-1.415 0ZM15.536 8.464a1 1 0 0 1 0-1.414l2.12-2.121a1 1 0 1 1 1.415 1.414L16.95 8.464a1 1 0 0 1-1.414 0Z"/>'
      }, props)
  }
  export function RiSystemLoader3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.055 13H5.07a7.002 7.002 0 0 0 13.858 0h2.016a9.001 9.001 0 0 1-17.89 0Zm0-2a9.001 9.001 0 0 1 17.89 0h-2.016A7.002 7.002 0 0 0 5.07 11H3.055Z"/>'
      }, props)
  }
  export function RiSystemLoader3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.055 13H5.07a7.002 7.002 0 0 0 13.858 0h2.016a9.001 9.001 0 0 1-17.89 0Zm0-2a9.001 9.001 0 0 1 17.89 0h-2.016A7.002 7.002 0 0 0 5.07 11H3.055Z"/>'
      }, props)
  }
  export function RiSystemLoader4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.364 5.636 16.95 7.05A7 7 0 1 0 19 12h2a9 9 0 1 1-2.636-6.364Z"/>'
      }, props)
  }
  export function RiSystemLoader4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.364 5.636 16.95 7.05A7 7 0 1 0 19 12h2a9 9 0 1 1-2.636-6.364Z"/>'
      }, props)
  }
  export function RiSystemLoader5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3a9 9 0 0 1 9 9h-2a7 7 0 0 0-7-7V3Z"/>'
      }, props)
  }
  export function RiSystemLoader5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3a9 9 0 0 1 9 9h-2a7 7 0 0 0-7-7V3Z"/>'
      }, props)
  }
  export function RiSystemLoaderFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Zm0 15a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm8.66-10a1 1 0 0 1-.366 1.366l-2.598 1.5a1 1 0 1 1-1-1.732l2.598-1.5A1 1 0 0 1 20.66 7ZM7.67 14.5a1 1 0 0 1-.367 1.366l-2.598 1.5a1 1 0 1 1-1-1.732l2.598-1.5a1 1 0 0 1 1.366.366ZM20.66 17a1 1 0 0 1-1.366.366l-2.598-1.5a1 1 0 0 1 1-1.732l2.598 1.5A1 1 0 0 1 20.66 17ZM7.67 9.5a1 1 0 0 1-1.367.366l-2.598-1.5a1 1 0 1 1 1-1.732l2.598 1.5A1 1 0 0 1 7.67 9.5Z"/>'
      }, props)
  }
  export function RiSystemLoaderLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Zm0 15a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm8.66-10a1 1 0 0 1-.366 1.366l-2.598 1.5a1 1 0 1 1-1-1.732l2.598-1.5A1 1 0 0 1 20.66 7ZM7.67 14.5a1 1 0 0 1-.367 1.366l-2.598 1.5a1 1 0 1 1-1-1.732l2.598-1.5a1 1 0 0 1 1.366.366ZM20.66 17a1 1 0 0 1-1.366.366l-2.598-1.5a1 1 0 0 1 1-1.732l2.598 1.5A1 1 0 0 1 20.66 17ZM7.67 9.5a1 1 0 0 1-1.367.366l-2.598-1.5a1 1 0 1 1 1-1.732l2.598 1.5A1 1 0 0 1 7.67 9.5Z"/>'
      }, props)
  }
  export function RiSystemLock2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0v1Zm-7 7.732V18h2v-2.268A2 2 0 0 0 12 12a2 2 0 0 0-1 3.732ZM16 8V7a4 4 0 0 0-8 0v1h8Z"/>'
      }, props)
  }
  export function RiSystemLock2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 8V7a6 6 0 1 1 12 0v1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2Zm13 2H5v10h14V10Zm-8 5.732A2 2 0 0 1 12 12a2 2 0 0 1 1 3.732V18h-2v-2.268ZM8 8h8V7a4 4 0 0 0-8 0v1Z"/>'
      }, props)
  }
  export function RiSystemLockFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 10h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1V9a7 7 0 0 1 14 0v1Zm-2 0V9A5 5 0 0 0 7 9v1h10Zm-6 4v4h2v-4h-2Z"/>'
      }, props)
  }
  export function RiSystemLockLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 10h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1V9a7 7 0 0 1 14 0v1ZM5 12v8h14v-8H5Zm6 2h2v4h-2v-4Zm6-4V9A5 5 0 0 0 7 9v1h10Z"/>'
      }, props)
  }
  export function RiSystemLockPasswordFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0v1Zm-2 0V7a4 4 0 0 0-8 0v1h8Zm-5 6v2h2v-2h-2Zm-4 0v2h2v-2H7Zm8 0v2h2v-2h-2Z"/>'
      }, props)
  }
  export function RiSystemLockPasswordLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0v1ZM5 10v10h14V10H5Zm6 4h2v2h-2v-2Zm-4 0h2v2H7v-2Zm8 0h2v2h-2v-2Zm1-6V7a4 4 0 0 0-8 0v1h8Z"/>'
      }, props)
  }
  export function RiSystemLockUnlockFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 10h13a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1V9a7 7 0 0 1 13.262-3.131l-1.789.894A5 5 0 0 0 7 9v1Zm3 5v2h4v-2h-4Z"/>'
      }, props)
  }
  export function RiSystemLockUnlockLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 10h13a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1V9a7 7 0 0 1 13.262-3.131l-1.789.894A5 5 0 0 0 7 9v1Zm-2 2v8h14v-8H5Zm5 3h4v2h-4v-2Z"/>'
      }, props)
  }
  export function RiSystemLoginBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 11H4V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8h6v3l5-4-5-4v3Z"/>'
      }, props)
  }
  export function RiSystemLoginBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 15h2v5h12V4H6v5H4V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6Zm6-4V8l5 4-5 4v-3H2v-2h8Z"/>'
      }, props)
  }
  export function RiSystemLoginCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 11H2.048c.502-5.053 4.765-9 9.95-9 5.523 0 10 4.477 10 10s-4.477 10-10 10c-5.185 0-9.448-3.947-9.95-9h7.95v3l5-4-5-4v3Z"/>'
      }, props)
  }
  export function RiSystemLoginCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 11V8l5 4-5 4v-3H1v-2h9Zm-7.542 4h2.124A8.003 8.003 0 0 0 20 12 8 8 0 0 0 4.582 9H2.458C3.732 4.943 7.522 2 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-4.478 0-8.268-2.943-9.542-7Z"/>'
      }, props)
  }
  export function RiSystemLogoutBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 2h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Zm4 9V8l-5 4 5 4v-3h6v-2H9Z"/>'
      }, props)
  }
  export function RiSystemLogoutBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 18h2v2h12V4H6v2H4V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3Zm2-7h7v2H6v3l-5-4 5-4v3Z"/>'
      }, props)
  }
  export function RiSystemLogoutBoxRFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 22a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5Zm10-6 5-4-5-4v3H9v2h6v3Z"/>'
      }, props)
  }
  export function RiSystemLogoutBoxRLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 22a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3h-2V4H6v16h12v-2h2v3a1 1 0 0 1-1 1H5Zm13-6v-3h-7v-2h7V8l5 4-5 4Z"/>'
      }, props)
  }
  export function RiSystemLogoutCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10ZM7 11V8l-5 4 5 4v-3h8v-2H7Z"/>'
      }, props)
  }
  export function RiSystemLogoutCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 11h8v2H5v3l-5-4 5-4v3Zm-1 7h2.708a8 8 0 1 0 0-12H4A9.985 9.985 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.985 9.985 0 0 1-8-4Z"/>'
      }, props)
  }
  export function RiSystemLogoutCircleRFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm5-6 5-4-5-4v3H9v2h8v3Z"/>'
      }, props)
  }
  export function RiSystemLogoutCircleRLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2a9.985 9.985 0 0 1 8 4h-2.71a8 8 0 1 0 .001 12h2.71A9.985 9.985 0 0 1 12 22Zm7-6v-3h-8v-2h8V8l5 4-5 4Z"/>'
      }, props)
  }
  export function RiSystemLoopLeftFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 4a7.986 7.986 0 0 0-6.357 3.143L8 9.5H2v-6l2.219 2.219A9.982 9.982 0 0 1 12 2c5.523 0 10 4.477 10 10h-2a8 8 0 0 0-8-8Zm-8 8a8 8 0 0 0 14.357 4.857L16 14.5h6v6l-2.219-2.219A9.982 9.982 0 0 1 12 22C6.477 22 2 17.523 2 12h2Z"/>'
      }, props)
  }
  export function RiSystemLoopLeftLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 4a7.992 7.992 0 0 0-6.616 3.5H8v2H2v-6h2V6a9.984 9.984 0 0 1 8-4c5.523 0 10 4.477 10 10h-2a8 8 0 0 0-8-8Zm-8 8a8 8 0 0 0 14.616 4.5H16v-2h6v6h-2V18a9.984 9.984 0 0 1-8 4C6.477 22 2 17.523 2 12h2Z"/>'
      }, props)
  }
  export function RiSystemLoopRightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 4c2.59 0 4.894 1.23 6.357 3.143L16 9.5h6v-6l-2.219 2.219A9.982 9.982 0 0 0 12 2C6.477 2 2 6.477 2 12h2a8 8 0 0 1 8-8Zm8 8a8 8 0 0 1-14.357 4.857L8 14.5H2v6l2.219-2.219A9.982 9.982 0 0 0 12 22c5.523 0 10-4.477 10-10h-2Z"/>'
      }, props)
  }
  export function RiSystemLoopRightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 4a7.992 7.992 0 0 1 6.616 3.5H16v2h6v-6h-2V6a9.984 9.984 0 0 0-8-4C6.477 2 2 6.477 2 12h2a8 8 0 0 1 8-8Zm8 8a8 8 0 0 1-14.616 4.5H8v-2H2v6h2V18a9.984 9.984 0 0 0 8 4c5.523 0 10-4.477 10-10h-2Z"/>'
      }, props)
  }
  export function RiSystemMenu2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm0 7h12v2H3v-2Zm0 7h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiSystemMenu2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm0 7h12v2H3v-2Zm0 7h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiSystemMenu3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm6 7h12v2H9v-2Zm-6 7h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiSystemMenu3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm6 7h12v2H9v-2Zm-6 7h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiSystemMenu4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 18v2H5v-2h11Zm5-7v2H3v-2h18Zm-2-7v2H8V4h11Z"/>'
      }, props)
  }
  export function RiSystemMenu4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 18v2H5v-2h11Zm5-7v2H3v-2h18Zm-2-7v2H8V4h11Z"/>'
      }, props)
  }
  export function RiSystemMenu5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 18v2H6v-2h12Zm3-7v2H3v-2h18Zm-3-7v2H6V4h12Z"/>'
      }, props)
  }
  export function RiSystemMenu5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 18v2H6v-2h12Zm3-7v2H3v-2h18Zm-3-7v2H6V4h12Z"/>'
      }, props)
  }
  export function RiSystemMenuAddFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18 15-.001 3H21v2h-3.001L18 23h-2l-.001-3H13v-2h2.999L16 15h2Zm-7 3v2H3v-2h8Zm10-7v2H3v-2h18Zm0-7v2H3V4h18Z"/>'
      }, props)
  }
  export function RiSystemMenuAddLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18 15-.001 3H21v2h-3.001L18 23h-2l-.001-3H13v-2h2.999L16 15h2Zm-7 3v2H3v-2h8Zm10-7v2H3v-2h18Zm0-7v2H3V4h18Z"/>'
      }, props)
  }
  export function RiSystemMenuFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm0 7h18v2H3v-2Zm0 7h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiSystemMenuFoldFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 18v2H3v-2h18ZM6.95 3.55v9.9L2 8.5l4.95-4.95ZM21 11v2h-9v-2h9Zm0-7v2h-9V4h9Z"/>'
      }, props)
  }
  export function RiSystemMenuFoldLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 18v2H3v-2h18ZM6.596 3.903 8.01 5.318 4.828 8.5 8.01 11.68l-1.414 1.415L2 8.5l4.596-4.597ZM21 11v2h-9v-2h9Zm0-7v2h-9V4h9Z"/>'
      }, props)
  }
  export function RiSystemMenuLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4h18v2H3V4Zm0 7h18v2H3v-2Zm0 7h18v2H3v-2Z"/>'
      }, props)
  }
  export function RiSystemMenuUnfoldFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 18v2H3v-2h18ZM17.05 3.55 22 8.5l-4.95 4.95v-9.9ZM12 11v2H3v-2h9Zm0-7v2H3V4h9Z"/>'
      }, props)
  }
  export function RiSystemMenuUnfoldLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 18v2H3v-2h18ZM17.404 3.903 22 8.5l-4.596 4.596-1.414-1.415L19.172 8.5 15.99 5.318l1.414-1.415ZM12 11v2H3v-2h9Zm0-7v2H3V4h9Z"/>'
      }, props)
  }
  export function RiSystemMore2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm0 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm0-7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"/>'
      }, props)
  }
  export function RiSystemMore2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 3c-.825 0-1.5.675-1.5 1.5S11.175 6 12 6s1.5-.675 1.5-1.5S12.825 3 12 3Zm0 15c-.825 0-1.5.675-1.5 1.5S11.175 21 12 21s1.5-.675 1.5-1.5S12.825 18 12 18Zm0-7.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5Z"/>'
      }, props)
  }
  export function RiSystemMoreFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm14 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-7 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"/>'
      }, props)
  }
  export function RiSystemMoreLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.5 10.5c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5S6 12.825 6 12s-.675-1.5-1.5-1.5Zm15 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5S21 12.825 21 12s-.675-1.5-1.5-1.5Zm-7.5 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5Z"/>'
      }, props)
  }
  export function RiSystemNotificationBadgeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.341 4A6 6 0 0 0 21 11.659V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9.341ZM19 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"/>'
      }, props)
  }
  export function RiSystemNotificationBadgeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13.341 4A5.99 5.99 0 0 0 13 6H5v14h14v-8a5.99 5.99 0 0 0 2-.341V21a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9.341ZM19 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"/>'
      }, props)
  }
  export function RiSystemProhibitedFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19.743 18.329A9.958 9.958 0 0 0 22 12c0-5.523-4.477-10-10-10a9.959 9.959 0 0 0-6.329 2.257L19.743 18.33ZM4.257 5.67A9.959 9.959 0 0 0 2 12c0 5.523 4.477 10 10 10a9.958 9.958 0 0 0 6.329-2.257L4.257 5.67Z"/>'
      }, props)
  }
  export function RiSystemProhibitedLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.094 5.68 18.32 16.906A8 8 0 0 0 7.094 5.68Zm9.812 12.64L5.68 7.094A8 8 0 0 0 16.906 18.32ZM4.929 4.929A9.972 9.972 0 0 1 12 2c5.523 0 10 4.477 10 10a9.972 9.972 0 0 1-2.929 7.071A9.972 9.972 0 0 1 12 22C6.477 22 2 17.523 2 12a9.972 9.972 0 0 1 2.929-7.071Z"/>'
      }, props)
  }
  export function RiSystemQuestionFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-1-7v2h2v-2h-2Zm2-1.645A3.502 3.502 0 0 0 12 6.5a3.501 3.501 0 0 0-3.433 2.813l1.962.393A1.5 1.5 0 1 1 12 11.5a1 1 0 0 0-1 1V14h2v-.645Z"/>'
      }, props)
  }
  export function RiSystemQuestionLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-1-5h2v2h-2v-2Zm2-1.645V14h-2v-1.5a1 1 0 0 1 1-1 1.5 1.5 0 1 0-1.471-1.794l-1.962-.393A3.501 3.501 0 1 1 13 13.355Z"/>'
      }, props)
  }
  export function RiSystemRadioButtonFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-6a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/>'
      }, props)
  }
  export function RiSystemRadioButtonLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-3a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z"/>'
      }, props)
  }
  export function RiSystemRefreshFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm4.82-4.924A7 7 0 0 0 9.032 5.658l.975 1.755A5 5 0 0 1 17 12h-3l2.82 5.076Zm-1.852 1.266-.975-1.755A5 5 0 0 1 7 12h3L7.18 6.924a7 7 0 0 0 7.788 11.418Z"/>'
      }, props)
  }
  export function RiSystemRefreshLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.463 4.433A9.961 9.961 0 0 1 12 2c5.523 0 10 4.477 10 10 0 2.136-.67 4.116-1.81 5.74L17 12h3A8 8 0 0 0 6.46 6.228l-.997-1.795Zm13.074 15.134A9.961 9.961 0 0 1 12 22C6.477 22 2 17.523 2 12c0-2.136.67-4.116 1.81-5.74L7 12H4a8 8 0 0 0 13.54 5.772l.997 1.795Z"/>'
      }, props)
  }
  export function RiSystemSearch2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9Zm8.485 16.071 2.829 2.828-1.415 1.415-2.828-2.829 1.414-1.414Z"/>'
      }, props)
  }
  export function RiSystemSearch2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9Zm0 16c3.867 0 7-3.133 7-7s-3.133-7-7-7-7 3.133-7 7 3.133 7 7 7Zm8.485.071 2.829 2.828-1.415 1.415-2.828-2.829 1.414-1.414Z"/>'
      }, props)
  }
  export function RiSystemSearchEyeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.031 16.617 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617Zm-5.853-9.44a4 4 0 1 0 2.646 2.646 2 2 0 1 1-2.646-2.647Z"/>'
      }, props)
  }
  export function RiSystemSearchEyeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.031 16.617 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617Zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.867-3.133-7-7-7s-7 3.133-7 7 3.133 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15Zm-3.847-8.699a2 2 0 1 0 2.646 2.646 4 4 0 1 1-2.646-2.646Z"/>'
      }, props)
  }
  export function RiSystemSearchFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.031 16.617 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617Z"/>'
      }, props)
  }
  export function RiSystemSearchLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.031 16.617 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617Zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.867-3.133-7-7-7s-7 3.133-7 7 3.133 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15Z"/>'
      }, props)
  }
  export function RiSystemSettings2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m8.687 4 2.607-2.607a1 1 0 0 1 1.414 0L15.315 4H19a1 1 0 0 1 1 1v3.686l2.607 2.607a1 1 0 0 1 0 1.414L20 15.314V19a1 1 0 0 1-1 1h-3.686l-2.607 2.607a1 1 0 0 1-1.414 0L8.687 20H5.001a1 1 0 0 1-1-1v-3.686l-2.607-2.607a1 1 0 0 1 0-1.414l2.607-2.607V5a1 1 0 0 1 1-1h3.686Zm3.314 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiSystemSettings2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m8.687 4 2.607-2.607a1 1 0 0 1 1.414 0L15.315 4H19a1 1 0 0 1 1 1v3.686l2.607 2.607a1 1 0 0 1 0 1.414L20 15.314V19a1 1 0 0 1-1 1h-3.686l-2.607 2.607a1 1 0 0 1-1.414 0L8.687 20H5.001a1 1 0 0 1-1-1v-3.686l-2.607-2.607a1 1 0 0 1 0-1.414l2.607-2.607V5a1 1 0 0 1 1-1h3.686ZM6.001 6v3.515L3.516 12 6 14.485V18h3.515L12 20.485 14.486 18h3.515v-3.515L20.486 12l-2.485-2.485V6h-3.515l-2.485-2.485L9.516 6H6Zm6 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiSystemSettings3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.954 2.21a9.99 9.99 0 0 1 4.09-.002A3.993 3.993 0 0 0 16 5.07a3.992 3.992 0 0 0 3.457.261A9.988 9.988 0 0 1 21.5 8.877a3.992 3.992 0 0 0-1.5 3.122c0 1.264.586 2.391 1.501 3.124a10.042 10.042 0 0 1-2.045 3.543 3.992 3.992 0 0 0-3.456.261 3.993 3.993 0 0 0-1.955 2.86 9.99 9.99 0 0 1-4.09.004A3.993 3.993 0 0 0 8 18.927a3.992 3.992 0 0 0-3.457-.26A9.99 9.99 0 0 1 2.5 15.121 3.992 3.992 0 0 0 4 11.999c0-1.264-.587-2.39-1.502-3.124a10.043 10.043 0 0 1 2.045-3.542A3.993 3.993 0 0 0 8 5.07a3.993 3.993 0 0 0 1.954-2.86ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiSystemSettings3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.34 17a10.017 10.017 0 0 1-.979-2.326 3 3 0 0 0 .003-5.347 9.99 9.99 0 0 1 2.5-4.337 3 3 0 0 0 4.632-2.674 9.99 9.99 0 0 1 5.007.003 3 3 0 0 0 4.632 2.671c.578.59 1.093 1.262 1.525 2.01.432.749.757 1.53.978 2.326a3 3 0 0 0-.002 5.347 9.99 9.99 0 0 1-2.501 4.337 3 3 0 0 0-4.632 2.674 9.99 9.99 0 0 1-5.007-.002 3 3 0 0 0-4.631-2.672A10.018 10.018 0 0 1 3.339 17Zm5.66.196a4.992 4.992 0 0 1 2.25 2.77c.499.047 1 .048 1.499.002a4.993 4.993 0 0 1 2.25-2.772 4.993 4.993 0 0 1 3.526-.564c.29-.408.54-.843.748-1.298A4.993 4.993 0 0 1 18 12c0-1.26.47-2.437 1.273-3.334a8.152 8.152 0 0 0-.75-1.298A4.993 4.993 0 0 1 15 6.804a4.993 4.993 0 0 1-2.25-2.77c-.5-.047-1-.048-1.5-.001A4.993 4.993 0 0 1 9 6.804a4.993 4.993 0 0 1-3.526.564c-.29.408-.54.843-.747 1.298A4.993 4.993 0 0 1 6 12c0 1.26-.471 2.437-1.273 3.334a8.16 8.16 0 0 0 .75 1.298A4.993 4.993 0 0 1 9 17.196ZM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiSystemSettings4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5.334 4.545a9.99 9.99 0 0 1 3.542-2.048A3.993 3.993 0 0 0 12 4a3.993 3.993 0 0 0 3.124-1.502 9.99 9.99 0 0 1 3.542 2.048 3.993 3.993 0 0 0 .262 3.454 3.993 3.993 0 0 0 2.863 1.955 10.038 10.038 0 0 1 0 4.09c-1.16.178-2.23.86-2.863 1.955a3.993 3.993 0 0 0-.262 3.455 9.988 9.988 0 0 1-3.542 2.047A3.993 3.993 0 0 0 12 20a3.993 3.993 0 0 0-3.124 1.503 9.988 9.988 0 0 1-3.542-2.048 3.992 3.992 0 0 0-.262-3.455 3.993 3.993 0 0 0-2.863-1.954 10.043 10.043 0 0 1 0-4.091 3.993 3.993 0 0 0 2.863-1.955 3.993 3.993 0 0 0 .262-3.454ZM13.5 14.597a3 3 0 1 0-3-5.196 3 3 0 0 0 3 5.196Z"/>'
      }, props)
  }
  export function RiSystemSettings4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 12c0-.865.11-1.704.316-2.504A3 3 0 0 0 4.99 4.867a9.99 9.99 0 0 1 4.335-2.506 3 3 0 0 0 5.348 0 9.99 9.99 0 0 1 4.335 2.506 3 3 0 0 0 2.675 4.63c.206.8.316 1.638.316 2.503 0 .864-.11 1.703-.316 2.503a3 3 0 0 0-2.675 4.63 9.99 9.99 0 0 1-4.335 2.505 3 3 0 0 0-5.348 0 9.99 9.99 0 0 1-4.335-2.505 3 3 0 0 0-2.675-4.63C2.11 13.703 2 12.864 2 12Zm4.804 3c.63 1.091.81 2.346.564 3.524.408.29.842.541 1.297.75A4.993 4.993 0 0 1 12 18c1.26 0 2.438.471 3.335 1.274.455-.209.889-.46 1.297-.75A4.993 4.993 0 0 1 17.196 15a4.993 4.993 0 0 1 2.77-2.25 8.142 8.142 0 0 0 0-1.5A4.993 4.993 0 0 1 17.195 9a4.993 4.993 0 0 1-.564-3.524 7.991 7.991 0 0 0-1.297-.75A4.993 4.993 0 0 1 12 6a4.993 4.993 0 0 1-3.335-1.274 7.99 7.99 0 0 0-1.297.75A4.993 4.993 0 0 1 6.804 9a4.993 4.993 0 0 1-2.77 2.25 8.125 8.125 0 0 0 0 1.5A4.993 4.993 0 0 1 6.805 15ZM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiSystemSettings5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.132 13.63a9.942 9.942 0 0 1 .001-3.26c1.101.026 2.092-.502 2.477-1.431.385-.93.058-2.003-.74-2.763a9.942 9.942 0 0 1 2.306-2.307c.76.798 1.834 1.125 2.763.74.93-.385 1.458-1.376 1.431-2.477a9.942 9.942 0 0 1 3.261 0c-.027 1.102.502 2.092 1.431 2.477.93.385 2.003.058 2.763-.74a9.939 9.939 0 0 1 2.307 2.306c-.798.76-1.125 1.834-.74 2.764.385.93 1.375 1.458 2.477 1.43a9.945 9.945 0 0 1 0 3.262c-1.102-.027-2.092.501-2.477 1.43-.385.93-.058 2.004.74 2.764a9.939 9.939 0 0 1-2.306 2.306c-.76-.798-1.834-1.125-2.764-.74-.93.385-1.458 1.376-1.43 2.478a9.94 9.94 0 0 1-3.262-.001c.027-1.101-.502-2.092-1.43-2.477-.93-.385-2.004-.058-2.764.74a9.943 9.943 0 0 1-2.306-2.306c.798-.76 1.125-1.834.74-2.763-.385-.93-1.376-1.458-2.478-1.431ZM12.001 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiSystemSettings5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2.213 14.06a9.945 9.945 0 0 1 .001-4.12c1.11.131 2.079-.236 2.396-1.001.316-.765-.109-1.71-.986-2.402a9.945 9.945 0 0 1 2.913-2.914c.692.878 1.637 1.303 2.402.986.765-.317 1.133-1.286 1.002-2.396a9.945 9.945 0 0 1 4.12 0c-.131 1.11.236 2.08 1.001 2.396.765.317 1.71-.108 2.402-.985a9.945 9.945 0 0 1 2.914 2.912c-.878.692-1.303 1.638-.986 2.403.317.765 1.286 1.132 2.396 1.001a9.944 9.944 0 0 1 0 4.12c-1.11-.13-2.08.237-2.396 1.002-.317.764.108 1.71.985 2.402a9.947 9.947 0 0 1-2.912 2.914c-.693-.878-1.638-1.304-2.403-.987-.765.317-1.132 1.286-1.001 2.397a9.944 9.944 0 0 1-4.12-.001c.13-1.11-.237-2.079-1.002-2.396-.765-.317-1.71.109-2.402.986a9.944 9.944 0 0 1-2.914-2.913c.878-.692 1.303-1.637.987-2.402-.317-.765-1.286-1.133-2.397-1.002Zm1.788-1.85c1.1.305 2.007 1.002 2.456 2.086.45 1.085.3 2.22-.262 3.212.097.102.196.201.298.298.993-.563 2.127-.712 3.212-.262 1.084.449 1.78 1.356 2.085 2.456.14.004.28.004.42 0 .305-1.1 1.002-2.007 2.087-2.456 1.084-.45 2.219-.3 3.212.262.101-.097.2-.196.297-.298-.562-.993-.711-2.127-.262-3.212.45-1.084 1.357-1.781 2.456-2.085.004-.14.004-.28 0-.421-1.1-.304-2.007-1.001-2.456-2.086-.45-1.084-.3-2.22.262-3.212a7.852 7.852 0 0 0-.297-.297c-.993.562-2.128.711-3.212.262C13.212 6.007 12.515 5.1 12.21 4a7.938 7.938 0 0 0-.42 0c-.305 1.1-1.002 2.008-2.086 2.457-1.085.45-2.22.3-3.212-.262-.102.096-.201.195-.298.297.563.993.712 2.128.262 3.212-.449 1.085-1.356 1.781-2.456 2.086-.004.14-.004.28 0 .42ZM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiSystemSettings6Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.5 2.474 23 12l-5.5 9.526h-11L1 12l5.5-9.526h11ZM8.634 8.17l5 8.66 1.732-1-5-8.66-1.732 1Z"/>'
      }, props)
  }
  export function RiSystemSettings6Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.5 2.474 23 12l-5.5 9.526h-11L1 12l5.5-9.526h11Zm-1.155 2h-8.69L3.309 12l4.346 7.526h8.69L20.691 12l-4.346-7.526ZM8.634 8.17l1.732-1 5 8.66-1.732 1-5-8.66Z"/>'
      }, props)
  }
  export function RiSystemSettingsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 9.5 5.5v11L12 23l-9.5-5.5v-11L12 1Zm0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiSystemSettingsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 9.5 5.5v11L12 23l-9.5-5.5v-11L12 1Zm0 2.311L4.5 7.653v8.694l7.5 4.342 7.5-4.342V7.653L12 3.311ZM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiSystemShareBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 3v2H5v14h14v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm7.707 4.707L12 13.414 10.586 12l5.707-5.707L13 3h8v8l-3.293-3.293Z"/>'
      }, props)
  }
  export function RiSystemShareBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 3v2H5v14h14v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm7.586 2H13V3h8v8h-2V6.414l-7 7L10.586 12l7-7Z"/>'
      }, props)
  }
  export function RiSystemShareCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2.05v2.012A8.001 8.001 0 0 0 12 20a8.001 8.001 0 0 0 7.938-7h2.013c-.502 5.053-4.766 9-9.951 9-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95Zm7.707 4.657L12 13.414 10.586 12l6.707-6.707L14 2h8v8l-3.293-3.293Z"/>'
      }, props)
  }
  export function RiSystemShareCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 2.05v2.012A8.001 8.001 0 0 0 12 20a8.001 8.001 0 0 0 7.938-7h2.013c-.502 5.053-4.766 9-9.951 9-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95Zm9 3.364-8 8L10.586 12l8-8H14V2h8v8h-2V5.414Z"/>'
      }, props)
  }
  export function RiSystemShareFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.576 17.271-5.11-2.787a3.5 3.5 0 1 1 0-4.968l5.11-2.787a3.5 3.5 0 1 1 .958 1.755l-5.11 2.787a3.514 3.514 0 0 1 0 1.457l5.11 2.788a3.5 3.5 0 1 1-.958 1.755Z"/>'
      }, props)
  }
  export function RiSystemShareForward2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 19h16v-5h2v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-6h2v5Zm8-9H9a5.992 5.992 0 0 0-4.854 2.473A8.003 8.003 0 0 1 12 6V2l8 6-8 6v-4Z"/>'
      }, props)
  }
  export function RiSystemShareForward2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 19h16v-5h2v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-6h2v5ZM16.172 7l-3.95-3.95 1.414-1.414L20 8l-6.364 6.364-1.414-1.415L16.172 9H5V7h11.172Z"/>'
      }, props)
  }
  export function RiSystemShareForwardBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 3v2H4v14h16v-9h2v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm7 2V1l7 6h-9a2 2 0 0 0-2 2v6h-2V9a4 4 0 0 1 4-4h2Z"/>'
      }, props)
  }
  export function RiSystemShareForwardBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 3v2H4v14h16v-9h2v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm9.95 2L16 2.05 17.414.636l5.34 5.34A.6.6 0 0 1 22.33 7H14a2 2 0 0 0-2 2v6h-2V9a4 4 0 0 1 4-4h4.95Z"/>'
      }, props)
  }
  export function RiSystemShareForwardFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 14h-2a8.999 8.999 0 0 0-7.968 4.81A10.133 10.133 0 0 1 3 18C3 12.477 7.477 8 13 8V3l10 8-10 8v-5Z"/>'
      }, props)
  }
  export function RiSystemShareForwardLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 14h-2a8.999 8.999 0 0 0-7.968 4.81A10.133 10.133 0 0 1 3 18C3 12.477 7.477 8 13 8V2.5L23.5 11 13 19.5V14Zm-2-2h4v3.308L20.321 11 15 6.692V10h-2a7.982 7.982 0 0 0-6.057 2.774A10.987 10.987 0 0 1 11 12Z"/>'
      }, props)
  }
  export function RiSystemShareLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13.12 17.023-4.199-2.29a4 4 0 1 1 0-5.465l4.2-2.29a4 4 0 1 1 .958 1.755l-4.2 2.29a4.008 4.008 0 0 1 0 1.954l4.2 2.29a4 4 0 1 1-.959 1.755ZM6 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm11-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiSystemShieldCheckFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976L12 1Zm4.452 7.222-4.95 4.949-2.828-2.828-1.414 1.414L11.503 16l6.364-6.364-1.415-1.414Z"/>'
      }, props)
  }
  export function RiSystemShieldCheckLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976L12 1Zm0 2.049L5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05Zm4.452 5.173 1.415 1.414L11.503 16 7.26 11.757l1.414-1.414 2.828 2.828 4.95-4.95Z"/>'
      }, props)
  }
  export function RiSystemShieldCrossFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.783 2.826 12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976ZM11 10H8v2h3v3h2v-3h3v-2h-3V7h-2v3Z"/>'
      }, props)
  }
  export function RiSystemShieldCrossLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.783 2.826 12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976ZM5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05 5 4.604ZM11 10V7h2v3h3v2h-3v3h-2v-3H8v-2h3Z"/>'
      }, props)
  }
  export function RiSystemShieldFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.783 2.826 12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976Z"/>'
      }, props)
  }
  export function RiSystemShieldFlashFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.783 2.826 12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976ZM13 10V5l-5 7h3v5l5-7h-3Z"/>'
      }, props)
  }
  export function RiSystemShieldFlashLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.783 2.826 12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976ZM5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05 5 4.604ZM13 10h3l-5 7v-5H8l5-7v5Z"/>'
      }, props)
  }
  export function RiSystemShieldKeyholeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976L12 1Zm0 6a2 2 0 0 0-1 3.732V15h2l.001-4.268A2 2 0 0 0 12 7Z"/>'
      }, props)
  }
  export function RiSystemShieldKeyholeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 1 8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976L12 1Zm0 2.049L5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05ZM12 7a2 2 0 0 1 1.001 3.732L13 15h-2v-4.268A2 2 0 0 1 12 7Z"/>'
      }, props)
  }
  export function RiSystemShieldLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.783 2.826 12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976ZM5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05 5 4.604Z"/>'
      }, props)
  }
  export function RiSystemShieldStarFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.783 2.826 12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976ZM12 13.5l2.939 1.545-.561-3.272 2.377-2.318-3.285-.478L12 6l-1.47 2.977-3.285.478 2.377 2.318-.56 3.272L12 13.5Z"/>'
      }, props)
  }
  export function RiSystemShieldStarLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05 5 4.604ZM3.783 2.826 12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976ZM12 13.5l-2.939 1.545.561-3.272-2.377-2.318 3.285-.478L12 6l1.47 2.977 3.285.478-2.377 2.318.56 3.272L12 13.5Z"/>'
      }, props)
  }
  export function RiSystemShieldUserFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.783 2.826 12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976ZM12 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-4.473 5h8.945a4.5 4.5 0 0 0-8.945 0Z"/>'
      }, props)
  }
  export function RiSystemShieldUserLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3.783 2.826 12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976ZM5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05 5 4.604ZM12 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm-4.473 5a4.5 4.5 0 0 1 8.945 0H7.527Z"/>'
      }, props)
  }
  export function RiSystemSideBarFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm6 2v14h11V5H9Z"/>'
      }, props)
  }
  export function RiSystemSideBarLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm5 2H4v14h4V5Zm2 0v14h10V5H10Z"/>'
      }, props)
  }
  export function RiSystemSpam2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.935 2.501 21.5 8.066v7.87l-5.565 5.565h-7.87L2.5 15.936v-7.87l5.565-5.565h7.87Zm-4.936 12.5v2h2v-2h-2Zm0-8v6h2V7h-2Z"/>'
      }, props)
  }
  export function RiSystemSpam2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.935 2.501 21.5 8.066v7.87l-5.565 5.565h-7.87L2.5 15.936v-7.87l5.565-5.565h7.87Zm-.828 2H8.893L4.5 8.894v6.214L8.893 19.5h6.214l4.393-4.393V8.894l-4.393-4.393Zm-4.108 10.5h2v2h-2v-2Zm0-8h2v6h-2V7Z"/>'
      }, props)
  }
  export function RiSystemSpam3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.935 2.501 21.5 8.066v7.87l-5.565 5.565h-7.87L2.5 15.936v-7.87l5.565-5.565h7.87Zm-7.936 8.5v2h8v-2H8Z"/>'
      }, props)
  }
  export function RiSystemSpam3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.935 2.501 21.5 8.066v7.87l-5.565 5.565h-7.87L2.5 15.936v-7.87l5.565-5.565h7.87Zm-.828 2H8.893L4.5 8.894v6.214L8.893 19.5h6.214l4.393-4.393V8.894l-4.393-4.393Zm-7.108 6.5h8v2H8v-2Z"/>'
      }, props)
  }
  export function RiSystemSpamFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.5 2.5 23 12l-5.5 9.5h-11L1 12l5.5-9.5h11ZM11 15v2h2v-2h-2Zm0-8v6h2V7h-2Z"/>'
      }, props)
  }
  export function RiSystemSpamLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.5 2.5 23 12l-5.5 9.5h-11L1 12l5.5-9.5h11Zm-1.153 2H7.653L3.311 12l4.342 7.5h8.694l4.342-7.5-4.342-7.5ZM11 15h2v2h-2v-2Zm0-8h2v6h-2V7Z"/>'
      }, props)
  }
  export function RiSystemStarFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 18.26-7.053 3.948 1.575-7.928L.588 8.792l8.027-.952L12 .5l3.385 7.34 8.027.952-5.934 5.488 1.575 7.928-7.053-3.948Z"/>'
      }, props)
  }
  export function RiSystemStarHalfFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 15.968 4.247 2.377-.948-4.773 3.573-3.305-4.833-.573-2.038-4.419v10.693Zm0 2.292-7.053 3.948 1.575-7.928L.588 8.792l8.027-.952L12 .5l3.385 7.34 8.027.952-5.934 5.488 1.575 7.928-7.053-3.948Z"/>'
      }, props)
  }
  export function RiSystemStarHalfLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 15.968 4.247 2.377-.948-4.773 3.573-3.305-4.833-.573-2.038-4.419v10.693Zm0 2.292-7.053 3.948 1.575-7.928L.588 8.792l8.027-.952L12 .5l3.385 7.34 8.027.952-5.934 5.488 1.575 7.928-7.053-3.948Z"/>'
      }, props)
  }
  export function RiSystemStarHalfSFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 14.656 2.818 1.72-.766-3.21 2.506-2.147-3.29-.264-1.267-3.047v6.948ZM12 17l-5.877 3.59 1.598-6.7-5.23-4.48 6.865-.55L12 2.5l2.645 6.36 6.865.55-5.23 4.48 1.598 6.7L12 17Z"/>'
      }, props)
  }
  export function RiSystemStarHalfSLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 14.656 2.818 1.72-.766-3.21 2.506-2.147-3.29-.264-1.267-3.047v6.948ZM12 17l-5.877 3.59 1.598-6.7-5.23-4.48 6.865-.55L12 2.5l2.645 6.36 6.865.55-5.23 4.48 1.598 6.7L12 17Z"/>'
      }, props)
  }
  export function RiSystemStarLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 18.26-7.053 3.948 1.575-7.928L.588 8.792l8.027-.952L12 .5l3.385 7.34 8.027.952-5.934 5.488 1.575 7.928-7.053-3.948Zm0-2.292 4.247 2.377-.948-4.773 3.573-3.305-4.833-.573-2.038-4.419-2.039 4.42-4.833.572 3.573 3.305-.948 4.773L12 15.968Z"/>'
      }, props)
  }
  export function RiSystemStarSFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 17-5.877 3.59 1.598-6.7-5.23-4.48 6.865-.55L12 2.5l2.645 6.36 6.865.55-5.23 4.48 1.598 6.7L12 17Z"/>'
      }, props)
  }
  export function RiSystemStarSLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 17-5.877 3.59 1.598-6.7-5.23-4.48 6.865-.55L12 2.5l2.645 6.36 6.865.55-5.23 4.48 1.598 6.7L12 17Zm0-2.344 2.818 1.72-.766-3.21 2.506-2.147-3.29-.264-1.267-3.047-1.268 3.047-3.29.264 2.507 2.147-.766 3.21 2.817-1.72Z"/>'
      }, props)
  }
  export function RiSystemSubtractFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 11H5v2h14v-2Z"/>'
      }, props)
  }
  export function RiSystemSubtractLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 11v2h14v-2H5Z"/>'
      }, props)
  }
  export function RiSystemThumbDownFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M22 15h-3V3h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1Zm-5.293 1.293-6.4 6.4a.5.5 0 0 1-.654.047L8.8 22.1a1.5 1.5 0 0 1-.553-1.57L9.4 16H3a2 2 0 0 1-2-2v-2.104a2 2 0 0 1 .15-.762L4.246 3.62A1 1 0 0 1 5.17 3H16a1 1 0 0 1 1 1v11.586a1 1 0 0 1-.293.707Z"/>'
      }, props)
  }
  export function RiSystemThumbDownLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.4 16H3a2 2 0 0 1-2-2v-2.104a2 2 0 0 1 .15-.762L4.246 3.62A1 1 0 0 1 5.17 3H22a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-3.482a1 1 0 0 0-.817.423l-5.453 7.726a.5.5 0 0 1-.632.159L9.802 22.4a2.5 2.5 0 0 1-1.305-2.853L9.4 16Zm7.6-2.588V5H5.84L3 11.896V14h6.4a2 2 0 0 1 1.938 2.493l-.903 3.548a.5.5 0 0 0 .261.571l.661.33 4.71-6.672c.25-.354.57-.644.933-.857ZM19 13h2V5h-2v8Z"/>'
      }, props)
  }
  export function RiSystemThumbUpFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 9h3v12H2a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1Zm5.293-1.293 6.4-6.4a.5.5 0 0 1 .654-.047l.853.64a1.5 1.5 0 0 1 .553 1.57L14.6 8H21a2 2 0 0 1 2 2v2.104a2 2 0 0 1-.15.762l-3.095 7.515a1 1 0 0 1-.925.619H8a1 1 0 0 1-1-1V8.414a1 1 0 0 1 .293-.707Z"/>'
      }, props)
  }
  export function RiSystemThumbUpLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.6 8H21a2 2 0 0 1 2 2v2.105c0 .26-.051.52-.15.761l-3.095 7.515a1 1 0 0 1-.925.62H2a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h3.482a1 1 0 0 0 .817-.424L11.752.851a.5.5 0 0 1 .632-.159l1.814.908a2.5 2.5 0 0 1 1.305 2.852L14.6 8ZM7 10.588V19h11.16L21 12.105V10h-6.4a2 2 0 0 1-1.938-2.493l.903-3.548a.5.5 0 0 0-.261-.57l-.661-.331-4.71 6.672c-.25.354-.57.645-.933.858ZM5 11H3v8h2v-8Z"/>'
      }, props)
  }
  export function RiSystemTimeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm1-10V7h-2v7h6v-2h-4Z"/>'
      }, props)
  }
  export function RiSystemTimeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-8h4v2h-6V7h2v5Z"/>'
      }, props)
  }
  export function RiSystemTimer2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm3.536 5.05L10.585 12 12 13.414l4.95-4.95-1.414-1.414Z"/>'
      }, props)
  }
  export function RiSystemTimer2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2Zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8Zm3.536-12.95 1.414 1.414-4.95 4.95L10.586 12l4.95-4.95Z"/>'
      }, props)
  }
  export function RiSystemTimerFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.618 5.968 1.453-1.453 1.414 1.414-1.453 1.453A9 9 0 1 1 12 4c2.125 0 4.078.736 5.618 1.968ZM11 8v6h2V8h-2ZM8 1h8v2H8V1Z"/>'
      }, props)
  }
  export function RiSystemTimerFlashFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.382 5.968A8.962 8.962 0 0 1 12 4c2.125 0 4.078.736 5.618 1.968l1.453-1.453 1.414 1.414-1.453 1.453A9 9 0 1 1 3 13c0-2.125.736-4.078 1.968-5.618L3.515 5.93l1.414-1.414 1.453 1.453ZM13 12V7.495L8 14h3v4.5l5-6.5h-3ZM8 1h8v2H8V1Z"/>'
      }, props)
  }
  export function RiSystemTimerFlashLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.382 5.968A8.962 8.962 0 0 1 12 4c2.125 0 4.078.736 5.618 1.968l1.453-1.453 1.414 1.414-1.453 1.453A9 9 0 1 1 3 13c0-2.125.736-4.078 1.968-5.618L3.515 5.93l1.414-1.414 1.453 1.453ZM12 20a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm1-8h3l-5 6.5V14H8l5-6.505V12ZM8 1h8v2H8V1Z"/>'
      }, props)
  }
  export function RiSystemTimerLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.618 5.968 1.453-1.453 1.414 1.414-1.453 1.453A9 9 0 1 1 12 4c2.125 0 4.078.736 5.618 1.968ZM12 20a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM11 8h2v6h-2V8ZM8 1h8v2H8V1Z"/>'
      }, props)
  }
  export function RiSystemToggleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 5h8a7 7 0 1 1 0 14H8A7 7 0 1 1 8 5Zm8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiSystemToggleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 7a5 5 0 0 0 0 10h8a5 5 0 0 0 0-10H8Zm0-2h8a7 7 0 1 1 0 14H8A7 7 0 1 1 8 5Zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"/>'
      }, props)
  }
  export function RiSystemUpload2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 19h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7ZM14 9v6h-4V9H5l7-7 7 7h-5Z"/>'
      }, props)
  }
  export function RiSystemUpload2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 19h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7Zm9-10v7h-2V9H6l6-6 6 6h-5Z"/>'
      }, props)
  }
  export function RiSystemUploadCloud2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 12.586 4.243 4.242-1.415 1.415L13 16.415V22h-2v-5.587l-1.828 1.83-1.415-1.415L12 12.586ZM12 2a7.001 7.001 0 0 1 6.954 6.194A5.5 5.5 0 0 1 18 18.978V17a6 6 0 0 0-11.996-.225L6 17v1.978a5.5 5.5 0 0 1-.954-10.784A7 7 0 0 1 12 2Z"/>'
      }, props)
  }
  export function RiSystemUploadCloud2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m12 12.586 4.243 4.242-1.415 1.415L13 16.415V22h-2v-5.587l-1.828 1.83-1.415-1.415L12 12.586ZM12 2a7.001 7.001 0 0 1 6.954 6.194A5.5 5.5 0 0 1 18 18.978v-2.014a3.5 3.5 0 1 0-1.111-6.91 5 5 0 1 0-9.777 0 3.5 3.5 0 0 0-1.292 6.88l.18.03v2.014a5.5 5.5 0 0 1-.954-10.784A7 7 0 0 1 12 2Z"/>'
      }, props)
  }
  export function RiSystemUploadCloudFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 20.981a6.5 6.5 0 0 1-2.936-12 8.001 8.001 0 0 1 15.872 0 6.5 6.5 0 0 1-2.936 12V21H7v-.019ZM13 13h3l-4-5-4 5h3v4h2v-4Z"/>'
      }, props)
  }
  export function RiSystemUploadCloudLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1 14.5a6.496 6.496 0 0 1 3.064-5.519 8.001 8.001 0 0 1 15.872 0 6.5 6.5 0 0 1-2.936 12L7 21c-3.356-.274-6-3.078-6-6.5Zm15.848 4.487a4.5 4.5 0 0 0 2.03-8.309l-.807-.503-.12-.942a6.001 6.001 0 0 0-11.903 0l-.12.942-.805.503a4.5 4.5 0 0 0 2.029 8.309l.173.013h9.35l.173-.013ZM13 13v4h-2v-4H8l4-5 4 5h-3Z"/>'
      }, props)
  }
  export function RiSystemUploadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 19h18v2H3v-2Zm10-9v8h-2v-8H4l8-8 8 8h-7Z"/>'
      }, props)
  }
  export function RiSystemUploadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 19h18v2H3v-2ZM13 5.828V17h-2V5.828L4.929 11.9l-1.414-1.414L12 2l8.485 8.485-1.414 1.415L13 5.827Z"/>'
      }, props)
  }
  export function RiSystemZoomInFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.031 16.617 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617ZM10 10H7v2h3v3h2v-3h3v-2h-3V7h-2v3Z"/>'
      }, props)
  }
  export function RiSystemZoomInLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.031 16.617 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617Zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.867-3.133-7-7-7s-7 3.133-7 7 3.133 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15ZM10 10V7h2v3h3v2h-3v3h-2v-3H7v-2h3Z"/>'
      }, props)
  }
  export function RiSystemZoomOutFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.031 16.617 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617ZM7 10v2h8v-2H7Z"/>'
      }, props)
  }
  export function RiSystemZoomOutLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m18.031 16.617 4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617Zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.867-3.133-7-7-7s-7 3.133-7 7 3.133 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15ZM7 10h8v2H7v-2Z"/>'
      }, props)
  }
  export function RiUserFacesAccountBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005V4.995ZM6.357 18h11.49a6.992 6.992 0 0 0-5.745-3 6.992 6.992 0 0 0-5.745 3ZM12 13a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"/>'
      }, props)
  }
  export function RiUserFacesAccountBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005V4.995ZM5 5v14h14V5H5Zm2.972 13.18a9.977 9.977 0 0 1-1.751-.978A6.994 6.994 0 0 1 12.102 14c2.4 0 4.517 1.207 5.778 3.047a9.987 9.987 0 0 1-1.724 1.025A4.993 4.993 0 0 0 12.101 16c-1.716 0-3.23.864-4.13 2.18ZM12 13a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesAccountCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2ZM6.023 15.416C7.491 17.606 9.695 19 12.16 19c2.464 0 4.669-1.393 6.136-3.584A8.968 8.968 0 0 0 12.16 13a8.968 8.968 0 0 0-6.137 2.416ZM12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiUserFacesAccountCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm.16 14a6.981 6.981 0 0 0-5.147 2.256A7.966 7.966 0 0 0 12 20c1.97 0 3.773-.712 5.167-1.892A6.979 6.979 0 0 0 12.16 16ZM12 4a8 8 0 0 0-6.384 12.821A8.975 8.975 0 0 1 12.16 14a8.972 8.972 0 0 1 6.362 2.634A8 8 0 0 0 12 4Zm0 1a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>'
      }, props)
  }
  export function RiUserFacesAccountPinBoxFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14 21-2 2-2-2H4.995A1.995 1.995 0 0 1 3 19.005V4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H14Zm-7.643-3h11.49a6.992 6.992 0 0 0-5.745-3 6.992 6.992 0 0 0-5.745 3ZM12 13a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"/>'
      }, props)
  }
  export function RiUserFacesAccountPinBoxLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m14 21-2 2-2-2H4.995A1.995 1.995 0 0 1 3 19.005V4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H14Zm5-2V5H5v14h5.828L12 20.172 13.172 19H19Zm-11.028-.82a9.977 9.977 0 0 1-1.751-.978A6.994 6.994 0 0 1 12.102 14c2.4 0 4.517 1.207 5.778 3.047a9.987 9.987 0 0 1-1.724 1.025A4.993 4.993 0 0 0 12.101 16c-1.716 0-3.23.864-4.13 2.18ZM12 13a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesAccountPinCircleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14.256 21.744 12 24l-2.256-2.256C5.31 20.72 2 16.744 2 12 2 6.48 6.48 2 12 2s10 4.48 10 10c0 4.744-3.31 8.72-7.744 9.744Zm-8.233-6.328C7.491 17.606 9.695 19 12.16 19c2.464 0 4.669-1.393 6.136-3.584A8.968 8.968 0 0 0 12.16 13a8.968 8.968 0 0 0-6.137 2.416ZM12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiUserFacesAccountPinCircleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.745 21.745C5.308 20.722 2 16.747 2 12 2 6.477 6.477 2 12 2s10 4.477 10 10c0 4.747-3.308 8.722-7.745 9.745L12 24l-2.255-2.255Zm-2.733-3.488a7.953 7.953 0 0 0 3.182 1.539l.56.129L12 21.172l1.247-1.247.56-.13a7.955 7.955 0 0 0 3.36-1.686A6.979 6.979 0 0 0 12.16 16c-2.036 0-3.87.87-5.148 2.257ZM5.616 16.82A8.975 8.975 0 0 1 12.16 14a8.972 8.972 0 0 1 6.362 2.634 8 8 0 1 0-12.906.187ZM12 13a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiUserFacesAdminFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 14v8H4a8 8 0 0 1 8-8Zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm9 4h1v5h-8v-5h1v-1a3 3 0 1 1 6 0v1Zm-2 0v-1a1 1 0 1 0-2 0v1h2Z"/>'
      }, props)
  }
  export function RiUserFacesAdminLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8Zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm9 6h1v5h-8v-5h1v-1a3 3 0 1 1 6 0v1Zm-2 0v-1a1 1 0 1 0-2 0v1h2Z"/>'
      }, props)
  }
  export function RiUserFacesAliensFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a8.5 8.5 0 0 1 8.5 8.5c0 6.5-5.5 12-8.5 12s-8.5-5.5-8.5-12A8.5 8.5 0 0 1 12 2Zm5.5 10a4.5 4.5 0 0 0-4.475 4.975 4.5 4.5 0 0 0 4.95-4.95A4.565 4.565 0 0 0 17.5 12Zm-11 0c-.16 0-.319.008-.475.025a4.5 4.5 0 0 0 4.95 4.95A4.5 4.5 0 0 0 6.5 12Z"/>'
      }, props)
  }
  export function RiUserFacesAliensLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a8.5 8.5 0 0 1 8.5 8.5c0 6.5-5.5 12-8.5 12s-8.5-5.5-8.5-12A8.5 8.5 0 0 1 12 2Zm0 2a6.5 6.5 0 0 0-6.5 6.5c0 4.794 4.165 10 6.5 10s6.5-5.206 6.5-10A6.5 6.5 0 0 0 12 4Zm5.5 7c.16 0 .319.008.475.025a4.5 4.5 0 0 1-4.95 4.95A4.5 4.5 0 0 1 17.5 11Zm-11 0a4.5 4.5 0 0 1 4.475 4.975 4.5 4.5 0 0 1-4.95-4.95C6.18 11.008 6.34 11 6.5 11Z"/>'
      }, props)
  }
  export function RiUserFacesBearSmileFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17.5 2a4.5 4.5 0 0 1 2.951 7.897c.355.967.549 2.013.549 3.103a9 9 0 1 1-18 0c0-1.09.194-2.136.55-3.103a4.5 4.5 0 1 1 6.791-5.744 9.05 9.05 0 0 1 3.32 0A4.494 4.494 0 0 1 17.5 2ZM10 13H8a4 4 0 0 0 8 0h-2a2 2 0 1 1-4 0Z"/>'
      }, props)
  }
  export function RiUserFacesBearSmileLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 17a4 4 0 0 0 4-4h-2a2 2 0 1 1-4 0H8a4 4 0 0 0 4 4ZM6.5 2a4.5 4.5 0 0 0-2.95 7.898 9 9 0 1 0 16.901 0 4.5 4.5 0 1 0-6.79-5.745 9.044 9.044 0 0 0-3.321 0A4.496 4.496 0 0 0 6.5 2ZM4 6.5a2.5 2.5 0 0 1 4.852-.851l.318.878.898-.257A7.004 7.004 0 0 1 12 6c.672 0 1.32.094 1.932.27l.898.257.318-.878a2.501 2.501 0 1 1 3.58 3.03l-.814.46.404.842a7 7 0 1 1-12.635 0l.403-.843-.814-.46A2.499 2.499 0 0 1 4 6.5Z"/>'
      }, props)
  }
  export function RiUserFacesBodyScanFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 16v4h4v2H2v-6h2Zm18 0v6h-6v-2h4v-4h2ZM7.5 7a4.5 4.5 0 0 0 9 0h2a6.5 6.5 0 0 1-3.499 5.767L15 19H9v-6.232A6.5 6.5 0 0 1 5.5 7h2ZM12 5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM8 2v2l-4-.001V8H2V2h6Zm14 0v6h-2V4h-4V2h6Z"/>'
      }, props)
  }
  export function RiUserFacesBodyScanLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 16v4h4v2H2v-6h2Zm18 0v6h-6v-2h4v-4h2ZM7.5 7a4.502 4.502 0 0 0 3.5 4.389V17h2l.001-5.612A4.502 4.502 0 0 0 16.5 7h2a6.5 6.5 0 0 1-3.499 5.767L15 19H9v-6.232A6.5 6.5 0 0 1 5.5 7h2ZM12 5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM8 2v2l-4-.001V8H2V2h6Zm14 0v6h-2V4h-4V2h6Z"/>'
      }, props)
  }
  export function RiUserFacesContactsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 22a8 8 0 1 1 16 0H2Zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm10 4h4v2h-4v-2Zm-3-5h7v2h-7v-2Zm2-5h5v2h-5V7Z"/>'
      }, props)
  }
  export function RiUserFacesContactsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 7h5v2h-5V7Zm-2 5h7v2h-7v-2Zm3 5h4v2h-4v-2ZM2 22a8 8 0 1 1 16 0h-2a6 6 0 0 0-12 0H2Zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Z"/>'
      }, props)
  }
  export function RiUserFacesCriminalFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a9 9 0 0 1 6.894 14.786c1.255.83 2.034 1.89 2.101 3.049L21 20l-9 2-9-2 .005-.165c.067-1.16.846-2.22 2.1-3.05A8.965 8.965 0 0 1 3 11a9 9 0 0 1 9-9Zm0 11c-1.38 0-2.5.672-2.5 1.5S10.62 16 12 16s2.5-.672 2.5-1.5S13.38 13 12 13ZM9 8c-1.105 0-2 .672-2 1.5S7.895 11 9 11s2-.672 2-1.5S10.105 8 9 8Zm6 0c-1.105 0-2 .672-2 1.5s.895 1.5 2 1.5 2-.672 2-1.5S16.105 8 15 8Z"/>'
      }, props)
  }
  export function RiUserFacesCriminalLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a9 9 0 0 1 6.894 14.786c1.255.83 2.034 1.89 2.101 3.049L21 20l-9 2-9-2 .005-.165c.067-1.16.846-2.22 2.1-3.05A8.965 8.965 0 0 1 3 11a9 9 0 0 1 9-9Zm0 2a7 7 0 0 0-7 7c0 1.567.514 3.05 1.445 4.261l.192.239 1.443 1.717-1.962 1.299-.137.097L12 19.951l6.018-1.338-.049-.036-.178-.123-1.871-1.237 1.443-1.718A6.963 6.963 0 0 0 19 11a7 7 0 0 0-7-7Zm0 9c1.38 0 2.5.672 2.5 1.5S13.38 16 12 16s-2.5-.672-2.5-1.5S10.62 13 12 13ZM9 8c1.105 0 2 .672 2 1.5S10.105 11 9 11s-2-.672-2-1.5S7.895 8 9 8Zm6 0c1.105 0 2 .672 2 1.5s-.895 1.5-2 1.5-2-.672-2-1.5.895-1.5 2-1.5Z"/>'
      }, props)
  }
  export function RiUserFacesEmotion2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-4-9a4 4 0 0 0 8 0H8Z"/>'
      }, props)
  }
  export function RiUserFacesEmotion2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-4-7h8a4 4 0 0 1-8 0Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-4-9a4 4 0 0 0 8 0H8Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionHappyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-5-9a5 5 0 0 0 10 0h-2a3 3 0 1 1-6 0H7Zm1-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionHappyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-5-7h2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0Zm1-2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionLaughFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 9c-2 0-3.667.333-5 1a5 5 0 0 0 10 0c-1.333-.667-3-1-5-1ZM8.5 7c-1.152 0-2.122.78-2.412 1.84L6.05 9h4.9A2.5 2.5 0 0 0 8.5 7Zm7 0c-1.152 0-2.122.78-2.412 1.84L13.05 9h4.9a2.5 2.5 0 0 0-2.45-2Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionLaughLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 7c2 0 3.667.333 5 1a5 5 0 0 1-10 0c1.333-.667 3-1 5-1ZM8.5 7a2.5 2.5 0 0 1 2.45 2h-4.9A2.5 2.5 0 0 1 8.5 7Zm7 0a2.5 2.5 0 0 1 2.45 2h-4.9a2.5 2.5 0 0 1 2.45-2Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-4-7h8a4 4 0 0 1-8 0Zm0-2a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionNormalFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-4-8v2h8v-2H8Zm0-3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionNormalLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-4-6h8v2H8v-2Zm0-3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionSadFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10a9.959 9.959 0 0 1-1.065 4.496 1.975 1.975 0 0 0-.398-.775l-.123-.135L19 14.172l-1.414 1.414-.117.127a2 2 0 0 0 1.679 3.282A9.974 9.974 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2Zm0 13c-1.38 0-2.63.56-3.534 1.463l-.166.174.945.86C10.035 17.182 10.982 17 12 17c.905 0 1.754.144 2.486.396l.269.1.945-.86A4.987 4.987 0 0 0 12 15Zm-3.5-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionSadLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10 0 .727-.078 1.435-.225 2.118l-1.782-1.783a8 8 0 1 0-4.374 6.801 3.998 3.998 0 0 0 1.555 1.423A9.955 9.955 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2Zm7 12.172 1.414 1.414a2 2 0 1 1-2.93.11l.102-.11L19 14.172ZM12 15c1.466 0 2.785.631 3.7 1.637l-.945.86C13.965 17.182 13.018 17 12 17c-1.018 0-1.965.183-2.755.496l-.945-.86A4.987 4.987 0 0 1 12 15Zm-3.5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm7 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionUnhappyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm-5-5h2a3 3 0 1 1 6 0h2a5 5 0 0 0-10 0Zm1-6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm8 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesEmotionUnhappyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-5-3a5 5 0 0 1 10 0h-2a3 3 0 1 0-6 0H7Zm1-6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesGenderlessFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 7.066V1h2v6.066A7.501 7.501 0 0 1 12 22a7.5 7.5 0 0 1-1-14.934Z"/>'
      }, props)
  }
  export function RiUserFacesGenderlessLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 7.066A7.501 7.501 0 0 1 12 22a7.5 7.5 0 0 1-1-14.934V1h2v6.066ZM12 20a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"/>'
      }, props)
  }
  export function RiUserFacesGhost2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c3.5 0 6 3 7 6 3 1 4 3.73 4 6l-2.775.793a1 1 0 0 0-.725.961v1.496A1.75 1.75 0 0 1 17.75 19h-.596a2 2 0 0 0-1.668.896C14.558 21.3 13.396 22 12 22c-1.396 0-2.558-.701-3.486-2.104A2 2 0 0 0 6.846 19H6.25a1.75 1.75 0 0 1-1.75-1.75v-1.496a1 1 0 0 0-.725-.961L1 14c0-2.266 1-5 4-6 1-3 3.5-6 7-6Zm0 10c-.828 0-1.5 1.12-1.5 2.5S11.172 17 12 17s1.5-1.12 1.5-2.5S12.828 12 12 12ZM9.5 8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>'
      }, props)
  }
  export function RiUserFacesGhost2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c3.5 0 6 3 7 6 3 1 4 3.73 4 6l-2.775.793a1 1 0 0 0-.725.961v1.496A1.75 1.75 0 0 1 17.75 19h-.596a2 2 0 0 0-1.668.896C14.558 21.3 13.396 22 12 22c-1.396 0-2.558-.701-3.486-2.104A2 2 0 0 0 6.846 19H6.25a1.75 1.75 0 0 1-1.75-1.75v-1.496a1 1 0 0 0-.725-.961L1 14c0-2.266 1-5 4-6 1-3 3.5-6 7-6Zm0 2C9.89 4 7.935 5.788 6.989 8.371l-.092.261-.316.95-.949.315c-1.255.419-2.067 1.341-2.424 2.56l-.023.086 1.14.327a3 3 0 0 1 2.17 2.703l.005.181V17h.346a4 4 0 0 1 3.2 1.6l.136.192C10.758 19.663 11.316 20 12 20c.638 0 1.167-.293 1.703-1.04l.115-.168a4 4 0 0 1 3.1-1.785l.236-.007h.346v-1.246a3 3 0 0 1 2.003-2.83l.173-.054 1.139-.327-.023-.087c-.337-1.151-1.08-2.037-2.22-2.484l-.204-.075-.95-.316-.315-.949C16.195 5.91 14.18 4 12 4Zm0 8c.828 0 1.5 1.12 1.5 2.5S12.828 17 12 17s-1.5-1.12-1.5-2.5.672-2.5 1.5-2.5ZM9.5 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>'
      }, props)
  }
  export function RiUserFacesGhostFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a9 9 0 0 1 9 9v7.5a3.5 3.5 0 0 1-6.39 1.976 2.999 2.999 0 0 1-5.223 0 3.5 3.5 0 0 1-6.382-1.783L3 18.499V11a9 9 0 0 1 9-9Zm0 10c-1.105 0-2 1.12-2 2.5s.895 2.5 2 2.5 2-1.12 2-2.5-.895-2.5-2-2.5ZM9.5 8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"/>'
      }, props)
  }
  export function RiUserFacesGhostLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a9 9 0 0 1 9 9v7.5a3.5 3.5 0 0 1-6.39 1.976 2.999 2.999 0 0 1-5.223 0 3.5 3.5 0 0 1-6.382-1.783L3 18.499V11a9 9 0 0 1 9-9Zm0 2a7 7 0 0 0-6.996 6.76L5 11v7.446l.002.138a1.5 1.5 0 0 0 2.645.88l.088-.116a2 2 0 0 1 3.393.142.999.999 0 0 0 1.74.003 2 2 0 0 1 3.296-.278l.097.13a1.5 1.5 0 0 0 2.732-.701L19 18.5V11a7 7 0 0 0-7-7Zm0 8c1.105 0 2 1.12 2 2.5s-.895 2.5-2 2.5-2-1.12-2-2.5.895-2.5 2-2.5ZM9.5 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>'
      }, props)
  }
  export function RiUserFacesGhostSmileFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a9 9 0 0 1 9 9v7.5a3.5 3.5 0 0 1-6.39 1.976 2.999 2.999 0 0 1-5.223 0 3.5 3.5 0 0 1-6.382-1.783L3 18.499V11a9 9 0 0 1 9-9Zm4 11h-2a2 2 0 0 1-3.995.15L10 13H8l.005.2a4 4 0 0 0 7.99 0L16 13Zm-4-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>'
      }, props)
  }
  export function RiUserFacesGhostSmileLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2a9 9 0 0 1 9 9v7.5a3.5 3.5 0 0 1-6.39 1.976 2.999 2.999 0 0 1-5.223 0 3.5 3.5 0 0 1-6.382-1.783L3 18.499V11a9 9 0 0 1 9-9Zm0 2a7 7 0 0 0-6.996 6.76L5 11v7.446l.002.138a1.5 1.5 0 0 0 2.645.88l.088-.116a2 2 0 0 1 3.393.142.999.999 0 0 0 1.74.003 2 2 0 0 1 3.296-.278l.097.13a1.5 1.5 0 0 0 2.732-.701L19 18.5V11a7 7 0 0 0-7-7Zm4 9a4 4 0 0 1-7.995.2L8 13h2a2 2 0 1 0 4 0h2Zm-4-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"/>'
      }, props)
  }
  export function RiUserFacesGroup2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 19.748V16.4c0-1.283.995-2.292 2.467-2.868A8.48 8.48 0 0 0 9.5 13c-1.89 0-3.636.617-5.047 1.66A8.017 8.017 0 0 0 10 19.748Zm8.88-3.662C18.485 15.553 17.17 15 15.5 15c-2.006 0-3.5.797-3.5 1.4V20a7.996 7.996 0 0 0 6.88-3.914ZM9.55 11.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Zm5.95 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z"/>'
      }, props)
  }
  export function RiUserFacesGroup2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.55 11.5a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5Zm.45 8.248V16.4c0-.488.144-.937.404-1.338a6.474 6.474 0 0 0-5.033 1.417A8.012 8.012 0 0 0 10 19.749ZM4.453 14.66A8.462 8.462 0 0 1 9.5 13a8.48 8.48 0 0 1 2.967.532C13.345 13.19 14.392 13 15.5 13c1.66 0 3.185.424 4.206 1.156a8 8 0 1 0-15.253.504Zm14.426 1.426C18.486 15.553 17.171 15 15.5 15c-2.006 0-3.5.797-3.5 1.4V20a7.996 7.996 0 0 0 6.88-3.914ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm3.5-9.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiUserFacesGroupFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 22a8 8 0 1 1 16 0H2Zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm7.363 2.233A7.505 7.505 0 0 1 22.983 22H20c0-2.61-1-4.986-2.637-6.767Zm-2.023-2.276A7.98 7.98 0 0 0 18 7a7.964 7.964 0 0 0-1.015-3.903A5 5 0 0 1 21 8a4.999 4.999 0 0 1-5.66 4.957Z"/>'
      }, props)
  }
  export function RiUserFacesGroupLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 22a8 8 0 1 1 16 0h-2a6 6 0 0 0-12 0H2Zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm8.284 3.703A8.002 8.002 0 0 1 23 22h-2a6.001 6.001 0 0 0-3.537-5.473l.82-1.824Zm-.688-11.29A5.5 5.5 0 0 1 21 8.5a5.499 5.499 0 0 1-5 5.478v-2.013a3.5 3.5 0 0 0 1.041-6.609l.555-1.943Z"/>'
      }, props)
  }
  export function RiUserFacesMenFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.586 5H14V3h8v8h-2V6.414l-3.537 3.537a7.5 7.5 0 1 1-1.414-1.414L18.586 5Z"/>'
      }, props)
  }
  export function RiUserFacesMenLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15.05 8.537 18.585 5H14V3h8v8h-2V6.414l-3.537 3.537a7.5 7.5 0 1 1-1.414-1.414ZM10.5 20a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"/>'
      }, props)
  }
  export function RiUserFacesMickeyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.5 2a4.5 4.5 0 0 1 .883 8.913 8 8 0 1 1-14.765-.001A4.499 4.499 0 0 1 5.5 2a4.5 4.5 0 0 1 4.493 4.254A7.998 7.998 0 0 1 12 6c.693 0 1.365.088 2.006.254A4.5 4.5 0 0 1 18.5 2Z"/>'
      }, props)
  }
  export function RiUserFacesMickeyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.617 10.913A4.501 4.501 0 0 1 5.5 2a4.5 4.5 0 0 1 4.493 4.254A8.014 8.014 0 0 1 12 6c.693 0 1.365.088 2.007.254a4.5 4.5 0 1 1 5.376 4.66 8 8 0 1 1-14.766 0ZM3 6.5a2.5 2.5 0 0 0 2.766 2.486 8.04 8.04 0 0 1 2.158-1.871A2.5 2.5 0 1 0 3 6.5Zm15.234 2.486a2.5 2.5 0 1 0-2.158-1.871 8.039 8.039 0 0 1 2.158 1.871ZM6 14a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"/>'
      }, props)
  }
  export function RiUserFacesOpenArmFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12.001 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm6 5v5h-2v-5c0-4.451 2.644-8.285 6.447-10.016l.828 1.82A9.002 9.002 0 0 0 18.001 17Zm-10 0v5h-2v-5A9.002 9.002 0 0 0 .727 8.805l.827-1.821A11.002 11.002 0 0 1 8.001 17Z"/>'
      }, props)
  }
  export function RiUserFacesOpenArmLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.001 17v5h-2v-5c0-4.451 2.644-8.285 6.447-10.016l.828 1.82A9.002 9.002 0 0 0 18.001 17Zm-10 0v5h-2v-5A9.002 9.002 0 0 0 .727 8.805l.827-1.821A11.002 11.002 0 0 1 8.001 17Zm4-5a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>'
      }, props)
  }
  export function RiUserFacesParentFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 11a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm10.5 4a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0 1a4.5 4.5 0 0 1 4.5 4.5v.5h-9v-.5a4.5 4.5 0 0 1 4.5-4.5ZM7 12a5 5 0 0 1 5 5v4H2v-4a5 5 0 0 1 5-5Z"/>'
      }, props)
  }
  export function RiUserFacesParentLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 2a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm10.5 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm2.5 6v-.5a2.5 2.5 0 0 0-5 0v.5h-2v-.5a4.5 4.5 0 1 1 9 0v.5h-2Zm-10 0v-4a3 3 0 1 0-6 0v4H2v-4a5 5 0 0 1 10 0v4h-2Z"/>'
      }, props)
  }
  export function RiUserFacesRobotFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 4.055c4.5.497 8 4.312 8 8.945v9H3v-9c0-4.633 3.5-8.448 8-8.945V1h2v3.055ZM12 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiUserFacesRobotLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 4.055c4.5.497 8 4.312 8 8.945v9H3v-9c0-4.633 3.5-8.448 8-8.945V1h2v3.055ZM19 20v-7a7 7 0 1 0-14 0v7h14Zm-7-2a5 5 0 1 1 0-10 5 5 0 0 1 0 10Zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"/>'
      }, props)
  }
  export function RiUserFacesSkull2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10v3.764a2 2 0 0 1-1.106 1.789L18 19v1a3 3 0 0 1-2.824 2.995L14.95 23c.022-.107.037-.218.044-.33L15 22.5V22a2 2 0 0 0-1.85-1.994L13 20h-2a2 2 0 0 0-1.995 1.85L9 22v.5c0 .171.017.339.05.5H9a3 3 0 0 1-3-3v-1l-2.894-1.447A2 2 0 0 1 2 15.763V12C2 6.477 6.477 2 12 2Zm-4 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>'
      }, props)
  }
  export function RiUserFacesSkull2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10v3.764a2 2 0 0 1-1.106 1.789L18 19v1a3 3 0 0 1-2.824 2.995L14.95 23c.022-.107.037-.218.044-.33L15 22.5V22a2 2 0 0 0-1.85-1.994L13 20h-2a2 2 0 0 0-1.995 1.85L9 22v.5c0 .171.017.339.05.5H9a3 3 0 0 1-3-3v-1l-2.894-1.447A2 2 0 0 1 2 15.763V12C2 6.477 6.477 2 12 2Zm0 2a8 8 0 0 0-7.996 7.75L4 12v3.764l4 2v1.591l.075-.084a3.993 3.993 0 0 1 2.723-1.266L11 18l2.073.001.223.01c.999.074 1.89.51 2.55 1.177l.154.167v-1.591l4-2V12a8 8 0 0 0-8-8Zm-4 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"/>'
      }, props)
  }
  export function RiUserFacesSkullFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18 18v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3H3a1 1 0 0 1-1-1v-5C2 6.477 6.477 2 12 2s10 4.477 10 10v5a1 1 0 0 1-1 1h-3ZM7.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesSkullLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 12a8 8 0 1 0-16 0v4h3a1 1 0 0 1 1 1v3h8v-3a1 1 0 0 1 1-1h3v-4Zm-2 6v3a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3H3a1 1 0 0 1-1-1v-5C2 6.477 6.477 2 12 2s10 4.477 10 10v5a1 1 0 0 1-1 1h-3ZM7.5 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesSpyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 13a4 4 0 0 1 0 8c-2.142 0-4-1.79-4-4h-2a4 4 0 1 1-.535-2h3.07A3.998 3.998 0 0 1 17 13ZM2 12v-2h2V7a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v3h2v2H2Z"/>'
      }, props)
  }
  export function RiUserFacesSpyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 13a4 4 0 1 1-4 4h-2a4 4 0 1 1-.535-2h3.07A3.998 3.998 0 0 1 17 13ZM7 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM16 3a4 4 0 0 1 4 4v3h2v2H2v-2h2V7a4 4 0 0 1 4-4h8Zm0 2H8c-1.054 0-2 .95-2 2v3h12V7c0-1.054-.95-2-2-2Z"/>'
      }, props)
  }
  export function RiUserFacesStarSmileFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.999.5 4.226 6.183 7.186 2.109-4.575 5.93.216 7.486-7.053-2.518-7.054 2.518.216-7.486-4.575-5.93 7.187-2.109L11.999.5Zm-2 11.5h-2a4 4 0 0 0 7.995.2l.005-.2h-2a2 2 0 0 1-3.995.15L10 12Z"/>'
      }, props)
  }
  export function RiUserFacesStarSmileLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m11.999.5 4.226 6.183 7.186 2.109-4.575 5.93.216 7.486-7.053-2.518-7.054 2.518.216-7.486-4.575-5.93 7.187-2.109L11.999.5Zm0 3.544L9.02 8.402 3.956 9.887l3.225 4.178-.153 5.275 4.97-1.774 4.97 1.774-.151-5.274 3.224-4.179-5.065-1.485L12 4.044Zm-2 7.956a2 2 0 1 0 4 0h2a4 4 0 1 1-8 0h2Z"/>'
      }, props)
  }
  export function RiUserFacesTeamFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-6.5 3a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM21 10.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm-9 .5a5 5 0 0 1 5 5v6H7v-6a5 5 0 0 1 5-5Zm-7 5c0-.693.1-1.362.288-1.994l-.17.014A3.5 3.5 0 0 0 2 17.5V22h3v-6Zm17 6v-4.5a3.5 3.5 0 0 0-3.288-3.494c.187.632.288 1.301.288 1.994v6h3Z"/>'
      }, props)
  }
  export function RiUserFacesTeamLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 11a5 5 0 0 1 5 5v6h-2v-6a3 3 0 0 0-2.824-2.995L12 13a3 3 0 0 0-2.995 2.824L9 16v6H7v-6a5 5 0 0 1 5-5Zm-6.5 3c.279 0 .55.033.81.094a5.948 5.948 0 0 0-.301 1.575L6 16v.086a1.493 1.493 0 0 0-.356-.08L5.5 16a1.5 1.5 0 0 0-1.493 1.355L4 17.5V22H2v-4.5A3.5 3.5 0 0 1 5.5 14Zm13 0a3.5 3.5 0 0 1 3.5 3.5V22h-2v-4.5a1.5 1.5 0 0 0-1.355-1.493L18.5 16c-.175 0-.343.03-.5.085V16c0-.666-.108-1.306-.308-1.904.258-.063.53-.096.808-.096Zm-13-6a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm13 0a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm-13 2a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm13 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM12 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>'
      }, props)
  }
  export function RiUserFacesTravestiFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.538 9.95 4.663 7.076 2.188 9.55.773 8.136l6.364-6.364 1.415 1.414-2.475 2.475 2.875 2.876A7.5 7.5 0 1 1 7.538 9.95Z"/>'
      }, props)
  }
  export function RiUserFacesTravestiLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.952 8.537A7.5 7.5 0 1 1 7.538 9.95L4.663 7.075 2.188 9.55.773 8.136l6.364-6.364 1.415 1.414-2.475 2.475 2.875 2.876ZM13.502 20a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"/>'
      }, props)
  }
  export function RiUserFacesUser2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 14.062V20h2v-5.938c3.946.492 7 3.858 7 7.938H4a8.001 8.001 0 0 1 7-7.938ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Z"/>'
      }, props)
  }
  export function RiUserFacesUser2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 22a8 8 0 1 1 16 0H4Zm9-5.917V20h4.659A6.008 6.008 0 0 0 13 16.083ZM11 20v-3.917A6.008 6.008 0 0 0 6.341 20H11Zm1-7c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Z"/>'
      }, props)
  }
  export function RiUserFacesUser3Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22H4v-2a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v2Zm-8-9a6 6 0 1 1 0-12 6 6 0 0 1 0 12Z"/>'
      }, props)
  }
  export function RiUserFacesUser3Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M20 22h-2v-2a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v2H4v-2a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v2Zm-8-9a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/>'
      }, props)
  }
  export function RiUserFacesUser4Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 20h14v2H5v-2Zm7-2a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z"/>'
      }, props)
  }
  export function RiUserFacesUser4Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 20h14v2H5v-2Zm7-2a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm0-2a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"/>'
      }, props)
  }
  export function RiUserFacesUser5Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.39 16.539a8 8 0 1 1 9.221 0l2.083 4.76a.5.5 0 0 1-.459.701H5.765a.5.5 0 0 1-.459-.7l2.083-4.761Zm.729-5.569a4.002 4.002 0 0 0 7.763 0l-1.941-.485a2 2 0 0 1-3.882 0l-1.94.485Z"/>'
      }, props)
  }
  export function RiUserFacesUser5Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.39 16.539a8 8 0 1 1 9.221 0l2.083 4.76a.5.5 0 0 1-.459.701H5.765a.5.5 0 0 1-.459-.7l2.083-4.761Zm6.735-.693 1.332-.941a6 6 0 1 0-6.913 0l1.331.941L8.058 20h7.884l-1.817-4.154ZM8.119 10.97l1.94-.485a2 2 0 0 0 3.882 0l1.94.485a4.002 4.002 0 0 1-7.762 0Z"/>'
      }, props)
  }
  export function RiUserFacesUser6Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 17c3.663 0 6.866 1.575 8.608 3.925l-1.842.871C17.348 20.116 14.848 19 12.001 19c-2.848 0-5.347 1.116-6.765 2.796l-1.841-.872C5.137 18.574 8.339 17 12 17Zm0-15a5 5 0 0 1 5 5v3a5 5 0 0 1-10 0V7a5 5 0 0 1 5-5Z"/>'
      }, props)
  }
  export function RiUserFacesUser6Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 17c3.663 0 6.866 1.575 8.608 3.925l-1.842.871C17.348 20.116 14.848 19 12.001 19c-2.848 0-5.347 1.116-6.765 2.796l-1.841-.872C5.137 18.574 8.339 17 12 17Zm0-15a5 5 0 0 1 5 5v3a5 5 0 0 1-4.782 4.995L12 15a5 5 0 0 1-5-5V7a5 5 0 0 1 4.783-4.995L12.001 2Zm0 2a3 3 0 0 0-2.994 2.824L9.001 7v3a3 3 0 0 0 5.995.176L15 10V7a3 3 0 0 0-3-3Z"/>'
      }, props)
  }
  export function RiUserFacesUserAddFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm6 4v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3Z"/>'
      }, props)
  }
  export function RiUserFacesUserAddLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm6 6v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3Z"/>'
      }, props)
  }
  export function RiUserFacesUserFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 22a8 8 0 1 1 16 0H4Zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Z"/>'
      }, props)
  }
  export function RiUserFacesUserFollowFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 14.062V22H4a8 8 0 0 1 9-7.938ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm5.793 6.914 3.535-3.535 1.415 1.414-4.95 4.95-3.536-3.536 1.415-1.414 2.12 2.121Z"/>'
      }, props)
  }
  export function RiUserFacesUserFollowLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm5.793 8.914 3.535-3.535 1.415 1.414-4.95 4.95-3.536-3.536 1.415-1.414 2.12 2.121Z"/>'
      }, props)
  }
  export function RiUserFacesUserHeartFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.841 15.659.176.177.178-.177a2.25 2.25 0 1 1 3.181 3.182L18.018 22.2l-3.359-3.359a2.25 2.25 0 1 1 3.182-3.182ZM12 14v8H4a8 8 0 0 1 7.75-7.996L12 14Zm0-13c3.315 0 6 2.685 6 6s-2.685 6-6 6-6-2.685-6-6 2.685-6 6-6Z"/>'
      }, props)
  }
  export function RiUserFacesUserHeartLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.841 15.659.176.177.178-.177a2.25 2.25 0 1 1 3.181 3.182L18.018 22.2l-3.359-3.359a2.25 2.25 0 1 1 3.182-3.182ZM12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 7.75-7.996L12 14Zm0-13c3.315 0 6 2.685 6 6a5.998 5.998 0 0 1-5.775 5.996L12 13c-3.315 0-6-2.685-6-6a5.998 5.998 0 0 1 5.775-5.996L12 1Zm0 2C9.79 3 8 4.79 8 7s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Z"/>'
      }, props)
  }
  export function RiUserFacesUserLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 22a8 8 0 1 1 16 0h-2a6 6 0 0 0-12 0H4Zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Z"/>'
      }, props)
  }
  export function RiUserFacesUserLocationFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 14v8H4a8 8 0 0 1 8-8Zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm8.828 7.828L18 23.657l-2.828-2.829a4 4 0 1 1 5.656 0ZM18 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiUserFacesUserLocationLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8Zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm8.828 10.071L18 24l-2.828-2.929c-1.563-1.618-1.563-4.24 0-5.858a3.904 3.904 0 0 1 5.656 0c1.563 1.618 1.563 4.24 0 5.858Zm-1.438-1.39c.813-.842.813-2.236 0-3.079a1.904 1.904 0 0 0-2.78 0c-.813.843-.813 2.237 0 3.08L18 21.12l1.39-1.44Z"/>'
      }, props)
  }
  export function RiUserFacesUserReceived2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm8 4h3v2h-3v3.5L15 18l5-4.5V17Z"/>'
      }, props)
  }
  export function RiUserFacesUserReceived2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm8 6h3v2h-3v3.5L15 18l5-4.5V17Z"/>'
      }, props)
  }
  export function RiUserFacesUserReceivedFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm7.418 4h3.586v2h-3.586l1.829 1.828-1.414 1.415L15.59 18l4.243-4.243 1.414 1.415L19.418 17Z"/>'
      }, props)
  }
  export function RiUserFacesUserReceivedLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm7.418 6h3.586v2h-3.586l1.829 1.828-1.414 1.415L15.59 18l4.243-4.243 1.414 1.415L19.418 17Z"/>'
      }, props)
  }
  export function RiUserFacesUserSearchFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 14v8H4a8 8 0 0 1 8-8Zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm9.446 7.032 1.504 1.503-1.415 1.415-1.503-1.504a4 4 0 1 1 1.414-1.414ZM18 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiUserFacesUserSearchLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8Zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm9.446 9.032 1.504 1.503-1.415 1.415-1.503-1.504a4 4 0 1 1 1.414-1.414ZM18 20a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiUserFacesUserSettingsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 14v8H4a8 8 0 0 1 8-8Zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm2.595 5.811a3.505 3.505 0 0 1 0-1.622l-.992-.573 1-1.732.992.573A3.498 3.498 0 0 1 17 14.645V13.5h2v1.145c.532.158 1.012.44 1.405.812l.992-.573 1 1.732-.991.573a3.512 3.512 0 0 1 0 1.622l.991.573-1 1.732-.992-.573a3.495 3.495 0 0 1-1.405.812V22.5h-2v-1.145a3.495 3.495 0 0 1-1.405-.812l-.992.573-1-1.732.992-.573ZM18 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>'
      }, props)
  }
  export function RiUserFacesUserSettingsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8Zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm2.595 7.811a3.505 3.505 0 0 1 0-1.622l-.992-.573 1-1.732.992.573A3.498 3.498 0 0 1 17 14.645V13.5h2v1.145c.532.158 1.012.44 1.405.812l.992-.573 1 1.732-.991.573a3.512 3.512 0 0 1 0 1.622l.991.573-1 1.732-.992-.573a3.495 3.495 0 0 1-1.405.812V22.5h-2v-1.145a3.495 3.495 0 0 1-1.405-.812l-.992.573-1-1.732.992-.573ZM18 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiUserFacesUserShared2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm6 4v-3.5l5 4.5-5 4.5V19h-3v-2h3Z"/>'
      }, props)
  }
  export function RiUserFacesUserShared2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm6 6v-3.5l5 4.5-5 4.5V19h-3v-2h3Z"/>'
      }, props)
  }
  export function RiUserFacesUserSharedFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm6.586 4-1.829-1.828 1.415-1.415L22.414 18l-4.242 4.243-1.415-1.415L18.586 19H15v-2h3.586Z"/>'
      }, props)
  }
  export function RiUserFacesUserSharedLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm6.586 6-1.829-1.828 1.415-1.415L22.414 18l-4.242 4.243-1.415-1.415L18.586 19H15v-2h3.586Z"/>'
      }, props)
  }
  export function RiUserFacesUserSmileFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10ZM7 12a5 5 0 0 0 10 0h-2a3 3 0 1 1-6 0H7Z"/>'
      }, props)
  }
  export function RiUserFacesUserSmileLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm-5-8h2a3 3 0 1 0 6 0h2a5 5 0 0 1-10 0Z"/>'
      }, props)
  }
  export function RiUserFacesUserStarFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 14v8H4a8 8 0 0 1 8-8Zm6 7.5-2.939 1.545.561-3.273-2.377-2.317 3.286-.477L18 14l1.47 2.977 3.285.478-2.377 2.318.56 3.272L18 21.5ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Z"/>'
      }, props)
  }
  export function RiUserFacesUserStarLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8Zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm6 10.5-2.939 1.545.561-3.273-2.377-2.317 3.286-.477L18 14l1.47 2.977 3.285.478-2.377 2.318.56 3.272L18 21.5Z"/>'
      }, props)
  }
  export function RiUserFacesUserUnfollowFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252V22H4a8 8 0 0 1 10-7.748ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm7 3.586 2.121-2.121 1.415 1.414L20.413 18l2.121 2.121-1.414 1.415L19 19.413l-2.121 2.121-1.415-1.414L17.587 18l-2.121-2.121 1.414-1.415L19 16.587Z"/>'
      }, props)
  }
  export function RiUserFacesUserUnfollowLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22H4a8 8 0 0 1 10-7.749ZM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm7 6.586 2.121-2.121 1.415 1.414L20.413 19l2.121 2.121-1.414 1.415L19 20.413l-2.121 2.121-1.415-1.414L17.587 19l-2.121-2.121 1.414-1.415L19 17.587Z"/>'
      }, props)
  }
  export function RiUserFacesUserVoiceFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1 22a8 8 0 0 1 16 0H1Zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm9.246-9.815A9.97 9.97 0 0 1 19 7a9.97 9.97 0 0 1-.754 3.816l-1.677-1.22A7.99 7.99 0 0 0 17 7a7.99 7.99 0 0 0-.43-2.596l1.676-1.22ZM21.548.784A13.942 13.942 0 0 1 23 7c0 2.233-.523 4.344-1.452 6.217l-1.645-1.197A11.956 11.956 0 0 0 21 7c0-1.792-.393-3.493-1.097-5.02L21.548.784Z"/>'
      }, props)
  }
  export function RiUserFacesUserVoiceLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1 22a8 8 0 0 1 16 0h-2a6 6 0 0 0-12 0H1Zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4ZM21.548.784A13.942 13.942 0 0 1 23 7c0 2.233-.523 4.344-1.452 6.217l-1.645-1.197A11.956 11.956 0 0 0 21 7c0-1.792-.393-3.493-1.097-5.02L21.548.784Zm-3.302 2.4A9.97 9.97 0 0 1 19 7a9.97 9.97 0 0 1-.754 3.816l-1.677-1.22A7.99 7.99 0 0 0 17 7a7.99 7.99 0 0 0-.43-2.596l1.676-1.22Z"/>'
      }, props)
  }
  export function RiUserFacesWomenFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 15.934A7.501 7.501 0 0 1 12 1a7.5 7.5 0 0 1 1 14.934V18h5v2h-5v4h-2v-4H6v-2h5v-2.066Z"/>'
      }, props)
  }
  export function RiUserFacesWomenLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 15.934A7.501 7.501 0 0 1 12 1a7.5 7.5 0 0 1 1 14.934V18h5v2h-5v4h-2v-4H6v-2h5v-2.066ZM12 14a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"/>'
      }, props)
  }
  export function RiWeatherBlazeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.5 9c1 1.06 1.5 2.394 1.5 4 0 3.466-3.7 4.276-5.5 9-.667-.575-1-1.408-1-2.5 0-3.482 5-5.29 5-10.5Zm-4-4c1.2 1.238 1.8 2.572 1.8 4 0 4.951-6.045 5.692-4.8 13C9.833 20.84 9 19.173 9 17c0-3.325 5.5-6 5.5-12ZM10 1c1.333 1.667 2 3.167 2 4.5 0 6.25-8.5 8.222-4 16.5-2.616-.58-4.5-3-4.5-6C3.5 9.5 10 8.5 10 1Z"/>'
      }, props)
  }
  export function RiWeatherBlazeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M19 9c.667 1.06 1 2.394 1 4 0 3-3.5 4-5 9-.667-.575-1-1.408-1-2.5 0-3.482 5-5.29 5-10.5Zm-4.5-4a8.309 8.309 0 0 1 1 4c0 5-6 6-4 13C9.833 20.84 9 19.173 9 17c0-3.325 5.5-6 5.5-12ZM10 1c.667 1.333 1 2.833 1 4.5 0 6-9 7.5-3 16.5-2.5-.5-4.5-3-4.5-6C3.5 9.5 10 8.5 10 1Z"/>'
      }, props)
  }
  export function RiWeatherCelsiusFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.5 10a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM22 10h-2a4 4 0 0 0-8 0v5a4 4 0 0 0 8 0h2a6 6 0 0 1-12 0v-5a6 6 0 0 1 12 0Z"/>'
      }, props)
  }
  export function RiWeatherCelsiusLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4.5 10a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM22 10h-2a4 4 0 0 0-8 0v5a4 4 0 0 0 8 0h2a6 6 0 0 1-12 0v-5a6 6 0 0 1 12 0Z"/>'
      }, props)
  }
  export function RiWeatherCloudWindyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 19v-3.993H2.074a8 8 0 1 1 14.383-6.908A5.5 5.5 0 1 1 17.5 19h-3.499Zm-8 2h10v2H6v-2Zm-4-4h10v2H2v-2Z"/>'
      }, props)
  }
  export function RiWeatherCloudWindyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 18v-2h3.5a3.5 3.5 0 1 0-2.5-5.95V10a6 6 0 0 0-12 0v.007H1V10a8 8 0 0 1 15.458-2.901A5.5 5.5 0 1 1 17.5 18H14Zm-8 2h10v2H6v-2Zm0-8h8v2H6v-2Zm-4 4h10v2H2v-2Z"/>'
      }, props)
  }
  export function RiWeatherCloudy2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 21H7A6 6 0 0 1 5.008 9.339a7 7 0 1 1 13.984 0A6 6 0 0 1 17 21Z"/>'
      }, props)
  }
  export function RiWeatherCloudy2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 21H7A6 6 0 0 1 5.008 9.339a7 7 0 1 1 13.984 0A6 6 0 0 1 17 21ZM7 19h10a4 4 0 1 0-.426-7.978 5 5 0 1 0-9.148 0A4 4 0 1 0 7 19Z"/>'
      }, props)
  }
  export function RiWeatherCloudyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9 20.985a8.5 8.5 0 1 1 7.715-12.982A6.5 6.5 0 0 1 17 20.981V21H9v-.015Z"/>'
      }, props)
  }
  export function RiWeatherCloudyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.5 6a6.5 6.5 0 0 0 0 13h7a4.5 4.5 0 1 0-.957-8.898A6.502 6.502 0 0 0 9.5 6Zm7 15h-7a8.5 8.5 0 1 1 7.215-12.997A6.5 6.5 0 0 1 16.5 21Z"/>'
      }, props)
  }
  export function RiWeatherDrizzleFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11 18v3H9v-3a8 8 0 1 1 7.458-10.901A5.5 5.5 0 1 1 17.5 18H11Zm2 2h2v3h-2v-3Z"/>'
      }, props)
  }
  export function RiWeatherDrizzleLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 18v-2h.5a3.5 3.5 0 1 0-2.5-5.95V10a6 6 0 1 0-8 5.659v2.089a8 8 0 1 1 9.458-10.65A5.5 5.5 0 1 1 17.5 18H17Zm-8-2h2v4H9v-4Zm4 3h2v4h-2v-4Z"/>'
      }, props)
  }
  export function RiWeatherEarthquakeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.327 1.612a1 1 0 0 1 1.246-.08l.1.08L23 11h-3v9a1 1 0 0 1-.883.993L19 21h-6.5l2.5-4-3.5-3 4-3L13 9l.5-3-3 3 2.5 2-5 3 3.75 3.5L8.5 21H5a1 1 0 0 1-.993-.883L4 20v-9H1l10.327-9.388Z"/>'
      }, props)
  }
  export function RiWeatherEarthquakeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 21a1 1 0 0 1-.993-.883L4 20v-9H1l10.327-9.388a1 1 0 0 1 1.246-.08l.1.08L23 11h-3v9a1 1 0 0 1-.883.993L19 21H5Zm7-17.298L6 9.156V19h4.357l1.393-1.5L8 14l5-3-2.5-2 3-3-.5 3 2.5 2-4 3 3.5 3-1.25 2H18V9.157l-6-5.455Z"/>'
      }, props)
  }
  export function RiWeatherFahrenheitFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 12h7v2h-7v7h-2V8a4 4 0 0 1 4-4h7v2h-7a2 2 0 0 0-2 2v4Zm-7.5-2a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiWeatherFahrenheitLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 12h7v2h-7v7h-2V8a4 4 0 0 1 4-4h7v2h-7a2 2 0 0 0-2 2v4Zm-7.5-2a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>'
      }, props)
  }
  export function RiWeatherFireFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 23a7.5 7.5 0 0 1-5.138-12.963C8.204 8.774 11.5 6.5 11 1.5c6 4 9 8 3 14 1 0 2.5 0 5-2.47.27.773.5 1.604.5 2.47A7.5 7.5 0 0 1 12 23Z"/>'
      }, props)
  }
  export function RiWeatherFireLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 23a7.5 7.5 0 0 0 7.5-7.5c0-.866-.23-1.697-.5-2.47-1.667 1.647-2.933 2.47-3.8 2.47 3.995-7 1.8-10-4.2-14 .5 5-2.796 7.274-4.138 8.537A7.5 7.5 0 0 0 12 23Zm.71-17.765c3.241 2.75 3.257 4.887.753 9.274-.761 1.333.202 2.991 1.737 2.991.688 0 1.384-.2 2.119-.595a5.5 5.5 0 1 1-9.087-5.412c.126-.118.765-.685.793-.71.424-.38.773-.717 1.118-1.086 1.23-1.318 2.114-2.78 2.566-4.462Z"/>'
      }, props)
  }
  export function RiWeatherFlashlightFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 10h7l-9 13v-9H4l9-13v9Z"/>'
      }, props)
  }
  export function RiWeatherFlashlightLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 9h8L11 24v-9H4l9-15v9Zm-2 2V7.22L7.532 13H13v4.394L17.263 11H11Z"/>'
      }, props)
  }
  export function RiWeatherFloodFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 17.472A5.978 5.978 0 0 0 20 19h2v2h-2a7.964 7.964 0 0 1-4-1.07A7.96 7.96 0 0 1 12 21a7.964 7.964 0 0 1-4-1.07A7.96 7.96 0 0 1 4 21H2v-2h2c1.537 0 2.94-.578 4-1.528A5.978 5.978 0 0 0 12 19c1.537 0 2.94-.578 4-1.528Zm-3.427-15.94.1.08L23 11h-3v6a4.992 4.992 0 0 1-4-2 4.991 4.991 0 0 1-4 2 4.993 4.993 0 0 1-4-2 4.991 4.991 0 0 1-4 2l-.001-6H1l10.327-9.388a1 1 0 0 1 1.14-.145l.106.065Z"/>'
      }, props)
  }
  export function RiWeatherFloodLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 17.472A5.978 5.978 0 0 0 20 19h2v2h-2a7.964 7.964 0 0 1-4-1.07A7.96 7.96 0 0 1 12 21a7.964 7.964 0 0 1-4-1.07A7.96 7.96 0 0 1 4 21H2v-2h2c1.537 0 2.94-.578 4-1.528A5.978 5.978 0 0 0 12 19c1.537 0 2.94-.578 4-1.528Zm-3.427-15.94.1.08L23 11h-3v6c-.701 0-1.374-.12-2-.341V9.157l-6-5.455-6 5.454.001 7.502a5.98 5.98 0 0 1-1.702.335L4 17v-6H1l10.327-9.388a1 1 0 0 1 1.246-.08Z"/>'
      }, props)
  }
  export function RiWeatherFoggyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1.584 13.007a8 8 0 1 1 14.873-5.908 5.5 5.5 0 0 1 6.52 5.908H1.584ZM4 19h17v2H4v-2Zm-2-4h21v2H2v-2Z"/>'
      }, props)
  }
  export function RiWeatherFoggyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1.584 13.007a8 8 0 1 1 14.873-5.908 5.5 5.5 0 0 1 6.52 5.908h-2.013A3.5 3.5 0 0 0 15 10.05V10a6 6 0 1 0-11.193 3.007H1.584ZM4 19h17v2H4v-2Zm-2-4h21v2H2v-2Z"/>'
      }, props)
  }
  export function RiWeatherHailFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M18.995 17.794a4 4 0 0 0-5.085-3.644A4.001 4.001 0 0 0 6 15c0 1.08.428 2.059 1.122 2.778a8 8 0 1 1 9.335-10.68 5.5 5.5 0 0 1 2.537 10.696ZM10 17a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm5 3a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-5 3a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiWeatherHailLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6 17.419A8.003 8.003 0 0 1 9 2a8.003 8.003 0 0 1 7.458 5.099A5.5 5.5 0 0 1 19 17.793v-2.13a3.5 3.5 0 1 0-4-5.612V10a6 6 0 1 0-9 5.197v2.222ZM10 17a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm5 3a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm-5 3a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"/>'
      }, props)
  }
  export function RiWeatherHaze2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 19a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm7.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-15 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM17 7a5 5 0 0 1 0 10c-1.844 0-3.51-1.04-5-3.121C10.51 15.959 8.844 17 7 17A5 5 0 0 1 7 7c1.844 0 3.51 1.04 5 3.121C13.49 8.041 15.156 7 17 7Zm-5-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM4.5 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm15 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>'
      }, props)
  }
  export function RiWeatherHaze2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 19a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm7.5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-15 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM17 7a5 5 0 0 1 0 10c-1.844 0-3.51-1.04-5-3.121C10.51 15.959 8.844 17 7 17A5 5 0 0 1 7 7c1.844 0 3.51 1.04 5 3.121C13.49 8.041 15.156 7 17 7ZM7 9a3 3 0 1 0 0 6c1.254 0 2.51-.875 3.759-2.854l.089-.147-.09-.145c-1.197-1.896-2.4-2.78-3.601-2.85L7 9Zm10 0c-1.254 0-2.51.875-3.759 2.854l-.09.146.09.146c1.198 1.896 2.4 2.78 3.602 2.85L17 15a3 3 0 1 0 0-6Zm-5-7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM4.5 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm15 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>'
      }, props)
  }
  export function RiWeatherHazeFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.083 13a6 6 0 1 1 11.834 0H6.083ZM2 15h10v2H2v-2Zm12 0h8v2h-8v-2Zm2 4h4v2h-4v-2ZM4 19h10v2H4v-2Zm7-18h2v3h-2V1ZM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93ZM19.07 3.515l1.414 1.414-2.121 2.121-1.414-1.414 2.121-2.121ZM23 11v2h-3v-2h3ZM4 11v2H1v-2h3Z"/>'
      }, props)
  }
  export function RiWeatherHazeLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.083 13a6 6 0 1 1 11.834 0h-2.043a4 4 0 1 0-7.748 0H6.083ZM2 15h10v2H2v-2Zm12 0h8v2h-8v-2Zm2 4h4v2h-4v-2ZM4 19h10v2H4v-2Zm7-18h2v3h-2V1ZM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93ZM19.07 3.515l1.414 1.414-2.121 2.121-1.414-1.414 2.121-2.121ZM23 11v2h-3v-2h3ZM4 11v2H1v-2h3Z"/>'
      }, props)
  }
  export function RiWeatherHeavyShowersFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M13 18v5h-2v-5H9v3H7v-3.252a8 8 0 1 1 9.458-10.65A5.5 5.5 0 1 1 17.5 18H17v3.001h-2v-3h-2Z"/>'
      }, props)
  }
  export function RiWeatherHeavyShowersLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 16.93a8 8 0 1 1 11.458-9.831A5.5 5.5 0 0 1 19 17.793v-2.13a3.5 3.5 0 1 0-4-5.612V10a6 6 0 1 0-10 4.472v2.458ZM7 14h2v6H7v-6Zm8 0h2v6h-2v-6Zm-4 3h2v6h-2v-6Z"/>'
      }, props)
  }
  export function RiWeatherMeteorFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 1v12A9 9 0 1 1 7.375 5.278L14 1.453v2.77L21 1Zm-9 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z"/>'
      }, props)
  }
  export function RiWeatherMeteorLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M21 1v12A9 9 0 1 1 7.375 5.278L14 1.453v2.77L21 1Zm-2 3.122-7 3.224v-2.43L8.597 6.881a6.997 6.997 0 0 0-3.592 5.845L5 13a7 7 0 0 0 13.996.24L19 13V4.122ZM12 8a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"/>'
      }, props)
  }
  export function RiWeatherMistFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 4h4v2H4V4Zm12 15h4v2h-4v-2ZM2 9h10v2H2V9Zm12 0h6v2h-6V9ZM4 14h6v2H4v-2Zm8 0h10v2H12v-2ZM10 4h12v2H10V4ZM2 19h12v2H2v-2Z"/>'
      }, props)
  }
  export function RiWeatherMistLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M4 4h4v2H4V4Zm12 15h4v2h-4v-2ZM2 9h5v2H2V9Zm7 0h3v2H9V9Zm5 0h6v2h-6V9ZM4 14h6v2H4v-2Zm8 0h3v2h-3v-2Zm5 0h5v2h-5v-2ZM10 4h12v2H10V4ZM2 19h12v2H2v-2Z"/>'
      }, props)
  }
  export function RiWeatherMoonClearFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.822 2.238a9 9 0 0 0 11.94 11.94C20.768 18.654 16.775 22 12 22 6.477 22 2 17.523 2 12c0-4.775 3.346-8.768 7.822-9.762Zm8.342.053L19 2.5v1l-.836.209a2 2 0 0 0-1.455 1.455L16.5 6h-1l-.209-.836a2 2 0 0 0-1.455-1.455L13 3.5v-1l.836-.209A2 2 0 0 0 15.29.836L15.5 0h1l.209.836a2 2 0 0 0 1.455 1.455Zm5 5L24 7.5v1l-.836.209a2 2 0 0 0-1.455 1.455L21.5 11h-1l-.209-.836a2 2 0 0 0-1.455-1.455L18 8.5v-1l.836-.209a2 2 0 0 0 1.455-1.455L20.5 5h1l.209.836a2 2 0 0 0 1.455 1.455Z"/>'
      }, props)
  }
  export function RiWeatherMoonClearLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 6a8 8 0 0 0 11.955 6.956C21.474 18.03 17.2 22 12 22 6.477 22 2 17.523 2 12c0-5.2 3.97-9.474 9.044-9.955A7.963 7.963 0 0 0 10 6Zm-6 6a8 8 0 0 0 8 8 8.006 8.006 0 0 0 6.957-4.045c-.316.03-.636.045-.957.045-5.523 0-10-4.477-10-10 0-.321.015-.64.045-.957A8.006 8.006 0 0 0 4 12Zm14.164-9.709L19 2.5v1l-.836.209a2 2 0 0 0-1.455 1.455L16.5 6h-1l-.209-.836a2 2 0 0 0-1.455-1.455L13 3.5v-1l.836-.209A2 2 0 0 0 15.29.836L15.5 0h1l.209.836a2 2 0 0 0 1.455 1.455Zm5 5L24 7.5v1l-.836.209a2 2 0 0 0-1.455 1.455L21.5 11h-1l-.209-.836a2 2 0 0 0-1.455-1.455L18 8.5v-1l.836-.209a2 2 0 0 0 1.455-1.455L20.5 5h1l.209.836a2 2 0 0 0 1.455 1.455Z"/>'
      }, props)
  }
  export function RiWeatherMoonCloudyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.67 5.007a7 7 0 0 1 7.55-3.901 4.5 4.5 0 0 0 5.674 5.674 7.038 7.038 0 0 1-.759 4.593A5.5 5.5 0 0 1 17.5 21H9a8 8 0 0 1-.33-15.993Zm2.177.207a8.016 8.016 0 0 1 5.61 4.885 5.533 5.533 0 0 1 2.96.245 4.97 4.97 0 0 0 .488-1.37 6.502 6.502 0 0 1-5.878-5.88 5.003 5.003 0 0 0-3.18 2.12Z"/>'
      }, props)
  }
  export function RiWeatherMoonCloudyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8.67 5.007a7 7 0 0 1 7.55-3.901 4.5 4.5 0 0 0 5.674 5.674 7.038 7.038 0 0 1-.759 4.593A5.5 5.5 0 0 1 17.5 21H9a8 8 0 0 1-.33-15.993Zm2.177.207a8.016 8.016 0 0 1 5.61 4.885 5.533 5.533 0 0 1 2.96.245 4.97 4.97 0 0 0 .488-1.37 6.502 6.502 0 0 1-5.878-5.88 5.003 5.003 0 0 0-3.18 2.12ZM17.5 19a3.5 3.5 0 1 0-2.5-5.95V13a6 6 0 1 0-6 6h8.5Z"/>'
      }, props)
  }
  export function RiWeatherMoonFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M11.38 2.019a7.5 7.5 0 1 0 10.6 10.6C21.662 17.855 17.316 22 12.001 22 6.477 22 2 17.523 2 12 2 6.685 6.146 2.34 11.38 2.02Z"/>'
      }, props)
  }
  export function RiWeatherMoonFoggyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 20.334V18h-2v-4H3.332A9.512 9.512 0 0 1 3 11.5c0-4.56 3.213-8.37 7.5-9.29a8 8 0 0 0 11.49 9.724 9.505 9.505 0 0 1-5.99 8.4ZM7 20h7v2H7v-2Zm-5-4h10v2H2v-2Z"/>'
      }, props)
  }
  export function RiWeatherMoonFoggyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 20.335v-2.2a7.523 7.523 0 0 0 3.623-4.281 9 9 0 0 1-10.622-8.99A7.518 7.518 0 0 0 5.151 10H3.117a9.505 9.505 0 0 1 8.538-7.963 7 7 0 0 0 10.316 8.728A9.503 9.503 0 0 1 16 20.335ZM7 20h7v2H7v-2Zm-3-8h6v2H4v-2Zm-2 4h10v2H2v-2Z"/>'
      }, props)
  }
  export function RiWeatherMoonLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10 7a7 7 0 0 0 12 4.9v.1c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2h.1A6.98 6.98 0 0 0 10 7Zm-6 5a8 8 0 0 0 15.062 3.762A9 9 0 0 1 8.238 4.938 7.999 7.999 0 0 0 4 12Z"/>'
      }, props)
  }
  export function RiWeatherRainbowFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 4c6.075 0 11 4.925 11 11v5h-3v-5a8 8 0 0 0-7.75-7.996L12 7a8 8 0 0 0-7.996 7.75L4 15v5H1v-5C1 8.925 5.925 4 12 4Zm0 4a7 7 0 0 1 7 7v5h-3v-5a4 4 0 0 0-3.8-3.995L12 11a4 4 0 0 0-3.995 3.8L8 15v5H5v-5a7 7 0 0 1 7-7Zm0 4a3 3 0 0 1 3 3v5H9v-5a3 3 0 0 1 3-3Z"/>'
      }, props)
  }
  export function RiWeatherRainbowLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 4c6.075 0 11 4.925 11 11v5h-2v-5a9 9 0 0 0-8.735-8.996L12 6a9 9 0 0 0-8.996 8.735L3 15v5H1v-5C1 8.925 5.925 4 12 4Zm0 4a7 7 0 0 1 7 7v5h-2v-5a5 5 0 0 0-4.783-4.995L12 10a5 5 0 0 0-4.995 4.783L7 15v5H5v-5a7 7 0 0 1 7-7Zm0 4a3 3 0 0 1 3 3v5h-2v-5a1 1 0 0 0-.883-.993L12 14a1 1 0 0 0-.993.883L11 15v5H9v-5a3 3 0 0 1 3-3Z"/>'
      }, props)
  }
  export function RiWeatherRainyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m15.86 18-3.153-3.153a1 1 0 0 0-1.414 0L8.18 17.96A8.001 8.001 0 1 1 15.98 6.087 6 6 0 1 1 17 18h-1.139Zm-5.628.732L12 16.965l1.768 1.767a2.5 2.5 0 1 1-3.536 0Z"/>'
      }, props)
  }
  export function RiWeatherRainyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M16 18v-2h1a4 4 0 1 0-2.157-7.37A6 6 0 1 0 8 15.917v2.022A8.001 8.001 0 0 1 9 2a7.998 7.998 0 0 1 6.98 4.087A6 6 0 1 1 17 18h-1Zm-5.768.732L12 16.965l1.768 1.767a2.5 2.5 0 1 1-3.536 0Z"/>'
      }, props)
  }
  export function RiWeatherShining2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 .5 16 8l7.5 4-7.5 4-4 7.5L8 16 .5 12 8 8l4-7.5Z"/>'
      }, props)
  }
  export function RiWeatherShining2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16 8 7.5 4-7.5 4-4 7.5L8 16 .5 12 8 8l4-7.5L16 8Zm3.25 4-4.728-2.522L12 4.75 9.478 9.478 4.75 12l4.728 2.522L12 19.25l2.522-4.728L19.25 12Z"/>'
      }, props)
  }
  export function RiWeatherShiningFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1 11c5.523 0 10-4.477 10-10h2c0 5.523 4.477 10 10 10v2c-5.523 0-10 4.477-10 10h-2c0-5.523-4.477-10-10-10v-2Z"/>'
      }, props)
  }
  export function RiWeatherShiningLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M1 11c5.523 0 10-4.477 10-10h2c0 5.523 4.477 10 10 10v2c-5.523 0-10 4.477-10 10h-2c0-5.523-4.477-10-10-10v-2Zm4.803 1A12.044 12.044 0 0 1 12 18.197 12.043 12.043 0 0 1 18.197 12 12.044 12.044 0 0 1 12 5.803 12.044 12.044 0 0 1 5.803 12Z"/>'
      }, props)
  }
  export function RiWeatherShowersFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M15 18H9v3H7v-3.252a8 8 0 1 1 9.458-10.65A5.5 5.5 0 1 1 17.5 18H17v3.001h-2v-3Zm-4 2h2v3h-2v-3Z"/>'
      }, props)
  }
  export function RiWeatherShowersLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M5 16.93a8 8 0 1 1 11.458-9.831A5.5 5.5 0 0 1 19 17.793v-2.13a3.5 3.5 0 1 0-4-5.612V10a6 6 0 1 0-10 4.472v2.458ZM7 16h2v4H7v-4Zm8 0h2v4h-2v-4Zm-4 3h2v4h-2v-4Z"/>'
      }, props)
  }
  export function RiWeatherSnowyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.027 17.43A8.003 8.003 0 0 1 9 2a8.003 8.003 0 0 1 7.458 5.099A5.5 5.5 0 1 1 18 17.978a6 6 0 0 0-11.973-.549ZM13 16.267l1.964-1.134 1 1.732L14 18l1.964 1.134-1 1.732L13 19.732V22h-2v-2.268l-1.964 1.134-1-1.732L10 18l-1.964-1.134 1-1.732L11 16.268V14h2v2.268Z"/>'
      }, props)
  }
  export function RiWeatherSnowyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m13 16.268 1.964-1.134 1 1.732L14 18l1.964 1.134-1 1.732L13 19.732V22h-2v-2.268l-1.964 1.134-1-1.732L10 18l-1.964-1.134 1-1.732L11 16.268V14h2v2.268ZM17 18v-2h.5a3.5 3.5 0 1 0-2.5-5.95V10a6 6 0 1 0-8 5.659v2.089a8 8 0 1 1 9.458-10.65A5.5 5.5 0 1 1 17.5 18H17Z"/>'
      }, props)
  }
  export function RiWeatherSparkling2Fill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17 1.208 1.32 2.473L20.792 5 18.32 6.319 17.002 8.79 15.68 6.32l-2.472-1.32 2.473-1.318L17 1.208ZM8 4.333l2.667 5 5 2.667-5 2.666-2.666 5-2.667-5-5-2.666 5-2.667 2.667-5Zm11.667 12-1.666-3.125-1.667 3.125L13.209 18l3.125 1.666 1.667 3.125 1.666-3.125L22.792 18l-3.125-1.667Z"/>'
      }, props)
  }
  export function RiWeatherSparkling2Line(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17 1.208 1.32 2.473L20.792 5 18.32 6.319 17.002 8.79 15.68 6.32l-2.472-1.32 2.473-1.318L17 1.208Zm-6.333 8.125 5 2.667-5 2.666-2.666 5-2.667-5-5-2.666 5-2.667 2.667-5 2.666 5Zm.75 2.667L9.19 10.81 8.001 8.583l-1.189 2.228L4.584 12l2.228 1.188 1.189 2.228 1.188-2.228L11.417 12Zm8.25 4.333-1.666-3.125-1.667 3.125L13.209 18l3.125 1.666 1.667 3.125 1.666-3.125L22.792 18l-3.125-1.667Z"/>'
      }, props)
  }
  export function RiWeatherSparklingFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 4.438A2.437 2.437 0 0 0 16.438 2h1.125A2.437 2.437 0 0 0 20 4.438v1.125A2.437 2.437 0 0 0 17.562 8h-1.125A2.437 2.437 0 0 0 14 5.562V4.438ZM1 11a6 6 0 0 0 6-6h2a6 6 0 0 0 6 6v2a6 6 0 0 0-6 6H7a6 6 0 0 0-6-6v-2Zm16.25 3A3.25 3.25 0 0 1 14 17.25v1.5A3.25 3.25 0 0 1 17.25 22h1.5A3.25 3.25 0 0 1 22 18.75v-1.5A3.25 3.25 0 0 1 18.75 14h-1.5Z"/>'
      }, props)
  }
  export function RiWeatherSparklingLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M14 4.438A2.437 2.437 0 0 0 16.438 2h1.125A2.437 2.437 0 0 0 20 4.438v1.125A2.437 2.437 0 0 0 17.562 8h-1.125A2.437 2.437 0 0 0 14 5.562V4.438ZM1 11a6 6 0 0 0 6-6h2a6 6 0 0 0 6 6v2a6 6 0 0 0-6 6H7a6 6 0 0 0-6-6v-2Zm3.876 1A8.038 8.038 0 0 1 8 15.124 8.038 8.038 0 0 1 11.124 12 8.038 8.038 0 0 1 8 8.876 8.038 8.038 0 0 1 4.876 12Zm12.374 2A3.25 3.25 0 0 1 14 17.25v1.5A3.25 3.25 0 0 1 17.25 22h1.5A3.25 3.25 0 0 1 22 18.75v-1.5A3.25 3.25 0 0 1 18.75 14h-1.5Z"/>'
      }, props)
  }
  export function RiWeatherSunCloudyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.984 5.06a6.5 6.5 0 0 1 11.286 6.436A5.5 5.5 0 0 1 17.5 21H9a8 8 0 1 1 .984-15.941Zm2.071.544a8.026 8.026 0 0 1 4.403 4.495 5.533 5.533 0 0 1 3.12.307 4.5 4.5 0 0 0-7.522-4.802Z"/>'
      }, props)
  }
  export function RiWeatherSunCloudyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M9.984 5.06a6.5 6.5 0 0 1 11.286 6.436A5.5 5.5 0 0 1 17.5 21H9a8 8 0 1 1 .984-15.941Zm2.071.544a8.026 8.026 0 0 1 4.403 4.495 5.533 5.533 0 0 1 3.12.307 4.5 4.5 0 0 0-7.522-4.802ZM17.5 19a3.5 3.5 0 1 0-2.5-5.95V13a6 6 0 1 0-6 6h8.5Z"/>'
      }, props)
  }
  export function RiWeatherSunFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12ZM11 1h2v3h-2V1Zm0 19h2v3h-2v-3ZM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93ZM16.95 18.364l1.414-1.414 2.121 2.121-1.414 1.414-2.121-2.121Zm2.121-14.85 1.414 1.415-2.121 2.121-1.414-1.414 2.121-2.121ZM5.636 16.95l1.414 1.414-2.121 2.121-1.414-1.414 2.121-2.121ZM23 11v2h-3v-2h3ZM4 11v2H1v-2h3Z"/>'
      }, props)
  }
  export function RiWeatherSunFoggyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M6.341 14A6 6 0 1 1 12 18v-4H6.341ZM6 20h9v2H6v-2Zm-5-9h3v2H1v-2Zm1 5h8v2H2v-2Zm9-15h2v3h-2V1ZM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93ZM16.95 18.364l1.414-1.414 2.121 2.121-1.414 1.414-2.121-2.121Zm2.121-14.85 1.414 1.415-2.121 2.121-1.414-1.414 2.121-2.121ZM23 11v2h-3v-2h3Z"/>'
      }, props)
  }
  export function RiWeatherSunFoggyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 12h2v2H4v-2h2a6 6 0 1 1 6 6v-2a4 4 0 1 0-4-4Zm-2 8h9v2H6v-2Zm-4-4h8v2H2v-2Zm9-15h2v3h-2V1ZM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93ZM16.95 18.364l1.414-1.414 2.121 2.121-1.414 1.414-2.121-2.121Zm2.121-14.85 1.414 1.415-2.121 2.121-1.414-1.414 2.121-2.121ZM23 11v2h-3v-2h3Z"/>'
      }, props)
  }
  export function RiWeatherSunLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 18a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-2a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM11 1h2v3h-2V1Zm0 19h2v3h-2v-3ZM3.515 4.929l1.414-1.414L7.05 5.636 5.636 7.05 3.515 4.93ZM16.95 18.364l1.414-1.414 2.121 2.121-1.414 1.414-2.121-2.121Zm2.121-14.85 1.414 1.415-2.121 2.121-1.414-1.414 2.121-2.121ZM5.636 16.95l1.414 1.414-2.121 2.121-1.414-1.414 2.121-2.121ZM23 11v2h-3v-2h3ZM4 11v2H1v-2h3Z"/>'
      }, props)
  }
  export function RiWeatherTempColdFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 10.255V5a4 4 0 1 1 8 0v5.255a7 7 0 1 1-8 0ZM8 16a4 4 0 0 0 8 0H8Z"/>'
      }, props)
  }
  export function RiWeatherTempColdLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 5a4 4 0 1 1 8 0v5.255a7 7 0 1 1-8 0V5Zm1.144 6.895a5 5 0 1 0 5.712 0L14 11.298V5a2 2 0 1 0-4 0v6.298l-.856.597ZM8 16h8a4 4 0 0 1-8 0Z"/>'
      }, props)
  }
  export function RiWeatherTempHotFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 10.255V5a4 4 0 1 1 8 0v5.255a7 7 0 1 1-8 0Zm3 1.871A4.002 4.002 0 0 0 12 20a4 4 0 0 0 1-7.874V5h-2v7.126Z"/>'
      }, props)
  }
  export function RiWeatherTempHotLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M8 5a4 4 0 1 1 8 0v5.255a7 7 0 1 1-8 0V5Zm1.144 6.895a5 5 0 1 0 5.712 0L14 11.298V5a2 2 0 1 0-4 0v6.298l-.856.597Zm1.856.231V5h2v7.126A4.002 4.002 0 0 1 12 20a4 4 0 0 1-1-7.874ZM12 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>'
      }, props)
  }
  export function RiWeatherThunderstormsFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m16.988 18 1.216-1.58a1.5 1.5 0 0 0-1.189-2.415H15v-3.976a1.5 1.5 0 0 0-2.69-.914l-6.365 8.281A8.002 8.002 0 0 1 9 2a8.003 8.003 0 0 1 7.458 5.099A5.5 5.5 0 1 1 17.5 18h-.512ZM13 16.005h3l-5 6.5v-4.5H8l5-6.505v4.505Z"/>'
      }, props)
  }
  export function RiWeatherThunderstormsLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M17 18v-2h.5a3.5 3.5 0 1 0-2.5-5.95V10a6 6 0 1 0-8 5.659v2.089a8 8 0 1 1 9.458-10.65A5.5 5.5 0 1 1 17.5 18H17Zm-4-1.995h3l-5 6.5v-4.5H8l5-6.505v4.505Z"/>'
      }, props)
  }
  export function RiWeatherTornadoFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3h20v2H2V3Zm2 4h16v2H4V7Zm4 4h14v2H8v-2Zm2 4h8v2h-8v-2Zm-2 4h6v2H8v-2Z"/>'
      }, props)
  }
  export function RiWeatherTornadoLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M2 3h20v2H2V3Zm2 4h16v2H4V7Zm4 4h14v2H8v-2Zm2 4h8v2h-8v-2Zm-2 4h6v2H8v-2Z"/>'
      }, props)
  }
  export function RiWeatherTyphoonFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.654 1.7-2.782 2.533a9.137 9.137 0 0 1 3.49 1.973c3.512 3.2 3.512 8.388 0 11.588-2.592 2.36-6.598 3.862-12.016 4.506l2.782-2.533a9.137 9.137 0 0 1-3.49-1.973c-3.512-3.2-3.533-8.369 0-11.588C8.23 3.846 12.237 2.344 17.655 1.7ZM12 8c-2.485 0-4.5 1.791-4.5 4 0 2.21 2.015 4 4.5 4s4.5-1.79 4.5-4c0-2.209-2.015-4-4.5-4Z"/>'
      }, props)
  }
  export function RiWeatherTyphoonLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="m17.654 1.7-2.782 2.533a9.137 9.137 0 0 1 3.49 1.973c3.512 3.2 3.512 8.388 0 11.588-2.592 2.36-6.598 3.862-12.016 4.506l2.782-2.533a9.137 9.137 0 0 1-3.49-1.973c-3.512-3.2-3.533-8.369 0-11.588C8.23 3.846 12.237 2.344 17.655 1.7ZM12 6c-3.866 0-7 2.686-7 6s3.134 6 7 6 7-2.686 7-6-3.134-6-7-6Zm0 2.3c2.21 0 4 1.657 4 3.7 0 2.044-1.79 3.7-4 3.7S8 14.044 8 12c0-2.043 1.79-3.7 4-3.7Zm0 2c-1.138 0-2 .798-2 1.7 0 .903.862 1.7 2 1.7s2-.797 2-1.7c0-.902-.862-1.7-2-1.7Z"/>'
      }, props)
  }
  export function RiWeatherWaterPercentFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M12 .269 5.636 6.633a9 9 0 1 0 12.728 0L12 .269Zm4.243 9.902-7.071 7.072-1.415-1.415 7.072-7.07 1.414 1.413ZM8.11 9.111a1.5 1.5 0 1 1 2.121 2.121 1.5 1.5 0 0 1-2.121-2.121Zm7.778 7.778a1.5 1.5 0 1 1-2.121-2.121 1.5 1.5 0 0 1 2.121 2.12Z"/>'
      }, props)
  }
  export function RiWeatherWaterPercentLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M7.05 8.047 12 3.097l4.95 4.95a7 7 0 1 1-9.9 0Zm11.314-1.414L12 .269 5.636 6.633a9 9 0 1 0 12.728 0Zm-2.121 3.538-1.414-1.414-7.072 7.071 1.415 1.415 7.07-7.072ZM8.11 11.232a1.5 1.5 0 1 0 2.121-2.121 1.5 1.5 0 0 0-2.121 2.121Zm7.778 5.657a1.5 1.5 0 1 1-2.121-2.121 1.5 1.5 0 0 1 2.121 2.12Z"/>'
      }, props)
  }
  export function RiWeatherWindyFill(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.5 17H4v-2h6.5a3.5 3.5 0 1 1-3.278 4.73l1.873-.703A1.5 1.5 0 1 0 10.5 17ZM5 11h13.5a3.5 3.5 0 1 1-3.278 4.73l1.873-.703A1.5 1.5 0 1 0 18.5 13H5a3 3 0 1 1 0-6h8.5a1.5 1.5 0 1 0-1.405-2.027l-1.873-.702A3.501 3.501 0 0 1 17 5.5 3.5 3.5 0 0 1 13.5 9H5a1 1 0 0 0 0 2Z"/>'
      }, props)
  }
  export function RiWeatherWindyLine(props) {
      return IconTemplate({
        a: {"viewBox":"0 0 24 24"},
        c: '<path fill="currentColor" d="M10.5 17H4v-2h6.5a3.5 3.5 0 1 1-3.278 4.73l1.873-.703A1.5 1.5 0 1 0 10.5 17ZM5 11h13.5a3.5 3.5 0 1 1-3.278 4.73l1.873-.703A1.5 1.5 0 1 0 18.5 13H5a3 3 0 1 1 0-6h8.5a1.5 1.5 0 1 0-1.405-2.027l-1.873-.702A3.501 3.501 0 0 1 17 5.5 3.5 3.5 0 0 1 13.5 9H5a1 1 0 0 0 0 2Z"/>'
      }, props)
  }